
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94e4"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94e4"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("8rWe0", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $626e029de0d7793d$export$ffb0004e005737fa, (v) => $626e029de0d7793d$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "jsx", () => $626e029de0d7793d$export$34b9dba7ce09269b, (v) => $626e029de0d7793d$export$34b9dba7ce09269b = v);
$parcel$export(module.exports, "jsxs", () => $626e029de0d7793d$export$25062201e9e25d76, (v) => $626e029de0d7793d$export$25062201e9e25d76 = v);
/**
 * @license React
 * react-jsx-runtime.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $626e029de0d7793d$export$ffb0004e005737fa;
var $626e029de0d7793d$export$34b9dba7ce09269b;
var $626e029de0d7793d$export$25062201e9e25d76;
"use strict";
var $626e029de0d7793d$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $626e029de0d7793d$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
function $626e029de0d7793d$var$jsxProd(type, config, maybeKey) {
    var key = null;
    void 0 !== maybeKey && (key = "" + maybeKey);
    void 0 !== config.key && (key = "" + config.key);
    if ("key" in config) {
        maybeKey = {};
        for(var propName in config)"key" !== propName && (maybeKey[propName] = config[propName]);
    } else maybeKey = config;
    config = maybeKey.ref;
    return {
        $$typeof: $626e029de0d7793d$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== config ? config : null,
        props: maybeKey
    };
}
$626e029de0d7793d$export$ffb0004e005737fa = $626e029de0d7793d$var$REACT_FRAGMENT_TYPE;
$626e029de0d7793d$export$34b9dba7ce09269b = $626e029de0d7793d$var$jsxProd;
$626e029de0d7793d$export$25062201e9e25d76 = $626e029de0d7793d$var$jsxProd;

});

parcelRegister("iWoMt", function(module, exports) {

$parcel$export(module.exports, "createRoot", () => $dca0ddb82b882518$export$882461b6382ed46c, (v) => $dca0ddb82b882518$export$882461b6382ed46c = v);
$parcel$export(module.exports, "hydrateRoot", () => $dca0ddb82b882518$export$757ceba2d55c277e, (v) => $dca0ddb82b882518$export$757ceba2d55c277e = v);
$parcel$export(module.exports, "version", () => $dca0ddb82b882518$export$83d89fbfd8236492, (v) => $dca0ddb82b882518$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom-client.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $dca0ddb82b882518$export$882461b6382ed46c;
var $dca0ddb82b882518$export$757ceba2d55c277e;
var $dca0ddb82b882518$export$83d89fbfd8236492;
"use strict";

var $fO90s = parcelRequire("fO90s");

var $acw62 = parcelRequire("acw62");

var $1u0KT = parcelRequire("1u0KT");
function $dca0ddb82b882518$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function $dca0ddb82b882518$var$isValidContainer(node) {
    return !(!node || 1 !== node.nodeType && 9 !== node.nodeType && 11 !== node.nodeType);
}
function $dca0ddb82b882518$var$getNearestMountedFiber(fiber) {
    for(var node = fiber, nextNode = node; nextNode && !nextNode.alternate;)node = nextNode, 0 !== (node.flags & 4098) && (fiber = node.return), nextNode = node.return;
    for(; node.return;)node = node.return;
    return 3 === node.tag ? fiber : null;
}
function $dca0ddb82b882518$var$getSuspenseInstanceFromFiber(fiber) {
    if (13 === fiber.tag) {
        var suspenseState = fiber.memoizedState;
        null === suspenseState && (fiber = fiber.alternate, null !== fiber && (suspenseState = fiber.memoizedState));
        if (null !== suspenseState) return suspenseState.dehydrated;
    }
    return null;
}
function $dca0ddb82b882518$var$getActivityInstanceFromFiber(fiber) {
    if (31 === fiber.tag) {
        var activityState = fiber.memoizedState;
        null === activityState && (fiber = fiber.alternate, null !== fiber && (activityState = fiber.memoizedState));
        if (null !== activityState) return activityState.dehydrated;
    }
    return null;
}
function $dca0ddb82b882518$var$assertIsMounted(fiber) {
    if ($dca0ddb82b882518$var$getNearestMountedFiber(fiber) !== fiber) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(188));
}
function $dca0ddb82b882518$var$findCurrentFiberUsingSlowPath(fiber) {
    var alternate = fiber.alternate;
    if (!alternate) {
        alternate = $dca0ddb82b882518$var$getNearestMountedFiber(fiber);
        if (null === alternate) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(188));
        return alternate !== fiber ? null : fiber;
    }
    for(var a = fiber, b = alternate;;){
        var parentA = a.return;
        if (null === parentA) break;
        var parentB = parentA.alternate;
        if (null === parentB) {
            b = parentA.return;
            if (null !== b) {
                a = b;
                continue;
            }
            break;
        }
        if (parentA.child === parentB.child) {
            for(parentB = parentA.child; parentB;){
                if (parentB === a) return $dca0ddb82b882518$var$assertIsMounted(parentA), fiber;
                if (parentB === b) return $dca0ddb82b882518$var$assertIsMounted(parentA), alternate;
                parentB = parentB.sibling;
            }
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(188));
        }
        if (a.return !== b.return) a = parentA, b = parentB;
        else {
            for(var didFindChild = !1, child$0 = parentA.child; child$0;){
                if (child$0 === a) {
                    didFindChild = !0;
                    a = parentA;
                    b = parentB;
                    break;
                }
                if (child$0 === b) {
                    didFindChild = !0;
                    b = parentA;
                    a = parentB;
                    break;
                }
                child$0 = child$0.sibling;
            }
            if (!didFindChild) {
                for(child$0 = parentB.child; child$0;){
                    if (child$0 === a) {
                        didFindChild = !0;
                        a = parentB;
                        b = parentA;
                        break;
                    }
                    if (child$0 === b) {
                        didFindChild = !0;
                        b = parentB;
                        a = parentA;
                        break;
                    }
                    child$0 = child$0.sibling;
                }
                if (!didFindChild) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(189));
            }
        }
        if (a.alternate !== b) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(190));
    }
    if (3 !== a.tag) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(188));
    return a.stateNode.current === a ? fiber : alternate;
}
function $dca0ddb82b882518$var$findCurrentHostFiberImpl(node) {
    var tag = node.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return node;
    for(node = node.child; null !== node;){
        tag = $dca0ddb82b882518$var$findCurrentHostFiberImpl(node);
        if (null !== tag) return tag;
        node = node.sibling;
    }
    return null;
}
function $dca0ddb82b882518$var$traverseVisibleInstancesAndTextInstances(child, searchWithinHosts, fn, a, b, c) {
    for(; null !== child;){
        if ((5 === child.tag || 27 === child.tag || 6 === child.tag) && fn(child, a, b, c) || (22 !== child.tag || null === child.memoizedState) && (searchWithinHosts || 5 !== child.tag && 27 !== child.tag) && $dca0ddb82b882518$var$traverseVisibleInstancesAndTextInstances(child.child, searchWithinHosts, fn, a, b, c)) return !0;
        child = child.sibling;
    }
    return !1;
}
function $dca0ddb82b882518$var$getFragmentParentInstanceOrContainerFiber(fiber) {
    for(fiber = fiber.return; null !== fiber;){
        if (3 === fiber.tag || 5 === fiber.tag || 27 === fiber.tag) return fiber;
        fiber = fiber.return;
    }
    return null;
}
function $dca0ddb82b882518$var$fiberIsPortaledIntoHost(fiber) {
    var foundPortalParent = !1;
    for(fiber = fiber.return; null !== fiber;){
        4 === fiber.tag && (foundPortalParent = !0);
        if (3 === fiber.tag || 5 === fiber.tag || 27 === fiber.tag) break;
        fiber = fiber.return;
    }
    return foundPortalParent;
}
function $dca0ddb82b882518$var$getFragmentInstanceOrTextInstanceSiblings(fiber) {
    var result = [
        null,
        null
    ], parentHostFiber = $dca0ddb82b882518$var$getFragmentParentInstanceOrContainerFiber(fiber);
    if (null === parentHostFiber) return result;
    $dca0ddb82b882518$var$findFragmentInstanceOrTextInstanceSiblings(result, fiber, parentHostFiber.child, {
        foundSelf: !1
    });
    return result;
}
function $dca0ddb82b882518$var$findFragmentInstanceOrTextInstanceSiblings(result, self, child, state) {
    for(; null !== child;){
        if (child === self) state.foundSelf = !0;
        else if (5 === child.tag || 27 === child.tag || 6 === child.tag) {
            if (state.foundSelf) return result[1] = child, !0;
            result[0] = child;
        } else if ((22 !== child.tag || null === child.memoizedState) && $dca0ddb82b882518$var$findFragmentInstanceOrTextInstanceSiblings(result, self, child.child, state)) return !0;
        child = child.sibling;
    }
    return !1;
}
function $dca0ddb82b882518$var$getInstanceFromHostFiber(fiber) {
    switch(fiber.tag){
        case 5:
        case 27:
        case 6:
            return fiber.stateNode;
        case 3:
            return fiber.stateNode.containerInfo;
        default:
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(559));
    }
}
var $dca0ddb82b882518$var$searchTarget = null, $dca0ddb82b882518$var$searchBoundary = null;
function $dca0ddb82b882518$var$isFiberPrecedingCheck(child, target, boundary) {
    return child === boundary ? !0 : child === target ? ($dca0ddb82b882518$var$searchTarget = child, !0) : !1;
}
function $dca0ddb82b882518$var$isFiberFollowingCheck(child, target, boundary) {
    return child === boundary ? ($dca0ddb82b882518$var$searchBoundary = child, !1) : child === target ? (null !== $dca0ddb82b882518$var$searchBoundary && ($dca0ddb82b882518$var$searchTarget = child), !0) : !1;
}
function $dca0ddb82b882518$var$getParentForFragmentAncestors(inst) {
    if (null === inst) return null;
    do inst = null === inst ? null : inst.return;
    while (inst && 5 !== inst.tag && 27 !== inst.tag && 3 !== inst.tag);
    return inst ? inst : null;
}
function $dca0ddb82b882518$var$getLowestCommonAncestor(instA, instB, getParent) {
    for(var depthA = 0, tempA = instA; tempA; tempA = getParent(tempA))depthA++;
    tempA = 0;
    for(var tempB = instB; tempB; tempB = getParent(tempB))tempA++;
    for(; 0 < depthA - tempA;)instA = getParent(instA), depthA--;
    for(; 0 < tempA - depthA;)instB = getParent(instB), tempA--;
    for(; depthA--;){
        if (instA === instB || null !== instB && instA === instB.alternate) return instA;
        instA = getParent(instA);
        instB = getParent(instB);
    }
    return null;
}
var $dca0ddb82b882518$var$assign = Object.assign, $dca0ddb82b882518$var$REACT_LEGACY_ELEMENT_TYPE = Symbol.for("react.element"), $dca0ddb82b882518$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $dca0ddb82b882518$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $dca0ddb82b882518$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $dca0ddb82b882518$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $dca0ddb82b882518$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $dca0ddb82b882518$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $dca0ddb82b882518$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $dca0ddb82b882518$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $dca0ddb82b882518$var$REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"), $dca0ddb82b882518$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $dca0ddb82b882518$var$REACT_LAZY_TYPE = Symbol.for("react.lazy");
Symbol.for("react.scope");
var $dca0ddb82b882518$var$REACT_ACTIVITY_TYPE = Symbol.for("react.activity"), $dca0ddb82b882518$var$REACT_LEGACY_HIDDEN_TYPE = Symbol.for("react.legacy_hidden");
Symbol.for("react.tracing_marker");
var $dca0ddb82b882518$var$REACT_MEMO_CACHE_SENTINEL = Symbol.for("react.memo_cache_sentinel"), $dca0ddb82b882518$var$REACT_VIEW_TRANSITION_TYPE = Symbol.for("react.view_transition"), $dca0ddb82b882518$var$REACT_RECOVERABLE_TYPE = Symbol.for("react.recoverable"), $dca0ddb82b882518$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $dca0ddb82b882518$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = $dca0ddb82b882518$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$dca0ddb82b882518$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $dca0ddb82b882518$var$REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference");
function $dca0ddb82b882518$var$getComponentNameFromType(type) {
    if (null == type) return null;
    if ("function" === typeof type) return type.$$typeof === $dca0ddb82b882518$var$REACT_CLIENT_REFERENCE ? null : type.displayName || type.name || null;
    if ("string" === typeof type) return type;
    switch(type){
        case $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE:
            return "Fragment";
        case $dca0ddb82b882518$var$REACT_PROFILER_TYPE:
            return "Profiler";
        case $dca0ddb82b882518$var$REACT_STRICT_MODE_TYPE:
            return "StrictMode";
        case $dca0ddb82b882518$var$REACT_SUSPENSE_TYPE:
            return "Suspense";
        case $dca0ddb82b882518$var$REACT_SUSPENSE_LIST_TYPE:
            return "SuspenseList";
        case $dca0ddb82b882518$var$REACT_ACTIVITY_TYPE:
            return "Activity";
        case $dca0ddb82b882518$var$REACT_VIEW_TRANSITION_TYPE:
            return "ViewTransition";
    }
    if ("object" === typeof type) switch(type.$$typeof){
        case $dca0ddb82b882518$var$REACT_PORTAL_TYPE:
            return "Portal";
        case $dca0ddb82b882518$var$REACT_CONTEXT_TYPE:
            return type.displayName || "Context";
        case $dca0ddb82b882518$var$REACT_CONSUMER_TYPE:
            return (type._context.displayName || "Context") + ".Consumer";
        case $dca0ddb82b882518$var$REACT_FORWARD_REF_TYPE:
            var innerType = type.render;
            type = type.displayName;
            type || (type = innerType.displayName || innerType.name || "", type = "" !== type ? "ForwardRef(" + type + ")" : "ForwardRef");
            return type;
        case $dca0ddb82b882518$var$REACT_MEMO_TYPE:
            return innerType = type.displayName || null, null !== innerType ? innerType : $dca0ddb82b882518$var$getComponentNameFromType(type.type) || "Memo";
        case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
            innerType = type._payload;
            type = type._init;
            try {
                return $dca0ddb82b882518$var$getComponentNameFromType(type(innerType));
            } catch (x) {}
    }
    return null;
}
var $dca0ddb82b882518$var$isArrayImpl = Array.isArray, $dca0ddb82b882518$var$ReactSharedInternals = $acw62.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $dca0ddb82b882518$var$ReactDOMSharedInternals = $1u0KT.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $dca0ddb82b882518$var$sharedNotPendingObject = {
    pending: !1,
    data: null,
    method: null,
    action: null
}, $dca0ddb82b882518$var$valueStack = [], $dca0ddb82b882518$var$index = -1;
function $dca0ddb82b882518$var$createCursor(defaultValue) {
    return {
        current: defaultValue
    };
}
function $dca0ddb82b882518$var$pop(cursor) {
    0 > $dca0ddb82b882518$var$index || (cursor.current = $dca0ddb82b882518$var$valueStack[$dca0ddb82b882518$var$index], $dca0ddb82b882518$var$valueStack[$dca0ddb82b882518$var$index] = null, $dca0ddb82b882518$var$index--);
}
function $dca0ddb82b882518$var$push(cursor, value) {
    $dca0ddb82b882518$var$index++;
    $dca0ddb82b882518$var$valueStack[$dca0ddb82b882518$var$index] = cursor.current;
    cursor.current = value;
}
var $dca0ddb82b882518$var$contextStackCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$contextFiberStackCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$rootInstanceStackCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$hostTransitionProviderCursor = $dca0ddb82b882518$var$createCursor(null);
function $dca0ddb82b882518$var$pushHostContainer(fiber, nextRootInstance) {
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$rootInstanceStackCursor, nextRootInstance);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$contextFiberStackCursor, fiber);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$contextStackCursor, null);
    switch(nextRootInstance.nodeType){
        case 9:
        case 11:
            fiber = (fiber = nextRootInstance.documentElement) ? (fiber = fiber.namespaceURI) ? $dca0ddb82b882518$var$getOwnHostContext(fiber) : 0 : 0;
            break;
        default:
            if (fiber = nextRootInstance.tagName, nextRootInstance = nextRootInstance.namespaceURI) nextRootInstance = $dca0ddb82b882518$var$getOwnHostContext(nextRootInstance), fiber = $dca0ddb82b882518$var$getChildHostContextProd(nextRootInstance, fiber);
            else switch(fiber){
                case "svg":
                    fiber = 1;
                    break;
                case "math":
                    fiber = 2;
                    break;
                default:
                    fiber = 0;
            }
    }
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$contextStackCursor);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$contextStackCursor, fiber);
}
function $dca0ddb82b882518$var$popHostContainer() {
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$contextStackCursor);
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$contextFiberStackCursor);
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$rootInstanceStackCursor);
}
function $dca0ddb82b882518$var$pushHostContext(fiber) {
    var stateHook = fiber.memoizedState;
    null !== stateHook && ($dca0ddb82b882518$var$HostTransitionContext._currentValue = stateHook.memoizedState, $dca0ddb82b882518$var$push($dca0ddb82b882518$var$hostTransitionProviderCursor, fiber));
    stateHook = $dca0ddb82b882518$var$contextStackCursor.current;
    var JSCompiler_inline_result = $dca0ddb82b882518$var$getChildHostContextProd(stateHook, fiber.type);
    stateHook !== JSCompiler_inline_result && ($dca0ddb82b882518$var$push($dca0ddb82b882518$var$contextFiberStackCursor, fiber), $dca0ddb82b882518$var$push($dca0ddb82b882518$var$contextStackCursor, JSCompiler_inline_result));
}
function $dca0ddb82b882518$var$popHostContext(fiber) {
    $dca0ddb82b882518$var$contextFiberStackCursor.current === fiber && ($dca0ddb82b882518$var$pop($dca0ddb82b882518$var$contextStackCursor), $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$contextFiberStackCursor));
    $dca0ddb82b882518$var$hostTransitionProviderCursor.current === fiber && ($dca0ddb82b882518$var$pop($dca0ddb82b882518$var$hostTransitionProviderCursor), $dca0ddb82b882518$var$HostTransitionContext._currentValue = $dca0ddb82b882518$var$sharedNotPendingObject);
}
var $dca0ddb82b882518$var$prefix, $dca0ddb82b882518$var$suffix;
function $dca0ddb82b882518$var$describeBuiltInComponentFrame(name) {
    if (void 0 === $dca0ddb82b882518$var$prefix) try {
        throw Error();
    } catch (x) {
        var match = x.stack.trim().match(/\n( *(at )?)/);
        $dca0ddb82b882518$var$prefix = match && match[1] || "";
        $dca0ddb82b882518$var$suffix = -1 < x.stack.indexOf("\n    at") ? " (<anonymous>)" : -1 < x.stack.indexOf("@") ? "@unknown:0:0" : "";
    }
    return "\n" + $dca0ddb82b882518$var$prefix + name + $dca0ddb82b882518$var$suffix;
}
var $dca0ddb82b882518$var$reentry = !1;
function $dca0ddb82b882518$var$describeNativeComponentFrame(fn, construct) {
    if (!fn || $dca0ddb82b882518$var$reentry) return "";
    $dca0ddb82b882518$var$reentry = !0;
    var previousPrepareStackTrace = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        var RunInRootFrame = {
            DetermineComponentFrameRoot: function() {
                try {
                    if (construct) {
                        var Fake = function() {
                            throw Error();
                        };
                        Object.defineProperty(Fake.prototype, "props", {
                            set: function() {
                                throw Error();
                            }
                        });
                        if ("object" === typeof Reflect && Reflect.construct) {
                            try {
                                Reflect.construct(Fake, []);
                            } catch (x) {
                                var control = x;
                            }
                            Reflect.construct(fn, [], Fake);
                        } else {
                            try {
                                Fake.call();
                            } catch (x$1) {
                                control = x$1;
                            }
                            Fake = !1;
                            try {
                                var prevProps = Object.getOwnPropertyDescriptor(fn.prototype, "props");
                                Object.defineProperty(fn.prototype, "props", {
                                    configurable: !0,
                                    set: function() {
                                        throw Error();
                                    }
                                });
                                Fake = !0;
                                new fn();
                            } finally{
                                Fake && (void 0 !== prevProps ? Object.defineProperty(fn.prototype, "props", prevProps) : delete fn.prototype.props);
                            }
                        }
                    } else {
                        try {
                            throw Error();
                        } catch (x$2) {
                            control = x$2;
                        }
                        (Fake = fn()) && "function" === typeof Fake.catch && Fake.catch(function() {});
                    }
                } catch (sample) {
                    if (sample && control && "string" === typeof sample.stack) return [
                        sample.stack,
                        control.stack
                    ];
                }
                return [
                    null,
                    null
                ];
            }
        };
        RunInRootFrame.DetermineComponentFrameRoot.displayName = "DetermineComponentFrameRoot";
        var namePropDescriptor = Object.getOwnPropertyDescriptor(RunInRootFrame.DetermineComponentFrameRoot, "name");
        namePropDescriptor && namePropDescriptor.configurable && Object.defineProperty(RunInRootFrame.DetermineComponentFrameRoot, "name", {
            value: "DetermineComponentFrameRoot"
        });
        var _RunInRootFrame$Deter = RunInRootFrame.DetermineComponentFrameRoot(), sampleStack = _RunInRootFrame$Deter[0], controlStack = _RunInRootFrame$Deter[1];
        if (sampleStack && controlStack) {
            var sampleLines = sampleStack.split("\n"), controlLines = controlStack.split("\n");
            for(namePropDescriptor = RunInRootFrame = 0; RunInRootFrame < sampleLines.length && !sampleLines[RunInRootFrame].includes("DetermineComponentFrameRoot");)RunInRootFrame++;
            for(; namePropDescriptor < controlLines.length && !controlLines[namePropDescriptor].includes("DetermineComponentFrameRoot");)namePropDescriptor++;
            if (RunInRootFrame === sampleLines.length || namePropDescriptor === controlLines.length) for(RunInRootFrame = sampleLines.length - 1, namePropDescriptor = controlLines.length - 1; 1 <= RunInRootFrame && 0 <= namePropDescriptor && sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor];)namePropDescriptor--;
            for(; 1 <= RunInRootFrame && 0 <= namePropDescriptor; RunInRootFrame--, namePropDescriptor--)if (sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                if (1 !== RunInRootFrame || 1 !== namePropDescriptor) {
                    do if (RunInRootFrame--, namePropDescriptor--, 0 > namePropDescriptor || sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                        var frame = "\n" + sampleLines[RunInRootFrame].replace(" at new ", " at ");
                        fn.displayName && frame.includes("<anonymous>") && (frame = frame.replace("<anonymous>", fn.displayName));
                        return frame;
                    }
                    while (1 <= RunInRootFrame && 0 <= namePropDescriptor);
                }
                break;
            }
        }
    } finally{
        $dca0ddb82b882518$var$reentry = !1, Error.prepareStackTrace = previousPrepareStackTrace;
    }
    return (previousPrepareStackTrace = fn ? fn.displayName || fn.name : "") ? $dca0ddb82b882518$var$describeBuiltInComponentFrame(previousPrepareStackTrace) : "";
}
function $dca0ddb82b882518$var$describeFiber(fiber, childFiber) {
    switch(fiber.tag){
        case 26:
        case 27:
        case 5:
            return $dca0ddb82b882518$var$describeBuiltInComponentFrame(fiber.type);
        case 16:
            return $dca0ddb82b882518$var$describeBuiltInComponentFrame("Lazy");
        case 13:
            return fiber.child !== childFiber && null !== childFiber ? $dca0ddb82b882518$var$describeBuiltInComponentFrame("Suspense Fallback") : $dca0ddb82b882518$var$describeBuiltInComponentFrame("Suspense");
        case 19:
            return $dca0ddb82b882518$var$describeBuiltInComponentFrame("SuspenseList");
        case 0:
        case 15:
            return $dca0ddb82b882518$var$describeNativeComponentFrame(fiber.type, !1);
        case 11:
            return $dca0ddb82b882518$var$describeNativeComponentFrame(fiber.type.render, !1);
        case 1:
            return $dca0ddb82b882518$var$describeNativeComponentFrame(fiber.type, !0);
        case 31:
            return $dca0ddb82b882518$var$describeBuiltInComponentFrame("Activity");
        case 30:
            return $dca0ddb82b882518$var$describeBuiltInComponentFrame("ViewTransition");
        default:
            return "";
    }
}
function $dca0ddb82b882518$var$getStackByFiberInDevAndProd(workInProgress) {
    try {
        var info = "", previous = null;
        do info += $dca0ddb82b882518$var$describeFiber(workInProgress, previous), previous = workInProgress, workInProgress = workInProgress.return;
        while (workInProgress);
        return info;
    } catch (x) {
        return "\nError generating stack: " + x.message + "\n" + x.stack;
    }
}
var $dca0ddb82b882518$var$hasOwnProperty = Object.prototype.hasOwnProperty, $dca0ddb82b882518$var$scheduleCallback$3 = $fO90s.unstable_scheduleCallback, $dca0ddb82b882518$var$cancelCallback$1 = $fO90s.unstable_cancelCallback, $dca0ddb82b882518$var$shouldYield = $fO90s.unstable_shouldYield, $dca0ddb82b882518$var$requestPaint = $fO90s.unstable_requestPaint, $dca0ddb82b882518$var$now = $fO90s.unstable_now, $dca0ddb82b882518$var$getCurrentPriorityLevel = $fO90s.unstable_getCurrentPriorityLevel, $dca0ddb82b882518$var$ImmediatePriority = $fO90s.unstable_ImmediatePriority, $dca0ddb82b882518$var$UserBlockingPriority = $fO90s.unstable_UserBlockingPriority, $dca0ddb82b882518$var$NormalPriority$1 = $fO90s.unstable_NormalPriority, $dca0ddb82b882518$var$LowPriority = $fO90s.unstable_LowPriority, $dca0ddb82b882518$var$IdlePriority = $fO90s.unstable_IdlePriority, $dca0ddb82b882518$var$log$1 = $fO90s.log, $dca0ddb82b882518$var$unstable_setDisableYieldValue = $fO90s.unstable_setDisableYieldValue, $dca0ddb82b882518$var$rendererID = null, $dca0ddb82b882518$var$injectedHook = null;
function $dca0ddb82b882518$var$setIsStrictModeForDevtools(newIsStrictMode) {
    "function" === typeof $dca0ddb82b882518$var$log$1 && $dca0ddb82b882518$var$unstable_setDisableYieldValue(newIsStrictMode);
    if ($dca0ddb82b882518$var$injectedHook && "function" === typeof $dca0ddb82b882518$var$injectedHook.setStrictMode) try {
        $dca0ddb82b882518$var$injectedHook.setStrictMode($dca0ddb82b882518$var$rendererID, newIsStrictMode);
    } catch (err) {}
}
var $dca0ddb82b882518$var$clz32 = Math.clz32 ? Math.clz32 : $dca0ddb82b882518$var$clz32Fallback, $dca0ddb82b882518$var$log = Math.log, $dca0ddb82b882518$var$LN2 = Math.LN2;
function $dca0ddb82b882518$var$clz32Fallback(x) {
    x >>>= 0;
    return 0 === x ? 32 : 31 - ($dca0ddb82b882518$var$log(x) / $dca0ddb82b882518$var$LN2 | 0) | 0;
}
var $dca0ddb82b882518$var$nextTransitionUpdateLane = 256, $dca0ddb82b882518$var$nextTransitionDeferredLane = 262144, $dca0ddb82b882518$var$nextRetryLane = 4194304;
function $dca0ddb82b882518$var$getHighestPriorityLanes(lanes) {
    var pendingSyncLanes = lanes & 42;
    if (0 !== pendingSyncLanes) return pendingSyncLanes;
    switch(lanes & -lanes){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
            return 64;
        case 128:
            return 128;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
            return lanes & -lanes;
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return lanes & 3932160;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return lanes & 62914560;
        case 67108864:
            return 67108864;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 0;
        default:
            return lanes;
    }
}
function $dca0ddb82b882518$var$getNextLanes(root, wipLanes, rootHasPendingCommit) {
    var pendingLanes = root.pendingLanes;
    if (0 === pendingLanes) return 0;
    var nextLanes = 0, suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes;
    root = root.warmLanes;
    var nonIdlePendingLanes = pendingLanes & 134217727;
    0 !== nonIdlePendingLanes ? (pendingLanes = nonIdlePendingLanes & ~suspendedLanes, 0 !== pendingLanes ? nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(pendingLanes) : (pingedLanes &= nonIdlePendingLanes, 0 !== pingedLanes ? nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = nonIdlePendingLanes & ~root, 0 !== rootHasPendingCommit && (nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(rootHasPendingCommit))))) : (nonIdlePendingLanes = pendingLanes & ~suspendedLanes, 0 !== nonIdlePendingLanes ? nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(nonIdlePendingLanes) : 0 !== pingedLanes ? nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = pendingLanes & ~root, 0 !== rootHasPendingCommit && (nextLanes = $dca0ddb82b882518$var$getHighestPriorityLanes(rootHasPendingCommit))));
    return 0 === nextLanes ? 0 : 0 !== wipLanes && wipLanes !== nextLanes && 0 === (wipLanes & suspendedLanes) && (suspendedLanes = nextLanes & -nextLanes, rootHasPendingCommit = wipLanes & -wipLanes, suspendedLanes >= rootHasPendingCommit || 32 === suspendedLanes && 0 !== (rootHasPendingCommit & 4194048)) ? wipLanes : nextLanes;
}
function $dca0ddb82b882518$var$checkIfRootIsPrerendering(root, renderLanes) {
    return 0 === (root.pendingLanes & ~(root.suspendedLanes & ~root.pingedLanes) & renderLanes);
}
function $dca0ddb82b882518$var$getEntangledLanes(root, renderLanes) {
    0 !== (renderLanes & 8) && (renderLanes |= renderLanes & 32);
    var allEntangledLanes = root.entangledLanes;
    if (0 !== allEntangledLanes) for(root = root.entanglements, allEntangledLanes &= renderLanes; 0 < allEntangledLanes;){
        var index$4 = 31 - $dca0ddb82b882518$var$clz32(allEntangledLanes), lane = 1 << index$4;
        renderLanes |= root[index$4];
        allEntangledLanes &= ~lane;
    }
    return renderLanes;
}
function $dca0ddb82b882518$var$computeExpirationTime(lane, currentTime) {
    switch(lane){
        case 1:
        case 2:
        case 4:
        case 8:
        case 64:
            return currentTime + 250;
        case 16:
        case 32:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return currentTime + 5e3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return -1;
        case 67108864:
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $dca0ddb82b882518$var$claimNextRetryLane() {
    var lane = $dca0ddb82b882518$var$nextRetryLane;
    $dca0ddb82b882518$var$nextRetryLane <<= 1;
    0 === ($dca0ddb82b882518$var$nextRetryLane & 62914560) && ($dca0ddb82b882518$var$nextRetryLane = 4194304);
    return lane;
}
function $dca0ddb82b882518$var$createLaneMap(initial) {
    for(var laneMap = [], i = 0; 31 > i; i++)laneMap.push(initial);
    return laneMap;
}
function $dca0ddb82b882518$var$markRootUpdated$1(root, updateLane) {
    root.pendingLanes |= updateLane;
    268435456 !== updateLane && (root.suspendedLanes = 0, root.pingedLanes = 0, root.warmLanes = 0);
}
function $dca0ddb82b882518$var$markRootFinished(root, finishedLanes, remainingLanes, spawnedLane, updatedLanes, suspendedRetryLanes) {
    var previouslyPendingLanes = root.pendingLanes;
    root.pendingLanes = remainingLanes;
    root.suspendedLanes = 0;
    root.pingedLanes = 0;
    root.warmLanes = 0;
    root.expiredLanes &= remainingLanes;
    root.entangledLanes &= remainingLanes;
    root.errorRecoveryDisabledLanes &= remainingLanes;
    root.shellSuspendCounter = 0;
    var entanglements = root.entanglements, expirationTimes = root.expirationTimes, hiddenUpdates = root.hiddenUpdates;
    for(remainingLanes = previouslyPendingLanes & ~remainingLanes; 0 < remainingLanes;){
        var index$7 = 31 - $dca0ddb82b882518$var$clz32(remainingLanes), lane = 1 << index$7;
        entanglements[index$7] = 0;
        expirationTimes[index$7] = -1;
        var hiddenUpdatesForLane = hiddenUpdates[index$7];
        if (null !== hiddenUpdatesForLane) for(hiddenUpdates[index$7] = null, index$7 = 0; index$7 < hiddenUpdatesForLane.length; index$7++){
            var update = hiddenUpdatesForLane[index$7];
            null !== update && (update.lane &= -536870913);
        }
        remainingLanes &= ~lane;
    }
    0 !== spawnedLane && $dca0ddb82b882518$var$markSpawnedDeferredLane(root, spawnedLane, 0);
    0 !== suspendedRetryLanes && 0 === updatedLanes && 0 !== root.tag && (root.suspendedLanes |= suspendedRetryLanes & ~(previouslyPendingLanes & ~finishedLanes));
}
function $dca0ddb82b882518$var$markSpawnedDeferredLane(root, spawnedLane, entangledLanes) {
    root.pendingLanes |= spawnedLane;
    root.suspendedLanes &= ~spawnedLane;
    var spawnedLaneIndex = 31 - $dca0ddb82b882518$var$clz32(spawnedLane);
    root.entangledLanes |= spawnedLane;
    root.entanglements[spawnedLaneIndex] = root.entanglements[spawnedLaneIndex] | 1073741824 | entangledLanes & 261930;
}
function $dca0ddb82b882518$var$markRootEntangled(root, entangledLanes) {
    var rootEntangledLanes = root.entangledLanes |= entangledLanes;
    for(root = root.entanglements; rootEntangledLanes;){
        var index$8 = 31 - $dca0ddb82b882518$var$clz32(rootEntangledLanes), lane = 1 << index$8;
        lane & entangledLanes | root[index$8] & entangledLanes && (root[index$8] |= entangledLanes);
        rootEntangledLanes &= ~lane;
    }
}
function $dca0ddb82b882518$var$getBumpedLaneForHydration(root, renderLanes) {
    var renderLane = renderLanes & -renderLanes;
    renderLane = 0 !== (renderLane & 42) ? 1 : $dca0ddb82b882518$var$getBumpedLaneForHydrationByLane(renderLane);
    return 0 !== (renderLane & (root.suspendedLanes | renderLanes)) ? 0 : renderLane;
}
function $dca0ddb82b882518$var$getBumpedLaneForHydrationByLane(lane) {
    switch(lane){
        case 2:
            lane = 1;
            break;
        case 8:
            lane = 4;
            break;
        case 32:
            lane = 16;
            break;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            lane = 128;
            break;
        case 268435456:
            lane = 134217728;
            break;
        default:
            lane = 0;
    }
    return lane;
}
function $dca0ddb82b882518$var$lanesToEventPriority(lanes) {
    lanes &= -lanes;
    return 2 < lanes ? 8 < lanes ? 0 !== (lanes & 134217727) ? 32 : 268435456 : 8 : 2;
}
function $dca0ddb82b882518$var$resolveUpdatePriority() {
    var updatePriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    if (0 !== updatePriority) return updatePriority;
    updatePriority = window.event;
    return void 0 === updatePriority ? 32 : $dca0ddb82b882518$var$getEventPriority(updatePriority.type);
}
function $dca0ddb82b882518$var$runWithPriority(priority, fn) {
    var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    try {
        return $dca0ddb82b882518$var$ReactDOMSharedInternals.p = priority, fn();
    } finally{
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority;
    }
}
var $dca0ddb82b882518$var$randomKey = Math.random().toString(36).slice(2), $dca0ddb82b882518$var$internalInstanceKey = "__reactFiber$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalPropsKey = "__reactProps$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalContainerInstanceKey = "__reactContainer$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalEventHandlersKey = "__reactEvents$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalEventHandlerListenersKey = "__reactListeners$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalEventHandlesSetKey = "__reactHandles$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalRootNodeResourcesKey = "__reactResources$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalHoistableMarker = "__reactMarker$" + $dca0ddb82b882518$var$randomKey, $dca0ddb82b882518$var$internalLoadPendingKey = "__reactLoad$" + $dca0ddb82b882518$var$randomKey;
function $dca0ddb82b882518$var$detachDeletedInstance(node) {
    delete node[$dca0ddb82b882518$var$internalInstanceKey];
    delete node[$dca0ddb82b882518$var$internalPropsKey];
    delete node[$dca0ddb82b882518$var$internalEventHandlerListenersKey];
    delete node[$dca0ddb82b882518$var$internalEventHandlesSetKey];
}
function $dca0ddb82b882518$var$getClosestInstanceFromNode(targetNode) {
    var targetInst;
    if (targetInst = targetNode[$dca0ddb82b882518$var$internalInstanceKey]) return targetInst;
    for(var parentNode = targetNode.parentNode; parentNode;){
        if (targetInst = parentNode[$dca0ddb82b882518$var$internalContainerInstanceKey] || parentNode[$dca0ddb82b882518$var$internalInstanceKey]) {
            parentNode = targetInst.alternate;
            if (null !== targetInst.child || null !== parentNode && null !== parentNode.child) for(targetNode = $dca0ddb82b882518$var$getParentHydrationBoundary(targetNode); null !== targetNode;){
                if (parentNode = targetNode[$dca0ddb82b882518$var$internalInstanceKey]) return parentNode;
                targetNode = $dca0ddb82b882518$var$getParentHydrationBoundary(targetNode);
            }
            return targetInst;
        }
        targetNode = parentNode;
        parentNode = targetNode.parentNode;
    }
    return null;
}
function $dca0ddb82b882518$var$getInstanceFromNode(node) {
    if (node = node[$dca0ddb82b882518$var$internalInstanceKey] || node[$dca0ddb82b882518$var$internalContainerInstanceKey]) {
        var tag = node.tag;
        if (5 === tag || 6 === tag || 13 === tag || 31 === tag || 26 === tag || 27 === tag || 3 === tag) return node;
    }
    return null;
}
function $dca0ddb82b882518$var$getNodeFromInstance(inst) {
    var tag = inst.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return inst.stateNode;
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(33));
}
function $dca0ddb82b882518$var$getResourcesFromRoot(root) {
    var resources = root[$dca0ddb82b882518$var$internalRootNodeResourcesKey];
    resources || (resources = root[$dca0ddb82b882518$var$internalRootNodeResourcesKey] = {
        hoistableStyles: new Map(),
        hoistableScripts: new Map()
    });
    return resources;
}
function $dca0ddb82b882518$var$markNodeAsHoistable(node) {
    node[$dca0ddb82b882518$var$internalHoistableMarker] = !0;
}
function $dca0ddb82b882518$var$clearPendingLoadOnNode(node) {
    node[$dca0ddb82b882518$var$internalLoadPendingKey] = void 0;
}
var $dca0ddb82b882518$var$allNativeEvents = new Set(), $dca0ddb82b882518$var$registrationNameDependencies = {};
function $dca0ddb82b882518$var$registerTwoPhaseEvent(registrationName, dependencies) {
    $dca0ddb82b882518$var$registerDirectEvent(registrationName, dependencies);
    $dca0ddb82b882518$var$registerDirectEvent(registrationName + "Capture", dependencies);
}
function $dca0ddb82b882518$var$registerDirectEvent(registrationName, dependencies) {
    $dca0ddb82b882518$var$registrationNameDependencies[registrationName] = dependencies;
    for(registrationName = 0; registrationName < dependencies.length; registrationName++)$dca0ddb82b882518$var$allNativeEvents.add(dependencies[registrationName]);
}
var $dca0ddb82b882518$var$VALID_ATTRIBUTE_NAME_REGEX = RegExp("^[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"), $dca0ddb82b882518$var$illegalAttributeNameCache = {}, $dca0ddb82b882518$var$validatedAttributeNameCache = {};
function $dca0ddb82b882518$var$isAttributeNameSafe(attributeName) {
    if ($dca0ddb82b882518$var$hasOwnProperty.call($dca0ddb82b882518$var$validatedAttributeNameCache, attributeName)) return !0;
    if ($dca0ddb82b882518$var$hasOwnProperty.call($dca0ddb82b882518$var$illegalAttributeNameCache, attributeName)) return !1;
    if ($dca0ddb82b882518$var$VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) return $dca0ddb82b882518$var$validatedAttributeNameCache[attributeName] = !0;
    $dca0ddb82b882518$var$illegalAttributeNameCache[attributeName] = !0;
    return !1;
}
var $dca0ddb82b882518$var$viewTransitionMutationContext = !1;
function $dca0ddb82b882518$var$pushMutationContext() {
    var prev = $dca0ddb82b882518$var$viewTransitionMutationContext;
    $dca0ddb82b882518$var$viewTransitionMutationContext = !1;
    return prev;
}
function $dca0ddb82b882518$var$setValueForAttribute(node, name, value) {
    if ($dca0ddb82b882518$var$isAttributeNameSafe(name)) {
        if (null === value) node.removeAttribute(name);
        else {
            switch(typeof value){
                case "undefined":
                case "function":
                case "symbol":
                    node.removeAttribute(name);
                    return;
                case "boolean":
                    var prefix$10 = name.toLowerCase().slice(0, 5);
                    if ("data-" !== prefix$10 && "aria-" !== prefix$10) {
                        node.removeAttribute(name);
                        return;
                    }
            }
            node.setAttribute(name, value);
        }
    }
}
function $dca0ddb82b882518$var$setValueForKnownAttribute(node, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttribute(name, value);
    }
}
function $dca0ddb82b882518$var$setValueForNamespacedAttribute(node, namespace, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttributeNS(namespace, name, value);
    }
}
function $dca0ddb82b882518$var$getToStringValue(value) {
    switch(typeof value){
        case "bigint":
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return value;
        case "object":
            return value;
        default:
            return "";
    }
}
function $dca0ddb82b882518$var$isCheckable(elem) {
    var type = elem.type;
    return (elem = elem.nodeName) && "input" === elem.toLowerCase() && ("checkbox" === type || "radio" === type);
}
function $dca0ddb82b882518$var$trackValueOnNode(node, valueField, currentValue) {
    var descriptor = Object.getOwnPropertyDescriptor(node.constructor.prototype, valueField);
    if (!node.hasOwnProperty(valueField) && "undefined" !== typeof descriptor && "function" === typeof descriptor.get && "function" === typeof descriptor.set) {
        var get = descriptor.get, set = descriptor.set;
        Object.defineProperty(node, valueField, {
            configurable: !0,
            get: function() {
                return get.call(this);
            },
            set: function(value) {
                currentValue = "" + value;
                set.call(this, value);
            }
        });
        Object.defineProperty(node, valueField, {
            enumerable: descriptor.enumerable
        });
        return {
            getValue: function() {
                return currentValue;
            },
            setValue: function(value) {
                currentValue = "" + value;
            },
            stopTracking: function() {
                node._valueTracker = null;
                delete node[valueField];
            }
        };
    }
}
function $dca0ddb82b882518$var$track(node) {
    if (!node._valueTracker) {
        var valueField = $dca0ddb82b882518$var$isCheckable(node) ? "checked" : "value";
        node._valueTracker = $dca0ddb82b882518$var$trackValueOnNode(node, valueField, "" + node[valueField]);
    }
}
function $dca0ddb82b882518$var$updateValueIfChanged(node) {
    if (!node) return !1;
    var tracker = node._valueTracker;
    if (!tracker) return !0;
    var lastValue = tracker.getValue();
    var value = "";
    node && (value = $dca0ddb82b882518$var$isCheckable(node) ? node.checked ? "true" : "false" : node.value);
    node = value;
    return node !== lastValue ? (tracker.setValue(node), !0) : !1;
}
var $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotesRegex = /[\n"\\]/g;
function $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(value) {
    return value.replace($dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotesRegex, function(ch) {
        return "\\" + ch.charCodeAt(0).toString(16) + " ";
    });
}
function $dca0ddb82b882518$var$updateInput(element, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name) {
    element.name = "";
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type ? element.type = type : element.removeAttribute("type");
    if (null != value) {
        if ("number" === type) {
            if (0 === value && "" === element.value || element.value != value) element.value = "" + $dca0ddb82b882518$var$getToStringValue(value);
        } else element.value !== "" + $dca0ddb82b882518$var$getToStringValue(value) && (element.value = "" + $dca0ddb82b882518$var$getToStringValue(value));
    } else "submit" !== type && "reset" !== type || element.removeAttribute("value");
    null != value ? "number" === type && element.value == value ? $dca0ddb82b882518$var$setDefaultValue(element, $dca0ddb82b882518$var$getToStringValue(element.value)) : $dca0ddb82b882518$var$setDefaultValue(element, $dca0ddb82b882518$var$getToStringValue(value)) : null != defaultValue ? $dca0ddb82b882518$var$setDefaultValue(element, $dca0ddb82b882518$var$getToStringValue(defaultValue)) : null != lastDefaultValue && element.removeAttribute("value");
    null == checked && null != defaultChecked && (element.defaultChecked = !!defaultChecked);
    null != checked && (element.checked = checked && "function" !== typeof checked && "symbol" !== typeof checked);
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name ? element.name = "" + $dca0ddb82b882518$var$getToStringValue(name) : element.removeAttribute("name");
}
function $dca0ddb82b882518$var$initInput(element, value, defaultValue, checked, defaultChecked, type, name, isHydrating) {
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type && (element.type = type);
    if (null != value || null != defaultValue) {
        if (!("submit" !== type && "reset" !== type || void 0 !== value && null !== value)) {
            $dca0ddb82b882518$var$track(element);
            return;
        }
        defaultValue = null != defaultValue ? "" + $dca0ddb82b882518$var$getToStringValue(defaultValue) : "";
        value = null != value ? "" + $dca0ddb82b882518$var$getToStringValue(value) : defaultValue;
        isHydrating || value === element.value || (element.value = value);
        element.defaultValue = value;
    }
    checked = null != checked ? checked : defaultChecked;
    checked = "function" !== typeof checked && "symbol" !== typeof checked && !!checked;
    element.checked = isHydrating ? element.checked : !!checked;
    element.defaultChecked = !!checked;
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name && (element.name = name);
    $dca0ddb82b882518$var$track(element);
}
function $dca0ddb82b882518$var$setDefaultValue(node, value) {
    node.defaultValue !== "" + value && (node.defaultValue = "" + value);
}
function $dca0ddb82b882518$var$updateOptions(node, multiple, propValue, setDefaultSelected) {
    node = node.options;
    if (multiple) {
        multiple = {};
        for(var i = 0; i < propValue.length; i++)multiple["$" + propValue[i]] = !0;
        for(propValue = 0; propValue < node.length; propValue++)i = multiple.hasOwnProperty("$" + node[propValue].value), node[propValue].selected !== i && (node[propValue].selected = i), i && setDefaultSelected && (node[propValue].defaultSelected = !0);
    } else {
        propValue = "" + $dca0ddb82b882518$var$getToStringValue(propValue);
        multiple = null;
        for(i = 0; i < node.length; i++){
            if (node[i].value === propValue) {
                node[i].selected = !0;
                setDefaultSelected && (node[i].defaultSelected = !0);
                return;
            }
            null !== multiple || node[i].disabled || (multiple = node[i]);
        }
        null !== multiple && (multiple.selected = !0);
    }
}
function $dca0ddb82b882518$var$updateTextarea(element, value, defaultValue) {
    if (null != value && (value = "" + $dca0ddb82b882518$var$getToStringValue(value), value !== element.value && (element.value = value), null == defaultValue)) {
        element.defaultValue !== value && (element.defaultValue = value);
        return;
    }
    element.defaultValue = null != defaultValue ? "" + $dca0ddb82b882518$var$getToStringValue(defaultValue) : "";
}
function $dca0ddb82b882518$var$initTextarea(element, value, defaultValue, children) {
    if (null == value) {
        if (null != children) {
            if (null != defaultValue) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(92));
            if ($dca0ddb82b882518$var$isArrayImpl(children)) {
                if (1 < children.length) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(93));
                children = children[0];
            }
            defaultValue = children;
        }
        null == defaultValue && (defaultValue = "");
        value = defaultValue;
    }
    defaultValue = $dca0ddb82b882518$var$getToStringValue(value);
    element.defaultValue = defaultValue;
    children = element.textContent;
    children === defaultValue && "" !== children && null !== children && (element.value = children);
    $dca0ddb82b882518$var$track(element);
}
function $dca0ddb82b882518$var$setTextContent(node, text) {
    if (text) {
        var firstChild = node.firstChild;
        if (firstChild && firstChild === node.lastChild && 3 === firstChild.nodeType) {
            firstChild.nodeValue = text;
            return;
        }
    }
    node.textContent = text;
}
var $dca0ddb82b882518$var$unitlessNumbers = new Set("animationIterationCount aspectRatio borderImageOutset borderImageSlice borderImageWidth boxFlex boxFlexGroup boxOrdinalGroup columnCount columns flex flexGrow flexPositive flexShrink flexNegative flexOrder gridArea gridRow gridRowEnd gridRowSpan gridRowStart gridColumn gridColumnEnd gridColumnSpan gridColumnStart fontWeight lineClamp lineHeight opacity order orphans scale tabSize widows zIndex zoom fillOpacity floodOpacity stopOpacity strokeDasharray strokeDashoffset strokeMiterlimit strokeOpacity strokeWidth MozAnimationIterationCount MozBoxFlex MozBoxFlexGroup MozLineClamp msAnimationIterationCount msFlex msZoom msFlexGrow msFlexNegative msFlexOrder msFlexPositive msFlexShrink msGridColumn msGridColumnSpan msGridRow msGridRowSpan WebkitAnimationIterationCount WebkitBoxFlex WebKitBoxFlexGroup WebkitBoxOrdinalGroup WebkitColumnCount WebkitColumns WebkitFlex WebkitFlexGrow WebkitFlexPositive WebkitFlexShrink WebkitLineClamp".split(" "));
function $dca0ddb82b882518$var$setValueForStyle(style, styleName, value) {
    var isCustomProperty = 0 === styleName.indexOf("--");
    null == value || "boolean" === typeof value || "" === value ? isCustomProperty ? style.setProperty(styleName, "") : "float" === styleName ? style.cssFloat = "" : style[styleName] = "" : isCustomProperty ? style.setProperty(styleName, value) : "number" !== typeof value || 0 === value || $dca0ddb82b882518$var$unitlessNumbers.has(styleName) ? "float" === styleName ? style.cssFloat = value : style[styleName] = ("" + value).trim() : style[styleName] = value + "px";
}
function $dca0ddb82b882518$var$setValueForStyles(node, styles, prevStyles) {
    if (null != styles && "object" !== typeof styles) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(62));
    node = node.style;
    if (null != prevStyles) {
        for(var styleName in prevStyles)!prevStyles.hasOwnProperty(styleName) || null != styles && styles.hasOwnProperty(styleName) || (0 === styleName.indexOf("--") ? node.setProperty(styleName, "") : "float" === styleName ? node.cssFloat = "" : node[styleName] = "", $dca0ddb82b882518$var$viewTransitionMutationContext = !0);
        for(var styleName$16 in styles)styleName = styles[styleName$16], styles.hasOwnProperty(styleName$16) && prevStyles[styleName$16] !== styleName && ($dca0ddb82b882518$var$setValueForStyle(node, styleName$16, styleName), $dca0ddb82b882518$var$viewTransitionMutationContext = !0);
    } else for(var styleName$17 in styles)styles.hasOwnProperty(styleName$17) && $dca0ddb82b882518$var$setValueForStyle(node, styleName$17, styles[styleName$17]);
}
function $dca0ddb82b882518$var$isCustomElement(tagName) {
    if (-1 === tagName.indexOf("-")) return !1;
    switch(tagName){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $dca0ddb82b882518$var$aliases = new Map([
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ],
    [
        "crossOrigin",
        "crossorigin"
    ],
    [
        "accentHeight",
        "accent-height"
    ],
    [
        "alignmentBaseline",
        "alignment-baseline"
    ],
    [
        "arabicForm",
        "arabic-form"
    ],
    [
        "baselineShift",
        "baseline-shift"
    ],
    [
        "capHeight",
        "cap-height"
    ],
    [
        "clipPath",
        "clip-path"
    ],
    [
        "clipRule",
        "clip-rule"
    ],
    [
        "colorInterpolation",
        "color-interpolation"
    ],
    [
        "colorInterpolationFilters",
        "color-interpolation-filters"
    ],
    [
        "colorProfile",
        "color-profile"
    ],
    [
        "colorRendering",
        "color-rendering"
    ],
    [
        "dominantBaseline",
        "dominant-baseline"
    ],
    [
        "enableBackground",
        "enable-background"
    ],
    [
        "fillOpacity",
        "fill-opacity"
    ],
    [
        "fillRule",
        "fill-rule"
    ],
    [
        "floodColor",
        "flood-color"
    ],
    [
        "floodOpacity",
        "flood-opacity"
    ],
    [
        "fontFamily",
        "font-family"
    ],
    [
        "fontSize",
        "font-size"
    ],
    [
        "fontSizeAdjust",
        "font-size-adjust"
    ],
    [
        "fontStretch",
        "font-stretch"
    ],
    [
        "fontStyle",
        "font-style"
    ],
    [
        "fontVariant",
        "font-variant"
    ],
    [
        "fontWeight",
        "font-weight"
    ],
    [
        "glyphName",
        "glyph-name"
    ],
    [
        "glyphOrientationHorizontal",
        "glyph-orientation-horizontal"
    ],
    [
        "glyphOrientationVertical",
        "glyph-orientation-vertical"
    ],
    [
        "horizAdvX",
        "horiz-adv-x"
    ],
    [
        "horizOriginX",
        "horiz-origin-x"
    ],
    [
        "imageRendering",
        "image-rendering"
    ],
    [
        "letterSpacing",
        "letter-spacing"
    ],
    [
        "lightingColor",
        "lighting-color"
    ],
    [
        "markerEnd",
        "marker-end"
    ],
    [
        "markerMid",
        "marker-mid"
    ],
    [
        "markerStart",
        "marker-start"
    ],
    [
        "maskType",
        "mask-type"
    ],
    [
        "overlinePosition",
        "overline-position"
    ],
    [
        "overlineThickness",
        "overline-thickness"
    ],
    [
        "paintOrder",
        "paint-order"
    ],
    [
        "panose-1",
        "panose-1"
    ],
    [
        "pointerEvents",
        "pointer-events"
    ],
    [
        "renderingIntent",
        "rendering-intent"
    ],
    [
        "shapeRendering",
        "shape-rendering"
    ],
    [
        "stopColor",
        "stop-color"
    ],
    [
        "stopOpacity",
        "stop-opacity"
    ],
    [
        "strikethroughPosition",
        "strikethrough-position"
    ],
    [
        "strikethroughThickness",
        "strikethrough-thickness"
    ],
    [
        "strokeDasharray",
        "stroke-dasharray"
    ],
    [
        "strokeDashoffset",
        "stroke-dashoffset"
    ],
    [
        "strokeLinecap",
        "stroke-linecap"
    ],
    [
        "strokeLinejoin",
        "stroke-linejoin"
    ],
    [
        "strokeMiterlimit",
        "stroke-miterlimit"
    ],
    [
        "strokeOpacity",
        "stroke-opacity"
    ],
    [
        "strokeWidth",
        "stroke-width"
    ],
    [
        "textAnchor",
        "text-anchor"
    ],
    [
        "textDecoration",
        "text-decoration"
    ],
    [
        "textRendering",
        "text-rendering"
    ],
    [
        "transformOrigin",
        "transform-origin"
    ],
    [
        "underlinePosition",
        "underline-position"
    ],
    [
        "underlineThickness",
        "underline-thickness"
    ],
    [
        "unicodeBidi",
        "unicode-bidi"
    ],
    [
        "unicodeRange",
        "unicode-range"
    ],
    [
        "unitsPerEm",
        "units-per-em"
    ],
    [
        "vAlphabetic",
        "v-alphabetic"
    ],
    [
        "vHanging",
        "v-hanging"
    ],
    [
        "vIdeographic",
        "v-ideographic"
    ],
    [
        "vMathematical",
        "v-mathematical"
    ],
    [
        "vectorEffect",
        "vector-effect"
    ],
    [
        "vertAdvY",
        "vert-adv-y"
    ],
    [
        "vertOriginX",
        "vert-origin-x"
    ],
    [
        "vertOriginY",
        "vert-origin-y"
    ],
    [
        "wordSpacing",
        "word-spacing"
    ],
    [
        "writingMode",
        "writing-mode"
    ],
    [
        "xmlnsXlink",
        "xmlns:xlink"
    ],
    [
        "xHeight",
        "x-height"
    ]
]), $dca0ddb82b882518$var$isJavaScriptProtocol = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*:/i;
function $dca0ddb82b882518$var$sanitizeURL(url) {
    return $dca0ddb82b882518$var$isJavaScriptProtocol.test("" + url) ? "javascript:throw new Error('React has blocked a javascript: URL as a security precaution.')" : url;
}
function $dca0ddb82b882518$var$noop$1() {}
var $dca0ddb82b882518$var$currentReplayingEvent = null;
function $dca0ddb82b882518$var$getEventTarget(nativeEvent) {
    nativeEvent = nativeEvent.target || nativeEvent.srcElement || window;
    nativeEvent.correspondingUseElement && (nativeEvent = nativeEvent.correspondingUseElement);
    return 3 === nativeEvent.nodeType ? nativeEvent.parentNode : nativeEvent;
}
var $dca0ddb82b882518$var$restoreTarget = null, $dca0ddb82b882518$var$restoreQueue = null;
function $dca0ddb82b882518$var$restoreStateOfTarget(target) {
    var internalInstance = $dca0ddb82b882518$var$getInstanceFromNode(target);
    if (internalInstance && (target = internalInstance.stateNode)) {
        var props = target[$dca0ddb82b882518$var$internalPropsKey] || null;
        a: switch(target = internalInstance.stateNode, internalInstance.type){
            case "input":
                $dca0ddb82b882518$var$updateInput(target, props.value, props.defaultValue, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name);
                internalInstance = props.name;
                if ("radio" === props.type && null != internalInstance) {
                    for(props = target; props.parentNode;)props = props.parentNode;
                    props = props.querySelectorAll('input[name="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes("" + internalInstance) + '"][type="radio"]');
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++){
                        var otherNode = props[internalInstance];
                        if (otherNode !== target && otherNode.form === target.form) {
                            var otherProps = otherNode[$dca0ddb82b882518$var$internalPropsKey] || null;
                            if (!otherProps) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(90));
                            $dca0ddb82b882518$var$updateInput(otherNode, otherProps.value, otherProps.defaultValue, otherProps.defaultValue, otherProps.checked, otherProps.defaultChecked, otherProps.type, otherProps.name);
                        }
                    }
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++)otherNode = props[internalInstance], otherNode.form === target.form && $dca0ddb82b882518$var$updateValueIfChanged(otherNode);
                }
                break a;
            case "textarea":
                $dca0ddb82b882518$var$updateTextarea(target, props.value, props.defaultValue);
                break a;
            case "select":
                internalInstance = props.value, null != internalInstance && $dca0ddb82b882518$var$updateOptions(target, !!props.multiple, internalInstance, !1);
        }
    }
}
var $dca0ddb82b882518$var$isInsideEventHandler = !1;
function $dca0ddb82b882518$var$batchedUpdates$1(fn, a, b) {
    if ($dca0ddb82b882518$var$isInsideEventHandler) return fn(a, b);
    $dca0ddb82b882518$var$isInsideEventHandler = !0;
    try {
        var JSCompiler_inline_result = fn(a);
        return JSCompiler_inline_result;
    } finally{
        if ($dca0ddb82b882518$var$isInsideEventHandler = !1, null !== $dca0ddb82b882518$var$restoreTarget || null !== $dca0ddb82b882518$var$restoreQueue) {
            if ($dca0ddb82b882518$var$flushSyncWork$1(), $dca0ddb82b882518$var$restoreTarget && (a = $dca0ddb82b882518$var$restoreTarget, fn = $dca0ddb82b882518$var$restoreQueue, $dca0ddb82b882518$var$restoreQueue = $dca0ddb82b882518$var$restoreTarget = null, $dca0ddb82b882518$var$restoreStateOfTarget(a), fn)) for(a = 0; a < fn.length; a++)$dca0ddb82b882518$var$restoreStateOfTarget(fn[a]);
        }
    }
}
function $dca0ddb82b882518$var$getListener(inst, registrationName) {
    var stateNode = inst.stateNode;
    if (null === stateNode) return null;
    var props = stateNode[$dca0ddb82b882518$var$internalPropsKey] || null;
    if (null === props) return null;
    stateNode = props[registrationName];
    a: switch(registrationName){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (props = !props.disabled) || (inst = inst.type, props = !("button" === inst || "input" === inst || "select" === inst || "textarea" === inst));
            inst = !props;
            break a;
        default:
            inst = !1;
    }
    if (inst) return null;
    if (stateNode && "function" !== typeof stateNode) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(231, registrationName, typeof stateNode));
    return stateNode;
}
var $dca0ddb82b882518$var$canUseDOM = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $dca0ddb82b882518$var$passiveBrowserEventsSupported = !1;
if ($dca0ddb82b882518$var$canUseDOM) try {
    var $dca0ddb82b882518$var$options = {};
    Object.defineProperty($dca0ddb82b882518$var$options, "passive", {
        get: function() {
            $dca0ddb82b882518$var$passiveBrowserEventsSupported = !0;
        }
    });
    window.addEventListener("test", $dca0ddb82b882518$var$options, $dca0ddb82b882518$var$options);
    window.removeEventListener("test", $dca0ddb82b882518$var$options, $dca0ddb82b882518$var$options);
} catch (e) {
    $dca0ddb82b882518$var$passiveBrowserEventsSupported = !1;
}
var $dca0ddb82b882518$var$root = null, $dca0ddb82b882518$var$startText = null, $dca0ddb82b882518$var$fallbackText = null;
function $dca0ddb82b882518$var$getData() {
    if ($dca0ddb82b882518$var$fallbackText) return $dca0ddb82b882518$var$fallbackText;
    var start, startValue = $dca0ddb82b882518$var$startText, startLength = startValue.length, end, endValue = "value" in $dca0ddb82b882518$var$root ? $dca0ddb82b882518$var$root.value : $dca0ddb82b882518$var$root.textContent, endLength = endValue.length;
    for(start = 0; start < startLength && startValue[start] === endValue[start]; start++);
    var minEnd = startLength - start;
    for(end = 1; end <= minEnd && startValue[startLength - end] === endValue[endLength - end]; end++);
    return $dca0ddb82b882518$var$fallbackText = endValue.slice(start, 1 < end ? 1 - end : void 0);
}
function $dca0ddb82b882518$var$getEventCharCode(nativeEvent) {
    var keyCode = nativeEvent.keyCode;
    "charCode" in nativeEvent ? (nativeEvent = nativeEvent.charCode, 0 === nativeEvent && 13 === keyCode && (nativeEvent = 13)) : nativeEvent = keyCode;
    10 === nativeEvent && (nativeEvent = 13);
    return 32 <= nativeEvent || 13 === nativeEvent ? nativeEvent : 0;
}
function $dca0ddb82b882518$var$functionThatReturnsTrue() {
    return !0;
}
function $dca0ddb82b882518$var$functionThatReturnsFalse() {
    return !1;
}
function $dca0ddb82b882518$var$createSyntheticEvent(Interface) {
    function SyntheticBaseEvent(reactName, reactEventType, targetInst, nativeEvent, nativeEventTarget) {
        this._reactName = reactName;
        this._targetInst = targetInst;
        this.type = reactEventType;
        this.nativeEvent = nativeEvent;
        this.target = nativeEventTarget;
        this.currentTarget = null;
        for(var propName in Interface)Interface.hasOwnProperty(propName) && (reactName = Interface[propName], this[propName] = reactName ? reactName(nativeEvent) : nativeEvent[propName]);
        this.isDefaultPrevented = (null != nativeEvent.defaultPrevented ? nativeEvent.defaultPrevented : !1 === nativeEvent.returnValue) ? $dca0ddb82b882518$var$functionThatReturnsTrue : $dca0ddb82b882518$var$functionThatReturnsFalse;
        this.isPropagationStopped = $dca0ddb82b882518$var$functionThatReturnsFalse;
        return this;
    }
    $dca0ddb82b882518$var$assign(SyntheticBaseEvent.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var event = this.nativeEvent;
            event && (event.preventDefault ? event.preventDefault() : "unknown" !== typeof event.returnValue && (event.returnValue = !1), this.isDefaultPrevented = $dca0ddb82b882518$var$functionThatReturnsTrue);
        },
        stopPropagation: function() {
            var event = this.nativeEvent;
            event && (event.stopPropagation ? event.stopPropagation() : "unknown" !== typeof event.cancelBubble && (event.cancelBubble = !0), this.isPropagationStopped = $dca0ddb82b882518$var$functionThatReturnsTrue);
        },
        persist: function() {},
        isPersistent: $dca0ddb82b882518$var$functionThatReturnsTrue
    });
    return SyntheticBaseEvent;
}
var $dca0ddb82b882518$var$EventInterface = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(event) {
        return event.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $dca0ddb82b882518$var$SyntheticEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$EventInterface), $dca0ddb82b882518$var$UIEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    view: 0,
    detail: 0
}), $dca0ddb82b882518$var$SyntheticUIEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$UIEventInterface), $dca0ddb82b882518$var$lastMovementX, $dca0ddb82b882518$var$lastMovementY, $dca0ddb82b882518$var$lastMouseEvent, $dca0ddb82b882518$var$MouseEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$UIEventInterface, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $dca0ddb82b882518$var$getEventModifierState,
    button: 0,
    buttons: 0,
    relatedTarget: function(event) {
        return void 0 === event.relatedTarget ? event.fromElement === event.srcElement ? event.toElement : event.fromElement : event.relatedTarget;
    },
    movementX: function(event) {
        if ("movementX" in event) return event.movementX;
        event !== $dca0ddb82b882518$var$lastMouseEvent && ($dca0ddb82b882518$var$lastMouseEvent && "mousemove" === event.type ? ($dca0ddb82b882518$var$lastMovementX = event.screenX - $dca0ddb82b882518$var$lastMouseEvent.screenX, $dca0ddb82b882518$var$lastMovementY = event.screenY - $dca0ddb82b882518$var$lastMouseEvent.screenY) : $dca0ddb82b882518$var$lastMovementY = $dca0ddb82b882518$var$lastMovementX = 0, $dca0ddb82b882518$var$lastMouseEvent = event);
        return $dca0ddb82b882518$var$lastMovementX;
    },
    movementY: function(event) {
        return "movementY" in event ? event.movementY : $dca0ddb82b882518$var$lastMovementY;
    }
}), $dca0ddb82b882518$var$SyntheticMouseEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$MouseEventInterface), $dca0ddb82b882518$var$DragEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$MouseEventInterface, {
    dataTransfer: 0
}), $dca0ddb82b882518$var$SyntheticDragEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$DragEventInterface), $dca0ddb82b882518$var$FocusEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$UIEventInterface, {
    relatedTarget: 0
}), $dca0ddb82b882518$var$SyntheticFocusEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$FocusEventInterface), $dca0ddb82b882518$var$AnimationEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $dca0ddb82b882518$var$SyntheticAnimationEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$AnimationEventInterface), $dca0ddb82b882518$var$ClipboardEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    clipboardData: function(event) {
        return "clipboardData" in event ? event.clipboardData : window.clipboardData;
    }
}), $dca0ddb82b882518$var$SyntheticClipboardEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$ClipboardEventInterface), $dca0ddb82b882518$var$CompositionEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    data: 0
}), $dca0ddb82b882518$var$SyntheticCompositionEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$CompositionEventInterface), $dca0ddb82b882518$var$normalizeKey = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $dca0ddb82b882518$var$translateToKey = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $dca0ddb82b882518$var$modifierKeyToProp = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $dca0ddb82b882518$var$modifierStateGetter(keyArg) {
    var nativeEvent = this.nativeEvent;
    return nativeEvent.getModifierState ? nativeEvent.getModifierState(keyArg) : (keyArg = $dca0ddb82b882518$var$modifierKeyToProp[keyArg]) ? !!nativeEvent[keyArg] : !1;
}
function $dca0ddb82b882518$var$getEventModifierState() {
    return $dca0ddb82b882518$var$modifierStateGetter;
}
var $dca0ddb82b882518$var$KeyboardEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$UIEventInterface, {
    key: function(nativeEvent) {
        if (nativeEvent.key) {
            var key = $dca0ddb82b882518$var$normalizeKey[nativeEvent.key] || nativeEvent.key;
            if ("Unidentified" !== key) return key;
        }
        return "keypress" === nativeEvent.type ? (nativeEvent = $dca0ddb82b882518$var$getEventCharCode(nativeEvent), 13 === nativeEvent ? "Enter" : String.fromCharCode(nativeEvent)) : "keydown" === nativeEvent.type || "keyup" === nativeEvent.type ? $dca0ddb82b882518$var$translateToKey[nativeEvent.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $dca0ddb82b882518$var$getEventModifierState,
    charCode: function(event) {
        return "keypress" === event.type ? $dca0ddb82b882518$var$getEventCharCode(event) : 0;
    },
    keyCode: function(event) {
        return "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    },
    which: function(event) {
        return "keypress" === event.type ? $dca0ddb82b882518$var$getEventCharCode(event) : "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    }
}), $dca0ddb82b882518$var$SyntheticKeyboardEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$KeyboardEventInterface), $dca0ddb82b882518$var$PointerEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$MouseEventInterface, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $dca0ddb82b882518$var$SyntheticPointerEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$PointerEventInterface), $dca0ddb82b882518$var$SubmitEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    submitter: 0
}), $dca0ddb82b882518$var$SyntheticSubmitEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$SubmitEventInterface), $dca0ddb82b882518$var$TouchEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$UIEventInterface, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $dca0ddb82b882518$var$getEventModifierState
}), $dca0ddb82b882518$var$SyntheticTouchEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$TouchEventInterface), $dca0ddb82b882518$var$TransitionEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $dca0ddb82b882518$var$SyntheticTransitionEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$TransitionEventInterface), $dca0ddb82b882518$var$WheelEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$MouseEventInterface, {
    deltaX: function(event) {
        return "deltaX" in event ? event.deltaX : "wheelDeltaX" in event ? -event.wheelDeltaX : 0;
    },
    deltaY: function(event) {
        return "deltaY" in event ? event.deltaY : "wheelDeltaY" in event ? -event.wheelDeltaY : "wheelDelta" in event ? -event.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $dca0ddb82b882518$var$SyntheticWheelEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$WheelEventInterface), $dca0ddb82b882518$var$ToggleEventInterface = $dca0ddb82b882518$var$assign({}, $dca0ddb82b882518$var$EventInterface, {
    newState: 0,
    oldState: 0,
    source: 0
}), $dca0ddb82b882518$var$SyntheticToggleEvent = $dca0ddb82b882518$var$createSyntheticEvent($dca0ddb82b882518$var$ToggleEventInterface), $dca0ddb82b882518$var$END_KEYCODES = [
    9,
    13,
    27,
    32
], $dca0ddb82b882518$var$canUseCompositionEvent = $dca0ddb82b882518$var$canUseDOM && "CompositionEvent" in window, $dca0ddb82b882518$var$documentMode = null;
$dca0ddb82b882518$var$canUseDOM && "documentMode" in document && ($dca0ddb82b882518$var$documentMode = document.documentMode);
var $dca0ddb82b882518$var$canUseTextInputEvent = $dca0ddb82b882518$var$canUseDOM && "TextEvent" in window && !$dca0ddb82b882518$var$documentMode, $dca0ddb82b882518$var$useFallbackCompositionData = $dca0ddb82b882518$var$canUseDOM && (!$dca0ddb82b882518$var$canUseCompositionEvent || $dca0ddb82b882518$var$documentMode && 8 < $dca0ddb82b882518$var$documentMode && 11 >= $dca0ddb82b882518$var$documentMode), $dca0ddb82b882518$var$SPACEBAR_CHAR = String.fromCharCode(32), $dca0ddb82b882518$var$hasSpaceKeypress = !1;
function $dca0ddb82b882518$var$isFallbackCompositionEnd(domEventName, nativeEvent) {
    switch(domEventName){
        case "keyup":
            return -1 !== $dca0ddb82b882518$var$END_KEYCODES.indexOf(nativeEvent.keyCode);
        case "keydown":
            return 229 !== nativeEvent.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $dca0ddb82b882518$var$getDataFromCustomEvent(nativeEvent) {
    nativeEvent = nativeEvent.detail;
    return "object" === typeof nativeEvent && "data" in nativeEvent ? nativeEvent.data : null;
}
var $dca0ddb82b882518$var$isComposing = !1;
function $dca0ddb82b882518$var$getNativeBeforeInputChars(domEventName, nativeEvent) {
    switch(domEventName){
        case "compositionend":
            return $dca0ddb82b882518$var$getDataFromCustomEvent(nativeEvent);
        case "keypress":
            if (32 !== nativeEvent.which) return null;
            $dca0ddb82b882518$var$hasSpaceKeypress = !0;
            return $dca0ddb82b882518$var$SPACEBAR_CHAR;
        case "textInput":
            return domEventName = nativeEvent.data, domEventName === $dca0ddb82b882518$var$SPACEBAR_CHAR && $dca0ddb82b882518$var$hasSpaceKeypress ? null : domEventName;
        default:
            return null;
    }
}
function $dca0ddb82b882518$var$getFallbackBeforeInputChars(domEventName, nativeEvent) {
    if ($dca0ddb82b882518$var$isComposing) return "compositionend" === domEventName || !$dca0ddb82b882518$var$canUseCompositionEvent && $dca0ddb82b882518$var$isFallbackCompositionEnd(domEventName, nativeEvent) ? (domEventName = $dca0ddb82b882518$var$getData(), $dca0ddb82b882518$var$fallbackText = $dca0ddb82b882518$var$startText = $dca0ddb82b882518$var$root = null, $dca0ddb82b882518$var$isComposing = !1, domEventName) : null;
    switch(domEventName){
        case "paste":
            return null;
        case "keypress":
            if (!(nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) || nativeEvent.ctrlKey && nativeEvent.altKey) {
                if (nativeEvent.char && 1 < nativeEvent.char.length) return nativeEvent.char;
                if (nativeEvent.which) return String.fromCharCode(nativeEvent.which);
            }
            return null;
        case "compositionend":
            return $dca0ddb82b882518$var$useFallbackCompositionData && "ko" !== nativeEvent.locale ? null : nativeEvent.data;
        default:
            return null;
    }
}
var $dca0ddb82b882518$var$supportedInputTypes = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $dca0ddb82b882518$var$isTextInputElement(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return "input" === nodeName ? !!$dca0ddb82b882518$var$supportedInputTypes[elem.type] : "textarea" === nodeName ? !0 : !1;
}
function $dca0ddb82b882518$var$createAndAccumulateChangeEvent(dispatchQueue, inst, nativeEvent, target) {
    $dca0ddb82b882518$var$restoreTarget ? $dca0ddb82b882518$var$restoreQueue ? $dca0ddb82b882518$var$restoreQueue.push(target) : $dca0ddb82b882518$var$restoreQueue = [
        target
    ] : $dca0ddb82b882518$var$restoreTarget = target;
    inst = $dca0ddb82b882518$var$accumulateTwoPhaseListeners(inst, "onChange");
    0 < inst.length && (nativeEvent = new $dca0ddb82b882518$var$SyntheticEvent("onChange", "change", null, nativeEvent, target), dispatchQueue.push({
        event: nativeEvent,
        listeners: inst
    }));
}
var $dca0ddb82b882518$var$activeElement$1 = null, $dca0ddb82b882518$var$activeElementInst$1 = null;
function $dca0ddb82b882518$var$runEventInBatch(dispatchQueue) {
    $dca0ddb82b882518$var$processDispatchQueue(dispatchQueue, 0);
}
function $dca0ddb82b882518$var$getInstIfValueChanged(targetInst) {
    var targetNode = $dca0ddb82b882518$var$getNodeFromInstance(targetInst);
    if ($dca0ddb82b882518$var$updateValueIfChanged(targetNode)) return targetInst;
}
function $dca0ddb82b882518$var$getTargetInstForChangeEvent(domEventName, targetInst) {
    if ("change" === domEventName) return targetInst;
}
var $dca0ddb82b882518$var$isInputEventSupported = !1;
if ($dca0ddb82b882518$var$canUseDOM) {
    var $dca0ddb82b882518$var$JSCompiler_inline_result$jscomp$318;
    if ($dca0ddb82b882518$var$canUseDOM) {
        var $dca0ddb82b882518$var$isSupported$jscomp$inline_474 = "oninput" in document;
        if (!$dca0ddb82b882518$var$isSupported$jscomp$inline_474) {
            var $dca0ddb82b882518$var$element$jscomp$inline_475 = document.createElement("div");
            $dca0ddb82b882518$var$element$jscomp$inline_475.setAttribute("oninput", "return;");
            $dca0ddb82b882518$var$isSupported$jscomp$inline_474 = "function" === typeof $dca0ddb82b882518$var$element$jscomp$inline_475.oninput;
        }
        $dca0ddb82b882518$var$JSCompiler_inline_result$jscomp$318 = $dca0ddb82b882518$var$isSupported$jscomp$inline_474;
    } else $dca0ddb82b882518$var$JSCompiler_inline_result$jscomp$318 = !1;
    $dca0ddb82b882518$var$isInputEventSupported = $dca0ddb82b882518$var$JSCompiler_inline_result$jscomp$318 && (!document.documentMode || 9 < document.documentMode);
}
function $dca0ddb82b882518$var$stopWatchingForValueChange() {
    $dca0ddb82b882518$var$activeElement$1 && ($dca0ddb82b882518$var$activeElement$1.detachEvent("onpropertychange", $dca0ddb82b882518$var$handlePropertyChange), $dca0ddb82b882518$var$activeElementInst$1 = $dca0ddb82b882518$var$activeElement$1 = null);
}
function $dca0ddb82b882518$var$handlePropertyChange(nativeEvent) {
    if ("value" === nativeEvent.propertyName && $dca0ddb82b882518$var$getInstIfValueChanged($dca0ddb82b882518$var$activeElementInst$1)) {
        var dispatchQueue = [];
        $dca0ddb82b882518$var$createAndAccumulateChangeEvent(dispatchQueue, $dca0ddb82b882518$var$activeElementInst$1, nativeEvent, $dca0ddb82b882518$var$getEventTarget(nativeEvent));
        $dca0ddb82b882518$var$batchedUpdates$1($dca0ddb82b882518$var$runEventInBatch, dispatchQueue);
    }
}
function $dca0ddb82b882518$var$handleEventsForInputEventPolyfill(domEventName, target, targetInst) {
    "focusin" === domEventName ? ($dca0ddb82b882518$var$stopWatchingForValueChange(), $dca0ddb82b882518$var$activeElement$1 = target, $dca0ddb82b882518$var$activeElementInst$1 = targetInst, $dca0ddb82b882518$var$activeElement$1.attachEvent("onpropertychange", $dca0ddb82b882518$var$handlePropertyChange)) : "focusout" === domEventName && $dca0ddb82b882518$var$stopWatchingForValueChange();
}
function $dca0ddb82b882518$var$getTargetInstForInputEventPolyfill(domEventName) {
    if ("selectionchange" === domEventName || "keyup" === domEventName || "keydown" === domEventName) return $dca0ddb82b882518$var$getInstIfValueChanged($dca0ddb82b882518$var$activeElementInst$1);
}
function $dca0ddb82b882518$var$getTargetInstForClickEvent(domEventName, targetInst) {
    if ("click" === domEventName) return $dca0ddb82b882518$var$getInstIfValueChanged(targetInst);
}
function $dca0ddb82b882518$var$getTargetInstForInputOrChangeEvent(domEventName, targetInst) {
    if ("input" === domEventName || "change" === domEventName) return $dca0ddb82b882518$var$getInstIfValueChanged(targetInst);
}
function $dca0ddb82b882518$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $dca0ddb82b882518$var$objectIs = "function" === typeof Object.is ? Object.is : $dca0ddb82b882518$var$is;
function $dca0ddb82b882518$var$shallowEqual(objA, objB) {
    if ($dca0ddb82b882518$var$objectIs(objA, objB)) return !0;
    if ("object" !== typeof objA || null === objA || "object" !== typeof objB || null === objB) return !1;
    var keysA = Object.keys(objA), keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return !1;
    for(keysB = 0; keysB < keysA.length; keysB++){
        var currentKey = keysA[keysB];
        if (!$dca0ddb82b882518$var$hasOwnProperty.call(objB, currentKey) || !$dca0ddb82b882518$var$objectIs(objA[currentKey], objB[currentKey])) return !1;
    }
    return !0;
}
function $dca0ddb82b882518$var$getActiveElement(doc) {
    doc = doc || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof doc) return null;
    try {
        return doc.activeElement || doc.body;
    } catch (e$20) {
        return doc.body;
    }
}
function $dca0ddb82b882518$var$getLeafNode(node) {
    for(; node && node.firstChild;)node = node.firstChild;
    return node;
}
function $dca0ddb82b882518$var$getNodeForCharacterOffset(root, offset) {
    var node = $dca0ddb82b882518$var$getLeafNode(root);
    root = 0;
    for(var nodeEnd; node;){
        if (3 === node.nodeType) {
            nodeEnd = root + node.textContent.length;
            if (root <= offset && nodeEnd >= offset) return {
                node: node,
                offset: offset - root
            };
            root = nodeEnd;
        }
        a: {
            for(; node;){
                if (node.nextSibling) {
                    node = node.nextSibling;
                    break a;
                }
                node = node.parentNode;
            }
            node = void 0;
        }
        node = $dca0ddb82b882518$var$getLeafNode(node);
    }
}
function $dca0ddb82b882518$var$containsNode(outerNode, innerNode) {
    return outerNode && innerNode ? outerNode === innerNode ? !0 : outerNode && 3 === outerNode.nodeType ? !1 : innerNode && 3 === innerNode.nodeType ? $dca0ddb82b882518$var$containsNode(outerNode, innerNode.parentNode) : "contains" in outerNode ? outerNode.contains(innerNode) : outerNode.compareDocumentPosition ? !!(outerNode.compareDocumentPosition(innerNode) & 16) : !1 : !1;
}
function $dca0ddb82b882518$var$getActiveElementDeep(containerInfo) {
    containerInfo = null != containerInfo && null != containerInfo.ownerDocument && null != containerInfo.ownerDocument.defaultView ? containerInfo.ownerDocument.defaultView : window;
    for(var element = $dca0ddb82b882518$var$getActiveElement(containerInfo.document); element instanceof containerInfo.HTMLIFrameElement;){
        try {
            var JSCompiler_inline_result = "string" === typeof element.contentWindow.location.href;
        } catch (err) {
            JSCompiler_inline_result = !1;
        }
        if (JSCompiler_inline_result) containerInfo = element.contentWindow;
        else break;
        element = $dca0ddb82b882518$var$getActiveElement(containerInfo.document);
    }
    return element;
}
function $dca0ddb82b882518$var$hasSelectionCapabilities(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return nodeName && ("input" === nodeName && ("text" === elem.type || "search" === elem.type || "tel" === elem.type || "url" === elem.type || "password" === elem.type) || "textarea" === nodeName || "true" === elem.contentEditable);
}
var $dca0ddb82b882518$var$skipSelectionChangeEvent = $dca0ddb82b882518$var$canUseDOM && "documentMode" in document && 11 >= document.documentMode, $dca0ddb82b882518$var$activeElement = null, $dca0ddb82b882518$var$activeElementInst = null, $dca0ddb82b882518$var$lastSelection = null, $dca0ddb82b882518$var$mouseDown = !1;
function $dca0ddb82b882518$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget) {
    var doc = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget.document : 9 === nativeEventTarget.nodeType ? nativeEventTarget : nativeEventTarget.ownerDocument;
    $dca0ddb82b882518$var$mouseDown || null == $dca0ddb82b882518$var$activeElement || $dca0ddb82b882518$var$activeElement !== $dca0ddb82b882518$var$getActiveElement(doc) || (doc = $dca0ddb82b882518$var$activeElement, "selectionStart" in doc && $dca0ddb82b882518$var$hasSelectionCapabilities(doc) ? doc = {
        start: doc.selectionStart,
        end: doc.selectionEnd
    } : (doc = (doc.ownerDocument && doc.ownerDocument.defaultView || window).getSelection(), doc = {
        anchorNode: doc.anchorNode,
        anchorOffset: doc.anchorOffset,
        focusNode: doc.focusNode,
        focusOffset: doc.focusOffset
    }), $dca0ddb82b882518$var$lastSelection && $dca0ddb82b882518$var$shallowEqual($dca0ddb82b882518$var$lastSelection, doc) || ($dca0ddb82b882518$var$lastSelection = doc, doc = $dca0ddb82b882518$var$accumulateTwoPhaseListeners($dca0ddb82b882518$var$activeElementInst, "onSelect"), 0 < doc.length && (nativeEvent = new $dca0ddb82b882518$var$SyntheticEvent("onSelect", "select", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
        event: nativeEvent,
        listeners: doc
    }), nativeEvent.target = $dca0ddb82b882518$var$activeElement)));
}
function $dca0ddb82b882518$var$makePrefixMap(styleProp, eventName) {
    var prefixes = {};
    prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
    prefixes["Webkit" + styleProp] = "webkit" + eventName;
    prefixes["Moz" + styleProp] = "moz" + eventName;
    return prefixes;
}
var $dca0ddb82b882518$var$vendorPrefixes = {
    animationend: $dca0ddb82b882518$var$makePrefixMap("Animation", "AnimationEnd"),
    animationiteration: $dca0ddb82b882518$var$makePrefixMap("Animation", "AnimationIteration"),
    animationstart: $dca0ddb82b882518$var$makePrefixMap("Animation", "AnimationStart"),
    transitionrun: $dca0ddb82b882518$var$makePrefixMap("Transition", "TransitionRun"),
    transitionstart: $dca0ddb82b882518$var$makePrefixMap("Transition", "TransitionStart"),
    transitioncancel: $dca0ddb82b882518$var$makePrefixMap("Transition", "TransitionCancel"),
    transitionend: $dca0ddb82b882518$var$makePrefixMap("Transition", "TransitionEnd")
}, $dca0ddb82b882518$var$prefixedEventNames = {}, $dca0ddb82b882518$var$style = {};
$dca0ddb82b882518$var$canUseDOM && ($dca0ddb82b882518$var$style = document.createElement("div").style, "AnimationEvent" in window || (delete $dca0ddb82b882518$var$vendorPrefixes.animationend.animation, delete $dca0ddb82b882518$var$vendorPrefixes.animationiteration.animation, delete $dca0ddb82b882518$var$vendorPrefixes.animationstart.animation), "TransitionEvent" in window || delete $dca0ddb82b882518$var$vendorPrefixes.transitionend.transition);
function $dca0ddb82b882518$var$getVendorPrefixedEventName(eventName) {
    if ($dca0ddb82b882518$var$prefixedEventNames[eventName]) return $dca0ddb82b882518$var$prefixedEventNames[eventName];
    if (!$dca0ddb82b882518$var$vendorPrefixes[eventName]) return eventName;
    var prefixMap = $dca0ddb82b882518$var$vendorPrefixes[eventName], styleProp;
    for(styleProp in prefixMap)if (prefixMap.hasOwnProperty(styleProp) && styleProp in $dca0ddb82b882518$var$style) return $dca0ddb82b882518$var$prefixedEventNames[eventName] = prefixMap[styleProp];
    return eventName;
}
var $dca0ddb82b882518$var$ANIMATION_END = $dca0ddb82b882518$var$getVendorPrefixedEventName("animationend"), $dca0ddb82b882518$var$ANIMATION_ITERATION = $dca0ddb82b882518$var$getVendorPrefixedEventName("animationiteration"), $dca0ddb82b882518$var$ANIMATION_START = $dca0ddb82b882518$var$getVendorPrefixedEventName("animationstart"), $dca0ddb82b882518$var$TRANSITION_RUN = $dca0ddb82b882518$var$getVendorPrefixedEventName("transitionrun"), $dca0ddb82b882518$var$TRANSITION_START = $dca0ddb82b882518$var$getVendorPrefixedEventName("transitionstart"), $dca0ddb82b882518$var$TRANSITION_CANCEL = $dca0ddb82b882518$var$getVendorPrefixedEventName("transitioncancel"), $dca0ddb82b882518$var$TRANSITION_END = $dca0ddb82b882518$var$getVendorPrefixedEventName("transitionend"), $dca0ddb82b882518$var$topLevelEventsToReactNames = new Map(), $dca0ddb82b882518$var$simpleEventPluginEvents = "abort auxClick beforeToggle cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error fullscreenChange fullscreenError gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
$dca0ddb82b882518$var$simpleEventPluginEvents.push("scrollEnd");
function $dca0ddb82b882518$var$registerSimpleEvent(domEventName, reactName) {
    $dca0ddb82b882518$var$topLevelEventsToReactNames.set(domEventName, reactName);
    $dca0ddb82b882518$var$registerTwoPhaseEvent(reactName, [
        domEventName
    ]);
}
var $dca0ddb82b882518$var$globalClientIdCounter$1 = 0;
function $dca0ddb82b882518$var$getViewTransitionName(props, instance) {
    if (null != props.name && "auto" !== props.name) return props.name;
    if (null !== instance.autoName) return instance.autoName;
    props = $dca0ddb82b882518$var$pendingEffectsRoot.identifierPrefix;
    var globalClientId = $dca0ddb82b882518$var$globalClientIdCounter$1++;
    props = "_" + props + "t_" + globalClientId.toString(32) + "_";
    return instance.autoName = props;
}
function $dca0ddb82b882518$var$getClassNameByType(classByType) {
    if (null == classByType || "string" === typeof classByType) return classByType;
    var className = null, activeTypes = $dca0ddb82b882518$var$pendingTransitionTypes;
    if (null !== activeTypes) for(var i = 0; i < activeTypes.length; i++){
        var match = classByType[activeTypes[i]];
        if (null != match) {
            if ("none" === match) return "none";
            className = null == className ? match : className + (" " + match);
        }
    }
    return null == className ? classByType.default : className;
}
function $dca0ddb82b882518$var$getViewTransitionClassName(defaultClass, eventClass) {
    defaultClass = $dca0ddb82b882518$var$getClassNameByType(defaultClass);
    eventClass = $dca0ddb82b882518$var$getClassNameByType(eventClass);
    return null == eventClass ? "auto" === defaultClass ? null : defaultClass : "auto" === eventClass ? null : eventClass;
}
var $dca0ddb82b882518$var$reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    }
    console.error(error);
}, $dca0ddb82b882518$var$concurrentQueues = [], $dca0ddb82b882518$var$concurrentQueuesIndex = 0, $dca0ddb82b882518$var$concurrentlyUpdatedLanes = 0;
function $dca0ddb82b882518$var$finishQueueingConcurrentUpdates() {
    for(var endIndex = $dca0ddb82b882518$var$concurrentQueuesIndex, i = $dca0ddb82b882518$var$concurrentlyUpdatedLanes = $dca0ddb82b882518$var$concurrentQueuesIndex = 0; i < endIndex;){
        var fiber = $dca0ddb82b882518$var$concurrentQueues[i];
        $dca0ddb82b882518$var$concurrentQueues[i++] = null;
        var queue = $dca0ddb82b882518$var$concurrentQueues[i];
        $dca0ddb82b882518$var$concurrentQueues[i++] = null;
        var update = $dca0ddb82b882518$var$concurrentQueues[i];
        $dca0ddb82b882518$var$concurrentQueues[i++] = null;
        var lane = $dca0ddb82b882518$var$concurrentQueues[i];
        $dca0ddb82b882518$var$concurrentQueues[i++] = null;
        if (null !== queue && null !== update) {
            var pending = queue.pending;
            null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
            queue.pending = update;
        }
        0 !== lane && $dca0ddb82b882518$var$markUpdateLaneFromFiberToRoot(fiber, update, lane);
    }
}
function $dca0ddb82b882518$var$enqueueUpdate$1(fiber, queue, update, lane) {
    $dca0ddb82b882518$var$concurrentQueues[$dca0ddb82b882518$var$concurrentQueuesIndex++] = fiber;
    $dca0ddb82b882518$var$concurrentQueues[$dca0ddb82b882518$var$concurrentQueuesIndex++] = queue;
    $dca0ddb82b882518$var$concurrentQueues[$dca0ddb82b882518$var$concurrentQueuesIndex++] = update;
    $dca0ddb82b882518$var$concurrentQueues[$dca0ddb82b882518$var$concurrentQueuesIndex++] = lane;
    $dca0ddb82b882518$var$concurrentlyUpdatedLanes |= lane;
    fiber.lanes |= lane;
    fiber = fiber.alternate;
    null !== fiber && (fiber.lanes |= lane);
}
function $dca0ddb82b882518$var$enqueueConcurrentHookUpdate(fiber, queue, update, lane) {
    $dca0ddb82b882518$var$enqueueUpdate$1(fiber, queue, update, lane);
    return $dca0ddb82b882518$var$getRootForUpdatedFiber(fiber);
}
function $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(fiber, lane) {
    $dca0ddb82b882518$var$enqueueUpdate$1(fiber, null, null, lane);
    return $dca0ddb82b882518$var$getRootForUpdatedFiber(fiber);
}
function $dca0ddb82b882518$var$markUpdateLaneFromFiberToRoot(sourceFiber, update, lane) {
    sourceFiber.lanes |= lane;
    var alternate = sourceFiber.alternate;
    null !== alternate && (alternate.lanes |= lane);
    for(var isHidden = !1, parent = sourceFiber.return; null !== parent;)parent.childLanes |= lane, alternate = parent.alternate, null !== alternate && (alternate.childLanes |= lane), 22 === parent.tag && (sourceFiber = parent.stateNode, null === sourceFiber || sourceFiber._visibility & 1 || (isHidden = !0)), sourceFiber = parent, parent = parent.return;
    return 3 === sourceFiber.tag ? (parent = sourceFiber.stateNode, isHidden && null !== update && (isHidden = 31 - $dca0ddb82b882518$var$clz32(lane), sourceFiber = parent.hiddenUpdates, alternate = sourceFiber[isHidden], null === alternate ? sourceFiber[isHidden] = [
        update
    ] : alternate.push(update), update.lane = lane | 536870912), parent) : null;
}
function $dca0ddb82b882518$var$getRootForUpdatedFiber(sourceFiber) {
    if (50 < $dca0ddb82b882518$var$nestedUpdateCount) throw $dca0ddb82b882518$var$nestedUpdateCount = 0, $dca0ddb82b882518$var$rootWithNestedUpdates = null, Error($dca0ddb82b882518$var$formatProdErrorMessage(185));
    for(var parent = sourceFiber.return; null !== parent;)sourceFiber = parent, parent = sourceFiber.return;
    return 3 === sourceFiber.tag ? sourceFiber.stateNode : null;
}
var $dca0ddb82b882518$var$emptyContextObject = {};
function $dca0ddb82b882518$var$FiberNode(tag, pendingProps, key, mode) {
    this.tag = tag;
    this.key = key;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.refCleanup = this.ref = null;
    this.pendingProps = pendingProps;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = mode;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $dca0ddb82b882518$var$createFiberImplClass(tag, pendingProps, key, mode) {
    return new $dca0ddb82b882518$var$FiberNode(tag, pendingProps, key, mode);
}
function $dca0ddb82b882518$var$shouldConstruct(Component) {
    Component = Component.prototype;
    return !(!Component || !Component.isReactComponent);
}
function $dca0ddb82b882518$var$createWorkInProgress(current, pendingProps) {
    var workInProgress = current.alternate;
    null === workInProgress ? (workInProgress = $dca0ddb82b882518$var$createFiberImplClass(current.tag, pendingProps, current.key, current.mode), workInProgress.elementType = current.elementType, workInProgress.type = current.type, workInProgress.stateNode = current.stateNode, workInProgress.alternate = current, current.alternate = workInProgress) : (workInProgress.pendingProps = pendingProps, workInProgress.type = current.type, workInProgress.flags = 0, workInProgress.subtreeFlags = 0, workInProgress.deletions = null);
    workInProgress.flags = current.flags & 1206910976;
    workInProgress.childLanes = current.childLanes;
    workInProgress.lanes = current.lanes;
    workInProgress.child = current.child;
    workInProgress.memoizedProps = current.memoizedProps;
    workInProgress.memoizedState = current.memoizedState;
    workInProgress.updateQueue = current.updateQueue;
    pendingProps = current.dependencies;
    workInProgress.dependencies = null === pendingProps ? null : {
        lanes: pendingProps.lanes,
        firstContext: pendingProps.firstContext
    };
    workInProgress.sibling = current.sibling;
    workInProgress.index = current.index;
    workInProgress.ref = current.ref;
    workInProgress.refCleanup = current.refCleanup;
    return workInProgress;
}
function $dca0ddb82b882518$var$resetWorkInProgress(workInProgress, renderLanes) {
    workInProgress.flags &= 1206910978;
    var current = workInProgress.alternate;
    null === current ? (workInProgress.childLanes = 0, workInProgress.lanes = renderLanes, workInProgress.child = null, workInProgress.subtreeFlags = 0, workInProgress.memoizedProps = null, workInProgress.memoizedState = null, workInProgress.updateQueue = null, workInProgress.dependencies = null, workInProgress.stateNode = null) : (workInProgress.childLanes = current.childLanes, workInProgress.lanes = current.lanes, workInProgress.child = current.child, workInProgress.subtreeFlags = 0, workInProgress.deletions = null, workInProgress.memoizedProps = current.memoizedProps, workInProgress.memoizedState = current.memoizedState, workInProgress.updateQueue = current.updateQueue, workInProgress.type = current.type, renderLanes = current.dependencies, workInProgress.dependencies = null === renderLanes ? null : {
        lanes: renderLanes.lanes,
        firstContext: renderLanes.firstContext
    });
    return workInProgress;
}
function $dca0ddb82b882518$var$createFiberFromTypeAndProps(type, key, pendingProps, owner, mode, lanes) {
    var fiberTag = 0;
    owner = type;
    if ("function" === typeof owner) $dca0ddb82b882518$var$shouldConstruct(owner) && (fiberTag = 1);
    else if ("string" === typeof owner) fiberTag = $dca0ddb82b882518$var$isHostHoistableType(type, pendingProps, $dca0ddb82b882518$var$contextStackCursor.current) ? 26 : "html" === type || "head" === type || "body" === type ? 27 : 5;
    else a: switch(owner){
        case $dca0ddb82b882518$var$REACT_ACTIVITY_TYPE:
            return type = $dca0ddb82b882518$var$createFiberImplClass(31, pendingProps, key, mode), type.elementType = $dca0ddb82b882518$var$REACT_ACTIVITY_TYPE, type.lanes = lanes, type;
        case $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE:
            return $dca0ddb82b882518$var$createFiberFromFragment(pendingProps.children, mode, lanes, key);
        case $dca0ddb82b882518$var$REACT_STRICT_MODE_TYPE:
            fiberTag = 8;
            mode |= 24;
            break;
        case $dca0ddb82b882518$var$REACT_PROFILER_TYPE:
            return type = $dca0ddb82b882518$var$createFiberImplClass(12, pendingProps, key, mode | 2), type.elementType = $dca0ddb82b882518$var$REACT_PROFILER_TYPE, type.lanes = lanes, type;
        case $dca0ddb82b882518$var$REACT_SUSPENSE_TYPE:
            return type = $dca0ddb82b882518$var$createFiberImplClass(13, pendingProps, key, mode), type.elementType = $dca0ddb82b882518$var$REACT_SUSPENSE_TYPE, type.lanes = lanes, type;
        case $dca0ddb82b882518$var$REACT_SUSPENSE_LIST_TYPE:
            return type = $dca0ddb82b882518$var$createFiberImplClass(19, pendingProps, key, mode), type.elementType = $dca0ddb82b882518$var$REACT_SUSPENSE_LIST_TYPE, type.lanes = lanes, type;
        case $dca0ddb82b882518$var$REACT_LEGACY_HIDDEN_TYPE:
        case $dca0ddb82b882518$var$REACT_VIEW_TRANSITION_TYPE:
            return type = mode | 32, type = $dca0ddb82b882518$var$createFiberImplClass(30, pendingProps, key, type), type.elementType = $dca0ddb82b882518$var$REACT_VIEW_TRANSITION_TYPE, type.lanes = lanes, type.stateNode = {
                autoName: null,
                paired: null,
                clones: null,
                ref: null
            }, type;
        default:
            if ("object" === typeof owner && null !== owner) switch(owner.$$typeof){
                case $dca0ddb82b882518$var$REACT_CONTEXT_TYPE:
                    fiberTag = 10;
                    break a;
                case $dca0ddb82b882518$var$REACT_CONSUMER_TYPE:
                    fiberTag = 9;
                    break a;
                case $dca0ddb82b882518$var$REACT_FORWARD_REF_TYPE:
                    fiberTag = 11;
                    break a;
                case $dca0ddb82b882518$var$REACT_MEMO_TYPE:
                    fiberTag = 14;
                    break a;
                case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
                    fiberTag = 16;
                    owner = null;
                    break a;
            }
            fiberTag = 29;
            pendingProps = Error($dca0ddb82b882518$var$formatProdErrorMessage(130, null === type ? "null" : typeof type, ""));
            owner = null;
    }
    key = $dca0ddb82b882518$var$createFiberImplClass(fiberTag, pendingProps, key, mode);
    key.elementType = type;
    key.type = owner;
    key.lanes = lanes;
    return key;
}
function $dca0ddb82b882518$var$createFiberFromFragment(elements, mode, lanes, key) {
    elements = $dca0ddb82b882518$var$createFiberImplClass(7, elements, key, mode);
    elements.lanes = lanes;
    return elements;
}
function $dca0ddb82b882518$var$createFiberFromText(content, mode, lanes) {
    content = $dca0ddb82b882518$var$createFiberImplClass(6, content, null, mode);
    content.lanes = lanes;
    return content;
}
function $dca0ddb82b882518$var$createFiberFromDehydratedFragment(dehydratedNode) {
    var fiber = $dca0ddb82b882518$var$createFiberImplClass(18, null, null, 0);
    fiber.stateNode = dehydratedNode;
    return fiber;
}
function $dca0ddb82b882518$var$createFiberFromPortal(portal, mode, lanes) {
    mode = $dca0ddb82b882518$var$createFiberImplClass(4, null !== portal.children ? portal.children : [], portal.key, mode);
    mode.lanes = lanes;
    mode.stateNode = {
        containerInfo: portal.containerInfo,
        pendingChildren: null,
        implementation: portal.implementation
    };
    return mode;
}
var $dca0ddb82b882518$var$CapturedStacks = new WeakMap();
function $dca0ddb82b882518$var$createCapturedValueAtFiber(value, source) {
    if ("object" === typeof value && null !== value) {
        var existing = $dca0ddb82b882518$var$CapturedStacks.get(value);
        if (void 0 !== existing) return existing;
        source = {
            value: value,
            source: source,
            stack: $dca0ddb82b882518$var$getStackByFiberInDevAndProd(source)
        };
        $dca0ddb82b882518$var$CapturedStacks.set(value, source);
        return source;
    }
    return {
        value: value,
        source: source,
        stack: $dca0ddb82b882518$var$getStackByFiberInDevAndProd(source)
    };
}
var $dca0ddb82b882518$var$forkStack = [], $dca0ddb82b882518$var$forkStackIndex = 0, $dca0ddb82b882518$var$treeForkProvider = null, $dca0ddb82b882518$var$treeForkCount = 0, $dca0ddb82b882518$var$idStack = [], $dca0ddb82b882518$var$idStackIndex = 0, $dca0ddb82b882518$var$treeContextProvider = null, $dca0ddb82b882518$var$treeContextId = 1, $dca0ddb82b882518$var$treeContextOverflow = "";
function $dca0ddb82b882518$var$pushTreeFork(workInProgress, totalChildren) {
    $dca0ddb82b882518$var$forkStack[$dca0ddb82b882518$var$forkStackIndex++] = $dca0ddb82b882518$var$treeForkCount;
    $dca0ddb82b882518$var$forkStack[$dca0ddb82b882518$var$forkStackIndex++] = $dca0ddb82b882518$var$treeForkProvider;
    $dca0ddb82b882518$var$treeForkProvider = workInProgress;
    $dca0ddb82b882518$var$treeForkCount = totalChildren;
}
function $dca0ddb82b882518$var$pushTreeId(workInProgress, totalChildren, index) {
    $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextId;
    $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextOverflow;
    $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextProvider;
    $dca0ddb82b882518$var$treeContextProvider = workInProgress;
    var baseIdWithLeadingBit = $dca0ddb82b882518$var$treeContextId;
    workInProgress = $dca0ddb82b882518$var$treeContextOverflow;
    var baseLength = 32 - $dca0ddb82b882518$var$clz32(baseIdWithLeadingBit) - 1;
    baseIdWithLeadingBit &= ~(1 << baseLength);
    index += 1;
    var length = 32 - $dca0ddb82b882518$var$clz32(totalChildren) + baseLength;
    if (30 < length) {
        var numberOfOverflowBits = baseLength - baseLength % 5;
        length = (baseIdWithLeadingBit & (1 << numberOfOverflowBits) - 1).toString(32);
        baseIdWithLeadingBit >>= numberOfOverflowBits;
        baseLength -= numberOfOverflowBits;
        $dca0ddb82b882518$var$treeContextId = 1 << 32 - $dca0ddb82b882518$var$clz32(totalChildren) + baseLength | index << baseLength | baseIdWithLeadingBit;
        $dca0ddb82b882518$var$treeContextOverflow = length + workInProgress;
    } else $dca0ddb82b882518$var$treeContextId = 1 << length | index << baseLength | baseIdWithLeadingBit, $dca0ddb82b882518$var$treeContextOverflow = workInProgress;
}
function $dca0ddb82b882518$var$pushMaterializedTreeId(workInProgress) {
    null !== workInProgress.return && ($dca0ddb82b882518$var$pushTreeFork(workInProgress, 1), $dca0ddb82b882518$var$pushTreeId(workInProgress, 1, 0));
}
function $dca0ddb82b882518$var$popTreeContext(workInProgress) {
    for(; workInProgress === $dca0ddb82b882518$var$treeForkProvider;)$dca0ddb82b882518$var$treeForkProvider = $dca0ddb82b882518$var$forkStack[--$dca0ddb82b882518$var$forkStackIndex], $dca0ddb82b882518$var$forkStack[$dca0ddb82b882518$var$forkStackIndex] = null, $dca0ddb82b882518$var$treeForkCount = $dca0ddb82b882518$var$forkStack[--$dca0ddb82b882518$var$forkStackIndex], $dca0ddb82b882518$var$forkStack[$dca0ddb82b882518$var$forkStackIndex] = null;
    for(; workInProgress === $dca0ddb82b882518$var$treeContextProvider;)$dca0ddb82b882518$var$treeContextProvider = $dca0ddb82b882518$var$idStack[--$dca0ddb82b882518$var$idStackIndex], $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex] = null, $dca0ddb82b882518$var$treeContextOverflow = $dca0ddb82b882518$var$idStack[--$dca0ddb82b882518$var$idStackIndex], $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex] = null, $dca0ddb82b882518$var$treeContextId = $dca0ddb82b882518$var$idStack[--$dca0ddb82b882518$var$idStackIndex], $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex] = null;
}
function $dca0ddb82b882518$var$restoreSuspendedTreeContext(workInProgress, suspendedContext) {
    $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextId;
    $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextOverflow;
    $dca0ddb82b882518$var$idStack[$dca0ddb82b882518$var$idStackIndex++] = $dca0ddb82b882518$var$treeContextProvider;
    $dca0ddb82b882518$var$treeContextId = suspendedContext.id;
    $dca0ddb82b882518$var$treeContextOverflow = suspendedContext.overflow;
    $dca0ddb82b882518$var$treeContextProvider = workInProgress;
}
var $dca0ddb82b882518$var$hydrationParentFiber = null, $dca0ddb82b882518$var$nextHydratableInstance = null, $dca0ddb82b882518$var$isHydrating = !1, $dca0ddb82b882518$var$hydrationErrors = null, $dca0ddb82b882518$var$rootOrSingletonContext = !1, $dca0ddb82b882518$var$HydrationMismatchException = Error($dca0ddb82b882518$var$formatProdErrorMessage(519));
function $dca0ddb82b882518$var$throwOnHydrationMismatch(fiber) {
    var error = Error($dca0ddb82b882518$var$formatProdErrorMessage(418, 1 < arguments.length && void 0 !== arguments[1] && arguments[1] ? "text" : "HTML", ""));
    $dca0ddb82b882518$var$queueHydrationError($dca0ddb82b882518$var$createCapturedValueAtFiber(error, fiber));
    throw $dca0ddb82b882518$var$HydrationMismatchException;
}
function $dca0ddb82b882518$var$prepareToHydrateHostInstance(fiber) {
    var instance = fiber.stateNode, type = fiber.type, props = fiber.memoizedProps;
    instance[$dca0ddb82b882518$var$internalInstanceKey] = fiber;
    instance[$dca0ddb82b882518$var$internalPropsKey] = props;
    switch(type){
        case "dialog":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("cancel", instance);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("close", instance);
            break;
        case "iframe":
        case "object":
        case "embed":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", instance);
            break;
        case "video":
        case "audio":
            for(type = 0; type < $dca0ddb82b882518$var$mediaEventTypes.length; type++)$dca0ddb82b882518$var$listenToNonDelegatedEvent($dca0ddb82b882518$var$mediaEventTypes[type], instance);
            break;
        case "source":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("error", instance);
            break;
        case "img":
        case "image":
        case "link":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("error", instance);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", instance);
            break;
        case "details":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("toggle", instance);
            break;
        case "input":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", instance);
            $dca0ddb82b882518$var$initInput(instance, props.value, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name, !0);
            break;
        case "select":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", instance);
            break;
        case "textarea":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", instance), $dca0ddb82b882518$var$initTextarea(instance, props.value, props.defaultValue, props.children);
    }
    type = props.children;
    "string" !== typeof type && "number" !== typeof type && "bigint" !== typeof type || instance.textContent === "" + type || !0 === props.suppressHydrationWarning || $dca0ddb82b882518$var$checkForUnmatchedText(instance.textContent, type) ? (null != props.popover && ($dca0ddb82b882518$var$listenToNonDelegatedEvent("beforetoggle", instance), $dca0ddb82b882518$var$listenToNonDelegatedEvent("toggle", instance)), null != props.onScroll && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scroll", instance), null != props.onScrollEnd && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scrollend", instance), null != props.onClick && (instance.onclick = $dca0ddb82b882518$var$noop$1), instance = !0) : instance = !1;
    instance || $dca0ddb82b882518$var$throwOnHydrationMismatch(fiber, !0);
}
function $dca0ddb82b882518$var$popToNextHostParent(fiber) {
    for($dca0ddb82b882518$var$hydrationParentFiber = fiber.return; $dca0ddb82b882518$var$hydrationParentFiber;)switch($dca0ddb82b882518$var$hydrationParentFiber.tag){
        case 5:
        case 31:
        case 13:
            $dca0ddb82b882518$var$rootOrSingletonContext = !1;
            return;
        case 27:
        case 3:
            $dca0ddb82b882518$var$rootOrSingletonContext = !0;
            return;
        default:
            $dca0ddb82b882518$var$hydrationParentFiber = $dca0ddb82b882518$var$hydrationParentFiber.return;
    }
}
function $dca0ddb82b882518$var$popHydrationState(fiber) {
    if (fiber !== $dca0ddb82b882518$var$hydrationParentFiber) return !1;
    if (!$dca0ddb82b882518$var$isHydrating) return $dca0ddb82b882518$var$popToNextHostParent(fiber), $dca0ddb82b882518$var$isHydrating = !0, !1;
    var tag = fiber.tag, JSCompiler_temp;
    if (JSCompiler_temp = 3 !== tag && 27 !== tag) {
        if (JSCompiler_temp = 5 === tag) JSCompiler_temp = fiber.type, JSCompiler_temp = !("form" !== JSCompiler_temp && "button" !== JSCompiler_temp) || $dca0ddb82b882518$var$shouldSetTextContent(fiber.type, fiber.memoizedProps);
        JSCompiler_temp = !JSCompiler_temp;
    }
    JSCompiler_temp && $dca0ddb82b882518$var$nextHydratableInstance && $dca0ddb82b882518$var$throwOnHydrationMismatch(fiber);
    $dca0ddb82b882518$var$popToNextHostParent(fiber);
    if (13 === tag) {
        fiber = fiber.memoizedState;
        fiber = null !== fiber ? fiber.dehydrated : null;
        if (!fiber) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(317));
        $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratableInstanceAfterHydrationBoundary(fiber);
    } else if (31 === tag) {
        fiber = fiber.memoizedState;
        fiber = null !== fiber ? fiber.dehydrated : null;
        if (!fiber) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(317));
        $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratableInstanceAfterHydrationBoundary(fiber);
    } else 27 === tag ? (tag = $dca0ddb82b882518$var$nextHydratableInstance, $dca0ddb82b882518$var$isSingletonScope(fiber.type) ? (fiber = $dca0ddb82b882518$var$previousHydratableOnEnteringScopedSingleton, $dca0ddb82b882518$var$previousHydratableOnEnteringScopedSingleton = null, $dca0ddb82b882518$var$nextHydratableInstance = fiber) : $dca0ddb82b882518$var$nextHydratableInstance = tag) : $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$hydrationParentFiber ? $dca0ddb82b882518$var$getNextHydratable(fiber.stateNode.nextSibling) : null;
    return !0;
}
function $dca0ddb82b882518$var$resetHydrationState() {
    $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$hydrationParentFiber = null;
    $dca0ddb82b882518$var$isHydrating = !1;
}
function $dca0ddb82b882518$var$upgradeHydrationErrorsToRecoverable() {
    var queuedErrors = $dca0ddb82b882518$var$hydrationErrors;
    null !== queuedErrors && (null === $dca0ddb82b882518$var$workInProgressRootRecoverableErrors ? $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = queuedErrors : $dca0ddb82b882518$var$workInProgressRootRecoverableErrors.push.apply($dca0ddb82b882518$var$workInProgressRootRecoverableErrors, queuedErrors), $dca0ddb82b882518$var$hydrationErrors = null);
    return queuedErrors;
}
function $dca0ddb82b882518$var$queueHydrationError(error) {
    null === $dca0ddb82b882518$var$hydrationErrors ? $dca0ddb82b882518$var$hydrationErrors = [
        error
    ] : $dca0ddb82b882518$var$hydrationErrors.push(error);
}
var $dca0ddb82b882518$var$valueCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$currentlyRenderingFiber$1 = null, $dca0ddb82b882518$var$lastContextDependency = null;
function $dca0ddb82b882518$var$pushProvider(providerFiber, context, nextValue) {
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$valueCursor, context._currentValue);
    context._currentValue = nextValue;
}
function $dca0ddb82b882518$var$popProvider(context) {
    context._currentValue = $dca0ddb82b882518$var$valueCursor.current;
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$valueCursor);
}
function $dca0ddb82b882518$var$scheduleContextWorkOnParentPath(parent, renderLanes, propagationRoot) {
    for(; null !== parent;){
        var alternate = parent.alternate;
        (parent.childLanes & renderLanes) !== renderLanes ? (parent.childLanes |= renderLanes, null !== alternate && (alternate.childLanes |= renderLanes)) : null !== alternate && (alternate.childLanes & renderLanes) !== renderLanes && (alternate.childLanes |= renderLanes);
        if (parent === propagationRoot) break;
        parent = parent.return;
    }
}
function $dca0ddb82b882518$var$propagateContextChanges(workInProgress, contexts, renderLanes, forcePropagateEntireTree) {
    var fiber = workInProgress.child;
    null !== fiber && (fiber.return = workInProgress);
    for(; null !== fiber;){
        var list = fiber.dependencies;
        if (null !== list) {
            var nextFiber = fiber.child;
            list = list.firstContext;
            a: for(; null !== list;){
                var dependency = list;
                list = fiber;
                for(var i = 0; i < contexts.length; i++)if (dependency.context === contexts[i]) {
                    list.lanes |= renderLanes;
                    dependency = list.alternate;
                    null !== dependency && (dependency.lanes |= renderLanes);
                    $dca0ddb82b882518$var$scheduleContextWorkOnParentPath(list.return, renderLanes, workInProgress);
                    forcePropagateEntireTree || (nextFiber = null);
                    break a;
                }
                list = dependency.next;
            }
        } else if (18 === fiber.tag) {
            nextFiber = fiber.return;
            if (null === nextFiber) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(341));
            nextFiber.lanes |= renderLanes;
            list = nextFiber.alternate;
            null !== list && (list.lanes |= renderLanes);
            $dca0ddb82b882518$var$scheduleContextWorkOnParentPath(nextFiber, renderLanes, workInProgress);
            nextFiber = null;
        } else 13 === fiber.tag && null !== fiber.memoizedState && null === fiber.memoizedState.dehydrated ? (fiber.lanes |= renderLanes, nextFiber = fiber.alternate, null !== nextFiber && (nextFiber.lanes |= renderLanes), $dca0ddb82b882518$var$scheduleContextWorkOnParentPath(fiber.return, renderLanes, workInProgress), nextFiber = fiber.child, nextFiber = null !== nextFiber ? nextFiber.sibling : null) : nextFiber = fiber.child;
        if (null !== nextFiber) nextFiber.return = fiber;
        else for(nextFiber = fiber; null !== nextFiber;){
            if (nextFiber === workInProgress) {
                nextFiber = null;
                break;
            }
            fiber = nextFiber.sibling;
            if (null !== fiber) {
                fiber.return = nextFiber.return;
                nextFiber = fiber;
                break;
            }
            nextFiber = nextFiber.return;
        }
        fiber = nextFiber;
    }
}
function $dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, forcePropagateEntireTree) {
    current = null;
    for(var parent = workInProgress, isInsidePropagationBailout = !1; null !== parent;){
        if (!isInsidePropagationBailout) {
            if (0 !== (parent.flags & 524288)) isInsidePropagationBailout = !0;
            else if (0 !== (parent.flags & 262144)) break;
        }
        if (10 === parent.tag) {
            var currentParent = parent.alternate;
            if (null === currentParent) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(387));
            currentParent = currentParent.memoizedProps;
            if (null !== currentParent) {
                var context = parent.type;
                $dca0ddb82b882518$var$objectIs(parent.pendingProps.value, currentParent.value) || (null !== current ? current.push(context) : current = [
                    context
                ]);
            }
        } else if (parent === $dca0ddb82b882518$var$hostTransitionProviderCursor.current) {
            currentParent = parent.alternate;
            if (null === currentParent) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(387));
            currentParent.memoizedState.memoizedState !== parent.memoizedState.memoizedState && (null !== current ? current.push($dca0ddb82b882518$var$HostTransitionContext) : current = [
                $dca0ddb82b882518$var$HostTransitionContext
            ]);
        }
        parent = parent.return;
    }
    null !== current && $dca0ddb82b882518$var$propagateContextChanges(workInProgress, current, renderLanes, forcePropagateEntireTree);
    workInProgress.flags |= 262144;
    return null !== current;
}
function $dca0ddb82b882518$var$checkIfContextChanged(currentDependencies) {
    for(currentDependencies = currentDependencies.firstContext; null !== currentDependencies;){
        if (!$dca0ddb82b882518$var$objectIs(currentDependencies.context._currentValue, currentDependencies.memoizedValue)) return !0;
        currentDependencies = currentDependencies.next;
    }
    return !1;
}
function $dca0ddb82b882518$var$prepareToReadContext(workInProgress) {
    $dca0ddb82b882518$var$currentlyRenderingFiber$1 = workInProgress;
    $dca0ddb82b882518$var$lastContextDependency = null;
    workInProgress = workInProgress.dependencies;
    null !== workInProgress && (workInProgress.firstContext = null);
}
function $dca0ddb82b882518$var$readContext(context) {
    return $dca0ddb82b882518$var$readContextForConsumer($dca0ddb82b882518$var$currentlyRenderingFiber$1, context);
}
function $dca0ddb82b882518$var$readContextDuringReconciliation(consumer, context) {
    null === $dca0ddb82b882518$var$currentlyRenderingFiber$1 && $dca0ddb82b882518$var$prepareToReadContext(consumer);
    return $dca0ddb82b882518$var$readContextForConsumer(consumer, context);
}
function $dca0ddb82b882518$var$readContextForConsumer(consumer, context) {
    var value = context._currentValue;
    context = {
        context: context,
        memoizedValue: value,
        next: null
    };
    if (null === $dca0ddb82b882518$var$lastContextDependency) {
        if (null === consumer) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(308));
        $dca0ddb82b882518$var$lastContextDependency = context;
        consumer.dependencies = {
            lanes: 0,
            firstContext: context
        };
        consumer.flags |= 524288;
    } else $dca0ddb82b882518$var$lastContextDependency = $dca0ddb82b882518$var$lastContextDependency.next = context;
    return value;
}
var $dca0ddb82b882518$var$AbortControllerLocal = "undefined" !== typeof AbortController ? AbortController : function() {
    var listeners = [], signal = this.signal = {
        aborted: !1,
        addEventListener: function(type, listener) {
            listeners.push(listener);
        }
    };
    this.abort = function() {
        signal.aborted = !0;
        listeners.forEach(function(listener) {
            return listener();
        });
    };
}, $dca0ddb82b882518$var$scheduleCallback$2 = $fO90s.unstable_scheduleCallback, $dca0ddb82b882518$var$NormalPriority = $fO90s.unstable_NormalPriority, $dca0ddb82b882518$var$CacheContext = {
    $$typeof: $dca0ddb82b882518$var$REACT_CONTEXT_TYPE,
    Consumer: null,
    Provider: null,
    _currentValue: null,
    _currentValue2: null,
    _threadCount: 0
};
function $dca0ddb82b882518$var$createCache() {
    return {
        controller: new $dca0ddb82b882518$var$AbortControllerLocal(),
        data: new Map(),
        refCount: 0
    };
}
function $dca0ddb82b882518$var$releaseCache(cache) {
    cache.refCount--;
    0 === cache.refCount && $dca0ddb82b882518$var$scheduleCallback$2($dca0ddb82b882518$var$NormalPriority, function() {
        cache.controller.abort();
    });
}
function $dca0ddb82b882518$var$queueTransitionTypes(root, transitionTypes) {
    if (0 !== (root.pendingLanes & 4194048)) {
        var queued = root.transitionTypes;
        null === queued && (queued = root.transitionTypes = []);
        for(root = 0; root < transitionTypes.length; root++){
            var transitionType = transitionTypes[root];
            -1 === queued.indexOf(transitionType) && queued.push(transitionType);
        }
    }
}
var $dca0ddb82b882518$var$entangledTransitionTypes = null;
function $dca0ddb82b882518$var$claimQueuedTransitionTypes(root) {
    var claimed = root.transitionTypes;
    root.transitionTypes = null;
    return claimed;
}
var $dca0ddb82b882518$var$currentEntangledListeners = null, $dca0ddb82b882518$var$currentEntangledPendingCount = 0, $dca0ddb82b882518$var$currentEntangledLane = 0, $dca0ddb82b882518$var$currentEntangledActionThenable = null;
function $dca0ddb82b882518$var$entangleAsyncAction(transition, thenable) {
    if (null === $dca0ddb82b882518$var$currentEntangledListeners) {
        var entangledListeners = $dca0ddb82b882518$var$currentEntangledListeners = [];
        $dca0ddb82b882518$var$currentEntangledPendingCount = 0;
        $dca0ddb82b882518$var$currentEntangledLane = $dca0ddb82b882518$var$requestTransitionLane();
        $dca0ddb82b882518$var$currentEntangledActionThenable = {
            status: "pending",
            value: void 0,
            then: function(resolve) {
                entangledListeners.push(resolve);
            }
        };
    }
    $dca0ddb82b882518$var$currentEntangledPendingCount++;
    thenable.then($dca0ddb82b882518$var$pingEngtangledActionScope, $dca0ddb82b882518$var$pingEngtangledActionScope);
    return thenable;
}
function $dca0ddb82b882518$var$pingEngtangledActionScope() {
    if (0 === --$dca0ddb82b882518$var$currentEntangledPendingCount && ($dca0ddb82b882518$var$entangledTransitionTypes = null, null !== $dca0ddb82b882518$var$currentEntangledListeners)) {
        null !== $dca0ddb82b882518$var$currentEntangledActionThenable && ($dca0ddb82b882518$var$currentEntangledActionThenable.status = "fulfilled");
        var listeners = $dca0ddb82b882518$var$currentEntangledListeners;
        $dca0ddb82b882518$var$currentEntangledListeners = null;
        $dca0ddb82b882518$var$currentEntangledLane = 0;
        $dca0ddb82b882518$var$currentEntangledActionThenable = null;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])();
    }
}
function $dca0ddb82b882518$var$chainThenableValue(thenable, result) {
    var listeners = [], thenableWithOverride = {
        status: "pending",
        value: null,
        reason: null,
        then: function(resolve) {
            listeners.push(resolve);
        }
    };
    thenable.then(function() {
        thenableWithOverride.status = "fulfilled";
        thenableWithOverride.value = result;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])(result);
    }, function(error) {
        thenableWithOverride.status = "rejected";
        thenableWithOverride.reason = error;
        for(error = 0; error < listeners.length; error++)(0, listeners[error])(void 0);
    });
    return thenableWithOverride;
}
var $dca0ddb82b882518$var$prevOnStartTransitionFinish = $dca0ddb82b882518$var$ReactSharedInternals.S;
$dca0ddb82b882518$var$ReactSharedInternals.S = function(transition, returnValue) {
    $dca0ddb82b882518$var$globalMostRecentTransitionTime = $dca0ddb82b882518$var$now();
    "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && $dca0ddb82b882518$var$entangleAsyncAction(transition, returnValue);
    if (null !== $dca0ddb82b882518$var$entangledTransitionTypes) for(var root$28 = $dca0ddb82b882518$var$firstScheduledRoot; null !== root$28;)$dca0ddb82b882518$var$queueTransitionTypes(root$28, $dca0ddb82b882518$var$entangledTransitionTypes), root$28 = root$28.next;
    root$28 = transition.types;
    if (null !== root$28) {
        for(var root$29 = $dca0ddb82b882518$var$firstScheduledRoot; null !== root$29;)$dca0ddb82b882518$var$queueTransitionTypes(root$29, root$28), root$29 = root$29.next;
        if (0 !== $dca0ddb82b882518$var$currentEntangledLane) {
            root$29 = $dca0ddb82b882518$var$entangledTransitionTypes;
            null === root$29 && (root$29 = $dca0ddb82b882518$var$entangledTransitionTypes = []);
            for(var i = 0; i < root$28.length; i++){
                var transitionType = root$28[i];
                -1 === root$29.indexOf(transitionType) && root$29.push(transitionType);
            }
        }
    }
    null !== $dca0ddb82b882518$var$prevOnStartTransitionFinish && $dca0ddb82b882518$var$prevOnStartTransitionFinish(transition, returnValue);
};
var $dca0ddb82b882518$var$resumedCache = $dca0ddb82b882518$var$createCursor(null);
function $dca0ddb82b882518$var$peekCacheFromPool() {
    var cacheResumedFromPreviousRender = $dca0ddb82b882518$var$resumedCache.current;
    return null !== cacheResumedFromPreviousRender ? cacheResumedFromPreviousRender : $dca0ddb82b882518$var$workInProgressRoot.pooledCache;
}
function $dca0ddb82b882518$var$pushTransition(offscreenWorkInProgress, prevCachePool) {
    null === prevCachePool ? $dca0ddb82b882518$var$push($dca0ddb82b882518$var$resumedCache, $dca0ddb82b882518$var$resumedCache.current) : $dca0ddb82b882518$var$push($dca0ddb82b882518$var$resumedCache, prevCachePool.pool);
}
function $dca0ddb82b882518$var$getSuspendedCache() {
    var cacheFromPool = $dca0ddb82b882518$var$peekCacheFromPool();
    return null === cacheFromPool ? null : {
        parent: $dca0ddb82b882518$var$CacheContext._currentValue,
        pool: cacheFromPool
    };
}
var $dca0ddb82b882518$var$SuspenseException = Error($dca0ddb82b882518$var$formatProdErrorMessage(460)), $dca0ddb82b882518$var$SuspenseyCommitException = Error($dca0ddb82b882518$var$formatProdErrorMessage(474)), $dca0ddb82b882518$var$SuspenseActionException = Error($dca0ddb82b882518$var$formatProdErrorMessage(542)), $dca0ddb82b882518$var$noopSuspenseyCommitThenable = {
    then: function() {}
};
function $dca0ddb82b882518$var$isThenableResolved(thenable) {
    thenable = thenable.status;
    return "fulfilled" === thenable || "rejected" === thenable;
}
function $dca0ddb82b882518$var$trackUsedThenable(thenableState, thenable, index) {
    index = thenableState[index];
    void 0 === index ? thenableState.push(thenable) : index !== thenable && (thenable.then($dca0ddb82b882518$var$noop$1, $dca0ddb82b882518$var$noop$1), thenable = index);
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            thenableState = thenable.reason;
            $dca0ddb82b882518$var$checkIfUseWrappedInAsyncCatch(thenableState);
            if (void 0 === thenableState && !("reason" in thenable)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(600));
            throw thenableState;
        default:
            if ("string" === typeof thenable.status) thenable.then($dca0ddb82b882518$var$noop$1, $dca0ddb82b882518$var$noop$1);
            else {
                thenableState = $dca0ddb82b882518$var$workInProgressRoot;
                if (null !== thenableState && 100 < thenableState.shellSuspendCounter) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(482));
                thenableState = thenable;
                thenableState.status = "pending";
                thenableState.then(function(fulfilledValue) {
                    if ("pending" === thenable.status) {
                        var fulfilledThenable = thenable;
                        fulfilledThenable.status = "fulfilled";
                        fulfilledThenable.value = fulfilledValue;
                    }
                }, function(error) {
                    if ("pending" === thenable.status) {
                        var rejectedThenable = thenable;
                        rejectedThenable.status = "rejected";
                        rejectedThenable.reason = error;
                    }
                });
            }
            switch(thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenableState = thenable.reason, $dca0ddb82b882518$var$checkIfUseWrappedInAsyncCatch(thenableState), thenableState;
            }
            $dca0ddb82b882518$var$suspendedThenable = thenable;
            throw $dca0ddb82b882518$var$SuspenseException;
    }
}
function $dca0ddb82b882518$var$resolveLazy(lazyType) {
    try {
        var init = lazyType._init;
        return init(lazyType._payload);
    } catch (x) {
        if (null !== x && "object" === typeof x && "function" === typeof x.then) throw $dca0ddb82b882518$var$suspendedThenable = x, $dca0ddb82b882518$var$SuspenseException;
        throw x;
    }
}
var $dca0ddb82b882518$var$suspendedThenable = null;
function $dca0ddb82b882518$var$getSuspendedThenable() {
    if (null === $dca0ddb82b882518$var$suspendedThenable) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(459));
    var thenable = $dca0ddb82b882518$var$suspendedThenable;
    $dca0ddb82b882518$var$suspendedThenable = null;
    return thenable;
}
function $dca0ddb82b882518$var$checkIfUseWrappedInAsyncCatch(rejectedReason) {
    if (rejectedReason === $dca0ddb82b882518$var$SuspenseException || rejectedReason === $dca0ddb82b882518$var$SuspenseActionException) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(483));
}
var $dca0ddb82b882518$var$thenableState$1 = null, $dca0ddb82b882518$var$thenableIndexCounter$1 = 0;
function $dca0ddb82b882518$var$unwrapThenable(thenable) {
    var index = $dca0ddb82b882518$var$thenableIndexCounter$1;
    $dca0ddb82b882518$var$thenableIndexCounter$1 += 1;
    null === $dca0ddb82b882518$var$thenableState$1 && ($dca0ddb82b882518$var$thenableState$1 = []);
    return $dca0ddb82b882518$var$trackUsedThenable($dca0ddb82b882518$var$thenableState$1, thenable, index);
}
function $dca0ddb82b882518$var$coerceRef(workInProgress, element) {
    element = element.props.ref;
    workInProgress.ref = void 0 !== element ? element : null;
}
function $dca0ddb82b882518$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild) {
    if (newChild.$$typeof === $dca0ddb82b882518$var$REACT_LEGACY_ELEMENT_TYPE) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(525));
    returnFiber = Object.prototype.toString.call(newChild);
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(31, "[object Object]" === returnFiber ? "object with keys {" + Object.keys(newChild).join(", ") + "}" : returnFiber));
}
function $dca0ddb82b882518$var$createChildReconciler(shouldTrackSideEffects) {
    function deleteChild(returnFiber, childToDelete) {
        if (shouldTrackSideEffects) {
            var deletions = returnFiber.deletions;
            null === deletions ? (returnFiber.deletions = [
                childToDelete
            ], returnFiber.flags |= 16) : deletions.push(childToDelete);
        }
    }
    function deleteRemainingChildren(returnFiber, currentFirstChild) {
        if (!shouldTrackSideEffects) return null;
        for(; null !== currentFirstChild;)deleteChild(returnFiber, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return null;
    }
    function mapRemainingChildren(currentFirstChild) {
        for(var existingChildren = new Map(); null !== currentFirstChild;)null === currentFirstChild.key ? existingChildren.set(currentFirstChild.index, currentFirstChild) : existingChildren.set(currentFirstChild.key, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return existingChildren;
    }
    function useFiber(fiber, pendingProps) {
        fiber = $dca0ddb82b882518$var$createWorkInProgress(fiber, pendingProps);
        fiber.index = 0;
        fiber.sibling = null;
        return fiber;
    }
    function placeChild(newFiber, lastPlacedIndex, newIndex) {
        newFiber.index = newIndex;
        if (!shouldTrackSideEffects) return newFiber.flags |= 1048576, lastPlacedIndex;
        newIndex = newFiber.alternate;
        if (null !== newIndex) return newIndex = newIndex.index, newIndex < lastPlacedIndex ? (newFiber.flags |= 2, lastPlacedIndex) : newIndex;
        newFiber.flags |= 134217730;
        return lastPlacedIndex;
    }
    function placeSingleChild(newFiber) {
        shouldTrackSideEffects && null === newFiber.alternate && (newFiber.flags |= 134217730);
        return newFiber;
    }
    function updateTextNode(returnFiber, current, textContent, lanes) {
        if (null === current || 6 !== current.tag) return current = $dca0ddb82b882518$var$createFiberFromText(textContent, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, textContent);
        current.return = returnFiber;
        return current;
    }
    function updateElement(returnFiber, current, element, lanes) {
        var elementType = element.type;
        if (elementType === $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE) return returnFiber = updateFragment(returnFiber, current, element.props.children, lanes, element.key), $dca0ddb82b882518$var$coerceRef(returnFiber, element), returnFiber;
        if (null !== current && (current.elementType === elementType || "object" === typeof elementType && null !== elementType && elementType.$$typeof === $dca0ddb82b882518$var$REACT_LAZY_TYPE && $dca0ddb82b882518$var$resolveLazy(elementType) === current.type)) return current = useFiber(current, element.props), $dca0ddb82b882518$var$coerceRef(current, element), current.return = returnFiber, current;
        current = $dca0ddb82b882518$var$createFiberFromTypeAndProps(element.type, element.key, element.props, null, returnFiber.mode, lanes);
        $dca0ddb82b882518$var$coerceRef(current, element);
        current.return = returnFiber;
        return current;
    }
    function updatePortal(returnFiber, current, portal, lanes) {
        if (null === current || 4 !== current.tag || current.stateNode.containerInfo !== portal.containerInfo || current.stateNode.implementation !== portal.implementation) return current = $dca0ddb82b882518$var$createFiberFromPortal(portal, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, portal.children || []);
        current.return = returnFiber;
        return current;
    }
    function updateFragment(returnFiber, current, fragment, lanes, key) {
        if (null === current || 7 !== current.tag) return current = $dca0ddb82b882518$var$createFiberFromFragment(fragment, returnFiber.mode, lanes, key), current.return = returnFiber, current;
        current = useFiber(current, fragment);
        current.return = returnFiber;
        return current;
    }
    function createChild(returnFiber, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return newChild = $dca0ddb82b882518$var$createFiberFromText("" + newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $dca0ddb82b882518$var$REACT_ELEMENT_TYPE:
                    return lanes = $dca0ddb82b882518$var$createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), $dca0ddb82b882518$var$coerceRef(lanes, newChild), lanes.return = returnFiber, lanes;
                case $dca0ddb82b882518$var$REACT_PORTAL_TYPE:
                    return newChild = $dca0ddb82b882518$var$createFiberFromPortal(newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
                case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
                    return newChild = $dca0ddb82b882518$var$resolveLazy(newChild), createChild(returnFiber, newChild, lanes);
            }
            if ($dca0ddb82b882518$var$isArrayImpl(newChild) || $dca0ddb82b882518$var$getIteratorFn(newChild)) return newChild = $dca0ddb82b882518$var$createFiberFromFragment(newChild, returnFiber.mode, lanes, null), newChild.return = returnFiber, newChild;
            if ("function" === typeof newChild.then) return createChild(returnFiber, $dca0ddb82b882518$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $dca0ddb82b882518$var$REACT_CONTEXT_TYPE) return createChild(returnFiber, $dca0ddb82b882518$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $dca0ddb82b882518$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function updateSlot(returnFiber, oldFiber, newChild, lanes) {
        var key = null !== oldFiber ? oldFiber.key : null;
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return null !== key ? null : updateTextNode(returnFiber, oldFiber, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $dca0ddb82b882518$var$REACT_ELEMENT_TYPE:
                    return newChild.key === key ? updateElement(returnFiber, oldFiber, newChild, lanes) : null;
                case $dca0ddb82b882518$var$REACT_PORTAL_TYPE:
                    return newChild.key === key ? updatePortal(returnFiber, oldFiber, newChild, lanes) : null;
                case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
                    return newChild = $dca0ddb82b882518$var$resolveLazy(newChild), updateSlot(returnFiber, oldFiber, newChild, lanes);
            }
            if ($dca0ddb82b882518$var$isArrayImpl(newChild) || $dca0ddb82b882518$var$getIteratorFn(newChild)) return null !== key ? null : updateFragment(returnFiber, oldFiber, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateSlot(returnFiber, oldFiber, $dca0ddb82b882518$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $dca0ddb82b882518$var$REACT_CONTEXT_TYPE) return updateSlot(returnFiber, oldFiber, $dca0ddb82b882518$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $dca0ddb82b882518$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return existingChildren = existingChildren.get(newIdx) || null, updateTextNode(returnFiber, existingChildren, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $dca0ddb82b882518$var$REACT_ELEMENT_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updateElement(returnFiber, existingChildren, newChild, lanes);
                case $dca0ddb82b882518$var$REACT_PORTAL_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updatePortal(returnFiber, existingChildren, newChild, lanes);
                case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
                    return newChild = $dca0ddb82b882518$var$resolveLazy(newChild), updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes);
            }
            if ($dca0ddb82b882518$var$isArrayImpl(newChild) || $dca0ddb82b882518$var$getIteratorFn(newChild)) return existingChildren = existingChildren.get(newIdx) || null, updateFragment(returnFiber, existingChildren, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateFromMap(existingChildren, returnFiber, newIdx, $dca0ddb82b882518$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $dca0ddb82b882518$var$REACT_CONTEXT_TYPE) return updateFromMap(existingChildren, returnFiber, newIdx, $dca0ddb82b882518$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $dca0ddb82b882518$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function reconcileChildrenArray(returnFiber, currentFirstChild, newChildren, lanes) {
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null; null !== oldFiber && newIdx < newChildren.length; newIdx++){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, newChildren[newIdx], lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (newIdx === newChildren.length) return deleteRemainingChildren(returnFiber, oldFiber), $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; newIdx < newChildren.length; newIdx++)oldFiber = createChild(returnFiber, newChildren[newIdx], lanes), null !== oldFiber && (currentFirstChild = placeChild(oldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = oldFiber : previousNewFiber.sibling = oldFiber, previousNewFiber = oldFiber);
            $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); newIdx < newChildren.length; newIdx++)nextOldFiber = updateFromMap(oldFiber, returnFiber, newIdx, newChildren[newIdx], lanes), null !== nextOldFiber && (shouldTrackSideEffects && (newFiber = nextOldFiber.alternate, null !== newFiber && oldFiber.delete(null === newFiber.key ? newIdx : newFiber.key)), currentFirstChild = placeChild(nextOldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = nextOldFiber : previousNewFiber.sibling = nextOldFiber, previousNewFiber = nextOldFiber);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildrenIterator(returnFiber, currentFirstChild, newChildren, lanes) {
        if (null == newChildren) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(151));
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null, step = newChildren.next(); null !== oldFiber && !step.done; newIdx++, step = newChildren.next()){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, step.value, lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (step.done) return deleteRemainingChildren(returnFiber, oldFiber), $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; !step.done; newIdx++, step = newChildren.next())step = createChild(returnFiber, step.value, lanes), null !== step && (currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
            $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); !step.done; newIdx++, step = newChildren.next())step = updateFromMap(oldFiber, returnFiber, newIdx, step.value, lanes), null !== step && (shouldTrackSideEffects && (nextOldFiber = step.alternate, null !== nextOldFiber && oldFiber.delete(null === nextOldFiber.key ? newIdx : nextOldFiber.key)), currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes) {
        "object" === typeof newChild && null !== newChild && newChild.type === $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE && null === newChild.key && void 0 === newChild.props.ref && (newChild = newChild.props.children);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $dca0ddb82b882518$var$REACT_ELEMENT_TYPE:
                    a: {
                        for(var key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                key = newChild.type;
                                if (key === $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE) {
                                    if (7 === currentFirstChild.tag) {
                                        deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                        lanes = useFiber(currentFirstChild, newChild.props.children);
                                        $dca0ddb82b882518$var$coerceRef(lanes, newChild);
                                        lanes.return = returnFiber;
                                        returnFiber = lanes;
                                        break a;
                                    }
                                } else if (currentFirstChild.elementType === key || "object" === typeof key && null !== key && key.$$typeof === $dca0ddb82b882518$var$REACT_LAZY_TYPE && $dca0ddb82b882518$var$resolveLazy(key) === currentFirstChild.type) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.props);
                                    $dca0ddb82b882518$var$coerceRef(lanes, newChild);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                }
                                deleteRemainingChildren(returnFiber, currentFirstChild);
                                break;
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        newChild.type === $dca0ddb82b882518$var$REACT_FRAGMENT_TYPE ? (lanes = $dca0ddb82b882518$var$createFiberFromFragment(newChild.props.children, returnFiber.mode, lanes, newChild.key), $dca0ddb82b882518$var$coerceRef(lanes, newChild), lanes.return = returnFiber, returnFiber = lanes) : (lanes = $dca0ddb82b882518$var$createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), $dca0ddb82b882518$var$coerceRef(lanes, newChild), lanes.return = returnFiber, returnFiber = lanes);
                    }
                    return placeSingleChild(returnFiber);
                case $dca0ddb82b882518$var$REACT_PORTAL_TYPE:
                    a: {
                        for(key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                if (4 === currentFirstChild.tag && currentFirstChild.stateNode.containerInfo === newChild.containerInfo && currentFirstChild.stateNode.implementation === newChild.implementation) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.children || []);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                } else {
                                    deleteRemainingChildren(returnFiber, currentFirstChild);
                                    break;
                                }
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        lanes = $dca0ddb82b882518$var$createFiberFromPortal(newChild, returnFiber.mode, lanes);
                        lanes.return = returnFiber;
                        returnFiber = lanes;
                    }
                    return placeSingleChild(returnFiber);
                case $dca0ddb82b882518$var$REACT_LAZY_TYPE:
                    return newChild = $dca0ddb82b882518$var$resolveLazy(newChild), reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ($dca0ddb82b882518$var$isArrayImpl(newChild)) return reconcileChildrenArray(returnFiber, currentFirstChild, newChild, lanes);
            if ($dca0ddb82b882518$var$getIteratorFn(newChild)) {
                key = $dca0ddb82b882518$var$getIteratorFn(newChild);
                if ("function" !== typeof key) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(150));
                newChild = key.call(newChild);
                return reconcileChildrenIterator(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ("function" === typeof newChild.then) return reconcileChildFibersImpl(returnFiber, currentFirstChild, $dca0ddb82b882518$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $dca0ddb82b882518$var$REACT_CONTEXT_TYPE) return reconcileChildFibersImpl(returnFiber, currentFirstChild, $dca0ddb82b882518$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $dca0ddb82b882518$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return "string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild ? (newChild = "" + newChild, null !== currentFirstChild && 6 === currentFirstChild.tag ? (deleteRemainingChildren(returnFiber, currentFirstChild.sibling), lanes = useFiber(currentFirstChild, newChild), lanes.return = returnFiber, returnFiber = lanes) : (deleteRemainingChildren(returnFiber, currentFirstChild), lanes = $dca0ddb82b882518$var$createFiberFromText(newChild, returnFiber.mode, lanes), lanes.return = returnFiber, returnFiber = lanes), placeSingleChild(returnFiber)) : deleteRemainingChildren(returnFiber, currentFirstChild);
    }
    return function(returnFiber, currentFirstChild, newChild, lanes) {
        try {
            $dca0ddb82b882518$var$thenableIndexCounter$1 = 0;
            var firstChildFiber = reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            $dca0ddb82b882518$var$thenableState$1 = null;
            return firstChildFiber;
        } catch (x) {
            if (x === $dca0ddb82b882518$var$SuspenseException || x === $dca0ddb82b882518$var$SuspenseActionException) throw x;
            var fiber = $dca0ddb82b882518$var$createFiberImplClass(29, x, null, returnFiber.mode);
            fiber.lanes = lanes;
            fiber.return = returnFiber;
            return fiber;
        } finally{}
    };
}
var $dca0ddb82b882518$var$reconcileChildFibers = $dca0ddb82b882518$var$createChildReconciler(!0), $dca0ddb82b882518$var$mountChildFibers = $dca0ddb82b882518$var$createChildReconciler(!1), $dca0ddb82b882518$var$hasForceUpdate = !1;
function $dca0ddb82b882518$var$initializeUpdateQueue(fiber) {
    fiber.updateQueue = {
        baseState: fiber.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            lanes: 0,
            hiddenCallbacks: null
        },
        callbacks: null
    };
}
function $dca0ddb82b882518$var$cloneUpdateQueue(current, workInProgress) {
    current = current.updateQueue;
    workInProgress.updateQueue === current && (workInProgress.updateQueue = {
        baseState: current.baseState,
        firstBaseUpdate: current.firstBaseUpdate,
        lastBaseUpdate: current.lastBaseUpdate,
        shared: current.shared,
        callbacks: null
    });
}
function $dca0ddb82b882518$var$createUpdate(lane) {
    return {
        lane: lane,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $dca0ddb82b882518$var$enqueueUpdate(fiber, update, lane) {
    var updateQueue = fiber.updateQueue;
    if (null === updateQueue) return null;
    updateQueue = updateQueue.shared;
    if (0 !== ($dca0ddb82b882518$var$executionContext & 2)) {
        var pending = updateQueue.pending;
        null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
        updateQueue.pending = update;
        update = $dca0ddb82b882518$var$getRootForUpdatedFiber(fiber);
        $dca0ddb82b882518$var$markUpdateLaneFromFiberToRoot(fiber, null, lane);
        return update;
    }
    $dca0ddb82b882518$var$enqueueUpdate$1(fiber, updateQueue, update, lane);
    return $dca0ddb82b882518$var$getRootForUpdatedFiber(fiber);
}
function $dca0ddb82b882518$var$entangleTransitions(root, fiber, lane) {
    fiber = fiber.updateQueue;
    if (null !== fiber && (fiber = fiber.shared, 0 !== (lane & 4194048))) {
        var queueLanes = fiber.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        fiber.lanes = lane;
        $dca0ddb82b882518$var$markRootEntangled(root, lane);
    }
}
function $dca0ddb82b882518$var$enqueueCapturedUpdate(workInProgress, capturedUpdate) {
    var queue = workInProgress.updateQueue, current = workInProgress.alternate;
    if (null !== current && (current = current.updateQueue, queue === current)) {
        var newFirst = null, newLast = null;
        queue = queue.firstBaseUpdate;
        if (null !== queue) {
            do {
                var clone = {
                    lane: queue.lane,
                    tag: queue.tag,
                    payload: queue.payload,
                    callback: null,
                    next: null
                };
                null === newLast ? newFirst = newLast = clone : newLast = newLast.next = clone;
                queue = queue.next;
            }while (null !== queue);
            null === newLast ? newFirst = newLast = capturedUpdate : newLast = newLast.next = capturedUpdate;
        } else newFirst = newLast = capturedUpdate;
        queue = {
            baseState: current.baseState,
            firstBaseUpdate: newFirst,
            lastBaseUpdate: newLast,
            shared: current.shared,
            callbacks: current.callbacks
        };
        workInProgress.updateQueue = queue;
        return;
    }
    workInProgress = queue.lastBaseUpdate;
    null === workInProgress ? queue.firstBaseUpdate = capturedUpdate : workInProgress.next = capturedUpdate;
    queue.lastBaseUpdate = capturedUpdate;
}
var $dca0ddb82b882518$var$didReadFromEntangledAsyncAction = !1;
function $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction() {
    if ($dca0ddb82b882518$var$didReadFromEntangledAsyncAction) {
        var entangledActionThenable = $dca0ddb82b882518$var$currentEntangledActionThenable;
        if (null !== entangledActionThenable) throw entangledActionThenable;
    }
}
function $dca0ddb82b882518$var$processUpdateQueue(workInProgress$jscomp$0, props, instance$jscomp$0, renderLanes) {
    $dca0ddb82b882518$var$didReadFromEntangledAsyncAction = !1;
    var queue = workInProgress$jscomp$0.updateQueue;
    $dca0ddb82b882518$var$hasForceUpdate = !1;
    var firstBaseUpdate = queue.firstBaseUpdate, lastBaseUpdate = queue.lastBaseUpdate, pendingQueue = queue.shared.pending;
    if (null !== pendingQueue) {
        queue.shared.pending = null;
        var lastPendingUpdate = pendingQueue, firstPendingUpdate = lastPendingUpdate.next;
        lastPendingUpdate.next = null;
        null === lastBaseUpdate ? firstBaseUpdate = firstPendingUpdate : lastBaseUpdate.next = firstPendingUpdate;
        lastBaseUpdate = lastPendingUpdate;
        var current = workInProgress$jscomp$0.alternate;
        null !== current && (current = current.updateQueue, pendingQueue = current.lastBaseUpdate, pendingQueue !== lastBaseUpdate && (null === pendingQueue ? current.firstBaseUpdate = firstPendingUpdate : pendingQueue.next = firstPendingUpdate, current.lastBaseUpdate = lastPendingUpdate));
    }
    if (null !== firstBaseUpdate) {
        var newState = queue.baseState;
        lastBaseUpdate = 0;
        current = firstPendingUpdate = lastPendingUpdate = null;
        pendingQueue = firstBaseUpdate;
        do {
            var updateLane = pendingQueue.lane & -536870913, isHiddenUpdate = updateLane !== pendingQueue.lane;
            if (isHiddenUpdate ? ($dca0ddb82b882518$var$workInProgressRootRenderLanes & updateLane) === updateLane : (renderLanes & updateLane) === updateLane) {
                0 !== updateLane && updateLane === $dca0ddb82b882518$var$currentEntangledLane && ($dca0ddb82b882518$var$didReadFromEntangledAsyncAction = !0);
                null !== current && (current = current.next = {
                    lane: 0,
                    tag: pendingQueue.tag,
                    payload: pendingQueue.payload,
                    callback: null,
                    next: null
                });
                a: {
                    var workInProgress = workInProgress$jscomp$0, update = pendingQueue;
                    updateLane = props;
                    var instance = instance$jscomp$0;
                    switch(update.tag){
                        case 1:
                            workInProgress = update.payload;
                            if ("function" === typeof workInProgress) {
                                newState = workInProgress.call(instance, newState, updateLane);
                                break a;
                            }
                            newState = workInProgress;
                            break a;
                        case 3:
                            workInProgress.flags = workInProgress.flags & -65537 | 128;
                        case 0:
                            workInProgress = update.payload;
                            updateLane = "function" === typeof workInProgress ? workInProgress.call(instance, newState, updateLane) : workInProgress;
                            if (null === updateLane || void 0 === updateLane) break a;
                            newState = $dca0ddb82b882518$var$assign({}, newState, updateLane);
                            break a;
                        case 2:
                            $dca0ddb82b882518$var$hasForceUpdate = !0;
                    }
                }
                updateLane = pendingQueue.callback;
                null !== updateLane && (workInProgress$jscomp$0.flags |= 64, isHiddenUpdate && (workInProgress$jscomp$0.flags |= 8192), isHiddenUpdate = queue.callbacks, null === isHiddenUpdate ? queue.callbacks = [
                    updateLane
                ] : isHiddenUpdate.push(updateLane));
            } else isHiddenUpdate = {
                lane: updateLane,
                tag: pendingQueue.tag,
                payload: pendingQueue.payload,
                callback: pendingQueue.callback,
                next: null
            }, null === current ? (firstPendingUpdate = current = isHiddenUpdate, lastPendingUpdate = newState) : current = current.next = isHiddenUpdate, lastBaseUpdate |= updateLane;
            pendingQueue = pendingQueue.next;
            if (null === pendingQueue) {
                if (pendingQueue = queue.shared.pending, null === pendingQueue) break;
                else isHiddenUpdate = pendingQueue, pendingQueue = isHiddenUpdate.next, isHiddenUpdate.next = null, queue.lastBaseUpdate = isHiddenUpdate, queue.shared.pending = null;
            }
        }while (1);
        null === current && (lastPendingUpdate = newState);
        queue.baseState = lastPendingUpdate;
        queue.firstBaseUpdate = firstPendingUpdate;
        queue.lastBaseUpdate = current;
        null === firstBaseUpdate && (queue.shared.lanes = 0);
        $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= lastBaseUpdate;
        workInProgress$jscomp$0.lanes = lastBaseUpdate;
        workInProgress$jscomp$0.memoizedState = newState;
    }
}
function $dca0ddb82b882518$var$callCallback(callback, context) {
    if ("function" !== typeof callback) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(191, callback));
    callback.call(context);
}
function $dca0ddb82b882518$var$commitCallbacks(updateQueue, context) {
    var callbacks = updateQueue.callbacks;
    if (null !== callbacks) for(updateQueue.callbacks = null, updateQueue = 0; updateQueue < callbacks.length; updateQueue++)$dca0ddb82b882518$var$callCallback(callbacks[updateQueue], context);
}
var $dca0ddb82b882518$var$currentTreeHiddenStackCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$prevEntangledRenderLanesCursor = $dca0ddb82b882518$var$createCursor(0);
function $dca0ddb82b882518$var$pushHiddenContext(fiber, context) {
    fiber = $dca0ddb82b882518$var$entangledRenderLanes;
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$prevEntangledRenderLanesCursor, fiber);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$currentTreeHiddenStackCursor, context);
    $dca0ddb82b882518$var$entangledRenderLanes = fiber | context.baseLanes;
}
function $dca0ddb82b882518$var$reuseHiddenContextOnStack() {
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$prevEntangledRenderLanesCursor, $dca0ddb82b882518$var$entangledRenderLanes);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$currentTreeHiddenStackCursor, $dca0ddb82b882518$var$currentTreeHiddenStackCursor.current);
}
function $dca0ddb82b882518$var$popHiddenContext() {
    $dca0ddb82b882518$var$entangledRenderLanes = $dca0ddb82b882518$var$prevEntangledRenderLanesCursor.current;
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$currentTreeHiddenStackCursor);
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$prevEntangledRenderLanesCursor);
}
var $dca0ddb82b882518$var$suspenseHandlerStackCursor = $dca0ddb82b882518$var$createCursor(null), $dca0ddb82b882518$var$shellBoundary = null;
function $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(handler) {
    var current = handler.alternate;
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, $dca0ddb82b882518$var$suspenseStackCursor.current & 1);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseHandlerStackCursor, handler);
    null === $dca0ddb82b882518$var$shellBoundary && (null === current || null !== $dca0ddb82b882518$var$currentTreeHiddenStackCursor.current ? $dca0ddb82b882518$var$shellBoundary = handler : null !== current.memoizedState && ($dca0ddb82b882518$var$shellBoundary = handler));
}
function $dca0ddb82b882518$var$pushDehydratedActivitySuspenseHandler(fiber) {
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, $dca0ddb82b882518$var$suspenseStackCursor.current);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseHandlerStackCursor, fiber);
    null === $dca0ddb82b882518$var$shellBoundary && ($dca0ddb82b882518$var$shellBoundary = fiber);
}
function $dca0ddb82b882518$var$pushOffscreenSuspenseHandler(fiber) {
    22 === fiber.tag ? ($dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, $dca0ddb82b882518$var$suspenseStackCursor.current), $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseHandlerStackCursor, fiber), null === $dca0ddb82b882518$var$shellBoundary && ($dca0ddb82b882518$var$shellBoundary = fiber)) : $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack();
}
function $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack() {
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, $dca0ddb82b882518$var$suspenseStackCursor.current);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseHandlerStackCursor, $dca0ddb82b882518$var$suspenseHandlerStackCursor.current);
}
function $dca0ddb82b882518$var$popSuspenseHandler(fiber) {
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$suspenseHandlerStackCursor);
    $dca0ddb82b882518$var$shellBoundary === fiber && ($dca0ddb82b882518$var$shellBoundary = null);
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$suspenseStackCursor);
}
var $dca0ddb82b882518$var$suspenseStackCursor = $dca0ddb82b882518$var$createCursor(0);
function $dca0ddb82b882518$var$pushSuspenseListContext(fiber, newContext) {
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseHandlerStackCursor, $dca0ddb82b882518$var$suspenseHandlerStackCursor.current);
    $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, newContext);
}
function $dca0ddb82b882518$var$popSuspenseListContext(fiber) {
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$suspenseStackCursor);
    $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$suspenseHandlerStackCursor);
    $dca0ddb82b882518$var$shellBoundary === fiber && ($dca0ddb82b882518$var$shellBoundary = null);
}
function $dca0ddb82b882518$var$findFirstSuspended(row) {
    for(var node = row; null !== node;){
        if (13 === node.tag) {
            var state = node.memoizedState;
            if (null !== state && (state = state.dehydrated, null === state || $dca0ddb82b882518$var$isSuspenseInstancePending(state) || $dca0ddb82b882518$var$isSuspenseInstanceFallback(state))) return node;
        } else if (19 === node.tag && "independent" !== node.memoizedProps.revealOrder) {
            if (0 !== (node.flags & 128)) return node;
        } else if (null !== node.child) {
            node.child.return = node;
            node = node.child;
            continue;
        }
        if (node === row) break;
        for(; null === node.sibling;){
            if (null === node.return || node.return === row) return null;
            node = node.return;
        }
        node.sibling.return = node.return;
        node = node.sibling;
    }
    return null;
}
var $dca0ddb82b882518$var$renderLanes = 0, $dca0ddb82b882518$var$currentlyRenderingFiber = null, $dca0ddb82b882518$var$currentHook = null, $dca0ddb82b882518$var$workInProgressHook = null, $dca0ddb82b882518$var$didScheduleRenderPhaseUpdate = !1, $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass = !1, $dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV = !1, $dca0ddb82b882518$var$localIdCounter = 0, $dca0ddb82b882518$var$thenableIndexCounter = 0, $dca0ddb82b882518$var$thenableState = null, $dca0ddb82b882518$var$globalClientIdCounter = 0;
function $dca0ddb82b882518$var$throwInvalidHookError() {
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(321));
}
function $dca0ddb82b882518$var$areHookInputsEqual(nextDeps, prevDeps) {
    if (null === prevDeps) return !1;
    for(var i = 0; i < prevDeps.length && i < nextDeps.length; i++)if (!$dca0ddb82b882518$var$objectIs(nextDeps[i], prevDeps[i])) return !1;
    return !0;
}
function $dca0ddb82b882518$var$renderWithHooks(current, workInProgress, Component, props, secondArg, nextRenderLanes) {
    $dca0ddb82b882518$var$renderLanes = nextRenderLanes;
    $dca0ddb82b882518$var$currentlyRenderingFiber = workInProgress;
    workInProgress.memoizedState = null;
    workInProgress.updateQueue = null;
    workInProgress.lanes = 0;
    $dca0ddb82b882518$var$ReactSharedInternals.H = null === current || null === current.memoizedState ? $dca0ddb82b882518$var$HooksDispatcherOnMount : $dca0ddb82b882518$var$HooksDispatcherOnUpdate;
    $dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV = !1;
    nextRenderLanes = Component(props, secondArg);
    $dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV = !1;
    $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass && (nextRenderLanes = $dca0ddb82b882518$var$renderWithHooksAgain(workInProgress, Component, props, secondArg));
    $dca0ddb82b882518$var$finishRenderingHooks(current);
    return nextRenderLanes;
}
function $dca0ddb82b882518$var$finishRenderingHooks(current) {
    $dca0ddb82b882518$var$ReactSharedInternals.H = $dca0ddb82b882518$var$ContextOnlyDispatcher;
    var didRenderTooFewHooks = null !== $dca0ddb82b882518$var$currentHook && null !== $dca0ddb82b882518$var$currentHook.next;
    $dca0ddb82b882518$var$renderLanes = 0;
    $dca0ddb82b882518$var$workInProgressHook = $dca0ddb82b882518$var$currentHook = $dca0ddb82b882518$var$currentlyRenderingFiber = null;
    $dca0ddb82b882518$var$didScheduleRenderPhaseUpdate = !1;
    $dca0ddb82b882518$var$thenableIndexCounter = 0;
    $dca0ddb82b882518$var$thenableState = null;
    if (didRenderTooFewHooks) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(300));
    null === current || $dca0ddb82b882518$var$didReceiveUpdate || (current = current.dependencies, null !== current && $dca0ddb82b882518$var$checkIfContextChanged(current) && ($dca0ddb82b882518$var$didReceiveUpdate = !0));
}
function $dca0ddb82b882518$var$renderWithHooksAgain(workInProgress, Component, props, secondArg) {
    $dca0ddb82b882518$var$currentlyRenderingFiber = workInProgress;
    var numberOfReRenders = 0;
    do {
        $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass && ($dca0ddb82b882518$var$thenableState = null);
        $dca0ddb82b882518$var$thenableIndexCounter = 0;
        $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass = !1;
        if (25 <= numberOfReRenders) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(301));
        numberOfReRenders += 1;
        $dca0ddb82b882518$var$workInProgressHook = $dca0ddb82b882518$var$currentHook = null;
        if (null != workInProgress.updateQueue) {
            var children = workInProgress.updateQueue;
            children.lastEffect = null;
            children.events = null;
            children.stores = null;
            null != children.memoCache && (children.memoCache.index = 0);
        }
        $dca0ddb82b882518$var$ReactSharedInternals.H = $dca0ddb82b882518$var$HooksDispatcherOnRerender;
        children = Component(props, secondArg);
    }while ($dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass);
    return children;
}
function $dca0ddb82b882518$var$TransitionAwareHostComponent() {
    var dispatcher = $dca0ddb82b882518$var$ReactSharedInternals.H, maybeThenable = dispatcher.useState()[0];
    maybeThenable = "function" === typeof maybeThenable.then ? $dca0ddb82b882518$var$useThenable(maybeThenable) : maybeThenable;
    dispatcher = dispatcher.useState()[0];
    (null !== $dca0ddb82b882518$var$currentHook ? $dca0ddb82b882518$var$currentHook.memoizedState : null) !== dispatcher && ($dca0ddb82b882518$var$currentlyRenderingFiber.flags |= 1024);
    return maybeThenable;
}
function $dca0ddb82b882518$var$checkDidRenderIdHook() {
    var didRenderIdHook = 0 !== $dca0ddb82b882518$var$localIdCounter;
    $dca0ddb82b882518$var$localIdCounter = 0;
    return didRenderIdHook;
}
function $dca0ddb82b882518$var$bailoutHooks(current, workInProgress, lanes) {
    workInProgress.updateQueue = current.updateQueue;
    workInProgress.flags &= -2053;
    current.lanes &= ~lanes;
}
function $dca0ddb82b882518$var$resetHooksOnUnwind(workInProgress) {
    if ($dca0ddb82b882518$var$didScheduleRenderPhaseUpdate) {
        for(workInProgress = workInProgress.memoizedState; null !== workInProgress;){
            var queue = workInProgress.queue;
            null !== queue && (queue.pending = null);
            workInProgress = workInProgress.next;
        }
        $dca0ddb82b882518$var$didScheduleRenderPhaseUpdate = !1;
    }
    $dca0ddb82b882518$var$renderLanes = 0;
    $dca0ddb82b882518$var$workInProgressHook = $dca0ddb82b882518$var$currentHook = $dca0ddb82b882518$var$currentlyRenderingFiber = null;
    $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass = !1;
    $dca0ddb82b882518$var$thenableIndexCounter = $dca0ddb82b882518$var$localIdCounter = 0;
    $dca0ddb82b882518$var$thenableState = null;
}
function $dca0ddb82b882518$var$mountWorkInProgressHook() {
    var hook = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $dca0ddb82b882518$var$workInProgressHook ? $dca0ddb82b882518$var$currentlyRenderingFiber.memoizedState = $dca0ddb82b882518$var$workInProgressHook = hook : $dca0ddb82b882518$var$workInProgressHook = $dca0ddb82b882518$var$workInProgressHook.next = hook;
    return $dca0ddb82b882518$var$workInProgressHook;
}
function $dca0ddb82b882518$var$updateWorkInProgressHook() {
    if (null === $dca0ddb82b882518$var$currentHook) {
        var nextCurrentHook = $dca0ddb82b882518$var$currentlyRenderingFiber.alternate;
        nextCurrentHook = null !== nextCurrentHook ? nextCurrentHook.memoizedState : null;
    } else nextCurrentHook = $dca0ddb82b882518$var$currentHook.next;
    var nextWorkInProgressHook = null === $dca0ddb82b882518$var$workInProgressHook ? $dca0ddb82b882518$var$currentlyRenderingFiber.memoizedState : $dca0ddb82b882518$var$workInProgressHook.next;
    if (null !== nextWorkInProgressHook) $dca0ddb82b882518$var$workInProgressHook = nextWorkInProgressHook, $dca0ddb82b882518$var$currentHook = nextCurrentHook;
    else {
        if (null === nextCurrentHook) {
            if (null === $dca0ddb82b882518$var$currentlyRenderingFiber.alternate) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(467));
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(310));
        }
        $dca0ddb82b882518$var$currentHook = nextCurrentHook;
        nextCurrentHook = {
            memoizedState: $dca0ddb82b882518$var$currentHook.memoizedState,
            baseState: $dca0ddb82b882518$var$currentHook.baseState,
            baseQueue: $dca0ddb82b882518$var$currentHook.baseQueue,
            queue: $dca0ddb82b882518$var$currentHook.queue,
            next: null
        };
        null === $dca0ddb82b882518$var$workInProgressHook ? $dca0ddb82b882518$var$currentlyRenderingFiber.memoizedState = $dca0ddb82b882518$var$workInProgressHook = nextCurrentHook : $dca0ddb82b882518$var$workInProgressHook = $dca0ddb82b882518$var$workInProgressHook.next = nextCurrentHook;
    }
    return $dca0ddb82b882518$var$workInProgressHook;
}
function $dca0ddb82b882518$var$createFunctionComponentUpdateQueue() {
    return {
        lastEffect: null,
        events: null,
        stores: null,
        memoCache: null
    };
}
function $dca0ddb82b882518$var$useThenable(thenable) {
    var index = $dca0ddb82b882518$var$thenableIndexCounter;
    $dca0ddb82b882518$var$thenableIndexCounter += 1;
    null === $dca0ddb82b882518$var$thenableState && ($dca0ddb82b882518$var$thenableState = []);
    thenable = $dca0ddb82b882518$var$trackUsedThenable($dca0ddb82b882518$var$thenableState, thenable, index);
    index = $dca0ddb82b882518$var$currentlyRenderingFiber;
    null === (null === $dca0ddb82b882518$var$workInProgressHook ? index.memoizedState : $dca0ddb82b882518$var$workInProgressHook.next) && (index = index.alternate, $dca0ddb82b882518$var$ReactSharedInternals.H = null === index || null === index.memoizedState ? $dca0ddb82b882518$var$HooksDispatcherOnMount : $dca0ddb82b882518$var$HooksDispatcherOnUpdate);
    return thenable;
}
function $dca0ddb82b882518$var$use(usable) {
    if (null !== usable && "object" === typeof usable) {
        if ("function" === typeof usable.then) return $dca0ddb82b882518$var$useThenable(usable);
        if (usable.$$typeof === $dca0ddb82b882518$var$REACT_RECOVERABLE_TYPE) return;
        if (usable.$$typeof === $dca0ddb82b882518$var$REACT_CONTEXT_TYPE) return $dca0ddb82b882518$var$readContext(usable);
    }
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(438, String(usable)));
}
function $dca0ddb82b882518$var$useMemoCache(size) {
    var memoCache = null, updateQueue = $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue;
    null !== updateQueue && (memoCache = updateQueue.memoCache);
    if (null == memoCache) {
        var current = $dca0ddb82b882518$var$currentlyRenderingFiber.alternate;
        null !== current && (current = current.updateQueue, null !== current && (current = current.memoCache, null != current && (memoCache = {
            data: current.data.map(function(array) {
                return array.slice();
            }),
            index: 0
        })));
    }
    null == memoCache && (memoCache = {
        data: [],
        index: 0
    });
    null === updateQueue && (updateQueue = $dca0ddb82b882518$var$createFunctionComponentUpdateQueue(), $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue = updateQueue);
    updateQueue.memoCache = memoCache;
    updateQueue = memoCache.data[memoCache.index];
    if (void 0 === updateQueue) for(updateQueue = memoCache.data[memoCache.index] = Array(size), current = 0; current < size; current++)updateQueue[current] = $dca0ddb82b882518$var$REACT_MEMO_CACHE_SENTINEL;
    memoCache.index++;
    return updateQueue;
}
function $dca0ddb82b882518$var$basicStateReducer(state, action) {
    return "function" === typeof action ? action(state) : action;
}
function $dca0ddb82b882518$var$updateReducer(reducer) {
    var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    return $dca0ddb82b882518$var$updateReducerImpl(hook, $dca0ddb82b882518$var$currentHook, reducer);
}
function $dca0ddb82b882518$var$updateReducerImpl(hook, current, reducer) {
    var queue = hook.queue;
    if (null === queue) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var baseQueue = hook.baseQueue, pendingQueue = queue.pending;
    if (null !== pendingQueue) {
        if (null !== baseQueue) {
            var baseFirst = baseQueue.next;
            baseQueue.next = pendingQueue.next;
            pendingQueue.next = baseFirst;
        }
        current.baseQueue = baseQueue = pendingQueue;
        queue.pending = null;
    }
    pendingQueue = hook.baseState;
    if (null === baseQueue) hook.memoizedState = pendingQueue;
    else {
        current = baseQueue.next;
        var newBaseQueueFirst = baseFirst = null, newBaseQueueLast = null, update = current, didReadFromEntangledAsyncAction$64 = !1;
        do {
            var updateLane = update.lane & -536870913;
            if (updateLane !== update.lane ? ($dca0ddb82b882518$var$workInProgressRootRenderLanes & updateLane) === updateLane : ($dca0ddb82b882518$var$renderLanes & updateLane) === updateLane) {
                var revertLane = update.revertLane;
                if (0 === revertLane) null !== newBaseQueueLast && (newBaseQueueLast = newBaseQueueLast.next = {
                    lane: 0,
                    revertLane: 0,
                    gesture: null,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }), updateLane === $dca0ddb82b882518$var$currentEntangledLane && (didReadFromEntangledAsyncAction$64 = !0);
                else if (($dca0ddb82b882518$var$renderLanes & revertLane) === revertLane) {
                    update = update.next;
                    revertLane === $dca0ddb82b882518$var$currentEntangledLane && (didReadFromEntangledAsyncAction$64 = !0);
                    continue;
                } else updateLane = {
                    lane: 0,
                    revertLane: update.revertLane,
                    gesture: null,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = updateLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = updateLane, $dca0ddb82b882518$var$currentlyRenderingFiber.lanes |= revertLane, $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= revertLane;
                updateLane = update.action;
                $dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV && reducer(pendingQueue, updateLane);
                pendingQueue = update.hasEagerState ? update.eagerState : reducer(pendingQueue, updateLane);
            } else revertLane = {
                lane: updateLane,
                revertLane: update.revertLane,
                gesture: update.gesture,
                action: update.action,
                hasEagerState: update.hasEagerState,
                eagerState: update.eagerState,
                next: null
            }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = revertLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = revertLane, $dca0ddb82b882518$var$currentlyRenderingFiber.lanes |= updateLane, $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= updateLane;
            update = update.next;
        }while (null !== update && update !== current);
        null === newBaseQueueLast ? baseFirst = pendingQueue : newBaseQueueLast.next = newBaseQueueFirst;
        if (!$dca0ddb82b882518$var$objectIs(pendingQueue, hook.memoizedState) && ($dca0ddb82b882518$var$didReceiveUpdate = !0, didReadFromEntangledAsyncAction$64 && (reducer = $dca0ddb82b882518$var$currentEntangledActionThenable, null !== reducer))) throw reducer;
        hook.memoizedState = pendingQueue;
        hook.baseState = baseFirst;
        hook.baseQueue = newBaseQueueLast;
        queue.lastRenderedState = pendingQueue;
    }
    null === baseQueue && (queue.lanes = 0);
    return [
        hook.memoizedState,
        queue.dispatch
    ];
}
function $dca0ddb82b882518$var$rerenderReducer(reducer) {
    var hook = $dca0ddb82b882518$var$updateWorkInProgressHook(), queue = hook.queue;
    if (null === queue) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var dispatch = queue.dispatch, lastRenderPhaseUpdate = queue.pending, newState = hook.memoizedState;
    if (null !== lastRenderPhaseUpdate) {
        queue.pending = null;
        var update = lastRenderPhaseUpdate = lastRenderPhaseUpdate.next;
        do newState = reducer(newState, update.action), update = update.next;
        while (update !== lastRenderPhaseUpdate);
        $dca0ddb82b882518$var$objectIs(newState, hook.memoizedState) || ($dca0ddb82b882518$var$didReceiveUpdate = !0);
        hook.memoizedState = newState;
        null === hook.baseQueue && (hook.baseState = newState);
        queue.lastRenderedState = newState;
    }
    return [
        newState,
        dispatch
    ];
}
function $dca0ddb82b882518$var$updateSyncExternalStore(subscribe, getSnapshot, getServerSnapshot) {
    var fiber = $dca0ddb82b882518$var$currentlyRenderingFiber, hook = $dca0ddb82b882518$var$updateWorkInProgressHook(), isHydrating$jscomp$0 = $dca0ddb82b882518$var$isHydrating;
    if (isHydrating$jscomp$0) {
        if (void 0 === getServerSnapshot) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(407));
        getServerSnapshot = getServerSnapshot();
    } else getServerSnapshot = getSnapshot();
    var snapshotChanged = !$dca0ddb82b882518$var$objectIs(($dca0ddb82b882518$var$currentHook || hook).memoizedState, getServerSnapshot);
    snapshotChanged && (hook.memoizedState = getServerSnapshot, $dca0ddb82b882518$var$didReceiveUpdate = !0);
    hook = hook.queue;
    $dca0ddb82b882518$var$updateEffect($dca0ddb82b882518$var$subscribeToStore.bind(null, fiber, hook, subscribe), [
        subscribe
    ]);
    subscribe = hook.getSnapshot !== getSnapshot || snapshotChanged || null !== $dca0ddb82b882518$var$workInProgressHook && 0 !== ($dca0ddb82b882518$var$workInProgressHook.memoizedState.tag & 1);
    $dca0ddb82b882518$var$pushSimpleEffect(subscribe ? 9 : 8, {
        destroy: void 0
    }, $dca0ddb82b882518$var$updateStoreInstance.bind(null, fiber, hook, getServerSnapshot, getSnapshot), null);
    if (subscribe) {
        fiber.flags |= 2048;
        if (null === $dca0ddb82b882518$var$workInProgressRoot) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(349));
        isHydrating$jscomp$0 || 0 !== ($dca0ddb82b882518$var$renderLanes & 127) || $dca0ddb82b882518$var$pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
    }
    return getServerSnapshot;
}
function $dca0ddb82b882518$var$pushStoreConsistencyCheck(fiber, getSnapshot, renderedSnapshot) {
    fiber.flags |= 16384;
    fiber = {
        getSnapshot: getSnapshot,
        value: renderedSnapshot
    };
    getSnapshot = $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue;
    null === getSnapshot ? (getSnapshot = $dca0ddb82b882518$var$createFunctionComponentUpdateQueue(), $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue = getSnapshot, getSnapshot.stores = [
        fiber
    ]) : (renderedSnapshot = getSnapshot.stores, null === renderedSnapshot ? getSnapshot.stores = [
        fiber
    ] : renderedSnapshot.push(fiber));
}
function $dca0ddb82b882518$var$updateStoreInstance(fiber, inst, nextSnapshot, getSnapshot) {
    inst.value = nextSnapshot;
    inst.getSnapshot = getSnapshot;
    $dca0ddb82b882518$var$checkIfSnapshotChanged(inst) && $dca0ddb82b882518$var$forceStoreRerender(fiber);
}
function $dca0ddb82b882518$var$subscribeToStore(fiber, inst, subscribe) {
    return subscribe(function() {
        $dca0ddb82b882518$var$checkIfSnapshotChanged(inst) && $dca0ddb82b882518$var$forceStoreRerender(fiber);
    });
}
function $dca0ddb82b882518$var$checkIfSnapshotChanged(inst) {
    var latestGetSnapshot = inst.getSnapshot;
    inst = inst.value;
    try {
        var nextValue = latestGetSnapshot();
        return !$dca0ddb82b882518$var$objectIs(inst, nextValue);
    } catch (error) {
        return !0;
    }
}
function $dca0ddb82b882518$var$forceStoreRerender(fiber) {
    var root = $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(fiber, 2);
    null !== root && $dca0ddb82b882518$var$scheduleUpdateOnFiber(root, fiber, 2);
}
function $dca0ddb82b882518$var$mountStateImpl(initialState) {
    var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
    if ("function" === typeof initialState) {
        var initialStateInitializer = initialState;
        initialState = initialStateInitializer();
        if ($dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV) {
            $dca0ddb82b882518$var$setIsStrictModeForDevtools(!0);
            try {
                initialStateInitializer();
            } finally{
                $dca0ddb82b882518$var$setIsStrictModeForDevtools(!1);
            }
        }
    }
    hook.memoizedState = hook.baseState = initialState;
    hook.queue = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $dca0ddb82b882518$var$basicStateReducer,
        lastRenderedState: initialState
    };
    return hook;
}
function $dca0ddb82b882518$var$updateOptimisticImpl(hook, current, passthrough, reducer) {
    hook.baseState = passthrough;
    return $dca0ddb82b882518$var$updateReducerImpl(hook, $dca0ddb82b882518$var$currentHook, "function" === typeof reducer ? reducer : $dca0ddb82b882518$var$basicStateReducer);
}
function $dca0ddb82b882518$var$dispatchActionState(fiber, actionQueue, setPendingState, setState, payload) {
    if ($dca0ddb82b882518$var$isRenderPhaseUpdate(fiber)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(485));
    fiber = actionQueue.action;
    if (null !== fiber) {
        var actionNode = {
            payload: payload,
            action: fiber,
            next: null,
            isTransition: !0,
            status: "pending",
            value: null,
            reason: null,
            listeners: [],
            then: function(listener) {
                actionNode.listeners.push(listener);
            }
        };
        null !== $dca0ddb82b882518$var$ReactSharedInternals.T ? setPendingState(!0) : actionNode.isTransition = !1;
        setState(actionNode);
        setPendingState = actionQueue.pending;
        null === setPendingState ? (actionNode.next = actionQueue.pending = actionNode, $dca0ddb82b882518$var$runActionStateAction(actionQueue, actionNode)) : (actionNode.next = setPendingState.next, actionQueue.pending = setPendingState.next = actionNode);
    }
}
function $dca0ddb82b882518$var$runActionStateAction(actionQueue, node) {
    var action = node.action, payload = node.payload, prevState = actionQueue.state;
    if (node.isTransition) {
        var prevTransition = $dca0ddb82b882518$var$ReactSharedInternals.T, currentTransition = {};
        currentTransition.types = null !== prevTransition ? prevTransition.types : null;
        $dca0ddb82b882518$var$ReactSharedInternals.T = currentTransition;
        try {
            var returnValue = action(prevState, payload), onStartTransitionFinish = $dca0ddb82b882518$var$ReactSharedInternals.S;
            null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
            $dca0ddb82b882518$var$handleActionReturnValue(actionQueue, node, returnValue);
        } catch (error) {
            $dca0ddb82b882518$var$onActionError(actionQueue, node, error);
        } finally{
            null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $dca0ddb82b882518$var$ReactSharedInternals.T = prevTransition;
        }
    } else try {
        prevTransition = action(prevState, payload), $dca0ddb82b882518$var$handleActionReturnValue(actionQueue, node, prevTransition);
    } catch (error$70) {
        $dca0ddb82b882518$var$onActionError(actionQueue, node, error$70);
    }
}
function $dca0ddb82b882518$var$handleActionReturnValue(actionQueue, node, returnValue) {
    null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then ? returnValue.then(function(nextState) {
        $dca0ddb82b882518$var$onActionSuccess(actionQueue, node, nextState);
    }, function(error) {
        return $dca0ddb82b882518$var$onActionError(actionQueue, node, error);
    }) : $dca0ddb82b882518$var$onActionSuccess(actionQueue, node, returnValue);
}
function $dca0ddb82b882518$var$onActionSuccess(actionQueue, actionNode, nextState) {
    actionNode.status = "fulfilled";
    actionNode.value = nextState;
    $dca0ddb82b882518$var$notifyActionListeners(actionNode);
    actionQueue.state = nextState;
    actionNode = actionQueue.pending;
    null !== actionNode && (nextState = actionNode.next, nextState === actionNode ? actionQueue.pending = null : (nextState = nextState.next, actionNode.next = nextState, $dca0ddb82b882518$var$runActionStateAction(actionQueue, nextState)));
}
function $dca0ddb82b882518$var$onActionError(actionQueue, actionNode, error) {
    var last = actionQueue.pending;
    actionQueue.pending = null;
    if (null !== last) {
        last = last.next;
        do actionNode.status = "rejected", actionNode.reason = error, $dca0ddb82b882518$var$notifyActionListeners(actionNode), actionNode = actionNode.next;
        while (actionNode !== last);
    }
    actionQueue.action = null;
}
function $dca0ddb82b882518$var$notifyActionListeners(actionNode) {
    actionNode = actionNode.listeners;
    for(var i = 0; i < actionNode.length; i++)(0, actionNode[i])();
}
function $dca0ddb82b882518$var$actionStateReducer(oldState, newState) {
    return newState;
}
function $dca0ddb82b882518$var$mountActionState(action, initialStateProp) {
    if ($dca0ddb82b882518$var$isHydrating) {
        var ssrFormState = $dca0ddb82b882518$var$workInProgressRoot.formState;
        if (null !== ssrFormState) {
            a: {
                var JSCompiler_inline_result = $dca0ddb82b882518$var$currentlyRenderingFiber;
                if ($dca0ddb82b882518$var$isHydrating) {
                    if ($dca0ddb82b882518$var$nextHydratableInstance) {
                        b: {
                            var JSCompiler_inline_result$jscomp$0 = $dca0ddb82b882518$var$nextHydratableInstance;
                            for(var inRootOrSingleton = $dca0ddb82b882518$var$rootOrSingletonContext; 8 !== JSCompiler_inline_result$jscomp$0.nodeType;){
                                if (!inRootOrSingleton) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                                JSCompiler_inline_result$jscomp$0 = $dca0ddb82b882518$var$getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                                if (null === JSCompiler_inline_result$jscomp$0) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                            }
                            inRootOrSingleton = JSCompiler_inline_result$jscomp$0.data;
                            JSCompiler_inline_result$jscomp$0 = "F!" === inRootOrSingleton || "F" === inRootOrSingleton ? JSCompiler_inline_result$jscomp$0 : null;
                        }
                        if (JSCompiler_inline_result$jscomp$0) {
                            $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                            JSCompiler_inline_result = "F!" === JSCompiler_inline_result$jscomp$0.data;
                            break a;
                        }
                    }
                    $dca0ddb82b882518$var$throwOnHydrationMismatch(JSCompiler_inline_result);
                }
                JSCompiler_inline_result = !1;
            }
            JSCompiler_inline_result && (initialStateProp = ssrFormState[0]);
        }
    }
    ssrFormState = $dca0ddb82b882518$var$mountWorkInProgressHook();
    ssrFormState.memoizedState = ssrFormState.baseState = initialStateProp;
    JSCompiler_inline_result = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $dca0ddb82b882518$var$actionStateReducer,
        lastRenderedState: initialStateProp
    };
    ssrFormState.queue = JSCompiler_inline_result;
    ssrFormState = $dca0ddb82b882518$var$dispatchSetState.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, JSCompiler_inline_result);
    JSCompiler_inline_result.dispatch = ssrFormState;
    JSCompiler_inline_result = $dca0ddb82b882518$var$mountStateImpl(!1);
    inRootOrSingleton = $dca0ddb82b882518$var$dispatchOptimisticSetState.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, !1, JSCompiler_inline_result.queue);
    JSCompiler_inline_result = $dca0ddb82b882518$var$mountWorkInProgressHook();
    JSCompiler_inline_result$jscomp$0 = {
        state: initialStateProp,
        dispatch: null,
        action: action,
        pending: null
    };
    JSCompiler_inline_result.queue = JSCompiler_inline_result$jscomp$0;
    ssrFormState = $dca0ddb82b882518$var$dispatchActionState.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, JSCompiler_inline_result$jscomp$0, inRootOrSingleton, ssrFormState);
    JSCompiler_inline_result$jscomp$0.dispatch = ssrFormState;
    JSCompiler_inline_result.memoizedState = action;
    return [
        initialStateProp,
        ssrFormState,
        !1
    ];
}
function $dca0ddb82b882518$var$updateActionState(action) {
    var stateHook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    return $dca0ddb82b882518$var$updateActionStateImpl(stateHook, $dca0ddb82b882518$var$currentHook, action);
}
function $dca0ddb82b882518$var$updateActionStateImpl(stateHook, currentStateHook, action) {
    currentStateHook = $dca0ddb82b882518$var$updateReducerImpl(stateHook, currentStateHook, $dca0ddb82b882518$var$actionStateReducer)[0];
    stateHook = $dca0ddb82b882518$var$updateReducer($dca0ddb82b882518$var$basicStateReducer)[0];
    if ("object" === typeof currentStateHook && null !== currentStateHook && "function" === typeof currentStateHook.then) try {
        var state = $dca0ddb82b882518$var$useThenable(currentStateHook);
    } catch (x) {
        if (x === $dca0ddb82b882518$var$SuspenseException) throw $dca0ddb82b882518$var$SuspenseActionException;
        throw x;
    }
    else state = currentStateHook;
    currentStateHook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    var actionQueue = currentStateHook.queue, dispatch = actionQueue.dispatch;
    action !== currentStateHook.memoizedState && ($dca0ddb82b882518$var$currentlyRenderingFiber.flags |= 2048, $dca0ddb82b882518$var$pushSimpleEffect(9, {
        destroy: void 0
    }, $dca0ddb82b882518$var$actionStateActionEffect.bind(null, actionQueue, action), null));
    return [
        state,
        dispatch,
        stateHook
    ];
}
function $dca0ddb82b882518$var$actionStateActionEffect(actionQueue, action) {
    actionQueue.action = action;
}
function $dca0ddb82b882518$var$rerenderActionState(action) {
    var stateHook = $dca0ddb82b882518$var$updateWorkInProgressHook(), currentStateHook = $dca0ddb82b882518$var$currentHook;
    if (null !== currentStateHook) return $dca0ddb82b882518$var$updateActionStateImpl(stateHook, currentStateHook, action);
    $dca0ddb82b882518$var$updateWorkInProgressHook();
    stateHook = stateHook.memoizedState;
    currentStateHook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    var dispatch = currentStateHook.queue.dispatch;
    currentStateHook.memoizedState = action;
    return [
        stateHook,
        dispatch,
        !1
    ];
}
function $dca0ddb82b882518$var$pushSimpleEffect(tag, inst, create, deps) {
    tag = {
        tag: tag,
        create: create,
        deps: deps,
        inst: inst,
        next: null
    };
    inst = $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue;
    null === inst && (inst = $dca0ddb82b882518$var$createFunctionComponentUpdateQueue(), $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue = inst);
    create = inst.lastEffect;
    null === create ? inst.lastEffect = tag.next = tag : (deps = create.next, create.next = tag, tag.next = deps, inst.lastEffect = tag);
    return tag;
}
function $dca0ddb82b882518$var$updateRef() {
    return $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
}
function $dca0ddb82b882518$var$mountEffectImpl(fiberFlags, hookFlags, create, deps) {
    var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
    $dca0ddb82b882518$var$currentlyRenderingFiber.flags |= fiberFlags;
    hook.memoizedState = $dca0ddb82b882518$var$pushSimpleEffect(1 | hookFlags, {
        destroy: void 0
    }, create, void 0 === deps ? null : deps);
}
function $dca0ddb82b882518$var$updateEffectImpl(fiberFlags, hookFlags, create, deps) {
    var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var inst = hook.memoizedState.inst;
    null !== $dca0ddb82b882518$var$currentHook && null !== deps && $dca0ddb82b882518$var$areHookInputsEqual(deps, $dca0ddb82b882518$var$currentHook.memoizedState.deps) ? hook.memoizedState = $dca0ddb82b882518$var$pushSimpleEffect(hookFlags, inst, create, deps) : ($dca0ddb82b882518$var$currentlyRenderingFiber.flags |= fiberFlags, hook.memoizedState = $dca0ddb82b882518$var$pushSimpleEffect(1 | hookFlags, inst, create, deps));
}
function $dca0ddb82b882518$var$mountEffect(create, deps) {
    $dca0ddb82b882518$var$mountEffectImpl(8390656, 8, create, deps);
}
function $dca0ddb82b882518$var$updateEffect(create, deps) {
    $dca0ddb82b882518$var$updateEffectImpl(2048, 8, create, deps);
}
function $dca0ddb82b882518$var$useEffectEventImpl(payload) {
    $dca0ddb82b882518$var$currentlyRenderingFiber.flags |= 4;
    var componentUpdateQueue = $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue;
    if (null === componentUpdateQueue) componentUpdateQueue = $dca0ddb82b882518$var$createFunctionComponentUpdateQueue(), $dca0ddb82b882518$var$currentlyRenderingFiber.updateQueue = componentUpdateQueue, componentUpdateQueue.events = [
        payload
    ];
    else {
        var events = componentUpdateQueue.events;
        null === events ? componentUpdateQueue.events = [
            payload
        ] : events.push(payload);
    }
}
function $dca0ddb82b882518$var$updateEvent(callback) {
    var ref = $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
    $dca0ddb82b882518$var$useEffectEventImpl({
        ref: ref,
        nextImpl: callback
    });
    return function() {
        if (0 !== ($dca0ddb82b882518$var$executionContext & 2)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(440));
        return ref.impl.apply(void 0, arguments);
    };
}
function $dca0ddb82b882518$var$updateInsertionEffect(create, deps) {
    return $dca0ddb82b882518$var$updateEffectImpl(4, 2, create, deps);
}
function $dca0ddb82b882518$var$updateLayoutEffect(create, deps) {
    return $dca0ddb82b882518$var$updateEffectImpl(4, 4, create, deps);
}
function $dca0ddb82b882518$var$imperativeHandleEffect(create, ref) {
    if ("function" === typeof ref) {
        create = create();
        var refCleanup = ref(create);
        return function() {
            "function" === typeof refCleanup ? refCleanup() : ref(null);
        };
    }
    if (null !== ref && void 0 !== ref) return create = create(), ref.current = create, function() {
        ref.current = null;
    };
}
function $dca0ddb82b882518$var$updateImperativeHandle(ref, create, deps) {
    deps = null !== deps && void 0 !== deps ? deps.concat([
        ref
    ]) : null;
    $dca0ddb82b882518$var$updateEffectImpl(4, 4, $dca0ddb82b882518$var$imperativeHandleEffect.bind(null, create, ref), deps);
}
function $dca0ddb82b882518$var$mountDebugValue() {}
function $dca0ddb82b882518$var$updateCallback(callback, deps) {
    var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && $dca0ddb82b882518$var$areHookInputsEqual(deps, prevState[1])) return prevState[0];
    hook.memoizedState = [
        callback,
        deps
    ];
    return callback;
}
function $dca0ddb82b882518$var$updateMemo(nextCreate, deps) {
    var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && $dca0ddb82b882518$var$areHookInputsEqual(deps, prevState[1])) return prevState[0];
    prevState = nextCreate();
    if ($dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV) {
        $dca0ddb82b882518$var$setIsStrictModeForDevtools(!0);
        try {
            nextCreate();
        } finally{
            $dca0ddb82b882518$var$setIsStrictModeForDevtools(!1);
        }
    }
    hook.memoizedState = [
        prevState,
        deps
    ];
    return prevState;
}
function $dca0ddb82b882518$var$mountDeferredValueImpl(hook, value, initialValue) {
    if (void 0 === initialValue || 0 !== ($dca0ddb82b882518$var$renderLanes & 1073741824) && 0 === ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 261930)) return hook.memoizedState = value;
    hook.memoizedState = initialValue;
    hook = $dca0ddb82b882518$var$requestDeferredLane();
    $dca0ddb82b882518$var$currentlyRenderingFiber.lanes |= hook;
    $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= hook;
    return initialValue;
}
function $dca0ddb82b882518$var$updateDeferredValueImpl(hook, prevValue, value, initialValue) {
    if ($dca0ddb82b882518$var$objectIs(value, prevValue)) return value;
    if (null !== $dca0ddb82b882518$var$currentTreeHiddenStackCursor.current) return hook = $dca0ddb82b882518$var$mountDeferredValueImpl(hook, value, initialValue), $dca0ddb82b882518$var$objectIs(hook, prevValue) || ($dca0ddb82b882518$var$didReceiveUpdate = !0), hook;
    if (0 === ($dca0ddb82b882518$var$renderLanes & 106) || 0 !== ($dca0ddb82b882518$var$renderLanes & 1073741824) && 0 === ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 261930)) return $dca0ddb82b882518$var$didReceiveUpdate = !0, hook.memoizedState = value;
    hook = $dca0ddb82b882518$var$requestDeferredLane();
    $dca0ddb82b882518$var$currentlyRenderingFiber.lanes |= hook;
    $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= hook;
    return prevValue;
}
function $dca0ddb82b882518$var$startTransition(fiber, queue, pendingState, finishedState, callback) {
    var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 0 !== previousPriority && 8 > previousPriority ? previousPriority : 8;
    var prevTransition = $dca0ddb82b882518$var$ReactSharedInternals.T, currentTransition = {};
    currentTransition.types = null !== prevTransition ? prevTransition.types : null;
    $dca0ddb82b882518$var$ReactSharedInternals.T = currentTransition;
    $dca0ddb82b882518$var$dispatchOptimisticSetState(fiber, !1, queue, pendingState);
    try {
        var returnValue = callback(), onStartTransitionFinish = $dca0ddb82b882518$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        if (null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then) {
            var thenableForFinishedState = $dca0ddb82b882518$var$chainThenableValue(returnValue, finishedState);
            $dca0ddb82b882518$var$dispatchSetStateInternal(fiber, queue, thenableForFinishedState, $dca0ddb82b882518$var$requestUpdateLane(fiber));
        } else $dca0ddb82b882518$var$dispatchSetStateInternal(fiber, queue, finishedState, $dca0ddb82b882518$var$requestUpdateLane(fiber));
    } catch (error) {
        $dca0ddb82b882518$var$dispatchSetStateInternal(fiber, queue, {
            then: function() {},
            status: "rejected",
            reason: error
        }, $dca0ddb82b882518$var$requestUpdateLane());
    } finally{
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $dca0ddb82b882518$var$ReactSharedInternals.T = prevTransition;
    }
}
function $dca0ddb82b882518$var$noop() {}
function $dca0ddb82b882518$var$startHostTransition(formFiber, pendingState, action, formData) {
    if (5 !== formFiber.tag) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(476));
    var queue = $dca0ddb82b882518$var$ensureFormComponentIsStateful(formFiber).queue;
    $dca0ddb82b882518$var$startTransition(formFiber, queue, pendingState, $dca0ddb82b882518$var$sharedNotPendingObject, null === action ? $dca0ddb82b882518$var$noop : function() {
        $dca0ddb82b882518$var$requestFormReset$1(formFiber);
        return action(formData);
    });
}
function $dca0ddb82b882518$var$ensureFormComponentIsStateful(formFiber) {
    var existingStateHook = formFiber.memoizedState;
    if (null !== existingStateHook) return existingStateHook;
    existingStateHook = {
        memoizedState: $dca0ddb82b882518$var$sharedNotPendingObject,
        baseState: $dca0ddb82b882518$var$sharedNotPendingObject,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: $dca0ddb82b882518$var$basicStateReducer,
            lastRenderedState: $dca0ddb82b882518$var$sharedNotPendingObject
        },
        next: null
    };
    var initialResetState = {};
    existingStateHook.next = {
        memoizedState: initialResetState,
        baseState: initialResetState,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: $dca0ddb82b882518$var$basicStateReducer,
            lastRenderedState: initialResetState
        },
        next: null
    };
    formFiber.memoizedState = existingStateHook;
    formFiber = formFiber.alternate;
    null !== formFiber && (formFiber.memoizedState = existingStateHook);
    return existingStateHook;
}
function $dca0ddb82b882518$var$requestFormReset$1(formFiber) {
    var stateHook = $dca0ddb82b882518$var$ensureFormComponentIsStateful(formFiber);
    null === stateHook.next && (stateHook = formFiber.alternate.memoizedState);
    $dca0ddb82b882518$var$dispatchSetStateInternal(formFiber, stateHook.next.queue, {}, $dca0ddb82b882518$var$requestUpdateLane());
}
function $dca0ddb82b882518$var$useHostTransitionStatus() {
    return $dca0ddb82b882518$var$readContext($dca0ddb82b882518$var$HostTransitionContext);
}
function $dca0ddb82b882518$var$updateId() {
    return $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
}
function $dca0ddb82b882518$var$updateRefresh() {
    return $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
}
function $dca0ddb82b882518$var$refreshCache(fiber) {
    for(var provider = fiber.return; null !== provider;){
        switch(provider.tag){
            case 24:
            case 3:
                var lane = $dca0ddb82b882518$var$requestUpdateLane();
                fiber = $dca0ddb82b882518$var$createUpdate(lane);
                var root$73 = $dca0ddb82b882518$var$enqueueUpdate(provider, fiber, lane);
                null !== root$73 && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(root$73, provider, lane), $dca0ddb82b882518$var$entangleTransitions(root$73, provider, lane));
                provider = {
                    cache: $dca0ddb82b882518$var$createCache()
                };
                fiber.payload = provider;
                return;
        }
        provider = provider.return;
    }
}
function $dca0ddb82b882518$var$dispatchReducerAction(fiber, queue, action) {
    var lane = $dca0ddb82b882518$var$requestUpdateLane();
    action = {
        lane: lane,
        revertLane: 0,
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    $dca0ddb82b882518$var$isRenderPhaseUpdate(fiber) ? $dca0ddb82b882518$var$enqueueRenderPhaseUpdate(queue, action) : (action = $dca0ddb82b882518$var$enqueueConcurrentHookUpdate(fiber, queue, action, lane), null !== action && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(action, fiber, lane), $dca0ddb82b882518$var$entangleTransitionUpdate(action, queue, lane)));
}
function $dca0ddb82b882518$var$dispatchSetState(fiber, queue, action) {
    var lane = $dca0ddb82b882518$var$requestUpdateLane();
    $dca0ddb82b882518$var$dispatchSetStateInternal(fiber, queue, action, lane);
}
function $dca0ddb82b882518$var$dispatchSetStateInternal(fiber, queue, action, lane) {
    var update = {
        lane: lane,
        revertLane: 0,
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($dca0ddb82b882518$var$isRenderPhaseUpdate(fiber)) $dca0ddb82b882518$var$enqueueRenderPhaseUpdate(queue, update);
    else {
        var alternate = fiber.alternate;
        if (0 === fiber.lanes && (null === alternate || 0 === alternate.lanes) && (alternate = queue.lastRenderedReducer, null !== alternate)) try {
            var currentState = queue.lastRenderedState, eagerState = alternate(currentState, action);
            update.hasEagerState = !0;
            update.eagerState = eagerState;
            if ($dca0ddb82b882518$var$objectIs(eagerState, currentState)) return $dca0ddb82b882518$var$enqueueUpdate$1(fiber, queue, update, 0), null === $dca0ddb82b882518$var$workInProgressRoot && $dca0ddb82b882518$var$finishQueueingConcurrentUpdates(), !1;
        } catch (error) {} finally{}
        action = $dca0ddb82b882518$var$enqueueConcurrentHookUpdate(fiber, queue, update, lane);
        if (null !== action) return $dca0ddb82b882518$var$scheduleUpdateOnFiber(action, fiber, lane), $dca0ddb82b882518$var$entangleTransitionUpdate(action, queue, lane), !0;
    }
    return !1;
}
function $dca0ddb82b882518$var$dispatchOptimisticSetState(fiber, throwIfDuringRender, queue, action) {
    action = {
        lane: 2,
        revertLane: $dca0ddb82b882518$var$requestTransitionLane(),
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($dca0ddb82b882518$var$isRenderPhaseUpdate(fiber)) {
        if (throwIfDuringRender) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(479));
    } else throwIfDuringRender = $dca0ddb82b882518$var$enqueueConcurrentHookUpdate(fiber, queue, action, 2), null !== throwIfDuringRender && $dca0ddb82b882518$var$scheduleUpdateOnFiber(throwIfDuringRender, fiber, 2);
}
function $dca0ddb82b882518$var$isRenderPhaseUpdate(fiber) {
    var alternate = fiber.alternate;
    return fiber === $dca0ddb82b882518$var$currentlyRenderingFiber || null !== alternate && alternate === $dca0ddb82b882518$var$currentlyRenderingFiber;
}
function $dca0ddb82b882518$var$enqueueRenderPhaseUpdate(queue, update) {
    $dca0ddb82b882518$var$didScheduleRenderPhaseUpdateDuringThisPass = $dca0ddb82b882518$var$didScheduleRenderPhaseUpdate = !0;
    var pending = queue.pending;
    null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
    queue.pending = update;
}
function $dca0ddb82b882518$var$entangleTransitionUpdate(root, queue, lane) {
    if (0 !== (lane & 4194048)) {
        var queueLanes = queue.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        queue.lanes = lane;
        $dca0ddb82b882518$var$markRootEntangled(root, lane);
    }
}
var $dca0ddb82b882518$var$ContextOnlyDispatcher = {
    readContext: $dca0ddb82b882518$var$readContext,
    use: $dca0ddb82b882518$var$use,
    useCallback: $dca0ddb82b882518$var$throwInvalidHookError,
    useContext: $dca0ddb82b882518$var$throwInvalidHookError,
    useEffect: $dca0ddb82b882518$var$throwInvalidHookError,
    useImperativeHandle: $dca0ddb82b882518$var$throwInvalidHookError,
    useLayoutEffect: $dca0ddb82b882518$var$throwInvalidHookError,
    useInsertionEffect: $dca0ddb82b882518$var$throwInvalidHookError,
    useMemo: $dca0ddb82b882518$var$throwInvalidHookError,
    useReducer: $dca0ddb82b882518$var$throwInvalidHookError,
    useRef: $dca0ddb82b882518$var$throwInvalidHookError,
    useState: $dca0ddb82b882518$var$throwInvalidHookError,
    useDebugValue: $dca0ddb82b882518$var$throwInvalidHookError,
    useDeferredValue: $dca0ddb82b882518$var$throwInvalidHookError,
    useTransition: $dca0ddb82b882518$var$throwInvalidHookError,
    useSyncExternalStore: $dca0ddb82b882518$var$throwInvalidHookError,
    useId: $dca0ddb82b882518$var$throwInvalidHookError,
    useHostTransitionStatus: $dca0ddb82b882518$var$throwInvalidHookError,
    useFormState: $dca0ddb82b882518$var$throwInvalidHookError,
    useActionState: $dca0ddb82b882518$var$throwInvalidHookError,
    useOptimistic: $dca0ddb82b882518$var$throwInvalidHookError,
    useMemoCache: $dca0ddb82b882518$var$throwInvalidHookError,
    useCacheRefresh: $dca0ddb82b882518$var$throwInvalidHookError,
    useEffectEvent: $dca0ddb82b882518$var$throwInvalidHookError
}, $dca0ddb82b882518$var$HooksDispatcherOnMount = {
    readContext: $dca0ddb82b882518$var$readContext,
    use: $dca0ddb82b882518$var$use,
    useCallback: function(callback, deps) {
        $dca0ddb82b882518$var$mountWorkInProgressHook().memoizedState = [
            callback,
            void 0 === deps ? null : deps
        ];
        return callback;
    },
    useContext: $dca0ddb82b882518$var$readContext,
    useEffect: $dca0ddb82b882518$var$mountEffect,
    useImperativeHandle: function(ref, create, deps) {
        deps = null !== deps && void 0 !== deps ? deps.concat([
            ref
        ]) : null;
        $dca0ddb82b882518$var$mountEffectImpl(4194308, 4, $dca0ddb82b882518$var$imperativeHandleEffect.bind(null, create, ref), deps);
    },
    useLayoutEffect: function(create, deps) {
        return $dca0ddb82b882518$var$mountEffectImpl(4194308, 4, create, deps);
    },
    useInsertionEffect: function(create, deps) {
        $dca0ddb82b882518$var$mountEffectImpl(4, 2, create, deps);
    },
    useMemo: function(nextCreate, deps) {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        deps = void 0 === deps ? null : deps;
        var nextValue = nextCreate();
        if ($dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV) {
            $dca0ddb82b882518$var$setIsStrictModeForDevtools(!0);
            try {
                nextCreate();
            } finally{
                $dca0ddb82b882518$var$setIsStrictModeForDevtools(!1);
            }
        }
        hook.memoizedState = [
            nextValue,
            deps
        ];
        return nextValue;
    },
    useReducer: function(reducer, initialArg, init) {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        if (void 0 !== init) {
            var initialState = init(initialArg);
            if ($dca0ddb82b882518$var$shouldDoubleInvokeUserFnsInHooksDEV) {
                $dca0ddb82b882518$var$setIsStrictModeForDevtools(!0);
                try {
                    init(initialArg);
                } finally{
                    $dca0ddb82b882518$var$setIsStrictModeForDevtools(!1);
                }
            }
        } else initialState = initialArg;
        hook.memoizedState = hook.baseState = initialState;
        reducer = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: reducer,
            lastRenderedState: initialState
        };
        hook.queue = reducer;
        reducer = reducer.dispatch = $dca0ddb82b882518$var$dispatchReducerAction.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, reducer);
        return [
            hook.memoizedState,
            reducer
        ];
    },
    useRef: function(initialValue) {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        initialValue = {
            current: initialValue
        };
        return hook.memoizedState = initialValue;
    },
    useState: function(initialState) {
        initialState = $dca0ddb82b882518$var$mountStateImpl(initialState);
        var queue = initialState.queue, dispatch = $dca0ddb82b882518$var$dispatchSetState.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, queue);
        queue.dispatch = dispatch;
        return [
            initialState.memoizedState,
            dispatch
        ];
    },
    useDebugValue: $dca0ddb82b882518$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        return $dca0ddb82b882518$var$mountDeferredValueImpl(hook, value, initialValue);
    },
    useTransition: function() {
        var stateHook = $dca0ddb82b882518$var$mountStateImpl(!1);
        stateHook = $dca0ddb82b882518$var$startTransition.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, stateHook.queue, !0, !1);
        $dca0ddb82b882518$var$mountWorkInProgressHook().memoizedState = stateHook;
        return [
            !1,
            stateHook
        ];
    },
    useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
        var fiber = $dca0ddb82b882518$var$currentlyRenderingFiber, hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        if ($dca0ddb82b882518$var$isHydrating) {
            if (void 0 === getServerSnapshot) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(407));
            getServerSnapshot = getServerSnapshot();
        } else {
            getServerSnapshot = getSnapshot();
            if (null === $dca0ddb82b882518$var$workInProgressRoot) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(349));
            0 !== ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 127) || $dca0ddb82b882518$var$pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
        }
        hook.memoizedState = getServerSnapshot;
        var inst = {
            value: getServerSnapshot,
            getSnapshot: getSnapshot
        };
        hook.queue = inst;
        $dca0ddb82b882518$var$mountEffect($dca0ddb82b882518$var$subscribeToStore.bind(null, fiber, inst, subscribe), [
            subscribe
        ]);
        fiber.flags |= 2048;
        $dca0ddb82b882518$var$pushSimpleEffect(9, {
            destroy: void 0
        }, $dca0ddb82b882518$var$updateStoreInstance.bind(null, fiber, inst, getServerSnapshot, getSnapshot), null);
        return getServerSnapshot;
    },
    useId: function() {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook(), identifierPrefix = $dca0ddb82b882518$var$workInProgressRoot.identifierPrefix;
        if ($dca0ddb82b882518$var$isHydrating) {
            var JSCompiler_inline_result = $dca0ddb82b882518$var$treeContextOverflow;
            var idWithLeadingBit = $dca0ddb82b882518$var$treeContextId;
            JSCompiler_inline_result = (idWithLeadingBit & ~(1 << 32 - $dca0ddb82b882518$var$clz32(idWithLeadingBit) - 1)).toString(32) + JSCompiler_inline_result;
            identifierPrefix = "_" + identifierPrefix + "R_" + JSCompiler_inline_result;
            JSCompiler_inline_result = $dca0ddb82b882518$var$localIdCounter++;
            0 < JSCompiler_inline_result && (identifierPrefix += "H" + JSCompiler_inline_result.toString(32));
            identifierPrefix += "_";
        } else JSCompiler_inline_result = $dca0ddb82b882518$var$globalClientIdCounter++, identifierPrefix = "_" + identifierPrefix + "r_" + JSCompiler_inline_result.toString(32) + "_";
        return hook.memoizedState = identifierPrefix;
    },
    useHostTransitionStatus: $dca0ddb82b882518$var$useHostTransitionStatus,
    useFormState: $dca0ddb82b882518$var$mountActionState,
    useActionState: $dca0ddb82b882518$var$mountActionState,
    useOptimistic: function(passthrough) {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook();
        hook.memoizedState = hook.baseState = passthrough;
        var queue = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: null,
            lastRenderedState: null
        };
        hook.queue = queue;
        hook = $dca0ddb82b882518$var$dispatchOptimisticSetState.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber, !0, queue);
        queue.dispatch = hook;
        return [
            passthrough,
            hook
        ];
    },
    useMemoCache: $dca0ddb82b882518$var$useMemoCache,
    useCacheRefresh: function() {
        return $dca0ddb82b882518$var$mountWorkInProgressHook().memoizedState = $dca0ddb82b882518$var$refreshCache.bind(null, $dca0ddb82b882518$var$currentlyRenderingFiber);
    },
    useEffectEvent: function(callback) {
        var hook = $dca0ddb82b882518$var$mountWorkInProgressHook(), ref = {
            impl: callback
        };
        hook.memoizedState = ref;
        return function() {
            if (0 !== ($dca0ddb82b882518$var$executionContext & 2)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(440));
            return ref.impl.apply(void 0, arguments);
        };
    }
}, $dca0ddb82b882518$var$HooksDispatcherOnUpdate = {
    readContext: $dca0ddb82b882518$var$readContext,
    use: $dca0ddb82b882518$var$use,
    useCallback: $dca0ddb82b882518$var$updateCallback,
    useContext: $dca0ddb82b882518$var$readContext,
    useEffect: $dca0ddb82b882518$var$updateEffect,
    useImperativeHandle: $dca0ddb82b882518$var$updateImperativeHandle,
    useInsertionEffect: $dca0ddb82b882518$var$updateInsertionEffect,
    useLayoutEffect: $dca0ddb82b882518$var$updateLayoutEffect,
    useMemo: $dca0ddb82b882518$var$updateMemo,
    useReducer: $dca0ddb82b882518$var$updateReducer,
    useRef: $dca0ddb82b882518$var$updateRef,
    useState: function() {
        return $dca0ddb82b882518$var$updateReducer($dca0ddb82b882518$var$basicStateReducer);
    },
    useDebugValue: $dca0ddb82b882518$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
        return $dca0ddb82b882518$var$updateDeferredValueImpl(hook, $dca0ddb82b882518$var$currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = $dca0ddb82b882518$var$updateReducer($dca0ddb82b882518$var$basicStateReducer)[0], start = $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : $dca0ddb82b882518$var$useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: $dca0ddb82b882518$var$updateSyncExternalStore,
    useId: $dca0ddb82b882518$var$updateId,
    useHostTransitionStatus: $dca0ddb82b882518$var$useHostTransitionStatus,
    useFormState: $dca0ddb82b882518$var$updateActionState,
    useActionState: $dca0ddb82b882518$var$updateActionState,
    useOptimistic: function(passthrough, reducer) {
        var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
        return $dca0ddb82b882518$var$updateOptimisticImpl(hook, $dca0ddb82b882518$var$currentHook, passthrough, reducer);
    },
    useMemoCache: $dca0ddb82b882518$var$useMemoCache,
    useCacheRefresh: $dca0ddb82b882518$var$updateRefresh,
    useEffectEvent: $dca0ddb82b882518$var$updateEvent
}, $dca0ddb82b882518$var$HooksDispatcherOnRerender = {
    readContext: $dca0ddb82b882518$var$readContext,
    use: $dca0ddb82b882518$var$use,
    useCallback: $dca0ddb82b882518$var$updateCallback,
    useContext: $dca0ddb82b882518$var$readContext,
    useEffect: $dca0ddb82b882518$var$updateEffect,
    useImperativeHandle: $dca0ddb82b882518$var$updateImperativeHandle,
    useInsertionEffect: $dca0ddb82b882518$var$updateInsertionEffect,
    useLayoutEffect: $dca0ddb82b882518$var$updateLayoutEffect,
    useMemo: $dca0ddb82b882518$var$updateMemo,
    useReducer: $dca0ddb82b882518$var$rerenderReducer,
    useRef: $dca0ddb82b882518$var$updateRef,
    useState: function() {
        return $dca0ddb82b882518$var$rerenderReducer($dca0ddb82b882518$var$basicStateReducer);
    },
    useDebugValue: $dca0ddb82b882518$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
        return null === $dca0ddb82b882518$var$currentHook ? $dca0ddb82b882518$var$mountDeferredValueImpl(hook, value, initialValue) : $dca0ddb82b882518$var$updateDeferredValueImpl(hook, $dca0ddb82b882518$var$currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = $dca0ddb82b882518$var$rerenderReducer($dca0ddb82b882518$var$basicStateReducer)[0], start = $dca0ddb82b882518$var$updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : $dca0ddb82b882518$var$useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: $dca0ddb82b882518$var$updateSyncExternalStore,
    useId: $dca0ddb82b882518$var$updateId,
    useHostTransitionStatus: $dca0ddb82b882518$var$useHostTransitionStatus,
    useFormState: $dca0ddb82b882518$var$rerenderActionState,
    useActionState: $dca0ddb82b882518$var$rerenderActionState,
    useOptimistic: function(passthrough, reducer) {
        var hook = $dca0ddb82b882518$var$updateWorkInProgressHook();
        if (null !== $dca0ddb82b882518$var$currentHook) return $dca0ddb82b882518$var$updateOptimisticImpl(hook, $dca0ddb82b882518$var$currentHook, passthrough, reducer);
        hook.baseState = passthrough;
        return [
            passthrough,
            hook.queue.dispatch
        ];
    },
    useMemoCache: $dca0ddb82b882518$var$useMemoCache,
    useCacheRefresh: $dca0ddb82b882518$var$updateRefresh,
    useEffectEvent: $dca0ddb82b882518$var$updateEvent
};
function $dca0ddb82b882518$var$applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, nextProps) {
    ctor = workInProgress.memoizedState;
    getDerivedStateFromProps = getDerivedStateFromProps(nextProps, ctor);
    getDerivedStateFromProps = null === getDerivedStateFromProps || void 0 === getDerivedStateFromProps ? ctor : $dca0ddb82b882518$var$assign({}, ctor, getDerivedStateFromProps);
    workInProgress.memoizedState = getDerivedStateFromProps;
    0 === workInProgress.lanes && (workInProgress.updateQueue.baseState = getDerivedStateFromProps);
}
var $dca0ddb82b882518$var$classComponentUpdater = {
    enqueueSetState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = $dca0ddb82b882518$var$requestUpdateLane(), update = $dca0ddb82b882518$var$createUpdate(lane);
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = $dca0ddb82b882518$var$enqueueUpdate(inst, update, lane);
        null !== payload && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(payload, inst, lane), $dca0ddb82b882518$var$entangleTransitions(payload, inst, lane));
    },
    enqueueReplaceState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = $dca0ddb82b882518$var$requestUpdateLane(), update = $dca0ddb82b882518$var$createUpdate(lane);
        update.tag = 1;
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = $dca0ddb82b882518$var$enqueueUpdate(inst, update, lane);
        null !== payload && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(payload, inst, lane), $dca0ddb82b882518$var$entangleTransitions(payload, inst, lane));
    },
    enqueueForceUpdate: function(inst, callback) {
        inst = inst._reactInternals;
        var lane = $dca0ddb82b882518$var$requestUpdateLane(), update = $dca0ddb82b882518$var$createUpdate(lane);
        update.tag = 2;
        void 0 !== callback && null !== callback && (update.callback = callback);
        callback = $dca0ddb82b882518$var$enqueueUpdate(inst, update, lane);
        null !== callback && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(callback, inst, lane), $dca0ddb82b882518$var$entangleTransitions(callback, inst, lane));
    }
};
function $dca0ddb82b882518$var$checkShouldComponentUpdate(workInProgress, ctor, oldProps, newProps, oldState, newState, nextContext) {
    workInProgress = workInProgress.stateNode;
    return "function" === typeof workInProgress.shouldComponentUpdate ? workInProgress.shouldComponentUpdate(newProps, newState, nextContext) : ctor.prototype && ctor.prototype.isPureReactComponent ? !$dca0ddb82b882518$var$shallowEqual(oldProps, newProps) || !$dca0ddb82b882518$var$shallowEqual(oldState, newState) : !0;
}
function $dca0ddb82b882518$var$callComponentWillReceiveProps(workInProgress, instance, newProps, nextContext) {
    workInProgress = instance.state;
    "function" === typeof instance.componentWillReceiveProps && instance.componentWillReceiveProps(newProps, nextContext);
    "function" === typeof instance.UNSAFE_componentWillReceiveProps && instance.UNSAFE_componentWillReceiveProps(newProps, nextContext);
    instance.state !== workInProgress && $dca0ddb82b882518$var$classComponentUpdater.enqueueReplaceState(instance, instance.state, null);
}
function $dca0ddb82b882518$var$resolveClassComponentProps(Component, baseProps) {
    var newProps = baseProps;
    if ("ref" in baseProps) {
        newProps = {};
        for(var propName in baseProps)"ref" !== propName && (newProps[propName] = baseProps[propName]);
    }
    if (Component = Component.defaultProps) {
        newProps === baseProps && (newProps = $dca0ddb82b882518$var$assign({}, newProps));
        for(var propName$77 in Component)void 0 === newProps[propName$77] && (newProps[propName$77] = Component[propName$77]);
    }
    return newProps;
}
function $dca0ddb82b882518$var$defaultOnUncaughtError(error) {
    $dca0ddb82b882518$var$reportGlobalError(error);
}
function $dca0ddb82b882518$var$defaultOnCaughtError(error) {
    console.error(error);
}
function $dca0ddb82b882518$var$defaultOnRecoverableError(error) {
    $dca0ddb82b882518$var$reportGlobalError(error);
}
function $dca0ddb82b882518$var$logUncaughtError(root, errorInfo) {
    try {
        var onUncaughtError = root.onUncaughtError;
        onUncaughtError(errorInfo.value, {
            componentStack: errorInfo.stack
        });
    } catch (e$78) {
        setTimeout(function() {
            throw e$78;
        });
    }
}
function $dca0ddb82b882518$var$logCaughtError(root, boundary, errorInfo) {
    try {
        var onCaughtError = root.onCaughtError;
        onCaughtError(errorInfo.value, {
            componentStack: errorInfo.stack,
            errorBoundary: 1 === boundary.tag ? boundary.stateNode : null
        });
    } catch (e$79) {
        setTimeout(function() {
            throw e$79;
        });
    }
}
function $dca0ddb82b882518$var$createRootErrorUpdate(root, errorInfo, lane) {
    lane = $dca0ddb82b882518$var$createUpdate(lane);
    lane.tag = 3;
    lane.payload = {
        element: null
    };
    lane.callback = function() {
        $dca0ddb82b882518$var$logUncaughtError(root, errorInfo);
    };
    return lane;
}
function $dca0ddb82b882518$var$createClassErrorUpdate(lane) {
    lane = $dca0ddb82b882518$var$createUpdate(lane);
    lane.tag = 3;
    return lane;
}
function $dca0ddb82b882518$var$initializeClassErrorUpdate(update, root, fiber, errorInfo) {
    var getDerivedStateFromError = fiber.type.getDerivedStateFromError;
    if ("function" === typeof getDerivedStateFromError) {
        var error = errorInfo.value;
        update.payload = function() {
            return getDerivedStateFromError(error);
        };
        update.callback = function() {
            $dca0ddb82b882518$var$logCaughtError(root, fiber, errorInfo);
        };
    }
    var inst = fiber.stateNode;
    null !== inst && "function" === typeof inst.componentDidCatch && (update.callback = function() {
        $dca0ddb82b882518$var$logCaughtError(root, fiber, errorInfo);
        "function" !== typeof getDerivedStateFromError && (null === $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed ? $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed = new Set([
            this
        ]) : $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed.add(this));
        var stack = errorInfo.stack;
        this.componentDidCatch(errorInfo.value, {
            componentStack: null !== stack ? stack : ""
        });
    });
}
function $dca0ddb82b882518$var$throwException(root, returnFiber, sourceFiber, value, rootRenderLanes) {
    sourceFiber.flags |= 32768;
    if (null !== value && "object" === typeof value && "function" === typeof value.then) {
        returnFiber = sourceFiber.alternate;
        null !== returnFiber && $dca0ddb82b882518$var$propagateParentContextChanges(returnFiber, sourceFiber, rootRenderLanes, !0);
        sourceFiber = $dca0ddb82b882518$var$suspenseHandlerStackCursor.current;
        if (null !== sourceFiber) {
            switch(sourceFiber.tag){
                case 31:
                case 13:
                case 19:
                    return null === $dca0ddb82b882518$var$shellBoundary ? $dca0ddb82b882518$var$renderDidSuspendDelayIfPossible() : null === sourceFiber.alternate && 0 === $dca0ddb82b882518$var$workInProgressRootExitStatus && ($dca0ddb82b882518$var$workInProgressRootExitStatus = 3), sourceFiber.flags &= -257, sourceFiber.flags |= 65536, sourceFiber.lanes = rootRenderLanes, value === $dca0ddb82b882518$var$noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? sourceFiber.updateQueue = new Set([
                        value
                    ]) : returnFiber.add(value), $dca0ddb82b882518$var$attachPingListener(root, value, rootRenderLanes)), !1;
                case 22:
                    return sourceFiber.flags |= 65536, value === $dca0ddb82b882518$var$noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? (returnFiber = {
                        transitions: null,
                        markerInstances: null,
                        retryQueue: new Set([
                            value
                        ])
                    }, sourceFiber.updateQueue = returnFiber) : (sourceFiber = returnFiber.retryQueue, null === sourceFiber ? returnFiber.retryQueue = new Set([
                        value
                    ]) : sourceFiber.add(value)), $dca0ddb82b882518$var$attachPingListener(root, value, rootRenderLanes)), !1;
            }
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(435, sourceFiber.tag));
        }
        $dca0ddb82b882518$var$attachPingListener(root, value, rootRenderLanes);
        $dca0ddb82b882518$var$renderDidSuspendDelayIfPossible();
        return !1;
    }
    if ($dca0ddb82b882518$var$isHydrating) return returnFiber = $dca0ddb82b882518$var$suspenseHandlerStackCursor.current, null !== returnFiber ? (0 === (returnFiber.flags & 65536) && (returnFiber.flags |= 256), returnFiber.flags |= 65536, returnFiber.lanes = rootRenderLanes, value !== $dca0ddb82b882518$var$HydrationMismatchException && (root = Error($dca0ddb82b882518$var$formatProdErrorMessage(422), {
        cause: value
    }), $dca0ddb82b882518$var$queueHydrationError($dca0ddb82b882518$var$createCapturedValueAtFiber(root, sourceFiber)))) : (value !== $dca0ddb82b882518$var$HydrationMismatchException && (returnFiber = Error($dca0ddb82b882518$var$formatProdErrorMessage(423), {
        cause: value
    }), $dca0ddb82b882518$var$queueHydrationError($dca0ddb82b882518$var$createCapturedValueAtFiber(returnFiber, sourceFiber))), root = root.current.alternate, root.flags |= 65536, rootRenderLanes &= -rootRenderLanes, root.lanes |= rootRenderLanes, value = $dca0ddb82b882518$var$createCapturedValueAtFiber(value, sourceFiber), rootRenderLanes = $dca0ddb82b882518$var$createRootErrorUpdate(root.stateNode, value, rootRenderLanes), $dca0ddb82b882518$var$enqueueCapturedUpdate(root, rootRenderLanes), 4 !== $dca0ddb82b882518$var$workInProgressRootExitStatus && ($dca0ddb82b882518$var$workInProgressRootExitStatus = 2)), !1;
    var wrapperError = Error($dca0ddb82b882518$var$formatProdErrorMessage(520), {
        cause: value
    });
    wrapperError = $dca0ddb82b882518$var$createCapturedValueAtFiber(wrapperError, sourceFiber);
    null === $dca0ddb82b882518$var$workInProgressRootConcurrentErrors ? $dca0ddb82b882518$var$workInProgressRootConcurrentErrors = [
        wrapperError
    ] : $dca0ddb82b882518$var$workInProgressRootConcurrentErrors.push(wrapperError);
    4 !== $dca0ddb82b882518$var$workInProgressRootExitStatus && ($dca0ddb82b882518$var$workInProgressRootExitStatus = 2);
    if (null === returnFiber) return !0;
    value = $dca0ddb82b882518$var$createCapturedValueAtFiber(value, sourceFiber);
    sourceFiber = returnFiber;
    do {
        switch(sourceFiber.tag){
            case 3:
                return sourceFiber.flags |= 65536, root = rootRenderLanes & -rootRenderLanes, sourceFiber.lanes |= root, root = $dca0ddb82b882518$var$createRootErrorUpdate(sourceFiber.stateNode, value, root), $dca0ddb82b882518$var$enqueueCapturedUpdate(sourceFiber, root), !1;
            case 1:
                returnFiber = sourceFiber.type;
                wrapperError = sourceFiber.stateNode;
                if (0 === (sourceFiber.flags & 128) && ("function" === typeof returnFiber.getDerivedStateFromError || null !== wrapperError && "function" === typeof wrapperError.componentDidCatch && (null === $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed || !$dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed.has(wrapperError)))) return sourceFiber.flags |= 65536, rootRenderLanes &= -rootRenderLanes, sourceFiber.lanes |= rootRenderLanes, rootRenderLanes = $dca0ddb82b882518$var$createClassErrorUpdate(rootRenderLanes), $dca0ddb82b882518$var$initializeClassErrorUpdate(rootRenderLanes, root, sourceFiber, value), $dca0ddb82b882518$var$enqueueCapturedUpdate(sourceFiber, rootRenderLanes), !1;
                break;
            case 22:
                if (null !== sourceFiber.memoizedState) return sourceFiber.flags |= 65536, !1;
        }
        sourceFiber = sourceFiber.return;
    }while (null !== sourceFiber);
    return !1;
}
var $dca0ddb82b882518$var$SelectiveHydrationException = Error($dca0ddb82b882518$var$formatProdErrorMessage(461)), $dca0ddb82b882518$var$didReceiveUpdate = !1;
function $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes) {
    workInProgress.child = null === current ? $dca0ddb82b882518$var$mountChildFibers(workInProgress, null, nextChildren, renderLanes) : $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, current.child, nextChildren, renderLanes);
}
function $dca0ddb82b882518$var$updateForwardRef(current, workInProgress, Component, nextProps, renderLanes) {
    Component = Component.render;
    var ref = workInProgress.ref;
    if ("ref" in nextProps) {
        var propsWithoutRef = {};
        for(var key in nextProps)"ref" !== key && (propsWithoutRef[key] = nextProps[key]);
    } else propsWithoutRef = nextProps;
    $dca0ddb82b882518$var$prepareToReadContext(workInProgress);
    nextProps = $dca0ddb82b882518$var$renderWithHooks(current, workInProgress, Component, propsWithoutRef, ref, renderLanes);
    key = $dca0ddb82b882518$var$checkDidRenderIdHook();
    if (null !== current && !$dca0ddb82b882518$var$didReceiveUpdate) return $dca0ddb82b882518$var$bailoutHooks(current, workInProgress, renderLanes), $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $dca0ddb82b882518$var$isHydrating && key && $dca0ddb82b882518$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function $dca0ddb82b882518$var$updateMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null === current) {
        var type = Component.type;
        if ("function" === typeof type && !$dca0ddb82b882518$var$shouldConstruct(type) && void 0 === type.defaultProps && null === Component.compare) return workInProgress.tag = 15, workInProgress.type = type, $dca0ddb82b882518$var$updateSimpleMemoComponent(current, workInProgress, type, nextProps, renderLanes);
        current = $dca0ddb82b882518$var$createFiberFromTypeAndProps(Component.type, null, nextProps, workInProgress, workInProgress.mode, renderLanes);
        current.ref = workInProgress.ref;
        current.return = workInProgress;
        return workInProgress.child = current;
    }
    type = current.child;
    if (!$dca0ddb82b882518$var$checkScheduledUpdateOrContext(current, renderLanes)) {
        var prevProps = type.memoizedProps;
        Component = Component.compare;
        Component = null !== Component ? Component : $dca0ddb82b882518$var$shallowEqual;
        if (Component(prevProps, nextProps) && current.ref === workInProgress.ref) return $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    }
    workInProgress.flags |= 1;
    current = $dca0ddb82b882518$var$createWorkInProgress(type, nextProps);
    current.ref = workInProgress.ref;
    current.return = workInProgress;
    return workInProgress.child = current;
}
function $dca0ddb82b882518$var$updateSimpleMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null !== current) {
        var prevProps = current.memoizedProps;
        if ($dca0ddb82b882518$var$shallowEqual(prevProps, nextProps) && current.ref === workInProgress.ref) {
            if ($dca0ddb82b882518$var$didReceiveUpdate = !1, workInProgress.pendingProps = nextProps = prevProps, $dca0ddb82b882518$var$checkScheduledUpdateOrContext(current, renderLanes)) 0 !== (current.flags & 131072) && ($dca0ddb82b882518$var$didReceiveUpdate = !0);
            else return workInProgress.lanes = current.lanes, $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
        }
    }
    return $dca0ddb82b882518$var$updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes);
}
function $dca0ddb82b882518$var$updateOffscreenComponent(current, workInProgress, renderLanes, nextProps) {
    var nextChildren = nextProps.children, prevState = null !== current ? current.memoizedState : null;
    null === current && null === workInProgress.stateNode && (workInProgress.stateNode = {
        _visibility: 1,
        _pendingMarkers: null,
        _retryCache: null,
        _transitions: null
    });
    if ("hidden" === nextProps.mode) {
        if (0 !== (workInProgress.flags & 128)) {
            prevState = null !== prevState ? prevState.baseLanes | renderLanes : renderLanes;
            if (null !== current) {
                nextProps = workInProgress.child = current.child;
                for(nextChildren = 0; null !== nextProps;)nextChildren = nextChildren | nextProps.lanes | nextProps.childLanes, nextProps = nextProps.sibling;
                nextProps = nextChildren & ~prevState;
            } else nextProps = 0, workInProgress.child = null;
            return $dca0ddb82b882518$var$deferHiddenOffscreenComponent(current, workInProgress, prevState, renderLanes, nextProps);
        }
        if (0 !== (renderLanes & 536870912)) workInProgress.memoizedState = {
            baseLanes: 0,
            cachePool: null
        }, null !== current && $dca0ddb82b882518$var$pushTransition(workInProgress, null !== prevState ? prevState.cachePool : null), null !== prevState ? $dca0ddb82b882518$var$pushHiddenContext(workInProgress, prevState) : $dca0ddb82b882518$var$reuseHiddenContextOnStack(), $dca0ddb82b882518$var$pushOffscreenSuspenseHandler(workInProgress);
        else return nextProps = workInProgress.lanes = 536870912, $dca0ddb82b882518$var$deferHiddenOffscreenComponent(current, workInProgress, null !== prevState ? prevState.baseLanes | renderLanes : renderLanes, renderLanes, nextProps);
    } else null !== prevState ? ($dca0ddb82b882518$var$pushTransition(workInProgress, prevState.cachePool), $dca0ddb82b882518$var$pushHiddenContext(workInProgress, prevState), $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(), workInProgress.memoizedState = null) : (null !== current && $dca0ddb82b882518$var$pushTransition(workInProgress, null), $dca0ddb82b882518$var$reuseHiddenContextOnStack(), $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack());
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
function $dca0ddb82b882518$var$bailoutOffscreenComponent(current, workInProgress) {
    null !== current && 22 === current.tag || null !== workInProgress.stateNode || (workInProgress.stateNode = {
        _visibility: 1,
        _pendingMarkers: null,
        _retryCache: null,
        _transitions: null
    });
    return workInProgress.sibling;
}
function $dca0ddb82b882518$var$deferHiddenOffscreenComponent(current, workInProgress, nextBaseLanes, renderLanes, remainingChildLanes) {
    var JSCompiler_inline_result = $dca0ddb82b882518$var$peekCacheFromPool();
    JSCompiler_inline_result = null === JSCompiler_inline_result ? null : {
        parent: $dca0ddb82b882518$var$CacheContext._currentValue,
        pool: JSCompiler_inline_result
    };
    workInProgress.memoizedState = {
        baseLanes: nextBaseLanes,
        cachePool: JSCompiler_inline_result
    };
    null !== current && $dca0ddb82b882518$var$pushTransition(workInProgress, null);
    $dca0ddb82b882518$var$reuseHiddenContextOnStack();
    $dca0ddb82b882518$var$pushOffscreenSuspenseHandler(workInProgress);
    null !== current && $dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, !0);
    workInProgress.childLanes = remainingChildLanes;
    return null;
}
function $dca0ddb82b882518$var$mountActivityChildren(workInProgress, nextProps) {
    nextProps = $dca0ddb82b882518$var$mountWorkInProgressOffscreenFiber({
        mode: nextProps.mode,
        children: nextProps.children
    }, workInProgress.mode);
    nextProps.ref = workInProgress.ref;
    workInProgress.child = nextProps;
    nextProps.return = workInProgress;
    return nextProps;
}
function $dca0ddb82b882518$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes) {
    $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes);
    current = $dca0ddb82b882518$var$mountActivityChildren(workInProgress, workInProgress.pendingProps);
    current.flags |= 2;
    $dca0ddb82b882518$var$popSuspenseHandler(workInProgress);
    workInProgress.memoizedState = null;
    return current;
}
function $dca0ddb82b882518$var$updateActivityComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, didSuspend = 0 !== (workInProgress.flags & 128);
    workInProgress.flags &= -129;
    if (null === current) {
        if ($dca0ddb82b882518$var$isHydrating) {
            if ("hidden" === nextProps.mode) return current = $dca0ddb82b882518$var$mountActivityChildren(workInProgress, nextProps), workInProgress.lanes = 536870912, current.memoizedState = {
                baseLanes: 0,
                cachePool: null
            }, $dca0ddb82b882518$var$bailoutOffscreenComponent(null, current);
            $dca0ddb82b882518$var$pushDehydratedActivitySuspenseHandler(workInProgress);
            (current = $dca0ddb82b882518$var$nextHydratableInstance) ? (current = $dca0ddb82b882518$var$canHydrateHydrationBoundary(current, $dca0ddb82b882518$var$rootOrSingletonContext), current = null !== current && "&" === current.data ? current : null, null !== current && (workInProgress.memoizedState = {
                dehydrated: current,
                treeContext: null !== $dca0ddb82b882518$var$treeContextProvider ? {
                    id: $dca0ddb82b882518$var$treeContextId,
                    overflow: $dca0ddb82b882518$var$treeContextOverflow
                } : null,
                retryLane: 536870912,
                hydrationErrors: null
            }, renderLanes = $dca0ddb82b882518$var$createFiberFromDehydratedFragment(current), renderLanes.return = workInProgress, workInProgress.child = renderLanes, $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$nextHydratableInstance = null)) : current = null;
            if (null === current) throw $dca0ddb82b882518$var$throwOnHydrationMismatch(workInProgress);
            workInProgress.lanes = 536870912;
            return null;
        }
        return $dca0ddb82b882518$var$mountActivityChildren(workInProgress, nextProps);
    }
    var prevState = current.memoizedState;
    if (null !== prevState) {
        var dehydrated = prevState.dehydrated;
        $dca0ddb82b882518$var$pushDehydratedActivitySuspenseHandler(workInProgress);
        if (didSuspend) {
            if (workInProgress.flags & 256) workInProgress.flags &= -257, workInProgress = $dca0ddb82b882518$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes);
            else if (null !== workInProgress.memoizedState) workInProgress.child = current.child, workInProgress.flags |= 128, workInProgress = null;
            else throw Error($dca0ddb82b882518$var$formatProdErrorMessage(558));
        } else if ($dca0ddb82b882518$var$didReceiveUpdate || $dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), didSuspend = 0 !== (renderLanes & current.childLanes), $dca0ddb82b882518$var$didReceiveUpdate || didSuspend) {
            if (null === $dca0ddb82b882518$var$currentTreeHiddenStackCursor.current) {
                nextProps = $dca0ddb82b882518$var$workInProgressRoot;
                if (null !== nextProps && (dehydrated = $dca0ddb82b882518$var$getBumpedLaneForHydration(nextProps, renderLanes), 0 !== dehydrated && dehydrated !== prevState.retryLane)) throw prevState.retryLane = dehydrated, $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(current, dehydrated), $dca0ddb82b882518$var$scheduleUpdateOnFiber(nextProps, current, dehydrated), $dca0ddb82b882518$var$SelectiveHydrationException;
                $dca0ddb82b882518$var$renderDidSuspendDelayIfPossible();
            }
            workInProgress = $dca0ddb82b882518$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else current = prevState.treeContext, $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(dehydrated.nextSibling), $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$isHydrating = !0, $dca0ddb82b882518$var$hydrationErrors = null, $dca0ddb82b882518$var$rootOrSingletonContext = !1, null !== current && $dca0ddb82b882518$var$restoreSuspendedTreeContext(workInProgress, current), workInProgress = $dca0ddb82b882518$var$mountActivityChildren(workInProgress, nextProps), workInProgress.flags |= 134221824;
        return workInProgress;
    }
    current = $dca0ddb82b882518$var$createWorkInProgress(current.child, {
        mode: nextProps.mode,
        children: nextProps.children
    });
    current.ref = workInProgress.ref;
    workInProgress.child = current;
    current.return = workInProgress;
    return current;
}
function $dca0ddb82b882518$var$markRef(current, workInProgress) {
    var ref = workInProgress.ref;
    if (null === ref) null !== current && null !== current.ref && (workInProgress.flags |= 4194816);
    else {
        if ("function" !== typeof ref && "object" !== typeof ref) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(284));
        if (null === current || current.ref !== ref) workInProgress.flags |= 4194816;
    }
}
function $dca0ddb82b882518$var$updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes) {
    $dca0ddb82b882518$var$prepareToReadContext(workInProgress);
    Component = $dca0ddb82b882518$var$renderWithHooks(current, workInProgress, Component, nextProps, void 0, renderLanes);
    nextProps = $dca0ddb82b882518$var$checkDidRenderIdHook();
    if (null !== current && !$dca0ddb82b882518$var$didReceiveUpdate) return $dca0ddb82b882518$var$bailoutHooks(current, workInProgress, renderLanes), $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $dca0ddb82b882518$var$isHydrating && nextProps && $dca0ddb82b882518$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, Component, renderLanes);
    return workInProgress.child;
}
function $dca0ddb82b882518$var$replayFunctionComponent(current, workInProgress, nextProps, Component, secondArg, renderLanes) {
    $dca0ddb82b882518$var$prepareToReadContext(workInProgress);
    workInProgress.updateQueue = null;
    nextProps = $dca0ddb82b882518$var$renderWithHooksAgain(workInProgress, Component, nextProps, secondArg);
    $dca0ddb82b882518$var$finishRenderingHooks(current);
    Component = $dca0ddb82b882518$var$checkDidRenderIdHook();
    if (null !== current && !$dca0ddb82b882518$var$didReceiveUpdate) return $dca0ddb82b882518$var$bailoutHooks(current, workInProgress, renderLanes), $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $dca0ddb82b882518$var$isHydrating && Component && $dca0ddb82b882518$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function $dca0ddb82b882518$var$updateClassComponent(current, workInProgress, Component, nextProps, renderLanes) {
    $dca0ddb82b882518$var$prepareToReadContext(workInProgress);
    if (null === workInProgress.stateNode) {
        var context = $dca0ddb82b882518$var$emptyContextObject, contextType = Component.contextType;
        "object" === typeof contextType && null !== contextType && (context = $dca0ddb82b882518$var$readContext(contextType));
        context = new Component(nextProps, context);
        workInProgress.memoizedState = null !== context.state && void 0 !== context.state ? context.state : null;
        context.updater = $dca0ddb82b882518$var$classComponentUpdater;
        workInProgress.stateNode = context;
        context._reactInternals = workInProgress;
        context = workInProgress.stateNode;
        context.props = nextProps;
        context.state = workInProgress.memoizedState;
        context.refs = {};
        $dca0ddb82b882518$var$initializeUpdateQueue(workInProgress);
        contextType = Component.contextType;
        context.context = "object" === typeof contextType && null !== contextType ? $dca0ddb82b882518$var$readContext(contextType) : $dca0ddb82b882518$var$emptyContextObject;
        context.state = workInProgress.memoizedState;
        contextType = Component.getDerivedStateFromProps;
        "function" === typeof contextType && ($dca0ddb82b882518$var$applyDerivedStateFromProps(workInProgress, Component, contextType, nextProps), context.state = workInProgress.memoizedState);
        "function" === typeof Component.getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || (contextType = context.state, "function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount(), contextType !== context.state && $dca0ddb82b882518$var$classComponentUpdater.enqueueReplaceState(context, context.state, null), $dca0ddb82b882518$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes), $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction(), context.state = workInProgress.memoizedState);
        "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308);
        nextProps = !0;
    } else if (null === current) {
        context = workInProgress.stateNode;
        var unresolvedOldProps = workInProgress.memoizedProps, oldProps = $dca0ddb82b882518$var$resolveClassComponentProps(Component, unresolvedOldProps);
        context.props = oldProps;
        var oldContext = context.context, contextType$jscomp$0 = Component.contextType;
        contextType = $dca0ddb82b882518$var$emptyContextObject;
        "object" === typeof contextType$jscomp$0 && null !== contextType$jscomp$0 && (contextType = $dca0ddb82b882518$var$readContext(contextType$jscomp$0));
        var getDerivedStateFromProps = Component.getDerivedStateFromProps;
        contextType$jscomp$0 = "function" === typeof getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate;
        unresolvedOldProps = workInProgress.pendingProps !== unresolvedOldProps;
        contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (unresolvedOldProps || oldContext !== contextType) && $dca0ddb82b882518$var$callComponentWillReceiveProps(workInProgress, context, nextProps, contextType);
        $dca0ddb82b882518$var$hasForceUpdate = !1;
        var oldState = workInProgress.memoizedState;
        context.state = oldState;
        $dca0ddb82b882518$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction();
        oldContext = workInProgress.memoizedState;
        unresolvedOldProps || oldState !== oldContext || $dca0ddb82b882518$var$hasForceUpdate ? ("function" === typeof getDerivedStateFromProps && ($dca0ddb82b882518$var$applyDerivedStateFromProps(workInProgress, Component, getDerivedStateFromProps, nextProps), oldContext = workInProgress.memoizedState), (oldProps = $dca0ddb82b882518$var$hasForceUpdate || $dca0ddb82b882518$var$checkShouldComponentUpdate(workInProgress, Component, oldProps, nextProps, oldState, oldContext, contextType)) ? (contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || ("function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount()), "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308)) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = oldContext), context.props = nextProps, context.state = oldContext, context.context = contextType, nextProps = oldProps) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), nextProps = !1);
    } else {
        context = workInProgress.stateNode;
        $dca0ddb82b882518$var$cloneUpdateQueue(current, workInProgress);
        contextType = workInProgress.memoizedProps;
        contextType$jscomp$0 = $dca0ddb82b882518$var$resolveClassComponentProps(Component, contextType);
        context.props = contextType$jscomp$0;
        getDerivedStateFromProps = workInProgress.pendingProps;
        oldState = context.context;
        oldContext = Component.contextType;
        oldProps = $dca0ddb82b882518$var$emptyContextObject;
        "object" === typeof oldContext && null !== oldContext && (oldProps = $dca0ddb82b882518$var$readContext(oldContext));
        unresolvedOldProps = Component.getDerivedStateFromProps;
        (oldContext = "function" === typeof unresolvedOldProps || "function" === typeof context.getSnapshotBeforeUpdate) || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (contextType !== getDerivedStateFromProps || oldState !== oldProps) && $dca0ddb82b882518$var$callComponentWillReceiveProps(workInProgress, context, nextProps, oldProps);
        $dca0ddb82b882518$var$hasForceUpdate = !1;
        oldState = workInProgress.memoizedState;
        context.state = oldState;
        $dca0ddb82b882518$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction();
        var newState = workInProgress.memoizedState;
        contextType !== getDerivedStateFromProps || oldState !== newState || $dca0ddb82b882518$var$hasForceUpdate || null !== current && null !== current.dependencies && $dca0ddb82b882518$var$checkIfContextChanged(current.dependencies) ? ("function" === typeof unresolvedOldProps && ($dca0ddb82b882518$var$applyDerivedStateFromProps(workInProgress, Component, unresolvedOldProps, nextProps), newState = workInProgress.memoizedState), (contextType$jscomp$0 = $dca0ddb82b882518$var$hasForceUpdate || $dca0ddb82b882518$var$checkShouldComponentUpdate(workInProgress, Component, contextType$jscomp$0, nextProps, oldState, newState, oldProps) || null !== current && null !== current.dependencies && $dca0ddb82b882518$var$checkIfContextChanged(current.dependencies)) ? (oldContext || "function" !== typeof context.UNSAFE_componentWillUpdate && "function" !== typeof context.componentWillUpdate || ("function" === typeof context.componentWillUpdate && context.componentWillUpdate(nextProps, newState, oldProps), "function" === typeof context.UNSAFE_componentWillUpdate && context.UNSAFE_componentWillUpdate(nextProps, newState, oldProps)), "function" === typeof context.componentDidUpdate && (workInProgress.flags |= 4), "function" === typeof context.getSnapshotBeforeUpdate && (workInProgress.flags |= 1024)) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = newState), context.props = nextProps, context.state = newState, context.context = oldProps, nextProps = contextType$jscomp$0) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), nextProps = !1);
    }
    context = nextProps;
    $dca0ddb82b882518$var$markRef(current, workInProgress);
    nextProps = 0 !== (workInProgress.flags & 128);
    context || nextProps ? (context = workInProgress.stateNode, Component = nextProps && "function" !== typeof Component.getDerivedStateFromError ? null : context.render(), workInProgress.flags |= 1, null !== current && nextProps ? (workInProgress.child = $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes), workInProgress.child = $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, null, Component, renderLanes)) : $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, Component, renderLanes), workInProgress.memoizedState = context.state, current = workInProgress.child) : current = $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    return current;
}
function $dca0ddb82b882518$var$mountHostRootWithoutHydrating(current, workInProgress, nextChildren, renderLanes) {
    $dca0ddb82b882518$var$resetHydrationState();
    workInProgress.flags |= 256;
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
var $dca0ddb82b882518$var$SUSPENDED_MARKER = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0,
    hydrationErrors: null
};
function $dca0ddb82b882518$var$mountSuspenseOffscreenState(renderLanes) {
    return {
        baseLanes: renderLanes,
        cachePool: $dca0ddb82b882518$var$getSuspendedCache()
    };
}
function $dca0ddb82b882518$var$getRemainingWorkInPrimaryTree(current, primaryTreeDidDefer, renderLanes) {
    current = null !== current ? current.childLanes & ~renderLanes : 0;
    primaryTreeDidDefer && (current |= $dca0ddb82b882518$var$workInProgressDeferredLane);
    return current;
}
function $dca0ddb82b882518$var$updateSuspenseComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, showFallback = !1, didSuspend = 0 !== (workInProgress.flags & 128), JSCompiler_temp;
    (JSCompiler_temp = didSuspend) || (JSCompiler_temp = null !== current && null === current.memoizedState ? !1 : 0 !== ($dca0ddb82b882518$var$suspenseStackCursor.current & 2));
    JSCompiler_temp && (showFallback = !0, workInProgress.flags &= -129);
    JSCompiler_temp = 0 !== (workInProgress.flags & 32);
    workInProgress.flags &= -33;
    if (null === current) {
        if ($dca0ddb82b882518$var$isHydrating) {
            showFallback ? $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress) : $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack();
            (current = $dca0ddb82b882518$var$nextHydratableInstance) ? (current = $dca0ddb82b882518$var$canHydrateHydrationBoundary(current, $dca0ddb82b882518$var$rootOrSingletonContext), current = null !== current && "&" !== current.data ? current : null, null !== current && (workInProgress.memoizedState = {
                dehydrated: current,
                treeContext: null !== $dca0ddb82b882518$var$treeContextProvider ? {
                    id: $dca0ddb82b882518$var$treeContextId,
                    overflow: $dca0ddb82b882518$var$treeContextOverflow
                } : null,
                retryLane: 536870912,
                hydrationErrors: null
            }, renderLanes = $dca0ddb82b882518$var$createFiberFromDehydratedFragment(current), renderLanes.return = workInProgress, workInProgress.child = renderLanes, $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$nextHydratableInstance = null)) : current = null;
            if (null === current) throw $dca0ddb82b882518$var$throwOnHydrationMismatch(workInProgress);
            $dca0ddb82b882518$var$isSuspenseInstanceFallback(current) ? workInProgress.lanes = 32 : workInProgress.lanes = 536870912;
            return null;
        }
        didSuspend = nextProps.children;
        nextProps = nextProps.fallback;
        if (showFallback) return $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(), showFallback = workInProgress.mode, didSuspend = $dca0ddb82b882518$var$mountWorkInProgressOffscreenFiber({
            mode: "hidden",
            children: didSuspend
        }, showFallback), nextProps = $dca0ddb82b882518$var$createFiberFromFragment(nextProps, showFallback, renderLanes, null), didSuspend.return = workInProgress, nextProps.return = workInProgress, didSuspend.sibling = nextProps, workInProgress.child = didSuspend, nextProps = workInProgress.child, nextProps.memoizedState = $dca0ddb82b882518$var$mountSuspenseOffscreenState(renderLanes), nextProps.childLanes = $dca0ddb82b882518$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $dca0ddb82b882518$var$SUSPENDED_MARKER, $dca0ddb82b882518$var$bailoutOffscreenComponent(null, nextProps);
        $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress);
        return $dca0ddb82b882518$var$mountSuspensePrimaryChildren(workInProgress, didSuspend);
    }
    var prevState = current.memoizedState;
    if (null !== prevState) {
        var dehydrated$96 = prevState.dehydrated;
        if (null !== dehydrated$96) return $dca0ddb82b882518$var$updateDehydratedSuspenseComponent(current, workInProgress, didSuspend, JSCompiler_temp, nextProps, dehydrated$96, prevState, renderLanes);
    }
    if (showFallback) return $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(), showFallback = nextProps.fallback, didSuspend = workInProgress.mode, prevState = current.child, dehydrated$96 = prevState.sibling, nextProps = $dca0ddb82b882518$var$createWorkInProgress(prevState, {
        mode: "hidden",
        children: nextProps.children
    }), nextProps.subtreeFlags = prevState.subtreeFlags & 1206910976, null !== dehydrated$96 ? showFallback = $dca0ddb82b882518$var$createWorkInProgress(dehydrated$96, showFallback) : (showFallback = $dca0ddb82b882518$var$createFiberFromFragment(showFallback, didSuspend, renderLanes, null), showFallback.flags |= 2), showFallback.return = workInProgress, nextProps.return = workInProgress, nextProps.sibling = showFallback, workInProgress.child = nextProps, $dca0ddb82b882518$var$bailoutOffscreenComponent(null, nextProps), nextProps = workInProgress.child, showFallback = current.child.memoizedState, null === showFallback ? showFallback = $dca0ddb82b882518$var$mountSuspenseOffscreenState(renderLanes) : (didSuspend = showFallback.cachePool, null !== didSuspend ? (prevState = $dca0ddb82b882518$var$CacheContext._currentValue, didSuspend = didSuspend.parent !== prevState ? {
        parent: prevState,
        pool: prevState
    } : didSuspend) : didSuspend = $dca0ddb82b882518$var$getSuspendedCache(), showFallback = {
        baseLanes: showFallback.baseLanes | renderLanes,
        cachePool: didSuspend
    }), nextProps.memoizedState = showFallback, nextProps.childLanes = $dca0ddb82b882518$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $dca0ddb82b882518$var$SUSPENDED_MARKER, $dca0ddb82b882518$var$bailoutOffscreenComponent(current.child, nextProps);
    $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress);
    renderLanes = current.child;
    current = renderLanes.sibling;
    renderLanes = $dca0ddb82b882518$var$createWorkInProgress(renderLanes, {
        mode: "visible",
        children: nextProps.children
    });
    renderLanes.return = workInProgress;
    renderLanes.sibling = null;
    null !== current && (JSCompiler_temp = workInProgress.deletions, null === JSCompiler_temp ? (workInProgress.deletions = [
        current
    ], workInProgress.flags |= 16) : JSCompiler_temp.push(current));
    workInProgress.child = renderLanes;
    workInProgress.memoizedState = null;
    return renderLanes;
}
function $dca0ddb82b882518$var$mountSuspensePrimaryChildren(workInProgress, primaryChildren) {
    primaryChildren = $dca0ddb82b882518$var$mountWorkInProgressOffscreenFiber({
        mode: "visible",
        children: primaryChildren
    }, workInProgress.mode);
    primaryChildren.return = workInProgress;
    return workInProgress.child = primaryChildren;
}
function $dca0ddb82b882518$var$mountWorkInProgressOffscreenFiber(offscreenProps, mode) {
    offscreenProps = $dca0ddb82b882518$var$createFiberImplClass(22, offscreenProps, null, mode);
    offscreenProps.lanes = 0;
    return offscreenProps;
}
function $dca0ddb82b882518$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes) {
    $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes);
    current = $dca0ddb82b882518$var$mountSuspensePrimaryChildren(workInProgress, workInProgress.pendingProps.children);
    current.flags |= 2;
    workInProgress.memoizedState = null;
    return current;
}
function $dca0ddb82b882518$var$updateDehydratedSuspenseComponent(current, workInProgress, didSuspend, didPrimaryChildrenDefer, nextProps, suspenseInstance, suspenseState, renderLanes) {
    if (didSuspend) {
        if (workInProgress.flags & 256) return $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags &= -257, $dca0ddb82b882518$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        if (null !== workInProgress.memoizedState) return $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack(), workInProgress.child = current.child, workInProgress.flags |= 128, null;
        $dca0ddb82b882518$var$reuseSuspenseHandlerOnStack();
        suspenseInstance = nextProps.fallback;
        suspenseState = workInProgress.mode;
        nextProps = $dca0ddb82b882518$var$mountWorkInProgressOffscreenFiber({
            mode: "visible",
            children: nextProps.children
        }, suspenseState);
        suspenseInstance = $dca0ddb82b882518$var$createFiberFromFragment(suspenseInstance, suspenseState, renderLanes, null);
        suspenseInstance.flags |= 2;
        nextProps.return = workInProgress;
        suspenseInstance.return = workInProgress;
        nextProps.sibling = suspenseInstance;
        workInProgress.child = nextProps;
        $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes);
        nextProps = workInProgress.child;
        nextProps.memoizedState = $dca0ddb82b882518$var$mountSuspenseOffscreenState(renderLanes);
        nextProps.childLanes = $dca0ddb82b882518$var$getRemainingWorkInPrimaryTree(current, didPrimaryChildrenDefer, renderLanes);
        workInProgress.memoizedState = $dca0ddb82b882518$var$SUSPENDED_MARKER;
        return $dca0ddb82b882518$var$bailoutOffscreenComponent(null, nextProps);
    }
    $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress);
    if ($dca0ddb82b882518$var$isSuspenseInstanceFallback(suspenseInstance)) {
        didPrimaryChildrenDefer = suspenseInstance.nextSibling && suspenseInstance.nextSibling.dataset;
        if (didPrimaryChildrenDefer) var digest = didPrimaryChildrenDefer.dgst;
        didPrimaryChildrenDefer = digest;
        "" !== didPrimaryChildrenDefer && (nextProps = Error($dca0ddb82b882518$var$formatProdErrorMessage(419)), nextProps.stack = "", nextProps.digest = didPrimaryChildrenDefer, $dca0ddb82b882518$var$queueHydrationError({
            value: nextProps,
            source: null,
            stack: null
        }));
        return $dca0ddb82b882518$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
    }
    $dca0ddb82b882518$var$didReceiveUpdate || $dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1);
    didPrimaryChildrenDefer = 0 !== (renderLanes & current.childLanes);
    if ($dca0ddb82b882518$var$didReceiveUpdate || didPrimaryChildrenDefer) {
        if (null !== $dca0ddb82b882518$var$currentTreeHiddenStackCursor.current) return $dca0ddb82b882518$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        didPrimaryChildrenDefer = $dca0ddb82b882518$var$workInProgressRoot;
        if (null !== didPrimaryChildrenDefer && (nextProps = $dca0ddb82b882518$var$getBumpedLaneForHydration(didPrimaryChildrenDefer, renderLanes), 0 !== nextProps && nextProps !== suspenseState.retryLane)) throw suspenseState.retryLane = nextProps, $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(current, nextProps), $dca0ddb82b882518$var$scheduleUpdateOnFiber(didPrimaryChildrenDefer, current, nextProps), $dca0ddb82b882518$var$SelectiveHydrationException;
        $dca0ddb82b882518$var$isSuspenseInstancePending(suspenseInstance) || $dca0ddb82b882518$var$renderDidSuspendDelayIfPossible();
        return $dca0ddb82b882518$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
    }
    if ($dca0ddb82b882518$var$isSuspenseInstancePending(suspenseInstance)) return workInProgress.flags |= 192, workInProgress.child = current.child, null;
    current = suspenseState.treeContext;
    $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(suspenseInstance.nextSibling);
    $dca0ddb82b882518$var$hydrationParentFiber = workInProgress;
    $dca0ddb82b882518$var$isHydrating = !0;
    $dca0ddb82b882518$var$hydrationErrors = null;
    $dca0ddb82b882518$var$rootOrSingletonContext = !1;
    null !== current && $dca0ddb82b882518$var$restoreSuspendedTreeContext(workInProgress, current);
    workInProgress = $dca0ddb82b882518$var$mountSuspensePrimaryChildren(workInProgress, nextProps.children);
    workInProgress.flags |= 134221824;
    return workInProgress;
}
function $dca0ddb82b882518$var$scheduleSuspenseWorkOnFiber(fiber, renderLanes, propagationRoot) {
    fiber.lanes |= renderLanes;
    var alternate = fiber.alternate;
    null !== alternate && (alternate.lanes |= renderLanes);
    $dca0ddb82b882518$var$scheduleContextWorkOnParentPath(fiber.return, renderLanes, propagationRoot);
}
function $dca0ddb82b882518$var$findLastContentRow(firstChild) {
    for(var lastContentRow = null; null !== firstChild;){
        var currentRow = firstChild.alternate;
        null !== currentRow && null === $dca0ddb82b882518$var$findFirstSuspended(currentRow) && (lastContentRow = firstChild);
        firstChild = firstChild.sibling;
    }
    return lastContentRow;
}
function $dca0ddb82b882518$var$initSuspenseListRenderState(workInProgress, isBackwards, tail, lastContentRow, tailMode, treeForkCount) {
    var renderState = workInProgress.memoizedState;
    null === renderState ? workInProgress.memoizedState = {
        isBackwards: isBackwards,
        rendering: null,
        renderingStartTime: 0,
        last: lastContentRow,
        tail: tail,
        tailMode: tailMode,
        treeForkCount: treeForkCount
    } : (renderState.isBackwards = isBackwards, renderState.rendering = null, renderState.renderingStartTime = 0, renderState.last = lastContentRow, renderState.tail = tail, renderState.tailMode = tailMode, renderState.treeForkCount = treeForkCount);
}
function $dca0ddb82b882518$var$reverseChildren(fiber) {
    var row = fiber.child;
    for(fiber.child = null; null !== row;){
        var nextRow = row.sibling;
        row.sibling = fiber.child;
        fiber.child = row;
        row = nextRow;
    }
}
function $dca0ddb82b882518$var$updateSuspenseListComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, revealOrder = nextProps.revealOrder, tailMode = nextProps.tail;
    nextProps = nextProps.children;
    var suspenseContext = $dca0ddb82b882518$var$suspenseStackCursor.current;
    if (workInProgress.flags & 128) return $dca0ddb82b882518$var$pushSuspenseListContext(workInProgress, suspenseContext), null;
    var shouldForceFallback = 0 !== (suspenseContext & 2);
    shouldForceFallback ? (suspenseContext = suspenseContext & 1 | 2, workInProgress.flags |= 128) : suspenseContext &= 1;
    $dca0ddb82b882518$var$pushSuspenseListContext(workInProgress, suspenseContext);
    "backwards" === revealOrder && null !== current ? ($dca0ddb82b882518$var$reverseChildren(current), $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextProps, renderLanes), $dca0ddb82b882518$var$reverseChildren(current)) : $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    nextProps = $dca0ddb82b882518$var$isHydrating ? $dca0ddb82b882518$var$treeForkCount : 0;
    if (!shouldForceFallback && null !== current && 0 !== (current.flags & 128)) a: for(current = workInProgress.child; null !== current;){
        if (13 === current.tag) null !== current.memoizedState && $dca0ddb82b882518$var$scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
        else if (19 === current.tag) $dca0ddb82b882518$var$scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
        else if (null !== current.child) {
            current.child.return = current;
            current = current.child;
            continue;
        }
        if (current === workInProgress) break a;
        for(; null === current.sibling;){
            if (null === current.return || current.return === workInProgress) break a;
            current = current.return;
        }
        current.sibling.return = current.return;
        current = current.sibling;
    }
    switch(revealOrder){
        case "backwards":
            renderLanes = $dca0ddb82b882518$var$findLastContentRow(workInProgress.child);
            null === renderLanes ? (revealOrder = workInProgress.child, workInProgress.child = null) : (revealOrder = renderLanes.sibling, renderLanes.sibling = null, $dca0ddb82b882518$var$reverseChildren(workInProgress));
            $dca0ddb82b882518$var$initSuspenseListRenderState(workInProgress, !0, revealOrder, null, tailMode, nextProps);
            break;
        case "unstable_legacy-backwards":
            renderLanes = null;
            revealOrder = workInProgress.child;
            for(workInProgress.child = null; null !== revealOrder;){
                current = revealOrder.alternate;
                if (null !== current && null === $dca0ddb82b882518$var$findFirstSuspended(current)) {
                    workInProgress.child = revealOrder;
                    break;
                }
                current = revealOrder.sibling;
                revealOrder.sibling = renderLanes;
                renderLanes = revealOrder;
                revealOrder = current;
            }
            $dca0ddb82b882518$var$initSuspenseListRenderState(workInProgress, !0, renderLanes, null, tailMode, nextProps);
            break;
        case "together":
            $dca0ddb82b882518$var$initSuspenseListRenderState(workInProgress, !1, null, null, void 0, nextProps);
            break;
        case "independent":
            workInProgress.memoizedState = null;
            break;
        default:
            renderLanes = $dca0ddb82b882518$var$findLastContentRow(workInProgress.child), null === renderLanes ? (revealOrder = workInProgress.child, workInProgress.child = null) : (revealOrder = renderLanes.sibling, renderLanes.sibling = null), $dca0ddb82b882518$var$initSuspenseListRenderState(workInProgress, !1, revealOrder, renderLanes, tailMode, nextProps);
    }
    return workInProgress.child;
}
function $dca0ddb82b882518$var$updateContextProvider(current, workInProgress, renderLanes) {
    var newProps = workInProgress.pendingProps;
    $dca0ddb82b882518$var$pushProvider(workInProgress, workInProgress.type, newProps.value);
    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, newProps.children, renderLanes);
    return workInProgress.child;
}
function $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes) {
    null !== current && (workInProgress.dependencies = current.dependencies);
    $dca0ddb82b882518$var$workInProgressRootSkippedLanes |= workInProgress.lanes;
    if (0 === (renderLanes & workInProgress.childLanes)) {
        if (null !== current) {
            if ($dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), 0 === (renderLanes & workInProgress.childLanes)) return null;
        } else return null;
    }
    if (null !== current && workInProgress.child !== current.child) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(153));
    if (null !== workInProgress.child) {
        current = workInProgress.child;
        renderLanes = $dca0ddb82b882518$var$createWorkInProgress(current, current.pendingProps);
        workInProgress.child = renderLanes;
        for(renderLanes.return = workInProgress; null !== current.sibling;)current = current.sibling, renderLanes = renderLanes.sibling = $dca0ddb82b882518$var$createWorkInProgress(current, current.pendingProps), renderLanes.return = workInProgress;
        renderLanes.sibling = null;
    }
    return workInProgress.child;
}
function $dca0ddb82b882518$var$checkScheduledUpdateOrContext(current, renderLanes) {
    if (0 !== (current.lanes & renderLanes)) return !0;
    current = current.dependencies;
    return null !== current && $dca0ddb82b882518$var$checkIfContextChanged(current) ? !0 : !1;
}
function $dca0ddb82b882518$var$attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes) {
    switch(workInProgress.tag){
        case 3:
            $dca0ddb82b882518$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, current.memoizedState.cache);
            $dca0ddb82b882518$var$resetHydrationState();
            break;
        case 27:
        case 5:
            $dca0ddb82b882518$var$pushHostContext(workInProgress);
            break;
        case 4:
            $dca0ddb82b882518$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            break;
        case 10:
            $dca0ddb82b882518$var$pushProvider(workInProgress, workInProgress.type, workInProgress.memoizedProps.value);
            break;
        case 31:
            if (null !== workInProgress.memoizedState) return workInProgress.flags |= 128, $dca0ddb82b882518$var$pushDehydratedActivitySuspenseHandler(workInProgress), null;
            break;
        case 13:
            var state$108 = workInProgress.memoizedState;
            if (null !== state$108) {
                if (null !== state$108.dehydrated) return $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags |= 128, null;
                state$108 = $dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1);
                var primaryChildLanes = workInProgress.child.childLanes;
                if (state$108 || 0 !== (renderLanes & primaryChildLanes)) return $dca0ddb82b882518$var$updateSuspenseComponent(current, workInProgress, renderLanes);
                $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress);
                current = $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                return null !== current ? current.sibling : null;
            }
            $dca0ddb82b882518$var$pushPrimaryTreeSuspenseHandler(workInProgress);
            break;
        case 19:
            if (workInProgress.flags & 128) return $dca0ddb82b882518$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
            primaryChildLanes = 0 !== (current.flags & 128);
            state$108 = 0 !== (renderLanes & workInProgress.childLanes);
            state$108 || ($dca0ddb82b882518$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), state$108 = 0 !== (renderLanes & workInProgress.childLanes));
            if (primaryChildLanes) {
                if (state$108) return $dca0ddb82b882518$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
                workInProgress.flags |= 128;
            }
            primaryChildLanes = workInProgress.memoizedState;
            null !== primaryChildLanes && (primaryChildLanes.rendering = null, primaryChildLanes.tail = null, primaryChildLanes.lastEffect = null);
            $dca0ddb82b882518$var$pushSuspenseListContext(workInProgress, $dca0ddb82b882518$var$suspenseStackCursor.current);
            if (state$108) break;
            else return null;
        case 22:
            return workInProgress.lanes = 0, $dca0ddb82b882518$var$updateOffscreenComponent(current, workInProgress, renderLanes, workInProgress.pendingProps);
        case 24:
            $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, current.memoizedState.cache);
    }
    return $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
}
function $dca0ddb82b882518$var$beginWork(current, workInProgress, renderLanes) {
    if (null !== current) {
        if (current.memoizedProps !== workInProgress.pendingProps) $dca0ddb82b882518$var$didReceiveUpdate = !0;
        else {
            if (!$dca0ddb82b882518$var$checkScheduledUpdateOrContext(current, renderLanes) && 0 === (workInProgress.flags & 128)) return $dca0ddb82b882518$var$didReceiveUpdate = !1, $dca0ddb82b882518$var$attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes);
            $dca0ddb82b882518$var$didReceiveUpdate = 0 !== (current.flags & 131072) ? !0 : !1;
        }
    } else $dca0ddb82b882518$var$didReceiveUpdate = !1, $dca0ddb82b882518$var$isHydrating && 0 !== (workInProgress.flags & 1048576) && $dca0ddb82b882518$var$pushTreeId(workInProgress, $dca0ddb82b882518$var$treeForkCount, workInProgress.index);
    workInProgress.lanes = 0;
    switch(workInProgress.tag){
        case 16:
            a: {
                var props = workInProgress.pendingProps;
                current = $dca0ddb82b882518$var$resolveLazy(workInProgress.elementType);
                workInProgress.type = current;
                if ("function" === typeof current) $dca0ddb82b882518$var$shouldConstruct(current) ? (props = $dca0ddb82b882518$var$resolveClassComponentProps(current, props), workInProgress.tag = 1, workInProgress = $dca0ddb82b882518$var$updateClassComponent(null, workInProgress, current, props, renderLanes)) : (workInProgress.tag = 0, workInProgress = $dca0ddb82b882518$var$updateFunctionComponent(null, workInProgress, current, props, renderLanes));
                else {
                    if (void 0 !== current && null !== current) {
                        var $$typeof = current.$$typeof;
                        if ($$typeof === $dca0ddb82b882518$var$REACT_FORWARD_REF_TYPE) {
                            workInProgress.tag = 11;
                            workInProgress = $dca0ddb82b882518$var$updateForwardRef(null, workInProgress, current, props, renderLanes);
                            break a;
                        } else if ($$typeof === $dca0ddb82b882518$var$REACT_MEMO_TYPE) {
                            workInProgress.tag = 14;
                            workInProgress = $dca0ddb82b882518$var$updateMemoComponent(null, workInProgress, current, props, renderLanes);
                            break a;
                        } else if ($$typeof === $dca0ddb82b882518$var$REACT_CONTEXT_TYPE) {
                            workInProgress.tag = 10;
                            workInProgress.type = current;
                            workInProgress = $dca0ddb82b882518$var$updateContextProvider(null, workInProgress, renderLanes);
                            break a;
                        }
                    }
                    workInProgress = $dca0ddb82b882518$var$getComponentNameFromType(current) || current;
                    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(306, workInProgress, ""));
                }
            }
            return workInProgress;
        case 0:
            return $dca0ddb82b882518$var$updateFunctionComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 1:
            return props = workInProgress.type, $$typeof = $dca0ddb82b882518$var$resolveClassComponentProps(props, workInProgress.pendingProps), $dca0ddb82b882518$var$updateClassComponent(current, workInProgress, props, $$typeof, renderLanes);
        case 3:
            a: {
                $dca0ddb82b882518$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
                if (null === current) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(387));
                props = workInProgress.pendingProps;
                var prevState = workInProgress.memoizedState;
                $$typeof = prevState.element;
                $dca0ddb82b882518$var$cloneUpdateQueue(current, workInProgress);
                $dca0ddb82b882518$var$processUpdateQueue(workInProgress, props, null, renderLanes);
                var nextState = workInProgress.memoizedState;
                props = nextState.cache;
                $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, props);
                props !== prevState.cache && $dca0ddb82b882518$var$propagateContextChanges(workInProgress, [
                    $dca0ddb82b882518$var$CacheContext
                ], renderLanes, !0);
                $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction();
                props = nextState.element;
                if (prevState.isDehydrated) {
                    if (prevState = {
                        element: props,
                        isDehydrated: !1,
                        cache: nextState.cache
                    }, workInProgress.updateQueue.baseState = prevState, workInProgress.memoizedState = prevState, workInProgress.flags & 256) {
                        workInProgress = $dca0ddb82b882518$var$mountHostRootWithoutHydrating(current, workInProgress, props, renderLanes);
                        break a;
                    } else if (props !== $$typeof) {
                        $$typeof = $dca0ddb82b882518$var$createCapturedValueAtFiber(Error($dca0ddb82b882518$var$formatProdErrorMessage(424)), workInProgress);
                        $dca0ddb82b882518$var$queueHydrationError($$typeof);
                        workInProgress = $dca0ddb82b882518$var$mountHostRootWithoutHydrating(current, workInProgress, props, renderLanes);
                        break a;
                    } else {
                        current = workInProgress.stateNode.containerInfo;
                        switch(current.nodeType){
                            case 9:
                                current = current.body;
                                break;
                            default:
                                current = "HTML" === current.nodeName ? current.ownerDocument.body : current;
                        }
                        $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(current.firstChild);
                        $dca0ddb82b882518$var$hydrationParentFiber = workInProgress;
                        $dca0ddb82b882518$var$isHydrating = !0;
                        $dca0ddb82b882518$var$hydrationErrors = null;
                        $dca0ddb82b882518$var$rootOrSingletonContext = !0;
                        renderLanes = $dca0ddb82b882518$var$mountChildFibers(workInProgress, null, props, renderLanes);
                        for(workInProgress.child = renderLanes; renderLanes;)renderLanes.flags = renderLanes.flags & -3 | 134221824, renderLanes = renderLanes.sibling;
                    }
                } else {
                    $dca0ddb82b882518$var$resetHydrationState();
                    if (props === $$typeof) {
                        workInProgress = $dca0ddb82b882518$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                        break a;
                    }
                    $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, props, renderLanes);
                }
                workInProgress = workInProgress.child;
            }
            return workInProgress;
        case 26:
            return $dca0ddb82b882518$var$markRef(current, workInProgress), null === current ? (renderLanes = $dca0ddb82b882518$var$getResource(workInProgress.type, null, workInProgress.pendingProps, null)) ? workInProgress.memoizedState = renderLanes : $dca0ddb82b882518$var$isHydrating || (workInProgress.stateNode = $dca0ddb82b882518$var$createHoistableInstance(workInProgress.type, workInProgress.pendingProps, $dca0ddb82b882518$var$rootInstanceStackCursor.current, workInProgress)) : workInProgress.memoizedState = $dca0ddb82b882518$var$getResource(workInProgress.type, current.memoizedProps, workInProgress.pendingProps, current.memoizedState), null;
        case 27:
            return $dca0ddb82b882518$var$pushHostContext(workInProgress), null === current && $dca0ddb82b882518$var$isHydrating && (props = workInProgress.stateNode = $dca0ddb82b882518$var$resolveSingletonInstance(workInProgress.type, workInProgress.pendingProps, $dca0ddb82b882518$var$rootInstanceStackCursor.current), $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$rootOrSingletonContext = !0, $$typeof = $dca0ddb82b882518$var$nextHydratableInstance, $dca0ddb82b882518$var$isSingletonScope(workInProgress.type) ? ($dca0ddb82b882518$var$previousHydratableOnEnteringScopedSingleton = $$typeof, $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(props.firstChild)) : $dca0ddb82b882518$var$nextHydratableInstance = $$typeof), $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), $dca0ddb82b882518$var$markRef(current, workInProgress), null === current && (workInProgress.flags |= 4194304), workInProgress.child;
        case 5:
            if (null === current && $dca0ddb82b882518$var$isHydrating) {
                if ($$typeof = props = $dca0ddb82b882518$var$nextHydratableInstance) props = $dca0ddb82b882518$var$canHydrateInstance(props, workInProgress.type, workInProgress.pendingProps, $dca0ddb82b882518$var$rootOrSingletonContext), null !== props ? (workInProgress.stateNode = props, $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$nextHydratableInstance = $dca0ddb82b882518$var$getNextHydratable(props.firstChild), $dca0ddb82b882518$var$rootOrSingletonContext = !1, $$typeof = !0) : $$typeof = !1;
                $$typeof || $dca0ddb82b882518$var$throwOnHydrationMismatch(workInProgress);
            }
            $dca0ddb82b882518$var$pushHostContext(workInProgress);
            $$typeof = workInProgress.type;
            prevState = workInProgress.pendingProps;
            nextState = null !== current ? current.memoizedProps : null;
            props = prevState.children;
            $dca0ddb82b882518$var$shouldSetTextContent($$typeof, prevState) ? props = null : null !== nextState && $dca0ddb82b882518$var$shouldSetTextContent($$typeof, nextState) && (workInProgress.flags |= 32);
            null !== workInProgress.memoizedState && ($$typeof = $dca0ddb82b882518$var$renderWithHooks(current, workInProgress, $dca0ddb82b882518$var$TransitionAwareHostComponent, null, null, renderLanes), $dca0ddb82b882518$var$HostTransitionContext._currentValue = $$typeof);
            $dca0ddb82b882518$var$markRef(current, workInProgress);
            $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, props, renderLanes);
            return workInProgress.child;
        case 6:
            if (null === current && $dca0ddb82b882518$var$isHydrating) {
                if (current = renderLanes = $dca0ddb82b882518$var$nextHydratableInstance) renderLanes = $dca0ddb82b882518$var$canHydrateTextInstance(renderLanes, workInProgress.pendingProps, $dca0ddb82b882518$var$rootOrSingletonContext), null !== renderLanes ? (workInProgress.stateNode = renderLanes, $dca0ddb82b882518$var$hydrationParentFiber = workInProgress, $dca0ddb82b882518$var$nextHydratableInstance = null, current = !0) : current = !1;
                current || $dca0ddb82b882518$var$throwOnHydrationMismatch(workInProgress);
            }
            return null;
        case 13:
            return $dca0ddb82b882518$var$updateSuspenseComponent(current, workInProgress, renderLanes);
        case 4:
            return $dca0ddb82b882518$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo), props = workInProgress.pendingProps, null === current ? workInProgress.child = $dca0ddb82b882518$var$reconcileChildFibers(workInProgress, null, props, renderLanes) : $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, props, renderLanes), workInProgress.child;
        case 11:
            return $dca0ddb82b882518$var$updateForwardRef(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 7:
            return props = workInProgress.pendingProps, $dca0ddb82b882518$var$markRef(current, workInProgress), $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, props, renderLanes), workInProgress.child;
        case 8:
            return $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 12:
            return $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 10:
            return $dca0ddb82b882518$var$updateContextProvider(current, workInProgress, renderLanes);
        case 9:
            return $$typeof = workInProgress.type._context, props = workInProgress.pendingProps.children, $dca0ddb82b882518$var$prepareToReadContext(workInProgress), $$typeof = $dca0ddb82b882518$var$readContext($$typeof), props = props($$typeof), workInProgress.flags |= 1, $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, props, renderLanes), workInProgress.child;
        case 14:
            return $dca0ddb82b882518$var$updateMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 15:
            return $dca0ddb82b882518$var$updateSimpleMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 19:
            return $dca0ddb82b882518$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
        case 31:
            return $dca0ddb82b882518$var$updateActivityComponent(current, workInProgress, renderLanes);
        case 22:
            return $dca0ddb82b882518$var$updateOffscreenComponent(current, workInProgress, renderLanes, workInProgress.pendingProps);
        case 24:
            return $dca0ddb82b882518$var$prepareToReadContext(workInProgress), props = $dca0ddb82b882518$var$readContext($dca0ddb82b882518$var$CacheContext), null === current ? ($$typeof = $dca0ddb82b882518$var$peekCacheFromPool(), null === $$typeof && ($$typeof = $dca0ddb82b882518$var$workInProgressRoot, prevState = $dca0ddb82b882518$var$createCache(), $$typeof.pooledCache = prevState, prevState.refCount++, null !== prevState && ($$typeof.pooledCacheLanes |= renderLanes), $$typeof = prevState), workInProgress.memoizedState = {
                parent: props,
                cache: $$typeof
            }, $dca0ddb82b882518$var$initializeUpdateQueue(workInProgress), $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, $$typeof)) : (0 !== (current.lanes & renderLanes) && ($dca0ddb82b882518$var$cloneUpdateQueue(current, workInProgress), $dca0ddb82b882518$var$processUpdateQueue(workInProgress, null, null, renderLanes), $dca0ddb82b882518$var$suspendIfUpdateReadFromEntangledAsyncAction()), $$typeof = current.memoizedState, prevState = workInProgress.memoizedState, $$typeof.parent !== props ? ($$typeof = {
                parent: props,
                cache: props
            }, workInProgress.memoizedState = $$typeof, 0 === workInProgress.lanes && (workInProgress.memoizedState = workInProgress.updateQueue.baseState = $$typeof), $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, props)) : (props = prevState.cache, $dca0ddb82b882518$var$pushProvider(workInProgress, $dca0ddb82b882518$var$CacheContext, props), props !== $$typeof.cache && $dca0ddb82b882518$var$propagateContextChanges(workInProgress, [
                $dca0ddb82b882518$var$CacheContext
            ], renderLanes, !0))), $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 30:
            return null === workInProgress.stateNode && (workInProgress.stateNode = {
                autoName: null,
                paired: null,
                clones: null,
                ref: null
            }), props = workInProgress.pendingProps, null != props.name && "auto" !== props.name ? workInProgress.flags |= null === current ? 18882560 : 18874368 : $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushMaterializedTreeId(workInProgress), null !== current && current.memoizedProps.name !== props.name ? workInProgress.flags |= 4194816 : $dca0ddb82b882518$var$markRef(current, workInProgress), $dca0ddb82b882518$var$reconcileChildren(current, workInProgress, props.children, renderLanes), workInProgress.child;
        case 29:
            throw workInProgress.pendingProps;
    }
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(156, workInProgress.tag));
}
function $dca0ddb82b882518$var$markUpdate(workInProgress) {
    workInProgress.flags |= 4;
}
function $dca0ddb82b882518$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, oldProps, newProps, renderLanes) {
    var JSCompiler_temp;
    if (JSCompiler_temp = 0 !== (workInProgress.mode & 32)) JSCompiler_temp = null === oldProps ? $dca0ddb82b882518$var$maySuspendCommit(type, newProps) : $dca0ddb82b882518$var$maySuspendCommit(type, newProps) && (newProps.src !== oldProps.src || newProps.srcSet !== oldProps.srcSet);
    if (JSCompiler_temp) {
        if (workInProgress.flags |= 16777216, (renderLanes & 335544128) === renderLanes) {
            if (workInProgress.stateNode.complete) workInProgress.flags |= 8192;
            else if ($dca0ddb82b882518$var$shouldRemainOnPreviousScreen()) workInProgress.flags |= 8192;
            else throw $dca0ddb82b882518$var$suspendedThenable = $dca0ddb82b882518$var$noopSuspenseyCommitThenable, $dca0ddb82b882518$var$SuspenseyCommitException;
        }
    } else workInProgress.flags &= -16777217;
}
function $dca0ddb82b882518$var$preloadResourceAndSuspendIfNeeded(workInProgress, resource) {
    if ("stylesheet" !== resource.type || 0 !== (resource.state.loading & 4)) workInProgress.flags &= -16777217;
    else if (workInProgress.flags |= 16777216, !$dca0ddb82b882518$var$preloadResource(resource)) {
        if ($dca0ddb82b882518$var$shouldRemainOnPreviousScreen()) workInProgress.flags |= 8192;
        else throw $dca0ddb82b882518$var$suspendedThenable = $dca0ddb82b882518$var$noopSuspenseyCommitThenable, $dca0ddb82b882518$var$SuspenseyCommitException;
    }
}
function $dca0ddb82b882518$var$scheduleRetryEffect(workInProgress, retryQueue) {
    null !== retryQueue && (workInProgress.flags |= 4);
    workInProgress.flags & 16384 && (retryQueue = 22 !== workInProgress.tag ? $dca0ddb82b882518$var$claimNextRetryLane() : 536870912, workInProgress.lanes |= retryQueue, $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes |= retryQueue);
}
function $dca0ddb82b882518$var$cutOffTailIfNeeded(renderState, hasRenderedATailFallback) {
    if (!$dca0ddb82b882518$var$isHydrating) switch(renderState.tailMode){
        case "visible":
            break;
        case "collapsed":
            for(var tailNode = renderState.tail, lastTailNode = null; null !== tailNode;)null !== tailNode.alternate && (lastTailNode = tailNode), tailNode = tailNode.sibling;
            null === lastTailNode ? hasRenderedATailFallback || null === renderState.tail ? renderState.tail = null : renderState.tail.sibling = null : lastTailNode.sibling = null;
            break;
        default:
            hasRenderedATailFallback = renderState.tail;
            for(tailNode = null; null !== hasRenderedATailFallback;)null !== hasRenderedATailFallback.alternate && (tailNode = hasRenderedATailFallback), hasRenderedATailFallback = hasRenderedATailFallback.sibling;
            null === tailNode ? renderState.tail = null : tailNode.sibling = null;
    }
}
function $dca0ddb82b882518$var$bubbleProperties(completedWork) {
    var didBailout = null !== completedWork.alternate && completedWork.alternate.child === completedWork.child, newChildLanes = 0, subtreeFlags = 0;
    if (didBailout) for(var child$113 = completedWork.child; null !== child$113;)newChildLanes |= child$113.lanes | child$113.childLanes, subtreeFlags |= child$113.subtreeFlags & 1206910976, subtreeFlags |= child$113.flags & 1206910976, child$113.return = completedWork, child$113 = child$113.sibling;
    else for(child$113 = completedWork.child; null !== child$113;)newChildLanes |= child$113.lanes | child$113.childLanes, subtreeFlags |= child$113.subtreeFlags, subtreeFlags |= child$113.flags, child$113.return = completedWork, child$113 = child$113.sibling;
    completedWork.subtreeFlags |= subtreeFlags;
    completedWork.childLanes = newChildLanes;
    return didBailout;
}
function $dca0ddb82b882518$var$completeWork(current, workInProgress, renderLanes) {
    var newProps = workInProgress.pendingProps;
    $dca0ddb82b882518$var$popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
        case 1:
            return $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
        case 3:
            renderLanes = workInProgress.stateNode;
            newProps = null;
            null !== current && (newProps = current.memoizedState.cache);
            workInProgress.memoizedState.cache !== newProps && (workInProgress.flags |= 2048);
            $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext);
            $dca0ddb82b882518$var$popHostContainer();
            renderLanes.pendingContext && (renderLanes.context = renderLanes.pendingContext, renderLanes.pendingContext = null);
            if (null === current || null === current.child) $dca0ddb82b882518$var$popHydrationState(workInProgress) ? $dca0ddb82b882518$var$markUpdate(workInProgress) : null === current || current.memoizedState.isDehydrated && 0 === (workInProgress.flags & 256) || (workInProgress.flags |= 1024, $dca0ddb82b882518$var$upgradeHydrationErrorsToRecoverable());
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            return null;
        case 26:
            var type = workInProgress.type, nextResource = workInProgress.memoizedState;
            null === current ? ($dca0ddb82b882518$var$markUpdate(workInProgress), null !== nextResource ? ($dca0ddb82b882518$var$bubbleProperties(workInProgress), $dca0ddb82b882518$var$preloadResourceAndSuspendIfNeeded(workInProgress, nextResource)) : ($dca0ddb82b882518$var$bubbleProperties(workInProgress), $dca0ddb82b882518$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, null, newProps, renderLanes))) : nextResource ? nextResource !== current.memoizedState ? ($dca0ddb82b882518$var$markUpdate(workInProgress), $dca0ddb82b882518$var$bubbleProperties(workInProgress), $dca0ddb82b882518$var$preloadResourceAndSuspendIfNeeded(workInProgress, nextResource)) : ($dca0ddb82b882518$var$bubbleProperties(workInProgress), workInProgress.flags &= -16777217) : (current = current.memoizedProps, current !== newProps && $dca0ddb82b882518$var$markUpdate(workInProgress), $dca0ddb82b882518$var$bubbleProperties(workInProgress), $dca0ddb82b882518$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, current, newProps, renderLanes));
            return null;
        case 27:
            $dca0ddb82b882518$var$popHostContext(workInProgress);
            renderLanes = $dca0ddb82b882518$var$rootInstanceStackCursor.current;
            type = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $dca0ddb82b882518$var$markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(166));
                    $dca0ddb82b882518$var$bubbleProperties(workInProgress);
                    workInProgress.subtreeFlags &= -33554433;
                    return null;
                }
                current = $dca0ddb82b882518$var$contextStackCursor.current;
                $dca0ddb82b882518$var$popHydrationState(workInProgress) ? $dca0ddb82b882518$var$prepareToHydrateHostInstance(workInProgress, current) : (current = $dca0ddb82b882518$var$resolveSingletonInstance(type, newProps, renderLanes), workInProgress.stateNode = current, $dca0ddb82b882518$var$markUpdate(workInProgress));
            }
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            workInProgress.subtreeFlags &= -33554433;
            return null;
        case 5:
            $dca0ddb82b882518$var$popHostContext(workInProgress);
            type = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $dca0ddb82b882518$var$markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(166));
                    $dca0ddb82b882518$var$bubbleProperties(workInProgress);
                    workInProgress.subtreeFlags &= -33554433;
                    return null;
                }
                nextResource = $dca0ddb82b882518$var$contextStackCursor.current;
                if ($dca0ddb82b882518$var$popHydrationState(workInProgress)) $dca0ddb82b882518$var$prepareToHydrateHostInstance(workInProgress, nextResource);
                else {
                    var ownerDocument = $dca0ddb82b882518$var$getOwnerDocumentFromRootContainer($dca0ddb82b882518$var$rootInstanceStackCursor.current);
                    switch(nextResource){
                        case 1:
                            nextResource = ownerDocument.createElementNS("http://www.w3.org/2000/svg", type);
                            break;
                        case 2:
                            nextResource = ownerDocument.createElementNS("http://www.w3.org/1998/Math/MathML", type);
                            break;
                        default:
                            switch(type){
                                case "svg":
                                    nextResource = ownerDocument.createElementNS("http://www.w3.org/2000/svg", type);
                                    break;
                                case "math":
                                    nextResource = ownerDocument.createElementNS("http://www.w3.org/1998/Math/MathML", type);
                                    break;
                                case "script":
                                    nextResource = ownerDocument.createElement("div");
                                    nextResource.innerHTML = "<script>\x3c/script>";
                                    nextResource = nextResource.removeChild(nextResource.firstChild);
                                    break;
                                case "select":
                                    nextResource = "string" === typeof newProps.is ? ownerDocument.createElement("select", {
                                        is: newProps.is
                                    }) : ownerDocument.createElement("select");
                                    newProps.multiple ? nextResource.multiple = !0 : newProps.size && (nextResource.size = newProps.size);
                                    break;
                                default:
                                    nextResource = "string" === typeof newProps.is ? ownerDocument.createElement(type, {
                                        is: newProps.is
                                    }) : ownerDocument.createElement(type);
                            }
                    }
                    nextResource[$dca0ddb82b882518$var$internalInstanceKey] = workInProgress;
                    nextResource[$dca0ddb82b882518$var$internalPropsKey] = newProps;
                    a: for(ownerDocument = workInProgress.child; null !== ownerDocument;){
                        if (5 === ownerDocument.tag || 6 === ownerDocument.tag) nextResource.appendChild(ownerDocument.stateNode);
                        else if (4 !== ownerDocument.tag && 27 !== ownerDocument.tag && null !== ownerDocument.child) {
                            ownerDocument.child.return = ownerDocument;
                            ownerDocument = ownerDocument.child;
                            continue;
                        }
                        if (ownerDocument === workInProgress) break a;
                        for(; null === ownerDocument.sibling;){
                            if (null === ownerDocument.return || ownerDocument.return === workInProgress) break a;
                            ownerDocument = ownerDocument.return;
                        }
                        ownerDocument.sibling.return = ownerDocument.return;
                        ownerDocument = ownerDocument.sibling;
                    }
                    workInProgress.stateNode = nextResource;
                    a: switch($dca0ddb82b882518$var$setInitialProperties(nextResource, type, newProps), type){
                        case "button":
                        case "input":
                        case "select":
                        case "textarea":
                            newProps = !!newProps.autoFocus;
                            break a;
                        case "img":
                            newProps = !0;
                            break a;
                        default:
                            newProps = !1;
                    }
                    newProps && $dca0ddb82b882518$var$markUpdate(workInProgress);
                }
            }
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            workInProgress.subtreeFlags &= -33554433;
            $dca0ddb82b882518$var$preloadInstanceAndSuspendIfNeeded(workInProgress, workInProgress.type, null === current ? null : current.memoizedProps, workInProgress.pendingProps, renderLanes);
            return null;
        case 6:
            if (current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $dca0ddb82b882518$var$markUpdate(workInProgress);
            else {
                if ("string" !== typeof newProps && null === workInProgress.stateNode) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(166));
                current = $dca0ddb82b882518$var$rootInstanceStackCursor.current;
                if ($dca0ddb82b882518$var$popHydrationState(workInProgress)) {
                    current = workInProgress.stateNode;
                    renderLanes = workInProgress.memoizedProps;
                    newProps = null;
                    type = $dca0ddb82b882518$var$hydrationParentFiber;
                    if (null !== type) switch(type.tag){
                        case 27:
                        case 5:
                            newProps = type.memoizedProps;
                    }
                    current[$dca0ddb82b882518$var$internalInstanceKey] = workInProgress;
                    current = current.nodeValue === renderLanes || null !== newProps && !0 === newProps.suppressHydrationWarning || $dca0ddb82b882518$var$checkForUnmatchedText(current.nodeValue, renderLanes) ? !0 : !1;
                    current || $dca0ddb82b882518$var$throwOnHydrationMismatch(workInProgress, !0);
                } else current = $dca0ddb82b882518$var$getOwnerDocumentFromRootContainer(current).createTextNode(newProps), current[$dca0ddb82b882518$var$internalInstanceKey] = workInProgress, workInProgress.stateNode = current;
            }
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            return null;
        case 31:
            renderLanes = workInProgress.memoizedState;
            if (null === current || null !== current.memoizedState) {
                newProps = $dca0ddb82b882518$var$popHydrationState(workInProgress);
                if (null !== renderLanes) {
                    if (null === current) {
                        if (!newProps) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(318));
                        current = workInProgress.memoizedState;
                        current = null !== current ? current.dehydrated : null;
                        if (!current) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(557));
                        current[$dca0ddb82b882518$var$internalInstanceKey] = workInProgress;
                    } else $dca0ddb82b882518$var$resetHydrationState(), 0 === (workInProgress.flags & 128) && (workInProgress.memoizedState = null), workInProgress.flags |= 4;
                    $dca0ddb82b882518$var$bubbleProperties(workInProgress);
                    current = !1;
                } else renderLanes = $dca0ddb82b882518$var$upgradeHydrationErrorsToRecoverable(), null !== current && null !== current.memoizedState && (current.memoizedState.hydrationErrors = renderLanes), current = !0;
                if (!current) {
                    if (workInProgress.flags & 256) return $dca0ddb82b882518$var$popSuspenseHandler(workInProgress), workInProgress;
                    $dca0ddb82b882518$var$popSuspenseHandler(workInProgress);
                    return null;
                }
                if (0 !== (workInProgress.flags & 128)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(558));
            }
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            return null;
        case 13:
            newProps = workInProgress.memoizedState;
            if (null === current || null !== current.memoizedState && null !== current.memoizedState.dehydrated) {
                type = $dca0ddb82b882518$var$popHydrationState(workInProgress);
                if (null !== newProps && null !== newProps.dehydrated) {
                    if (null === current) {
                        if (!type) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(318));
                        type = workInProgress.memoizedState;
                        type = null !== type ? type.dehydrated : null;
                        if (!type) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(317));
                        type[$dca0ddb82b882518$var$internalInstanceKey] = workInProgress;
                    } else $dca0ddb82b882518$var$resetHydrationState(), 0 === (workInProgress.flags & 128) && (workInProgress.memoizedState = null), workInProgress.flags |= 4;
                    $dca0ddb82b882518$var$bubbleProperties(workInProgress);
                    type = !1;
                } else type = $dca0ddb82b882518$var$upgradeHydrationErrorsToRecoverable(), null !== current && null !== current.memoizedState && (current.memoizedState.hydrationErrors = type), type = !0;
                if (!type) {
                    if (workInProgress.flags & 256) return $dca0ddb82b882518$var$popSuspenseHandler(workInProgress), workInProgress;
                    $dca0ddb82b882518$var$popSuspenseHandler(workInProgress);
                    return null;
                }
            }
            $dca0ddb82b882518$var$popSuspenseHandler(workInProgress);
            if (0 !== (workInProgress.flags & 128)) return workInProgress.lanes = renderLanes, workInProgress;
            renderLanes = null !== newProps;
            current = null !== current && null !== current.memoizedState;
            renderLanes && (newProps = workInProgress.child, type = null, null !== newProps.alternate && null !== newProps.alternate.memoizedState && null !== newProps.alternate.memoizedState.cachePool && (type = newProps.alternate.memoizedState.cachePool.pool), nextResource = null, null !== newProps.memoizedState && null !== newProps.memoizedState.cachePool && (nextResource = newProps.memoizedState.cachePool.pool), nextResource !== type && (newProps.flags |= 2048));
            renderLanes !== current && renderLanes && (workInProgress.child.flags |= 8192);
            $dca0ddb82b882518$var$scheduleRetryEffect(workInProgress, workInProgress.updateQueue);
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            return null;
        case 4:
            return $dca0ddb82b882518$var$popHostContainer(), null === current && $dca0ddb82b882518$var$listenToAllSupportedEvents(workInProgress.stateNode.containerInfo), workInProgress.flags |= 67108864, $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
        case 10:
            return $dca0ddb82b882518$var$popProvider(workInProgress.type), $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
        case 19:
            $dca0ddb82b882518$var$popSuspenseListContext(workInProgress);
            newProps = workInProgress.memoizedState;
            if (null === newProps) return $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
            type = 0 !== (workInProgress.flags & 128);
            nextResource = newProps.rendering;
            if (null === nextResource) {
                if (type) $dca0ddb82b882518$var$cutOffTailIfNeeded(newProps, !1);
                else {
                    if (0 !== $dca0ddb82b882518$var$workInProgressRootExitStatus || null !== current && 0 !== (current.flags & 128)) for(current = workInProgress.child; null !== current;){
                        nextResource = $dca0ddb82b882518$var$findFirstSuspended(current);
                        if (null !== nextResource) {
                            workInProgress.flags |= 128;
                            $dca0ddb82b882518$var$cutOffTailIfNeeded(newProps, !1);
                            current = nextResource.updateQueue;
                            workInProgress.updateQueue = current;
                            $dca0ddb82b882518$var$scheduleRetryEffect(workInProgress, current);
                            workInProgress.subtreeFlags = 0;
                            current = renderLanes;
                            for(renderLanes = workInProgress.child; null !== renderLanes;)$dca0ddb82b882518$var$resetWorkInProgress(renderLanes, current), renderLanes = renderLanes.sibling;
                            $dca0ddb82b882518$var$pushSuspenseListContext(workInProgress, $dca0ddb82b882518$var$suspenseStackCursor.current & 1 | 2);
                            $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(workInProgress, newProps.treeForkCount);
                            return workInProgress.child;
                        }
                        current = current.sibling;
                    }
                    null !== newProps.tail && $dca0ddb82b882518$var$now() > $dca0ddb82b882518$var$workInProgressRootRenderTargetTime && (workInProgress.flags |= 128, type = !0, $dca0ddb82b882518$var$cutOffTailIfNeeded(newProps, !1), workInProgress.lanes = 4194304);
                }
            } else {
                if (!type) {
                    if (current = $dca0ddb82b882518$var$findFirstSuspended(nextResource), null !== current) {
                        if (workInProgress.flags |= 128, type = !0, current = current.updateQueue, workInProgress.updateQueue = current, $dca0ddb82b882518$var$scheduleRetryEffect(workInProgress, current), $dca0ddb82b882518$var$cutOffTailIfNeeded(newProps, !0), null === newProps.tail && "collapsed" !== newProps.tailMode && "visible" !== newProps.tailMode && !nextResource.alternate && !$dca0ddb82b882518$var$isHydrating) return $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
                    } else 2 * $dca0ddb82b882518$var$now() - newProps.renderingStartTime > $dca0ddb82b882518$var$workInProgressRootRenderTargetTime && 536870912 !== renderLanes && (workInProgress.flags |= 128, type = !0, $dca0ddb82b882518$var$cutOffTailIfNeeded(newProps, !1), workInProgress.lanes = 4194304);
                }
                newProps.isBackwards ? (nextResource.sibling = workInProgress.child, workInProgress.child = nextResource) : (current = newProps.last, null !== current ? current.sibling = nextResource : workInProgress.child = nextResource, newProps.last = nextResource);
            }
            if (null !== newProps.tail) {
                current = newProps.tail;
                a: {
                    for(renderLanes = current; null !== renderLanes;){
                        if (null !== renderLanes.alternate) {
                            renderLanes = !1;
                            break a;
                        }
                        renderLanes = renderLanes.sibling;
                    }
                    renderLanes = !0;
                }
                newProps.rendering = current;
                newProps.tail = current.sibling;
                newProps.renderingStartTime = $dca0ddb82b882518$var$now();
                current.sibling = null;
                nextResource = $dca0ddb82b882518$var$suspenseStackCursor.current;
                nextResource = type ? nextResource & 1 | 2 : nextResource & 1;
                "visible" === newProps.tailMode || "collapsed" === newProps.tailMode || !renderLanes || $dca0ddb82b882518$var$isHydrating ? $dca0ddb82b882518$var$pushSuspenseListContext(workInProgress, nextResource) : (renderLanes = nextResource, $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseHandlerStackCursor, workInProgress), $dca0ddb82b882518$var$push($dca0ddb82b882518$var$suspenseStackCursor, renderLanes), null === $dca0ddb82b882518$var$shellBoundary && ($dca0ddb82b882518$var$shellBoundary = workInProgress));
                $dca0ddb82b882518$var$isHydrating && $dca0ddb82b882518$var$pushTreeFork(workInProgress, newProps.treeForkCount);
                return current;
            }
            $dca0ddb82b882518$var$bubbleProperties(workInProgress);
            return null;
        case 22:
        case 23:
            return $dca0ddb82b882518$var$popSuspenseHandler(workInProgress), $dca0ddb82b882518$var$popHiddenContext(), newProps = null !== workInProgress.memoizedState, null !== current ? null !== current.memoizedState !== newProps && (workInProgress.flags |= 8192) : newProps && (workInProgress.flags |= 8192), newProps ? 0 !== (renderLanes & 536870912) && 0 === (workInProgress.flags & 128) && ($dca0ddb82b882518$var$bubbleProperties(workInProgress), workInProgress.subtreeFlags & 6 && (workInProgress.flags |= 8192)) : $dca0ddb82b882518$var$bubbleProperties(workInProgress), renderLanes = workInProgress.updateQueue, null !== renderLanes && $dca0ddb82b882518$var$scheduleRetryEffect(workInProgress, renderLanes.retryQueue), renderLanes = null, null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (renderLanes = current.memoizedState.cachePool.pool), newProps = null, null !== workInProgress.memoizedState && null !== workInProgress.memoizedState.cachePool && (newProps = workInProgress.memoizedState.cachePool.pool), newProps !== renderLanes && (workInProgress.flags |= 2048), null !== current && $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$resumedCache), null;
        case 24:
            return renderLanes = null, null !== current && (renderLanes = current.memoizedState.cache), workInProgress.memoizedState.cache !== renderLanes && (workInProgress.flags |= 2048), $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext), $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
        case 25:
            return null;
        case 30:
            return workInProgress.flags |= 33554432, $dca0ddb82b882518$var$bubbleProperties(workInProgress), null;
    }
    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(156, workInProgress.tag));
}
function $dca0ddb82b882518$var$unwindWork(current, workInProgress) {
    $dca0ddb82b882518$var$popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 1:
            return current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 3:
            return $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext), $dca0ddb82b882518$var$popHostContainer(), current = workInProgress.flags, 0 !== (current & 65536) && 0 === (current & 128) ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 26:
        case 27:
        case 5:
            return $dca0ddb82b882518$var$popHostContext(workInProgress), null;
        case 31:
            if (null !== workInProgress.memoizedState) {
                $dca0ddb82b882518$var$popSuspenseHandler(workInProgress);
                if (null === workInProgress.alternate) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(340));
                $dca0ddb82b882518$var$resetHydrationState();
            }
            current = workInProgress.flags;
            return current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 13:
            $dca0ddb82b882518$var$popSuspenseHandler(workInProgress);
            current = workInProgress.memoizedState;
            if (null !== current && null !== current.dehydrated) {
                if (null === workInProgress.alternate) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(340));
                $dca0ddb82b882518$var$resetHydrationState();
            }
            current = workInProgress.flags;
            return current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 19:
            return $dca0ddb82b882518$var$popSuspenseListContext(workInProgress), current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, current = workInProgress.memoizedState, null !== current && (current.rendering = null, current.tail = null), workInProgress.flags |= 4, workInProgress) : null;
        case 4:
            return $dca0ddb82b882518$var$popHostContainer(), null;
        case 10:
            return $dca0ddb82b882518$var$popProvider(workInProgress.type), null;
        case 22:
        case 23:
            return $dca0ddb82b882518$var$popSuspenseHandler(workInProgress), $dca0ddb82b882518$var$popHiddenContext(), null !== current && $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$resumedCache), current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 24:
            return $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext), null;
        case 25:
            return null;
        default:
            return null;
    }
}
function $dca0ddb82b882518$var$unwindInterruptedWork(current, interruptedWork) {
    $dca0ddb82b882518$var$popTreeContext(interruptedWork);
    switch(interruptedWork.tag){
        case 3:
            $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext);
            $dca0ddb82b882518$var$popHostContainer();
            break;
        case 26:
        case 27:
        case 5:
            $dca0ddb82b882518$var$popHostContext(interruptedWork);
            break;
        case 4:
            $dca0ddb82b882518$var$popHostContainer();
            break;
        case 31:
            null !== interruptedWork.memoizedState && $dca0ddb82b882518$var$popSuspenseHandler(interruptedWork);
            break;
        case 13:
            $dca0ddb82b882518$var$popSuspenseHandler(interruptedWork);
            break;
        case 19:
            $dca0ddb82b882518$var$popSuspenseListContext(interruptedWork);
            break;
        case 10:
            $dca0ddb82b882518$var$popProvider(interruptedWork.type);
            break;
        case 22:
        case 23:
            $dca0ddb82b882518$var$popSuspenseHandler(interruptedWork);
            $dca0ddb82b882518$var$popHiddenContext();
            null !== current && $dca0ddb82b882518$var$pop($dca0ddb82b882518$var$resumedCache);
            break;
        case 24:
            $dca0ddb82b882518$var$popProvider($dca0ddb82b882518$var$CacheContext);
    }
}
function $dca0ddb82b882518$var$commitHookEffectListMount(flags, finishedWork) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    lastEffect = void 0;
                    var create = updateQueue.create, inst = updateQueue.inst;
                    lastEffect = create();
                    inst.destroy = lastEffect;
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $dca0ddb82b882518$var$commitHookEffectListUnmount(flags, finishedWork, nearestMountedAncestor$jscomp$0) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    var inst = updateQueue.inst, destroy = inst.destroy;
                    if (void 0 !== destroy) {
                        inst.destroy = void 0;
                        lastEffect = finishedWork;
                        var nearestMountedAncestor = nearestMountedAncestor$jscomp$0, destroy_ = destroy;
                        try {
                            destroy_();
                        } catch (error) {
                            $dca0ddb82b882518$var$captureCommitPhaseError(lastEffect, nearestMountedAncestor, error);
                        }
                    }
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $dca0ddb82b882518$var$commitClassCallbacks(finishedWork) {
    var updateQueue = finishedWork.updateQueue;
    if (null !== updateQueue) {
        var instance = finishedWork.stateNode;
        try {
            $dca0ddb82b882518$var$commitCallbacks(updateQueue, instance);
        } catch (error) {
            $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
}
function $dca0ddb82b882518$var$safelyCallComponentWillUnmount(current, nearestMountedAncestor, instance) {
    instance.props = $dca0ddb82b882518$var$resolveClassComponentProps(current.type, current.memoizedProps);
    instance.state = current.memoizedState;
    try {
        instance.componentWillUnmount();
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function $dca0ddb82b882518$var$safelyAttachRef(current, nearestMountedAncestor) {
    try {
        var ref = current.ref;
        if (null !== ref) {
            switch(current.tag){
                case 26:
                case 27:
                case 5:
                    var instanceToUse = current.stateNode;
                    break;
                case 30:
                    var instance = current.stateNode, name = $dca0ddb82b882518$var$getViewTransitionName(current.memoizedProps, instance);
                    if (null === instance.ref || instance.ref.name !== name) instance.ref = $dca0ddb82b882518$var$createViewTransitionInstance(name);
                    instanceToUse = instance.ref;
                    break;
                case 7:
                    if (null === current.stateNode) {
                        var fragmentInstance = new $dca0ddb82b882518$var$FragmentInstance(current);
                        $dca0ddb82b882518$var$traverseVisibleInstancesAndTextInstances(current.child, !1, $dca0ddb82b882518$var$addFragmentHandleToFiber, fragmentInstance, void 0, void 0);
                        current.stateNode = fragmentInstance;
                    }
                    instanceToUse = current.stateNode;
                    break;
                default:
                    instanceToUse = current.stateNode;
            }
            "function" === typeof ref ? current.refCleanup = ref(instanceToUse) : ref.current = instanceToUse;
        }
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function $dca0ddb82b882518$var$safelyDetachRef(current, nearestMountedAncestor) {
    var ref = current.ref, refCleanup = current.refCleanup;
    if (null !== ref) {
        if ("function" === typeof refCleanup) try {
            refCleanup();
        } catch (error) {
            $dca0ddb82b882518$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
        } finally{
            current.refCleanup = null, current = current.alternate, null != current && (current.refCleanup = null);
        }
        else if ("function" === typeof ref) try {
            ref(null);
        } catch (error$148) {
            $dca0ddb82b882518$var$captureCommitPhaseError(current, nearestMountedAncestor, error$148);
        }
        else ref.current = null;
    }
}
function $dca0ddb82b882518$var$commitNewChildToFragmentInstances(fiber, parentFragmentInstances) {
    if ((5 === fiber.tag || 27 === fiber.tag || 6 === fiber.tag) && null === fiber.alternate && null !== parentFragmentInstances) for(var i = 0; i < parentFragmentInstances.length; i++)$dca0ddb82b882518$var$commitNewChildToFragmentInstance(fiber.stateNode, parentFragmentInstances[i]);
}
function $dca0ddb82b882518$var$commitFragmentInstanceInsertionEffects(fiber) {
    for(var parent = fiber.return; null !== parent;){
        $dca0ddb82b882518$var$isFragmentInstanceParent(parent) && $dca0ddb82b882518$var$commitNewChildToFragmentInstance(fiber.stateNode, parent.stateNode);
        if ($dca0ddb82b882518$var$isFragmentInstanceHostBoundary(parent)) break;
        parent = parent.return;
    }
}
function $dca0ddb82b882518$var$commitFragmentInstanceDeletionEffects(fiber) {
    for(var parent = fiber.return; null !== parent;){
        $dca0ddb82b882518$var$isFragmentInstanceParent(parent) && $dca0ddb82b882518$var$deleteChildFromFragmentInstance(fiber.stateNode, parent.stateNode);
        if ($dca0ddb82b882518$var$isFragmentInstanceHostBoundary(parent)) break;
        parent = parent.return;
    }
}
function $dca0ddb82b882518$var$isFragmentInstanceHostBoundary(fiber) {
    return 5 === fiber.tag || 3 === fiber.tag || 27 === fiber.tag;
}
function $dca0ddb82b882518$var$isFragmentInstanceParent(fiber) {
    return fiber && 7 === fiber.tag && null !== fiber.stateNode;
}
function $dca0ddb82b882518$var$commitHostMount(finishedWork) {
    var type = finishedWork.type, props = finishedWork.memoizedProps, instance = finishedWork.stateNode;
    try {
        a: switch(type){
            case "button":
            case "input":
            case "select":
            case "textarea":
                props.autoFocus && instance.focus();
                break a;
            case "img":
                props.src ? instance.src = props.src : props.srcSet && (instance.srcset = props.srcSet);
        }
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $dca0ddb82b882518$var$commitHostUpdate(finishedWork, newProps, oldProps) {
    try {
        var domElement = finishedWork.stateNode;
        $dca0ddb82b882518$var$updateProperties(domElement, finishedWork.type, oldProps, newProps);
        domElement[$dca0ddb82b882518$var$internalPropsKey] = newProps;
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $dca0ddb82b882518$var$isHostParent(fiber) {
    return 5 === fiber.tag || 3 === fiber.tag || 26 === fiber.tag || 27 === fiber.tag && $dca0ddb82b882518$var$isSingletonScope(fiber.type) || 4 === fiber.tag;
}
function $dca0ddb82b882518$var$getHostSibling(fiber) {
    a: for(;;){
        for(; null === fiber.sibling;){
            if (null === fiber.return || $dca0ddb82b882518$var$isHostParent(fiber.return)) return null;
            fiber = fiber.return;
        }
        fiber.sibling.return = fiber.return;
        for(fiber = fiber.sibling; 5 !== fiber.tag && 6 !== fiber.tag && 18 !== fiber.tag;){
            if (27 === fiber.tag && $dca0ddb82b882518$var$isSingletonScope(fiber.type)) continue a;
            if (fiber.flags & 2) continue a;
            if (null === fiber.child || 4 === fiber.tag) continue a;
            else fiber.child.return = fiber, fiber = fiber.child;
        }
        if (!(fiber.flags & 2)) return fiber.stateNode;
    }
}
function $dca0ddb82b882518$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent, parentFragmentInstances) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) tag = node.stateNode, before ? (9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent).insertBefore(tag, before) : (before = 9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent, before.appendChild(tag), parent = parent._reactRootContainer, null !== parent && void 0 !== parent || null !== before.onclick || (before.onclick = $dca0ddb82b882518$var$noop$1)), $dca0ddb82b882518$var$commitNewChildToFragmentInstances(node, parentFragmentInstances), $dca0ddb82b882518$var$viewTransitionMutationContext = !0;
    else if (4 !== tag && (27 === tag && ($dca0ddb82b882518$var$commitNewChildToFragmentInstances(node, parentFragmentInstances), parentFragmentInstances = null, $dca0ddb82b882518$var$isSingletonScope(node.type) && (parent = node.stateNode, before = null)), node = node.child, null !== node)) for($dca0ddb82b882518$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent, parentFragmentInstances), node = node.sibling; null !== node;)$dca0ddb82b882518$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent, parentFragmentInstances), node = node.sibling;
}
function $dca0ddb82b882518$var$insertOrAppendPlacementNode(node, before, parent, parentFragmentInstances) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) tag = node.stateNode, before ? parent.insertBefore(tag, before) : parent.appendChild(tag), $dca0ddb82b882518$var$commitNewChildToFragmentInstances(node, parentFragmentInstances), $dca0ddb82b882518$var$viewTransitionMutationContext = !0;
    else if (4 !== tag && (27 === tag && ($dca0ddb82b882518$var$commitNewChildToFragmentInstances(node, parentFragmentInstances), parentFragmentInstances = null, $dca0ddb82b882518$var$isSingletonScope(node.type) && (parent = node.stateNode)), node = node.child, null !== node)) for($dca0ddb82b882518$var$insertOrAppendPlacementNode(node, before, parent, parentFragmentInstances), node = node.sibling; null !== node;)$dca0ddb82b882518$var$insertOrAppendPlacementNode(node, before, parent, parentFragmentInstances), node = node.sibling;
}
function $dca0ddb82b882518$var$commitHostSingletonAcquisition(finishedWork) {
    var singleton = finishedWork.stateNode, props = finishedWork.memoizedProps;
    try {
        for(var type = finishedWork.type, attributes = singleton.attributes; attributes.length;)singleton.removeAttributeNode(attributes[0]);
        $dca0ddb82b882518$var$setInitialProperties(singleton, type, props);
        singleton[$dca0ddb82b882518$var$internalInstanceKey] = finishedWork;
        singleton[$dca0ddb82b882518$var$internalPropsKey] = props;
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
var $dca0ddb82b882518$var$shouldStartViewTransition = !1, $dca0ddb82b882518$var$appearingViewTransitions = null;
function $dca0ddb82b882518$var$trackEnterViewTransitions(placement) {
    if (30 === placement.tag || 0 !== (placement.subtreeFlags & 33554432)) $dca0ddb82b882518$var$shouldStartViewTransition = !0;
}
var $dca0ddb82b882518$var$viewTransitionCancelableChildren = null;
function $dca0ddb82b882518$var$pushViewTransitionCancelableScope() {
    var prevChildren = $dca0ddb82b882518$var$viewTransitionCancelableChildren;
    $dca0ddb82b882518$var$viewTransitionCancelableChildren = null;
    return prevChildren;
}
var $dca0ddb82b882518$var$viewTransitionHostInstanceIdx = 0;
function $dca0ddb82b882518$var$applyViewTransitionToHostInstances(fiber, name, className, collectMeasurements, stopAtNestedViewTransitions) {
    $dca0ddb82b882518$var$viewTransitionHostInstanceIdx = 0;
    return $dca0ddb82b882518$var$applyViewTransitionToHostInstancesRecursive(fiber.child, name, className, collectMeasurements, stopAtNestedViewTransitions);
}
function $dca0ddb82b882518$var$applyViewTransitionToHostInstancesRecursive(child, name, className, collectMeasurements, stopAtNestedViewTransitions) {
    for(var inViewport = !1; null !== child;){
        if (5 === child.tag) {
            var instance = child.stateNode;
            if (null !== collectMeasurements) {
                var measurement = $dca0ddb82b882518$var$measureInstance(instance);
                collectMeasurements.push(measurement);
                measurement.view && (inViewport = !0);
            } else inViewport || $dca0ddb82b882518$var$measureInstance(instance).view && (inViewport = !0);
            $dca0ddb82b882518$var$shouldStartViewTransition = !0;
            $dca0ddb82b882518$var$applyViewTransitionName(instance, 0 === $dca0ddb82b882518$var$viewTransitionHostInstanceIdx ? name : name + "_" + $dca0ddb82b882518$var$viewTransitionHostInstanceIdx, className);
            $dca0ddb82b882518$var$viewTransitionHostInstanceIdx++;
        } else if (22 !== child.tag || null === child.memoizedState) 30 === child.tag && stopAtNestedViewTransitions || $dca0ddb82b882518$var$applyViewTransitionToHostInstancesRecursive(child.child, name, className, collectMeasurements, stopAtNestedViewTransitions) && (inViewport = !0);
        child = child.sibling;
    }
    return inViewport;
}
function $dca0ddb82b882518$var$restoreViewTransitionOnHostInstances(child, stopAtNestedViewTransitions) {
    for(; null !== child;){
        if (5 === child.tag) $dca0ddb82b882518$var$restoreViewTransitionName(child.stateNode, child.memoizedProps);
        else if (22 !== child.tag || null === child.memoizedState) 30 === child.tag && stopAtNestedViewTransitions || $dca0ddb82b882518$var$restoreViewTransitionOnHostInstances(child.child, stopAtNestedViewTransitions);
        child = child.sibling;
    }
}
function $dca0ddb82b882518$var$commitAppearingPairViewTransitions(placement) {
    if (0 !== (placement.subtreeFlags & 18874368)) for(placement = placement.child; null !== placement;){
        if (22 !== placement.tag || null === placement.memoizedState) {
            if ($dca0ddb82b882518$var$commitAppearingPairViewTransitions(placement), 30 === placement.tag && 0 !== (placement.flags & 18874368) && placement.stateNode.paired) {
                var props = placement.memoizedProps;
                if (null == props.name || "auto" === props.name) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(544));
                var name = props.name;
                props = $dca0ddb82b882518$var$getViewTransitionClassName(props.default, props.share);
                "none" !== props && ($dca0ddb82b882518$var$applyViewTransitionToHostInstances(placement, name, props, null, !1) || $dca0ddb82b882518$var$restoreViewTransitionOnHostInstances(placement.child, !1));
            }
        }
        placement = placement.sibling;
    }
}
function $dca0ddb82b882518$var$commitEnterViewTransitions(placement, gesture) {
    if (30 === placement.tag) {
        var state = placement.stateNode, props = placement.memoizedProps, name = $dca0ddb82b882518$var$getViewTransitionName(props, state), className = $dca0ddb82b882518$var$getViewTransitionClassName(props.default, state.paired ? props.share : props.enter);
        "none" !== className ? $dca0ddb82b882518$var$applyViewTransitionToHostInstances(placement, name, className, null, !1) ? ($dca0ddb82b882518$var$commitAppearingPairViewTransitions(placement), state.paired || gesture || $dca0ddb82b882518$var$scheduleViewTransitionEvent(placement, props.onEnter)) : $dca0ddb82b882518$var$restoreViewTransitionOnHostInstances(placement.child, !1) : $dca0ddb82b882518$var$commitAppearingPairViewTransitions(placement);
    } else if (0 !== (placement.subtreeFlags & 33554432)) for(placement = placement.child; null !== placement;)$dca0ddb82b882518$var$commitEnterViewTransitions(placement, gesture), placement = placement.sibling;
    else $dca0ddb82b882518$var$commitAppearingPairViewTransitions(placement);
}
function $dca0ddb82b882518$var$commitDeletedPairViewTransitions(deletion) {
    if (null !== $dca0ddb82b882518$var$appearingViewTransitions && 0 !== $dca0ddb82b882518$var$appearingViewTransitions.size) {
        var pairs = $dca0ddb82b882518$var$appearingViewTransitions;
        if (0 !== (deletion.subtreeFlags & 18874368)) for(deletion = deletion.child; null !== deletion;){
            if (22 !== deletion.tag || null === deletion.memoizedState) {
                if (30 === deletion.tag && 0 !== (deletion.flags & 18874368)) {
                    var props = deletion.memoizedProps, name = props.name;
                    if (null != name && "auto" !== name) {
                        var pair = pairs.get(name);
                        if (void 0 !== pair) {
                            var className = $dca0ddb82b882518$var$getViewTransitionClassName(props.default, props.share);
                            "none" !== className && ($dca0ddb82b882518$var$applyViewTransitionToHostInstances(deletion, name, className, null, !1) ? (className = deletion.stateNode, pair.paired = className, className.paired = pair, $dca0ddb82b882518$var$scheduleViewTransitionEvent(deletion, props.onShare)) : $dca0ddb82b882518$var$restoreViewTransitionOnHostInstances(deletion.child, !1));
                            pairs.delete(name);
                            if (0 === pairs.size) break;
                        }
                    }
                }
                $dca0ddb82b882518$var$commitDeletedPairViewTransitions(deletion);
            }
            deletion = deletion.sibling;
        }
    }
}
function $dca0ddb82b882518$var$commitExitViewTransitions(deletion) {
    if (30 === deletion.tag) {
        var props = deletion.memoizedProps, name = $dca0ddb82b882518$var$getViewTransitionName(props, deletion.stateNode), pair = null !== $dca0ddb82b882518$var$appearingViewTransitions ? $dca0ddb82b882518$var$appearingViewTransitions.get(name) : void 0, className = $dca0ddb82b882518$var$getViewTransitionClassName(props.default, void 0 !== pair ? props.share : props.exit);
        "none" !== className && ($dca0ddb82b882518$var$applyViewTransitionToHostInstances(deletion, name, className, null, !1) ? void 0 !== pair ? (className = deletion.stateNode, pair.paired = className, className.paired = pair, $dca0ddb82b882518$var$appearingViewTransitions.delete(name), $dca0ddb82b882518$var$scheduleViewTransitionEvent(deletion, props.onShare)) : $dca0ddb82b882518$var$scheduleViewTransitionEvent(deletion, props.onExit) : $dca0ddb82b882518$var$restoreViewTransitionOnHostInstances(deletion.child, !1));
        null !== $dca0ddb82b882518$var$appearingViewTransitions && $dca0ddb82b882518$var$commitDeletedPairViewTransitions(deletion);
    } else if (0 !== (deletion.subtreeFlags & 33554432)) for(deletion = deletion.child; null !== deletion;)$dca0ddb82b882518$var$commitExitViewTransitions(deletion), deletion = deletion.sibling;
    else null !== $dca0ddb82b882518$var$appearingViewTransitions && $dca0ddb82b882518$var$commitDeletedPairViewTransitions(deletion);
}
function $dca0ddb82b882518$var$commitNestedViewTransitions(changedParent) {
    for(changedParent = changedParent.child; null !== changedParent;){
        if (30 === changedParent.tag) {
            var props = changedParent.memoizedProps, name = $dca0ddb82b882518$var$getViewTransitionName(props, changedParent.stateNode);
            props = $dca0ddb82b882518$var$getViewTransitionClassName(props.default, props.update);
            changedParent.flags &= -5;
            "none" !== props && $dca0ddb82b882518$var$applyViewTransitionToHostInstances(changedParent, name, props, changedParent.memoizedState = [], !1);
        } else 0 !== (changedParent.subtreeFlags & 33554432) && $dca0ddb82b882518$var$commitNestedViewTransitions(changedParent);
        changedParent = changedParent.sibling;
    }
}
function $dca0ddb82b882518$var$restorePairedViewTransitions(parent) {
    if (0 !== (parent.subtreeFlags & 18874368)) for(parent = parent.child; null !== parent;){
        if (22 !== parent.tag || null === parent.memoizedState) {
            if (30 === parent.tag && 0 !== (parent.flags & 18874368)) {
                var instance = parent.stateNode;
                null !== instance.paired && (instance.paired = null, $dca0ddb82b882518$var$restoreViewTransitionOnHostInstances(parent.child, !1));
            }
            $dca0ddb82b882518$var$restorePairedViewTransitions(parent);
        }
        parent = parent.sibling;
    }
}
function $dca0ddb82b882518$var$restoreEnterOrExitViewTransitions(fiber) {
    if (30 === fiber.tag) fiber.stateNode.paired = null, $dca0ddb82b882518$var$restoreViewTransitionOnHostInstances(fiber.child, !1), $dca0ddb82b882518$var$restorePairedViewTransitions(fiber);
    else if (0 !== (fiber.subtreeFlags & 33554432)) for(fiber = fiber.child; null !== fiber;)$dca0ddb82b882518$var$restoreEnterOrExitViewTransitions(fiber), fiber = fiber.sibling;
    else $dca0ddb82b882518$var$restorePairedViewTransitions(fiber);
}
function $dca0ddb82b882518$var$restoreNestedViewTransitions(changedParent) {
    for(changedParent = changedParent.child; null !== changedParent;)30 === changedParent.tag ? $dca0ddb82b882518$var$restoreViewTransitionOnHostInstances(changedParent.child, !1) : 0 !== (changedParent.subtreeFlags & 33554432) && $dca0ddb82b882518$var$restoreNestedViewTransitions(changedParent), changedParent = changedParent.sibling;
}
function $dca0ddb82b882518$var$measureViewTransitionHostInstancesRecursive(parentViewTransition, child, newName, oldName, className, previousMeasurements, stopAtNestedViewTransitions) {
    for(var inViewport = !1; null !== child;){
        if (5 === child.tag) {
            var instance = child.stateNode;
            if (null !== previousMeasurements && $dca0ddb82b882518$var$viewTransitionHostInstanceIdx < previousMeasurements.length) {
                var previousMeasurement = previousMeasurements[$dca0ddb82b882518$var$viewTransitionHostInstanceIdx], nextMeasurement = $dca0ddb82b882518$var$measureInstance(instance);
                if (previousMeasurement.view || nextMeasurement.view) inViewport = !0;
                var JSCompiler_temp;
                if (JSCompiler_temp = 0 === (parentViewTransition.flags & 4)) {
                    if (nextMeasurement.clip) JSCompiler_temp = !0;
                    else {
                        JSCompiler_temp = previousMeasurement.rect;
                        var newRect = nextMeasurement.rect;
                        JSCompiler_temp = JSCompiler_temp.y !== newRect.y || JSCompiler_temp.x !== newRect.x || JSCompiler_temp.height !== newRect.height || JSCompiler_temp.width !== newRect.width;
                    }
                }
                JSCompiler_temp && (parentViewTransition.flags |= 4);
                nextMeasurement.abs ? nextMeasurement = !previousMeasurement.abs : (previousMeasurement = previousMeasurement.rect, nextMeasurement = nextMeasurement.rect, nextMeasurement = previousMeasurement.height !== nextMeasurement.height || previousMeasurement.width !== nextMeasurement.width);
                nextMeasurement && (parentViewTransition.flags |= 32);
            } else parentViewTransition.flags |= 32;
            0 !== (parentViewTransition.flags & 4) && $dca0ddb82b882518$var$applyViewTransitionName(instance, 0 === $dca0ddb82b882518$var$viewTransitionHostInstanceIdx ? newName : newName + "_" + $dca0ddb82b882518$var$viewTransitionHostInstanceIdx, className);
            inViewport && 0 !== (parentViewTransition.flags & 4) || (null === $dca0ddb82b882518$var$viewTransitionCancelableChildren && ($dca0ddb82b882518$var$viewTransitionCancelableChildren = []), $dca0ddb82b882518$var$viewTransitionCancelableChildren.push(instance, 0 === $dca0ddb82b882518$var$viewTransitionHostInstanceIdx ? oldName : oldName + "_" + $dca0ddb82b882518$var$viewTransitionHostInstanceIdx, child.memoizedProps));
            $dca0ddb82b882518$var$viewTransitionHostInstanceIdx++;
        } else if (22 !== child.tag || null === child.memoizedState) 30 === child.tag && stopAtNestedViewTransitions ? parentViewTransition.flags |= child.flags & 32 : $dca0ddb82b882518$var$measureViewTransitionHostInstancesRecursive(parentViewTransition, child.child, newName, oldName, className, previousMeasurements, stopAtNestedViewTransitions) && (inViewport = !0);
        child = child.sibling;
    }
    return inViewport;
}
function $dca0ddb82b882518$var$measureNestedViewTransitions(changedParent, gesture) {
    for(changedParent = changedParent.child; null !== changedParent;){
        if (30 === changedParent.tag) {
            var props = changedParent.memoizedProps, state = changedParent.stateNode, name = $dca0ddb82b882518$var$getViewTransitionName(props, state), className = $dca0ddb82b882518$var$getViewTransitionClassName(props.default, props.update);
            if (gesture) {
                state = state.clones;
                var previousMeasurements = null === state ? null : state.map($dca0ddb82b882518$var$measureClonedInstance);
            } else previousMeasurements = changedParent.memoizedState, changedParent.memoizedState = null;
            state = changedParent;
            var child = changedParent.child;
            $dca0ddb82b882518$var$viewTransitionHostInstanceIdx = 0;
            name = $dca0ddb82b882518$var$measureViewTransitionHostInstancesRecursive(state, child, name, name, className, previousMeasurements, !1);
            0 !== (changedParent.flags & 4) && name && (gesture || $dca0ddb82b882518$var$scheduleViewTransitionEvent(changedParent, props.onUpdate));
        } else 0 !== (changedParent.subtreeFlags & 33554432) && $dca0ddb82b882518$var$measureNestedViewTransitions(changedParent, gesture);
        changedParent = changedParent.sibling;
    }
}
var $dca0ddb82b882518$var$offscreenSubtreeIsHidden = !1, $dca0ddb82b882518$var$offscreenSubtreeWasHidden = !1, $dca0ddb82b882518$var$offscreenDirectParentIsHidden = !1, $dca0ddb82b882518$var$needsFormReset = !1, $dca0ddb82b882518$var$PossiblyWeakSet = "function" === typeof WeakSet ? WeakSet : Set, $dca0ddb82b882518$var$nextEffect = null, $dca0ddb82b882518$var$viewTransitionContextChanged = !1, $dca0ddb82b882518$var$inUpdateViewTransition = !1, $dca0ddb82b882518$var$rootViewTransitionAffected = !1, $dca0ddb82b882518$var$rootViewTransitionNameCanceled = !1;
function $dca0ddb82b882518$var$commitBeforeMutationEffects(root, firstChild, committedLanes) {
    root = root.containerInfo;
    $dca0ddb82b882518$var$eventsEnabled = $dca0ddb82b882518$var$_enabled;
    root = $dca0ddb82b882518$var$getActiveElementDeep(root);
    if ($dca0ddb82b882518$var$hasSelectionCapabilities(root)) {
        if ("selectionStart" in root) var JSCompiler_temp = {
            start: root.selectionStart,
            end: root.selectionEnd
        };
        else a: {
            JSCompiler_temp = (JSCompiler_temp = root.ownerDocument) && JSCompiler_temp.defaultView || window;
            var selection = JSCompiler_temp.getSelection && JSCompiler_temp.getSelection();
            if (selection && 0 !== selection.rangeCount) {
                JSCompiler_temp = selection.anchorNode;
                var anchorOffset = selection.anchorOffset, focusNode = selection.focusNode;
                selection = selection.focusOffset;
                try {
                    JSCompiler_temp.nodeType, focusNode.nodeType;
                } catch (e$21) {
                    JSCompiler_temp = null;
                    break a;
                }
                var length = 0, start = -1, end = -1, indexWithinAnchor = 0, indexWithinFocus = 0, node = root, parentNode = null;
                b: for(;;){
                    for(var next;;){
                        node !== JSCompiler_temp || 0 !== anchorOffset && 3 !== node.nodeType || (start = length + anchorOffset);
                        node !== focusNode || 0 !== selection && 3 !== node.nodeType || (end = length + selection);
                        3 === node.nodeType && (length += node.nodeValue.length);
                        if (null === (next = node.firstChild)) break;
                        parentNode = node;
                        node = next;
                    }
                    for(;;){
                        if (node === root) break b;
                        parentNode === JSCompiler_temp && ++indexWithinAnchor === anchorOffset && (start = length);
                        parentNode === focusNode && ++indexWithinFocus === selection && (end = length);
                        if (null !== (next = node.nextSibling)) break;
                        node = parentNode;
                        parentNode = node.parentNode;
                    }
                    node = next;
                }
                JSCompiler_temp = -1 === start || -1 === end ? null : {
                    start: start,
                    end: end
                };
            } else JSCompiler_temp = null;
        }
        JSCompiler_temp = JSCompiler_temp || {
            start: 0,
            end: 0
        };
    } else JSCompiler_temp = null;
    $dca0ddb82b882518$var$selectionInformation = {
        focusedElem: root,
        selectionRange: JSCompiler_temp
    };
    $dca0ddb82b882518$var$_enabled = !1;
    committedLanes = (committedLanes & 335544064) === committedLanes;
    $dca0ddb82b882518$var$nextEffect = firstChild;
    for(firstChild = committedLanes ? 9270 : 1024; null !== $dca0ddb82b882518$var$nextEffect;){
        root = $dca0ddb82b882518$var$nextEffect;
        if (committedLanes && (JSCompiler_temp = root.deletions, null !== JSCompiler_temp)) for(anchorOffset = 0; anchorOffset < JSCompiler_temp.length; anchorOffset++)committedLanes && $dca0ddb82b882518$var$commitExitViewTransitions(JSCompiler_temp[anchorOffset]);
        if (null === root.alternate && 0 !== (root.flags & 2)) committedLanes && $dca0ddb82b882518$var$trackEnterViewTransitions(root), $dca0ddb82b882518$var$commitBeforeMutationEffects_complete(committedLanes);
        else {
            if (22 === root.tag) {
                if (JSCompiler_temp = root.alternate, null !== root.memoizedState) {
                    null !== JSCompiler_temp && null === JSCompiler_temp.memoizedState && committedLanes && $dca0ddb82b882518$var$commitExitViewTransitions(JSCompiler_temp);
                    $dca0ddb82b882518$var$commitBeforeMutationEffects_complete(committedLanes);
                    continue;
                } else if (null !== JSCompiler_temp && null !== JSCompiler_temp.memoizedState) {
                    committedLanes && $dca0ddb82b882518$var$trackEnterViewTransitions(root);
                    $dca0ddb82b882518$var$commitBeforeMutationEffects_complete(committedLanes);
                    continue;
                }
            }
            JSCompiler_temp = root.child;
            0 !== (root.subtreeFlags & firstChild) && null !== JSCompiler_temp ? (JSCompiler_temp.return = root, $dca0ddb82b882518$var$nextEffect = JSCompiler_temp) : (committedLanes && $dca0ddb82b882518$var$commitNestedViewTransitions(root), $dca0ddb82b882518$var$commitBeforeMutationEffects_complete(committedLanes));
        }
    }
    $dca0ddb82b882518$var$appearingViewTransitions = null;
}
function $dca0ddb82b882518$var$commitBeforeMutationEffects_complete(isViewTransitionEligible$jscomp$0) {
    for(; null !== $dca0ddb82b882518$var$nextEffect;){
        var fiber = $dca0ddb82b882518$var$nextEffect, isViewTransitionEligible = isViewTransitionEligible$jscomp$0, current = fiber.alternate, flags = fiber.flags;
        switch(fiber.tag){
            case 0:
            case 11:
            case 15:
                break;
            case 1:
                if (0 !== (flags & 1024) && null !== current) {
                    isViewTransitionEligible = void 0;
                    flags = current.memoizedProps;
                    current = current.memoizedState;
                    var instance = fiber.stateNode;
                    try {
                        var resolvedPrevProps = $dca0ddb82b882518$var$resolveClassComponentProps(fiber.type, flags);
                        isViewTransitionEligible = instance.getSnapshotBeforeUpdate(resolvedPrevProps, current);
                        instance.__reactInternalSnapshotBeforeUpdate = isViewTransitionEligible;
                    } catch (error) {
                        $dca0ddb82b882518$var$captureCommitPhaseError(fiber, fiber.return, error);
                    }
                }
                break;
            case 3:
                if (0 !== (flags & 1024)) {
                    if (current = fiber.stateNode.containerInfo, isViewTransitionEligible = current.nodeType, 9 === isViewTransitionEligible) $dca0ddb82b882518$var$clearContainerSparingly(current);
                    else if (1 === isViewTransitionEligible) switch(current.nodeName){
                        case "HEAD":
                        case "HTML":
                        case "BODY":
                            $dca0ddb82b882518$var$clearContainerSparingly(current);
                            break;
                        default:
                            current.textContent = "";
                    }
                }
                break;
            case 5:
            case 26:
            case 27:
            case 6:
            case 4:
            case 17:
                break;
            case 30:
                isViewTransitionEligible && null !== current && (isViewTransitionEligible = $dca0ddb82b882518$var$getViewTransitionName(current.memoizedProps, current.stateNode), flags = fiber.memoizedProps, flags = $dca0ddb82b882518$var$getViewTransitionClassName(flags.default, flags.update), "none" !== flags && $dca0ddb82b882518$var$applyViewTransitionToHostInstances(current, isViewTransitionEligible, flags, current.memoizedState = [], !0));
                break;
            default:
                if (0 !== (flags & 1024)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(163));
        }
        current = fiber.sibling;
        if (null !== current) {
            current.return = fiber.return;
            $dca0ddb82b882518$var$nextEffect = current;
            break;
        }
        $dca0ddb82b882518$var$nextEffect = fiber.return;
    }
}
function $dca0ddb82b882518$var$commitLayoutEffectOnFiber(finishedRoot, current, finishedWork) {
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $dca0ddb82b882518$var$commitHookEffectListMount(5, finishedWork);
            break;
        case 1:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 4) {
                if (finishedRoot = finishedWork.stateNode, null === current) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
                else {
                    var prevProps = $dca0ddb82b882518$var$resolveClassComponentProps(finishedWork.type, current.memoizedProps);
                    current = current.memoizedState;
                    try {
                        finishedRoot.componentDidUpdate(prevProps, current, finishedRoot.__reactInternalSnapshotBeforeUpdate);
                    } catch (error$146) {
                        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error$146);
                    }
                }
            }
            flags & 64 && $dca0ddb82b882518$var$commitClassCallbacks(finishedWork);
            flags & 512 && $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 3:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 64 && (finishedRoot = finishedWork.updateQueue, null !== finishedRoot)) {
                current = null;
                if (null !== finishedWork.child) switch(finishedWork.child.tag){
                    case 27:
                    case 5:
                        current = finishedWork.child.stateNode;
                        break;
                    case 1:
                        current = finishedWork.child.stateNode;
                }
                try {
                    $dca0ddb82b882518$var$commitCallbacks(finishedRoot, current);
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 27:
            null === current && flags & 4 && $dca0ddb82b882518$var$commitHostSingletonAcquisition(finishedWork);
        case 26:
        case 5:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            null === current && flags & 4 && $dca0ddb82b882518$var$commitHostMount(finishedWork);
            flags & 512 && $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 12:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            break;
        case 31:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $dca0ddb82b882518$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork);
            break;
        case 13:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $dca0ddb82b882518$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
            flags & 64 && (finishedRoot = finishedWork.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot && (finishedWork = $dca0ddb82b882518$var$retryDehydratedSuspenseBoundary.bind(null, finishedWork), $dca0ddb82b882518$var$registerSuspenseInstanceRetry(finishedRoot, finishedWork))));
            break;
        case 22:
            flags = null !== finishedWork.memoizedState || $dca0ddb82b882518$var$offscreenSubtreeIsHidden;
            if (!flags) {
                var newOffscreenSubtreeWasHidden = null !== current && null !== current.memoizedState || $dca0ddb82b882518$var$offscreenSubtreeWasHidden;
                current = $dca0ddb82b882518$var$offscreenSubtreeIsHidden;
                prevProps = $dca0ddb82b882518$var$offscreenSubtreeWasHidden;
                $dca0ddb82b882518$var$offscreenSubtreeIsHidden = flags;
                ($dca0ddb82b882518$var$offscreenSubtreeWasHidden = newOffscreenSubtreeWasHidden) && !prevProps ? (flags = 2, 0 !== (finishedWork.subtreeFlags & 8772) && (flags |= 1), $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, flags)) : $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
                $dca0ddb82b882518$var$offscreenSubtreeIsHidden = current;
                $dca0ddb82b882518$var$offscreenSubtreeWasHidden = prevProps;
            }
            break;
        case 30:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 512 && $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 7:
            flags & 512 && $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
        default:
            $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
    }
}
function $dca0ddb82b882518$var$hideOrUnhideAllChildren(parentFiber, isHidden) {
    for(parentFiber = parentFiber.child; null !== parentFiber;)$dca0ddb82b882518$var$hideOrUnhideAllChildrenOnFiber(parentFiber, isHidden), parentFiber = parentFiber.sibling;
}
function $dca0ddb82b882518$var$hideOrUnhideAllChildrenOnFiber(fiber, isHidden) {
    switch(fiber.tag){
        case 5:
        case 26:
            try {
                var instance = fiber.stateNode;
                if (isHidden) {
                    var style = instance.style;
                    "function" === typeof style.setProperty ? style.setProperty("display", "none", "important") : style.display = "none";
                } else {
                    var instance$jscomp$0 = fiber.stateNode, styleProp = fiber.memoizedProps.style, display = void 0 !== styleProp && null !== styleProp && styleProp.hasOwnProperty("display") ? styleProp.display : null;
                    instance$jscomp$0.style.display = null == display || "boolean" === typeof display ? "" : ("" + display).trim();
                }
            } catch (error) {
                $dca0ddb82b882518$var$captureCommitPhaseError(fiber, fiber.return, error);
            }
            $dca0ddb82b882518$var$hideOrUnhideNearestPortals(fiber, isHidden);
            break;
        case 6:
            try {
                fiber.stateNode.nodeValue = isHidden ? "" : fiber.memoizedProps, $dca0ddb82b882518$var$viewTransitionMutationContext = !0;
            } catch (error) {
                $dca0ddb82b882518$var$captureCommitPhaseError(fiber, fiber.return, error);
            }
            break;
        case 18:
            try {
                var instance$jscomp$1 = fiber.stateNode;
                isHidden ? $dca0ddb82b882518$var$hideOrUnhideDehydratedBoundary(instance$jscomp$1, !0) : $dca0ddb82b882518$var$hideOrUnhideDehydratedBoundary(fiber.stateNode, !1);
            } catch (error) {
                $dca0ddb82b882518$var$captureCommitPhaseError(fiber, fiber.return, error);
            }
            break;
        case 22:
        case 23:
            null === fiber.memoizedState && $dca0ddb82b882518$var$hideOrUnhideAllChildren(fiber, isHidden);
            break;
        default:
            $dca0ddb82b882518$var$hideOrUnhideAllChildren(fiber, isHidden);
    }
}
function $dca0ddb82b882518$var$hideOrUnhideNearestPortals(parentFiber, isHidden$jscomp$0) {
    if (parentFiber.subtreeFlags & 67108864) for(parentFiber = parentFiber.child; null !== parentFiber;){
        a: {
            var fiber = parentFiber, isHidden = isHidden$jscomp$0;
            switch(fiber.tag){
                case 4:
                    $dca0ddb82b882518$var$hideOrUnhideAllChildrenOnFiber(fiber, isHidden);
                    break a;
                case 22:
                    null === fiber.memoizedState && $dca0ddb82b882518$var$hideOrUnhideNearestPortals(fiber, isHidden);
                    break a;
                default:
                    $dca0ddb82b882518$var$hideOrUnhideNearestPortals(fiber, isHidden);
            }
        }
        parentFiber = parentFiber.sibling;
    }
}
function $dca0ddb82b882518$var$detachFiberAfterEffects(fiber) {
    var alternate = fiber.alternate;
    null !== alternate && (fiber.alternate = null, $dca0ddb82b882518$var$detachFiberAfterEffects(alternate));
    fiber.child = null;
    fiber.deletions = null;
    fiber.sibling = null;
    5 === fiber.tag && (alternate = fiber.stateNode, null !== alternate && $dca0ddb82b882518$var$detachDeletedInstance(alternate));
    fiber.stateNode = null;
    fiber.return = null;
    fiber.dependencies = null;
    fiber.memoizedProps = null;
    fiber.memoizedState = null;
    fiber.pendingProps = null;
    fiber.stateNode = null;
    fiber.updateQueue = null;
}
var $dca0ddb82b882518$var$hostParent = null, $dca0ddb82b882518$var$hostParentIsContainer = !1;
function $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, parent) {
    for(parent = parent.child; null !== parent;)$dca0ddb82b882518$var$commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, parent), parent = parent.sibling;
}
function $dca0ddb82b882518$var$commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, deletedFiber) {
    if ($dca0ddb82b882518$var$injectedHook && "function" === typeof $dca0ddb82b882518$var$injectedHook.onCommitFiberUnmount) try {
        $dca0ddb82b882518$var$injectedHook.onCommitFiberUnmount($dca0ddb82b882518$var$rendererID, deletedFiber);
    } catch (err) {}
    switch(deletedFiber.tag){
        case 26:
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden || $dca0ddb82b882518$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            deletedFiber.memoizedState ? deletedFiber.memoizedState.count-- : deletedFiber.stateNode && !$dca0ddb82b882518$var$offscreenSubtreeWasHidden && (deletedFiber = deletedFiber.stateNode, deletedFiber.parentNode.removeChild(deletedFiber));
            break;
        case 27:
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden || $dca0ddb82b882518$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            $dca0ddb82b882518$var$commitFragmentInstanceDeletionEffects(deletedFiber);
            var prevHostParent = $dca0ddb82b882518$var$hostParent, prevHostParentIsContainer = $dca0ddb82b882518$var$hostParentIsContainer;
            $dca0ddb82b882518$var$isSingletonScope(deletedFiber.type) && ($dca0ddb82b882518$var$hostParent = deletedFiber.stateNode, $dca0ddb82b882518$var$hostParentIsContainer = !1);
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $dca0ddb82b882518$var$releaseSingletonInstance(deletedFiber.stateNode, deletedFiber.type, deletedFiber.memoizedProps);
            $dca0ddb82b882518$var$hostParent = prevHostParent;
            $dca0ddb82b882518$var$hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 5:
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden || $dca0ddb82b882518$var$safelyDetachRef(deletedFiber, nearestMountedAncestor), $dca0ddb82b882518$var$commitFragmentInstanceDeletionEffects(deletedFiber);
        case 6:
            6 === deletedFiber.tag && $dca0ddb82b882518$var$commitFragmentInstanceDeletionEffects(deletedFiber);
            prevHostParent = $dca0ddb82b882518$var$hostParent;
            prevHostParentIsContainer = $dca0ddb82b882518$var$hostParentIsContainer;
            $dca0ddb82b882518$var$hostParent = null;
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $dca0ddb82b882518$var$hostParent = prevHostParent;
            $dca0ddb82b882518$var$hostParentIsContainer = prevHostParentIsContainer;
            if (null !== $dca0ddb82b882518$var$hostParent) {
                if ($dca0ddb82b882518$var$hostParentIsContainer) try {
                    (9 === $dca0ddb82b882518$var$hostParent.nodeType ? $dca0ddb82b882518$var$hostParent.body : "HTML" === $dca0ddb82b882518$var$hostParent.nodeName ? $dca0ddb82b882518$var$hostParent.ownerDocument.body : $dca0ddb82b882518$var$hostParent).removeChild(deletedFiber.stateNode), $dca0ddb82b882518$var$viewTransitionMutationContext = !0;
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
                else try {
                    $dca0ddb82b882518$var$hostParent.removeChild(deletedFiber.stateNode), $dca0ddb82b882518$var$viewTransitionMutationContext = !0;
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
            }
            break;
        case 18:
            null !== $dca0ddb82b882518$var$hostParent && ($dca0ddb82b882518$var$hostParentIsContainer ? (finishedRoot = $dca0ddb82b882518$var$hostParent, $dca0ddb82b882518$var$clearHydrationBoundary(9 === finishedRoot.nodeType ? finishedRoot.body : "HTML" === finishedRoot.nodeName ? finishedRoot.ownerDocument.body : finishedRoot, deletedFiber.stateNode), $dca0ddb82b882518$var$retryIfBlockedOn(finishedRoot)) : $dca0ddb82b882518$var$clearHydrationBoundary($dca0ddb82b882518$var$hostParent, deletedFiber.stateNode));
            break;
        case 4:
            prevHostParent = $dca0ddb82b882518$var$hostParent;
            prevHostParentIsContainer = $dca0ddb82b882518$var$hostParentIsContainer;
            $dca0ddb82b882518$var$hostParent = deletedFiber.stateNode.containerInfo;
            $dca0ddb82b882518$var$hostParentIsContainer = !0;
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $dca0ddb82b882518$var$hostParent = prevHostParent;
            $dca0ddb82b882518$var$hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            $dca0ddb82b882518$var$commitHookEffectListUnmount(2, deletedFiber, nearestMountedAncestor);
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden || $dca0ddb82b882518$var$commitHookEffectListUnmount(4, deletedFiber, nearestMountedAncestor);
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 1:
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden || ($dca0ddb82b882518$var$safelyDetachRef(deletedFiber, nearestMountedAncestor), prevHostParent = deletedFiber.stateNode, "function" === typeof prevHostParent.componentWillUnmount && $dca0ddb82b882518$var$safelyCallComponentWillUnmount(deletedFiber, nearestMountedAncestor, prevHostParent));
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 21:
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 22:
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden = (prevHostParent = $dca0ddb82b882518$var$offscreenSubtreeWasHidden) || null !== deletedFiber.memoizedState;
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden = prevHostParent;
            break;
        case 30:
            $dca0ddb82b882518$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 7:
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden || $dca0ddb82b882518$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        default:
            $dca0ddb82b882518$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
    }
}
function $dca0ddb82b882518$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork) {
    if (null === finishedWork.memoizedState && (finishedRoot = finishedWork.alternate, null !== finishedRoot && (finishedRoot = finishedRoot.memoizedState, null !== finishedRoot))) {
        finishedRoot = finishedRoot.dehydrated;
        try {
            $dca0ddb82b882518$var$retryIfBlockedOn(finishedRoot);
        } catch (error) {
            $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
}
function $dca0ddb82b882518$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork) {
    if (null === finishedWork.memoizedState && (finishedRoot = finishedWork.alternate, null !== finishedRoot && (finishedRoot = finishedRoot.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot)))) try {
        $dca0ddb82b882518$var$retryIfBlockedOn(finishedRoot);
    } catch (error) {
        $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $dca0ddb82b882518$var$getRetryCache(finishedWork) {
    switch(finishedWork.tag){
        case 31:
        case 13:
        case 19:
            var retryCache = finishedWork.stateNode;
            null === retryCache && (retryCache = finishedWork.stateNode = new $dca0ddb82b882518$var$PossiblyWeakSet());
            return retryCache;
        case 22:
            return finishedWork = finishedWork.stateNode, retryCache = finishedWork._retryCache, null === retryCache && (retryCache = finishedWork._retryCache = new $dca0ddb82b882518$var$PossiblyWeakSet()), retryCache;
        default:
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(435, finishedWork.tag));
    }
}
function $dca0ddb82b882518$var$attachSuspenseRetryListeners(finishedWork, wakeables) {
    var retryCache = $dca0ddb82b882518$var$getRetryCache(finishedWork);
    wakeables.forEach(function(wakeable) {
        if (!retryCache.has(wakeable)) {
            retryCache.add(wakeable);
            var retry = $dca0ddb82b882518$var$resolveRetryWakeable.bind(null, finishedWork, wakeable);
            wakeable.then(retry, retry);
        }
    });
}
function $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root$jscomp$0, parentFiber, lanes) {
    var deletions = parentFiber.deletions;
    if (null !== deletions) for(var i = 0; i < deletions.length; i++){
        var childToDelete = deletions[i], root = root$jscomp$0, returnFiber = parentFiber, parent = returnFiber;
        a: for(; null !== parent;){
            switch(parent.tag){
                case 27:
                    if ($dca0ddb82b882518$var$isSingletonScope(parent.type)) {
                        $dca0ddb82b882518$var$hostParent = parent.stateNode;
                        $dca0ddb82b882518$var$hostParentIsContainer = !1;
                        break a;
                    }
                    break;
                case 5:
                    $dca0ddb82b882518$var$hostParent = parent.stateNode;
                    $dca0ddb82b882518$var$hostParentIsContainer = !1;
                    break a;
                case 3:
                case 4:
                    $dca0ddb82b882518$var$hostParent = parent.stateNode.containerInfo;
                    $dca0ddb82b882518$var$hostParentIsContainer = !0;
                    break a;
            }
            parent = parent.return;
        }
        if (null === $dca0ddb82b882518$var$hostParent) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(160));
        $dca0ddb82b882518$var$commitDeletionEffectsOnFiber(root, returnFiber, childToDelete);
        $dca0ddb82b882518$var$hostParent = null;
        $dca0ddb82b882518$var$hostParentIsContainer = !1;
        root = childToDelete.alternate;
        null !== root && (root.return = null);
        childToDelete.return = null;
    }
    if (parentFiber.subtreeFlags & 13886) for(parentFiber = parentFiber.child; null !== parentFiber;)$dca0ddb82b882518$var$commitMutationEffectsOnFiber(parentFiber, root$jscomp$0, lanes), parentFiber = parentFiber.sibling;
}
var $dca0ddb82b882518$var$currentHoistableRoot = null;
function $dca0ddb82b882518$var$commitMutationEffectsOnFiber(finishedWork, root, lanes) {
    var current = finishedWork.alternate, flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            if (flags & 4 && (current = finishedWork.updateQueue, current = null !== current ? current.events : null, null !== current)) for(var ii = 0; ii < current.length; ii++){
                var _eventPayloads$ii2 = current[ii];
                _eventPayloads$ii2.ref.impl = _eventPayloads$ii2.nextImpl;
            }
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 4 && ($dca0ddb82b882518$var$commitHookEffectListUnmount(3, finishedWork, finishedWork.return), $dca0ddb82b882518$var$commitHookEffectListMount(3, finishedWork), $dca0ddb82b882518$var$commitHookEffectListUnmount(5, finishedWork, finishedWork.return));
            break;
        case 1:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($dca0ddb82b882518$var$offscreenSubtreeWasHidden || null === current || $dca0ddb82b882518$var$safelyDetachRef(current, current.return));
            flags & 64 && $dca0ddb82b882518$var$offscreenSubtreeIsHidden && (finishedWork = finishedWork.updateQueue, null !== finishedWork && (root = finishedWork.callbacks, null !== root && (lanes = finishedWork.shared.hiddenCallbacks, finishedWork.shared.hiddenCallbacks = null === lanes ? root : lanes.concat(root))));
            break;
        case 26:
            ii = $dca0ddb82b882518$var$currentHoistableRoot;
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($dca0ddb82b882518$var$offscreenSubtreeWasHidden || null === current || $dca0ddb82b882518$var$safelyDetachRef(current, current.return));
            if (flags & 4) {
                if (flags = null !== current ? current.memoizedState : null, lanes = finishedWork.memoizedState, null === current) {
                    if (null === lanes) {
                        if (null === finishedWork.stateNode) {
                            if ($dca0ddb82b882518$var$offscreenSubtreeIsHidden) finishedWork.stateNode = $dca0ddb82b882518$var$createHoistableInstance(finishedWork.type, finishedWork.memoizedProps, root.containerInfo, finishedWork);
                            else {
                                a: {
                                    root = finishedWork.type;
                                    lanes = finishedWork.memoizedProps;
                                    flags = ii.ownerDocument || ii;
                                    b: switch(root){
                                        case "title":
                                            current = flags.getElementsByTagName("title")[0];
                                            if (!current || current[$dca0ddb82b882518$var$internalHoistableMarker] || current[$dca0ddb82b882518$var$internalInstanceKey] || "http://www.w3.org/2000/svg" === current.namespaceURI || current.hasAttribute("itemprop")) current = flags.createElement(root), flags.head.insertBefore(current, flags.querySelector("head > title"));
                                            $dca0ddb82b882518$var$setInitialProperties(current, root, lanes);
                                            current[$dca0ddb82b882518$var$internalInstanceKey] = finishedWork;
                                            $dca0ddb82b882518$var$markNodeAsHoistable(current);
                                            root = current;
                                            break a;
                                        case "link":
                                            if (ii = $dca0ddb82b882518$var$getHydratableHoistableCache("link", "href", flags).get(root + (lanes.href || ""))) {
                                                for(_eventPayloads$ii2 = 0; _eventPayloads$ii2 < ii.length; _eventPayloads$ii2++)if (current = ii[_eventPayloads$ii2], current.getAttribute("href") === (null == lanes.href || "" === lanes.href ? null : lanes.href) && current.getAttribute("rel") === (null == lanes.rel ? null : lanes.rel) && current.getAttribute("title") === (null == lanes.title ? null : lanes.title) && current.getAttribute("crossorigin") === (null == lanes.crossOrigin ? null : lanes.crossOrigin)) {
                                                    ii.splice(_eventPayloads$ii2, 1);
                                                    break b;
                                                }
                                            }
                                            current = flags.createElement(root);
                                            $dca0ddb82b882518$var$setInitialProperties(current, root, lanes);
                                            flags.head.appendChild(current);
                                            break;
                                        case "meta":
                                            if (ii = $dca0ddb82b882518$var$getHydratableHoistableCache("meta", "content", flags).get(root + (lanes.content || ""))) {
                                                for(_eventPayloads$ii2 = 0; _eventPayloads$ii2 < ii.length; _eventPayloads$ii2++)if (current = ii[_eventPayloads$ii2], current.getAttribute("content") === (null == lanes.content ? null : "" + lanes.content) && current.getAttribute("name") === (null == lanes.name ? null : lanes.name) && current.getAttribute("property") === (null == lanes.property ? null : lanes.property) && current.getAttribute("http-equiv") === (null == lanes.httpEquiv ? null : lanes.httpEquiv) && current.getAttribute("charset") === (null == lanes.charSet ? null : lanes.charSet)) {
                                                    ii.splice(_eventPayloads$ii2, 1);
                                                    break b;
                                                }
                                            }
                                            current = flags.createElement(root);
                                            $dca0ddb82b882518$var$setInitialProperties(current, root, lanes);
                                            flags.head.appendChild(current);
                                            break;
                                        default:
                                            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(468, root));
                                    }
                                    current[$dca0ddb82b882518$var$internalInstanceKey] = finishedWork;
                                    $dca0ddb82b882518$var$markNodeAsHoistable(current);
                                    root = current;
                                }
                                finishedWork.stateNode = root;
                            }
                        } else $dca0ddb82b882518$var$offscreenSubtreeIsHidden || $dca0ddb82b882518$var$mountHoistable(ii, finishedWork.type, finishedWork.stateNode);
                    } else finishedWork.stateNode = $dca0ddb82b882518$var$acquireResource(ii, lanes, finishedWork.memoizedProps);
                } else flags !== lanes ? (null === flags ? (root = current.stateNode, null === root || $dca0ddb82b882518$var$offscreenSubtreeWasHidden || root.parentNode.removeChild(root)) : flags.count--, null === lanes ? $dca0ddb82b882518$var$offscreenSubtreeIsHidden || $dca0ddb82b882518$var$mountHoistable(ii, finishedWork.type, finishedWork.stateNode) : $dca0ddb82b882518$var$acquireResource(ii, lanes, finishedWork.memoizedProps)) : null === lanes && null !== finishedWork.stateNode && $dca0ddb82b882518$var$commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
            }
            break;
        case 27:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($dca0ddb82b882518$var$offscreenSubtreeWasHidden || null === current || $dca0ddb82b882518$var$safelyDetachRef(current, current.return));
            null !== current && flags & 4 && $dca0ddb82b882518$var$commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
            break;
        case 5:
            ii = $dca0ddb82b882518$var$offscreenDirectParentIsHidden;
            $dca0ddb82b882518$var$offscreenDirectParentIsHidden = !1;
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $dca0ddb82b882518$var$offscreenDirectParentIsHidden = ii;
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($dca0ddb82b882518$var$offscreenSubtreeWasHidden || null === current || $dca0ddb82b882518$var$safelyDetachRef(current, current.return));
            if (finishedWork.flags & 32) {
                root = finishedWork.stateNode;
                try {
                    $dca0ddb82b882518$var$setTextContent(root, ""), $dca0ddb82b882518$var$viewTransitionMutationContext = !0;
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            flags & 4 && null != finishedWork.stateNode && (root = finishedWork.memoizedProps, $dca0ddb82b882518$var$commitHostUpdate(finishedWork, root, null !== current ? current.memoizedProps : root));
            flags & 1024 && ($dca0ddb82b882518$var$needsFormReset = !0);
            break;
        case 6:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            if (flags & 4) {
                if (null === finishedWork.stateNode) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(162));
                root = finishedWork.memoizedProps;
                lanes = finishedWork.stateNode;
                try {
                    lanes.nodeValue = root, $dca0ddb82b882518$var$viewTransitionMutationContext = !0;
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 3:
            $dca0ddb82b882518$var$viewTransitionMutationContext = !1;
            $dca0ddb82b882518$var$tagCaches = null;
            ii = $dca0ddb82b882518$var$currentHoistableRoot;
            $dca0ddb82b882518$var$currentHoistableRoot = $dca0ddb82b882518$var$getHoistableRoot(root.containerInfo);
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $dca0ddb82b882518$var$currentHoistableRoot = ii;
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            if (flags & 4 && null !== current && current.memoizedState.isDehydrated) try {
                $dca0ddb82b882518$var$retryIfBlockedOn(root.containerInfo);
            } catch (error) {
                $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
            }
            $dca0ddb82b882518$var$needsFormReset && ($dca0ddb82b882518$var$needsFormReset = !1, $dca0ddb82b882518$var$recursivelyResetForms(finishedWork));
            $dca0ddb82b882518$var$viewTransitionMutationContext = !1;
            break;
        case 4:
            flags = $dca0ddb82b882518$var$offscreenDirectParentIsHidden;
            $dca0ddb82b882518$var$offscreenDirectParentIsHidden = $dca0ddb82b882518$var$offscreenSubtreeIsHidden;
            current = $dca0ddb82b882518$var$pushMutationContext();
            ii = $dca0ddb82b882518$var$currentHoistableRoot;
            $dca0ddb82b882518$var$currentHoistableRoot = $dca0ddb82b882518$var$getHoistableRoot(finishedWork.stateNode.containerInfo);
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            $dca0ddb82b882518$var$currentHoistableRoot = ii;
            $dca0ddb82b882518$var$viewTransitionMutationContext && $dca0ddb82b882518$var$inUpdateViewTransition && ($dca0ddb82b882518$var$rootViewTransitionAffected = !0);
            $dca0ddb82b882518$var$viewTransitionMutationContext = current;
            $dca0ddb82b882518$var$offscreenDirectParentIsHidden = flags;
            break;
        case 12:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            break;
        case 31:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 4 && (root = finishedWork.updateQueue, null !== root && (finishedWork.updateQueue = null, $dca0ddb82b882518$var$attachSuspenseRetryListeners(finishedWork, root)));
            break;
        case 13:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            finishedWork.child.flags & 8192 && null !== finishedWork.memoizedState !== (null !== current && null !== current.memoizedState) && ($dca0ddb82b882518$var$globalMostRecentFallbackTime = $dca0ddb82b882518$var$now());
            flags & 4 && (root = finishedWork.updateQueue, null !== root && (finishedWork.updateQueue = null, $dca0ddb82b882518$var$attachSuspenseRetryListeners(finishedWork, root)));
            break;
        case 22:
            ii = null !== finishedWork.memoizedState;
            _eventPayloads$ii2 = null !== current && null !== current.memoizedState;
            var prevOffscreenSubtreeIsHidden = $dca0ddb82b882518$var$offscreenSubtreeIsHidden, prevOffscreenSubtreeWasHidden = $dca0ddb82b882518$var$offscreenSubtreeWasHidden, prevOffscreenDirectParentIsHidden$166 = $dca0ddb82b882518$var$offscreenDirectParentIsHidden;
            $dca0ddb82b882518$var$offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden || ii;
            $dca0ddb82b882518$var$offscreenDirectParentIsHidden = prevOffscreenDirectParentIsHidden$166 || ii;
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden || _eventPayloads$ii2;
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $dca0ddb82b882518$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
            $dca0ddb82b882518$var$offscreenDirectParentIsHidden = prevOffscreenDirectParentIsHidden$166;
            $dca0ddb82b882518$var$offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden;
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 8192 && (root = finishedWork.stateNode, root._visibility = ii ? root._visibility & -2 : root._visibility | 1, !ii || null === current || _eventPayloads$ii2 || $dca0ddb82b882518$var$offscreenSubtreeIsHidden || $dca0ddb82b882518$var$offscreenSubtreeWasHidden || (root = _eventPayloads$ii2 || $dca0ddb82b882518$var$offscreenSubtreeWasHidden, lanes = $dca0ddb82b882518$var$offscreenSubtreeIsHidden, current = $dca0ddb82b882518$var$offscreenSubtreeWasHidden, $dca0ddb82b882518$var$offscreenSubtreeIsHidden = ii || $dca0ddb82b882518$var$offscreenSubtreeIsHidden, $dca0ddb82b882518$var$offscreenSubtreeWasHidden = root, $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork, 2), $dca0ddb82b882518$var$offscreenSubtreeIsHidden = lanes, $dca0ddb82b882518$var$offscreenSubtreeWasHidden = current), !ii && $dca0ddb82b882518$var$offscreenDirectParentIsHidden || $dca0ddb82b882518$var$hideOrUnhideAllChildren(finishedWork, ii));
            flags & 4 && (root = finishedWork.updateQueue, null !== root && (lanes = root.retryQueue, null !== lanes && (root.retryQueue = null, $dca0ddb82b882518$var$attachSuspenseRetryListeners(finishedWork, lanes))));
            break;
        case 19:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            flags & 4 && (root = finishedWork.updateQueue, null !== root && (finishedWork.updateQueue = null, $dca0ddb82b882518$var$attachSuspenseRetryListeners(finishedWork, root)));
            break;
        case 30:
            flags & 512 && ($dca0ddb82b882518$var$offscreenSubtreeWasHidden || null === current || $dca0ddb82b882518$var$safelyDetachRef(current, current.return));
            flags = $dca0ddb82b882518$var$pushMutationContext();
            ii = $dca0ddb82b882518$var$inUpdateViewTransition;
            _eventPayloads$ii2 = (lanes & 335544064) === lanes;
            prevOffscreenSubtreeIsHidden = finishedWork.memoizedProps;
            $dca0ddb82b882518$var$inUpdateViewTransition = _eventPayloads$ii2 && "none" !== $dca0ddb82b882518$var$getViewTransitionClassName(prevOffscreenSubtreeIsHidden.default, prevOffscreenSubtreeIsHidden.update);
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
            _eventPayloads$ii2 && null !== current && $dca0ddb82b882518$var$viewTransitionMutationContext && (finishedWork.flags |= 4);
            $dca0ddb82b882518$var$inUpdateViewTransition = ii;
            $dca0ddb82b882518$var$viewTransitionMutationContext = flags;
            break;
        case 21:
            break;
        case 7:
            flags & 512 && ($dca0ddb82b882518$var$offscreenSubtreeWasHidden || null === current || $dca0ddb82b882518$var$safelyDetachRef(current, current.return)), current && null !== current.stateNode && (current.stateNode._fragmentFiber = finishedWork);
        default:
            $dca0ddb82b882518$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes), $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork);
    }
}
function $dca0ddb82b882518$var$commitReconciliationEffects(finishedWork) {
    var flags = finishedWork.flags;
    if (flags & 2) {
        try {
            for(var hostParentFiber, parentFiber = finishedWork.return; null !== parentFiber;){
                if ($dca0ddb82b882518$var$isHostParent(parentFiber)) {
                    hostParentFiber = parentFiber;
                    break;
                }
                parentFiber = parentFiber.return;
            }
            parentFiber = null;
            for(var parent = finishedWork.return; null !== parent;){
                if ($dca0ddb82b882518$var$isFragmentInstanceParent(parent)) {
                    var fragmentInstance = parent.stateNode;
                    null === parentFiber ? parentFiber = [
                        fragmentInstance
                    ] : parentFiber.push(fragmentInstance);
                }
                if ($dca0ddb82b882518$var$isFragmentInstanceHostBoundary(parent)) break;
                parent = parent.return;
            }
            var JSCompiler_inline_result = parentFiber;
            if (null == hostParentFiber) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(160));
            switch(hostParentFiber.tag){
                case 27:
                    var parent$jscomp$0 = hostParentFiber.stateNode, before = $dca0ddb82b882518$var$getHostSibling(finishedWork);
                    $dca0ddb82b882518$var$insertOrAppendPlacementNode(finishedWork, before, parent$jscomp$0, JSCompiler_inline_result);
                    break;
                case 5:
                    var parent$149 = hostParentFiber.stateNode;
                    hostParentFiber.flags & 32 && ($dca0ddb82b882518$var$setTextContent(parent$149, ""), hostParentFiber.flags &= -33);
                    var before$150 = $dca0ddb82b882518$var$getHostSibling(finishedWork);
                    $dca0ddb82b882518$var$insertOrAppendPlacementNode(finishedWork, before$150, parent$149, JSCompiler_inline_result);
                    break;
                case 3:
                case 4:
                    var parent$151 = hostParentFiber.stateNode.containerInfo, before$152 = $dca0ddb82b882518$var$getHostSibling(finishedWork);
                    $dca0ddb82b882518$var$insertOrAppendPlacementNodeIntoContainer(finishedWork, before$152, parent$151, JSCompiler_inline_result);
                    break;
                default:
                    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(161));
            }
        } catch (error) {
            $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
        finishedWork.flags &= -3;
    }
    flags & 4096 && (finishedWork.flags &= -4097);
}
function $dca0ddb82b882518$var$recursivelyResetForms(parentFiber) {
    if (parentFiber.subtreeFlags & 1024) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var fiber = parentFiber;
        $dca0ddb82b882518$var$recursivelyResetForms(fiber);
        5 === fiber.tag && fiber.flags & 1024 && (fiber = fiber.stateNode, $dca0ddb82b882518$var$_enabled = !0, fiber.reset(), $dca0ddb82b882518$var$_enabled = !1);
        parentFiber = parentFiber.sibling;
    }
}
function $dca0ddb82b882518$var$recursivelyTraverseAfterMutationEffects(root, parentFiber) {
    if (parentFiber.subtreeFlags & 9270) for(parentFiber = parentFiber.child; null !== parentFiber;)$dca0ddb82b882518$var$commitAfterMutationEffectsOnFiber(parentFiber, root), parentFiber = parentFiber.sibling;
    else $dca0ddb82b882518$var$measureNestedViewTransitions(parentFiber, !1);
}
function $dca0ddb82b882518$var$commitAfterMutationEffectsOnFiber(finishedWork, root) {
    var current = finishedWork.alternate;
    if (null === current) $dca0ddb82b882518$var$commitEnterViewTransitions(finishedWork, !1);
    else switch(finishedWork.tag){
        case 3:
            $dca0ddb82b882518$var$rootViewTransitionNameCanceled = $dca0ddb82b882518$var$viewTransitionContextChanged = !1;
            $dca0ddb82b882518$var$pushViewTransitionCancelableScope();
            $dca0ddb82b882518$var$recursivelyTraverseAfterMutationEffects(root, finishedWork);
            if (!$dca0ddb82b882518$var$viewTransitionContextChanged && !$dca0ddb82b882518$var$rootViewTransitionAffected) {
                finishedWork = $dca0ddb82b882518$var$viewTransitionCancelableChildren;
                if (null !== finishedWork) for(var i = 0; i < finishedWork.length; i += 3){
                    current = finishedWork[i];
                    var oldName = finishedWork[i + 1];
                    $dca0ddb82b882518$var$restoreViewTransitionName(current, finishedWork[i + 2]);
                    current = current.ownerDocument.documentElement;
                    null !== current && current.animate({
                        opacity: [
                            0,
                            0
                        ],
                        pointerEvents: [
                            "none",
                            "none"
                        ]
                    }, {
                        duration: 0,
                        fill: "forwards",
                        pseudoElement: "::view-transition-group(" + oldName + ")"
                    });
                }
                finishedWork = root.containerInfo;
                finishedWork = 9 === finishedWork.nodeType ? finishedWork.documentElement : finishedWork.ownerDocument.documentElement;
                null !== finishedWork && "" === finishedWork.style.viewTransitionName && (finishedWork.style.viewTransitionName = "none", finishedWork.animate({
                    opacity: [
                        0,
                        0
                    ],
                    pointerEvents: [
                        "none",
                        "none"
                    ]
                }, {
                    duration: 0,
                    fill: "forwards",
                    pseudoElement: "::view-transition-group(root)"
                }), finishedWork.animate({
                    width: [
                        0,
                        0
                    ],
                    height: [
                        0,
                        0
                    ]
                }, {
                    duration: 0,
                    fill: "forwards",
                    pseudoElement: "::view-transition"
                }));
                $dca0ddb82b882518$var$rootViewTransitionNameCanceled = !0;
            }
            $dca0ddb82b882518$var$viewTransitionCancelableChildren = null;
            break;
        case 5:
            $dca0ddb82b882518$var$recursivelyTraverseAfterMutationEffects(root, finishedWork);
            break;
        case 4:
            i = $dca0ddb82b882518$var$viewTransitionContextChanged;
            $dca0ddb82b882518$var$viewTransitionContextChanged = !1;
            $dca0ddb82b882518$var$recursivelyTraverseAfterMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$viewTransitionContextChanged && ($dca0ddb82b882518$var$rootViewTransitionAffected = !0);
            $dca0ddb82b882518$var$viewTransitionContextChanged = i;
            break;
        case 22:
            null === finishedWork.memoizedState && (null !== current.memoizedState ? $dca0ddb82b882518$var$commitEnterViewTransitions(finishedWork, !1) : $dca0ddb82b882518$var$recursivelyTraverseAfterMutationEffects(root, finishedWork));
            break;
        case 30:
            i = $dca0ddb82b882518$var$viewTransitionContextChanged;
            oldName = $dca0ddb82b882518$var$pushViewTransitionCancelableScope();
            $dca0ddb82b882518$var$viewTransitionContextChanged = !1;
            $dca0ddb82b882518$var$recursivelyTraverseAfterMutationEffects(root, finishedWork);
            $dca0ddb82b882518$var$viewTransitionContextChanged && (finishedWork.flags |= 4);
            var props = finishedWork.memoizedProps, state = finishedWork.stateNode;
            root = $dca0ddb82b882518$var$getViewTransitionName(props, state);
            state = $dca0ddb82b882518$var$getViewTransitionName(current.memoizedProps, state);
            var className = $dca0ddb82b882518$var$getViewTransitionClassName(props.default, props.update);
            "none" === className ? root = !1 : (props = current.memoizedState, current.memoizedState = null, current = finishedWork.child, $dca0ddb82b882518$var$viewTransitionHostInstanceIdx = 0, root = $dca0ddb82b882518$var$measureViewTransitionHostInstancesRecursive(finishedWork, current, root, state, className, props, !0), $dca0ddb82b882518$var$viewTransitionHostInstanceIdx !== (null === props ? 0 : props.length) && (finishedWork.flags |= 32));
            0 !== (finishedWork.flags & 4) && root ? ($dca0ddb82b882518$var$scheduleViewTransitionEvent(finishedWork, finishedWork.memoizedProps.onUpdate), $dca0ddb82b882518$var$viewTransitionCancelableChildren = oldName) : null !== oldName && (oldName.push.apply(oldName, $dca0ddb82b882518$var$viewTransitionCancelableChildren), $dca0ddb82b882518$var$viewTransitionCancelableChildren = oldName);
            $dca0ddb82b882518$var$viewTransitionContextChanged = 0 !== (finishedWork.flags & 32) ? !0 : i;
            break;
        default:
            $dca0ddb82b882518$var$recursivelyTraverseAfterMutationEffects(root, finishedWork);
    }
}
function $dca0ddb82b882518$var$recursivelyTraverseLayoutEffects(root, parentFiber) {
    if (parentFiber.subtreeFlags & 8772) for(parentFiber = parentFiber.child; null !== parentFiber;)$dca0ddb82b882518$var$commitLayoutEffectOnFiber(root, parentFiber.alternate, parentFiber), parentFiber = parentFiber.sibling;
}
function $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(parentFiber, layoutEffectTraversalFlags$jscomp$0) {
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedWork = parentFiber, layoutEffectTraversalFlags = layoutEffectTraversalFlags$jscomp$0;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 14:
            case 15:
                $dca0ddb82b882518$var$commitHookEffectListUnmount(4, finishedWork, finishedWork.return);
                $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork, layoutEffectTraversalFlags);
                break;
            case 1:
                $dca0ddb82b882518$var$safelyDetachRef(finishedWork, finishedWork.return);
                var instance = finishedWork.stateNode;
                "function" === typeof instance.componentWillUnmount && $dca0ddb82b882518$var$safelyCallComponentWillUnmount(finishedWork, finishedWork.return, instance);
                $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork, layoutEffectTraversalFlags);
                break;
            case 27:
                0 !== (layoutEffectTraversalFlags & 2) && $dca0ddb82b882518$var$releaseSingletonInstance(finishedWork.stateNode, finishedWork.type, finishedWork.memoizedProps);
            case 5:
                $dca0ddb82b882518$var$safelyDetachRef(finishedWork, finishedWork.return);
                5 !== finishedWork.tag && 27 !== finishedWork.tag || $dca0ddb82b882518$var$commitFragmentInstanceDeletionEffects(finishedWork);
                $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork, layoutEffectTraversalFlags);
                break;
            case 6:
                $dca0ddb82b882518$var$commitFragmentInstanceDeletionEffects(finishedWork);
                break;
            case 26:
                $dca0ddb82b882518$var$safelyDetachRef(finishedWork, finishedWork.return);
                instance = finishedWork.stateNode;
                null !== finishedWork.memoizedState || null === instance || $dca0ddb82b882518$var$offscreenSubtreeWasHidden || instance.parentNode.removeChild(instance);
                $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork, layoutEffectTraversalFlags);
                break;
            case 22:
                null === finishedWork.memoizedState && $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork, layoutEffectTraversalFlags);
                break;
            case 30:
                $dca0ddb82b882518$var$safelyDetachRef(finishedWork, finishedWork.return);
                $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork, layoutEffectTraversalFlags);
                break;
            case 7:
                $dca0ddb82b882518$var$safelyDetachRef(finishedWork, finishedWork.return);
            default:
                $dca0ddb82b882518$var$recursivelyTraverseDisappearLayoutEffects(finishedWork, layoutEffectTraversalFlags);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot$jscomp$0, parentFiber, layoutEffectTraversalFlags) {
    layoutEffectTraversalFlags = 0 !== (parentFiber.subtreeFlags & 8772) ? layoutEffectTraversalFlags : layoutEffectTraversalFlags & -2;
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var current = parentFiber.alternate, finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags, includeWorkInProgressEffects = 0 !== (layoutEffectTraversalFlags & 1);
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, layoutEffectTraversalFlags);
                $dca0ddb82b882518$var$commitHookEffectListMount(4, finishedWork);
                break;
            case 1:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, layoutEffectTraversalFlags);
                current = finishedWork;
                finishedRoot = current.stateNode;
                if ("function" === typeof finishedRoot.componentDidMount) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(current, current.return, error);
                }
                current = finishedWork;
                finishedRoot = current.updateQueue;
                if (null !== finishedRoot) {
                    var instance = current.stateNode;
                    try {
                        var hiddenCallbacks = finishedRoot.shared.hiddenCallbacks;
                        if (null !== hiddenCallbacks) for(finishedRoot.shared.hiddenCallbacks = null, finishedRoot = 0; finishedRoot < hiddenCallbacks.length; finishedRoot++)$dca0ddb82b882518$var$callCallback(hiddenCallbacks[finishedRoot], instance);
                    } catch (error) {
                        $dca0ddb82b882518$var$captureCommitPhaseError(current, current.return, error);
                    }
                }
                includeWorkInProgressEffects && flags & 64 && $dca0ddb82b882518$var$commitClassCallbacks(finishedWork);
                $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 27:
                0 !== (layoutEffectTraversalFlags & 2) && $dca0ddb82b882518$var$commitHostSingletonAcquisition(finishedWork);
            case 5:
                5 !== finishedWork.tag && 27 !== finishedWork.tag || $dca0ddb82b882518$var$commitFragmentInstanceInsertionEffects(finishedWork);
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, layoutEffectTraversalFlags);
                includeWorkInProgressEffects && null === current && flags & 4 && $dca0ddb82b882518$var$commitHostMount(finishedWork);
                $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 6:
                $dca0ddb82b882518$var$commitFragmentInstanceInsertionEffects(finishedWork);
                break;
            case 26:
                instance = finishedWork.stateNode;
                null !== finishedWork.memoizedState || null === instance || $dca0ddb82b882518$var$offscreenSubtreeIsHidden || $dca0ddb82b882518$var$mountHoistable($dca0ddb82b882518$var$getHoistableRoot(instance.ownerDocument), finishedWork.type, instance);
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, layoutEffectTraversalFlags);
                includeWorkInProgressEffects && null === current && flags & 4 && $dca0ddb82b882518$var$commitHostMount(finishedWork);
                $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 12:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, layoutEffectTraversalFlags);
                break;
            case 31:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, layoutEffectTraversalFlags);
                includeWorkInProgressEffects && flags & 4 && $dca0ddb82b882518$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case 13:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, layoutEffectTraversalFlags);
                includeWorkInProgressEffects && flags & 4 && $dca0ddb82b882518$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case 22:
                null === finishedWork.memoizedState && $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, layoutEffectTraversalFlags);
                $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 30:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, layoutEffectTraversalFlags);
                $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 7:
                $dca0ddb82b882518$var$safelyAttachRef(finishedWork, finishedWork.return);
            default:
                $dca0ddb82b882518$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, layoutEffectTraversalFlags);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $dca0ddb82b882518$var$commitOffscreenPassiveMountEffects(current, finishedWork) {
    var previousCache = null;
    null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (previousCache = current.memoizedState.cachePool.pool);
    current = null;
    null !== finishedWork.memoizedState && null !== finishedWork.memoizedState.cachePool && (current = finishedWork.memoizedState.cachePool.pool);
    current !== previousCache && (null != current && current.refCount++, null != previousCache && $dca0ddb82b882518$var$releaseCache(previousCache));
}
function $dca0ddb82b882518$var$commitCachePassiveMountEffect(current, finishedWork) {
    current = null;
    null !== finishedWork.alternate && (current = finishedWork.alternate.memoizedState.cache);
    finishedWork = finishedWork.memoizedState.cache;
    finishedWork !== current && (finishedWork.refCount++, null != current && $dca0ddb82b882518$var$releaseCache(current));
}
function $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(root, parentFiber, committedLanes, committedTransitions) {
    var isViewTransitionEligible = (committedLanes & 335544064) === committedLanes;
    if (parentFiber.subtreeFlags & (isViewTransitionEligible ? 10262 : 10256)) for(parentFiber = parentFiber.child; null !== parentFiber;)$dca0ddb82b882518$var$commitPassiveMountOnFiber(root, parentFiber, committedLanes, committedTransitions), parentFiber = parentFiber.sibling;
    else isViewTransitionEligible && $dca0ddb82b882518$var$restoreNestedViewTransitions(parentFiber);
}
function $dca0ddb82b882518$var$commitPassiveMountOnFiber(finishedRoot, finishedWork, committedLanes, committedTransitions) {
    var isViewTransitionEligible = (committedLanes & 335544064) === committedLanes;
    isViewTransitionEligible && null === finishedWork.alternate && null !== finishedWork.return && null !== finishedWork.return.alternate && $dca0ddb82b882518$var$restoreEnterOrExitViewTransitions(finishedWork);
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && $dca0ddb82b882518$var$commitHookEffectListMount(9, finishedWork);
            break;
        case 1:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 3:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            isViewTransitionEligible && $dca0ddb82b882518$var$rootViewTransitionNameCanceled && (finishedRoot = finishedRoot.containerInfo, finishedRoot = 9 === finishedRoot.nodeType ? finishedRoot.body : "HTML" === finishedRoot.nodeName ? finishedRoot.ownerDocument.body : finishedRoot, "root" === finishedRoot.style.viewTransitionName && (finishedRoot.style.viewTransitionName = ""), finishedRoot = finishedRoot.ownerDocument.documentElement, null !== finishedRoot && "none" === finishedRoot.style.viewTransitionName && (finishedRoot.style.viewTransitionName = ""));
            flags & 2048 && (flags = null, null !== finishedWork.alternate && (flags = finishedWork.alternate.memoizedState.cache), finishedWork = finishedWork.memoizedState.cache, finishedWork !== flags && (finishedWork.refCount++, null != flags && $dca0ddb82b882518$var$releaseCache(flags)));
            break;
        case 12:
            if (flags & 2048) {
                $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
                flags = finishedWork.stateNode;
                try {
                    var _finishedWork$memoize2 = finishedWork.memoizedProps, id = _finishedWork$memoize2.id, onPostCommit = _finishedWork$memoize2.onPostCommit;
                    "function" === typeof onPostCommit && onPostCommit(id, null === finishedWork.alternate ? "mount" : "update", flags.passiveEffectDuration, -0);
                } catch (error) {
                    $dca0ddb82b882518$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            } else $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 31:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 13:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 23:
            break;
        case 22:
            _finishedWork$memoize2 = finishedWork.stateNode;
            id = finishedWork.alternate;
            null !== finishedWork.memoizedState ? (isViewTransitionEligible && null !== id && null === id.memoizedState && $dca0ddb82b882518$var$restoreEnterOrExitViewTransitions(id), _finishedWork$memoize2._visibility & 2 ? $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork)) : (isViewTransitionEligible && null !== id && null !== id.memoizedState && $dca0ddb82b882518$var$restoreEnterOrExitViewTransitions(finishedWork), _finishedWork$memoize2._visibility & 2 ? $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : (_finishedWork$memoize2._visibility |= 2, $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, 0 !== (finishedWork.subtreeFlags & 10256) || !1)));
            flags & 2048 && $dca0ddb82b882518$var$commitOffscreenPassiveMountEffects(id, finishedWork);
            break;
        case 24:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && $dca0ddb82b882518$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
            break;
        case 30:
            isViewTransitionEligible && (flags = finishedWork.alternate, null !== flags && ($dca0ddb82b882518$var$restoreViewTransitionOnHostInstances(flags.child, !0), $dca0ddb82b882518$var$restoreViewTransitionOnHostInstances(finishedWork.child, !0)));
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        default:
            $dca0ddb82b882518$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
    }
}
function $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot$jscomp$0, parentFiber, committedLanes$jscomp$0, committedTransitions$jscomp$0, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && (0 !== (parentFiber.subtreeFlags & 10256) || !1);
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, committedLanes = committedLanes$jscomp$0, committedTransitions = committedTransitions$jscomp$0, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                $dca0ddb82b882518$var$commitHookEffectListMount(8, finishedWork);
                break;
            case 23:
                break;
            case 22:
                var instance = finishedWork.stateNode;
                null !== finishedWork.memoizedState ? instance._visibility & 2 ? $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects) : $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : (instance._visibility |= 2, $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects));
                includeWorkInProgressEffects && flags & 2048 && $dca0ddb82b882518$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 2048 && $dca0ddb82b882518$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                $dca0ddb82b882518$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot$jscomp$0, parentFiber) {
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 22:
                $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && $dca0ddb82b882518$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && $dca0ddb82b882518$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                $dca0ddb82b882518$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
        }
        parentFiber = parentFiber.sibling;
    }
}
var $dca0ddb82b882518$var$suspenseyCommitFlag = 8192;
function $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(parentFiber, committedLanes, suspendedState) {
    if (parentFiber.subtreeFlags & $dca0ddb82b882518$var$suspenseyCommitFlag) for(parentFiber = parentFiber.child; null !== parentFiber;)$dca0ddb82b882518$var$accumulateSuspenseyCommitOnFiber(parentFiber, committedLanes, suspendedState), parentFiber = parentFiber.sibling;
}
function $dca0ddb82b882518$var$accumulateSuspenseyCommitOnFiber(fiber, committedLanes, suspendedState) {
    switch(fiber.tag){
        case 26:
            $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            fiber.flags & $dca0ddb82b882518$var$suspenseyCommitFlag && (null !== fiber.memoizedState ? $dca0ddb82b882518$var$suspendResource(suspendedState, $dca0ddb82b882518$var$currentHoistableRoot, fiber.memoizedState, fiber.memoizedProps) : (fiber = fiber.stateNode, (committedLanes & 335544128) === committedLanes && $dca0ddb82b882518$var$suspendInstance(suspendedState, fiber)));
            break;
        case 5:
            $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            fiber.flags & $dca0ddb82b882518$var$suspenseyCommitFlag && (fiber = fiber.stateNode, (committedLanes & 335544128) === committedLanes && $dca0ddb82b882518$var$suspendInstance(suspendedState, fiber));
            break;
        case 3:
        case 4:
            var previousHoistableRoot = $dca0ddb82b882518$var$currentHoistableRoot;
            $dca0ddb82b882518$var$currentHoistableRoot = $dca0ddb82b882518$var$getHoistableRoot(fiber.stateNode.containerInfo);
            $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            $dca0ddb82b882518$var$currentHoistableRoot = previousHoistableRoot;
            break;
        case 22:
            null === fiber.memoizedState && (previousHoistableRoot = fiber.alternate, null !== previousHoistableRoot && null !== previousHoistableRoot.memoizedState ? (previousHoistableRoot = $dca0ddb82b882518$var$suspenseyCommitFlag, $dca0ddb82b882518$var$suspenseyCommitFlag = 16777216, $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState), $dca0ddb82b882518$var$suspenseyCommitFlag = previousHoistableRoot) : $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState));
            break;
        case 30:
            if (0 !== (fiber.flags & $dca0ddb82b882518$var$suspenseyCommitFlag) && (previousHoistableRoot = fiber.memoizedProps.name, null != previousHoistableRoot && "auto" !== previousHoistableRoot)) {
                var state = fiber.stateNode;
                state.paired = null;
                null === $dca0ddb82b882518$var$appearingViewTransitions && ($dca0ddb82b882518$var$appearingViewTransitions = new Map());
                $dca0ddb82b882518$var$appearingViewTransitions.set(previousHoistableRoot, state);
            }
            $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            break;
        default:
            $dca0ddb82b882518$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
    }
}
function $dca0ddb82b882518$var$detachAlternateSiblings(parentFiber) {
    var previousFiber = parentFiber.alternate;
    if (null !== previousFiber && (parentFiber = previousFiber.child, null !== parentFiber)) {
        previousFiber.child = null;
        do previousFiber = parentFiber.sibling, parentFiber.sibling = null, parentFiber = previousFiber;
        while (null !== parentFiber);
    }
}
function $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            $dca0ddb82b882518$var$nextEffect = childToDelete;
            $dca0ddb82b882518$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        $dca0ddb82b882518$var$detachAlternateSiblings(parentFiber);
    }
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)$dca0ddb82b882518$var$commitPassiveUnmountOnFiber(parentFiber), parentFiber = parentFiber.sibling;
}
function $dca0ddb82b882518$var$commitPassiveUnmountOnFiber(finishedWork) {
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            finishedWork.flags & 2048 && $dca0ddb82b882518$var$commitHookEffectListUnmount(9, finishedWork, finishedWork.return);
            break;
        case 3:
            $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 12:
            $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 22:
            var instance = finishedWork.stateNode;
            null !== finishedWork.memoizedState && instance._visibility & 2 && (null === finishedWork.return || 13 !== finishedWork.return.tag) ? (instance._visibility &= -3, $dca0ddb82b882518$var$recursivelyTraverseDisconnectPassiveEffects(finishedWork)) : $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        default:
            $dca0ddb82b882518$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
    }
}
function $dca0ddb82b882518$var$recursivelyTraverseDisconnectPassiveEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            $dca0ddb82b882518$var$nextEffect = childToDelete;
            $dca0ddb82b882518$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        $dca0ddb82b882518$var$detachAlternateSiblings(parentFiber);
    }
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        deletions = parentFiber;
        switch(deletions.tag){
            case 0:
            case 11:
            case 15:
                $dca0ddb82b882518$var$commitHookEffectListUnmount(8, deletions, deletions.return);
                $dca0ddb82b882518$var$recursivelyTraverseDisconnectPassiveEffects(deletions);
                break;
            case 22:
                i = deletions.stateNode;
                i._visibility & 2 && (i._visibility &= -3, $dca0ddb82b882518$var$recursivelyTraverseDisconnectPassiveEffects(deletions));
                break;
            default:
                $dca0ddb82b882518$var$recursivelyTraverseDisconnectPassiveEffects(deletions);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $dca0ddb82b882518$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(deletedSubtreeRoot, nearestMountedAncestor) {
    for(; null !== $dca0ddb82b882518$var$nextEffect;){
        var fiber = $dca0ddb82b882518$var$nextEffect;
        switch(fiber.tag){
            case 0:
            case 11:
            case 15:
                $dca0ddb82b882518$var$commitHookEffectListUnmount(8, fiber, nearestMountedAncestor);
                break;
            case 23:
            case 22:
                if (null !== fiber.memoizedState && null !== fiber.memoizedState.cachePool) {
                    var cache = fiber.memoizedState.cachePool.pool;
                    null != cache && cache.refCount++;
                }
                break;
            case 24:
                $dca0ddb82b882518$var$releaseCache(fiber.memoizedState.cache);
        }
        cache = fiber.child;
        if (null !== cache) cache.return = fiber, $dca0ddb82b882518$var$nextEffect = cache;
        else a: for(fiber = deletedSubtreeRoot; null !== $dca0ddb82b882518$var$nextEffect;){
            cache = $dca0ddb82b882518$var$nextEffect;
            var sibling = cache.sibling, returnFiber = cache.return;
            $dca0ddb82b882518$var$detachFiberAfterEffects(cache);
            if (cache === fiber) {
                $dca0ddb82b882518$var$nextEffect = null;
                break a;
            }
            if (null !== sibling) {
                sibling.return = returnFiber;
                $dca0ddb82b882518$var$nextEffect = sibling;
                break a;
            }
            $dca0ddb82b882518$var$nextEffect = returnFiber;
        }
    }
}
var $dca0ddb82b882518$var$DefaultAsyncDispatcher = {
    getCacheForType: function(resourceType) {
        var cache = $dca0ddb82b882518$var$readContext($dca0ddb82b882518$var$CacheContext), cacheForType = cache.data.get(resourceType);
        void 0 === cacheForType && (cacheForType = resourceType(), cache.data.set(resourceType, cacheForType));
        return cacheForType;
    },
    cacheSignal: function() {
        return $dca0ddb82b882518$var$readContext($dca0ddb82b882518$var$CacheContext).controller.signal;
    }
}, $dca0ddb82b882518$var$PossiblyWeakMap = "function" === typeof WeakMap ? WeakMap : Map, $dca0ddb82b882518$var$executionContext = 0, $dca0ddb82b882518$var$workInProgressRoot = null, $dca0ddb82b882518$var$workInProgress = null, $dca0ddb82b882518$var$workInProgressRootRenderLanes = 0, $dca0ddb82b882518$var$workInProgressSuspendedReason = 0, $dca0ddb82b882518$var$workInProgressThrownValue = null, $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings = !1, $dca0ddb82b882518$var$workInProgressRootIsPrerendering = !1, $dca0ddb82b882518$var$workInProgressRootDidAttachPingListener = !1, $dca0ddb82b882518$var$entangledRenderLanes = 0, $dca0ddb82b882518$var$workInProgressRootExitStatus = 0, $dca0ddb82b882518$var$workInProgressRootSkippedLanes = 0, $dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes = 0, $dca0ddb82b882518$var$workInProgressRootPingedLanes = 0, $dca0ddb82b882518$var$workInProgressDeferredLane = 0, $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes = 0, $dca0ddb82b882518$var$workInProgressRootConcurrentErrors = null, $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = null, $dca0ddb82b882518$var$workInProgressRootDidIncludeRecursiveRenderUpdate = !1, $dca0ddb82b882518$var$globalMostRecentFallbackTime = 0, $dca0ddb82b882518$var$globalMostRecentTransitionTime = 0, $dca0ddb82b882518$var$workInProgressRootRenderTargetTime = Infinity, $dca0ddb82b882518$var$workInProgressTransitions = null, $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed = null, $dca0ddb82b882518$var$pendingEffectsStatus = 0, $dca0ddb82b882518$var$pendingEffectsRoot = null, $dca0ddb82b882518$var$pendingFinishedWork = null, $dca0ddb82b882518$var$pendingEffectsLanes = 0, $dca0ddb82b882518$var$pendingEffectsRemainingLanes = 0, $dca0ddb82b882518$var$pendingPassiveTransitions = null, $dca0ddb82b882518$var$pendingRecoverableErrors = null, $dca0ddb82b882518$var$pendingViewTransition = null, $dca0ddb82b882518$var$pendingViewTransitionEvents = null, $dca0ddb82b882518$var$pendingTransitionTypes = null, $dca0ddb82b882518$var$nestedUpdateCount = 0, $dca0ddb82b882518$var$rootWithNestedUpdates = null;
function $dca0ddb82b882518$var$requestUpdateLane() {
    return 0 !== ($dca0ddb82b882518$var$executionContext & 2) && 0 !== $dca0ddb82b882518$var$workInProgressRootRenderLanes ? $dca0ddb82b882518$var$workInProgressRootRenderLanes & -$dca0ddb82b882518$var$workInProgressRootRenderLanes : null !== $dca0ddb82b882518$var$ReactSharedInternals.T ? $dca0ddb82b882518$var$requestTransitionLane() : $dca0ddb82b882518$var$resolveUpdatePriority();
}
function $dca0ddb82b882518$var$requestDeferredLane() {
    if (0 === $dca0ddb82b882518$var$workInProgressDeferredLane) {
        if (0 === ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 536870912) || $dca0ddb82b882518$var$isHydrating) {
            var lane = $dca0ddb82b882518$var$nextTransitionDeferredLane;
            $dca0ddb82b882518$var$nextTransitionDeferredLane <<= 1;
            0 === ($dca0ddb82b882518$var$nextTransitionDeferredLane & 3932160) && ($dca0ddb82b882518$var$nextTransitionDeferredLane = 262144);
            $dca0ddb82b882518$var$workInProgressDeferredLane = lane;
        } else $dca0ddb82b882518$var$workInProgressDeferredLane = 536870912;
    }
    lane = $dca0ddb82b882518$var$suspenseHandlerStackCursor.current;
    null !== lane && (lane.flags |= 32);
    return $dca0ddb82b882518$var$workInProgressDeferredLane;
}
function $dca0ddb82b882518$var$scheduleViewTransitionEvent(fiber, callback) {
    if (null != callback) {
        var state = fiber.stateNode, instance = state.ref;
        null === instance && (instance = state.ref = $dca0ddb82b882518$var$createViewTransitionInstance($dca0ddb82b882518$var$getViewTransitionName(fiber.memoizedProps, state)));
        null === $dca0ddb82b882518$var$pendingViewTransitionEvents && ($dca0ddb82b882518$var$pendingViewTransitionEvents = []);
        $dca0ddb82b882518$var$pendingViewTransitionEvents.push(callback.bind(null, instance));
    }
}
function $dca0ddb82b882518$var$scheduleUpdateOnFiber(root, fiber, lane) {
    if (root === $dca0ddb82b882518$var$workInProgressRoot && (2 === $dca0ddb82b882518$var$workInProgressSuspendedReason || 9 === $dca0ddb82b882518$var$workInProgressSuspendedReason) || null !== root.cancelPendingCommit) $dca0ddb82b882518$var$prepareFreshStack(root, 0), $dca0ddb82b882518$var$markRootSuspended(root, $dca0ddb82b882518$var$workInProgressRootRenderLanes, $dca0ddb82b882518$var$workInProgressDeferredLane, !1);
    $dca0ddb82b882518$var$markRootUpdated$1(root, lane);
    if (0 === ($dca0ddb82b882518$var$executionContext & 2) || root !== $dca0ddb82b882518$var$workInProgressRoot) root === $dca0ddb82b882518$var$workInProgressRoot && (0 === ($dca0ddb82b882518$var$executionContext & 2) && ($dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes |= lane), 4 === $dca0ddb82b882518$var$workInProgressRootExitStatus && $dca0ddb82b882518$var$markRootSuspended(root, $dca0ddb82b882518$var$workInProgressRootRenderLanes, $dca0ddb82b882518$var$workInProgressDeferredLane, !1)), $dca0ddb82b882518$var$ensureRootIsScheduled(root);
}
function $dca0ddb82b882518$var$performWorkOnRoot(root$jscomp$0, lanes, forceSync) {
    if (0 !== ($dca0ddb82b882518$var$executionContext & 6)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(327));
    var shouldTimeSlice = !forceSync && 0 === (lanes & 127) && 0 === (lanes & root$jscomp$0.expiredLanes) || $dca0ddb82b882518$var$checkIfRootIsPrerendering(root$jscomp$0, lanes), exitStatus = shouldTimeSlice ? $dca0ddb82b882518$var$renderRootConcurrent(root$jscomp$0, lanes) : $dca0ddb82b882518$var$renderRootSync(root$jscomp$0, lanes, !0), renderWasConcurrent = shouldTimeSlice;
    do {
        if (0 === exitStatus) {
            $dca0ddb82b882518$var$workInProgressRootIsPrerendering && !shouldTimeSlice && $dca0ddb82b882518$var$markRootSuspended(root$jscomp$0, lanes, 0, !1);
            break;
        } else {
            forceSync = root$jscomp$0.current.alternate;
            if (renderWasConcurrent && !$dca0ddb82b882518$var$isRenderConsistentWithExternalStores(forceSync)) {
                exitStatus = $dca0ddb82b882518$var$renderRootSync(root$jscomp$0, lanes, !1);
                renderWasConcurrent = !1;
                continue;
            }
            if (2 === exitStatus) {
                renderWasConcurrent = lanes;
                if (root$jscomp$0.errorRecoveryDisabledLanes & renderWasConcurrent) var JSCompiler_inline_result = 0;
                else JSCompiler_inline_result = root$jscomp$0.pendingLanes & -536870913, JSCompiler_inline_result = 0 !== JSCompiler_inline_result ? JSCompiler_inline_result : JSCompiler_inline_result & 536870912 ? 536870912 : 0;
                if (0 !== JSCompiler_inline_result) {
                    lanes = JSCompiler_inline_result;
                    a: {
                        var root = root$jscomp$0;
                        exitStatus = $dca0ddb82b882518$var$workInProgressRootConcurrentErrors;
                        var wasRootDehydrated = root.current.memoizedState.isDehydrated;
                        wasRootDehydrated && ($dca0ddb82b882518$var$prepareFreshStack(root, JSCompiler_inline_result).flags |= 256);
                        JSCompiler_inline_result = $dca0ddb82b882518$var$renderRootSync(root, JSCompiler_inline_result, !1);
                        if (2 !== JSCompiler_inline_result && 6 !== JSCompiler_inline_result) {
                            if ($dca0ddb82b882518$var$workInProgressRootDidAttachPingListener && !wasRootDehydrated) {
                                root.errorRecoveryDisabledLanes |= renderWasConcurrent;
                                $dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes |= renderWasConcurrent;
                                exitStatus = 4;
                                break a;
                            }
                            renderWasConcurrent = $dca0ddb82b882518$var$workInProgressRootRecoverableErrors;
                            $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = exitStatus;
                            null !== renderWasConcurrent && (null === $dca0ddb82b882518$var$workInProgressRootRecoverableErrors ? $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = renderWasConcurrent : $dca0ddb82b882518$var$workInProgressRootRecoverableErrors.push.apply($dca0ddb82b882518$var$workInProgressRootRecoverableErrors, renderWasConcurrent));
                        }
                        exitStatus = JSCompiler_inline_result;
                    }
                    renderWasConcurrent = !1;
                    if (2 !== exitStatus) continue;
                }
            }
            if (1 === exitStatus) {
                $dca0ddb82b882518$var$prepareFreshStack(root$jscomp$0, 0);
                $dca0ddb82b882518$var$markRootSuspended(root$jscomp$0, lanes, 0, !0);
                break;
            }
            a: {
                shouldTimeSlice = root$jscomp$0;
                renderWasConcurrent = exitStatus;
                switch(renderWasConcurrent){
                    case 0:
                    case 1:
                        throw Error($dca0ddb82b882518$var$formatProdErrorMessage(345));
                    case 4:
                        if ((lanes & 4194048) !== lanes && (lanes & 62914560) !== lanes) break;
                    case 6:
                        $dca0ddb82b882518$var$markRootSuspended(shouldTimeSlice, lanes, $dca0ddb82b882518$var$workInProgressDeferredLane, !$dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings);
                        break a;
                    case 2:
                        $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = null;
                        break;
                    case 3:
                    case 5:
                        break;
                    default:
                        throw Error($dca0ddb82b882518$var$formatProdErrorMessage(329));
                }
                if ((lanes & 62914560) === lanes && (exitStatus = $dca0ddb82b882518$var$globalMostRecentFallbackTime + 300 - $dca0ddb82b882518$var$now(), 10 < exitStatus)) {
                    $dca0ddb82b882518$var$markRootSuspended(shouldTimeSlice, lanes, $dca0ddb82b882518$var$workInProgressDeferredLane, !$dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings);
                    if (0 !== $dca0ddb82b882518$var$getNextLanes(shouldTimeSlice, 0, !0)) break a;
                    $dca0ddb82b882518$var$pendingEffectsLanes = lanes;
                    shouldTimeSlice.timeoutHandle = $dca0ddb82b882518$var$scheduleTimeout($dca0ddb82b882518$var$completeRootWhenReady.bind(null, shouldTimeSlice, forceSync, $dca0ddb82b882518$var$workInProgressRootRecoverableErrors, $dca0ddb82b882518$var$workInProgressTransitions, $dca0ddb82b882518$var$workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, $dca0ddb82b882518$var$workInProgressDeferredLane, $dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes, $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes, $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings, renderWasConcurrent, "Throttled", -0, 0), exitStatus);
                    break a;
                }
                $dca0ddb82b882518$var$completeRootWhenReady(shouldTimeSlice, forceSync, $dca0ddb82b882518$var$workInProgressRootRecoverableErrors, $dca0ddb82b882518$var$workInProgressTransitions, $dca0ddb82b882518$var$workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, $dca0ddb82b882518$var$workInProgressDeferredLane, $dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes, $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes, $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings, renderWasConcurrent, null, -0, 0);
            }
        }
        break;
    }while (1);
    $dca0ddb82b882518$var$ensureRootIsScheduled(root$jscomp$0);
}
function $dca0ddb82b882518$var$completeRootWhenReady(root, finishedWork, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, lanes, spawnedLane, updatedLanes, suspendedRetryLanes, didSkipSuspendedSiblings, exitStatus, suspendedCommitReason, completedRenderStartTime, completedRenderEndTime) {
    root.timeoutHandle = -1;
    var subtreeFlags = finishedWork.subtreeFlags, isViewTransitionEligible = (lanes & 335544064) === lanes;
    suspendedCommitReason = null;
    if (isViewTransitionEligible || subtreeFlags & 8192 || 16785408 === (subtreeFlags & 16785408)) {
        if (suspendedCommitReason = {
            stylesheets: null,
            count: 0,
            imgCount: 0,
            imgBytes: 0,
            suspenseyImages: [],
            waitingForImages: !0,
            waitingForViewTransition: !1,
            unsuspend: $dca0ddb82b882518$var$noop$1
        }, $dca0ddb82b882518$var$appearingViewTransitions = null, $dca0ddb82b882518$var$accumulateSuspenseyCommitOnFiber(finishedWork, lanes, suspendedCommitReason), isViewTransitionEligible && (subtreeFlags = suspendedCommitReason, isViewTransitionEligible = root.containerInfo, isViewTransitionEligible = (9 === isViewTransitionEligible.nodeType ? isViewTransitionEligible : isViewTransitionEligible.ownerDocument).__reactViewTransition, null != isViewTransitionEligible && (subtreeFlags.count++, subtreeFlags.waitingForViewTransition = !0, subtreeFlags = $dca0ddb82b882518$var$onUnsuspend.bind(subtreeFlags), isViewTransitionEligible.finished.then(subtreeFlags, subtreeFlags))), subtreeFlags = (lanes & 62914560) === lanes ? $dca0ddb82b882518$var$globalMostRecentFallbackTime - $dca0ddb82b882518$var$now() : (lanes & 4194048) === lanes ? $dca0ddb82b882518$var$globalMostRecentTransitionTime - $dca0ddb82b882518$var$now() : 0, subtreeFlags = $dca0ddb82b882518$var$waitForCommitToBeReady(suspendedCommitReason, subtreeFlags), null !== subtreeFlags) {
            $dca0ddb82b882518$var$pendingEffectsLanes = lanes;
            root.cancelPendingCommit = subtreeFlags($dca0ddb82b882518$var$completeRoot.bind(null, root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes, didSkipSuspendedSiblings, exitStatus, suspendedCommitReason, null, completedRenderStartTime, completedRenderEndTime));
            $dca0ddb82b882518$var$markRootSuspended(root, lanes, spawnedLane, !didSkipSuspendedSiblings);
            return;
        }
    }
    $dca0ddb82b882518$var$completeRoot(root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes, didSkipSuspendedSiblings, exitStatus, suspendedCommitReason);
}
function $dca0ddb82b882518$var$isRenderConsistentWithExternalStores(finishedWork) {
    for(var node = finishedWork;;){
        var tag = node.tag;
        if ((0 === tag || 11 === tag || 15 === tag) && node.flags & 16384 && (tag = node.updateQueue, null !== tag && (tag = tag.stores, null !== tag))) for(var i = 0; i < tag.length; i++){
            var check = tag[i], getSnapshot = check.getSnapshot;
            check = check.value;
            try {
                if (!$dca0ddb82b882518$var$objectIs(getSnapshot(), check)) return !1;
            } catch (error) {
                return !1;
            }
        }
        tag = node.child;
        if (node.subtreeFlags & 16384 && null !== tag) tag.return = node, node = tag;
        else {
            if (node === finishedWork) break;
            for(; null === node.sibling;){
                if (null === node.return || node.return === finishedWork) return !0;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        }
    }
    return !0;
}
function $dca0ddb82b882518$var$markRootSuspended(root, suspendedLanes, spawnedLane, didAttemptEntireTree) {
    suspendedLanes = $dca0ddb82b882518$var$getEntangledLanes(root, suspendedLanes);
    suspendedLanes &= ~$dca0ddb82b882518$var$workInProgressRootPingedLanes;
    suspendedLanes &= ~$dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes;
    root.suspendedLanes |= suspendedLanes;
    root.pingedLanes &= ~suspendedLanes;
    didAttemptEntireTree && (root.warmLanes |= suspendedLanes);
    didAttemptEntireTree = root.expirationTimes;
    for(var lanes = suspendedLanes; 0 < lanes;){
        var index$6 = 31 - $dca0ddb82b882518$var$clz32(lanes), lane = 1 << index$6;
        didAttemptEntireTree[index$6] = -1;
        lanes &= ~lane;
    }
    0 !== spawnedLane && $dca0ddb82b882518$var$markSpawnedDeferredLane(root, spawnedLane, suspendedLanes);
}
function $dca0ddb82b882518$var$flushSyncWork$1() {
    return 0 === ($dca0ddb82b882518$var$executionContext & 6) ? ($dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(0, !1), !1) : !0;
}
function $dca0ddb82b882518$var$resetWorkInProgressStack() {
    if (null !== $dca0ddb82b882518$var$workInProgress) {
        if (0 === $dca0ddb82b882518$var$workInProgressSuspendedReason) var interruptedWork = $dca0ddb82b882518$var$workInProgress.return;
        else interruptedWork = $dca0ddb82b882518$var$workInProgress, $dca0ddb82b882518$var$lastContextDependency = $dca0ddb82b882518$var$currentlyRenderingFiber$1 = null, $dca0ddb82b882518$var$resetHooksOnUnwind(interruptedWork), $dca0ddb82b882518$var$thenableState$1 = null, $dca0ddb82b882518$var$thenableIndexCounter$1 = 0, interruptedWork = $dca0ddb82b882518$var$workInProgress;
        for(; null !== interruptedWork;)$dca0ddb82b882518$var$unwindInterruptedWork(interruptedWork.alternate, interruptedWork), interruptedWork = interruptedWork.return;
        $dca0ddb82b882518$var$workInProgress = null;
    }
}
function $dca0ddb82b882518$var$prepareFreshStack(root, lanes) {
    var timeoutHandle = root.timeoutHandle;
    -1 !== timeoutHandle && (root.timeoutHandle = -1, $dca0ddb82b882518$var$cancelTimeout(timeoutHandle));
    timeoutHandle = root.cancelPendingCommit;
    null !== timeoutHandle && (root.cancelPendingCommit = null, timeoutHandle());
    $dca0ddb82b882518$var$pendingEffectsLanes = 0;
    $dca0ddb82b882518$var$resetWorkInProgressStack();
    $dca0ddb82b882518$var$workInProgressRoot = root;
    $dca0ddb82b882518$var$workInProgress = timeoutHandle = $dca0ddb82b882518$var$createWorkInProgress(root.current, null);
    $dca0ddb82b882518$var$workInProgressRootRenderLanes = lanes;
    $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
    $dca0ddb82b882518$var$workInProgressThrownValue = null;
    $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings = !1;
    $dca0ddb82b882518$var$workInProgressRootIsPrerendering = $dca0ddb82b882518$var$checkIfRootIsPrerendering(root, lanes);
    $dca0ddb82b882518$var$workInProgressRootDidAttachPingListener = !1;
    $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes = $dca0ddb82b882518$var$workInProgressDeferredLane = $dca0ddb82b882518$var$workInProgressRootPingedLanes = $dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes = $dca0ddb82b882518$var$workInProgressRootSkippedLanes = $dca0ddb82b882518$var$workInProgressRootExitStatus = 0;
    $dca0ddb82b882518$var$workInProgressRootRecoverableErrors = $dca0ddb82b882518$var$workInProgressRootConcurrentErrors = null;
    $dca0ddb82b882518$var$workInProgressRootDidIncludeRecursiveRenderUpdate = !1;
    $dca0ddb82b882518$var$entangledRenderLanes = $dca0ddb82b882518$var$getEntangledLanes(root, lanes);
    $dca0ddb82b882518$var$finishQueueingConcurrentUpdates();
    return timeoutHandle;
}
function $dca0ddb82b882518$var$handleThrow(root, thrownValue) {
    $dca0ddb82b882518$var$currentlyRenderingFiber = null;
    $dca0ddb82b882518$var$ReactSharedInternals.H = $dca0ddb82b882518$var$ContextOnlyDispatcher;
    thrownValue === $dca0ddb82b882518$var$SuspenseException || thrownValue === $dca0ddb82b882518$var$SuspenseActionException ? (thrownValue = $dca0ddb82b882518$var$getSuspendedThenable(), $dca0ddb82b882518$var$workInProgressSuspendedReason = 3) : thrownValue === $dca0ddb82b882518$var$SuspenseyCommitException ? (thrownValue = $dca0ddb82b882518$var$getSuspendedThenable(), $dca0ddb82b882518$var$workInProgressSuspendedReason = 4) : $dca0ddb82b882518$var$workInProgressSuspendedReason = thrownValue === $dca0ddb82b882518$var$SelectiveHydrationException ? 8 : null !== thrownValue && "object" === typeof thrownValue && "function" === typeof thrownValue.then ? 6 : 1;
    $dca0ddb82b882518$var$workInProgressThrownValue = thrownValue;
    null === $dca0ddb82b882518$var$workInProgress && ($dca0ddb82b882518$var$workInProgressRootExitStatus = 1, $dca0ddb82b882518$var$logUncaughtError(root, $dca0ddb82b882518$var$createCapturedValueAtFiber(thrownValue, root.current)));
}
function $dca0ddb82b882518$var$shouldRemainOnPreviousScreen() {
    var handler = $dca0ddb82b882518$var$suspenseHandlerStackCursor.current;
    return null === handler ? !0 : ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 4194048) === $dca0ddb82b882518$var$workInProgressRootRenderLanes ? null === $dca0ddb82b882518$var$shellBoundary ? !0 : !1 : ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 62914560) === $dca0ddb82b882518$var$workInProgressRootRenderLanes || 0 !== ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 536870912) ? handler === $dca0ddb82b882518$var$shellBoundary : !1;
}
function $dca0ddb82b882518$var$pushDispatcher() {
    var prevDispatcher = $dca0ddb82b882518$var$ReactSharedInternals.H;
    $dca0ddb82b882518$var$ReactSharedInternals.H = $dca0ddb82b882518$var$ContextOnlyDispatcher;
    return null === prevDispatcher ? $dca0ddb82b882518$var$ContextOnlyDispatcher : prevDispatcher;
}
function $dca0ddb82b882518$var$pushAsyncDispatcher() {
    var prevAsyncDispatcher = $dca0ddb82b882518$var$ReactSharedInternals.A;
    $dca0ddb82b882518$var$ReactSharedInternals.A = $dca0ddb82b882518$var$DefaultAsyncDispatcher;
    return prevAsyncDispatcher;
}
function $dca0ddb82b882518$var$renderDidSuspendDelayIfPossible() {
    $dca0ddb82b882518$var$workInProgressRootExitStatus = 4;
    $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings || ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 4194048) !== $dca0ddb82b882518$var$workInProgressRootRenderLanes && null !== $dca0ddb82b882518$var$suspenseHandlerStackCursor.current || ($dca0ddb82b882518$var$workInProgressRootIsPrerendering = !0);
    0 === ($dca0ddb82b882518$var$workInProgressRootSkippedLanes & 134217727) && 0 === ($dca0ddb82b882518$var$workInProgressRootInterleavedUpdatedLanes & 134217727) || null === $dca0ddb82b882518$var$workInProgressRoot || $dca0ddb82b882518$var$markRootSuspended($dca0ddb82b882518$var$workInProgressRoot, $dca0ddb82b882518$var$workInProgressRootRenderLanes, $dca0ddb82b882518$var$workInProgressDeferredLane, !1);
}
function $dca0ddb82b882518$var$renderRootSync(root, lanes, shouldYieldForPrerendering) {
    var prevExecutionContext = $dca0ddb82b882518$var$executionContext;
    $dca0ddb82b882518$var$executionContext |= 2;
    var prevDispatcher = $dca0ddb82b882518$var$pushDispatcher(), prevAsyncDispatcher = $dca0ddb82b882518$var$pushAsyncDispatcher();
    if ($dca0ddb82b882518$var$workInProgressRoot !== root || $dca0ddb82b882518$var$workInProgressRootRenderLanes !== lanes) $dca0ddb82b882518$var$workInProgressTransitions = null, $dca0ddb82b882518$var$prepareFreshStack(root, lanes);
    lanes = !1;
    var exitStatus = $dca0ddb82b882518$var$workInProgressRootExitStatus;
    a: do try {
        if (0 !== $dca0ddb82b882518$var$workInProgressSuspendedReason && null !== $dca0ddb82b882518$var$workInProgress) {
            var unitOfWork = $dca0ddb82b882518$var$workInProgress, thrownValue = $dca0ddb82b882518$var$workInProgressThrownValue;
            switch($dca0ddb82b882518$var$workInProgressSuspendedReason){
                case 8:
                    $dca0ddb82b882518$var$resetWorkInProgressStack();
                    exitStatus = 6;
                    break a;
                case 3:
                case 2:
                case 9:
                case 6:
                    null === $dca0ddb82b882518$var$suspenseHandlerStackCursor.current && (lanes = !0);
                    var reason = $dca0ddb82b882518$var$workInProgressSuspendedReason;
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                    $dca0ddb82b882518$var$workInProgressThrownValue = null;
                    $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
                    if (shouldYieldForPrerendering && $dca0ddb82b882518$var$workInProgressRootIsPrerendering) {
                        exitStatus = 0;
                        break a;
                    }
                    break;
                default:
                    reason = $dca0ddb82b882518$var$workInProgressSuspendedReason, $dca0ddb82b882518$var$workInProgressSuspendedReason = 0, $dca0ddb82b882518$var$workInProgressThrownValue = null, $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
            }
        }
        $dca0ddb82b882518$var$workLoopSync();
        exitStatus = $dca0ddb82b882518$var$workInProgressRootExitStatus;
        break;
    } catch (thrownValue$184) {
        $dca0ddb82b882518$var$handleThrow(root, thrownValue$184);
    }
    while (1);
    lanes && root.shellSuspendCounter++;
    $dca0ddb82b882518$var$lastContextDependency = $dca0ddb82b882518$var$currentlyRenderingFiber$1 = null;
    $dca0ddb82b882518$var$executionContext = prevExecutionContext;
    $dca0ddb82b882518$var$ReactSharedInternals.H = prevDispatcher;
    $dca0ddb82b882518$var$ReactSharedInternals.A = prevAsyncDispatcher;
    null === $dca0ddb82b882518$var$workInProgress && ($dca0ddb82b882518$var$workInProgressRoot = null, $dca0ddb82b882518$var$workInProgressRootRenderLanes = 0, $dca0ddb82b882518$var$finishQueueingConcurrentUpdates());
    return exitStatus;
}
function $dca0ddb82b882518$var$workLoopSync() {
    for(; null !== $dca0ddb82b882518$var$workInProgress;)$dca0ddb82b882518$var$performUnitOfWork($dca0ddb82b882518$var$workInProgress);
}
function $dca0ddb82b882518$var$renderRootConcurrent(root, lanes) {
    var prevExecutionContext = $dca0ddb82b882518$var$executionContext;
    $dca0ddb82b882518$var$executionContext |= 2;
    var prevDispatcher = $dca0ddb82b882518$var$pushDispatcher(), prevAsyncDispatcher = $dca0ddb82b882518$var$pushAsyncDispatcher();
    $dca0ddb82b882518$var$workInProgressRoot !== root || $dca0ddb82b882518$var$workInProgressRootRenderLanes !== lanes ? ($dca0ddb82b882518$var$workInProgressTransitions = null, $dca0ddb82b882518$var$workInProgressRootRenderTargetTime = $dca0ddb82b882518$var$now() + 500, $dca0ddb82b882518$var$prepareFreshStack(root, lanes)) : $dca0ddb82b882518$var$workInProgressRootIsPrerendering = $dca0ddb82b882518$var$checkIfRootIsPrerendering(root, lanes);
    a: do try {
        if (0 !== $dca0ddb82b882518$var$workInProgressSuspendedReason && null !== $dca0ddb82b882518$var$workInProgress) {
            lanes = $dca0ddb82b882518$var$workInProgress;
            var thrownValue = $dca0ddb82b882518$var$workInProgressThrownValue;
            b: switch($dca0ddb82b882518$var$workInProgressSuspendedReason){
                case 1:
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                    $dca0ddb82b882518$var$workInProgressThrownValue = null;
                    $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 1);
                    break;
                case 2:
                case 9:
                    if ($dca0ddb82b882518$var$isThenableResolved(thrownValue)) {
                        $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                        $dca0ddb82b882518$var$workInProgressThrownValue = null;
                        $dca0ddb82b882518$var$replaySuspendedUnitOfWork(lanes);
                        break;
                    }
                    lanes = function() {
                        2 !== $dca0ddb82b882518$var$workInProgressSuspendedReason && 9 !== $dca0ddb82b882518$var$workInProgressSuspendedReason || $dca0ddb82b882518$var$workInProgressRoot !== root || ($dca0ddb82b882518$var$workInProgressSuspendedReason = 7);
                        $dca0ddb82b882518$var$ensureRootIsScheduled(root);
                    };
                    thrownValue.then(lanes, lanes);
                    break a;
                case 3:
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 7;
                    break a;
                case 4:
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 5;
                    break a;
                case 7:
                    $dca0ddb82b882518$var$isThenableResolved(thrownValue) ? ($dca0ddb82b882518$var$workInProgressSuspendedReason = 0, $dca0ddb82b882518$var$workInProgressThrownValue = null, $dca0ddb82b882518$var$replaySuspendedUnitOfWork(lanes)) : ($dca0ddb82b882518$var$workInProgressSuspendedReason = 0, $dca0ddb82b882518$var$workInProgressThrownValue = null, $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 7));
                    break;
                case 5:
                    var resource = null;
                    switch($dca0ddb82b882518$var$workInProgress.tag){
                        case 26:
                            resource = $dca0ddb82b882518$var$workInProgress.memoizedState;
                        case 5:
                        case 27:
                            var hostFiber = $dca0ddb82b882518$var$workInProgress;
                            if (resource ? $dca0ddb82b882518$var$preloadResource(resource) : hostFiber.stateNode.complete) {
                                $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                                $dca0ddb82b882518$var$workInProgressThrownValue = null;
                                var sibling = hostFiber.sibling;
                                if (null !== sibling) $dca0ddb82b882518$var$workInProgress = sibling;
                                else {
                                    var returnFiber = hostFiber.return;
                                    null !== returnFiber ? ($dca0ddb82b882518$var$workInProgress = returnFiber, $dca0ddb82b882518$var$completeUnitOfWork(returnFiber)) : $dca0ddb82b882518$var$workInProgress = null;
                                }
                                break b;
                            }
                    }
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                    $dca0ddb82b882518$var$workInProgressThrownValue = null;
                    $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 5);
                    break;
                case 6:
                    $dca0ddb82b882518$var$workInProgressSuspendedReason = 0;
                    $dca0ddb82b882518$var$workInProgressThrownValue = null;
                    $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 6);
                    break;
                case 8:
                    $dca0ddb82b882518$var$resetWorkInProgressStack();
                    $dca0ddb82b882518$var$workInProgressRootExitStatus = 6;
                    break a;
                default:
                    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(462));
            }
        }
        $dca0ddb82b882518$var$workLoopConcurrentByScheduler();
        break;
    } catch (thrownValue$186) {
        $dca0ddb82b882518$var$handleThrow(root, thrownValue$186);
    }
    while (1);
    $dca0ddb82b882518$var$lastContextDependency = $dca0ddb82b882518$var$currentlyRenderingFiber$1 = null;
    $dca0ddb82b882518$var$ReactSharedInternals.H = prevDispatcher;
    $dca0ddb82b882518$var$ReactSharedInternals.A = prevAsyncDispatcher;
    $dca0ddb82b882518$var$executionContext = prevExecutionContext;
    if (null !== $dca0ddb82b882518$var$workInProgress) return 0;
    $dca0ddb82b882518$var$workInProgressRoot = null;
    $dca0ddb82b882518$var$workInProgressRootRenderLanes = 0;
    $dca0ddb82b882518$var$finishQueueingConcurrentUpdates();
    return $dca0ddb82b882518$var$workInProgressRootExitStatus;
}
function $dca0ddb82b882518$var$workLoopConcurrentByScheduler() {
    for(; null !== $dca0ddb82b882518$var$workInProgress && !$dca0ddb82b882518$var$shouldYield();)$dca0ddb82b882518$var$performUnitOfWork($dca0ddb82b882518$var$workInProgress);
}
function $dca0ddb82b882518$var$performUnitOfWork(unitOfWork) {
    var next = $dca0ddb82b882518$var$beginWork(unitOfWork.alternate, unitOfWork, $dca0ddb82b882518$var$entangledRenderLanes);
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? $dca0ddb82b882518$var$completeUnitOfWork(unitOfWork) : $dca0ddb82b882518$var$workInProgress = next;
}
function $dca0ddb82b882518$var$replaySuspendedUnitOfWork(unitOfWork) {
    var next = unitOfWork;
    var current = next.alternate;
    switch(next.tag){
        case 15:
        case 0:
            next = $dca0ddb82b882518$var$replayFunctionComponent(current, next, next.pendingProps, next.type, void 0, $dca0ddb82b882518$var$workInProgressRootRenderLanes);
            break;
        case 11:
            next = $dca0ddb82b882518$var$replayFunctionComponent(current, next, next.pendingProps, next.type.render, next.ref, $dca0ddb82b882518$var$workInProgressRootRenderLanes);
            break;
        case 5:
            $dca0ddb82b882518$var$resetHooksOnUnwind(next);
            var fiber = next;
            fiber === $dca0ddb82b882518$var$hydrationParentFiber && ($dca0ddb82b882518$var$isHydrating ? ($dca0ddb82b882518$var$popToNextHostParent(fiber), 5 === fiber.tag && null != fiber.stateNode && ($dca0ddb82b882518$var$nextHydratableInstance = fiber.stateNode)) : ($dca0ddb82b882518$var$popToNextHostParent(fiber), $dca0ddb82b882518$var$isHydrating = !0));
        default:
            $dca0ddb82b882518$var$unwindInterruptedWork(current, next), next = $dca0ddb82b882518$var$workInProgress = $dca0ddb82b882518$var$resetWorkInProgress(next, $dca0ddb82b882518$var$entangledRenderLanes), next = $dca0ddb82b882518$var$beginWork(current, next, $dca0ddb82b882518$var$entangledRenderLanes);
    }
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? $dca0ddb82b882518$var$completeUnitOfWork(unitOfWork) : $dca0ddb82b882518$var$workInProgress = next;
}
function $dca0ddb82b882518$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, suspendedReason) {
    $dca0ddb82b882518$var$lastContextDependency = $dca0ddb82b882518$var$currentlyRenderingFiber$1 = null;
    $dca0ddb82b882518$var$resetHooksOnUnwind(unitOfWork);
    $dca0ddb82b882518$var$thenableState$1 = null;
    $dca0ddb82b882518$var$thenableIndexCounter$1 = 0;
    var returnFiber = unitOfWork.return;
    try {
        if ($dca0ddb82b882518$var$throwException(root, returnFiber, unitOfWork, thrownValue, $dca0ddb82b882518$var$workInProgressRootRenderLanes)) {
            $dca0ddb82b882518$var$workInProgressRootExitStatus = 1;
            $dca0ddb82b882518$var$logUncaughtError(root, $dca0ddb82b882518$var$createCapturedValueAtFiber(thrownValue, root.current));
            $dca0ddb82b882518$var$workInProgress = null;
            return;
        }
    } catch (error) {
        if (null !== returnFiber) throw $dca0ddb82b882518$var$workInProgress = returnFiber, error;
        $dca0ddb82b882518$var$workInProgressRootExitStatus = 1;
        $dca0ddb82b882518$var$logUncaughtError(root, $dca0ddb82b882518$var$createCapturedValueAtFiber(thrownValue, root.current));
        $dca0ddb82b882518$var$workInProgress = null;
        return;
    }
    if (unitOfWork.flags & 32768) {
        if ($dca0ddb82b882518$var$isHydrating || 1 === suspendedReason) root = !0;
        else if ($dca0ddb82b882518$var$workInProgressRootIsPrerendering || 0 !== ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 536870912)) root = !1;
        else if ($dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings = root = !0, 2 === suspendedReason || 9 === suspendedReason || 3 === suspendedReason || 6 === suspendedReason) suspendedReason = $dca0ddb82b882518$var$suspenseHandlerStackCursor.current, null !== suspendedReason && 13 === suspendedReason.tag && (suspendedReason.flags |= 16384);
        $dca0ddb82b882518$var$unwindUnitOfWork(unitOfWork, root);
    } else $dca0ddb82b882518$var$completeUnitOfWork(unitOfWork);
}
function $dca0ddb82b882518$var$completeUnitOfWork(unitOfWork) {
    var completedWork = unitOfWork;
    do {
        if (0 !== (completedWork.flags & 32768)) {
            $dca0ddb82b882518$var$unwindUnitOfWork(completedWork, $dca0ddb82b882518$var$workInProgressRootDidSkipSuspendedSiblings);
            return;
        }
        unitOfWork = completedWork.return;
        var next = $dca0ddb82b882518$var$completeWork(completedWork.alternate, completedWork, $dca0ddb82b882518$var$entangledRenderLanes);
        if (null !== next) {
            $dca0ddb82b882518$var$workInProgress = next;
            return;
        }
        completedWork = completedWork.sibling;
        if (null !== completedWork) {
            $dca0ddb82b882518$var$workInProgress = completedWork;
            return;
        }
        $dca0ddb82b882518$var$workInProgress = completedWork = unitOfWork;
    }while (null !== completedWork);
    0 === $dca0ddb82b882518$var$workInProgressRootExitStatus && ($dca0ddb82b882518$var$workInProgressRootExitStatus = 5);
}
function $dca0ddb82b882518$var$unwindUnitOfWork(unitOfWork, skipSiblings) {
    do {
        var next = $dca0ddb82b882518$var$unwindWork(unitOfWork.alternate, unitOfWork);
        if (null !== next) {
            next.flags &= 32767;
            $dca0ddb82b882518$var$workInProgress = next;
            return;
        }
        next = unitOfWork.return;
        null !== next && (next.flags |= 32768, next.subtreeFlags = 0, next.deletions = null);
        if (!skipSiblings && (unitOfWork = unitOfWork.sibling, null !== unitOfWork)) {
            $dca0ddb82b882518$var$workInProgress = unitOfWork;
            return;
        }
        $dca0ddb82b882518$var$workInProgress = unitOfWork = next;
    }while (null !== unitOfWork);
    $dca0ddb82b882518$var$workInProgressRootExitStatus = 6;
    $dca0ddb82b882518$var$workInProgress = null;
}
function $dca0ddb82b882518$var$completeRoot(root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes, didSkipSuspendedSiblings, exitStatus, suspendedState) {
    root.cancelPendingCommit = null;
    do $dca0ddb82b882518$var$flushPendingEffects();
    while (0 !== $dca0ddb82b882518$var$pendingEffectsStatus);
    if (0 !== ($dca0ddb82b882518$var$executionContext & 6)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(327));
    if (null !== finishedWork) {
        if (finishedWork === root.current) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(177));
        root === $dca0ddb82b882518$var$workInProgressRoot && ($dca0ddb82b882518$var$workInProgress = $dca0ddb82b882518$var$workInProgressRoot = null, $dca0ddb82b882518$var$workInProgressRootRenderLanes = 0);
        $dca0ddb82b882518$var$pendingFinishedWork = finishedWork;
        $dca0ddb82b882518$var$pendingEffectsRoot = root;
        $dca0ddb82b882518$var$pendingEffectsLanes = lanes;
        $dca0ddb82b882518$var$pendingPassiveTransitions = transitions;
        $dca0ddb82b882518$var$pendingRecoverableErrors = recoverableErrors;
        $dca0ddb82b882518$var$commitRoot(root, finishedWork, lanes, spawnedLane, updatedLanes, suspendedRetryLanes, suspendedState);
    }
}
function $dca0ddb82b882518$var$commitRoot(root, finishedWork, lanes, spawnedLane, updatedLanes, suspendedRetryLanes, suspendedState) {
    var remainingLanes = finishedWork.lanes | finishedWork.childLanes;
    $dca0ddb82b882518$var$pendingEffectsRemainingLanes = remainingLanes;
    remainingLanes |= $dca0ddb82b882518$var$concurrentlyUpdatedLanes;
    $dca0ddb82b882518$var$markRootFinished(root, lanes, remainingLanes, spawnedLane, updatedLanes, suspendedRetryLanes);
    $dca0ddb82b882518$var$pendingViewTransitionEvents = null;
    (lanes & 335544064) === lanes ? ($dca0ddb82b882518$var$pendingTransitionTypes = $dca0ddb82b882518$var$claimQueuedTransitionTypes(root), spawnedLane = 10262) : ($dca0ddb82b882518$var$pendingTransitionTypes = null, spawnedLane = 10256);
    0 !== (finishedWork.subtreeFlags & spawnedLane) || 0 !== (finishedWork.flags & spawnedLane) ? (root.callbackNode = null, root.callbackPriority = 0, $dca0ddb82b882518$var$scheduleCallback$1($dca0ddb82b882518$var$NormalPriority$1, function() {
        $dca0ddb82b882518$var$flushPassiveEffects();
        return null;
    })) : (root.callbackNode = null, root.callbackPriority = 0);
    $dca0ddb82b882518$var$shouldStartViewTransition = !1;
    spawnedLane = 0 !== (finishedWork.flags & 13878);
    if (0 !== (finishedWork.subtreeFlags & 13878) || spawnedLane) {
        spawnedLane = $dca0ddb82b882518$var$ReactSharedInternals.T;
        $dca0ddb82b882518$var$ReactSharedInternals.T = null;
        updatedLanes = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 2;
        suspendedRetryLanes = $dca0ddb82b882518$var$executionContext;
        $dca0ddb82b882518$var$executionContext |= 4;
        try {
            $dca0ddb82b882518$var$commitBeforeMutationEffects(root, finishedWork, lanes);
        } finally{
            $dca0ddb82b882518$var$executionContext = suspendedRetryLanes, $dca0ddb82b882518$var$ReactDOMSharedInternals.p = updatedLanes, $dca0ddb82b882518$var$ReactSharedInternals.T = spawnedLane;
        }
    }
    $dca0ddb82b882518$var$pendingEffectsStatus = 1;
    $dca0ddb82b882518$var$shouldStartViewTransition ? $dca0ddb82b882518$var$pendingViewTransition = $dca0ddb82b882518$var$startViewTransition(suspendedState, root.containerInfo, $dca0ddb82b882518$var$pendingTransitionTypes, $dca0ddb82b882518$var$flushMutationEffects, $dca0ddb82b882518$var$flushLayoutEffects, $dca0ddb82b882518$var$flushAfterMutationEffects, $dca0ddb82b882518$var$flushSpawnedWork, $dca0ddb82b882518$var$flushPassiveEffects, $dca0ddb82b882518$var$reportViewTransitionError, null, null) : ($dca0ddb82b882518$var$flushMutationEffects(), $dca0ddb82b882518$var$flushLayoutEffects(), $dca0ddb82b882518$var$flushSpawnedWork());
}
function $dca0ddb82b882518$var$reportViewTransitionError(error) {
    if (0 !== $dca0ddb82b882518$var$pendingEffectsStatus) {
        var onRecoverableError = $dca0ddb82b882518$var$pendingEffectsRoot.onRecoverableError;
        onRecoverableError(error, {
            componentStack: null
        });
    }
}
function $dca0ddb82b882518$var$flushAfterMutationEffects() {
    3 === $dca0ddb82b882518$var$pendingEffectsStatus && ($dca0ddb82b882518$var$pendingEffectsStatus = 0, $dca0ddb82b882518$var$commitAfterMutationEffectsOnFiber($dca0ddb82b882518$var$pendingFinishedWork, $dca0ddb82b882518$var$pendingEffectsRoot), $dca0ddb82b882518$var$pendingEffectsStatus = 4);
}
function $dca0ddb82b882518$var$flushMutationEffects() {
    if (1 === $dca0ddb82b882518$var$pendingEffectsStatus) {
        $dca0ddb82b882518$var$pendingEffectsStatus = 0;
        var root = $dca0ddb82b882518$var$pendingEffectsRoot, finishedWork = $dca0ddb82b882518$var$pendingFinishedWork, lanes = $dca0ddb82b882518$var$pendingEffectsLanes, rootMutationHasEffect = 0 !== (finishedWork.flags & 13878);
        if (0 !== (finishedWork.subtreeFlags & 13878) || rootMutationHasEffect) {
            rootMutationHasEffect = $dca0ddb82b882518$var$ReactSharedInternals.T;
            $dca0ddb82b882518$var$ReactSharedInternals.T = null;
            var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
            $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 2;
            var prevExecutionContext = $dca0ddb82b882518$var$executionContext;
            $dca0ddb82b882518$var$executionContext |= 4;
            try {
                $dca0ddb82b882518$var$inUpdateViewTransition = $dca0ddb82b882518$var$rootViewTransitionAffected = !1;
                $dca0ddb82b882518$var$commitMutationEffectsOnFiber(finishedWork, root, lanes);
                lanes = $dca0ddb82b882518$var$selectionInformation;
                var curFocusedElem = $dca0ddb82b882518$var$getActiveElementDeep(root.containerInfo), priorFocusedElem = lanes.focusedElem, priorSelectionRange = lanes.selectionRange;
                if (curFocusedElem !== priorFocusedElem && priorFocusedElem && priorFocusedElem.ownerDocument && $dca0ddb82b882518$var$containsNode(priorFocusedElem.ownerDocument.documentElement, priorFocusedElem)) {
                    if (null !== priorSelectionRange && $dca0ddb82b882518$var$hasSelectionCapabilities(priorFocusedElem)) {
                        var start = priorSelectionRange.start, end = priorSelectionRange.end;
                        void 0 === end && (end = start);
                        if ("selectionStart" in priorFocusedElem) priorFocusedElem.selectionStart = start, priorFocusedElem.selectionEnd = Math.min(end, priorFocusedElem.value.length);
                        else {
                            var doc = priorFocusedElem.ownerDocument || document, win = doc && doc.defaultView || window;
                            if (win.getSelection) {
                                var selection = win.getSelection(), length = priorFocusedElem.textContent.length, start$jscomp$0 = Math.min(priorSelectionRange.start, length), end$jscomp$0 = void 0 === priorSelectionRange.end ? start$jscomp$0 : Math.min(priorSelectionRange.end, length);
                                !selection.extend && start$jscomp$0 > end$jscomp$0 && (curFocusedElem = end$jscomp$0, end$jscomp$0 = start$jscomp$0, start$jscomp$0 = curFocusedElem);
                                var startMarker = $dca0ddb82b882518$var$getNodeForCharacterOffset(priorFocusedElem, start$jscomp$0), endMarker = $dca0ddb82b882518$var$getNodeForCharacterOffset(priorFocusedElem, end$jscomp$0);
                                if (startMarker && endMarker && (1 !== selection.rangeCount || selection.anchorNode !== startMarker.node || selection.anchorOffset !== startMarker.offset || selection.focusNode !== endMarker.node || selection.focusOffset !== endMarker.offset)) {
                                    var range = doc.createRange();
                                    range.setStart(startMarker.node, startMarker.offset);
                                    selection.removeAllRanges();
                                    start$jscomp$0 > end$jscomp$0 ? (selection.addRange(range), selection.extend(endMarker.node, endMarker.offset)) : (range.setEnd(endMarker.node, endMarker.offset), selection.addRange(range));
                                }
                            }
                        }
                    }
                    doc = [];
                    for(selection = priorFocusedElem; selection = selection.parentNode;)1 === selection.nodeType && doc.push({
                        element: selection,
                        left: selection.scrollLeft,
                        top: selection.scrollTop
                    });
                    "function" === typeof priorFocusedElem.focus && priorFocusedElem.focus();
                    for(priorFocusedElem = 0; priorFocusedElem < doc.length; priorFocusedElem++){
                        var info = doc[priorFocusedElem];
                        info.element.scrollLeft = info.left;
                        info.element.scrollTop = info.top;
                    }
                }
                $dca0ddb82b882518$var$_enabled = !!$dca0ddb82b882518$var$eventsEnabled;
                $dca0ddb82b882518$var$selectionInformation = $dca0ddb82b882518$var$eventsEnabled = null;
            } finally{
                $dca0ddb82b882518$var$executionContext = prevExecutionContext, $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, $dca0ddb82b882518$var$ReactSharedInternals.T = rootMutationHasEffect;
            }
        }
        root.current = finishedWork;
        $dca0ddb82b882518$var$pendingEffectsStatus = 2;
    }
}
function $dca0ddb82b882518$var$flushLayoutEffects() {
    if (2 === $dca0ddb82b882518$var$pendingEffectsStatus) {
        $dca0ddb82b882518$var$pendingEffectsStatus = 0;
        var root = $dca0ddb82b882518$var$pendingEffectsRoot, finishedWork = $dca0ddb82b882518$var$pendingFinishedWork, rootHasLayoutEffect = 0 !== (finishedWork.flags & 8772);
        if (0 !== (finishedWork.subtreeFlags & 8772) || rootHasLayoutEffect) {
            rootHasLayoutEffect = $dca0ddb82b882518$var$ReactSharedInternals.T;
            $dca0ddb82b882518$var$ReactSharedInternals.T = null;
            var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
            $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 2;
            var prevExecutionContext = $dca0ddb82b882518$var$executionContext;
            $dca0ddb82b882518$var$executionContext |= 4;
            try {
                $dca0ddb82b882518$var$commitLayoutEffectOnFiber(root, finishedWork.alternate, finishedWork);
            } finally{
                $dca0ddb82b882518$var$executionContext = prevExecutionContext, $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, $dca0ddb82b882518$var$ReactSharedInternals.T = rootHasLayoutEffect;
            }
        }
        $dca0ddb82b882518$var$pendingEffectsStatus = 3;
    }
}
function $dca0ddb82b882518$var$flushSpawnedWork() {
    if (4 === $dca0ddb82b882518$var$pendingEffectsStatus || 3 === $dca0ddb82b882518$var$pendingEffectsStatus) {
        $dca0ddb82b882518$var$pendingEffectsStatus = 0;
        var committedViewTransition = $dca0ddb82b882518$var$pendingViewTransition;
        $dca0ddb82b882518$var$pendingViewTransition = null;
        $dca0ddb82b882518$var$requestPaint();
        var root = $dca0ddb82b882518$var$pendingEffectsRoot, finishedWork = $dca0ddb82b882518$var$pendingFinishedWork, lanes = $dca0ddb82b882518$var$pendingEffectsLanes, recoverableErrors = $dca0ddb82b882518$var$pendingRecoverableErrors, passiveSubtreeMask = (lanes & 335544064) === lanes ? 10262 : 10256;
        0 !== (finishedWork.subtreeFlags & passiveSubtreeMask) || 0 !== (finishedWork.flags & passiveSubtreeMask) ? $dca0ddb82b882518$var$pendingEffectsStatus = 5 : ($dca0ddb82b882518$var$pendingEffectsStatus = 0, $dca0ddb82b882518$var$pendingFinishedWork = $dca0ddb82b882518$var$pendingEffectsRoot = null, $dca0ddb82b882518$var$releaseRootPooledCache(root, root.pendingLanes));
        passiveSubtreeMask = root.pendingLanes;
        0 === passiveSubtreeMask && ($dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed = null);
        $dca0ddb82b882518$var$lanesToEventPriority(lanes);
        finishedWork = finishedWork.stateNode;
        if ($dca0ddb82b882518$var$injectedHook && "function" === typeof $dca0ddb82b882518$var$injectedHook.onCommitFiberRoot) try {
            $dca0ddb82b882518$var$injectedHook.onCommitFiberRoot($dca0ddb82b882518$var$rendererID, finishedWork, void 0, 128 === (finishedWork.current.flags & 128));
        } catch (err) {}
        if (null !== recoverableErrors) {
            finishedWork = $dca0ddb82b882518$var$ReactSharedInternals.T;
            passiveSubtreeMask = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
            $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 2;
            $dca0ddb82b882518$var$ReactSharedInternals.T = null;
            try {
                for(var onRecoverableError = root.onRecoverableError, i = 0; i < recoverableErrors.length; i++){
                    var recoverableError = recoverableErrors[i];
                    onRecoverableError(recoverableError.value, {
                        componentStack: recoverableError.stack
                    });
                }
            } finally{
                $dca0ddb82b882518$var$ReactSharedInternals.T = finishedWork, $dca0ddb82b882518$var$ReactDOMSharedInternals.p = passiveSubtreeMask;
            }
        }
        recoverableErrors = $dca0ddb82b882518$var$pendingViewTransitionEvents;
        onRecoverableError = $dca0ddb82b882518$var$pendingTransitionTypes;
        $dca0ddb82b882518$var$pendingTransitionTypes = null;
        if (null !== recoverableErrors && ($dca0ddb82b882518$var$pendingViewTransitionEvents = null, null === onRecoverableError && (onRecoverableError = []), null !== committedViewTransition)) for(recoverableError = 0; recoverableError < recoverableErrors.length; recoverableError++)finishedWork = (0, recoverableErrors[recoverableError])(onRecoverableError), void 0 !== finishedWork && committedViewTransition.finished.finally(finishedWork);
        0 !== ($dca0ddb82b882518$var$pendingEffectsLanes & 3) && $dca0ddb82b882518$var$flushPendingEffects();
        $dca0ddb82b882518$var$ensureRootIsScheduled(root);
        passiveSubtreeMask = root.pendingLanes;
        0 !== (lanes & 261930) && 0 !== (passiveSubtreeMask & 42) ? root === $dca0ddb82b882518$var$rootWithNestedUpdates ? $dca0ddb82b882518$var$nestedUpdateCount++ : ($dca0ddb82b882518$var$nestedUpdateCount = 0, $dca0ddb82b882518$var$rootWithNestedUpdates = root) : ($dca0ddb82b882518$var$nestedUpdateCount = 0, $dca0ddb82b882518$var$rootWithNestedUpdates = null);
        $dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(0, !1);
    }
}
function $dca0ddb82b882518$var$releaseRootPooledCache(root, remainingLanes) {
    0 === (root.pooledCacheLanes &= remainingLanes) && (remainingLanes = root.pooledCache, null != remainingLanes && (root.pooledCache = null, $dca0ddb82b882518$var$releaseCache(remainingLanes)));
}
function $dca0ddb82b882518$var$flushPendingEffects() {
    null !== $dca0ddb82b882518$var$pendingViewTransition && ($dca0ddb82b882518$var$pendingViewTransition.skipTransition(), $dca0ddb82b882518$var$pendingViewTransition = null);
    $dca0ddb82b882518$var$flushMutationEffects();
    $dca0ddb82b882518$var$flushLayoutEffects();
    $dca0ddb82b882518$var$flushSpawnedWork();
    return $dca0ddb82b882518$var$flushPassiveEffects();
}
function $dca0ddb82b882518$var$flushPassiveEffects() {
    if (5 !== $dca0ddb82b882518$var$pendingEffectsStatus) return !1;
    var root = $dca0ddb82b882518$var$pendingEffectsRoot, remainingLanes = $dca0ddb82b882518$var$pendingEffectsRemainingLanes;
    $dca0ddb82b882518$var$pendingEffectsRemainingLanes = 0;
    var renderPriority = $dca0ddb82b882518$var$lanesToEventPriority($dca0ddb82b882518$var$pendingEffectsLanes), prevTransition = $dca0ddb82b882518$var$ReactSharedInternals.T, previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    try {
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 32 > renderPriority ? 32 : renderPriority;
        $dca0ddb82b882518$var$ReactSharedInternals.T = null;
        renderPriority = $dca0ddb82b882518$var$pendingPassiveTransitions;
        $dca0ddb82b882518$var$pendingPassiveTransitions = null;
        var root$jscomp$0 = $dca0ddb82b882518$var$pendingEffectsRoot, lanes = $dca0ddb82b882518$var$pendingEffectsLanes;
        $dca0ddb82b882518$var$pendingEffectsStatus = 0;
        $dca0ddb82b882518$var$pendingFinishedWork = $dca0ddb82b882518$var$pendingEffectsRoot = null;
        $dca0ddb82b882518$var$pendingEffectsLanes = 0;
        if (0 !== ($dca0ddb82b882518$var$executionContext & 6)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(331));
        var prevExecutionContext = $dca0ddb82b882518$var$executionContext;
        $dca0ddb82b882518$var$executionContext |= 4;
        $dca0ddb82b882518$var$commitPassiveUnmountOnFiber(root$jscomp$0.current);
        $dca0ddb82b882518$var$commitPassiveMountOnFiber(root$jscomp$0, root$jscomp$0.current, lanes, renderPriority);
        $dca0ddb82b882518$var$executionContext = prevExecutionContext;
        $dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(0, !1);
        if ($dca0ddb82b882518$var$injectedHook && "function" === typeof $dca0ddb82b882518$var$injectedHook.onPostCommitFiberRoot) try {
            $dca0ddb82b882518$var$injectedHook.onPostCommitFiberRoot($dca0ddb82b882518$var$rendererID, root$jscomp$0);
        } catch (err) {}
        return !0;
    } finally{
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, $dca0ddb82b882518$var$ReactSharedInternals.T = prevTransition, $dca0ddb82b882518$var$releaseRootPooledCache(root, remainingLanes);
    }
}
function $dca0ddb82b882518$var$captureCommitPhaseErrorOnRoot(rootFiber, sourceFiber, error) {
    sourceFiber = $dca0ddb82b882518$var$createCapturedValueAtFiber(error, sourceFiber);
    sourceFiber = $dca0ddb82b882518$var$createRootErrorUpdate(rootFiber.stateNode, sourceFiber, 2);
    rootFiber = $dca0ddb82b882518$var$enqueueUpdate(rootFiber, sourceFiber, 2);
    null !== rootFiber && ($dca0ddb82b882518$var$markRootUpdated$1(rootFiber, 2), $dca0ddb82b882518$var$ensureRootIsScheduled(rootFiber));
}
function $dca0ddb82b882518$var$captureCommitPhaseError(sourceFiber, nearestMountedAncestor, error) {
    if (3 === sourceFiber.tag) $dca0ddb82b882518$var$captureCommitPhaseErrorOnRoot(sourceFiber, sourceFiber, error);
    else for(; null !== nearestMountedAncestor;){
        if (3 === nearestMountedAncestor.tag) {
            $dca0ddb82b882518$var$captureCommitPhaseErrorOnRoot(nearestMountedAncestor, sourceFiber, error);
            break;
        } else if (1 === nearestMountedAncestor.tag) {
            var instance = nearestMountedAncestor.stateNode;
            if ("function" === typeof nearestMountedAncestor.type.getDerivedStateFromError || "function" === typeof instance.componentDidCatch && (null === $dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed || !$dca0ddb82b882518$var$legacyErrorBoundariesThatAlreadyFailed.has(instance))) {
                sourceFiber = $dca0ddb82b882518$var$createCapturedValueAtFiber(error, sourceFiber);
                error = $dca0ddb82b882518$var$createClassErrorUpdate(2);
                instance = $dca0ddb82b882518$var$enqueueUpdate(nearestMountedAncestor, error, 2);
                null !== instance && ($dca0ddb82b882518$var$initializeClassErrorUpdate(error, instance, nearestMountedAncestor, sourceFiber), $dca0ddb82b882518$var$markRootUpdated$1(instance, 2), $dca0ddb82b882518$var$ensureRootIsScheduled(instance));
                break;
            }
        }
        nearestMountedAncestor = nearestMountedAncestor.return;
    }
}
function $dca0ddb82b882518$var$attachPingListener(root, wakeable, lanes) {
    var pingCache = root.pingCache;
    if (null === pingCache) {
        pingCache = root.pingCache = new $dca0ddb82b882518$var$PossiblyWeakMap();
        var threadIDs = new Set();
        pingCache.set(wakeable, threadIDs);
    } else threadIDs = pingCache.get(wakeable), void 0 === threadIDs && (threadIDs = new Set(), pingCache.set(wakeable, threadIDs));
    threadIDs.has(lanes) || ($dca0ddb82b882518$var$workInProgressRootDidAttachPingListener = !0, threadIDs.add(lanes), root = $dca0ddb82b882518$var$pingSuspendedRoot.bind(null, root, wakeable, lanes), wakeable.then(root, root));
}
function $dca0ddb82b882518$var$pingSuspendedRoot(root, wakeable, pingedLanes) {
    var pingCache = root.pingCache;
    null !== pingCache && pingCache.delete(wakeable);
    root.pingedLanes |= root.suspendedLanes & pingedLanes;
    root.warmLanes &= ~pingedLanes;
    $dca0ddb82b882518$var$workInProgressRoot === root && ($dca0ddb82b882518$var$workInProgressRootRenderLanes & pingedLanes) === pingedLanes && (4 === $dca0ddb82b882518$var$workInProgressRootExitStatus || 3 === $dca0ddb82b882518$var$workInProgressRootExitStatus && ($dca0ddb82b882518$var$workInProgressRootRenderLanes & 62914560) === $dca0ddb82b882518$var$workInProgressRootRenderLanes && 300 > $dca0ddb82b882518$var$now() - $dca0ddb82b882518$var$globalMostRecentFallbackTime ? 0 === ($dca0ddb82b882518$var$executionContext & 2) ? $dca0ddb82b882518$var$prepareFreshStack(root, 0) : $dca0ddb82b882518$var$workInProgressRootPingedLanes |= pingedLanes : $dca0ddb82b882518$var$workInProgressRootPingedLanes |= pingedLanes, $dca0ddb82b882518$var$workInProgressSuspendedRetryLanes === $dca0ddb82b882518$var$workInProgressRootRenderLanes && ($dca0ddb82b882518$var$workInProgressSuspendedRetryLanes = 0));
    $dca0ddb82b882518$var$ensureRootIsScheduled(root);
}
function $dca0ddb82b882518$var$retryTimedOutBoundary(boundaryFiber, retryLane) {
    0 === retryLane && (retryLane = $dca0ddb82b882518$var$claimNextRetryLane());
    boundaryFiber = $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(boundaryFiber, retryLane);
    null !== boundaryFiber && ($dca0ddb82b882518$var$markRootUpdated$1(boundaryFiber, retryLane), $dca0ddb82b882518$var$ensureRootIsScheduled(boundaryFiber));
}
function $dca0ddb82b882518$var$retryDehydratedSuspenseBoundary(boundaryFiber) {
    var suspenseState = boundaryFiber.memoizedState, retryLane = 0;
    null !== suspenseState && (retryLane = suspenseState.retryLane);
    $dca0ddb82b882518$var$retryTimedOutBoundary(boundaryFiber, retryLane);
}
function $dca0ddb82b882518$var$resolveRetryWakeable(boundaryFiber, wakeable) {
    var retryLane = 0;
    switch(boundaryFiber.tag){
        case 31:
        case 13:
            var retryCache = boundaryFiber.stateNode;
            var suspenseState = boundaryFiber.memoizedState;
            null !== suspenseState && (retryLane = suspenseState.retryLane);
            break;
        case 19:
            retryCache = boundaryFiber.stateNode;
            break;
        case 22:
            retryCache = boundaryFiber.stateNode._retryCache;
            break;
        default:
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(314));
    }
    null !== retryCache && retryCache.delete(wakeable);
    $dca0ddb82b882518$var$retryTimedOutBoundary(boundaryFiber, retryLane);
}
function $dca0ddb82b882518$var$scheduleCallback$1(priorityLevel, callback) {
    return $dca0ddb82b882518$var$scheduleCallback$3(priorityLevel, callback);
}
var $dca0ddb82b882518$var$firstScheduledRoot = null, $dca0ddb82b882518$var$lastScheduledRoot = null, $dca0ddb82b882518$var$didScheduleMicrotask = !1, $dca0ddb82b882518$var$mightHavePendingSyncWork = !1, $dca0ddb82b882518$var$isFlushingWork = !1, $dca0ddb82b882518$var$currentEventTransitionLane = 0;
function $dca0ddb82b882518$var$ensureRootIsScheduled(root) {
    root !== $dca0ddb82b882518$var$lastScheduledRoot && null === root.next && (null === $dca0ddb82b882518$var$lastScheduledRoot ? $dca0ddb82b882518$var$firstScheduledRoot = $dca0ddb82b882518$var$lastScheduledRoot = root : $dca0ddb82b882518$var$lastScheduledRoot = $dca0ddb82b882518$var$lastScheduledRoot.next = root);
    $dca0ddb82b882518$var$mightHavePendingSyncWork = !0;
    $dca0ddb82b882518$var$didScheduleMicrotask || ($dca0ddb82b882518$var$didScheduleMicrotask = !0, $dca0ddb82b882518$var$scheduleImmediateRootScheduleTask());
}
function $dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(syncTransitionLanes, onlyLegacy) {
    if (!$dca0ddb82b882518$var$isFlushingWork && $dca0ddb82b882518$var$mightHavePendingSyncWork) {
        $dca0ddb82b882518$var$isFlushingWork = !0;
        do {
            var didPerformSomeWork = !1;
            for(var root$190 = $dca0ddb82b882518$var$firstScheduledRoot; null !== root$190;){
                if (!onlyLegacy) {
                    if (0 !== syncTransitionLanes) {
                        var pendingLanes = root$190.pendingLanes;
                        if (0 === pendingLanes) var JSCompiler_inline_result = 0;
                        else {
                            var suspendedLanes = root$190.suspendedLanes, pingedLanes = root$190.pingedLanes;
                            JSCompiler_inline_result = (1 << 31 - $dca0ddb82b882518$var$clz32(42 | syncTransitionLanes) + 1) - 1;
                            JSCompiler_inline_result &= pendingLanes & ~(suspendedLanes & ~pingedLanes);
                            JSCompiler_inline_result = JSCompiler_inline_result & 201326741 ? JSCompiler_inline_result & 201326741 | 1 : JSCompiler_inline_result ? JSCompiler_inline_result | 2 : 0;
                        }
                        0 !== JSCompiler_inline_result && (didPerformSomeWork = !0, $dca0ddb82b882518$var$performSyncWorkOnRoot(root$190, JSCompiler_inline_result));
                    } else JSCompiler_inline_result = $dca0ddb82b882518$var$workInProgressRootRenderLanes, JSCompiler_inline_result = $dca0ddb82b882518$var$getNextLanes(root$190, root$190 === $dca0ddb82b882518$var$workInProgressRoot ? JSCompiler_inline_result : 0, null !== root$190.cancelPendingCommit || -1 !== root$190.timeoutHandle), 0 === (JSCompiler_inline_result & 3) || $dca0ddb82b882518$var$checkIfRootIsPrerendering(root$190, JSCompiler_inline_result) || (didPerformSomeWork = !0, $dca0ddb82b882518$var$performSyncWorkOnRoot(root$190, JSCompiler_inline_result));
                }
                root$190 = root$190.next;
            }
        }while (didPerformSomeWork);
        $dca0ddb82b882518$var$isFlushingWork = !1;
    }
}
function $dca0ddb82b882518$var$processRootScheduleInImmediateTask() {
    $dca0ddb82b882518$var$processRootScheduleInMicrotask();
}
function $dca0ddb82b882518$var$processRootScheduleInMicrotask() {
    $dca0ddb82b882518$var$mightHavePendingSyncWork = $dca0ddb82b882518$var$didScheduleMicrotask = !1;
    var syncTransitionLanes = 0;
    0 !== $dca0ddb82b882518$var$currentEventTransitionLane && $dca0ddb82b882518$var$shouldAttemptEagerTransition() && (syncTransitionLanes = $dca0ddb82b882518$var$currentEventTransitionLane);
    for(var currentTime = $dca0ddb82b882518$var$now(), prev = null, root = $dca0ddb82b882518$var$firstScheduledRoot; null !== root;){
        var next = root.next, nextLanes = $dca0ddb82b882518$var$scheduleTaskForRootDuringMicrotask(root, currentTime);
        if (0 === nextLanes) root.next = null, null === prev ? $dca0ddb82b882518$var$firstScheduledRoot = next : prev.next = next, null === next && ($dca0ddb82b882518$var$lastScheduledRoot = prev);
        else if (prev = root, 0 !== syncTransitionLanes || 0 !== (nextLanes & 3)) $dca0ddb82b882518$var$mightHavePendingSyncWork = !0;
        root = next;
    }
    0 !== $dca0ddb82b882518$var$pendingEffectsStatus && 5 !== $dca0ddb82b882518$var$pendingEffectsStatus || $dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(syncTransitionLanes, !1);
    0 !== $dca0ddb82b882518$var$currentEventTransitionLane && ($dca0ddb82b882518$var$currentEventTransitionLane = 0);
}
function $dca0ddb82b882518$var$scheduleTaskForRootDuringMicrotask(root, currentTime) {
    for(var suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes, expirationTimes = root.expirationTimes, lanes = root.pendingLanes & -62914561; 0 < lanes;){
        var index$5 = 31 - $dca0ddb82b882518$var$clz32(lanes), lane = 1 << index$5, expirationTime = expirationTimes[index$5];
        if (-1 === expirationTime) {
            if (0 === (lane & suspendedLanes) || 0 !== (lane & pingedLanes)) expirationTimes[index$5] = $dca0ddb82b882518$var$computeExpirationTime(lane, currentTime);
        } else expirationTime <= currentTime && (root.expiredLanes |= lane);
        lanes &= ~lane;
    }
    currentTime = $dca0ddb82b882518$var$workInProgressRoot;
    suspendedLanes = $dca0ddb82b882518$var$workInProgressRootRenderLanes;
    suspendedLanes = $dca0ddb82b882518$var$getNextLanes(root, root === currentTime ? suspendedLanes : 0, null !== root.cancelPendingCommit || -1 !== root.timeoutHandle);
    pingedLanes = root.callbackNode;
    if (0 === suspendedLanes || root === currentTime && (2 === $dca0ddb82b882518$var$workInProgressSuspendedReason || 9 === $dca0ddb82b882518$var$workInProgressSuspendedReason) || null !== root.cancelPendingCommit) return null !== pingedLanes && null !== pingedLanes && $dca0ddb82b882518$var$cancelCallback$1(pingedLanes), root.callbackNode = null, root.callbackPriority = 0;
    if (0 === (suspendedLanes & 3) || $dca0ddb82b882518$var$checkIfRootIsPrerendering(root, suspendedLanes)) {
        currentTime = suspendedLanes & -suspendedLanes;
        if (currentTime === root.callbackPriority) return currentTime;
        null !== pingedLanes && $dca0ddb82b882518$var$cancelCallback$1(pingedLanes);
        switch($dca0ddb82b882518$var$lanesToEventPriority(suspendedLanes)){
            case 2:
            case 8:
                suspendedLanes = $dca0ddb82b882518$var$UserBlockingPriority;
                break;
            case 32:
                suspendedLanes = $dca0ddb82b882518$var$NormalPriority$1;
                break;
            case 268435456:
                suspendedLanes = $dca0ddb82b882518$var$IdlePriority;
                break;
            default:
                suspendedLanes = $dca0ddb82b882518$var$NormalPriority$1;
        }
        pingedLanes = $dca0ddb82b882518$var$performWorkOnRootViaSchedulerTask.bind(null, root);
        suspendedLanes = $dca0ddb82b882518$var$scheduleCallback$3(suspendedLanes, pingedLanes);
        root.callbackPriority = currentTime;
        root.callbackNode = suspendedLanes;
        return currentTime;
    }
    null !== pingedLanes && null !== pingedLanes && $dca0ddb82b882518$var$cancelCallback$1(pingedLanes);
    root.callbackPriority = 2;
    root.callbackNode = null;
    return 2;
}
function $dca0ddb82b882518$var$performWorkOnRootViaSchedulerTask(root, didTimeout) {
    if (0 !== $dca0ddb82b882518$var$pendingEffectsStatus && 5 !== $dca0ddb82b882518$var$pendingEffectsStatus) return root.callbackNode = null, root.callbackPriority = 0, null;
    var originalCallbackNode = root.callbackNode;
    if ($dca0ddb82b882518$var$flushPendingEffects() && root.callbackNode !== originalCallbackNode) return null;
    var workInProgressRootRenderLanes$jscomp$0 = $dca0ddb82b882518$var$workInProgressRootRenderLanes;
    workInProgressRootRenderLanes$jscomp$0 = $dca0ddb82b882518$var$getNextLanes(root, root === $dca0ddb82b882518$var$workInProgressRoot ? workInProgressRootRenderLanes$jscomp$0 : 0, null !== root.cancelPendingCommit || -1 !== root.timeoutHandle);
    if (0 === workInProgressRootRenderLanes$jscomp$0) return null;
    $dca0ddb82b882518$var$performWorkOnRoot(root, workInProgressRootRenderLanes$jscomp$0, didTimeout);
    $dca0ddb82b882518$var$scheduleTaskForRootDuringMicrotask(root, $dca0ddb82b882518$var$now());
    return null != root.callbackNode && root.callbackNode === originalCallbackNode ? $dca0ddb82b882518$var$performWorkOnRootViaSchedulerTask.bind(null, root) : null;
}
function $dca0ddb82b882518$var$performSyncWorkOnRoot(root, lanes) {
    if ($dca0ddb82b882518$var$flushPendingEffects()) return null;
    $dca0ddb82b882518$var$performWorkOnRoot(root, lanes, !0);
}
function $dca0ddb82b882518$var$scheduleImmediateRootScheduleTask() {
    $dca0ddb82b882518$var$scheduleMicrotask(function() {
        0 !== ($dca0ddb82b882518$var$executionContext & 6) ? $dca0ddb82b882518$var$scheduleCallback$3($dca0ddb82b882518$var$ImmediatePriority, $dca0ddb82b882518$var$processRootScheduleInImmediateTask) : $dca0ddb82b882518$var$processRootScheduleInMicrotask();
    });
}
function $dca0ddb82b882518$var$requestTransitionLane() {
    if (0 === $dca0ddb82b882518$var$currentEventTransitionLane) {
        var actionScopeLane = $dca0ddb82b882518$var$currentEntangledLane;
        0 === actionScopeLane && (actionScopeLane = $dca0ddb82b882518$var$nextTransitionUpdateLane, $dca0ddb82b882518$var$nextTransitionUpdateLane <<= 1, 0 === ($dca0ddb82b882518$var$nextTransitionUpdateLane & 261888) && ($dca0ddb82b882518$var$nextTransitionUpdateLane = 256));
        $dca0ddb82b882518$var$currentEventTransitionLane = actionScopeLane;
    }
    return $dca0ddb82b882518$var$currentEventTransitionLane;
}
function $dca0ddb82b882518$var$coerceFormActionProp(actionProp) {
    return null == actionProp || "symbol" === typeof actionProp || "boolean" === typeof actionProp ? null : "function" === typeof actionProp ? actionProp : $dca0ddb82b882518$var$sanitizeURL(actionProp);
}
function $dca0ddb82b882518$var$extractEvents$1(dispatchQueue, domEventName, maybeTargetInst, nativeEvent, nativeEventTarget) {
    if ("submit" === domEventName && maybeTargetInst && maybeTargetInst.stateNode === nativeEventTarget) {
        var action = $dca0ddb82b882518$var$coerceFormActionProp((nativeEventTarget[$dca0ddb82b882518$var$internalPropsKey] || null).action), submitter = nativeEvent.submitter;
        submitter && (domEventName = (domEventName = submitter[$dca0ddb82b882518$var$internalPropsKey] || null) ? $dca0ddb82b882518$var$coerceFormActionProp(domEventName.formAction) : submitter.getAttribute("formAction"), null !== domEventName && (action = domEventName, submitter = null));
        var event = new $dca0ddb82b882518$var$SyntheticEvent("action", "action", null, nativeEvent, nativeEventTarget);
        dispatchQueue.push({
            event: event,
            listeners: [
                {
                    instance: null,
                    listener: function() {
                        if (nativeEvent.defaultPrevented) {
                            if (0 !== $dca0ddb82b882518$var$currentEventTransitionLane) {
                                var formData = new FormData(nativeEventTarget, submitter);
                                $dca0ddb82b882518$var$startHostTransition(maybeTargetInst, {
                                    pending: !0,
                                    data: formData,
                                    method: nativeEventTarget.method,
                                    action: action
                                }, null, formData);
                            }
                        } else "function" === typeof action && (event.preventDefault(), formData = new FormData(nativeEventTarget, submitter), $dca0ddb82b882518$var$startHostTransition(maybeTargetInst, {
                            pending: !0,
                            data: formData,
                            method: nativeEventTarget.method,
                            action: action
                        }, action, formData));
                    },
                    currentTarget: nativeEventTarget
                }
            ]
        });
    }
}
for(var $dca0ddb82b882518$var$i$jscomp$inline_1667 = 0; $dca0ddb82b882518$var$i$jscomp$inline_1667 < $dca0ddb82b882518$var$simpleEventPluginEvents.length; $dca0ddb82b882518$var$i$jscomp$inline_1667++){
    var $dca0ddb82b882518$var$eventName$jscomp$inline_1668 = $dca0ddb82b882518$var$simpleEventPluginEvents[$dca0ddb82b882518$var$i$jscomp$inline_1667], $dca0ddb82b882518$var$domEventName$jscomp$inline_1669 = $dca0ddb82b882518$var$eventName$jscomp$inline_1668.toLowerCase(), $dca0ddb82b882518$var$capitalizedEvent$jscomp$inline_1670 = $dca0ddb82b882518$var$eventName$jscomp$inline_1668[0].toUpperCase() + $dca0ddb82b882518$var$eventName$jscomp$inline_1668.slice(1);
    $dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$domEventName$jscomp$inline_1669, "on" + $dca0ddb82b882518$var$capitalizedEvent$jscomp$inline_1670);
}
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$ANIMATION_END, "onAnimationEnd");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$ANIMATION_ITERATION, "onAnimationIteration");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$ANIMATION_START, "onAnimationStart");
$dca0ddb82b882518$var$registerSimpleEvent("dblclick", "onDoubleClick");
$dca0ddb82b882518$var$registerSimpleEvent("focusin", "onFocus");
$dca0ddb82b882518$var$registerSimpleEvent("focusout", "onBlur");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$TRANSITION_RUN, "onTransitionRun");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$TRANSITION_START, "onTransitionStart");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$TRANSITION_CANCEL, "onTransitionCancel");
$dca0ddb82b882518$var$registerSimpleEvent($dca0ddb82b882518$var$TRANSITION_END, "onTransitionEnd");
$dca0ddb82b882518$var$registerDirectEvent("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$dca0ddb82b882518$var$registerDirectEvent("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$dca0ddb82b882518$var$registerDirectEvent("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$dca0ddb82b882518$var$registerDirectEvent("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$dca0ddb82b882518$var$registerTwoPhaseEvent("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$dca0ddb82b882518$var$registerTwoPhaseEvent("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$dca0ddb82b882518$var$registerTwoPhaseEvent("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$dca0ddb82b882518$var$registerTwoPhaseEvent("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$dca0ddb82b882518$var$registerTwoPhaseEvent("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$dca0ddb82b882518$var$registerTwoPhaseEvent("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $dca0ddb82b882518$var$mediaEventTypes = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $dca0ddb82b882518$var$nonDelegatedEvents = new Set("beforetoggle cancel close invalid load scroll scrollend toggle".split(" ").concat($dca0ddb82b882518$var$mediaEventTypes));
function $dca0ddb82b882518$var$processDispatchQueue(dispatchQueue, eventSystemFlags) {
    eventSystemFlags = 0 !== (eventSystemFlags & 4);
    for(var i = 0; i < dispatchQueue.length; i++){
        var _dispatchQueue$i = dispatchQueue[i], event = _dispatchQueue$i.event;
        _dispatchQueue$i = _dispatchQueue$i.listeners;
        a: {
            var previousInstance = void 0;
            if (eventSystemFlags) for(var i$jscomp$0 = _dispatchQueue$i.length - 1; 0 <= i$jscomp$0; i$jscomp$0--){
                var _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0], instance = _dispatchListeners$i.instance, currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    $dca0ddb82b882518$var$reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
            else for(i$jscomp$0 = 0; i$jscomp$0 < _dispatchQueue$i.length; i$jscomp$0++){
                _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0];
                instance = _dispatchListeners$i.instance;
                currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    $dca0ddb82b882518$var$reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
        }
    }
}
function $dca0ddb82b882518$var$listenToNonDelegatedEvent(domEventName, targetElement) {
    var JSCompiler_inline_result = targetElement[$dca0ddb82b882518$var$internalEventHandlersKey];
    void 0 === JSCompiler_inline_result && (JSCompiler_inline_result = targetElement[$dca0ddb82b882518$var$internalEventHandlersKey] = new Set());
    var listenerSetKey = domEventName + "__bubble";
    JSCompiler_inline_result.has(listenerSetKey) || ($dca0ddb82b882518$var$addTrappedEventListener(targetElement, domEventName, 2, !1), JSCompiler_inline_result.add(listenerSetKey));
}
function $dca0ddb82b882518$var$listenToNativeEvent(domEventName, isCapturePhaseListener, target) {
    var eventSystemFlags = 0;
    isCapturePhaseListener && (eventSystemFlags |= 4);
    $dca0ddb82b882518$var$addTrappedEventListener(target, domEventName, eventSystemFlags, isCapturePhaseListener);
}
var $dca0ddb82b882518$var$listeningMarker = "_reactListening" + Math.random().toString(36).slice(2);
function $dca0ddb82b882518$var$listenToAllSupportedEvents(rootContainerElement) {
    if (!rootContainerElement[$dca0ddb82b882518$var$listeningMarker]) {
        rootContainerElement[$dca0ddb82b882518$var$listeningMarker] = !0;
        $dca0ddb82b882518$var$allNativeEvents.forEach(function(domEventName) {
            "selectionchange" !== domEventName && ($dca0ddb82b882518$var$nonDelegatedEvents.has(domEventName) || $dca0ddb82b882518$var$listenToNativeEvent(domEventName, !1, rootContainerElement), $dca0ddb82b882518$var$listenToNativeEvent(domEventName, !0, rootContainerElement));
        });
        var ownerDocument = 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
        null === ownerDocument || ownerDocument[$dca0ddb82b882518$var$listeningMarker] || (ownerDocument[$dca0ddb82b882518$var$listeningMarker] = !0, $dca0ddb82b882518$var$listenToNativeEvent("selectionchange", !1, ownerDocument));
    }
}
function $dca0ddb82b882518$var$addTrappedEventListener(targetContainer, domEventName, eventSystemFlags, isCapturePhaseListener) {
    switch($dca0ddb82b882518$var$getEventPriority(domEventName)){
        case 2:
            var listenerWrapper = $dca0ddb82b882518$var$dispatchDiscreteEvent;
            break;
        case 8:
            listenerWrapper = $dca0ddb82b882518$var$dispatchContinuousEvent;
            break;
        default:
            listenerWrapper = $dca0ddb82b882518$var$dispatchEvent;
    }
    eventSystemFlags = listenerWrapper.bind(null, domEventName, eventSystemFlags, targetContainer);
    listenerWrapper = void 0;
    !$dca0ddb82b882518$var$passiveBrowserEventsSupported || "touchstart" !== domEventName && "touchmove" !== domEventName && "wheel" !== domEventName || (listenerWrapper = !0);
    isCapturePhaseListener ? void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        capture: !0,
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !0) : void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !1);
}
function $dca0ddb82b882518$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, targetInst$jscomp$0, targetContainer) {
    var ancestorInst = targetInst$jscomp$0;
    if (0 === (eventSystemFlags & 1) && 0 === (eventSystemFlags & 2) && null !== targetInst$jscomp$0) a: for(;;){
        if (null === targetInst$jscomp$0) return;
        var nodeTag = targetInst$jscomp$0.tag;
        if (3 === nodeTag || 4 === nodeTag) {
            var container = targetInst$jscomp$0.stateNode.containerInfo;
            if (container === targetContainer) break;
            if (4 === nodeTag) for(nodeTag = targetInst$jscomp$0.return; null !== nodeTag;){
                var grandTag = nodeTag.tag;
                if ((3 === grandTag || 4 === grandTag) && nodeTag.stateNode.containerInfo === targetContainer) return;
                nodeTag = nodeTag.return;
            }
            for(; null !== container;){
                nodeTag = $dca0ddb82b882518$var$getClosestInstanceFromNode(container);
                if (null === nodeTag) return;
                grandTag = nodeTag.tag;
                if (5 === grandTag || 6 === grandTag || 26 === grandTag || 27 === grandTag) {
                    targetInst$jscomp$0 = ancestorInst = nodeTag;
                    continue a;
                }
                container = container.parentNode;
            }
        }
        targetInst$jscomp$0 = targetInst$jscomp$0.return;
    }
    $dca0ddb82b882518$var$batchedUpdates$1(function() {
        var targetInst = ancestorInst, nativeEventTarget = $dca0ddb82b882518$var$getEventTarget(nativeEvent), dispatchQueue = [];
        a: {
            var reactName = $dca0ddb82b882518$var$topLevelEventsToReactNames.get(domEventName);
            if (void 0 !== reactName) {
                var SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticEvent, reactEventType = domEventName;
                switch(domEventName){
                    case "keypress":
                        if (0 === $dca0ddb82b882518$var$getEventCharCode(nativeEvent)) break a;
                    case "keydown":
                    case "keyup":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticKeyboardEvent;
                        break;
                    case "focusin":
                        reactEventType = "focus";
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticFocusEvent;
                        break;
                    case "focusout":
                        reactEventType = "blur";
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticFocusEvent;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticFocusEvent;
                        break;
                    case "click":
                        if (2 === nativeEvent.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticMouseEvent;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticDragEvent;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticTouchEvent;
                        break;
                    case $dca0ddb82b882518$var$ANIMATION_END:
                    case $dca0ddb82b882518$var$ANIMATION_ITERATION:
                    case $dca0ddb82b882518$var$ANIMATION_START:
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticAnimationEvent;
                        break;
                    case $dca0ddb82b882518$var$TRANSITION_END:
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticTransitionEvent;
                        break;
                    case "scroll":
                    case "scrollend":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticUIEvent;
                        break;
                    case "wheel":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticWheelEvent;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticClipboardEvent;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticPointerEvent;
                        break;
                    case "submit":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticSubmitEvent;
                        break;
                    case "toggle":
                    case "beforetoggle":
                        SyntheticEventCtor = $dca0ddb82b882518$var$SyntheticToggleEvent;
                }
                var inCapturePhase = 0 !== (eventSystemFlags & 4), accumulateTargetOnly = !inCapturePhase && ("scroll" === domEventName || "scrollend" === domEventName), reactEventName = inCapturePhase ? null !== reactName ? reactName + "Capture" : null : reactName;
                inCapturePhase = [];
                for(var instance = targetInst, lastHostComponent; null !== instance;){
                    var _instance = instance;
                    lastHostComponent = _instance.stateNode;
                    _instance = _instance.tag;
                    5 !== _instance && 26 !== _instance && 27 !== _instance || null === lastHostComponent || null === reactEventName || (_instance = $dca0ddb82b882518$var$getListener(instance, reactEventName), null != _instance && inCapturePhase.push($dca0ddb82b882518$var$createDispatchListener(instance, _instance, lastHostComponent)));
                    if (accumulateTargetOnly) break;
                    instance = instance.return;
                }
                0 < inCapturePhase.length && (reactName = new SyntheticEventCtor(reactName, reactEventType, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                    event: reactName,
                    listeners: inCapturePhase
                }));
            }
        }
        if (0 === (eventSystemFlags & 7)) {
            a: {
                SyntheticEventCtor = "mouseover" === domEventName || "pointerover" === domEventName;
                reactName = "mouseout" === domEventName || "pointerout" === domEventName;
                if (SyntheticEventCtor && nativeEvent !== $dca0ddb82b882518$var$currentReplayingEvent && (reactEventType = nativeEvent.relatedTarget || nativeEvent.fromElement) && ($dca0ddb82b882518$var$getClosestInstanceFromNode(reactEventType) || reactEventType[$dca0ddb82b882518$var$internalContainerInstanceKey])) break a;
                if (reactName || SyntheticEventCtor) {
                    reactEventType = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget : (SyntheticEventCtor = nativeEventTarget.ownerDocument) ? SyntheticEventCtor.defaultView || SyntheticEventCtor.parentWindow : window;
                    if (reactName) {
                        if (SyntheticEventCtor = nativeEvent.relatedTarget || nativeEvent.toElement, reactName = targetInst, SyntheticEventCtor = SyntheticEventCtor ? $dca0ddb82b882518$var$getClosestInstanceFromNode(SyntheticEventCtor) : null, null !== SyntheticEventCtor && (accumulateTargetOnly = $dca0ddb82b882518$var$getNearestMountedFiber(SyntheticEventCtor), inCapturePhase = SyntheticEventCtor.tag, SyntheticEventCtor !== accumulateTargetOnly || 5 !== inCapturePhase && 27 !== inCapturePhase && 6 !== inCapturePhase)) SyntheticEventCtor = null;
                    } else reactName = null, SyntheticEventCtor = targetInst;
                    if (reactName !== SyntheticEventCtor) {
                        inCapturePhase = $dca0ddb82b882518$var$SyntheticMouseEvent;
                        _instance = "onMouseLeave";
                        reactEventName = "onMouseEnter";
                        instance = "mouse";
                        if ("pointerout" === domEventName || "pointerover" === domEventName) inCapturePhase = $dca0ddb82b882518$var$SyntheticPointerEvent, _instance = "onPointerLeave", reactEventName = "onPointerEnter", instance = "pointer";
                        accumulateTargetOnly = null == reactName ? reactEventType : $dca0ddb82b882518$var$getNodeFromInstance(reactName);
                        lastHostComponent = null == SyntheticEventCtor ? reactEventType : $dca0ddb82b882518$var$getNodeFromInstance(SyntheticEventCtor);
                        reactEventType = new inCapturePhase(_instance, instance + "leave", reactName, nativeEvent, nativeEventTarget);
                        reactEventType.target = accumulateTargetOnly;
                        reactEventType.relatedTarget = lastHostComponent;
                        _instance = null;
                        $dca0ddb82b882518$var$getClosestInstanceFromNode(nativeEventTarget) === targetInst && (inCapturePhase = new inCapturePhase(reactEventName, instance + "enter", SyntheticEventCtor, nativeEvent, nativeEventTarget), inCapturePhase.target = lastHostComponent, inCapturePhase.relatedTarget = accumulateTargetOnly, _instance = inCapturePhase);
                        accumulateTargetOnly = _instance;
                        inCapturePhase = reactName && SyntheticEventCtor ? $dca0ddb82b882518$var$getLowestCommonAncestor(reactName, SyntheticEventCtor, $dca0ddb82b882518$var$getParent) : null;
                        null !== reactName && $dca0ddb82b882518$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, reactEventType, reactName, inCapturePhase, !1);
                        null !== SyntheticEventCtor && null !== accumulateTargetOnly && $dca0ddb82b882518$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, accumulateTargetOnly, SyntheticEventCtor, inCapturePhase, !0);
                    }
                }
            }
            a: {
                reactName = targetInst ? $dca0ddb82b882518$var$getNodeFromInstance(targetInst) : window;
                SyntheticEventCtor = reactName.nodeName && reactName.nodeName.toLowerCase();
                if ("select" === SyntheticEventCtor || "input" === SyntheticEventCtor && "file" === reactName.type) var getTargetInstFunc = $dca0ddb82b882518$var$getTargetInstForChangeEvent;
                else if ($dca0ddb82b882518$var$isTextInputElement(reactName)) {
                    if ($dca0ddb82b882518$var$isInputEventSupported) getTargetInstFunc = $dca0ddb82b882518$var$getTargetInstForInputOrChangeEvent;
                    else {
                        getTargetInstFunc = $dca0ddb82b882518$var$getTargetInstForInputEventPolyfill;
                        var handleEventFunc = $dca0ddb82b882518$var$handleEventsForInputEventPolyfill;
                    }
                } else SyntheticEventCtor = reactName.nodeName, !SyntheticEventCtor || "input" !== SyntheticEventCtor.toLowerCase() || "checkbox" !== reactName.type && "radio" !== reactName.type ? targetInst && $dca0ddb82b882518$var$isCustomElement(targetInst.elementType) && (getTargetInstFunc = $dca0ddb82b882518$var$getTargetInstForChangeEvent) : getTargetInstFunc = $dca0ddb82b882518$var$getTargetInstForClickEvent;
                if (getTargetInstFunc && (getTargetInstFunc = getTargetInstFunc(domEventName, targetInst))) {
                    $dca0ddb82b882518$var$createAndAccumulateChangeEvent(dispatchQueue, getTargetInstFunc, nativeEvent, nativeEventTarget);
                    break a;
                }
                handleEventFunc && handleEventFunc(domEventName, reactName, targetInst);
            }
            handleEventFunc = targetInst ? $dca0ddb82b882518$var$getNodeFromInstance(targetInst) : window;
            switch(domEventName){
                case "focusin":
                    if ($dca0ddb82b882518$var$isTextInputElement(handleEventFunc) || "true" === handleEventFunc.contentEditable) $dca0ddb82b882518$var$activeElement = handleEventFunc, $dca0ddb82b882518$var$activeElementInst = targetInst, $dca0ddb82b882518$var$lastSelection = null;
                    break;
                case "focusout":
                    $dca0ddb82b882518$var$lastSelection = $dca0ddb82b882518$var$activeElementInst = $dca0ddb82b882518$var$activeElement = null;
                    break;
                case "mousedown":
                    $dca0ddb82b882518$var$mouseDown = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $dca0ddb82b882518$var$mouseDown = !1;
                    $dca0ddb82b882518$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
                    break;
                case "selectionchange":
                    if ($dca0ddb82b882518$var$skipSelectionChangeEvent) break;
                case "keydown":
                case "keyup":
                    $dca0ddb82b882518$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
            }
            var fallbackData;
            if ($dca0ddb82b882518$var$canUseCompositionEvent) b: {
                switch(domEventName){
                    case "compositionstart":
                        var eventType = "onCompositionStart";
                        break b;
                    case "compositionend":
                        eventType = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        eventType = "onCompositionUpdate";
                        break b;
                }
                eventType = void 0;
            }
            else $dca0ddb82b882518$var$isComposing ? $dca0ddb82b882518$var$isFallbackCompositionEnd(domEventName, nativeEvent) && (eventType = "onCompositionEnd") : "keydown" === domEventName && 229 === nativeEvent.keyCode && (eventType = "onCompositionStart");
            eventType && ($dca0ddb82b882518$var$useFallbackCompositionData && "ko" !== nativeEvent.locale && ($dca0ddb82b882518$var$isComposing || "onCompositionStart" !== eventType ? "onCompositionEnd" === eventType && $dca0ddb82b882518$var$isComposing && (fallbackData = $dca0ddb82b882518$var$getData()) : ($dca0ddb82b882518$var$root = nativeEventTarget, $dca0ddb82b882518$var$startText = "value" in $dca0ddb82b882518$var$root ? $dca0ddb82b882518$var$root.value : $dca0ddb82b882518$var$root.textContent, $dca0ddb82b882518$var$isComposing = !0)), handleEventFunc = $dca0ddb82b882518$var$accumulateTwoPhaseListeners(targetInst, eventType), 0 < handleEventFunc.length && (eventType = new $dca0ddb82b882518$var$SyntheticCompositionEvent(eventType, domEventName, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: eventType,
                listeners: handleEventFunc
            }), fallbackData ? eventType.data = fallbackData : (fallbackData = $dca0ddb82b882518$var$getDataFromCustomEvent(nativeEvent), null !== fallbackData && (eventType.data = fallbackData))));
            if (fallbackData = $dca0ddb82b882518$var$canUseTextInputEvent ? $dca0ddb82b882518$var$getNativeBeforeInputChars(domEventName, nativeEvent) : $dca0ddb82b882518$var$getFallbackBeforeInputChars(domEventName, nativeEvent)) eventType = $dca0ddb82b882518$var$accumulateTwoPhaseListeners(targetInst, "onBeforeInput"), 0 < eventType.length && (handleEventFunc = new $dca0ddb82b882518$var$SyntheticCompositionEvent("onBeforeInput", "beforeinput", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: handleEventFunc,
                listeners: eventType
            }), handleEventFunc.data = fallbackData);
            $dca0ddb82b882518$var$extractEvents$1(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
        }
        $dca0ddb82b882518$var$processDispatchQueue(dispatchQueue, eventSystemFlags);
    });
}
function $dca0ddb82b882518$var$createDispatchListener(instance, listener, currentTarget) {
    return {
        instance: instance,
        listener: listener,
        currentTarget: currentTarget
    };
}
function $dca0ddb82b882518$var$accumulateTwoPhaseListeners(targetFiber, reactName) {
    for(var captureName = reactName + "Capture", listeners = []; null !== targetFiber;){
        var _instance2 = targetFiber, stateNode = _instance2.stateNode;
        _instance2 = _instance2.tag;
        5 !== _instance2 && 26 !== _instance2 && 27 !== _instance2 || null === stateNode || (_instance2 = $dca0ddb82b882518$var$getListener(targetFiber, captureName), null != _instance2 && listeners.unshift($dca0ddb82b882518$var$createDispatchListener(targetFiber, _instance2, stateNode)), _instance2 = $dca0ddb82b882518$var$getListener(targetFiber, reactName), null != _instance2 && listeners.push($dca0ddb82b882518$var$createDispatchListener(targetFiber, _instance2, stateNode)));
        if (3 === targetFiber.tag) return listeners;
        targetFiber = targetFiber.return;
    }
    return [];
}
function $dca0ddb82b882518$var$getParent(inst) {
    if (null === inst) return null;
    do inst = inst.return;
    while (inst && 5 !== inst.tag && 27 !== inst.tag);
    return inst ? inst : null;
}
function $dca0ddb82b882518$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, event, target, common, inCapturePhase) {
    for(var registrationName = event._reactName, listeners = []; null !== target && target !== common;){
        var _instance3 = target, alternate = _instance3.alternate, stateNode = _instance3.stateNode;
        _instance3 = _instance3.tag;
        if (null !== alternate && alternate === common) break;
        5 !== _instance3 && 26 !== _instance3 && 27 !== _instance3 || null === stateNode || (alternate = stateNode, inCapturePhase ? (stateNode = $dca0ddb82b882518$var$getListener(target, registrationName), null != stateNode && listeners.unshift($dca0ddb82b882518$var$createDispatchListener(target, stateNode, alternate))) : inCapturePhase || (stateNode = $dca0ddb82b882518$var$getListener(target, registrationName), null != stateNode && listeners.push($dca0ddb82b882518$var$createDispatchListener(target, stateNode, alternate))));
        target = target.return;
    }
    0 !== listeners.length && dispatchQueue.push({
        event: event,
        listeners: listeners
    });
}
var $dca0ddb82b882518$var$NORMALIZE_NEWLINES_REGEX = /\r\n?/g, $dca0ddb82b882518$var$NORMALIZE_NULL_AND_REPLACEMENT_REGEX = /\u0000|\uFFFD/g;
function $dca0ddb82b882518$var$normalizeMarkupForTextOrAttribute(markup) {
    return ("string" === typeof markup ? markup : "" + markup).replace($dca0ddb82b882518$var$NORMALIZE_NEWLINES_REGEX, "\n").replace($dca0ddb82b882518$var$NORMALIZE_NULL_AND_REPLACEMENT_REGEX, "");
}
function $dca0ddb82b882518$var$checkForUnmatchedText(serverText, clientText) {
    clientText = $dca0ddb82b882518$var$normalizeMarkupForTextOrAttribute(clientText);
    return $dca0ddb82b882518$var$normalizeMarkupForTextOrAttribute(serverText) === clientText ? !0 : !1;
}
function $dca0ddb82b882518$var$setProp(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "children":
            if ("string" === typeof value) "body" === tag || "textarea" === tag && "" === value || $dca0ddb82b882518$var$setTextContent(domElement, value);
            else if ("number" === typeof value || "bigint" === typeof value) "body" !== tag && $dca0ddb82b882518$var$setTextContent(domElement, "" + value);
            else return;
            break;
        case "className":
            $dca0ddb82b882518$var$setValueForKnownAttribute(domElement, "class", value);
            break;
        case "tabIndex":
            $dca0ddb82b882518$var$setValueForKnownAttribute(domElement, "tabindex", value);
            break;
        case "dir":
        case "role":
        case "viewBox":
        case "width":
        case "height":
            $dca0ddb82b882518$var$setValueForKnownAttribute(domElement, key, value);
            break;
        case "style":
            $dca0ddb82b882518$var$setValueForStyles(domElement, value, prevValue);
            return;
        case "data":
            if ("object" !== tag) {
                $dca0ddb82b882518$var$setValueForKnownAttribute(domElement, "data", value);
                break;
            }
        case "src":
        case "href":
            if ("" === value && ("a" !== tag || "href" !== key)) {
                domElement.removeAttribute(key);
                break;
            }
            if (null == value || "function" === typeof value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = $dca0ddb82b882518$var$sanitizeURL(value);
            domElement.setAttribute(key, value);
            break;
        case "action":
        case "formAction":
            if ("function" === typeof value) {
                domElement.setAttribute(key, "javascript:throw new Error('A React form was unexpectedly submitted. If you called form.submit() manually, consider using form.requestSubmit() instead. If you\\'re trying to use event.stopPropagation() in a submit event handler, consider also calling event.preventDefault().')");
                break;
            } else "function" === typeof prevValue && ("formAction" === key ? ("input" !== tag && $dca0ddb82b882518$var$setProp(domElement, tag, "name", props.name, props, null), $dca0ddb82b882518$var$setProp(domElement, tag, "formEncType", props.formEncType, props, null), $dca0ddb82b882518$var$setProp(domElement, tag, "formMethod", props.formMethod, props, null), $dca0ddb82b882518$var$setProp(domElement, tag, "formTarget", props.formTarget, props, null)) : ($dca0ddb82b882518$var$setProp(domElement, tag, "encType", props.encType, props, null), $dca0ddb82b882518$var$setProp(domElement, tag, "method", props.method, props, null), $dca0ddb82b882518$var$setProp(domElement, tag, "target", props.target, props, null)));
            if (null == value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = $dca0ddb82b882518$var$sanitizeURL(value);
            domElement.setAttribute(key, value);
            break;
        case "onClick":
            null != value && (domElement.onclick = $dca0ddb82b882518$var$noop$1);
            return;
        case "onScroll":
            null != value && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scroll", domElement);
            return;
        case "onScrollEnd":
            null != value && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scrollend", domElement);
            return;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(60));
                    (null != prevValue ? prevValue.__html : void 0) !== key && (domElement.innerHTML = key);
                }
            }
            break;
        case "multiple":
            domElement.multiple = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "muted":
            domElement.muted = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "defaultValue":
        case "defaultChecked":
        case "innerHTML":
        case "ref":
            break;
        case "autoFocus":
            break;
        case "xlinkHref":
            if (null == value || "function" === typeof value || "boolean" === typeof value || "symbol" === typeof value) {
                domElement.removeAttribute("xlink:href");
                break;
            }
            key = $dca0ddb82b882518$var$sanitizeURL(value);
            domElement.setAttributeNS("http://www.w3.org/1999/xlink", "xlink:href", key);
            break;
        case "contentEditable":
        case "spellCheck":
        case "draggable":
        case "value":
        case "autoReverse":
        case "externalResourcesRequired":
        case "focusable":
        case "preserveAlpha":
            null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "inert":
        case "allowFullScreen":
        case "async":
        case "autoPlay":
        case "controls":
        case "credentialless":
        case "default":
        case "defer":
        case "disabled":
        case "disablePictureInPicture":
        case "disableRemotePlayback":
        case "formNoValidate":
        case "hidden":
        case "loop":
        case "noModule":
        case "noValidate":
        case "open":
        case "playsInline":
        case "readOnly":
        case "required":
        case "reversed":
        case "scoped":
        case "seamless":
        case "itemScope":
            value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, "") : domElement.removeAttribute(key);
            break;
        case "capture":
        case "download":
            !0 === value ? domElement.setAttribute(key, "") : !1 !== value && null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "cols":
        case "rows":
        case "size":
        case "span":
            null != value && "function" !== typeof value && "symbol" !== typeof value && !isNaN(value) && 1 <= value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "rowSpan":
        case "start":
            null == value || "function" === typeof value || "symbol" === typeof value || isNaN(value) ? domElement.removeAttribute(key) : domElement.setAttribute(key, value);
            break;
        case "popover":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("beforetoggle", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("toggle", domElement);
            $dca0ddb82b882518$var$setValueForAttribute(domElement, "popover", value);
            break;
        case "xlinkActuate":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:actuate", value);
            break;
        case "xlinkArcrole":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:arcrole", value);
            break;
        case "xlinkRole":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:role", value);
            break;
        case "xlinkShow":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:show", value);
            break;
        case "xlinkTitle":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:title", value);
            break;
        case "xlinkType":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:type", value);
            break;
        case "xmlBase":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:base", value);
            break;
        case "xmlLang":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:lang", value);
            break;
        case "xmlSpace":
            $dca0ddb82b882518$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:space", value);
            break;
        case "is":
            $dca0ddb82b882518$var$setValueForAttribute(domElement, "is", value);
            break;
        case "innerText":
        case "textContent":
            return;
        default:
            if (!(2 < key.length) || "o" !== key[0] && "O" !== key[0] || "n" !== key[1] && "N" !== key[1]) key = $dca0ddb82b882518$var$aliases.get(key) || key, $dca0ddb82b882518$var$setValueForAttribute(domElement, key, value);
            else return;
    }
    $dca0ddb82b882518$var$viewTransitionMutationContext = !0;
}
function $dca0ddb82b882518$var$setPropOnCustomElement(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "style":
            $dca0ddb82b882518$var$setValueForStyles(domElement, value, prevValue);
            return;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(60));
                    (null != prevValue ? prevValue.__html : void 0) !== key && (domElement.innerHTML = key);
                }
            }
            break;
        case "children":
            if ("string" === typeof value) $dca0ddb82b882518$var$setTextContent(domElement, value);
            else if ("number" === typeof value || "bigint" === typeof value) $dca0ddb82b882518$var$setTextContent(domElement, "" + value);
            else return;
            break;
        case "onScroll":
            null != value && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scroll", domElement);
            return;
        case "onScrollEnd":
            null != value && $dca0ddb82b882518$var$listenToNonDelegatedEvent("scrollend", domElement);
            return;
        case "onClick":
            null != value && (domElement.onclick = $dca0ddb82b882518$var$noop$1);
            return;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "innerHTML":
        case "ref":
            return;
        case "innerText":
        case "textContent":
            return;
        default:
            if (!$dca0ddb82b882518$var$registrationNameDependencies.hasOwnProperty(key)) a: {
                if ("o" === key[0] && "n" === key[1] && (props = key.endsWith("Capture"), prevValue = key.slice(2, props ? key.length - 7 : void 0), tag = domElement[$dca0ddb82b882518$var$internalPropsKey] || null, tag = null != tag ? tag[key] : null, "function" === typeof tag && domElement.removeEventListener(prevValue, tag, props), "function" === typeof value)) {
                    "function" !== typeof tag && null !== tag && (key in domElement ? domElement[key] = null : domElement.hasAttribute(key) && domElement.removeAttribute(key));
                    domElement.addEventListener(prevValue, value, props);
                    break a;
                }
                $dca0ddb82b882518$var$viewTransitionMutationContext = !0;
                key in domElement ? domElement[key] = value : !0 === value ? domElement.setAttribute(key, "") : $dca0ddb82b882518$var$setValueForAttribute(domElement, key, value);
            }
            return;
    }
    $dca0ddb82b882518$var$viewTransitionMutationContext = !0;
}
function $dca0ddb82b882518$var$setInitialProperties(domElement, tag, props) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "img":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("error", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", domElement);
            var hasSrc = !1, hasSrcSet = !1, propKey;
            for(propKey in props)if (props.hasOwnProperty(propKey)) {
                var propValue = props[propKey];
                if (null != propValue) switch(propKey){
                    case "src":
                        hasSrc = !0;
                        break;
                    case "srcSet":
                        hasSrcSet = !0;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        throw Error($dca0ddb82b882518$var$formatProdErrorMessage(137, tag));
                    default:
                        $dca0ddb82b882518$var$setProp(domElement, tag, propKey, propValue, props, null);
                }
            }
            hasSrcSet && $dca0ddb82b882518$var$setProp(domElement, tag, "srcSet", props.srcSet, props, null);
            hasSrc && $dca0ddb82b882518$var$setProp(domElement, tag, "src", props.src, props, null);
            return;
        case "input":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", domElement);
            var defaultValue = propKey = propValue = hasSrcSet = null, checked = null, defaultChecked = null;
            for(hasSrc in props)if (props.hasOwnProperty(hasSrc)) {
                var propValue$204 = props[hasSrc];
                if (null != propValue$204) switch(hasSrc){
                    case "name":
                        hasSrcSet = propValue$204;
                        break;
                    case "type":
                        propValue = propValue$204;
                        break;
                    case "checked":
                        checked = propValue$204;
                        break;
                    case "defaultChecked":
                        defaultChecked = propValue$204;
                        break;
                    case "value":
                        propKey = propValue$204;
                        break;
                    case "defaultValue":
                        defaultValue = propValue$204;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propValue$204) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(137, tag));
                        break;
                    default:
                        $dca0ddb82b882518$var$setProp(domElement, tag, hasSrc, propValue$204, props, null);
                }
            }
            $dca0ddb82b882518$var$initInput(domElement, propKey, defaultValue, checked, defaultChecked, propValue, hasSrcSet, !1);
            return;
        case "select":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", domElement);
            hasSrc = propValue = propKey = null;
            for(hasSrcSet in props)if (props.hasOwnProperty(hasSrcSet) && (defaultValue = props[hasSrcSet], null != defaultValue)) switch(hasSrcSet){
                case "value":
                    propKey = defaultValue;
                    break;
                case "defaultValue":
                    propValue = defaultValue;
                    break;
                case "multiple":
                    hasSrc = defaultValue;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, hasSrcSet, defaultValue, props, null);
            }
            tag = propKey;
            props = propValue;
            domElement.multiple = !!hasSrc;
            null != tag ? $dca0ddb82b882518$var$updateOptions(domElement, !!hasSrc, tag, !1) : null != props && $dca0ddb82b882518$var$updateOptions(domElement, !!hasSrc, props, !0);
            return;
        case "textarea":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("invalid", domElement);
            propKey = hasSrcSet = hasSrc = null;
            for(propValue in props)if (props.hasOwnProperty(propValue) && (defaultValue = props[propValue], null != defaultValue)) switch(propValue){
                case "value":
                    hasSrc = defaultValue;
                    break;
                case "defaultValue":
                    hasSrcSet = defaultValue;
                    break;
                case "children":
                    propKey = defaultValue;
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != defaultValue) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(91));
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, propValue, defaultValue, props, null);
            }
            $dca0ddb82b882518$var$initTextarea(domElement, hasSrc, hasSrcSet, propKey);
            return;
        case "option":
            for(checked in props)if (props.hasOwnProperty(checked) && (hasSrc = props[checked], null != hasSrc)) switch(checked){
                case "selected":
                    domElement.selected = hasSrc && "function" !== typeof hasSrc && "symbol" !== typeof hasSrc;
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, checked, hasSrc, props, null);
            }
            return;
        case "dialog":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("beforetoggle", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("toggle", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("cancel", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("close", domElement);
            break;
        case "iframe":
        case "object":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", domElement);
            break;
        case "video":
        case "audio":
            for(hasSrc = 0; hasSrc < $dca0ddb82b882518$var$mediaEventTypes.length; hasSrc++)$dca0ddb82b882518$var$listenToNonDelegatedEvent($dca0ddb82b882518$var$mediaEventTypes[hasSrc], domElement);
            break;
        case "image":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("error", domElement);
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", domElement);
            break;
        case "details":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("toggle", domElement);
            break;
        case "embed":
        case "source":
        case "link":
            $dca0ddb82b882518$var$listenToNonDelegatedEvent("error", domElement), $dca0ddb82b882518$var$listenToNonDelegatedEvent("load", domElement);
        case "area":
        case "base":
        case "br":
        case "col":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "track":
        case "wbr":
        case "menuitem":
            for(defaultChecked in props)if (props.hasOwnProperty(defaultChecked) && (hasSrc = props[defaultChecked], null != hasSrc)) switch(defaultChecked){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error($dca0ddb82b882518$var$formatProdErrorMessage(137, tag));
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, defaultChecked, hasSrc, props, null);
            }
            return;
        default:
            if ($dca0ddb82b882518$var$isCustomElement(tag)) {
                for(propValue$204 in props)props.hasOwnProperty(propValue$204) && (hasSrc = props[propValue$204], void 0 !== hasSrc && $dca0ddb82b882518$var$setPropOnCustomElement(domElement, tag, propValue$204, hasSrc, props, void 0));
                return;
            }
    }
    for(defaultValue in props)props.hasOwnProperty(defaultValue) && (hasSrc = props[defaultValue], null != hasSrc && $dca0ddb82b882518$var$setProp(domElement, tag, defaultValue, hasSrc, props, null));
}
var $dca0ddb82b882518$var$emptyProps = {};
function $dca0ddb82b882518$var$updateProperties(domElement, tag, lastProps, nextProps) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "input":
            var name = null, type = null, value = null, defaultValue = null, lastDefaultValue = null, checked = null, defaultChecked = null;
            for(propKey in lastProps){
                var lastProp = lastProps[propKey];
                if (lastProps.hasOwnProperty(propKey) && null != lastProp) switch(propKey){
                    case "checked":
                        break;
                    case "value":
                        break;
                    case "defaultValue":
                        lastDefaultValue = lastProp;
                    default:
                        nextProps.hasOwnProperty(propKey) || $dca0ddb82b882518$var$setProp(domElement, tag, propKey, null, nextProps, lastProp);
                }
            }
            for(var propKey$221 in nextProps){
                var propKey = nextProps[propKey$221];
                lastProp = lastProps[propKey$221];
                if (nextProps.hasOwnProperty(propKey$221) && (null != propKey || null != lastProp)) switch(propKey$221){
                    case "type":
                        propKey !== lastProp && ($dca0ddb82b882518$var$viewTransitionMutationContext = !0);
                        type = propKey;
                        break;
                    case "name":
                        propKey !== lastProp && ($dca0ddb82b882518$var$viewTransitionMutationContext = !0);
                        name = propKey;
                        break;
                    case "checked":
                        propKey !== lastProp && ($dca0ddb82b882518$var$viewTransitionMutationContext = !0);
                        checked = propKey;
                        break;
                    case "defaultChecked":
                        propKey !== lastProp && ($dca0ddb82b882518$var$viewTransitionMutationContext = !0);
                        defaultChecked = propKey;
                        break;
                    case "value":
                        propKey !== lastProp && ($dca0ddb82b882518$var$viewTransitionMutationContext = !0);
                        value = propKey;
                        break;
                    case "defaultValue":
                        propKey !== lastProp && ($dca0ddb82b882518$var$viewTransitionMutationContext = !0);
                        defaultValue = propKey;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propKey) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(137, tag));
                        break;
                    default:
                        propKey !== lastProp && $dca0ddb82b882518$var$setProp(domElement, tag, propKey$221, propKey, nextProps, lastProp);
                }
            }
            $dca0ddb82b882518$var$updateInput(domElement, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name);
            return;
        case "select":
            propKey = value = defaultValue = propKey$221 = null;
            for(type in lastProps)if (lastDefaultValue = lastProps[type], lastProps.hasOwnProperty(type) && null != lastDefaultValue) switch(type){
                case "value":
                    break;
                case "multiple":
                    propKey = lastDefaultValue;
                default:
                    nextProps.hasOwnProperty(type) || $dca0ddb82b882518$var$setProp(domElement, tag, type, null, nextProps, lastDefaultValue);
            }
            for(name in nextProps)if (type = nextProps[name], lastDefaultValue = lastProps[name], nextProps.hasOwnProperty(name) && (null != type || null != lastDefaultValue)) switch(name){
                case "value":
                    type !== lastDefaultValue && ($dca0ddb82b882518$var$viewTransitionMutationContext = !0);
                    propKey$221 = type;
                    break;
                case "defaultValue":
                    type !== lastDefaultValue && ($dca0ddb82b882518$var$viewTransitionMutationContext = !0);
                    defaultValue = type;
                    break;
                case "multiple":
                    type !== lastDefaultValue && ($dca0ddb82b882518$var$viewTransitionMutationContext = !0), value = type;
                default:
                    type !== lastDefaultValue && $dca0ddb82b882518$var$setProp(domElement, tag, name, type, nextProps, lastDefaultValue);
            }
            tag = defaultValue;
            lastProps = value;
            nextProps = propKey;
            null != propKey$221 ? $dca0ddb82b882518$var$updateOptions(domElement, !!lastProps, propKey$221, !1) : !!nextProps !== !!lastProps && (null != tag ? $dca0ddb82b882518$var$updateOptions(domElement, !!lastProps, tag, !0) : $dca0ddb82b882518$var$updateOptions(domElement, !!lastProps, lastProps ? [] : "", !1));
            return;
        case "textarea":
            propKey = propKey$221 = null;
            for(defaultValue in lastProps)if (name = lastProps[defaultValue], lastProps.hasOwnProperty(defaultValue) && null != name && !nextProps.hasOwnProperty(defaultValue)) switch(defaultValue){
                case "value":
                    break;
                case "children":
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, defaultValue, null, nextProps, name);
            }
            for(value in nextProps)if (name = nextProps[value], type = lastProps[value], nextProps.hasOwnProperty(value) && (null != name || null != type)) switch(value){
                case "value":
                    name !== type && ($dca0ddb82b882518$var$viewTransitionMutationContext = !0);
                    propKey$221 = name;
                    break;
                case "defaultValue":
                    name !== type && ($dca0ddb82b882518$var$viewTransitionMutationContext = !0);
                    propKey = name;
                    break;
                case "children":
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != name) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(91));
                    break;
                default:
                    name !== type && $dca0ddb82b882518$var$setProp(domElement, tag, value, name, nextProps, type);
            }
            $dca0ddb82b882518$var$updateTextarea(domElement, propKey$221, propKey);
            return;
        case "option":
            for(var propKey$237 in lastProps)if (propKey$221 = lastProps[propKey$237], lastProps.hasOwnProperty(propKey$237) && null != propKey$221 && !nextProps.hasOwnProperty(propKey$237)) switch(propKey$237){
                case "selected":
                    domElement.selected = !1;
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, propKey$237, null, nextProps, propKey$221);
            }
            for(lastDefaultValue in nextProps)if (propKey$221 = nextProps[lastDefaultValue], propKey = lastProps[lastDefaultValue], nextProps.hasOwnProperty(lastDefaultValue) && propKey$221 !== propKey && (null != propKey$221 || null != propKey)) switch(lastDefaultValue){
                case "selected":
                    propKey$221 !== propKey && ($dca0ddb82b882518$var$viewTransitionMutationContext = !0);
                    domElement.selected = propKey$221 && "function" !== typeof propKey$221 && "symbol" !== typeof propKey$221;
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, lastDefaultValue, propKey$221, nextProps, propKey);
            }
            return;
        case "img":
        case "link":
        case "area":
        case "base":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "source":
        case "track":
        case "wbr":
        case "menuitem":
            for(var propKey$242 in lastProps)propKey$221 = lastProps[propKey$242], lastProps.hasOwnProperty(propKey$242) && null != propKey$221 && !nextProps.hasOwnProperty(propKey$242) && $dca0ddb82b882518$var$setProp(domElement, tag, propKey$242, null, nextProps, propKey$221);
            for(checked in nextProps)if (propKey$221 = nextProps[checked], propKey = lastProps[checked], nextProps.hasOwnProperty(checked) && propKey$221 !== propKey && (null != propKey$221 || null != propKey)) switch(checked){
                case "children":
                case "dangerouslySetInnerHTML":
                    if (null != propKey$221) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(137, tag));
                    break;
                default:
                    $dca0ddb82b882518$var$setProp(domElement, tag, checked, propKey$221, nextProps, propKey);
            }
            return;
        default:
            if ($dca0ddb82b882518$var$isCustomElement(tag)) {
                for(var propKey$247 in lastProps)propKey$221 = lastProps[propKey$247], lastProps.hasOwnProperty(propKey$247) && void 0 !== propKey$221 && !nextProps.hasOwnProperty(propKey$247) && $dca0ddb82b882518$var$setPropOnCustomElement(domElement, tag, propKey$247, void 0, nextProps, propKey$221);
                for(defaultChecked in nextProps)propKey$221 = nextProps[defaultChecked], propKey = lastProps[defaultChecked], !nextProps.hasOwnProperty(defaultChecked) || propKey$221 === propKey || void 0 === propKey$221 && void 0 === propKey || $dca0ddb82b882518$var$setPropOnCustomElement(domElement, tag, defaultChecked, propKey$221, nextProps, propKey);
                return;
            }
    }
    for(var propKey$252 in lastProps)propKey$221 = lastProps[propKey$252], lastProps.hasOwnProperty(propKey$252) && null != propKey$221 && !nextProps.hasOwnProperty(propKey$252) && $dca0ddb82b882518$var$setProp(domElement, tag, propKey$252, null, nextProps, propKey$221);
    for(lastProp in nextProps)propKey$221 = nextProps[lastProp], propKey = lastProps[lastProp], !nextProps.hasOwnProperty(lastProp) || propKey$221 === propKey || null == propKey$221 && null == propKey || $dca0ddb82b882518$var$setProp(domElement, tag, lastProp, propKey$221, nextProps, propKey);
}
function $dca0ddb82b882518$var$isLikelyStaticResource(initiatorType) {
    switch(initiatorType){
        case "css":
        case "script":
        case "font":
        case "img":
        case "image":
        case "input":
        case "link":
            return !0;
        default:
            return !1;
    }
}
function $dca0ddb82b882518$var$estimateBandwidth() {
    if ("function" === typeof performance.getEntriesByType) {
        for(var count = 0, bits = 0, resourceEntries = performance.getEntriesByType("resource"), i = 0; i < resourceEntries.length; i++){
            var entry = resourceEntries[i], transferSize = entry.transferSize, initiatorType = entry.initiatorType, duration = entry.duration;
            if (transferSize && duration && $dca0ddb82b882518$var$isLikelyStaticResource(initiatorType)) {
                initiatorType = 0;
                duration = entry.responseEnd;
                for(i += 1; i < resourceEntries.length; i++){
                    var overlapEntry = resourceEntries[i], overlapStartTime = overlapEntry.startTime;
                    if (overlapStartTime > duration) break;
                    var overlapTransferSize = overlapEntry.transferSize, overlapInitiatorType = overlapEntry.initiatorType;
                    overlapTransferSize && $dca0ddb82b882518$var$isLikelyStaticResource(overlapInitiatorType) && (overlapEntry = overlapEntry.responseEnd, initiatorType += overlapTransferSize * (overlapEntry < duration ? 1 : (duration - overlapStartTime) / (overlapEntry - overlapStartTime)));
                }
                --i;
                bits += 8 * (transferSize + initiatorType) / (entry.duration / 1e3);
                count++;
                if (10 < count) break;
            }
        }
        if (0 < count) return bits / count / 1e6;
    }
    return navigator.connection && (count = navigator.connection.downlink, "number" === typeof count) ? count : 5;
}
var $dca0ddb82b882518$var$eventsEnabled = null, $dca0ddb82b882518$var$selectionInformation = null;
function $dca0ddb82b882518$var$getOwnerDocumentFromRootContainer(rootContainerElement) {
    return 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
}
function $dca0ddb82b882518$var$getOwnHostContext(namespaceURI) {
    switch(namespaceURI){
        case "http://www.w3.org/2000/svg":
            return 1;
        case "http://www.w3.org/1998/Math/MathML":
            return 2;
        default:
            return 0;
    }
}
function $dca0ddb82b882518$var$getChildHostContextProd(parentNamespace, type) {
    if (0 === parentNamespace) switch(type){
        case "svg":
            return 1;
        case "math":
            return 2;
        default:
            return 0;
    }
    return 1 === parentNamespace && "foreignObject" === type ? 0 : parentNamespace;
}
function $dca0ddb82b882518$var$createHoistableInstance(type, props, rootContainerInstance, internalInstanceHandle) {
    rootContainerInstance = $dca0ddb82b882518$var$getOwnerDocumentFromRootContainer(rootContainerInstance).createElement(type);
    rootContainerInstance[$dca0ddb82b882518$var$internalInstanceKey] = internalInstanceHandle;
    rootContainerInstance[$dca0ddb82b882518$var$internalPropsKey] = props;
    $dca0ddb82b882518$var$setInitialProperties(rootContainerInstance, type, props);
    $dca0ddb82b882518$var$markNodeAsHoistable(rootContainerInstance);
    return rootContainerInstance;
}
function $dca0ddb82b882518$var$shouldSetTextContent(type, props) {
    return "textarea" === type || "noscript" === type || "string" === typeof props.children || "number" === typeof props.children || "bigint" === typeof props.children || "object" === typeof props.dangerouslySetInnerHTML && null !== props.dangerouslySetInnerHTML && null != props.dangerouslySetInnerHTML.__html;
}
var $dca0ddb82b882518$var$currentPopstateTransitionEvent = null;
function $dca0ddb82b882518$var$shouldAttemptEagerTransition() {
    var event = window.event;
    if (event && "popstate" === event.type) {
        if (event === $dca0ddb82b882518$var$currentPopstateTransitionEvent) return !1;
        $dca0ddb82b882518$var$currentPopstateTransitionEvent = event;
        return !0;
    }
    $dca0ddb82b882518$var$currentPopstateTransitionEvent = null;
    return !1;
}
var $dca0ddb82b882518$var$scheduleTimeout = "function" === typeof setTimeout ? setTimeout : void 0, $dca0ddb82b882518$var$cancelTimeout = "function" === typeof clearTimeout ? clearTimeout : void 0, $dca0ddb82b882518$var$localPromise = "function" === typeof Promise ? Promise : void 0, $dca0ddb82b882518$var$localRequestAnimationFrame = "function" === typeof requestAnimationFrame ? requestAnimationFrame : $dca0ddb82b882518$var$scheduleTimeout, $dca0ddb82b882518$var$scheduleMicrotask = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $dca0ddb82b882518$var$localPromise ? function(callback) {
    return $dca0ddb82b882518$var$localPromise.resolve(null).then(callback).catch($dca0ddb82b882518$var$handleErrorInNextTick);
} : $dca0ddb82b882518$var$scheduleTimeout;
function $dca0ddb82b882518$var$handleErrorInNextTick(error) {
    setTimeout(function() {
        throw error;
    });
}
function $dca0ddb82b882518$var$isSingletonScope(type) {
    return "head" === type;
}
function $dca0ddb82b882518$var$clearHydrationBoundary(parentInstance, hydrationInstance) {
    var node = hydrationInstance, depth = 0;
    do {
        var nextNode = node.nextSibling;
        parentInstance.removeChild(node);
        if (nextNode && 8 === nextNode.nodeType) {
            if (node = nextNode.data, "/$" === node || "/&" === node) {
                if (0 === depth) {
                    parentInstance.removeChild(nextNode);
                    $dca0ddb82b882518$var$retryIfBlockedOn(hydrationInstance);
                    return;
                }
                depth--;
            } else if ("$" === node || "$?" === node || "$~" === node || "$!" === node || "&" === node) depth++;
            else if ("html" === node) $dca0ddb82b882518$var$clearSingletonPreambleContribution(parentInstance.ownerDocument.documentElement);
            else if ("head" === node) {
                node = parentInstance.ownerDocument.head;
                $dca0ddb82b882518$var$clearSingletonPreambleContribution(node);
                for(var node$jscomp$0 = node.firstChild; node$jscomp$0;){
                    var nextNode$jscomp$0 = node$jscomp$0.nextSibling, nodeName = node$jscomp$0.nodeName;
                    node$jscomp$0[$dca0ddb82b882518$var$internalHoistableMarker] || "SCRIPT" === nodeName || "STYLE" === nodeName || "LINK" === nodeName && "stylesheet" === node$jscomp$0.rel.toLowerCase() || node.removeChild(node$jscomp$0);
                    node$jscomp$0 = nextNode$jscomp$0;
                }
            } else "body" === node && $dca0ddb82b882518$var$clearSingletonPreambleContribution(parentInstance.ownerDocument.body);
        }
        node = nextNode;
    }while (node);
    $dca0ddb82b882518$var$retryIfBlockedOn(hydrationInstance);
}
function $dca0ddb82b882518$var$hideOrUnhideDehydratedBoundary(suspenseInstance, isHidden) {
    var node = suspenseInstance;
    suspenseInstance = 0;
    do {
        var nextNode = node.nextSibling;
        1 === node.nodeType ? isHidden ? (node._stashedDisplay = node.style.display, node.style.display = "none") : (node.style.display = node._stashedDisplay || "", "" === node.getAttribute("style") && node.removeAttribute("style")) : 3 === node.nodeType && (isHidden ? (node._stashedText = node.nodeValue, node.nodeValue = "") : node.nodeValue = node._stashedText || "");
        if (nextNode && 8 === nextNode.nodeType) {
            if (node = nextNode.data, "/$" === node) {
                if (0 === suspenseInstance) break;
                else suspenseInstance--;
            } else "$" !== node && "$?" !== node && "$~" !== node && "$!" !== node || suspenseInstance++;
        }
        node = nextNode;
    }while (node);
}
function $dca0ddb82b882518$var$applyViewTransitionName(instance, name, className) {
    name = CSS.escape(name) !== name ? "r-" + btoa(name).replace(/=/g, "") : name;
    instance.style.viewTransitionName = name;
    null != className && (instance.style.viewTransitionClass = className);
    className = getComputedStyle(instance);
    if ("inline" === className.display) {
        name = instance.getClientRects();
        if (1 === name.length) var JSCompiler_inline_result = 1;
        else for(var i = JSCompiler_inline_result = 0; i < name.length; i++){
            var rect = name[i];
            0 < rect.width && 0 < rect.height && JSCompiler_inline_result++;
        }
        1 === JSCompiler_inline_result && (instance = instance.style, instance.display = 1 === name.length ? "inline-block" : "block", instance.marginTop = "-" + className.paddingTop, instance.marginBottom = "-" + className.paddingBottom);
    }
}
function $dca0ddb82b882518$var$restoreViewTransitionName(instance, props) {
    instance = instance.style;
    props = props.style;
    var viewTransitionName = null != props ? props.hasOwnProperty("viewTransitionName") ? props.viewTransitionName : props.hasOwnProperty("view-transition-name") ? props["view-transition-name"] : null : null;
    instance.viewTransitionName = null == viewTransitionName || "boolean" === typeof viewTransitionName ? "" : ("" + viewTransitionName).trim();
    viewTransitionName = null != props ? props.hasOwnProperty("viewTransitionClass") ? props.viewTransitionClass : props.hasOwnProperty("view-transition-class") ? props["view-transition-class"] : null : null;
    instance.viewTransitionClass = null == viewTransitionName || "boolean" === typeof viewTransitionName ? "" : ("" + viewTransitionName).trim();
    "inline-block" === instance.display && (null == props ? instance.display = instance.margin = "" : (viewTransitionName = props.display, instance.display = null == viewTransitionName || "boolean" === typeof viewTransitionName ? "" : viewTransitionName, viewTransitionName = props.margin, null != viewTransitionName ? instance.margin = viewTransitionName : (viewTransitionName = props.hasOwnProperty("marginTop") ? props.marginTop : props["margin-top"], instance.marginTop = null == viewTransitionName || "boolean" === typeof viewTransitionName ? "" : viewTransitionName, props = props.hasOwnProperty("marginBottom") ? props.marginBottom : props["margin-bottom"], instance.marginBottom = null == props || "boolean" === typeof props ? "" : props)));
}
function $dca0ddb82b882518$var$createMeasurement(rect, computedStyle, element) {
    element = element.ownerDocument.defaultView;
    return {
        rect: rect,
        abs: "absolute" === computedStyle.position || "fixed" === computedStyle.position,
        clip: "none" !== computedStyle.clipPath || "visible" !== computedStyle.overflow || "none" !== computedStyle.filter || "none" !== computedStyle.mask || "none" !== computedStyle.mask || "0px" !== computedStyle.borderRadius,
        view: 0 <= rect.bottom && 0 <= rect.right && rect.top <= element.innerHeight && rect.left <= element.innerWidth
    };
}
function $dca0ddb82b882518$var$measureInstance(instance) {
    var rect = instance.getBoundingClientRect(), computedStyle = getComputedStyle(instance);
    return $dca0ddb82b882518$var$createMeasurement(rect, computedStyle, instance);
}
function $dca0ddb82b882518$var$measureClonedInstance(instance) {
    var measuredRect = instance.getBoundingClientRect();
    measuredRect = new DOMRect(measuredRect.x + 2e4, measuredRect.y + 2e4, measuredRect.width, measuredRect.height);
    var computedStyle = getComputedStyle(instance);
    return $dca0ddb82b882518$var$createMeasurement(measuredRect, computedStyle, instance);
}
function $dca0ddb82b882518$var$forceLayout(ownerDocument) {
    return ownerDocument.documentElement.clientHeight;
}
function $dca0ddb82b882518$var$waitForImageToLoad(resolve) {
    this.addEventListener("load", resolve);
    this.addEventListener("error", resolve);
}
function $dca0ddb82b882518$var$startViewTransition(suspendedState, rootContainer, transitionTypes, mutationCallback, layoutCallback, afterMutationCallback, spawnedWorkCallback, passiveCallback, errorCallback) {
    var ownerDocument = 9 === rootContainer.nodeType ? rootContainer : rootContainer.ownerDocument;
    try {
        var transition = ownerDocument.startViewTransition({
            update: function() {
                var ownerWindow = ownerDocument.defaultView, pendingNavigation = ownerWindow.navigation && ownerWindow.navigation.transition, previousFontLoadingStatus = ownerDocument.fonts.status;
                mutationCallback();
                var blockingPromises = [];
                "loaded" === previousFontLoadingStatus && ($dca0ddb82b882518$var$forceLayout(ownerDocument), "loading" === ownerDocument.fonts.status && blockingPromises.push(ownerDocument.fonts.ready));
                previousFontLoadingStatus = blockingPromises.length;
                if (null !== suspendedState) for(var suspenseyImages = suspendedState.suspenseyImages, imgBytes = 0, i = 0; i < suspenseyImages.length; i++){
                    var suspenseyImage = suspenseyImages[i];
                    if (!suspenseyImage.complete) {
                        var rect = suspenseyImage.getBoundingClientRect();
                        if (0 < rect.bottom && 0 < rect.right && rect.top < ownerWindow.innerHeight && rect.left < ownerWindow.innerWidth) {
                            imgBytes += $dca0ddb82b882518$var$estimateImageBytes(suspenseyImage);
                            if (imgBytes > $dca0ddb82b882518$var$estimatedBytesWithinLimit) {
                                blockingPromises.length = previousFontLoadingStatus;
                                break;
                            }
                            suspenseyImage = new Promise($dca0ddb82b882518$var$waitForImageToLoad.bind(suspenseyImage));
                            blockingPromises.push(suspenseyImage);
                        }
                    }
                }
                if (0 < blockingPromises.length) return ownerWindow = Promise.race([
                    Promise.all(blockingPromises),
                    new Promise(function(resolve) {
                        return setTimeout(resolve, 500);
                    })
                ]).then(layoutCallback, layoutCallback), (pendingNavigation ? Promise.allSettled([
                    pendingNavigation.finished,
                    ownerWindow
                ]) : ownerWindow).then(afterMutationCallback, afterMutationCallback);
                layoutCallback();
                if (pendingNavigation) return pendingNavigation.finished.then(afterMutationCallback, afterMutationCallback);
                afterMutationCallback();
            },
            types: transitionTypes
        });
        ownerDocument.__reactViewTransition = transition;
        var viewTransitionAnimations = [];
        transition.ready.then(function() {
            for(var animations = ownerDocument.documentElement.getAnimations({
                subtree: !0
            }), i = 0; i < animations.length; i++){
                var animation = animations[i], effect = animation.effect, pseudoElement = effect.pseudoElement;
                if (null != pseudoElement && pseudoElement.startsWith("::view-transition")) {
                    viewTransitionAnimations.push(animation);
                    animation = effect.getKeyframes();
                    for(var height = pseudoElement = void 0, unchangedDimensions = !0, j = 0; j < animation.length; j++){
                        var keyframe = animation[j], w = keyframe.width;
                        if (void 0 === pseudoElement) pseudoElement = w;
                        else if (pseudoElement !== w) {
                            unchangedDimensions = !1;
                            break;
                        }
                        w = keyframe.height;
                        if (void 0 === height) height = w;
                        else if (height !== w) {
                            unchangedDimensions = !1;
                            break;
                        }
                        delete keyframe.width;
                        delete keyframe.height;
                        "none" === keyframe.transform && delete keyframe.transform;
                    }
                    unchangedDimensions && void 0 !== pseudoElement && void 0 !== height && (effect.setKeyframes(animation), unchangedDimensions = getComputedStyle(effect.target, effect.pseudoElement), unchangedDimensions.width !== pseudoElement || unchangedDimensions.height !== height) && (unchangedDimensions = animation[0], unchangedDimensions.width = pseudoElement, unchangedDimensions.height = height, unchangedDimensions = animation[animation.length - 1], unchangedDimensions.width = pseudoElement, unchangedDimensions.height = height, effect.setKeyframes(animation));
                }
            }
            spawnedWorkCallback();
        }, function(error) {
            ownerDocument.__reactViewTransition === transition && (ownerDocument.__reactViewTransition = null);
            try {
                if ("object" === typeof error && null !== error) switch(error.name){
                    case "InvalidStateError":
                        if ("View transition was skipped because document visibility state is hidden." === error.message || "Skipping view transition because document visibility state has become hidden." === error.message || "Skipping view transition because viewport size changed." === error.message || "Transition was aborted because of invalid state" === error.message) error = null;
                }
                null !== error && errorCallback(error);
            } finally{
                mutationCallback(), layoutCallback(), spawnedWorkCallback();
            }
        });
        transition.finished.finally(function() {
            for(var i = 0; i < viewTransitionAnimations.length; i++)viewTransitionAnimations[i].cancel();
            ownerDocument.__reactViewTransition === transition && (ownerDocument.__reactViewTransition = null);
            passiveCallback();
        });
        return transition;
    } catch (x) {
        return mutationCallback(), layoutCallback(), spawnedWorkCallback(), null;
    }
}
function $dca0ddb82b882518$var$ViewTransitionPseudoElement(pseudo, name) {
    this._scope = document.documentElement;
    this._selector = "::view-transition-" + pseudo + "(" + name + ")";
}
$dca0ddb82b882518$var$ViewTransitionPseudoElement.prototype.animate = function(keyframes, options) {
    options = "number" === typeof options ? {
        duration: options
    } : $dca0ddb82b882518$var$assign({}, options);
    options.pseudoElement = this._selector;
    return this._scope.animate(keyframes, options);
};
$dca0ddb82b882518$var$ViewTransitionPseudoElement.prototype.getAnimations = function() {
    for(var scope = this._scope, selector = this._selector, animations = scope.getAnimations({
        subtree: !0
    }), result = [], i = 0; i < animations.length; i++){
        var effect = animations[i].effect;
        null !== effect && effect.target === scope && effect.pseudoElement === selector && result.push(animations[i]);
    }
    return result;
};
$dca0ddb82b882518$var$ViewTransitionPseudoElement.prototype.getComputedStyle = function() {
    return getComputedStyle(this._scope, this._selector);
};
function $dca0ddb82b882518$var$createViewTransitionInstance(name) {
    return {
        name: name,
        group: new $dca0ddb82b882518$var$ViewTransitionPseudoElement("group", name),
        imagePair: new $dca0ddb82b882518$var$ViewTransitionPseudoElement("image-pair", name),
        old: new $dca0ddb82b882518$var$ViewTransitionPseudoElement("old", name),
        new: new $dca0ddb82b882518$var$ViewTransitionPseudoElement("new", name)
    };
}
function $dca0ddb82b882518$var$FragmentInstance(fragmentFiber) {
    this._fragmentFiber = fragmentFiber;
    this._observers = this._eventListeners = null;
}
$dca0ddb82b882518$var$FragmentInstance.prototype.addEventListener = function(type, listener, optionsOrUseCapture) {
    var signal = null, cleanup = null;
    if (null != optionsOrUseCapture && "boolean" !== typeof optionsOrUseCapture && (signal = optionsOrUseCapture.signal || null, null !== signal && signal.aborted)) return;
    null === this._eventListeners && (this._eventListeners = []);
    var listeners = this._eventListeners;
    if (-1 === $dca0ddb82b882518$var$indexOfEventListener(listeners, type, listener, optionsOrUseCapture)) {
        var fragmentInstance = this, attachedListener = listener;
        null != optionsOrUseCapture && "boolean" !== typeof optionsOrUseCapture && !0 === optionsOrUseCapture.once && (attachedListener = function(event) {
            fragmentInstance.removeEventListener(type, listener, optionsOrUseCapture);
            "function" === typeof listener ? listener.call(this, event) : listener.handleEvent(event);
        });
        null !== signal && (cleanup = fragmentInstance.removeEventListener.bind(fragmentInstance, type, listener, optionsOrUseCapture), signal.addEventListener("abort", cleanup, {
            once: !0
        }), cleanup = signal.removeEventListener.bind(signal, "abort", cleanup));
        signal = $dca0ddb82b882518$var$getAttachOptions(optionsOrUseCapture);
        listeners.push({
            type: type,
            listener: listener,
            optionsOrUseCapture: optionsOrUseCapture,
            attachedListener: attachedListener,
            cleanup: cleanup
        });
        $dca0ddb82b882518$var$traverseVisibleInstancesAndTextInstances(this._fragmentFiber.child, !1, $dca0ddb82b882518$var$addEventListenerToChild, type, attachedListener, signal);
    }
    this._eventListeners = listeners;
};
function $dca0ddb82b882518$var$addEventListenerToChild(child, type, listener, optionsOrUseCapture) {
    $dca0ddb82b882518$var$getInstanceFromHostFiber(child).addEventListener(type, listener, optionsOrUseCapture);
    return !1;
}
$dca0ddb82b882518$var$FragmentInstance.prototype.removeEventListener = function(type, listener, optionsOrUseCapture) {
    var listeners = this._eventListeners;
    if (null !== listeners && (listener = $dca0ddb82b882518$var$indexOfEventListener(listeners, type, listener, optionsOrUseCapture), -1 !== listener)) {
        var _listeners$index = listeners[listener];
        optionsOrUseCapture = _listeners$index.attachedListener;
        var cleanup = _listeners$index.cleanup;
        _listeners$index = $dca0ddb82b882518$var$getAttachOptions(_listeners$index.optionsOrUseCapture);
        $dca0ddb82b882518$var$traverseVisibleInstancesAndTextInstances(this._fragmentFiber.child, !1, $dca0ddb82b882518$var$removeEventListenerFromChild, type, optionsOrUseCapture, _listeners$index);
        listeners.splice(listener, 1);
        null !== cleanup && cleanup();
    }
};
function $dca0ddb82b882518$var$removeEventListenerFromChild(child, type, listener, optionsOrUseCapture) {
    $dca0ddb82b882518$var$getInstanceFromHostFiber(child).removeEventListener(type, listener, optionsOrUseCapture);
    return !1;
}
function $dca0ddb82b882518$var$getAttachOptions(opts) {
    return null != opts && "boolean" !== typeof opts && (!0 === opts.once || opts.signal instanceof AbortSignal) ? {
        capture: opts.capture,
        passive: opts.passive
    } : opts;
}
function $dca0ddb82b882518$var$normalizeListenerOptions(opts) {
    return null == opts ? "c=0" : "boolean" === typeof opts ? "c=" + (opts ? "1" : "0") : "c=" + (opts.capture ? "1" : "0");
}
function $dca0ddb82b882518$var$indexOfEventListener(eventListeners, type, listener, optionsOrUseCapture) {
    if (0 === eventListeners.length) return -1;
    optionsOrUseCapture = $dca0ddb82b882518$var$normalizeListenerOptions(optionsOrUseCapture);
    for(var i = 0; i < eventListeners.length; i++){
        var item = eventListeners[i];
        if (item.type === type && item.listener === listener && $dca0ddb82b882518$var$normalizeListenerOptions(item.optionsOrUseCapture) === optionsOrUseCapture) return i;
    }
    return -1;
}
$dca0ddb82b882518$var$FragmentInstance.prototype.dispatchEvent = function(event) {
    var parentHostFiber = $dca0ddb82b882518$var$getFragmentParentInstanceOrContainerFiber(this._fragmentFiber);
    if (null === parentHostFiber) return !0;
    parentHostFiber = $dca0ddb82b882518$var$getInstanceFromHostFiber(parentHostFiber);
    var eventListeners = this._eventListeners;
    if (null !== eventListeners && 0 < eventListeners.length || !event.bubbles) {
        var temp = 9 === parentHostFiber.nodeType ? parentHostFiber.createComment("") : document.createTextNode("");
        if (eventListeners) for(var i = 0; i < eventListeners.length; i++){
            var _eventListeners$i = eventListeners[i];
            temp.addEventListener(_eventListeners$i.type, _eventListeners$i.attachedListener, $dca0ddb82b882518$var$getAttachOptions(_eventListeners$i.optionsOrUseCapture));
        }
        parentHostFiber.appendChild(temp);
        event = temp.dispatchEvent(event);
        if (eventListeners) for(i = 0; i < eventListeners.length; i++)_eventListeners$i = eventListeners[i], temp.removeEventListener(_eventListeners$i.type, _eventListeners$i.attachedListener, $dca0ddb82b882518$var$getAttachOptions(_eventListeners$i.optionsOrUseCapture));
        parentHostFiber.removeChild(temp);
        return event;
    }
    return parentHostFiber.dispatchEvent(event);
};
$dca0ddb82b882518$var$FragmentInstance.prototype.focus = function(focusOptions) {
    $dca0ddb82b882518$var$traverseVisibleInstancesAndTextInstances(this._fragmentFiber.child, !0, $dca0ddb82b882518$var$setFocusOnFiberIfFocusable, focusOptions, void 0, void 0);
};
function $dca0ddb82b882518$var$setFocusOnFiberIfFocusable(fiber, focusOptions) {
    if (6 === fiber.tag) return !1;
    fiber = $dca0ddb82b882518$var$getInstanceFromHostFiber(fiber);
    return $dca0ddb82b882518$var$setFocusIfFocusable(fiber, focusOptions);
}
$dca0ddb82b882518$var$FragmentInstance.prototype.focusLast = function(focusOptions) {
    var children = [];
    $dca0ddb82b882518$var$traverseVisibleInstancesAndTextInstances(this._fragmentFiber.child, !0, $dca0ddb82b882518$var$collectChildren, children, void 0, void 0);
    for(var i = children.length - 1; 0 <= i && !$dca0ddb82b882518$var$setFocusOnFiberIfFocusable(children[i], focusOptions); i--);
};
function $dca0ddb82b882518$var$collectChildren(child, collection) {
    collection.push(child);
    return !1;
}
$dca0ddb82b882518$var$FragmentInstance.prototype.blur = function() {
    var parentHostFiber = $dca0ddb82b882518$var$getFragmentParentInstanceOrContainerFiber(this._fragmentFiber);
    null !== parentHostFiber && (parentHostFiber = $dca0ddb82b882518$var$getInstanceFromHostFiber(parentHostFiber), parentHostFiber = $dca0ddb82b882518$var$getOwnerDocumentFromRootContainer(parentHostFiber).activeElement, null !== parentHostFiber && $dca0ddb82b882518$var$traverseVisibleInstancesAndTextInstances(this._fragmentFiber.child, !1, $dca0ddb82b882518$var$blurActiveElementWithinFragment, parentHostFiber, void 0, void 0));
};
function $dca0ddb82b882518$var$blurActiveElementWithinFragment(child, activeElement) {
    if (6 === child.tag) return !1;
    child = $dca0ddb82b882518$var$getInstanceFromHostFiber(child);
    return child === activeElement || child.contains(activeElement) ? (activeElement.blur(), !0) : !1;
}
$dca0ddb82b882518$var$FragmentInstance.prototype.observeUsing = function(observer) {
    null === this._observers && (this._observers = new Set());
    this._observers.add(observer);
    $dca0ddb82b882518$var$traverseVisibleInstancesAndTextInstances(this._fragmentFiber.child, !1, $dca0ddb82b882518$var$observeChild, observer, void 0, void 0);
};
function $dca0ddb82b882518$var$observeChild(child, observer) {
    if (6 === child.tag) return !1;
    child = $dca0ddb82b882518$var$getInstanceFromHostFiber(child);
    observer.observe(child);
    return !1;
}
$dca0ddb82b882518$var$FragmentInstance.prototype.unobserveUsing = function(observer) {
    var observers = this._observers;
    if (null !== observers && observers.has(observer)) {
        observers.delete(observer);
        $dca0ddb82b882518$var$traverseVisibleInstancesAndTextInstances(this._fragmentFiber.child, !1, $dca0ddb82b882518$var$unobserveChild, observer, void 0, void 0);
        for(var i = observers = 0; i < $dca0ddb82b882518$var$pendingIntersectionUnobserves.length; i++){
            var pending = $dca0ddb82b882518$var$pendingIntersectionUnobserves[i];
            pending.fragmentInstance === this && pending.observer === observer ? observer.unobserve(pending.instance) : $dca0ddb82b882518$var$pendingIntersectionUnobserves[observers++] = pending;
        }
        $dca0ddb82b882518$var$pendingIntersectionUnobserves.length = observers;
    }
};
function $dca0ddb82b882518$var$unobserveChild(child, observer) {
    if (6 === child.tag) return !1;
    child = $dca0ddb82b882518$var$getInstanceFromHostFiber(child);
    observer.unobserve(child);
    return !1;
}
var $dca0ddb82b882518$var$pendingIntersectionUnobserves = [], $dca0ddb82b882518$var$intersectionUnobserveScheduled = !1;
function $dca0ddb82b882518$var$schedulePendingIntersectionUnobserve(fragmentInstance, observer, instance) {
    $dca0ddb82b882518$var$pendingIntersectionUnobserves.push({
        fragmentInstance: fragmentInstance,
        observer: observer,
        instance: instance
    });
    $dca0ddb82b882518$var$intersectionUnobserveScheduled || ($dca0ddb82b882518$var$intersectionUnobserveScheduled = !0, $dca0ddb82b882518$var$requestPostPaintCallback(function() {
        $dca0ddb82b882518$var$intersectionUnobserveScheduled = !1;
        var pending = $dca0ddb82b882518$var$pendingIntersectionUnobserves;
        $dca0ddb82b882518$var$pendingIntersectionUnobserves = [];
        for(var i = 0; i < pending.length; i++){
            var item = pending[i];
            item.observer.unobserve(item.instance);
        }
    }));
}
$dca0ddb82b882518$var$FragmentInstance.prototype.getClientRects = function() {
    var rects = [];
    $dca0ddb82b882518$var$traverseVisibleInstancesAndTextInstances(this._fragmentFiber.child, !1, $dca0ddb82b882518$var$collectClientRects, rects, void 0, void 0);
    return rects;
};
function $dca0ddb82b882518$var$collectClientRects(child, rects) {
    if (6 === child.tag) {
        child = child.stateNode;
        var range = child.ownerDocument.createRange();
        range.selectNodeContents(child);
        rects.push.apply(rects, range.getClientRects());
    } else child = $dca0ddb82b882518$var$getInstanceFromHostFiber(child), rects.push.apply(rects, child.getClientRects());
    return !1;
}
$dca0ddb82b882518$var$FragmentInstance.prototype.getRootNode = function(getRootNodeOptions) {
    var parentHostFiber = $dca0ddb82b882518$var$getFragmentParentInstanceOrContainerFiber(this._fragmentFiber);
    return null === parentHostFiber ? this : $dca0ddb82b882518$var$getInstanceFromHostFiber(parentHostFiber).getRootNode(getRootNodeOptions);
};
$dca0ddb82b882518$var$FragmentInstance.prototype.compareDocumentPosition = function(otherNode) {
    var parentHostFiber = $dca0ddb82b882518$var$getFragmentParentInstanceOrContainerFiber(this._fragmentFiber);
    if (null === parentHostFiber) return Node.DOCUMENT_POSITION_DISCONNECTED;
    var children = [];
    $dca0ddb82b882518$var$traverseVisibleInstancesAndTextInstances(this._fragmentFiber.child, !1, $dca0ddb82b882518$var$collectChildren, children, void 0, void 0);
    var parentHostInstance = $dca0ddb82b882518$var$getInstanceFromHostFiber(parentHostFiber);
    if (0 === children.length) {
        children = parentHostInstance;
        if ($dca0ddb82b882518$var$fiberIsPortaledIntoHost(this._fragmentFiber)) {
            a: {
                for(parentHostFiber = this._fragmentFiber.return; null !== parentHostFiber;){
                    if (4 === parentHostFiber.tag) {
                        parentHostFiber = parentHostFiber.stateNode.containerInfo;
                        break a;
                    }
                    if (3 === parentHostFiber.tag || 5 === parentHostFiber.tag || 27 === parentHostFiber.tag) break;
                    parentHostFiber = parentHostFiber.return;
                }
                parentHostFiber = null;
            }
            null != parentHostFiber && (children = parentHostFiber);
        }
        parentHostFiber = this._fragmentFiber;
        var result = parentHostInstance = children.compareDocumentPosition(otherNode);
        children === otherNode ? result = Node.DOCUMENT_POSITION_CONTAINS : parentHostInstance & Node.DOCUMENT_POSITION_CONTAINED_BY && (children = $dca0ddb82b882518$var$getFragmentInstanceOrTextInstanceSiblings(parentHostFiber)[1], null === children ? result = Node.DOCUMENT_POSITION_PRECEDING : (otherNode = $dca0ddb82b882518$var$getInstanceFromHostFiber(children).compareDocumentPosition(otherNode), result = 0 === otherNode || otherNode & Node.DOCUMENT_POSITION_FOLLOWING ? Node.DOCUMENT_POSITION_FOLLOWING : Node.DOCUMENT_POSITION_PRECEDING));
        return result |= Node.DOCUMENT_POSITION_IMPLEMENTATION_SPECIFIC;
    }
    parentHostFiber = $dca0ddb82b882518$var$getInstanceFromHostFiber(children[0]);
    result = $dca0ddb82b882518$var$getInstanceFromHostFiber(children[children.length - 1]);
    var parentHostInstanceFromDOM = $dca0ddb82b882518$var$fiberIsPortaledIntoHost(this._fragmentFiber) ? parentHostFiber.parentElement : parentHostInstance;
    if (null == parentHostInstanceFromDOM) return Node.DOCUMENT_POSITION_DISCONNECTED;
    parentHostInstance = parentHostInstanceFromDOM.compareDocumentPosition(parentHostFiber) & Node.DOCUMENT_POSITION_CONTAINED_BY;
    parentHostInstanceFromDOM = parentHostInstanceFromDOM.compareDocumentPosition(result) & Node.DOCUMENT_POSITION_CONTAINED_BY;
    var firstResult = parentHostFiber.compareDocumentPosition(otherNode), lastResult = result.compareDocumentPosition(otherNode), otherNodeIsWithinFirstOrLastChild = firstResult & Node.DOCUMENT_POSITION_CONTAINED_BY || lastResult & Node.DOCUMENT_POSITION_CONTAINED_BY;
    lastResult = parentHostInstance && parentHostInstanceFromDOM && firstResult & Node.DOCUMENT_POSITION_FOLLOWING && lastResult & Node.DOCUMENT_POSITION_PRECEDING;
    parentHostFiber = parentHostInstance && parentHostFiber === otherNode || parentHostInstanceFromDOM && result === otherNode || otherNodeIsWithinFirstOrLastChild || lastResult ? Node.DOCUMENT_POSITION_CONTAINED_BY : !parentHostInstance && parentHostFiber === otherNode || !parentHostInstanceFromDOM && result === otherNode ? Node.DOCUMENT_POSITION_IMPLEMENTATION_SPECIFIC : firstResult;
    return parentHostFiber & Node.DOCUMENT_POSITION_DISCONNECTED || parentHostFiber & Node.DOCUMENT_POSITION_IMPLEMENTATION_SPECIFIC || $dca0ddb82b882518$var$validateDocumentPositionWithFiberTree(parentHostFiber, this._fragmentFiber, children[0], children[children.length - 1], otherNode) ? parentHostFiber : Node.DOCUMENT_POSITION_IMPLEMENTATION_SPECIFIC;
};
function $dca0ddb82b882518$var$validateDocumentPositionWithFiberTree(documentPosition, fragmentFiber, precedingBoundaryFiber, followingBoundaryFiber, otherNode) {
    var otherFiber = $dca0ddb82b882518$var$getClosestInstanceFromNode(otherNode);
    if (documentPosition & Node.DOCUMENT_POSITION_CONTAINED_BY) {
        if (precedingBoundaryFiber = !!otherFiber) a: {
            for(; null !== otherFiber;){
                if (7 === otherFiber.tag && (otherFiber === fragmentFiber || otherFiber.alternate === fragmentFiber)) {
                    precedingBoundaryFiber = !0;
                    break a;
                }
                otherFiber = otherFiber.return;
            }
            precedingBoundaryFiber = !1;
        }
        return precedingBoundaryFiber;
    }
    if (documentPosition & Node.DOCUMENT_POSITION_CONTAINS) {
        if (null === otherFiber) return otherFiber = otherNode.ownerDocument, otherNode === otherFiber || otherNode === otherFiber.documentElement || otherNode === otherFiber.body;
        a: {
            otherFiber = fragmentFiber;
            for(fragmentFiber = $dca0ddb82b882518$var$getFragmentParentInstanceOrContainerFiber(fragmentFiber); null !== otherFiber;){
                if (!(5 !== otherFiber.tag && 3 !== otherFiber.tag && 27 !== otherFiber.tag || otherFiber !== fragmentFiber && otherFiber.alternate !== fragmentFiber)) {
                    otherFiber = !0;
                    break a;
                }
                otherFiber = otherFiber.return;
            }
            otherFiber = !1;
        }
        return otherFiber;
    }
    return documentPosition & Node.DOCUMENT_POSITION_PRECEDING ? ((fragmentFiber = !!otherFiber) && !(fragmentFiber = otherFiber === precedingBoundaryFiber) && (fragmentFiber = $dca0ddb82b882518$var$getLowestCommonAncestor(precedingBoundaryFiber, otherFiber, $dca0ddb82b882518$var$getParentForFragmentAncestors), null === fragmentFiber ? fragmentFiber = !1 : ($dca0ddb82b882518$var$traverseVisibleInstancesAndTextInstances(fragmentFiber, !0, $dca0ddb82b882518$var$isFiberPrecedingCheck, otherFiber, precedingBoundaryFiber), otherFiber = $dca0ddb82b882518$var$searchTarget, $dca0ddb82b882518$var$searchTarget = null, fragmentFiber = null !== otherFiber)), fragmentFiber) : documentPosition & Node.DOCUMENT_POSITION_FOLLOWING ? ((fragmentFiber = !!otherFiber) && !(fragmentFiber = otherFiber === followingBoundaryFiber) && (fragmentFiber = $dca0ddb82b882518$var$getLowestCommonAncestor(followingBoundaryFiber, otherFiber, $dca0ddb82b882518$var$getParentForFragmentAncestors), null === fragmentFiber ? fragmentFiber = !1 : ($dca0ddb82b882518$var$traverseVisibleInstancesAndTextInstances(fragmentFiber, !0, $dca0ddb82b882518$var$isFiberFollowingCheck, otherFiber, followingBoundaryFiber), otherFiber = $dca0ddb82b882518$var$searchTarget, $dca0ddb82b882518$var$searchBoundary = $dca0ddb82b882518$var$searchTarget = null, fragmentFiber = null !== otherFiber)), fragmentFiber) : !1;
}
function $dca0ddb82b882518$var$scrollTextNodeIntoView(textNode, resolvedAlignToTop) {
    var range = textNode.ownerDocument.createRange();
    range.selectNodeContents(textNode);
    textNode = range.getBoundingClientRect();
    window.scrollTo(window.scrollX + textNode.left, resolvedAlignToTop ? window.scrollY + textNode.top : window.scrollY + textNode.bottom - window.innerHeight);
}
$dca0ddb82b882518$var$FragmentInstance.prototype.scrollIntoView = function(alignToTop) {
    if ("object" === typeof alignToTop) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(566));
    var children = [];
    $dca0ddb82b882518$var$traverseVisibleInstancesAndTextInstances(this._fragmentFiber.child, !1, $dca0ddb82b882518$var$collectChildren, children, void 0, void 0);
    var resolvedAlignToTop = !1 !== alignToTop;
    if (0 === children.length) {
        var hostSiblings = $dca0ddb82b882518$var$getFragmentInstanceOrTextInstanceSiblings(this._fragmentFiber);
        hostSiblings = resolvedAlignToTop ? hostSiblings[1] || hostSiblings[0] || $dca0ddb82b882518$var$getFragmentParentInstanceOrContainerFiber(this._fragmentFiber) : hostSiblings[0] || hostSiblings[1];
        if (null === hostSiblings) return;
        if (6 === hostSiblings.tag) {
            alignToTop = $dca0ddb82b882518$var$getInstanceFromHostFiber(hostSiblings);
            $dca0ddb82b882518$var$scrollTextNodeIntoView(alignToTop, resolvedAlignToTop);
            return;
        }
        hostSiblings = $dca0ddb82b882518$var$getInstanceFromHostFiber(hostSiblings);
        if (9 !== hostSiblings.nodeType) {
            if (11 === hostSiblings.nodeType) {
                resolvedAlignToTop = "host" in hostSiblings ? hostSiblings.host : null;
                null !== resolvedAlignToTop && resolvedAlignToTop.scrollIntoView(alignToTop);
                return;
            }
            hostSiblings.scrollIntoView(alignToTop);
        }
    }
    for(hostSiblings = resolvedAlignToTop ? children.length - 1 : 0; hostSiblings !== (resolvedAlignToTop ? -1 : children.length);){
        var child = children[hostSiblings];
        6 === child.tag ? (child = $dca0ddb82b882518$var$getInstanceFromHostFiber(child), $dca0ddb82b882518$var$scrollTextNodeIntoView(child, resolvedAlignToTop)) : $dca0ddb82b882518$var$getInstanceFromHostFiber(child).scrollIntoView(alignToTop);
        hostSiblings += resolvedAlignToTop ? -1 : 1;
    }
};
function $dca0ddb82b882518$var$addFragmentHandleToFiber(child, fragmentInstance) {
    child = $dca0ddb82b882518$var$getInstanceFromHostFiber(child);
    $dca0ddb82b882518$var$addFragmentHandleToInstance(child, fragmentInstance);
    return !1;
}
function $dca0ddb82b882518$var$addFragmentHandleToInstance(instance, fragmentInstance) {
    null == instance.reactFragments && (instance.reactFragments = new Set());
    instance.reactFragments.add(fragmentInstance);
}
function $dca0ddb82b882518$var$commitNewChildToFragmentInstance(childInstance, fragmentInstance) {
    var eventListeners = fragmentInstance._eventListeners;
    if (null !== eventListeners) for(var i$jscomp$0 = 0; i$jscomp$0 < eventListeners.length; i$jscomp$0++){
        var _eventListeners$i3 = eventListeners[i$jscomp$0];
        childInstance.addEventListener(_eventListeners$i3.type, _eventListeners$i3.attachedListener, $dca0ddb82b882518$var$getAttachOptions(_eventListeners$i3.optionsOrUseCapture));
    }
    3 !== childInstance.nodeType && (eventListeners = fragmentInstance._observers, null !== eventListeners && eventListeners.forEach(function(observer) {
        for(var writeIdx = 0, i = 0; i < $dca0ddb82b882518$var$pendingIntersectionUnobserves.length; i++){
            var pending = $dca0ddb82b882518$var$pendingIntersectionUnobserves[i];
            if (pending.fragmentInstance !== fragmentInstance || pending.observer !== observer || pending.instance !== childInstance) $dca0ddb82b882518$var$pendingIntersectionUnobserves[writeIdx++] = pending;
        }
        $dca0ddb82b882518$var$pendingIntersectionUnobserves.length = writeIdx;
        observer.observe(childInstance);
    }), $dca0ddb82b882518$var$addFragmentHandleToInstance(childInstance, fragmentInstance));
}
function $dca0ddb82b882518$var$deleteChildFromFragmentInstance(childInstance, fragmentInstance) {
    var eventListeners = fragmentInstance._eventListeners;
    if (null !== eventListeners) for(var i = 0; i < eventListeners.length; i++){
        var _eventListeners$i4 = eventListeners[i];
        childInstance.removeEventListener(_eventListeners$i4.type, _eventListeners$i4.attachedListener, $dca0ddb82b882518$var$getAttachOptions(_eventListeners$i4.optionsOrUseCapture));
    }
    3 !== childInstance.nodeType && (eventListeners = fragmentInstance._observers, null !== eventListeners && eventListeners.forEach(function(observer) {
        "string" === typeof observer.rootMargin ? $dca0ddb82b882518$var$schedulePendingIntersectionUnobserve(fragmentInstance, observer, childInstance) : observer.unobserve(childInstance);
    }), null != childInstance.reactFragments && childInstance.reactFragments.delete(fragmentInstance));
}
function $dca0ddb82b882518$var$clearContainerSparingly(container) {
    var nextNode = container.firstChild;
    nextNode && 10 === nextNode.nodeType && (nextNode = nextNode.nextSibling);
    for(; nextNode;){
        var node = nextNode;
        nextNode = nextNode.nextSibling;
        switch(node.nodeName){
            case "HTML":
            case "HEAD":
            case "BODY":
                $dca0ddb82b882518$var$clearContainerSparingly(node);
                $dca0ddb82b882518$var$detachDeletedInstance(node);
                continue;
            case "SCRIPT":
            case "STYLE":
                continue;
            case "LINK":
                if ("stylesheet" === node.rel.toLowerCase()) continue;
        }
        container.removeChild(node);
    }
}
function $dca0ddb82b882518$var$canHydrateInstance(instance, type, props, inRootOrSingleton) {
    for(; 1 === instance.nodeType;){
        var anyProps = props;
        if (instance.nodeName.toLowerCase() !== type.toLowerCase()) {
            if (!inRootOrSingleton && ("INPUT" !== instance.nodeName || "hidden" !== instance.type)) break;
        } else if (!inRootOrSingleton) {
            if ("input" === type && "hidden" === instance.type) {
                var name = null == anyProps.name ? null : "" + anyProps.name;
                if ("hidden" === anyProps.type && instance.getAttribute("name") === name) return instance;
            } else return instance;
        } else if (!instance[$dca0ddb82b882518$var$internalHoistableMarker]) switch(type){
            case "meta":
                if (!instance.hasAttribute("itemprop")) break;
                return instance;
            case "link":
                name = instance.getAttribute("rel");
                if ("stylesheet" === name && instance.hasAttribute("data-precedence")) break;
                else if (name !== anyProps.rel || instance.getAttribute("href") !== (null == anyProps.href || "" === anyProps.href ? null : anyProps.href) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin) || instance.getAttribute("title") !== (null == anyProps.title ? null : anyProps.title)) break;
                return instance;
            case "style":
                if (instance.hasAttribute("data-precedence")) break;
                return instance;
            case "script":
                name = instance.getAttribute("src");
                if ((name !== (null == anyProps.src ? null : anyProps.src) || instance.getAttribute("type") !== (null == anyProps.type ? null : anyProps.type) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin)) && name && instance.hasAttribute("async") && !instance.hasAttribute("itemprop")) break;
                return instance;
            default:
                return instance;
        }
        instance = $dca0ddb82b882518$var$getNextHydratable(instance.nextSibling);
        if (null === instance) break;
    }
    return null;
}
function $dca0ddb82b882518$var$canHydrateTextInstance(instance, text, inRootOrSingleton) {
    if ("" === text) return null;
    for(; 3 !== instance.nodeType;){
        if ((1 !== instance.nodeType || "INPUT" !== instance.nodeName || "hidden" !== instance.type) && !inRootOrSingleton) return null;
        instance = $dca0ddb82b882518$var$getNextHydratable(instance.nextSibling);
        if (null === instance) return null;
    }
    return instance;
}
function $dca0ddb82b882518$var$canHydrateHydrationBoundary(instance, inRootOrSingleton) {
    for(; 8 !== instance.nodeType;){
        if ((1 !== instance.nodeType || "INPUT" !== instance.nodeName || "hidden" !== instance.type) && !inRootOrSingleton) return null;
        instance = $dca0ddb82b882518$var$getNextHydratable(instance.nextSibling);
        if (null === instance) return null;
    }
    return instance;
}
function $dca0ddb82b882518$var$isSuspenseInstancePending(instance) {
    return "$?" === instance.data || "$~" === instance.data;
}
function $dca0ddb82b882518$var$isSuspenseInstanceFallback(instance) {
    return "$!" === instance.data || "$?" === instance.data && "loading" !== instance.ownerDocument.readyState;
}
function $dca0ddb82b882518$var$registerSuspenseInstanceRetry(instance, callback) {
    var ownerDocument = instance.ownerDocument;
    if ("$~" === instance.data) instance._reactRetry = callback;
    else if ("$?" !== instance.data || "loading" !== ownerDocument.readyState) callback();
    else {
        var listener = function() {
            callback();
            ownerDocument.removeEventListener("DOMContentLoaded", listener);
        };
        ownerDocument.addEventListener("DOMContentLoaded", listener);
        instance._reactRetry = listener;
    }
}
function $dca0ddb82b882518$var$getNextHydratable(node) {
    for(; null != node; node = node.nextSibling){
        var nodeType = node.nodeType;
        if (1 === nodeType || 3 === nodeType) break;
        if (8 === nodeType) {
            nodeType = node.data;
            if ("$" === nodeType || "$!" === nodeType || "$?" === nodeType || "$~" === nodeType || "&" === nodeType || "F!" === nodeType || "F" === nodeType) break;
            if ("/$" === nodeType || "/&" === nodeType) return null;
        }
    }
    return node;
}
var $dca0ddb82b882518$var$previousHydratableOnEnteringScopedSingleton = null;
function $dca0ddb82b882518$var$getNextHydratableInstanceAfterHydrationBoundary(hydrationInstance) {
    hydrationInstance = hydrationInstance.nextSibling;
    for(var depth = 0; hydrationInstance;){
        if (8 === hydrationInstance.nodeType) {
            var data = hydrationInstance.data;
            if ("/$" === data || "/&" === data) {
                if (0 === depth) return $dca0ddb82b882518$var$getNextHydratable(hydrationInstance.nextSibling);
                depth--;
            } else "$" !== data && "$!" !== data && "$?" !== data && "$~" !== data && "&" !== data || depth++;
        }
        hydrationInstance = hydrationInstance.nextSibling;
    }
    return null;
}
function $dca0ddb82b882518$var$getParentHydrationBoundary(targetInstance) {
    targetInstance = targetInstance.previousSibling;
    for(var depth = 0; targetInstance;){
        if (8 === targetInstance.nodeType) {
            var data = targetInstance.data;
            if ("$" === data || "$!" === data || "$?" === data || "$~" === data || "&" === data) {
                if (0 === depth) return targetInstance;
                depth--;
            } else "/$" !== data && "/&" !== data || depth++;
        }
        targetInstance = targetInstance.previousSibling;
    }
    return null;
}
function $dca0ddb82b882518$var$setFocusIfFocusable(node, focusOptions) {
    function handleFocus() {
        didFocus = !0;
    }
    if (node.ownerDocument.activeElement === node) return !0;
    var didFocus = !1;
    try {
        node.ownerDocument.addEventListener("focus", handleFocus, !0), (node.focus || HTMLElement.prototype.focus).call(node, focusOptions);
    } finally{
        node.ownerDocument.removeEventListener("focus", handleFocus, !0);
    }
    return didFocus;
}
function $dca0ddb82b882518$var$requestPostPaintCallback(callback) {
    $dca0ddb82b882518$var$localRequestAnimationFrame(function() {
        $dca0ddb82b882518$var$localRequestAnimationFrame(function(time) {
            return callback(time);
        });
    });
}
function $dca0ddb82b882518$var$resolveSingletonInstance(type, props, rootContainerInstance) {
    props = $dca0ddb82b882518$var$getOwnerDocumentFromRootContainer(rootContainerInstance);
    switch(type){
        case "html":
            type = props.documentElement;
            if (!type) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(452));
            return type;
        case "head":
            type = props.head;
            if (!type) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(453));
            return type;
        case "body":
            type = props.body;
            if (!type) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(454));
            return type;
        default:
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(451));
    }
}
function $dca0ddb82b882518$var$releaseSingletonInstance(instance, type, props) {
    for(var propKey in props){
        var propValue = props[propKey];
        props.hasOwnProperty(propKey) && null != propValue && $dca0ddb82b882518$var$setProp(instance, type, propKey, null, $dca0ddb82b882518$var$emptyProps, propValue);
    }
    null != props.dangerouslySetInnerHTML && (instance.textContent = "");
    instance.onclick === $dca0ddb82b882518$var$noop$1 && (instance.onclick = null);
    $dca0ddb82b882518$var$detachDeletedInstance(instance);
}
function $dca0ddb82b882518$var$clearSingletonPreambleContribution(instance) {
    for(var attributes = instance.attributes; attributes.length;)instance.removeAttributeNode(attributes[0]);
    $dca0ddb82b882518$var$detachDeletedInstance(instance);
}
var $dca0ddb82b882518$var$preloadPropsMap = new Map(), $dca0ddb82b882518$var$preconnectsSet = new Set();
function $dca0ddb82b882518$var$getHoistableRoot(container) {
    if ("function" === typeof container.getRootNode) {
        var rootNode = container.getRootNode();
        if (9 === rootNode.nodeType || 11 === rootNode.nodeType) return rootNode;
    }
    return 9 === container.nodeType ? container : container.ownerDocument;
}
var $dca0ddb82b882518$var$previousDispatcher = $dca0ddb82b882518$var$ReactDOMSharedInternals.d;
$dca0ddb82b882518$var$ReactDOMSharedInternals.d = {
    f: $dca0ddb82b882518$var$flushSyncWork,
    r: $dca0ddb82b882518$var$requestFormReset,
    D: $dca0ddb82b882518$var$prefetchDNS,
    C: $dca0ddb82b882518$var$preconnect,
    L: $dca0ddb82b882518$var$preload,
    m: $dca0ddb82b882518$var$preloadModule,
    X: $dca0ddb82b882518$var$preinitScript,
    S: $dca0ddb82b882518$var$preinitStyle,
    M: $dca0ddb82b882518$var$preinitModuleScript
};
function $dca0ddb82b882518$var$flushSyncWork() {
    var previousWasRendering = $dca0ddb82b882518$var$previousDispatcher.f(), wasRendering = $dca0ddb82b882518$var$flushSyncWork$1();
    return previousWasRendering || wasRendering;
}
function $dca0ddb82b882518$var$requestFormReset(form) {
    var formInst = $dca0ddb82b882518$var$getInstanceFromNode(form);
    null !== formInst && 5 === formInst.tag && "form" === formInst.type ? $dca0ddb82b882518$var$requestFormReset$1(formInst) : $dca0ddb82b882518$var$previousDispatcher.r(form);
}
var $dca0ddb82b882518$var$globalDocument = "undefined" === typeof document ? null : document;
function $dca0ddb82b882518$var$preconnectAs(rel, href, crossOrigin) {
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && "string" === typeof href && href) {
        var limitedEscapedHref = $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(href);
        limitedEscapedHref = 'link[rel="' + rel + '"][href="' + limitedEscapedHref + '"]';
        "string" === typeof crossOrigin && (limitedEscapedHref += '[crossorigin="' + crossOrigin + '"]');
        $dca0ddb82b882518$var$preconnectsSet.has(limitedEscapedHref) || ($dca0ddb82b882518$var$preconnectsSet.add(limitedEscapedHref), rel = {
            rel: rel,
            crossOrigin: crossOrigin,
            href: href
        }, null === ownerDocument.querySelector(limitedEscapedHref) && (href = ownerDocument.createElement("link"), $dca0ddb82b882518$var$setInitialProperties(href, "link", rel), $dca0ddb82b882518$var$markNodeAsHoistable(href), ownerDocument.head.appendChild(href)));
    }
}
function $dca0ddb82b882518$var$prefetchDNS(href) {
    $dca0ddb82b882518$var$previousDispatcher.D(href);
    $dca0ddb82b882518$var$preconnectAs("dns-prefetch", href, null);
}
function $dca0ddb82b882518$var$preconnect(href, crossOrigin) {
    $dca0ddb82b882518$var$previousDispatcher.C(href, crossOrigin);
    $dca0ddb82b882518$var$preconnectAs("preconnect", href, crossOrigin);
}
function $dca0ddb82b882518$var$preload(href, as, options) {
    $dca0ddb82b882518$var$previousDispatcher.L(href, as, options);
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && href && as) {
        var preloadSelector = 'link[rel="preload"][as="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"]';
        "image" === as ? options && options.imageSrcSet ? (preloadSelector += '[imagesrcset="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSrcSet) + '"]', "string" === typeof options.imageSizes && (preloadSelector += '[imagesizes="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSizes) + '"]')) : preloadSelector += '[href="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]' : preloadSelector += '[href="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]';
        var key = preloadSelector;
        switch(as){
            case "style":
                key = $dca0ddb82b882518$var$getStyleKey(href);
                break;
            case "script":
                key = $dca0ddb82b882518$var$getScriptKey(href);
        }
        if (!($dca0ddb82b882518$var$preloadPropsMap.has(key) || (href = $dca0ddb82b882518$var$assign({
            rel: "preload",
            href: "image" === as && options && options.imageSrcSet ? void 0 : href,
            as: as
        }, options), $dca0ddb82b882518$var$preloadPropsMap.set(key, href), null !== ownerDocument.querySelector(preloadSelector) || "style" === as && ownerDocument.querySelector($dca0ddb82b882518$var$getStylesheetSelectorFromKey(key)) || "script" === as && ownerDocument.querySelector($dca0ddb82b882518$var$getScriptSelectorFromKey(key))))) {
            var instance = ownerDocument.createElement("link");
            $dca0ddb82b882518$var$setInitialProperties(instance, "link", href);
            "style" === as && (instance[$dca0ddb82b882518$var$internalLoadPendingKey] = !0, instance.onload = instance.onerror = function() {
                $dca0ddb82b882518$var$clearPendingLoadOnNode(instance);
            });
            $dca0ddb82b882518$var$markNodeAsHoistable(instance);
            ownerDocument.head.appendChild(instance);
        }
    }
}
function $dca0ddb82b882518$var$preloadModule(href, options) {
    $dca0ddb82b882518$var$previousDispatcher.m(href, options);
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && href) {
        var as = options && "string" === typeof options.as ? options.as : "script", preloadSelector = 'link[rel="modulepreload"][as="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"][href="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]', key = preloadSelector;
        switch(as){
            case "audioworklet":
            case "paintworklet":
            case "serviceworker":
            case "sharedworker":
            case "worker":
            case "script":
                key = $dca0ddb82b882518$var$getScriptKey(href);
        }
        if (!$dca0ddb82b882518$var$preloadPropsMap.has(key) && (href = $dca0ddb82b882518$var$assign({
            rel: "modulepreload",
            href: href
        }, options), $dca0ddb82b882518$var$preloadPropsMap.set(key, href), null === ownerDocument.querySelector(preloadSelector))) {
            switch(as){
                case "audioworklet":
                case "paintworklet":
                case "serviceworker":
                case "sharedworker":
                case "worker":
                case "script":
                    if (ownerDocument.querySelector($dca0ddb82b882518$var$getScriptSelectorFromKey(key))) return;
            }
            as = ownerDocument.createElement("link");
            $dca0ddb82b882518$var$setInitialProperties(as, "link", href);
            $dca0ddb82b882518$var$markNodeAsHoistable(as);
            ownerDocument.head.appendChild(as);
        }
    }
}
function $dca0ddb82b882518$var$preinitStyle(href, precedence, options) {
    $dca0ddb82b882518$var$previousDispatcher.S(href, precedence, options);
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && href) {
        var styles = $dca0ddb82b882518$var$getResourcesFromRoot(ownerDocument).hoistableStyles, key = $dca0ddb82b882518$var$getStyleKey(href);
        precedence = precedence || "default";
        var resource = styles.get(key);
        if (!resource) {
            var state = {
                loading: 0,
                preload: null
            };
            if (resource = ownerDocument.querySelector($dca0ddb82b882518$var$getStylesheetSelectorFromKey(key))) state.loading = 5;
            else {
                href = $dca0ddb82b882518$var$assign({
                    rel: "stylesheet",
                    href: href,
                    "data-precedence": precedence
                }, options);
                (options = $dca0ddb82b882518$var$preloadPropsMap.get(key)) && $dca0ddb82b882518$var$adoptPreloadPropsForStylesheet(href, options);
                var link = resource = ownerDocument.createElement("link");
                $dca0ddb82b882518$var$markNodeAsHoistable(link);
                $dca0ddb82b882518$var$setInitialProperties(link, "link", href);
                link._p = new Promise(function(resolve, reject) {
                    link.onload = resolve;
                    link.onerror = reject;
                });
                link.addEventListener("load", function() {
                    state.loading |= 1;
                });
                link.addEventListener("error", function() {
                    state.loading |= 2;
                });
                state.loading |= 4;
                $dca0ddb82b882518$var$insertStylesheet(resource, precedence, ownerDocument);
            }
            resource = {
                type: "stylesheet",
                instance: resource,
                count: 1,
                state: state
            };
            styles.set(key, resource);
        }
    }
}
function $dca0ddb82b882518$var$preinitScript(src, options) {
    $dca0ddb82b882518$var$previousDispatcher.X(src, options);
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && src) {
        var scripts = $dca0ddb82b882518$var$getResourcesFromRoot(ownerDocument).hoistableScripts, key = $dca0ddb82b882518$var$getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector($dca0ddb82b882518$var$getScriptSelectorFromKey(key)), resource || (src = $dca0ddb82b882518$var$assign({
            src: src,
            async: !0
        }, options), (options = $dca0ddb82b882518$var$preloadPropsMap.get(key)) && $dca0ddb82b882518$var$adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), $dca0ddb82b882518$var$markNodeAsHoistable(resource), $dca0ddb82b882518$var$setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function $dca0ddb82b882518$var$preinitModuleScript(src, options) {
    $dca0ddb82b882518$var$previousDispatcher.M(src, options);
    var ownerDocument = $dca0ddb82b882518$var$globalDocument;
    if (ownerDocument && src) {
        var scripts = $dca0ddb82b882518$var$getResourcesFromRoot(ownerDocument).hoistableScripts, key = $dca0ddb82b882518$var$getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector($dca0ddb82b882518$var$getScriptSelectorFromKey(key)), resource || (src = $dca0ddb82b882518$var$assign({
            src: src,
            async: !0,
            type: "module"
        }, options), (options = $dca0ddb82b882518$var$preloadPropsMap.get(key)) && $dca0ddb82b882518$var$adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), $dca0ddb82b882518$var$markNodeAsHoistable(resource), $dca0ddb82b882518$var$setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function $dca0ddb82b882518$var$getResource(type, currentProps, pendingProps, currentResource) {
    var JSCompiler_inline_result = (JSCompiler_inline_result = $dca0ddb82b882518$var$rootInstanceStackCursor.current) ? $dca0ddb82b882518$var$getHoistableRoot(JSCompiler_inline_result) : null;
    if (!JSCompiler_inline_result) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(446));
    switch(type){
        case "meta":
        case "title":
            return null;
        case "style":
            return "string" === typeof pendingProps.precedence && "string" === typeof pendingProps.href ? (pendingProps = $dca0ddb82b882518$var$getStyleKey(pendingProps.href), currentProps = $dca0ddb82b882518$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, currentResource = currentProps.get(pendingProps), currentResource || (currentResource = {
                type: "style",
                instance: null,
                count: 0,
                state: null
            }, currentProps.set(pendingProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        case "link":
            if ("stylesheet" === pendingProps.rel && "string" === typeof pendingProps.href && "string" === typeof pendingProps.precedence) {
                type = $dca0ddb82b882518$var$getStyleKey(pendingProps.href);
                var styles$268 = $dca0ddb82b882518$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, resource$269 = styles$268.get(type);
                resource$269 || (JSCompiler_inline_result = JSCompiler_inline_result.ownerDocument || JSCompiler_inline_result, resource$269 = {
                    type: "stylesheet",
                    instance: null,
                    count: 0,
                    state: {
                        loading: 0,
                        preload: null
                    }
                }, styles$268.set(type, resource$269), (styles$268 = JSCompiler_inline_result.querySelector($dca0ddb82b882518$var$getStylesheetSelectorFromKey(type))) ? styles$268._p || (resource$269.instance = styles$268, resource$269.state.loading = 5) : (styles$268 = $dca0ddb82b882518$var$preloadPropsMap.get(type), styles$268 || (styles$268 = {
                    rel: "preload",
                    as: "style",
                    href: pendingProps.href,
                    crossOrigin: pendingProps.crossOrigin,
                    integrity: pendingProps.integrity,
                    media: pendingProps.media,
                    hrefLang: pendingProps.hrefLang,
                    referrerPolicy: pendingProps.referrerPolicy
                }, $dca0ddb82b882518$var$preloadPropsMap.set(type, styles$268)), $dca0ddb82b882518$var$preloadStylesheet(JSCompiler_inline_result, type, styles$268, resource$269.state)));
                if (currentProps && null === currentResource) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(528, ""));
                return resource$269;
            }
            if (currentProps && null !== currentResource) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(529, ""));
            return null;
        case "script":
            return currentProps = pendingProps.async, pendingProps = pendingProps.src, "string" === typeof pendingProps && currentProps && "function" !== typeof currentProps && "symbol" !== typeof currentProps ? (pendingProps = $dca0ddb82b882518$var$getScriptKey(pendingProps), currentProps = $dca0ddb82b882518$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableScripts, currentResource = currentProps.get(pendingProps), currentResource || (currentResource = {
                type: "script",
                instance: null,
                count: 0,
                state: null
            }, currentProps.set(pendingProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        default:
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(444, type));
    }
}
function $dca0ddb82b882518$var$getStyleKey(href) {
    return 'href="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"';
}
function $dca0ddb82b882518$var$getStylesheetSelectorFromKey(key) {
    return 'link[rel="stylesheet"][' + key + "]";
}
function $dca0ddb82b882518$var$stylesheetPropsFromRawProps(rawProps) {
    return $dca0ddb82b882518$var$assign({}, rawProps, {
        "data-precedence": rawProps.precedence,
        precedence: null
    });
}
function $dca0ddb82b882518$var$preloadStylesheet(ownerDocument, key, preloadProps, state) {
    if (key = ownerDocument.querySelector('link[rel="preload"][as="style"][' + key + "]")) {
        if (!0 !== key[$dca0ddb82b882518$var$internalLoadPendingKey]) {
            state.loading = 1;
            return;
        }
    } else key = ownerDocument.createElement("link"), key[$dca0ddb82b882518$var$internalLoadPendingKey] = !0, key.onload = key.onerror = $dca0ddb82b882518$var$clearPendingLoadOnNode.bind(null, key), $dca0ddb82b882518$var$setInitialProperties(key, "link", preloadProps), $dca0ddb82b882518$var$markNodeAsHoistable(key), ownerDocument.head.appendChild(key);
    state.preload = key;
    key.addEventListener("load", function() {
        return state.loading |= 1;
    });
    key.addEventListener("error", function() {
        return state.loading |= 2;
    });
}
function $dca0ddb82b882518$var$getScriptKey(src) {
    return '[src="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(src) + '"]';
}
function $dca0ddb82b882518$var$getScriptSelectorFromKey(key) {
    return "script[async]" + key;
}
function $dca0ddb82b882518$var$acquireResource(hoistableRoot, resource, props) {
    resource.count++;
    if (null === resource.instance) switch(resource.type){
        case "style":
            var instance = hoistableRoot.querySelector('style[data-href~="' + $dca0ddb82b882518$var$escapeSelectorAttributeValueInsideDoubleQuotes(props.href) + '"]');
            if (instance) return resource.instance = instance, $dca0ddb82b882518$var$markNodeAsHoistable(instance), instance;
            var styleProps = $dca0ddb82b882518$var$assign({}, props, {
                "data-href": props.href,
                "data-precedence": props.precedence,
                href: null,
                precedence: null
            });
            instance = (hoistableRoot.ownerDocument || hoistableRoot).createElement("style");
            $dca0ddb82b882518$var$markNodeAsHoistable(instance);
            $dca0ddb82b882518$var$setInitialProperties(instance, "style", styleProps);
            $dca0ddb82b882518$var$insertStylesheet(instance, props.precedence, hoistableRoot);
            return resource.instance = instance;
        case "stylesheet":
            styleProps = $dca0ddb82b882518$var$getStyleKey(props.href);
            var instance$274 = hoistableRoot.querySelector($dca0ddb82b882518$var$getStylesheetSelectorFromKey(styleProps));
            if (instance$274) return resource.state.loading |= 4, resource.instance = instance$274, $dca0ddb82b882518$var$markNodeAsHoistable(instance$274), instance$274;
            instance = $dca0ddb82b882518$var$stylesheetPropsFromRawProps(props);
            (styleProps = $dca0ddb82b882518$var$preloadPropsMap.get(styleProps)) && $dca0ddb82b882518$var$adoptPreloadPropsForStylesheet(instance, styleProps);
            instance$274 = (hoistableRoot.ownerDocument || hoistableRoot).createElement("link");
            $dca0ddb82b882518$var$markNodeAsHoistable(instance$274);
            var linkInstance = instance$274;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            $dca0ddb82b882518$var$setInitialProperties(instance$274, "link", instance);
            resource.state.loading |= 4;
            $dca0ddb82b882518$var$insertStylesheet(instance$274, props.precedence, hoistableRoot);
            return resource.instance = instance$274;
        case "script":
            instance$274 = $dca0ddb82b882518$var$getScriptKey(props.src);
            if (styleProps = hoistableRoot.querySelector($dca0ddb82b882518$var$getScriptSelectorFromKey(instance$274))) return resource.instance = styleProps, $dca0ddb82b882518$var$markNodeAsHoistable(styleProps), styleProps;
            instance = props;
            if (styleProps = $dca0ddb82b882518$var$preloadPropsMap.get(instance$274)) instance = $dca0ddb82b882518$var$assign({}, props), $dca0ddb82b882518$var$adoptPreloadPropsForScript(instance, styleProps);
            hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
            styleProps = hoistableRoot.createElement("script");
            $dca0ddb82b882518$var$markNodeAsHoistable(styleProps);
            $dca0ddb82b882518$var$setInitialProperties(styleProps, "link", instance);
            hoistableRoot.head.appendChild(styleProps);
            return resource.instance = styleProps;
        case "void":
            return null;
        default:
            throw Error($dca0ddb82b882518$var$formatProdErrorMessage(443, resource.type));
    }
    else "stylesheet" === resource.type && 0 === (resource.state.loading & 4) && (instance = resource.instance, resource.state.loading |= 4, $dca0ddb82b882518$var$insertStylesheet(instance, props.precedence, hoistableRoot));
    return resource.instance;
}
function $dca0ddb82b882518$var$insertStylesheet(instance, precedence, root) {
    for(var nodes = root.querySelectorAll('link[rel="stylesheet"][data-precedence],style[data-precedence]'), last = nodes.length ? nodes[nodes.length - 1] : null, prior = last, i = 0; i < nodes.length; i++){
        var node = nodes[i];
        if (node.dataset.precedence === precedence) prior = node;
        else if (prior !== last) break;
    }
    prior ? prior.parentNode.insertBefore(instance, prior.nextSibling) : (precedence = 9 === root.nodeType ? root.head : root, precedence.insertBefore(instance, precedence.firstChild));
}
function $dca0ddb82b882518$var$adoptPreloadPropsForStylesheet(stylesheetProps, preloadProps) {
    null == stylesheetProps.crossOrigin && (stylesheetProps.crossOrigin = preloadProps.crossOrigin);
    null == stylesheetProps.referrerPolicy && (stylesheetProps.referrerPolicy = preloadProps.referrerPolicy);
    null == stylesheetProps.title && (stylesheetProps.title = preloadProps.title);
}
function $dca0ddb82b882518$var$adoptPreloadPropsForScript(scriptProps, preloadProps) {
    null == scriptProps.crossOrigin && (scriptProps.crossOrigin = preloadProps.crossOrigin);
    null == scriptProps.referrerPolicy && (scriptProps.referrerPolicy = preloadProps.referrerPolicy);
    null == scriptProps.integrity && (scriptProps.integrity = preloadProps.integrity);
}
var $dca0ddb82b882518$var$tagCaches = null;
function $dca0ddb82b882518$var$getHydratableHoistableCache(type, keyAttribute, ownerDocument) {
    if (null === $dca0ddb82b882518$var$tagCaches) {
        var cache = new Map();
        var caches = $dca0ddb82b882518$var$tagCaches = new Map();
        caches.set(ownerDocument, cache);
    } else caches = $dca0ddb82b882518$var$tagCaches, cache = caches.get(ownerDocument), cache || (cache = new Map(), caches.set(ownerDocument, cache));
    if (cache.has(type)) return cache;
    cache.set(type, null);
    ownerDocument = ownerDocument.getElementsByTagName(type);
    for(caches = 0; caches < ownerDocument.length; caches++){
        var node = ownerDocument[caches];
        if (!(node[$dca0ddb82b882518$var$internalHoistableMarker] || node[$dca0ddb82b882518$var$internalInstanceKey] || "link" === type && "stylesheet" === node.getAttribute("rel")) && "http://www.w3.org/2000/svg" !== node.namespaceURI) {
            var nodeKey = node.getAttribute(keyAttribute) || "";
            nodeKey = type + nodeKey;
            var existing = cache.get(nodeKey);
            existing ? existing.push(node) : cache.set(nodeKey, [
                node
            ]);
        }
    }
    return cache;
}
function $dca0ddb82b882518$var$mountHoistable(hoistableRoot, type, instance) {
    hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
    hoistableRoot.head.insertBefore(instance, "title" === type ? hoistableRoot.querySelector("head > title") : null);
}
function $dca0ddb82b882518$var$isHostHoistableType(type, props, hostContext) {
    if (1 === hostContext || null != props.itemProp) return !1;
    switch(type){
        case "meta":
        case "title":
            return !0;
        case "style":
            if ("string" !== typeof props.precedence || "string" !== typeof props.href || "" === props.href) break;
            return !0;
        case "link":
            if ("string" !== typeof props.rel || "string" !== typeof props.href || "" === props.href || props.onLoad || props.onError) break;
            switch(props.rel){
                case "stylesheet":
                    return type = props.disabled, "string" === typeof props.precedence && null == type;
                default:
                    return !0;
            }
        case "script":
            if (props.async && "function" !== typeof props.async && "symbol" !== typeof props.async && !props.onLoad && !props.onError && props.src && "string" === typeof props.src) return !0;
    }
    return !1;
}
function $dca0ddb82b882518$var$maySuspendCommit(type, props) {
    return "img" === type && null != props.src && "" !== props.src && null == props.onLoad && "lazy" !== props.loading;
}
function $dca0ddb82b882518$var$preloadResource(resource) {
    return "stylesheet" === resource.type && 0 === (resource.state.loading & 3) ? !1 : !0;
}
function $dca0ddb82b882518$var$estimateImageBytes(instance) {
    return (instance.width || 100) * (instance.height || 100) * ("number" === typeof devicePixelRatio ? devicePixelRatio : 1) * 0.25;
}
function $dca0ddb82b882518$var$suspendInstance(state, instance) {
    "function" === typeof instance.decode && (state.imgCount++, instance.complete || (state.imgBytes += $dca0ddb82b882518$var$estimateImageBytes(instance), state.suspenseyImages.push(instance)), state = $dca0ddb82b882518$var$onUnsuspendImg.bind(state), instance.decode().then(state, state));
}
function $dca0ddb82b882518$var$suspendResource(state, hoistableRoot, resource, props) {
    if ("stylesheet" === resource.type && ("string" !== typeof props.media || !1 !== matchMedia(props.media).matches) && 0 === (resource.state.loading & 4)) {
        if (null === resource.instance) {
            var key = $dca0ddb82b882518$var$getStyleKey(props.href), instance = hoistableRoot.querySelector($dca0ddb82b882518$var$getStylesheetSelectorFromKey(key));
            if (instance) {
                hoistableRoot = instance._p;
                null !== hoistableRoot && "object" === typeof hoistableRoot && "function" === typeof hoistableRoot.then && (state.count++, state = $dca0ddb82b882518$var$onUnsuspend.bind(state), hoistableRoot.then(state, state));
                resource.state.loading |= 4;
                resource.instance = instance;
                $dca0ddb82b882518$var$markNodeAsHoistable(instance);
                return;
            }
            instance = hoistableRoot.ownerDocument || hoistableRoot;
            props = $dca0ddb82b882518$var$stylesheetPropsFromRawProps(props);
            (key = $dca0ddb82b882518$var$preloadPropsMap.get(key)) && $dca0ddb82b882518$var$adoptPreloadPropsForStylesheet(props, key);
            instance = instance.createElement("link");
            $dca0ddb82b882518$var$markNodeAsHoistable(instance);
            var linkInstance = instance;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            $dca0ddb82b882518$var$setInitialProperties(instance, "link", props);
            resource.instance = instance;
        }
        null === state.stylesheets && (state.stylesheets = new Map());
        state.stylesheets.set(resource, hoistableRoot);
        (hoistableRoot = resource.state.preload) && 0 === (resource.state.loading & 3) && (state.count++, resource = $dca0ddb82b882518$var$onUnsuspend.bind(state), hoistableRoot.addEventListener("load", resource), hoistableRoot.addEventListener("error", resource));
    }
}
var $dca0ddb82b882518$var$estimatedBytesWithinLimit = 0;
function $dca0ddb82b882518$var$waitForCommitToBeReady(state, timeoutOffset) {
    state.stylesheets && 0 === state.count && $dca0ddb82b882518$var$insertSuspendedStylesheets(state, state.stylesheets);
    return 0 < state.count || 0 < state.imgCount ? function(commit) {
        var stylesheetTimer = setTimeout(function() {
            state.stylesheets && $dca0ddb82b882518$var$insertSuspendedStylesheets(state, state.stylesheets);
            if (state.unsuspend) {
                var unsuspend = state.unsuspend;
                state.unsuspend = null;
                unsuspend();
            }
        }, 6e4 + timeoutOffset);
        0 < state.imgBytes && 0 === $dca0ddb82b882518$var$estimatedBytesWithinLimit && ($dca0ddb82b882518$var$estimatedBytesWithinLimit = 62500 * $dca0ddb82b882518$var$estimateBandwidth());
        var imgTimer = setTimeout(function() {
            state.waitingForImages = !1;
            if (0 === state.count && (state.stylesheets && $dca0ddb82b882518$var$insertSuspendedStylesheets(state, state.stylesheets), state.unsuspend)) {
                var unsuspend = state.unsuspend;
                state.unsuspend = null;
                unsuspend();
            }
        }, (state.imgBytes > $dca0ddb82b882518$var$estimatedBytesWithinLimit ? 50 : 800) + timeoutOffset);
        state.unsuspend = commit;
        return function() {
            state.unsuspend = null;
            clearTimeout(stylesheetTimer);
            clearTimeout(imgTimer);
        };
    } : null;
}
function $dca0ddb82b882518$var$checkIfFullyUnsuspended(state) {
    if (0 === state.count && (0 === state.imgCount || !state.waitingForImages)) {
        if (state.stylesheets) $dca0ddb82b882518$var$insertSuspendedStylesheets(state, state.stylesheets);
        else if (state.unsuspend) {
            var unsuspend = state.unsuspend;
            state.unsuspend = null;
            unsuspend();
        }
    }
}
function $dca0ddb82b882518$var$onUnsuspend() {
    this.count--;
    $dca0ddb82b882518$var$checkIfFullyUnsuspended(this);
}
function $dca0ddb82b882518$var$onUnsuspendImg() {
    this.imgCount--;
    $dca0ddb82b882518$var$checkIfFullyUnsuspended(this);
}
var $dca0ddb82b882518$var$precedencesByRoot = null;
function $dca0ddb82b882518$var$insertSuspendedStylesheets(state, resources) {
    state.stylesheets = null;
    null !== state.unsuspend && (state.count++, $dca0ddb82b882518$var$precedencesByRoot = new Map(), resources.forEach($dca0ddb82b882518$var$insertStylesheetIntoRoot, state), $dca0ddb82b882518$var$precedencesByRoot = null, $dca0ddb82b882518$var$onUnsuspend.call(state));
}
function $dca0ddb82b882518$var$insertStylesheetIntoRoot(root, resource) {
    if (!(resource.state.loading & 4)) {
        var precedences = $dca0ddb82b882518$var$precedencesByRoot.get(root);
        if (precedences) var last = precedences.get(null);
        else {
            precedences = new Map();
            $dca0ddb82b882518$var$precedencesByRoot.set(root, precedences);
            for(var nodes = root.querySelectorAll("link[data-precedence],style[data-precedence]"), i = 0; i < nodes.length; i++){
                var node = nodes[i];
                if ("LINK" === node.nodeName || "not all" !== node.getAttribute("media")) precedences.set(node.dataset.precedence, node), last = node;
            }
            last && precedences.set(null, last);
        }
        nodes = resource.instance;
        node = nodes.getAttribute("data-precedence");
        i = precedences.get(node) || last;
        i === last && precedences.set(null, nodes);
        precedences.set(node, nodes);
        this.count++;
        last = $dca0ddb82b882518$var$onUnsuspend.bind(this);
        nodes.addEventListener("load", last);
        nodes.addEventListener("error", last);
        i ? i.parentNode.insertBefore(nodes, i.nextSibling) : (root = 9 === root.nodeType ? root.head : root, root.insertBefore(nodes, root.firstChild));
        resource.state.loading |= 4;
    }
}
var $dca0ddb82b882518$var$HostTransitionContext = {
    $$typeof: $dca0ddb82b882518$var$REACT_CONTEXT_TYPE,
    Provider: null,
    Consumer: null,
    _currentValue: $dca0ddb82b882518$var$sharedNotPendingObject,
    _currentValue2: $dca0ddb82b882518$var$sharedNotPendingObject,
    _threadCount: 0
};
function $dca0ddb82b882518$var$FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator, formState) {
    this.tag = 1;
    this.containerInfo = containerInfo;
    this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.next = this.pendingContext = this.context = this.cancelPendingCommit = null;
    this.callbackPriority = 0;
    this.expirationTimes = $dca0ddb82b882518$var$createLaneMap(-1);
    this.entangledLanes = this.shellSuspendCounter = this.errorRecoveryDisabledLanes = this.expiredLanes = this.warmLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $dca0ddb82b882518$var$createLaneMap(0);
    this.hiddenUpdates = $dca0ddb82b882518$var$createLaneMap(null);
    this.identifierPrefix = identifierPrefix;
    this.onUncaughtError = onUncaughtError;
    this.onCaughtError = onCaughtError;
    this.onRecoverableError = onRecoverableError;
    this.pooledCache = null;
    this.pooledCacheLanes = 0;
    this.formState = formState;
    this.transitionTypes = null;
    this.incompleteTransitions = new Map();
}
function $dca0ddb82b882518$var$createFiberRoot(containerInfo, tag, hydrate, initialChildren, hydrationCallbacks, isStrictMode, identifierPrefix, formState, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator) {
    containerInfo = new $dca0ddb82b882518$var$FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator, formState);
    tag = 1;
    !0 === isStrictMode && (tag |= 24);
    isStrictMode = $dca0ddb82b882518$var$createFiberImplClass(3, null, null, tag);
    containerInfo.current = isStrictMode;
    isStrictMode.stateNode = containerInfo;
    tag = $dca0ddb82b882518$var$createCache();
    tag.refCount++;
    containerInfo.pooledCache = tag;
    tag.refCount++;
    isStrictMode.memoizedState = {
        element: initialChildren,
        isDehydrated: hydrate,
        cache: tag
    };
    $dca0ddb82b882518$var$initializeUpdateQueue(isStrictMode);
    return containerInfo;
}
function $dca0ddb82b882518$var$getContextForSubtree(parentComponent) {
    if (!parentComponent) return $dca0ddb82b882518$var$emptyContextObject;
    parentComponent = $dca0ddb82b882518$var$emptyContextObject;
    return parentComponent;
}
function $dca0ddb82b882518$var$updateContainerImpl(rootFiber, lane, element, container, parentComponent, callback) {
    parentComponent = $dca0ddb82b882518$var$getContextForSubtree(parentComponent);
    null === container.context ? container.context = parentComponent : container.pendingContext = parentComponent;
    container = $dca0ddb82b882518$var$createUpdate(lane);
    container.payload = {
        element: element
    };
    callback = void 0 === callback ? null : callback;
    null !== callback && (container.callback = callback);
    element = $dca0ddb82b882518$var$enqueueUpdate(rootFiber, container, lane);
    null !== element && ($dca0ddb82b882518$var$scheduleUpdateOnFiber(element, rootFiber, lane), $dca0ddb82b882518$var$entangleTransitions(element, rootFiber, lane));
}
function $dca0ddb82b882518$var$markRetryLaneImpl(fiber, retryLane) {
    fiber = fiber.memoizedState;
    if (null !== fiber && null !== fiber.dehydrated) {
        var a = fiber.retryLane;
        fiber.retryLane = 0 !== a && a < retryLane ? a : retryLane;
    }
}
function $dca0ddb82b882518$var$markRetryLaneIfNotHydrated(fiber, retryLane) {
    $dca0ddb82b882518$var$markRetryLaneImpl(fiber, retryLane);
    (fiber = fiber.alternate) && $dca0ddb82b882518$var$markRetryLaneImpl(fiber, retryLane);
}
function $dca0ddb82b882518$var$attemptContinuousHydration(fiber) {
    if (13 === fiber.tag || 31 === fiber.tag) {
        var root = $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(fiber, 67108864);
        null !== root && $dca0ddb82b882518$var$scheduleUpdateOnFiber(root, fiber, 67108864);
        $dca0ddb82b882518$var$markRetryLaneIfNotHydrated(fiber, 67108864);
    }
}
function $dca0ddb82b882518$var$attemptHydrationAtCurrentPriority(fiber) {
    if (13 === fiber.tag || 31 === fiber.tag) {
        var lane = $dca0ddb82b882518$var$requestUpdateLane();
        lane = $dca0ddb82b882518$var$getBumpedLaneForHydrationByLane(lane);
        var root = $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(fiber, lane);
        null !== root && $dca0ddb82b882518$var$scheduleUpdateOnFiber(root, fiber, lane);
        $dca0ddb82b882518$var$markRetryLaneIfNotHydrated(fiber, lane);
    }
}
var $dca0ddb82b882518$var$_enabled = !0;
function $dca0ddb82b882518$var$dispatchDiscreteEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = $dca0ddb82b882518$var$ReactSharedInternals.T;
    $dca0ddb82b882518$var$ReactSharedInternals.T = null;
    var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    try {
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 2, $dca0ddb82b882518$var$dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, $dca0ddb82b882518$var$ReactSharedInternals.T = prevTransition;
    }
}
function $dca0ddb82b882518$var$dispatchContinuousEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = $dca0ddb82b882518$var$ReactSharedInternals.T;
    $dca0ddb82b882518$var$ReactSharedInternals.T = null;
    var previousPriority = $dca0ddb82b882518$var$ReactDOMSharedInternals.p;
    try {
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = 8, $dca0ddb82b882518$var$dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        $dca0ddb82b882518$var$ReactDOMSharedInternals.p = previousPriority, $dca0ddb82b882518$var$ReactSharedInternals.T = prevTransition;
    }
}
function $dca0ddb82b882518$var$dispatchEvent(domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if ($dca0ddb82b882518$var$_enabled) {
        var blockedOn = $dca0ddb82b882518$var$findInstanceBlockingEvent(nativeEvent);
        if (null === blockedOn) $dca0ddb82b882518$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, $dca0ddb82b882518$var$return_targetInst, targetContainer), $dca0ddb82b882518$var$clearIfContinuousEvent(domEventName, nativeEvent);
        else if ($dca0ddb82b882518$var$queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)) nativeEvent.stopPropagation();
        else if ($dca0ddb82b882518$var$clearIfContinuousEvent(domEventName, nativeEvent), eventSystemFlags & 4 && -1 < $dca0ddb82b882518$var$discreteReplayableEvents.indexOf(domEventName)) {
            for(; null !== blockedOn;){
                var fiber = $dca0ddb82b882518$var$getInstanceFromNode(blockedOn);
                if (null !== fiber) switch(fiber.tag){
                    case 3:
                        fiber = fiber.stateNode;
                        if (fiber.current.memoizedState.isDehydrated) {
                            var lanes = $dca0ddb82b882518$var$getHighestPriorityLanes(fiber.pendingLanes);
                            if (0 !== lanes) {
                                var root = fiber;
                                root.pendingLanes |= 2;
                                for(root.entangledLanes |= 2; lanes;){
                                    var lane = 1 << 31 - $dca0ddb82b882518$var$clz32(lanes);
                                    root.entanglements[1] |= lane;
                                    lanes &= ~lane;
                                }
                                $dca0ddb82b882518$var$ensureRootIsScheduled(fiber);
                                0 === ($dca0ddb82b882518$var$executionContext & 6) && ($dca0ddb82b882518$var$workInProgressRootRenderTargetTime = $dca0ddb82b882518$var$now() + 500, $dca0ddb82b882518$var$flushSyncWorkAcrossRoots_impl(0, !1));
                            }
                        }
                        break;
                    case 31:
                    case 13:
                        root = $dca0ddb82b882518$var$enqueueConcurrentRenderForLane(fiber, 2), null !== root && $dca0ddb82b882518$var$scheduleUpdateOnFiber(root, fiber, 2), $dca0ddb82b882518$var$flushSyncWork$1(), $dca0ddb82b882518$var$markRetryLaneIfNotHydrated(fiber, 2);
                }
                fiber = $dca0ddb82b882518$var$findInstanceBlockingEvent(nativeEvent);
                null === fiber && $dca0ddb82b882518$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, $dca0ddb82b882518$var$return_targetInst, targetContainer);
                if (fiber === blockedOn) break;
                blockedOn = fiber;
            }
            null !== blockedOn && nativeEvent.stopPropagation();
        } else $dca0ddb82b882518$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, null, targetContainer);
    }
}
function $dca0ddb82b882518$var$findInstanceBlockingEvent(nativeEvent) {
    nativeEvent = $dca0ddb82b882518$var$getEventTarget(nativeEvent);
    return $dca0ddb82b882518$var$findInstanceBlockingTarget(nativeEvent);
}
var $dca0ddb82b882518$var$return_targetInst = null;
function $dca0ddb82b882518$var$findInstanceBlockingTarget(targetNode) {
    $dca0ddb82b882518$var$return_targetInst = null;
    targetNode = $dca0ddb82b882518$var$getClosestInstanceFromNode(targetNode);
    if (null !== targetNode) {
        var nearestMounted = $dca0ddb82b882518$var$getNearestMountedFiber(targetNode);
        if (null === nearestMounted) targetNode = null;
        else {
            var tag = nearestMounted.tag;
            if (13 === tag) {
                targetNode = $dca0ddb82b882518$var$getSuspenseInstanceFromFiber(nearestMounted);
                if (null !== targetNode) return targetNode;
                targetNode = null;
            } else if (31 === tag) {
                targetNode = $dca0ddb82b882518$var$getActivityInstanceFromFiber(nearestMounted);
                if (null !== targetNode) return targetNode;
                targetNode = null;
            } else if (3 === tag) {
                if (nearestMounted.stateNode.current.memoizedState.isDehydrated) return 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                targetNode = null;
            } else nearestMounted !== targetNode && (targetNode = null);
        }
    }
    $dca0ddb82b882518$var$return_targetInst = targetNode;
    return null;
}
function $dca0ddb82b882518$var$getEventPriority(domEventName) {
    switch(domEventName){
        case "beforetoggle":
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "seeked":
        case "submit":
        case "toggle":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "fullscreenerror":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 2;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "resize":
        case "scroll":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 8;
        case "message":
            switch($dca0ddb82b882518$var$getCurrentPriorityLevel()){
                case $dca0ddb82b882518$var$ImmediatePriority:
                    return 2;
                case $dca0ddb82b882518$var$UserBlockingPriority:
                    return 8;
                case $dca0ddb82b882518$var$NormalPriority$1:
                case $dca0ddb82b882518$var$LowPriority:
                    return 32;
                case $dca0ddb82b882518$var$IdlePriority:
                    return 268435456;
                default:
                    return 32;
            }
        default:
            return 32;
    }
}
var $dca0ddb82b882518$var$hasScheduledReplayAttempt = !1, $dca0ddb82b882518$var$queuedFocus = null, $dca0ddb82b882518$var$queuedDrag = null, $dca0ddb82b882518$var$queuedMouse = null, $dca0ddb82b882518$var$queuedPointers = new Map(), $dca0ddb82b882518$var$queuedPointerCaptures = new Map(), $dca0ddb82b882518$var$queuedExplicitHydrationTargets = [], $dca0ddb82b882518$var$discreteReplayableEvents = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset".split(" ");
function $dca0ddb82b882518$var$clearIfContinuousEvent(domEventName, nativeEvent) {
    switch(domEventName){
        case "focusin":
        case "focusout":
            $dca0ddb82b882518$var$queuedFocus = null;
            break;
        case "dragenter":
        case "dragleave":
            $dca0ddb82b882518$var$queuedDrag = null;
            break;
        case "mouseover":
        case "mouseout":
            $dca0ddb82b882518$var$queuedMouse = null;
            break;
        case "pointerover":
        case "pointerout":
            $dca0ddb82b882518$var$queuedPointers.delete(nativeEvent.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $dca0ddb82b882518$var$queuedPointerCaptures.delete(nativeEvent.pointerId);
    }
}
function $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent(existingQueuedEvent, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if (null === existingQueuedEvent || existingQueuedEvent.nativeEvent !== nativeEvent) return existingQueuedEvent = {
        blockedOn: blockedOn,
        domEventName: domEventName,
        eventSystemFlags: eventSystemFlags,
        nativeEvent: nativeEvent,
        targetContainers: [
            targetContainer
        ]
    }, null !== blockedOn && (blockedOn = $dca0ddb82b882518$var$getInstanceFromNode(blockedOn), null !== blockedOn && $dca0ddb82b882518$var$attemptContinuousHydration(blockedOn)), existingQueuedEvent;
    existingQueuedEvent.eventSystemFlags |= eventSystemFlags;
    blockedOn = existingQueuedEvent.targetContainers;
    null !== targetContainer && -1 === blockedOn.indexOf(targetContainer) && blockedOn.push(targetContainer);
    return existingQueuedEvent;
}
function $dca0ddb82b882518$var$queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    switch(domEventName){
        case "focusin":
            return $dca0ddb82b882518$var$queuedFocus = $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent($dca0ddb82b882518$var$queuedFocus, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "dragenter":
            return $dca0ddb82b882518$var$queuedDrag = $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent($dca0ddb82b882518$var$queuedDrag, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "mouseover":
            return $dca0ddb82b882518$var$queuedMouse = $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent($dca0ddb82b882518$var$queuedMouse, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "pointerover":
            var pointerId = nativeEvent.pointerId;
            $dca0ddb82b882518$var$queuedPointers.set(pointerId, $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent($dca0ddb82b882518$var$queuedPointers.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent));
            return !0;
        case "gotpointercapture":
            return pointerId = nativeEvent.pointerId, $dca0ddb82b882518$var$queuedPointerCaptures.set(pointerId, $dca0ddb82b882518$var$accumulateOrCreateContinuousQueuedReplayableEvent($dca0ddb82b882518$var$queuedPointerCaptures.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)), !0;
    }
    return !1;
}
function $dca0ddb82b882518$var$attemptExplicitHydrationTarget(queuedTarget) {
    var targetInst = $dca0ddb82b882518$var$getClosestInstanceFromNode(queuedTarget.target);
    if (null !== targetInst) {
        var nearestMounted = $dca0ddb82b882518$var$getNearestMountedFiber(targetInst);
        if (null !== nearestMounted) {
            if (targetInst = nearestMounted.tag, 13 === targetInst) {
                if (targetInst = $dca0ddb82b882518$var$getSuspenseInstanceFromFiber(nearestMounted), null !== targetInst) {
                    queuedTarget.blockedOn = targetInst;
                    $dca0ddb82b882518$var$runWithPriority(queuedTarget.priority, function() {
                        $dca0ddb82b882518$var$attemptHydrationAtCurrentPriority(nearestMounted);
                    });
                    return;
                }
            } else if (31 === targetInst) {
                if (targetInst = $dca0ddb82b882518$var$getActivityInstanceFromFiber(nearestMounted), null !== targetInst) {
                    queuedTarget.blockedOn = targetInst;
                    $dca0ddb82b882518$var$runWithPriority(queuedTarget.priority, function() {
                        $dca0ddb82b882518$var$attemptHydrationAtCurrentPriority(nearestMounted);
                    });
                    return;
                }
            } else if (3 === targetInst && nearestMounted.stateNode.current.memoizedState.isDehydrated) {
                queuedTarget.blockedOn = 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                return;
            }
        }
    }
    queuedTarget.blockedOn = null;
}
function $dca0ddb82b882518$var$attemptReplayContinuousQueuedEvent(queuedEvent) {
    if (null !== queuedEvent.blockedOn) return !1;
    for(var targetContainers = queuedEvent.targetContainers; 0 < targetContainers.length;){
        var nextBlockedOn = $dca0ddb82b882518$var$findInstanceBlockingEvent(queuedEvent.nativeEvent);
        if (null === nextBlockedOn) {
            nextBlockedOn = queuedEvent.nativeEvent;
            var nativeEventClone = new nextBlockedOn.constructor(nextBlockedOn.type, nextBlockedOn);
            $dca0ddb82b882518$var$currentReplayingEvent = nativeEventClone;
            nextBlockedOn.target.dispatchEvent(nativeEventClone);
            $dca0ddb82b882518$var$currentReplayingEvent = null;
        } else return targetContainers = $dca0ddb82b882518$var$getInstanceFromNode(nextBlockedOn), null !== targetContainers && $dca0ddb82b882518$var$attemptContinuousHydration(targetContainers), queuedEvent.blockedOn = nextBlockedOn, !1;
        targetContainers.shift();
    }
    return !0;
}
function $dca0ddb82b882518$var$attemptReplayContinuousQueuedEventInMap(queuedEvent, key, map) {
    $dca0ddb82b882518$var$attemptReplayContinuousQueuedEvent(queuedEvent) && map.delete(key);
}
function $dca0ddb82b882518$var$replayUnblockedEvents() {
    $dca0ddb82b882518$var$hasScheduledReplayAttempt = !1;
    null !== $dca0ddb82b882518$var$queuedFocus && $dca0ddb82b882518$var$attemptReplayContinuousQueuedEvent($dca0ddb82b882518$var$queuedFocus) && ($dca0ddb82b882518$var$queuedFocus = null);
    null !== $dca0ddb82b882518$var$queuedDrag && $dca0ddb82b882518$var$attemptReplayContinuousQueuedEvent($dca0ddb82b882518$var$queuedDrag) && ($dca0ddb82b882518$var$queuedDrag = null);
    null !== $dca0ddb82b882518$var$queuedMouse && $dca0ddb82b882518$var$attemptReplayContinuousQueuedEvent($dca0ddb82b882518$var$queuedMouse) && ($dca0ddb82b882518$var$queuedMouse = null);
    $dca0ddb82b882518$var$queuedPointers.forEach($dca0ddb82b882518$var$attemptReplayContinuousQueuedEventInMap);
    $dca0ddb82b882518$var$queuedPointerCaptures.forEach($dca0ddb82b882518$var$attemptReplayContinuousQueuedEventInMap);
}
function $dca0ddb82b882518$var$scheduleCallbackIfUnblocked(queuedEvent, unblocked) {
    queuedEvent.blockedOn === unblocked && (queuedEvent.blockedOn = null, $dca0ddb82b882518$var$hasScheduledReplayAttempt || ($dca0ddb82b882518$var$hasScheduledReplayAttempt = !0, $fO90s.unstable_scheduleCallback($fO90s.unstable_NormalPriority, $dca0ddb82b882518$var$replayUnblockedEvents)));
}
var $dca0ddb82b882518$var$lastScheduledReplayQueue = null;
function $dca0ddb82b882518$var$scheduleReplayQueueIfNeeded(formReplayingQueue) {
    $dca0ddb82b882518$var$lastScheduledReplayQueue !== formReplayingQueue && ($dca0ddb82b882518$var$lastScheduledReplayQueue = formReplayingQueue, $fO90s.unstable_scheduleCallback($fO90s.unstable_NormalPriority, function() {
        $dca0ddb82b882518$var$lastScheduledReplayQueue === formReplayingQueue && ($dca0ddb82b882518$var$lastScheduledReplayQueue = null);
        for(var i = 0; i < formReplayingQueue.length; i += 3){
            var form = formReplayingQueue[i], submitterOrAction = formReplayingQueue[i + 1], formData = formReplayingQueue[i + 2];
            if ("function" !== typeof submitterOrAction) {
                if (null === $dca0ddb82b882518$var$findInstanceBlockingTarget(submitterOrAction || form)) continue;
                else break;
            }
            var formInst = $dca0ddb82b882518$var$getInstanceFromNode(form);
            null !== formInst && (formReplayingQueue.splice(i, 3), i -= 3, $dca0ddb82b882518$var$startHostTransition(formInst, {
                pending: !0,
                data: formData,
                method: form.method,
                action: submitterOrAction
            }, submitterOrAction, formData));
        }
    }));
}
function $dca0ddb82b882518$var$retryIfBlockedOn(unblocked) {
    function unblock(queuedEvent) {
        return $dca0ddb82b882518$var$scheduleCallbackIfUnblocked(queuedEvent, unblocked);
    }
    null !== $dca0ddb82b882518$var$queuedFocus && $dca0ddb82b882518$var$scheduleCallbackIfUnblocked($dca0ddb82b882518$var$queuedFocus, unblocked);
    null !== $dca0ddb82b882518$var$queuedDrag && $dca0ddb82b882518$var$scheduleCallbackIfUnblocked($dca0ddb82b882518$var$queuedDrag, unblocked);
    null !== $dca0ddb82b882518$var$queuedMouse && $dca0ddb82b882518$var$scheduleCallbackIfUnblocked($dca0ddb82b882518$var$queuedMouse, unblocked);
    $dca0ddb82b882518$var$queuedPointers.forEach(unblock);
    $dca0ddb82b882518$var$queuedPointerCaptures.forEach(unblock);
    for(var i = 0; i < $dca0ddb82b882518$var$queuedExplicitHydrationTargets.length; i++){
        var queuedTarget = $dca0ddb82b882518$var$queuedExplicitHydrationTargets[i];
        queuedTarget.blockedOn === unblocked && (queuedTarget.blockedOn = null);
    }
    for(; 0 < $dca0ddb82b882518$var$queuedExplicitHydrationTargets.length && (i = $dca0ddb82b882518$var$queuedExplicitHydrationTargets[0], null === i.blockedOn);)$dca0ddb82b882518$var$attemptExplicitHydrationTarget(i), null === i.blockedOn && $dca0ddb82b882518$var$queuedExplicitHydrationTargets.shift();
    i = (unblocked.ownerDocument || unblocked).$$reactFormReplay;
    if (null != i) for(queuedTarget = 0; queuedTarget < i.length; queuedTarget += 3){
        var form = i[queuedTarget], submitterOrAction = i[queuedTarget + 1], formProps = form[$dca0ddb82b882518$var$internalPropsKey] || null;
        if ("function" === typeof submitterOrAction) formProps || $dca0ddb82b882518$var$scheduleReplayQueueIfNeeded(i);
        else if (formProps) {
            var action = null;
            if (submitterOrAction && submitterOrAction.hasAttribute("formAction")) {
                if (form = submitterOrAction, formProps = submitterOrAction[$dca0ddb82b882518$var$internalPropsKey] || null) action = formProps.formAction;
                else {
                    if (null !== $dca0ddb82b882518$var$findInstanceBlockingTarget(form)) continue;
                }
            } else action = formProps.action;
            "function" === typeof action ? i[queuedTarget + 1] = action : (i.splice(queuedTarget, 3), queuedTarget -= 3);
            $dca0ddb82b882518$var$scheduleReplayQueueIfNeeded(i);
        }
    }
}
function $dca0ddb82b882518$var$defaultOnDefaultTransitionIndicator() {
    function handleNavigate(event) {
        event.canIntercept && "react-transition" === event.info && event.intercept({
            handler: function() {
                return new Promise(function(resolve) {
                    return pendingResolve = resolve;
                });
            },
            focusReset: "manual",
            scroll: "manual"
        });
    }
    function handleNavigateComplete() {
        null !== pendingResolve && (pendingResolve(), pendingResolve = null);
        isCancelled || setTimeout(startFakeNavigation, 20);
    }
    function startFakeNavigation() {
        if (!isCancelled && !navigation.transition) {
            var currentEntry = navigation.currentEntry;
            currentEntry && null != currentEntry.url && navigation.navigate(currentEntry.url, {
                state: currentEntry.getState(),
                info: "react-transition",
                history: "replace"
            });
        }
    }
    if ("object" === typeof navigation) {
        var isCancelled = !1, pendingResolve = null;
        navigation.addEventListener("navigate", handleNavigate);
        navigation.addEventListener("navigatesuccess", handleNavigateComplete);
        navigation.addEventListener("navigateerror", handleNavigateComplete);
        setTimeout(startFakeNavigation, 100);
        return function() {
            isCancelled = !0;
            navigation.removeEventListener("navigate", handleNavigate);
            navigation.removeEventListener("navigatesuccess", handleNavigateComplete);
            navigation.removeEventListener("navigateerror", handleNavigateComplete);
            null !== pendingResolve && (pendingResolve(), pendingResolve = null);
        };
    }
}
function $dca0ddb82b882518$var$ReactDOMRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
$dca0ddb82b882518$var$ReactDOMHydrationRoot.prototype.render = $dca0ddb82b882518$var$ReactDOMRoot.prototype.render = function(children) {
    var root = this._internalRoot;
    if (null === root) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(409));
    var current = root.current, lane = $dca0ddb82b882518$var$requestUpdateLane();
    $dca0ddb82b882518$var$updateContainerImpl(current, lane, children, root, null, null);
};
$dca0ddb82b882518$var$ReactDOMHydrationRoot.prototype.unmount = $dca0ddb82b882518$var$ReactDOMRoot.prototype.unmount = function() {
    var root = this._internalRoot;
    if (null !== root) {
        this._internalRoot = null;
        var container = root.containerInfo;
        $dca0ddb82b882518$var$updateContainerImpl(root.current, 2, null, root, null, null);
        $dca0ddb82b882518$var$flushSyncWork$1();
        container[$dca0ddb82b882518$var$internalContainerInstanceKey] = null;
    }
};
function $dca0ddb82b882518$var$ReactDOMHydrationRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
$dca0ddb82b882518$var$ReactDOMHydrationRoot.prototype.unstable_scheduleHydration = function(target) {
    if (target) {
        var updatePriority = $dca0ddb82b882518$var$resolveUpdatePriority();
        target = {
            blockedOn: null,
            target: target,
            priority: updatePriority
        };
        for(var i = 0; i < $dca0ddb82b882518$var$queuedExplicitHydrationTargets.length && 0 !== updatePriority && updatePriority < $dca0ddb82b882518$var$queuedExplicitHydrationTargets[i].priority; i++);
        $dca0ddb82b882518$var$queuedExplicitHydrationTargets.splice(i, 0, target);
        0 === i && $dca0ddb82b882518$var$attemptExplicitHydrationTarget(target);
    }
};
var $dca0ddb82b882518$var$isomorphicReactPackageVersion$jscomp$inline_2043 = $acw62.version;
if ("19.3.1" !== $dca0ddb82b882518$var$isomorphicReactPackageVersion$jscomp$inline_2043) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(527, $dca0ddb82b882518$var$isomorphicReactPackageVersion$jscomp$inline_2043, "19.3.1"));
$dca0ddb82b882518$var$ReactDOMSharedInternals.findDOMNode = function(componentOrElement) {
    var fiber = componentOrElement._reactInternals;
    if (void 0 === fiber) {
        if ("function" === typeof componentOrElement.render) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(188));
        componentOrElement = Object.keys(componentOrElement).join(",");
        throw Error($dca0ddb82b882518$var$formatProdErrorMessage(268, componentOrElement));
    }
    componentOrElement = $dca0ddb82b882518$var$findCurrentFiberUsingSlowPath(fiber);
    componentOrElement = null !== componentOrElement ? $dca0ddb82b882518$var$findCurrentHostFiberImpl(componentOrElement) : null;
    componentOrElement = null === componentOrElement ? null : componentOrElement.stateNode;
    return componentOrElement;
};
var $dca0ddb82b882518$var$internals$jscomp$inline_2586 = {
    bundleType: 0,
    version: "19.3.1",
    rendererPackageName: "react-dom",
    currentDispatcherRef: $dca0ddb82b882518$var$ReactSharedInternals,
    reconcilerVersion: "19.3.1"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $dca0ddb82b882518$var$hook$jscomp$inline_2587 = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$dca0ddb82b882518$var$hook$jscomp$inline_2587.isDisabled && $dca0ddb82b882518$var$hook$jscomp$inline_2587.supportsFiber) try {
        $dca0ddb82b882518$var$rendererID = $dca0ddb82b882518$var$hook$jscomp$inline_2587.inject($dca0ddb82b882518$var$internals$jscomp$inline_2586), $dca0ddb82b882518$var$injectedHook = $dca0ddb82b882518$var$hook$jscomp$inline_2587;
    } catch (err) {}
}
$dca0ddb82b882518$export$882461b6382ed46c = function(container, options) {
    if (!$dca0ddb82b882518$var$isValidContainer(container)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = $dca0ddb82b882518$var$defaultOnUncaughtError, onCaughtError = $dca0ddb82b882518$var$defaultOnCaughtError, onRecoverableError = $dca0ddb82b882518$var$defaultOnRecoverableError;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError));
    options = $dca0ddb82b882518$var$createFiberRoot(container, 1, !1, null, null, isStrictMode, identifierPrefix, null, onUncaughtError, onCaughtError, onRecoverableError, $dca0ddb82b882518$var$defaultOnDefaultTransitionIndicator);
    container[$dca0ddb82b882518$var$internalContainerInstanceKey] = options.current;
    $dca0ddb82b882518$var$listenToAllSupportedEvents(container);
    return new $dca0ddb82b882518$var$ReactDOMRoot(options);
};
$dca0ddb82b882518$export$757ceba2d55c277e = function(container, initialChildren, options) {
    if (!$dca0ddb82b882518$var$isValidContainer(container)) throw Error($dca0ddb82b882518$var$formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = $dca0ddb82b882518$var$defaultOnUncaughtError, onCaughtError = $dca0ddb82b882518$var$defaultOnCaughtError, onRecoverableError = $dca0ddb82b882518$var$defaultOnRecoverableError, formState = null;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError), void 0 !== options.formState && (formState = options.formState));
    initialChildren = $dca0ddb82b882518$var$createFiberRoot(container, 1, !0, initialChildren, null != options ? options : null, isStrictMode, identifierPrefix, formState, onUncaughtError, onCaughtError, onRecoverableError, $dca0ddb82b882518$var$defaultOnDefaultTransitionIndicator);
    initialChildren.context = $dca0ddb82b882518$var$getContextForSubtree(null);
    options = initialChildren.current;
    isStrictMode = $dca0ddb82b882518$var$requestUpdateLane();
    isStrictMode = $dca0ddb82b882518$var$getBumpedLaneForHydrationByLane(isStrictMode);
    identifierPrefix = $dca0ddb82b882518$var$createUpdate(isStrictMode);
    identifierPrefix.callback = null;
    $dca0ddb82b882518$var$enqueueUpdate(options, identifierPrefix, isStrictMode);
    options = isStrictMode;
    initialChildren.current.lanes = options;
    $dca0ddb82b882518$var$markRootUpdated$1(initialChildren, options);
    $dca0ddb82b882518$var$ensureRootIsScheduled(initialChildren);
    container[$dca0ddb82b882518$var$internalContainerInstanceKey] = initialChildren.current;
    $dca0ddb82b882518$var$listenToAllSupportedEvents(container);
    return new $dca0ddb82b882518$var$ReactDOMHydrationRoot(initialChildren);
};
$dca0ddb82b882518$export$83d89fbfd8236492 = "19.3.1";

});
parcelRegister("fO90s", function(module, exports) {
'use strict';

module.exports = (parcelRequire("1wAW3"));

});
parcelRegister("1wAW3", function(module, exports) {

$parcel$export(module.exports, "unstable_now", () => $11c56e2ffb2d6006$export$c4744153514ff05d, (v) => $11c56e2ffb2d6006$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $11c56e2ffb2d6006$export$3e506c1ccc9cc1a7, (v) => $11c56e2ffb2d6006$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $11c56e2ffb2d6006$export$e26fe2ed2fa76875, (v) => $11c56e2ffb2d6006$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $11c56e2ffb2d6006$export$502329bbf4b505b1, (v) => $11c56e2ffb2d6006$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $11c56e2ffb2d6006$export$6e3807111c4874c4, (v) => $11c56e2ffb2d6006$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $11c56e2ffb2d6006$export$c27134553091fb3a, (v) => $11c56e2ffb2d6006$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $11c56e2ffb2d6006$export$33ee1acdc04fd2a2, (v) => $11c56e2ffb2d6006$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $11c56e2ffb2d6006$export$b00a404bbd5edef2, (v) => $11c56e2ffb2d6006$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $11c56e2ffb2d6006$export$d66a1c1c77bd778b, (v) => $11c56e2ffb2d6006$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $11c56e2ffb2d6006$export$d3dfb8e4810cb555, (v) => $11c56e2ffb2d6006$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_next", () => $11c56e2ffb2d6006$export$72fdf0e06517287b, (v) => $11c56e2ffb2d6006$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $11c56e2ffb2d6006$export$816d2913ae6b83b1, (v) => $11c56e2ffb2d6006$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $11c56e2ffb2d6006$export$61bcfe829111a1d0, (v) => $11c56e2ffb2d6006$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $11c56e2ffb2d6006$export$7ee8c9beb337bc3f, (v) => $11c56e2ffb2d6006$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $11c56e2ffb2d6006$export$b5836b71941fa3ed, (v) => $11c56e2ffb2d6006$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $11c56e2ffb2d6006$export$cf845f2c119da08a, (v) => $11c56e2ffb2d6006$export$cf845f2c119da08a = v);
/**
 * @license React
 * scheduler.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $11c56e2ffb2d6006$export$c4744153514ff05d;
var $11c56e2ffb2d6006$export$3e506c1ccc9cc1a7;
var $11c56e2ffb2d6006$export$e26fe2ed2fa76875;
var $11c56e2ffb2d6006$export$502329bbf4b505b1;
var $11c56e2ffb2d6006$export$6e3807111c4874c4;
var $11c56e2ffb2d6006$export$c27134553091fb3a;
var $11c56e2ffb2d6006$export$33ee1acdc04fd2a2;
var $11c56e2ffb2d6006$export$b00a404bbd5edef2;
var $11c56e2ffb2d6006$export$d66a1c1c77bd778b;
var $11c56e2ffb2d6006$export$d3dfb8e4810cb555;
var $11c56e2ffb2d6006$export$72fdf0e06517287b;
var $11c56e2ffb2d6006$export$816d2913ae6b83b1;
var $11c56e2ffb2d6006$export$61bcfe829111a1d0;
var $11c56e2ffb2d6006$export$7ee8c9beb337bc3f;
var $11c56e2ffb2d6006$export$b5836b71941fa3ed;
var $11c56e2ffb2d6006$export$cf845f2c119da08a;
"use strict";
function $11c56e2ffb2d6006$var$push(heap, node) {
    var index = heap.length;
    heap.push(node);
    a: for(; 0 < index;){
        var parentIndex = index - 1 >>> 1, parent = heap[parentIndex];
        if (0 < $11c56e2ffb2d6006$var$compare(parent, node)) heap[parentIndex] = node, heap[index] = parent, index = parentIndex;
        else break a;
    }
}
function $11c56e2ffb2d6006$var$peek(heap) {
    return 0 === heap.length ? null : heap[0];
}
function $11c56e2ffb2d6006$var$pop(heap) {
    if (0 === heap.length) return null;
    var first = heap[0], last = heap.pop();
    if (last !== first) {
        heap[0] = last;
        a: for(var index = 0, length = heap.length, halfLength = length >>> 1; index < halfLength;){
            var leftIndex = 2 * (index + 1) - 1, left = heap[leftIndex], rightIndex = leftIndex + 1, right = heap[rightIndex];
            if (0 > $11c56e2ffb2d6006$var$compare(left, last)) rightIndex < length && 0 > $11c56e2ffb2d6006$var$compare(right, left) ? (heap[index] = right, heap[rightIndex] = last, index = rightIndex) : (heap[index] = left, heap[leftIndex] = last, index = leftIndex);
            else if (rightIndex < length && 0 > $11c56e2ffb2d6006$var$compare(right, last)) heap[index] = right, heap[rightIndex] = last, index = rightIndex;
            else break a;
        }
    }
    return first;
}
function $11c56e2ffb2d6006$var$compare(a, b) {
    var diff = a.sortIndex - b.sortIndex;
    return 0 !== diff ? diff : a.id - b.id;
}
$11c56e2ffb2d6006$export$c4744153514ff05d = void 0;
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $11c56e2ffb2d6006$var$localPerformance = performance;
    $11c56e2ffb2d6006$export$c4744153514ff05d = function() {
        return $11c56e2ffb2d6006$var$localPerformance.now();
    };
} else {
    var $11c56e2ffb2d6006$var$localDate = Date, $11c56e2ffb2d6006$var$initialTime = $11c56e2ffb2d6006$var$localDate.now();
    $11c56e2ffb2d6006$export$c4744153514ff05d = function() {
        return $11c56e2ffb2d6006$var$localDate.now() - $11c56e2ffb2d6006$var$initialTime;
    };
}
var $11c56e2ffb2d6006$var$taskQueue = [], $11c56e2ffb2d6006$var$timerQueue = [], $11c56e2ffb2d6006$var$taskIdCounter = 1, $11c56e2ffb2d6006$var$currentTask = null, $11c56e2ffb2d6006$var$currentPriorityLevel = 3, $11c56e2ffb2d6006$var$isPerformingWork = !1, $11c56e2ffb2d6006$var$isHostCallbackScheduled = !1, $11c56e2ffb2d6006$var$isHostTimeoutScheduled = !1, $11c56e2ffb2d6006$var$needsPaint = !1, $11c56e2ffb2d6006$var$localSetTimeout = "function" === typeof setTimeout ? setTimeout : null, $11c56e2ffb2d6006$var$localClearTimeout = "function" === typeof clearTimeout ? clearTimeout : null, $11c56e2ffb2d6006$var$localSetImmediate = "undefined" !== typeof setImmediate ? setImmediate : null;
function $11c56e2ffb2d6006$var$advanceTimers(currentTime) {
    for(var timer = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$timerQueue); null !== timer;){
        if (null === timer.callback) $11c56e2ffb2d6006$var$pop($11c56e2ffb2d6006$var$timerQueue);
        else if (timer.startTime <= currentTime) $11c56e2ffb2d6006$var$pop($11c56e2ffb2d6006$var$timerQueue), timer.sortIndex = timer.expirationTime, $11c56e2ffb2d6006$var$push($11c56e2ffb2d6006$var$taskQueue, timer);
        else break;
        timer = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$timerQueue);
    }
}
function $11c56e2ffb2d6006$var$handleTimeout(currentTime) {
    $11c56e2ffb2d6006$var$isHostTimeoutScheduled = !1;
    $11c56e2ffb2d6006$var$advanceTimers(currentTime);
    if (!$11c56e2ffb2d6006$var$isHostCallbackScheduled) {
        if (null !== $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$taskQueue)) $11c56e2ffb2d6006$var$isHostCallbackScheduled = !0, $11c56e2ffb2d6006$var$isMessageLoopRunning || ($11c56e2ffb2d6006$var$isMessageLoopRunning = !0, $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline());
        else {
            var firstTimer = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$timerQueue);
            null !== firstTimer && $11c56e2ffb2d6006$var$requestHostTimeout($11c56e2ffb2d6006$var$handleTimeout, firstTimer.startTime - currentTime);
        }
    }
}
var $11c56e2ffb2d6006$var$isMessageLoopRunning = !1, $11c56e2ffb2d6006$var$taskTimeoutID = -1, $11c56e2ffb2d6006$var$frameInterval = 5, $11c56e2ffb2d6006$var$startTime = -1;
function $11c56e2ffb2d6006$var$shouldYieldToHost() {
    return $11c56e2ffb2d6006$var$needsPaint ? !0 : $11c56e2ffb2d6006$export$c4744153514ff05d() - $11c56e2ffb2d6006$var$startTime < $11c56e2ffb2d6006$var$frameInterval ? !1 : !0;
}
function $11c56e2ffb2d6006$var$performWorkUntilDeadline() {
    $11c56e2ffb2d6006$var$needsPaint = !1;
    if ($11c56e2ffb2d6006$var$isMessageLoopRunning) {
        var currentTime = $11c56e2ffb2d6006$export$c4744153514ff05d();
        $11c56e2ffb2d6006$var$startTime = currentTime;
        var hasMoreWork = !0;
        try {
            a: {
                $11c56e2ffb2d6006$var$isHostCallbackScheduled = !1;
                $11c56e2ffb2d6006$var$isHostTimeoutScheduled && ($11c56e2ffb2d6006$var$isHostTimeoutScheduled = !1, $11c56e2ffb2d6006$var$localClearTimeout($11c56e2ffb2d6006$var$taskTimeoutID), $11c56e2ffb2d6006$var$taskTimeoutID = -1);
                $11c56e2ffb2d6006$var$isPerformingWork = !0;
                var previousPriorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
                try {
                    b: {
                        $11c56e2ffb2d6006$var$advanceTimers(currentTime);
                        for($11c56e2ffb2d6006$var$currentTask = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$taskQueue); null !== $11c56e2ffb2d6006$var$currentTask && !($11c56e2ffb2d6006$var$currentTask.expirationTime > currentTime && $11c56e2ffb2d6006$var$shouldYieldToHost());){
                            var callback = $11c56e2ffb2d6006$var$currentTask.callback;
                            if ("function" === typeof callback) {
                                $11c56e2ffb2d6006$var$currentTask.callback = null;
                                $11c56e2ffb2d6006$var$currentPriorityLevel = $11c56e2ffb2d6006$var$currentTask.priorityLevel;
                                var continuationCallback = callback($11c56e2ffb2d6006$var$currentTask.expirationTime <= currentTime);
                                currentTime = $11c56e2ffb2d6006$export$c4744153514ff05d();
                                if ("function" === typeof continuationCallback) {
                                    $11c56e2ffb2d6006$var$currentTask.callback = continuationCallback;
                                    $11c56e2ffb2d6006$var$advanceTimers(currentTime);
                                    hasMoreWork = !0;
                                    break b;
                                }
                                $11c56e2ffb2d6006$var$currentTask === $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$taskQueue) && $11c56e2ffb2d6006$var$pop($11c56e2ffb2d6006$var$taskQueue);
                                $11c56e2ffb2d6006$var$advanceTimers(currentTime);
                            } else $11c56e2ffb2d6006$var$pop($11c56e2ffb2d6006$var$taskQueue);
                            $11c56e2ffb2d6006$var$currentTask = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$taskQueue);
                        }
                        if (null !== $11c56e2ffb2d6006$var$currentTask) hasMoreWork = !0;
                        else {
                            var firstTimer = $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$timerQueue);
                            null !== firstTimer && $11c56e2ffb2d6006$var$requestHostTimeout($11c56e2ffb2d6006$var$handleTimeout, firstTimer.startTime - currentTime);
                            hasMoreWork = !1;
                        }
                    }
                    break a;
                } finally{
                    $11c56e2ffb2d6006$var$currentTask = null, $11c56e2ffb2d6006$var$currentPriorityLevel = previousPriorityLevel, $11c56e2ffb2d6006$var$isPerformingWork = !1;
                }
                hasMoreWork = void 0;
            }
        } finally{
            hasMoreWork ? $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline() : $11c56e2ffb2d6006$var$isMessageLoopRunning = !1;
        }
    }
}
var $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline;
if ("function" === typeof $11c56e2ffb2d6006$var$localSetImmediate) $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline = function() {
    $11c56e2ffb2d6006$var$localSetImmediate($11c56e2ffb2d6006$var$performWorkUntilDeadline);
};
else if ("undefined" !== typeof MessageChannel) {
    var $11c56e2ffb2d6006$var$channel = new MessageChannel(), $11c56e2ffb2d6006$var$port = $11c56e2ffb2d6006$var$channel.port2;
    $11c56e2ffb2d6006$var$channel.port1.onmessage = $11c56e2ffb2d6006$var$performWorkUntilDeadline;
    $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline = function() {
        $11c56e2ffb2d6006$var$port.postMessage(null);
    };
} else $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline = function() {
    $11c56e2ffb2d6006$var$localSetTimeout($11c56e2ffb2d6006$var$performWorkUntilDeadline, 0);
};
function $11c56e2ffb2d6006$var$requestHostTimeout(callback, ms) {
    $11c56e2ffb2d6006$var$taskTimeoutID = $11c56e2ffb2d6006$var$localSetTimeout(function() {
        callback($11c56e2ffb2d6006$export$c4744153514ff05d());
    }, ms);
}
$11c56e2ffb2d6006$export$3e506c1ccc9cc1a7 = 5;
$11c56e2ffb2d6006$export$e26fe2ed2fa76875 = 1;
$11c56e2ffb2d6006$export$502329bbf4b505b1 = 4;
$11c56e2ffb2d6006$export$6e3807111c4874c4 = 3;
$11c56e2ffb2d6006$export$c27134553091fb3a = null;
$11c56e2ffb2d6006$export$33ee1acdc04fd2a2 = 2;
$11c56e2ffb2d6006$export$b00a404bbd5edef2 = function(task) {
    task.callback = null;
};
$11c56e2ffb2d6006$export$d66a1c1c77bd778b = function(fps) {
    0 > fps || 125 < fps ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $11c56e2ffb2d6006$var$frameInterval = 0 < fps ? Math.floor(1e3 / fps) : 5;
};
$11c56e2ffb2d6006$export$d3dfb8e4810cb555 = function() {
    return $11c56e2ffb2d6006$var$currentPriorityLevel;
};
$11c56e2ffb2d6006$export$72fdf0e06517287b = function(eventHandler) {
    switch($11c56e2ffb2d6006$var$currentPriorityLevel){
        case 1:
        case 2:
        case 3:
            var priorityLevel = 3;
            break;
        default:
            priorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
    }
    var previousPriorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
    $11c56e2ffb2d6006$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $11c56e2ffb2d6006$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$11c56e2ffb2d6006$export$816d2913ae6b83b1 = function() {
    $11c56e2ffb2d6006$var$needsPaint = !0;
};
$11c56e2ffb2d6006$export$61bcfe829111a1d0 = function(priorityLevel, eventHandler) {
    switch(priorityLevel){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            priorityLevel = 3;
    }
    var previousPriorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
    $11c56e2ffb2d6006$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $11c56e2ffb2d6006$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$11c56e2ffb2d6006$export$7ee8c9beb337bc3f = function(priorityLevel, callback, options) {
    var currentTime = $11c56e2ffb2d6006$export$c4744153514ff05d();
    "object" === typeof options && null !== options ? (options = options.delay, options = "number" === typeof options && 0 < options ? currentTime + options : currentTime) : options = currentTime;
    switch(priorityLevel){
        case 1:
            var timeout = -1;
            break;
        case 2:
            timeout = 250;
            break;
        case 5:
            timeout = 1073741823;
            break;
        case 4:
            timeout = 1e4;
            break;
        default:
            timeout = 5e3;
    }
    timeout = options + timeout;
    priorityLevel = {
        id: $11c56e2ffb2d6006$var$taskIdCounter++,
        callback: callback,
        priorityLevel: priorityLevel,
        startTime: options,
        expirationTime: timeout,
        sortIndex: -1
    };
    options > currentTime ? (priorityLevel.sortIndex = options, $11c56e2ffb2d6006$var$push($11c56e2ffb2d6006$var$timerQueue, priorityLevel), null === $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$taskQueue) && priorityLevel === $11c56e2ffb2d6006$var$peek($11c56e2ffb2d6006$var$timerQueue) && ($11c56e2ffb2d6006$var$isHostTimeoutScheduled ? ($11c56e2ffb2d6006$var$localClearTimeout($11c56e2ffb2d6006$var$taskTimeoutID), $11c56e2ffb2d6006$var$taskTimeoutID = -1) : $11c56e2ffb2d6006$var$isHostTimeoutScheduled = !0, $11c56e2ffb2d6006$var$requestHostTimeout($11c56e2ffb2d6006$var$handleTimeout, options - currentTime))) : (priorityLevel.sortIndex = timeout, $11c56e2ffb2d6006$var$push($11c56e2ffb2d6006$var$taskQueue, priorityLevel), $11c56e2ffb2d6006$var$isHostCallbackScheduled || $11c56e2ffb2d6006$var$isPerformingWork || ($11c56e2ffb2d6006$var$isHostCallbackScheduled = !0, $11c56e2ffb2d6006$var$isMessageLoopRunning || ($11c56e2ffb2d6006$var$isMessageLoopRunning = !0, $11c56e2ffb2d6006$var$schedulePerformWorkUntilDeadline())));
    return priorityLevel;
};
$11c56e2ffb2d6006$export$b5836b71941fa3ed = $11c56e2ffb2d6006$var$shouldYieldToHost;
$11c56e2ffb2d6006$export$cf845f2c119da08a = function(callback) {
    var parentPriorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
    return function() {
        var previousPriorityLevel = $11c56e2ffb2d6006$var$currentPriorityLevel;
        $11c56e2ffb2d6006$var$currentPriorityLevel = parentPriorityLevel;
        try {
            return callback.apply(this, arguments);
        } finally{
            $11c56e2ffb2d6006$var$currentPriorityLevel = previousPriorityLevel;
        }
    };
};

});


parcelRegister("acw62", function(module, exports) {
'use strict';

module.exports = (parcelRequire("9Qu0I"));

});
parcelRegister("9Qu0I", function(module, exports) {

$parcel$export(module.exports, "Activity", () => $72b03fdf46effee2$export$9c16c1426311996d, (v) => $72b03fdf46effee2$export$9c16c1426311996d = v);
$parcel$export(module.exports, "Children", () => $72b03fdf46effee2$export$dca3b0875bd9a954, (v) => $72b03fdf46effee2$export$dca3b0875bd9a954 = v);
$parcel$export(module.exports, "Component", () => $72b03fdf46effee2$export$16fa2f45be04daa8, (v) => $72b03fdf46effee2$export$16fa2f45be04daa8 = v);
$parcel$export(module.exports, "Fragment", () => $72b03fdf46effee2$export$ffb0004e005737fa, (v) => $72b03fdf46effee2$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Profiler", () => $72b03fdf46effee2$export$e2c29f18771995cb, (v) => $72b03fdf46effee2$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "PureComponent", () => $72b03fdf46effee2$export$221d75b3f55bb0bd, (v) => $72b03fdf46effee2$export$221d75b3f55bb0bd = v);
$parcel$export(module.exports, "StrictMode", () => $72b03fdf46effee2$export$5f8d39834fd61797, (v) => $72b03fdf46effee2$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $72b03fdf46effee2$export$74bf444e3cd11ea5, (v) => $72b03fdf46effee2$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "ViewTransition", () => $72b03fdf46effee2$export$8cdaa4703948c5e9, (v) => $72b03fdf46effee2$export$8cdaa4703948c5e9 = v);
$parcel$export(module.exports, "__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", () => $72b03fdf46effee2$export$1ced07cd6b1985ce, (v) => $72b03fdf46effee2$export$1ced07cd6b1985ce = v);
$parcel$export(module.exports, "__COMPILER_RUNTIME", () => $72b03fdf46effee2$export$abd8e32b826d7ea7, (v) => $72b03fdf46effee2$export$abd8e32b826d7ea7 = v);
$parcel$export(module.exports, "addTransitionType", () => $72b03fdf46effee2$export$87c99536b1b8cdd8, (v) => $72b03fdf46effee2$export$87c99536b1b8cdd8 = v);
$parcel$export(module.exports, "cache", () => $72b03fdf46effee2$export$69a3209f1a06c04d, (v) => $72b03fdf46effee2$export$69a3209f1a06c04d = v);
$parcel$export(module.exports, "cacheSignal", () => $72b03fdf46effee2$export$8c538325882c7eec, (v) => $72b03fdf46effee2$export$8c538325882c7eec = v);
$parcel$export(module.exports, "cloneElement", () => $72b03fdf46effee2$export$e530037191fcd5d7, (v) => $72b03fdf46effee2$export$e530037191fcd5d7 = v);
$parcel$export(module.exports, "createContext", () => $72b03fdf46effee2$export$fd42f52fd3ae1109, (v) => $72b03fdf46effee2$export$fd42f52fd3ae1109 = v);
$parcel$export(module.exports, "createElement", () => $72b03fdf46effee2$export$c8a8987d4410bf2d, (v) => $72b03fdf46effee2$export$c8a8987d4410bf2d = v);
$parcel$export(module.exports, "createRef", () => $72b03fdf46effee2$export$7d1e3a5e95ceca43, (v) => $72b03fdf46effee2$export$7d1e3a5e95ceca43 = v);
$parcel$export(module.exports, "forwardRef", () => $72b03fdf46effee2$export$257a8862b851cb5b, (v) => $72b03fdf46effee2$export$257a8862b851cb5b = v);
$parcel$export(module.exports, "isValidElement", () => $72b03fdf46effee2$export$a8257692ac88316c, (v) => $72b03fdf46effee2$export$a8257692ac88316c = v);
$parcel$export(module.exports, "lazy", () => $72b03fdf46effee2$export$488013bae63b21da, (v) => $72b03fdf46effee2$export$488013bae63b21da = v);
$parcel$export(module.exports, "memo", () => $72b03fdf46effee2$export$7c73462e0d25e514, (v) => $72b03fdf46effee2$export$7c73462e0d25e514 = v);
$parcel$export(module.exports, "startTransition", () => $72b03fdf46effee2$export$7568632d0d33d16d, (v) => $72b03fdf46effee2$export$7568632d0d33d16d = v);
$parcel$export(module.exports, "unstable_useCacheRefresh", () => $72b03fdf46effee2$export$f93f40ac0ca7e3a8, (v) => $72b03fdf46effee2$export$f93f40ac0ca7e3a8 = v);
$parcel$export(module.exports, "use", () => $72b03fdf46effee2$export$1f96ae73734a86cc, (v) => $72b03fdf46effee2$export$1f96ae73734a86cc = v);
$parcel$export(module.exports, "useActionState", () => $72b03fdf46effee2$export$9a47ced3238df325, (v) => $72b03fdf46effee2$export$9a47ced3238df325 = v);
$parcel$export(module.exports, "useCallback", () => $72b03fdf46effee2$export$35808ee640e87ca7, (v) => $72b03fdf46effee2$export$35808ee640e87ca7 = v);
$parcel$export(module.exports, "useContext", () => $72b03fdf46effee2$export$fae74005e78b1a27, (v) => $72b03fdf46effee2$export$fae74005e78b1a27 = v);
$parcel$export(module.exports, "useDebugValue", () => $72b03fdf46effee2$export$dc8fbce3eb94dc1e, (v) => $72b03fdf46effee2$export$dc8fbce3eb94dc1e = v);
$parcel$export(module.exports, "useDeferredValue", () => $72b03fdf46effee2$export$6a7bc4e911dc01cf, (v) => $72b03fdf46effee2$export$6a7bc4e911dc01cf = v);
$parcel$export(module.exports, "useEffect", () => $72b03fdf46effee2$export$6d9c69b0de29b591, (v) => $72b03fdf46effee2$export$6d9c69b0de29b591 = v);
$parcel$export(module.exports, "useEffectEvent", () => $72b03fdf46effee2$export$7f54fc3180508a52, (v) => $72b03fdf46effee2$export$7f54fc3180508a52 = v);
$parcel$export(module.exports, "useId", () => $72b03fdf46effee2$export$f680877a34711e37, (v) => $72b03fdf46effee2$export$f680877a34711e37 = v);
$parcel$export(module.exports, "useImperativeHandle", () => $72b03fdf46effee2$export$d5a552a76deda3c2, (v) => $72b03fdf46effee2$export$d5a552a76deda3c2 = v);
$parcel$export(module.exports, "useInsertionEffect", () => $72b03fdf46effee2$export$aaabe4eda9ed9969, (v) => $72b03fdf46effee2$export$aaabe4eda9ed9969 = v);
$parcel$export(module.exports, "useLayoutEffect", () => $72b03fdf46effee2$export$e5c5a5f917a5871c, (v) => $72b03fdf46effee2$export$e5c5a5f917a5871c = v);
$parcel$export(module.exports, "useMemo", () => $72b03fdf46effee2$export$1538c33de8887b59, (v) => $72b03fdf46effee2$export$1538c33de8887b59 = v);
$parcel$export(module.exports, "useOptimistic", () => $72b03fdf46effee2$export$fca7f784ae7a249a, (v) => $72b03fdf46effee2$export$fca7f784ae7a249a = v);
$parcel$export(module.exports, "useReducer", () => $72b03fdf46effee2$export$13e3392192263954, (v) => $72b03fdf46effee2$export$13e3392192263954 = v);
$parcel$export(module.exports, "useRef", () => $72b03fdf46effee2$export$b8f5890fc79d6aca, (v) => $72b03fdf46effee2$export$b8f5890fc79d6aca = v);
$parcel$export(module.exports, "useState", () => $72b03fdf46effee2$export$60241385465d0a34, (v) => $72b03fdf46effee2$export$60241385465d0a34 = v);
$parcel$export(module.exports, "useSyncExternalStore", () => $72b03fdf46effee2$export$306c0aa65ff9ec16, (v) => $72b03fdf46effee2$export$306c0aa65ff9ec16 = v);
$parcel$export(module.exports, "useTransition", () => $72b03fdf46effee2$export$7b286972b8d8ccbf, (v) => $72b03fdf46effee2$export$7b286972b8d8ccbf = v);
$parcel$export(module.exports, "version", () => $72b03fdf46effee2$export$83d89fbfd8236492, (v) => $72b03fdf46effee2$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $72b03fdf46effee2$export$9c16c1426311996d;
var $72b03fdf46effee2$export$dca3b0875bd9a954;
var $72b03fdf46effee2$export$16fa2f45be04daa8;
var $72b03fdf46effee2$export$ffb0004e005737fa;
var $72b03fdf46effee2$export$e2c29f18771995cb;
var $72b03fdf46effee2$export$221d75b3f55bb0bd;
var $72b03fdf46effee2$export$5f8d39834fd61797;
var $72b03fdf46effee2$export$74bf444e3cd11ea5;
var $72b03fdf46effee2$export$8cdaa4703948c5e9;
var $72b03fdf46effee2$export$1ced07cd6b1985ce;
var $72b03fdf46effee2$export$abd8e32b826d7ea7;
var $72b03fdf46effee2$export$87c99536b1b8cdd8;
var $72b03fdf46effee2$export$69a3209f1a06c04d;
var $72b03fdf46effee2$export$8c538325882c7eec;
var $72b03fdf46effee2$export$e530037191fcd5d7;
var $72b03fdf46effee2$export$fd42f52fd3ae1109;
var $72b03fdf46effee2$export$c8a8987d4410bf2d;
var $72b03fdf46effee2$export$7d1e3a5e95ceca43;
var $72b03fdf46effee2$export$257a8862b851cb5b;
var $72b03fdf46effee2$export$a8257692ac88316c;
var $72b03fdf46effee2$export$488013bae63b21da;
var $72b03fdf46effee2$export$7c73462e0d25e514;
var $72b03fdf46effee2$export$7568632d0d33d16d;
var $72b03fdf46effee2$export$f93f40ac0ca7e3a8;
var $72b03fdf46effee2$export$1f96ae73734a86cc;
var $72b03fdf46effee2$export$9a47ced3238df325;
var $72b03fdf46effee2$export$35808ee640e87ca7;
var $72b03fdf46effee2$export$fae74005e78b1a27;
var $72b03fdf46effee2$export$dc8fbce3eb94dc1e;
var $72b03fdf46effee2$export$6a7bc4e911dc01cf;
var $72b03fdf46effee2$export$6d9c69b0de29b591;
var $72b03fdf46effee2$export$7f54fc3180508a52;
var $72b03fdf46effee2$export$f680877a34711e37;
var $72b03fdf46effee2$export$d5a552a76deda3c2;
var $72b03fdf46effee2$export$aaabe4eda9ed9969;
var $72b03fdf46effee2$export$e5c5a5f917a5871c;
var $72b03fdf46effee2$export$1538c33de8887b59;
var $72b03fdf46effee2$export$fca7f784ae7a249a;
var $72b03fdf46effee2$export$13e3392192263954;
var $72b03fdf46effee2$export$b8f5890fc79d6aca;
var $72b03fdf46effee2$export$60241385465d0a34;
var $72b03fdf46effee2$export$306c0aa65ff9ec16;
var $72b03fdf46effee2$export$7b286972b8d8ccbf;
var $72b03fdf46effee2$export$83d89fbfd8236492;
"use strict";
var $72b03fdf46effee2$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $72b03fdf46effee2$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $72b03fdf46effee2$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $72b03fdf46effee2$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $72b03fdf46effee2$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $72b03fdf46effee2$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $72b03fdf46effee2$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $72b03fdf46effee2$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $72b03fdf46effee2$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $72b03fdf46effee2$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $72b03fdf46effee2$var$REACT_LAZY_TYPE = Symbol.for("react.lazy"), $72b03fdf46effee2$var$REACT_ACTIVITY_TYPE = Symbol.for("react.activity"), $72b03fdf46effee2$var$REACT_VIEW_TRANSITION_TYPE = Symbol.for("react.view_transition"), $72b03fdf46effee2$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $72b03fdf46effee2$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = $72b03fdf46effee2$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$72b03fdf46effee2$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $72b03fdf46effee2$var$ReactNoopUpdateQueue = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $72b03fdf46effee2$var$assign = Object.assign, $72b03fdf46effee2$var$emptyObject = {};
function $72b03fdf46effee2$var$Component(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $72b03fdf46effee2$var$emptyObject;
    this.updater = updater || $72b03fdf46effee2$var$ReactNoopUpdateQueue;
}
$72b03fdf46effee2$var$Component.prototype.isReactComponent = {};
$72b03fdf46effee2$var$Component.prototype.setState = function(partialState, callback) {
    if ("object" !== typeof partialState && "function" !== typeof partialState && null != partialState) throw Error("takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, partialState, callback, "setState");
};
$72b03fdf46effee2$var$Component.prototype.forceUpdate = function(callback) {
    this.updater.enqueueForceUpdate(this, callback, "forceUpdate");
};
function $72b03fdf46effee2$var$ComponentDummy() {}
$72b03fdf46effee2$var$ComponentDummy.prototype = $72b03fdf46effee2$var$Component.prototype;
function $72b03fdf46effee2$var$PureComponent(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $72b03fdf46effee2$var$emptyObject;
    this.updater = updater || $72b03fdf46effee2$var$ReactNoopUpdateQueue;
}
var $72b03fdf46effee2$var$pureComponentPrototype = $72b03fdf46effee2$var$PureComponent.prototype = new $72b03fdf46effee2$var$ComponentDummy();
$72b03fdf46effee2$var$pureComponentPrototype.constructor = $72b03fdf46effee2$var$PureComponent;
$72b03fdf46effee2$var$assign($72b03fdf46effee2$var$pureComponentPrototype, $72b03fdf46effee2$var$Component.prototype);
$72b03fdf46effee2$var$pureComponentPrototype.isPureReactComponent = !0;
var $72b03fdf46effee2$var$isArrayImpl = Array.isArray;
function $72b03fdf46effee2$var$noop() {}
var $72b03fdf46effee2$var$ReactSharedInternals = {
    H: null,
    A: null,
    T: null,
    S: null
}, $72b03fdf46effee2$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $72b03fdf46effee2$var$ReactElement(type, key, props) {
    var refProp = props.ref;
    return {
        $$typeof: $72b03fdf46effee2$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== refProp ? refProp : null,
        props: props
    };
}
function $72b03fdf46effee2$var$cloneAndReplaceKey(oldElement, newKey) {
    return $72b03fdf46effee2$var$ReactElement(oldElement.type, newKey, oldElement.props);
}
function $72b03fdf46effee2$var$isValidElement(object) {
    return "object" === typeof object && null !== object && object.$$typeof === $72b03fdf46effee2$var$REACT_ELEMENT_TYPE;
}
function $72b03fdf46effee2$var$escape(key) {
    var escaperLookup = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + key.replace(/[=:]/g, function(match) {
        return escaperLookup[match];
    });
}
var $72b03fdf46effee2$var$userProvidedKeyEscapeRegex = /\/+/g;
function $72b03fdf46effee2$var$getElementKey(element, index) {
    return "object" === typeof element && null !== element && null != element.key ? $72b03fdf46effee2$var$escape("" + element.key) : index.toString(36);
}
function $72b03fdf46effee2$var$resolveThenable(thenable) {
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenable.reason;
        default:
            switch("string" === typeof thenable.status ? thenable.then($72b03fdf46effee2$var$noop, $72b03fdf46effee2$var$noop) : (thenable.status = "pending", thenable.then(function(fulfilledValue) {
                "pending" === thenable.status && (thenable.status = "fulfilled", thenable.value = fulfilledValue);
            }, function(error) {
                "pending" === thenable.status && (thenable.status = "rejected", thenable.reason = error);
            })), thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenable.reason;
            }
    }
    throw thenable;
}
function $72b03fdf46effee2$var$mapIntoArray(children, array, escapedPrefix, nameSoFar, callback) {
    var type = typeof children;
    if ("undefined" === type || "boolean" === type) children = null;
    var invokeCallback = !1;
    if (null === children) invokeCallback = !0;
    else switch(type){
        case "bigint":
        case "string":
        case "number":
            invokeCallback = !0;
            break;
        case "object":
            switch(children.$$typeof){
                case $72b03fdf46effee2$var$REACT_ELEMENT_TYPE:
                case $72b03fdf46effee2$var$REACT_PORTAL_TYPE:
                    invokeCallback = !0;
                    break;
                case $72b03fdf46effee2$var$REACT_LAZY_TYPE:
                    return invokeCallback = children._init, $72b03fdf46effee2$var$mapIntoArray(invokeCallback(children._payload), array, escapedPrefix, nameSoFar, callback);
            }
    }
    if (invokeCallback) return callback = callback(children), invokeCallback = "" === nameSoFar ? "." + $72b03fdf46effee2$var$getElementKey(children, 0) : nameSoFar, $72b03fdf46effee2$var$isArrayImpl(callback) ? (escapedPrefix = "", null != invokeCallback && (escapedPrefix = invokeCallback.replace($72b03fdf46effee2$var$userProvidedKeyEscapeRegex, "$&/") + "/"), $72b03fdf46effee2$var$mapIntoArray(callback, array, escapedPrefix, "", function(c) {
        return c;
    })) : null != callback && ($72b03fdf46effee2$var$isValidElement(callback) && (callback = $72b03fdf46effee2$var$cloneAndReplaceKey(callback, escapedPrefix + (null == callback.key || children && children.key === callback.key ? "" : ("" + callback.key).replace($72b03fdf46effee2$var$userProvidedKeyEscapeRegex, "$&/") + "/") + invokeCallback)), array.push(callback)), 1;
    invokeCallback = 0;
    var nextNamePrefix = "" === nameSoFar ? "." : nameSoFar + ":";
    if ($72b03fdf46effee2$var$isArrayImpl(children)) for(var i = 0; i < children.length; i++)nameSoFar = children[i], type = nextNamePrefix + $72b03fdf46effee2$var$getElementKey(nameSoFar, i), invokeCallback += $72b03fdf46effee2$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if (i = $72b03fdf46effee2$var$getIteratorFn(children), "function" === typeof i) for(children = i.call(children), i = 0; !(nameSoFar = children.next()).done;)nameSoFar = nameSoFar.value, type = nextNamePrefix + $72b03fdf46effee2$var$getElementKey(nameSoFar, i++), invokeCallback += $72b03fdf46effee2$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if ("object" === type) {
        if ("function" === typeof children.then) return $72b03fdf46effee2$var$mapIntoArray($72b03fdf46effee2$var$resolveThenable(children), array, escapedPrefix, nameSoFar, callback);
        array = String(children);
        throw Error("Objects are not valid as a React child (found: " + ("[object Object]" === array ? "object with keys {" + Object.keys(children).join(", ") + "}" : array) + "). If you meant to render a collection of children, use an array instead.");
    }
    return invokeCallback;
}
function $72b03fdf46effee2$var$mapChildren(children, func, context) {
    if (null == children) return children;
    var result = [], count = 0;
    $72b03fdf46effee2$var$mapIntoArray(children, result, "", "", function(child) {
        return func.call(context, child, count++);
    });
    return result;
}
function $72b03fdf46effee2$var$lazyInitializer(payload) {
    if (-1 === payload._status) {
        var ctor = payload._result, thenable = ctor();
        thenable.then(function(moduleObject) {
            if (0 === payload._status || -1 === payload._status) payload._status = 1, payload._result = moduleObject, void 0 === thenable.status && (thenable.status = "fulfilled", thenable.value = moduleObject);
        }, function(error) {
            if (0 === payload._status || -1 === payload._status) payload._status = 2, payload._result = error, void 0 === thenable.status && (thenable.status = "rejected", thenable.reason = error);
        });
        -1 === payload._status && (payload._status = 0, payload._result = thenable);
    }
    if (1 === payload._status) return payload._result.default;
    throw payload._result;
}
var $72b03fdf46effee2$var$reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    }
    console.error(error);
};
function $72b03fdf46effee2$var$startTransition(scope) {
    var prevTransition = $72b03fdf46effee2$var$ReactSharedInternals.T, currentTransition = {};
    currentTransition.types = null !== prevTransition ? prevTransition.types : null;
    $72b03fdf46effee2$var$ReactSharedInternals.T = currentTransition;
    try {
        var returnValue = scope(), onStartTransitionFinish = $72b03fdf46effee2$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && returnValue.then($72b03fdf46effee2$var$noop, $72b03fdf46effee2$var$reportGlobalError);
    } catch (error) {
        $72b03fdf46effee2$var$reportGlobalError(error);
    } finally{
        null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $72b03fdf46effee2$var$ReactSharedInternals.T = prevTransition;
    }
}
function $72b03fdf46effee2$var$addTransitionType(type) {
    var transition = $72b03fdf46effee2$var$ReactSharedInternals.T;
    if (null !== transition) {
        var transitionTypes = transition.types;
        null === transitionTypes ? transition.types = [
            type
        ] : -1 === transitionTypes.indexOf(type) && transitionTypes.push(type);
    } else $72b03fdf46effee2$var$startTransition($72b03fdf46effee2$var$addTransitionType.bind(null, type));
}
var $72b03fdf46effee2$var$Children = {
    map: $72b03fdf46effee2$var$mapChildren,
    forEach: function(children, forEachFunc, forEachContext) {
        $72b03fdf46effee2$var$mapChildren(children, function() {
            forEachFunc.apply(this, arguments);
        }, forEachContext);
    },
    count: function(children) {
        var n = 0;
        $72b03fdf46effee2$var$mapChildren(children, function() {
            n++;
        });
        return n;
    },
    toArray: function(children) {
        return $72b03fdf46effee2$var$mapChildren(children, function(child) {
            return child;
        }) || [];
    },
    only: function(children) {
        if (!$72b03fdf46effee2$var$isValidElement(children)) throw Error("React.Children.only expected to receive a single React element child.");
        return children;
    }
};
$72b03fdf46effee2$export$9c16c1426311996d = $72b03fdf46effee2$var$REACT_ACTIVITY_TYPE;
$72b03fdf46effee2$export$dca3b0875bd9a954 = $72b03fdf46effee2$var$Children;
$72b03fdf46effee2$export$16fa2f45be04daa8 = $72b03fdf46effee2$var$Component;
$72b03fdf46effee2$export$ffb0004e005737fa = $72b03fdf46effee2$var$REACT_FRAGMENT_TYPE;
$72b03fdf46effee2$export$e2c29f18771995cb = $72b03fdf46effee2$var$REACT_PROFILER_TYPE;
$72b03fdf46effee2$export$221d75b3f55bb0bd = $72b03fdf46effee2$var$PureComponent;
$72b03fdf46effee2$export$5f8d39834fd61797 = $72b03fdf46effee2$var$REACT_STRICT_MODE_TYPE;
$72b03fdf46effee2$export$74bf444e3cd11ea5 = $72b03fdf46effee2$var$REACT_SUSPENSE_TYPE;
$72b03fdf46effee2$export$8cdaa4703948c5e9 = $72b03fdf46effee2$var$REACT_VIEW_TRANSITION_TYPE;
$72b03fdf46effee2$export$1ced07cd6b1985ce = $72b03fdf46effee2$var$ReactSharedInternals;
$72b03fdf46effee2$export$abd8e32b826d7ea7 = {
    __proto__: null,
    c: function(size) {
        return $72b03fdf46effee2$var$ReactSharedInternals.H.useMemoCache(size);
    }
};
$72b03fdf46effee2$export$87c99536b1b8cdd8 = $72b03fdf46effee2$var$addTransitionType;
$72b03fdf46effee2$export$69a3209f1a06c04d = function(fn) {
    return function() {
        return fn.apply(null, arguments);
    };
};
$72b03fdf46effee2$export$8c538325882c7eec = function() {
    return null;
};
$72b03fdf46effee2$export$e530037191fcd5d7 = function(element, config, children) {
    if (null === element || void 0 === element) throw Error("The argument must be a React element, but you passed " + element + ".");
    var props = $72b03fdf46effee2$var$assign({}, element.props), key = element.key;
    if (null != config) for(propName in void 0 !== config.key && (key = "" + config.key), config)!$72b03fdf46effee2$var$hasOwnProperty.call(config, propName) || "key" === propName || "__self" === propName || "__source" === propName || "ref" === propName && void 0 === config.ref || (props[propName] = config[propName]);
    var propName = arguments.length - 2;
    if (1 === propName) props.children = children;
    else if (1 < propName) {
        for(var childArray = Array(propName), i = 0; i < propName; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    return $72b03fdf46effee2$var$ReactElement(element.type, key, props);
};
$72b03fdf46effee2$export$fd42f52fd3ae1109 = function(defaultValue) {
    defaultValue = {
        $$typeof: $72b03fdf46effee2$var$REACT_CONTEXT_TYPE,
        _currentValue: defaultValue,
        _currentValue2: defaultValue,
        _threadCount: 0,
        Provider: null,
        Consumer: null
    };
    defaultValue.Provider = defaultValue;
    defaultValue.Consumer = {
        $$typeof: $72b03fdf46effee2$var$REACT_CONSUMER_TYPE,
        _context: defaultValue
    };
    return defaultValue;
};
$72b03fdf46effee2$export$c8a8987d4410bf2d = function(type, config, children) {
    var propName, props = {}, key = null;
    if (null != config) for(propName in void 0 !== config.key && (key = "" + config.key), config)$72b03fdf46effee2$var$hasOwnProperty.call(config, propName) && "key" !== propName && "__self" !== propName && "__source" !== propName && (props[propName] = config[propName]);
    var childrenLength = arguments.length - 2;
    if (1 === childrenLength) props.children = children;
    else if (1 < childrenLength) {
        for(var childArray = Array(childrenLength), i = 0; i < childrenLength; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    if (type && type.defaultProps) for(propName in childrenLength = type.defaultProps, childrenLength)void 0 === props[propName] && (props[propName] = childrenLength[propName]);
    return $72b03fdf46effee2$var$ReactElement(type, key, props);
};
$72b03fdf46effee2$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$72b03fdf46effee2$export$257a8862b851cb5b = function(render) {
    return {
        $$typeof: $72b03fdf46effee2$var$REACT_FORWARD_REF_TYPE,
        render: render
    };
};
$72b03fdf46effee2$export$a8257692ac88316c = $72b03fdf46effee2$var$isValidElement;
$72b03fdf46effee2$export$488013bae63b21da = function(ctor) {
    return {
        $$typeof: $72b03fdf46effee2$var$REACT_LAZY_TYPE,
        _payload: {
            _status: -1,
            _result: ctor
        },
        _init: $72b03fdf46effee2$var$lazyInitializer
    };
};
$72b03fdf46effee2$export$7c73462e0d25e514 = function(type, compare) {
    return {
        $$typeof: $72b03fdf46effee2$var$REACT_MEMO_TYPE,
        type: type,
        compare: void 0 === compare ? null : compare
    };
};
$72b03fdf46effee2$export$7568632d0d33d16d = $72b03fdf46effee2$var$startTransition;
$72b03fdf46effee2$export$f93f40ac0ca7e3a8 = function() {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useCacheRefresh();
};
$72b03fdf46effee2$export$1f96ae73734a86cc = function(usable) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.use(usable);
};
$72b03fdf46effee2$export$9a47ced3238df325 = function(action, initialState, permalink) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useActionState(action, initialState, permalink);
};
$72b03fdf46effee2$export$35808ee640e87ca7 = function(callback, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useCallback(callback, deps);
};
$72b03fdf46effee2$export$fae74005e78b1a27 = function(Context) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useContext(Context);
};
$72b03fdf46effee2$export$dc8fbce3eb94dc1e = function() {};
$72b03fdf46effee2$export$6a7bc4e911dc01cf = function(value, initialValue) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useDeferredValue(value, initialValue);
};
$72b03fdf46effee2$export$6d9c69b0de29b591 = function(create, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useEffect(create, deps);
};
$72b03fdf46effee2$export$7f54fc3180508a52 = function(callback) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useEffectEvent(callback);
};
$72b03fdf46effee2$export$f680877a34711e37 = function() {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useId();
};
$72b03fdf46effee2$export$d5a552a76deda3c2 = function(ref, create, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useImperativeHandle(ref, create, deps);
};
$72b03fdf46effee2$export$aaabe4eda9ed9969 = function(create, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useInsertionEffect(create, deps);
};
$72b03fdf46effee2$export$e5c5a5f917a5871c = function(create, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useLayoutEffect(create, deps);
};
$72b03fdf46effee2$export$1538c33de8887b59 = function(create, deps) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useMemo(create, deps);
};
$72b03fdf46effee2$export$fca7f784ae7a249a = function(passthrough, reducer) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useOptimistic(passthrough, reducer);
};
$72b03fdf46effee2$export$13e3392192263954 = function(reducer, initialArg, init) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useReducer(reducer, initialArg, init);
};
$72b03fdf46effee2$export$b8f5890fc79d6aca = function(initialValue) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useRef(initialValue);
};
$72b03fdf46effee2$export$60241385465d0a34 = function(initialState) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useState(initialState);
};
$72b03fdf46effee2$export$306c0aa65ff9ec16 = function(subscribe, getSnapshot, getServerSnapshot) {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
};
$72b03fdf46effee2$export$7b286972b8d8ccbf = function() {
    return $72b03fdf46effee2$var$ReactSharedInternals.H.useTransition();
};
$72b03fdf46effee2$export$83d89fbfd8236492 = "19.3.1";

});


parcelRegister("1u0KT", function(module, exports) {
'use strict';
function $11492dca620dcaa5$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($11492dca620dcaa5$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$11492dca620dcaa5$var$checkDCE();

module.exports = (parcelRequire("5R2tS"));

});
parcelRegister("5R2tS", function(module, exports) {

$parcel$export(module.exports, "__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", () => $4433d39f12c5883f$export$69ce8ef3fe5cead0, (v) => $4433d39f12c5883f$export$69ce8ef3fe5cead0 = v);
$parcel$export(module.exports, "browser", () => $4433d39f12c5883f$export$3f2684e5d7cb1006, (v) => $4433d39f12c5883f$export$3f2684e5d7cb1006 = v);
$parcel$export(module.exports, "createPortal", () => $4433d39f12c5883f$export$d39a5bbd09211389, (v) => $4433d39f12c5883f$export$d39a5bbd09211389 = v);
$parcel$export(module.exports, "flushSync", () => $4433d39f12c5883f$export$cd75ccfd720a3cd4, (v) => $4433d39f12c5883f$export$cd75ccfd720a3cd4 = v);
$parcel$export(module.exports, "preconnect", () => $4433d39f12c5883f$export$a0816fa17a9e79be, (v) => $4433d39f12c5883f$export$a0816fa17a9e79be = v);
$parcel$export(module.exports, "prefetchDNS", () => $4433d39f12c5883f$export$7292efcadded39f3, (v) => $4433d39f12c5883f$export$7292efcadded39f3 = v);
$parcel$export(module.exports, "preinit", () => $4433d39f12c5883f$export$da407abadb9b8f86, (v) => $4433d39f12c5883f$export$da407abadb9b8f86 = v);
$parcel$export(module.exports, "preinitModule", () => $4433d39f12c5883f$export$314cfea32580671c, (v) => $4433d39f12c5883f$export$314cfea32580671c = v);
$parcel$export(module.exports, "preload", () => $4433d39f12c5883f$export$513ccb98c53b8039, (v) => $4433d39f12c5883f$export$513ccb98c53b8039 = v);
$parcel$export(module.exports, "preloadModule", () => $4433d39f12c5883f$export$dbca993bc2d264a, (v) => $4433d39f12c5883f$export$dbca993bc2d264a = v);
$parcel$export(module.exports, "requestFormReset", () => $4433d39f12c5883f$export$4797a8006f0655d0, (v) => $4433d39f12c5883f$export$4797a8006f0655d0 = v);
$parcel$export(module.exports, "unstable_batchedUpdates", () => $4433d39f12c5883f$export$c78a37762a8d58e1, (v) => $4433d39f12c5883f$export$c78a37762a8d58e1 = v);
$parcel$export(module.exports, "useFormState", () => $4433d39f12c5883f$export$606f11b2eb45ecc6, (v) => $4433d39f12c5883f$export$606f11b2eb45ecc6 = v);
$parcel$export(module.exports, "useFormStatus", () => $4433d39f12c5883f$export$f7e8a0bf92324b1e, (v) => $4433d39f12c5883f$export$f7e8a0bf92324b1e = v);
$parcel$export(module.exports, "version", () => $4433d39f12c5883f$export$83d89fbfd8236492, (v) => $4433d39f12c5883f$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $4433d39f12c5883f$export$69ce8ef3fe5cead0;
var $4433d39f12c5883f$export$3f2684e5d7cb1006;
var $4433d39f12c5883f$export$d39a5bbd09211389;
var $4433d39f12c5883f$export$cd75ccfd720a3cd4;
var $4433d39f12c5883f$export$a0816fa17a9e79be;
var $4433d39f12c5883f$export$7292efcadded39f3;
var $4433d39f12c5883f$export$da407abadb9b8f86;
var $4433d39f12c5883f$export$314cfea32580671c;
var $4433d39f12c5883f$export$513ccb98c53b8039;
var $4433d39f12c5883f$export$dbca993bc2d264a;
var $4433d39f12c5883f$export$4797a8006f0655d0;
var $4433d39f12c5883f$export$c78a37762a8d58e1;
var $4433d39f12c5883f$export$606f11b2eb45ecc6;
var $4433d39f12c5883f$export$f7e8a0bf92324b1e;
var $4433d39f12c5883f$export$83d89fbfd8236492;
"use strict";

var $acw62 = parcelRequire("acw62");
function $4433d39f12c5883f$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function $4433d39f12c5883f$var$noop() {}
var $4433d39f12c5883f$var$Internals = {
    d: {
        f: $4433d39f12c5883f$var$noop,
        r: function() {
            throw Error($4433d39f12c5883f$var$formatProdErrorMessage(522));
        },
        D: $4433d39f12c5883f$var$noop,
        C: $4433d39f12c5883f$var$noop,
        L: $4433d39f12c5883f$var$noop,
        m: $4433d39f12c5883f$var$noop,
        X: $4433d39f12c5883f$var$noop,
        S: $4433d39f12c5883f$var$noop,
        M: $4433d39f12c5883f$var$noop
    },
    p: 0,
    findDOMNode: null
}, $4433d39f12c5883f$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $4433d39f12c5883f$var$REACT_RECOVERABLE_TYPE = Symbol.for("react.recoverable"), $4433d39f12c5883f$var$REACT_OPTIMISTIC_KEY = Symbol.for("react.optimistic_key");
function $4433d39f12c5883f$var$createPortal$1(children, containerInfo, implementation) {
    var key = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $4433d39f12c5883f$var$REACT_PORTAL_TYPE,
        key: null == key ? null : key === $4433d39f12c5883f$var$REACT_OPTIMISTIC_KEY ? $4433d39f12c5883f$var$REACT_OPTIMISTIC_KEY : "" + key,
        children: children,
        containerInfo: containerInfo,
        implementation: implementation
    };
}
var $4433d39f12c5883f$var$ReactSharedInternals = $acw62.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE;
function $4433d39f12c5883f$var$getCrossOriginStringAs(as, input) {
    if ("font" === as) return "";
    if ("string" === typeof input) return "use-credentials" === input ? input : "";
}
$4433d39f12c5883f$export$69ce8ef3fe5cead0 = $4433d39f12c5883f$var$Internals;
$4433d39f12c5883f$export$3f2684e5d7cb1006 = function(reason) {
    return {
        $$typeof: $4433d39f12c5883f$var$REACT_RECOVERABLE_TYPE,
        _reason: reason
    };
};
$4433d39f12c5883f$export$d39a5bbd09211389 = function(children, container) {
    var key = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!container || 1 !== container.nodeType && 9 !== container.nodeType && 11 !== container.nodeType) throw Error($4433d39f12c5883f$var$formatProdErrorMessage(299));
    return $4433d39f12c5883f$var$createPortal$1(children, container, null, key);
};
$4433d39f12c5883f$export$cd75ccfd720a3cd4 = function(fn) {
    var previousTransition = $4433d39f12c5883f$var$ReactSharedInternals.T, previousUpdatePriority = $4433d39f12c5883f$var$Internals.p;
    try {
        if ($4433d39f12c5883f$var$ReactSharedInternals.T = null, $4433d39f12c5883f$var$Internals.p = 2, fn) return fn();
    } finally{
        $4433d39f12c5883f$var$ReactSharedInternals.T = previousTransition, $4433d39f12c5883f$var$Internals.p = previousUpdatePriority, $4433d39f12c5883f$var$Internals.d.f();
    }
};
$4433d39f12c5883f$export$a0816fa17a9e79be = function(href, options) {
    "string" === typeof href && (options ? (options = options.crossOrigin, options = "string" === typeof options ? "use-credentials" === options ? options : "" : void 0) : options = null, $4433d39f12c5883f$var$Internals.d.C(href, options));
};
$4433d39f12c5883f$export$7292efcadded39f3 = function(href) {
    "string" === typeof href && $4433d39f12c5883f$var$Internals.d.D(href);
};
$4433d39f12c5883f$export$da407abadb9b8f86 = function(href, options) {
    if ("string" === typeof href && options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = $4433d39f12c5883f$var$getCrossOriginStringAs(as, options.crossOrigin), integrity = "string" === typeof options.integrity ? options.integrity : void 0, fetchPriority = "string" === typeof options.fetchPriority ? options.fetchPriority : void 0;
        "style" === as ? $4433d39f12c5883f$var$Internals.d.S(href, "string" === typeof options.precedence ? options.precedence : void 0, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority
        }) : "script" === as && $4433d39f12c5883f$var$Internals.d.X(href, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0
        });
    }
};
$4433d39f12c5883f$export$314cfea32580671c = function(href, options) {
    if ("string" === typeof href) {
        if ("object" === typeof options && null !== options) {
            if (null == options.as || "script" === options.as) {
                var crossOrigin = $4433d39f12c5883f$var$getCrossOriginStringAs(options.as, options.crossOrigin);
                $4433d39f12c5883f$var$Internals.d.M(href, {
                    crossOrigin: crossOrigin,
                    integrity: "string" === typeof options.integrity ? options.integrity : void 0,
                    nonce: "string" === typeof options.nonce ? options.nonce : void 0,
                    fetchPriority: "string" === typeof options.fetchPriority ? options.fetchPriority : void 0
                });
            }
        } else null == options && $4433d39f12c5883f$var$Internals.d.M(href);
    }
};
$4433d39f12c5883f$export$513ccb98c53b8039 = function(href, options) {
    if ("string" === typeof href && "object" === typeof options && null !== options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = $4433d39f12c5883f$var$getCrossOriginStringAs(as, options.crossOrigin);
        $4433d39f12c5883f$var$Internals.d.L(href, as, {
            crossOrigin: crossOrigin,
            integrity: "string" === typeof options.integrity ? options.integrity : void 0,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0,
            type: "string" === typeof options.type ? options.type : void 0,
            fetchPriority: "string" === typeof options.fetchPriority ? options.fetchPriority : void 0,
            referrerPolicy: "string" === typeof options.referrerPolicy ? options.referrerPolicy : void 0,
            imageSrcSet: "string" === typeof options.imageSrcSet ? options.imageSrcSet : void 0,
            imageSizes: "string" === typeof options.imageSizes ? options.imageSizes : void 0,
            media: "string" === typeof options.media ? options.media : void 0
        });
    }
};
$4433d39f12c5883f$export$dbca993bc2d264a = function(href, options) {
    if ("string" === typeof href) {
        if (options) {
            var crossOrigin = $4433d39f12c5883f$var$getCrossOriginStringAs(options.as, options.crossOrigin);
            $4433d39f12c5883f$var$Internals.d.m(href, {
                as: "string" === typeof options.as && "script" !== options.as ? options.as : void 0,
                crossOrigin: crossOrigin,
                integrity: "string" === typeof options.integrity ? options.integrity : void 0,
                nonce: "string" === typeof options.nonce ? options.nonce : void 0,
                fetchPriority: "string" === typeof options.fetchPriority ? options.fetchPriority : void 0
            });
        } else $4433d39f12c5883f$var$Internals.d.m(href);
    }
};
$4433d39f12c5883f$export$4797a8006f0655d0 = function(form) {
    $4433d39f12c5883f$var$Internals.d.r(form);
};
$4433d39f12c5883f$export$c78a37762a8d58e1 = function(fn, a) {
    return fn(a);
};
$4433d39f12c5883f$export$606f11b2eb45ecc6 = function(action, initialState, permalink) {
    return $4433d39f12c5883f$var$ReactSharedInternals.H.useFormState(action, initialState, permalink);
};
$4433d39f12c5883f$export$f7e8a0bf92324b1e = function() {
    return $4433d39f12c5883f$var$ReactSharedInternals.H.useHostTransitionStatus();
};
$4433d39f12c5883f$export$83d89fbfd8236492 = "19.3.1";

});



var $7b02d682eb115277$exports = {};
'use strict';

$7b02d682eb115277$exports = (parcelRequire("8rWe0"));


var $7e96a608cb33bf79$exports = {};
'use strict';
function $7e96a608cb33bf79$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($7e96a608cb33bf79$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$7e96a608cb33bf79$var$checkDCE();

$7e96a608cb33bf79$exports = (parcelRequire("iWoMt"));


var $14d120258bb760db$export$711302eb3e721627;
$14d120258bb760db$export$711302eb3e721627 = `WnT_GG_containerHome`;




var $acw62 = parcelRequire("acw62");
/* empty css             */ parcelRequire("acw62");

//#region src/components/icones/svg/barra-accions/comenta.svg?react
var $973b9146f3756d1c$export$2e2bcd8739ae039 = (t)=>/* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...t,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M20 17.17L18.83 16H4V4H20V17.17ZM20 2H4C2.9 2 2 2.9 2 4V16C2 17.1 2.9 18 4 18H18L22 22V4C22 2.9 21.1 2 20 2Z",
            fill: "currentColor"
        })
    });


parcelRequire("acw62");

//#region src/components/icones/svg/barra-accions/comparteix.svg?react
var $5f88a93f63a76718$export$2e2bcd8739ae039 = (t)=>/* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...t,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M18 16.08C17.24 16.08 16.56 16.38 16.04 16.85L8.91 12.7C8.96 12.47 9 12.24 9 12C9 11.76 8.96 11.53 8.91 11.3L15.96 7.19C16.5 7.69 17.21 8 18 8C19.66 8 21 6.66 21 5C21 3.34 19.66 2 18 2C16.34 2 15 3.34 15 5C15 5.24 15.04 5.47 15.09 5.7L8.04 9.81C7.5 9.31 6.79 9 6 9C4.34 9 3 10.34 3 12C3 13.66 4.34 15 6 15C6.79 15 7.5 14.69 8.04 14.19L15.16 18.35C15.11 18.56 15.08 18.78 15.08 19C15.08 20.61 16.39 21.92 18 21.92C19.61 21.92 20.92 20.61 20.92 19C20.92 17.39 19.61 16.08 18 16.08ZM18 4C18.55 4 19 4.45 19 5C19 5.55 18.55 6 18 6C17.45 6 17 5.55 17 5C17 4.45 17.45 4 18 4ZM6 13C5.45 13 5 12.55 5 12C5 11.45 5.45 11 6 11C6.55 11 7 11.45 7 12C7 12.55 6.55 13 6 13ZM18 20.02C17.45 20.02 17 19.57 17 19.02C17 18.47 17.45 18.02 18 18.02C18.55 18.02 19 18.47 19 19.02C19 19.57 18.55 20.02 18 20.02Z",
            fill: "currentColor"
        })
    });


parcelRequire("acw62");

//#region src/components/icones/svg/barra-accions/concurrents.svg?react
var $a934b4450e4f1b04$export$2e2bcd8739ae039 = (t)=>/* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...t,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M9 13.75C6.66 13.75 2 14.92 2 17.25V19H16V17.25C16 14.92 11.34 13.75 9 13.75ZM4.34 17C5.18 16.42 7.21 15.75 9 15.75C10.79 15.75 12.82 16.42 13.66 17H4.34ZM9 12C10.93 12 12.5 10.43 12.5 8.5C12.5 6.57 10.93 5 9 5C7.07 5 5.5 6.57 5.5 8.5C5.5 10.43 7.07 12 9 12ZM9 7C9.83 7 10.5 7.67 10.5 8.5C10.5 9.33 9.83 10 9 10C8.17 10 7.5 9.33 7.5 8.5C7.5 7.67 8.17 7 9 7ZM16.04 13.81C17.2 14.65 18 15.77 18 17.25V19H22V17.25C22 15.23 18.5 14.08 16.04 13.81ZM15 12C16.93 12 18.5 10.43 18.5 8.5C18.5 6.57 16.93 5 15 5C14.46 5 13.96 5.13 13.5 5.35C14.13 6.24 14.5 7.33 14.5 8.5C14.5 9.67 14.13 10.76 13.5 11.65C13.96 11.87 14.46 12 15 12Z",
            fill: "currentColor"
        })
    });


parcelRequire("acw62");

//#region src/components/icones/svg/barra-accions/guarda.svg?react
var $b42a738766dcbe21$export$2e2bcd8739ae039 = (t)=>/* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...t,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M17 3H7C5.9 3 5 3.9 5 5V21L12 18L19 21V5C19 3.9 18.1 3 17 3ZM17 18L12 15.82L7 18V5H17V18Z",
            fill: "currentColor"
        })
    });


parcelRequire("acw62");

//#region src/components/icones/svg/barra-accions/guardats-ple.svg?react
var $d9dcd8600386b8b0$export$2e2bcd8739ae039 = (t)=>/* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...t,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M17 3H7C5.9 3 5 3.9 5 5V21L12 18L19 21V5C19 3.9 18.1 3 17 3Z",
            fill: "currentColor"
        })
    });


parcelRequire("acw62");

//#region src/components/icones/svg/barra-accions/imatges-fotogaleria.svg?react
var $8e31e2f62c4708a1$export$2e2bcd8739ae039 = (t)=>/* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...t,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M20 4V16H8V4H20ZM20 2H8C6.9 2 6 2.9 6 4V16C6 17.1 6.9 18 8 18H20C21.1 18 22 17.1 22 16V4C22 2.9 21.1 2 20 2ZM11.5 11.67L13.19 13.93L15.67 10.83L19 15H9L11.5 11.67ZM2 6V20C2 21.1 2.9 22 4 22H18V20H4V6H2Z",
            fill: "currentColor"
        })
    });


parcelRequire("acw62");

//#region src/components/icones/svg/barra-accions/like.svg?react
var $b0e35be5ed982988$export$2e2bcd8739ae039 = (t)=>/* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...t,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M16.5 3C14.76 3 13.09 3.81 12 5.09C10.91 3.81 9.24 3 7.5 3C4.42 3 2 5.42 2 8.5C2 12.28 5.4 15.36 10.55 20.04L12 21.35L13.45 20.03C18.6 15.36 22 12.28 22 8.5C22 5.42 19.58 3 16.5 3ZM12.1 18.55L12 18.65L11.9 18.55C7.14 14.24 4 11.39 4 8.5C4 6.5 5.5 5 7.5 5C9.04 5 10.54 5.99 11.07 7.36H12.94C13.46 5.99 14.96 5 16.5 5C18.5 5 20 6.5 20 8.5C20 11.39 16.86 14.24 12.1 18.55Z",
            fill: "currentColor"
        })
    });


parcelRequire("acw62");

//#region src/components/icones/svg/barra-accions/regala.svg?react
var $13d59f9cadebb796$export$2e2bcd8739ae039 = (t)=>/* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...t,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M20 6H17.82C17.93 5.69 18 5.35 18 5C18 3.34 16.66 2 15 2C13.95 2 13.04 2.54 12.5 3.35L12 4.02L11.5 3.34C10.96 2.54 10.05 2 9 2C7.34 2 6 3.34 6 5C6 5.35 6.07 5.69 6.18 6H4C2.89 6 2.01 6.89 2.01 8L2 19C2 20.11 2.89 21 4 21H20C21.11 21 22 20.11 22 19V8C22 6.89 21.11 6 20 6ZM15 4C15.55 4 16 4.45 16 5C16 5.55 15.55 6 15 6C14.45 6 14 5.55 14 5C14 4.45 14.45 4 15 4ZM9 4C9.55 4 10 4.45 10 5C10 5.55 9.55 6 9 6C8.45 6 8 5.55 8 5C8 4.45 8.45 4 9 4ZM20 19H4V17H20V19ZM20 14H4V8H9.08L7 10.83L8.62 12L12 7.4L15.38 12L17 10.83L14.92 8H20V14Z",
            fill: "currentColor"
        })
    });


parcelRequire("acw62");

//#region src/components/icones/svg/barra-accions/temps-lectura.svg?react
var $780f851f62e41878$export$2e2bcd8739ae039 = (t)=>/* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...t,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M15 1H9V3H15V1ZM11 14H13V8H11V14ZM19.03 7.39L20.45 5.97C20.02 5.46 19.55 4.98 19.04 4.56L17.62 5.98C16.07 4.74 14.12 4 12 4C7.03 4 3 8.03 3 13C3 17.97 7.02 22 12 22C16.98 22 21 17.97 21 13C21 10.88 20.26 8.93 19.03 7.39ZM12 20C8.13 20 5 16.87 5 13C5 9.13 8.13 6 12 6C15.87 6 19 9.13 19 13C19 16.87 15.87 20 12 20Z",
            fill: "currentColor"
        })
    });


parcelRequire("acw62");

//#region src/components/icones/svg/boto-txt/add.svg?react
var $2dd5a364d1134466$export$2e2bcd8739ae039 = (t)=>/* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...t,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M19 13H13V19H11V13H5V11H11V5H13V11H19V13Z",
            fill: "currentColor"
        })
    });


parcelRequire("acw62");

//#region src/components/icones/svg/boto-txt/check.svg?react
var $976f59050c045dcc$export$2e2bcd8739ae039 = (t)=>/* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...t,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M9 16.17L4.83 12L3.41 13.41L9 19L21 7.00003L19.59 5.59003L9 16.17Z",
            fill: "currentColor"
        })
    });


parcelRequire("acw62");

//#region src/components/icones/svg/comentaris/deixa-de-seguir.svg?react
var $4a263096607b5985$export$2e2bcd8739ae039 = (t)=>/* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...t,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M16 11V9H22V11H16ZM9 12C7.9 12 6.95833 11.6083 6.175 10.825C5.39167 10.0417 5 9.1 5 8C5 6.9 5.39167 5.95833 6.175 5.175C6.95833 4.39167 7.9 4 9 4C10.1 4 11.0417 4.39167 11.825 5.175C12.6083 5.95833 13 6.9 13 8C13 9.1 12.6083 10.0417 11.825 10.825C11.0417 11.6083 10.1 12 9 12ZM1 20V17.2C1 16.6333 1.146 16.1123 1.438 15.637C1.72933 15.1623 2.11667 14.8 2.6 14.55C3.63333 14.0333 4.68333 13.6457 5.75 13.387C6.81667 13.129 7.9 13 9 13C10.1 13 11.1833 13.129 12.25 13.387C13.3167 13.6457 14.3667 14.0333 15.4 14.55C15.8833 14.8 16.2707 15.1623 16.562 15.637C16.854 16.1123 17 16.6333 17 17.2V20H1ZM3 18H15V17.2C15 17.0167 14.9543 16.85 14.863 16.7C14.771 16.55 14.65 16.4333 14.5 16.35C13.6 15.9 12.6917 15.5623 11.775 15.337C10.8583 15.1123 9.93333 15 9 15C8.06667 15 7.14167 15.1123 6.225 15.337C5.30833 15.5623 4.4 15.9 3.5 16.35C3.35 16.4333 3.22933 16.55 3.138 16.7C3.046 16.85 3 17.0167 3 17.2V18ZM9 10C9.55 10 10.021 9.804 10.413 9.412C10.8043 9.02067 11 8.55 11 8C11 7.45 10.8043 6.97933 10.413 6.588C10.021 6.196 9.55 6 9 6C8.45 6 7.97933 6.196 7.588 6.588C7.196 6.97933 7 7.45 7 8C7 8.55 7.196 9.02067 7.588 9.412C7.97933 9.804 8.45 10 9 10Z",
            fill: "currentColor"
        })
    });


parcelRequire("acw62");

//#region src/components/icones/svg/comentaris/denuncia.svg?react
var $5f974cc1d9e54f23$export$2e2bcd8739ae039 = (t)=>/* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...t,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M8 13V22H6V4C6 3.71667 6.09583 3.47917 6.2875 3.2875C6.47917 3.09583 6.71667 3 7 3H20.525C20.7083 3 20.8708 3.04167 21.0125 3.125C21.1542 3.20833 21.2667 3.31667 21.35 3.45C21.4333 3.58333 21.4875 3.72917 21.5125 3.8875C21.5375 4.04583 21.5167 4.20833 21.45 4.375L20 8L21.45 11.625C21.5167 11.7917 21.5375 11.9542 21.5125 12.1125C21.4875 12.2708 21.4333 12.4167 21.35 12.55C21.2667 12.6833 21.1542 12.7917 21.0125 12.875C20.8708 12.9583 20.7083 13 20.525 13H8ZM8 11H19.05L18.15 8.75C18.05 8.51667 18 8.26667 18 8C18 7.73333 18.05 7.48333 18.15 7.25L19.05 5H8V11Z",
            fill: "currentColor"
        })
    });


parcelRequire("acw62");

//#region src/components/icones/svg/comentaris/denunciat.svg?react
var $74805a3475ea0dae$export$2e2bcd8739ae039 = (t)=>/* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...t,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M7 13V22H5V4C5 3.71667 5.09583 3.47917 5.2875 3.2875C5.47917 3.09583 5.71667 3 6 3H19.525C19.7083 3 19.8708 3.04167 20.0125 3.125C20.1542 3.20833 20.2667 3.31667 20.35 3.45C20.4333 3.58333 20.4875 3.72917 20.5125 3.8875C20.5375 4.04583 20.5167 4.20833 20.45 4.375L19 8L20.45 11.625C20.5167 11.7917 20.5375 11.9542 20.5125 12.1125C20.4875 12.2708 20.4333 12.4167 20.35 12.55C20.2667 12.6833 20.1542 12.7917 20.0125 12.875C19.8708 12.9583 19.7083 13 19.525 13H7Z",
            fill: "currentColor"
        })
    });


parcelRequire("acw62");

//#region src/components/icones/svg/comentaris/desilencia.svg?react
var $f0c513577aab84b3$export$2e2bcd8739ae039 = (t)=>/* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...t,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M12 6.5C15.79 6.5 19.17 8.63 20.82 12C19.17 15.37 15.8 17.5 12 17.5C8.2 17.5 4.83 15.37 3.18 12C4.83 8.63 8.21 6.5 12 6.5ZM12 4.5C7 4.5 2.73 7.61 1 12C2.73 16.39 7 19.5 12 19.5C17 19.5 21.27 16.39 23 12C21.27 7.61 17 4.5 12 4.5ZM12 9.5C13.38 9.5 14.5 10.62 14.5 12C14.5 13.38 13.38 14.5 12 14.5C10.62 14.5 9.5 13.38 9.5 12C9.5 10.62 10.62 9.5 12 9.5ZM12 7.5C9.52 7.5 7.5 9.52 7.5 12C7.5 14.48 9.52 16.5 12 16.5C14.48 16.5 16.5 14.48 16.5 12C16.5 9.52 14.48 7.5 12 7.5Z",
            fill: "currentColor"
        })
    });


parcelRequire("acw62");

//#region src/components/icones/svg/comentaris/mes.svg?react
var $9760da9b9ac82366$export$2e2bcd8739ae039 = (t)=>/* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...t,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M20 6C20 4.9 19.1 4 18 4C16.9 4 16 4.9 16 6C16 7.1 16.9 8 18 8C19.1 8 20 7.1 20 6ZM20 18C20 16.9 19.1 16 18 16C16.9 16 16 16.9 16 18C16 19.1 16.9 20 18 20C19.1 20 20 19.1 20 18ZM20 12C20 10.9 19.1 10 18 10C16.9 10 16 10.9 16 12C16 13.1 16.9 14 18 14C19.1 14 20 13.1 20 12Z",
            fill: "currentColor"
        })
    });


parcelRequire("acw62");

//#region src/components/icones/svg/comentaris/perfil.svg?react
var $aff3cdd86f90c051$export$2e2bcd8739ae039 = (n)=>/* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...n,
        children: [
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM7.35 18.5C8.66 17.56 10.26 17 12 17C13.74 17 15.34 17.56 16.65 18.5C15.34 19.44 13.74 20 12 20C10.26 20 8.66 19.44 7.35 18.5ZM18.14 17.12C16.45 15.8 14.32 15 12 15C9.68 15 7.55 15.8 5.86 17.12C4.7 15.73 4 13.95 4 12C4 7.58 7.58 4 12 4C16.42 4 20 7.58 20 12C20 13.95 19.3 15.73 18.14 17.12Z",
                fill: "currentColor"
            }),
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M12 6C10.07 6 8.5 7.57 8.5 9.5C8.5 11.43 10.07 13 12 13C13.93 13 15.5 11.43 15.5 9.5C15.5 7.57 13.93 6 12 6ZM12 11C11.17 11 10.5 10.33 10.5 9.5C10.5 8.67 11.17 8 12 8C12.83 8 13.5 8.67 13.5 9.5C13.5 10.33 12.83 11 12 11Z",
                fill: "currentColor"
            })
        ]
    });


parcelRequire("acw62");

//#region src/components/icones/svg/comentaris/respon.svg?react
var $43aa37dba422056f$export$2e2bcd8739ae039 = (t)=>/* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...t,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M15 4V11H5.17L4 12.17V4H15ZM16 2H3C2.45 2 2 2.45 2 3V17L6 13H16C16.55 13 17 12.55 17 12V3C17 2.45 16.55 2 16 2ZM21 6H19V15H6V17C6 17.55 6.45 18 7 18H18L22 22V7C22 6.45 21.55 6 21 6Z",
            fill: "currentColor"
        })
    });


parcelRequire("acw62");

//#region src/components/icones/svg/comentaris/segueix.svg?react
var $dfdd4fd7d559275a$export$2e2bcd8739ae039 = (t)=>/* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...t,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M20 9V6H18V9H15V11H18V14H20V11H23V9H20ZM9 12C11.21 12 13 10.21 13 8C13 5.79 11.21 4 9 4C6.79 4 5 5.79 5 8C5 10.21 6.79 12 9 12ZM9 6C10.1 6 11 6.9 11 8C11 9.1 10.1 10 9 10C7.9 10 7 9.1 7 8C7 6.9 7.9 6 9 6ZM15.39 14.56C13.71 13.7 11.53 13 9 13C6.47 13 4.29 13.7 2.61 14.56C1.61 15.07 1 16.1 1 17.22V20H17V17.22C17 16.1 16.39 15.07 15.39 14.56ZM15 18H3V17.22C3 16.84 3.2 16.5 3.52 16.34C4.71 15.73 6.63 15 9 15C11.37 15 13.29 15.73 14.48 16.34C14.8 16.5 15 16.84 15 17.22V18Z",
            fill: "currentColor"
        })
    });


parcelRequire("acw62");

//#region src/components/icones/svg/comentaris/silencia.svg?react
var $60745f8ce6d17b27$export$2e2bcd8739ae039 = (t)=>/* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...t,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M12 5.99995C15.79 5.99995 19.17 8.12995 20.82 11.5C20.23 12.72 19.4 13.77 18.41 14.62L19.82 16.03C21.21 14.8 22.31 13.26 23 11.5C21.27 7.10995 17 3.99995 12 3.99995C10.73 3.99995 9.51 4.19995 8.36 4.56995L10.01 6.21995C10.66 6.08995 11.32 5.99995 12 5.99995ZM10.93 7.13995L13 9.20995C13.57 9.45995 14.03 9.91995 14.28 10.49L16.35 12.56C16.43 12.22 16.49 11.86 16.49 11.49C16.5 9.00995 14.48 6.99995 12 6.99995C11.63 6.99995 11.28 7.04995 10.93 7.13995ZM2.01 3.86995L4.69 6.54995C3.06 7.82995 1.77 9.52995 1 11.5C2.73 15.89 7 19 12 19C13.52 19 14.98 18.71 16.32 18.18L19.74 21.6L21.15 20.19L3.42 2.44995L2.01 3.86995ZM9.51 11.37L12.12 13.98C12.08 13.99 12.04 14 12 14C10.62 14 9.5 12.88 9.5 11.5C9.5 11.45 9.51 11.42 9.51 11.37ZM6.11 7.96995L7.86 9.71995C7.63 10.27 7.5 10.87 7.5 11.5C7.5 13.98 9.52 16 12 16C12.63 16 13.23 15.87 13.77 15.64L14.75 16.62C13.87 16.86 12.95 17 12 17C8.21 17 4.83 14.87 3.18 11.5C3.88 10.07 4.9 8.88995 6.11 7.96995Z",
            fill: "currentColor"
        })
    });


parcelRequire("acw62");

//#region src/components/icones/svg/menu/descobreix.svg?react
var $28d48aa2b07e9769$export$2e2bcd8739ae039 = (t)=>/* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...t,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20ZM6.5 17.5L14.01 14.01L17.5 6.5L9.99 9.99L6.5 17.5ZM12 10.9C12.61 10.9 13.1 11.39 13.1 12C13.1 12.61 12.61 13.1 12 13.1C11.39 13.1 10.9 12.61 10.9 12C10.9 11.39 11.39 10.9 12 10.9Z",
            fill: "currentColor"
        })
    });


parcelRequire("acw62");

//#region src/components/icones/svg/menu/jocs.svg?react
var $4133bb805d61a9b6$export$2e2bcd8739ae039 = (t)=>/* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...t,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M10 13C10.5523 13 11 13.4477 11 14V21L10.9951 21.1025C10.9472 21.573 10.573 21.9472 10.1025 21.9951L10 22C5.58172 22 2 18.4183 2 14C2 13.4477 2.44772 13 3 13H10ZM21 13C21.5523 13 22 13.4477 22 14C22 18.4183 18.4183 22 14 22L13.8975 21.9951C13.427 21.9472 13.0528 21.573 13.0049 21.1025L13 21V14C13 13.4477 13.4477 13 14 13H21ZM4.08496 15C4.50658 17.5122 6.48776 19.4934 9 19.915V15H4.08496ZM15 19.915C17.5122 19.4934 19.4934 17.5122 19.915 15H15V19.915ZM21 2C21.5523 2 22 2.44772 22 3V10C22 10.5177 21.6067 10.9438 21.1025 10.9951L21 11H14L13.8975 10.9951C13.427 10.9472 13.0528 10.573 13.0049 10.1025L13 10V3C13 2.44772 13.4477 2 14 2H21ZM15 9H20V4H15V9Z",
            fill: "currentColor"
        })
    });


parcelRequire("acw62");

//#region src/components/icones/svg/menu/log-out.svg?react
var $5c2005a21d543783$export$2e2bcd8739ae039 = (t)=>/* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...t,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M12 5.9C13.16 5.9 14.1 6.84 14.1 8C14.1 9.16 13.16 10.1 12 10.1C10.84 10.1 9.9 9.16 9.9 8C9.9 6.84 10.84 5.9 12 5.9ZM12 14.9C14.97 14.9 18.1 16.36 18.1 17V18.1H5.9V17C5.9 16.36 9.03 14.9 12 14.9ZM12 4C9.79 4 8 5.79 8 8C8 10.21 9.79 12 12 12C14.21 12 16 10.21 16 8C16 5.79 14.21 4 12 4ZM12 13C9.33 13 4 14.34 4 17V20H20V17C20 14.34 14.67 13 12 13Z",
            fill: "currentColor"
        })
    });


parcelRequire("acw62");

//#region src/components/icones/svg/menu/logo.svg?react
var $b5f3dfa39a516548$export$2e2bcd8739ae039 = (t)=>/* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...t,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M1 16.8757C1 15.2365 1.97959 13.3514 3.73469 12.3679C6.71429 10.7697 11.449 11.1795 13.2041 10.7287V6.91759C13.2041 4.04899 12.3469 2.86058 10.2653 2.86058C9.16327 2.86058 8.14286 3.14744 7.40816 3.6392C8.22449 4.37683 8.59184 5.15545 8.59184 6.17995C8.59184 8.14698 7.4898 9.29442 5.36735 9.29442C3.57143 9.29442 2.14286 7.94208 2.14286 6.22093C2.22449 3.59822 4.87755 2 11.4082 2C16.9592 2 19.6939 4.04899 19.6939 8.96658V18.0641C19.6939 20.1541 20.551 20.6049 22.7551 19.6213L23 20.0721C21.4082 21.2196 19.9796 21.9572 18.1837 21.9572C15.2857 21.9572 14.0612 20.8507 13.6122 18.7198H13.449C11.9796 20.4 10.0204 21.9982 7.12245 21.9982C2.87755 22.0801 1 19.3755 1 16.8757ZM13.2041 17.9002V11.5483C8.95918 11.9991 7.85714 13.0646 7.85714 16.22C7.85714 18.228 8.91837 19.4574 10.551 19.4574C11.6122 19.4574 12.6735 18.8018 13.2041 17.9002Z",
            fill: "currentColor"
        })
    });


parcelRequire("acw62");

//#region src/components/icones/svg/menu/seccions.svg?react
var $fab4f43b6e677d91$export$2e2bcd8739ae039 = (t)=>/* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...t,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M3 18H21V16H3V18ZM3 13H21V11H3V13ZM3 6V8H21V6H3Z",
            fill: "currentColor"
        })
    });


parcelRequire("acw62");

//#region src/components/icones/svg/menu/ultima-hora-actiu.svg?react
var $f6eabb0c0a522dba$export$2e2bcd8739ae039 = (n)=>/* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...n,
        children: [
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M11.99 2C6.47 2 2 6.48 2 12C2 17.52 6.47 22 11.99 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 11.99 2ZM12 20C7.58 20 4 16.42 4 12C4 7.58 7.58 4 12 4C16.42 4 20 7.58 20 12C20 16.42 16.42 20 12 20ZM12.5 7H11V13L16.25 16.15L17 14.92L12.5 12.25V7Z",
                fill: "currentColor"
            }),
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("circle", {
                cx: 20,
                cy: 4,
                r: 3,
                fill: "#ED4600"
            })
        ]
    });


parcelRequire("acw62");

//#region src/components/icones/svg/menu/ultima-hora.svg?react
var $222b30207139f37f$export$2e2bcd8739ae039 = (t)=>/* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...t,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M11.99 2C6.47 2 2 6.48 2 12C2 17.52 6.47 22 11.99 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 11.99 2ZM12 20C7.58 20 4 16.42 4 12C4 7.58 7.58 4 12 4C16.42 4 20 7.58 20 12C20 16.42 16.42 20 12 20ZM12.5 7H11V13L16.25 16.15L17 14.92L12.5 12.25V7Z",
            fill: "currentColor"
        })
    });


parcelRequire("acw62");

//#region src/components/icones/svg/multimedia/arxius.svg?react
var $59ad0c9d4550fcdb$export$2e2bcd8739ae039 = (t)=>/* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...t,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M9.17 6L11.17 8H20V18H4V6H9.17ZM10 4H4C2.9 4 2.01 4.9 2.01 6L2 18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V8C22 6.9 21.1 6 20 6H12L10 4Z",
            fill: "currentColor"
        })
    });


parcelRequire("acw62");

//#region src/components/icones/svg/multimedia/audio.svg?react
var $335d7c4c5baec0b1$export$2e2bcd8739ae039 = (t)=>/* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...t,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M19 14V17C19 17.55 18.55 18 18 18H17V14H19ZM7 14V18H6C5.45 18 5 17.55 5 17V14H7ZM12 1C7.03 1 3 5.03 3 10V17C3 18.66 4.34 20 6 20H9V12H5V10C5 6.13 8.13 3 12 3C15.87 3 19 6.13 19 10V12H15V20H18C19.66 20 21 18.66 21 17V10C21 5.03 16.97 1 12 1Z",
            fill: "currentColor"
        })
    });


parcelRequire("acw62");

//#region src/components/icones/svg/multimedia/enquesta.svg?react
var $a37fd0b4b334c538$export$2e2bcd8739ae039 = (t)=>/* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...t,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M5 9.2H8V19H5V9.2ZM10.6 5H13.4V19H10.6V5ZM16.2 13H19V19H16.2V13Z",
            fill: "currentColor"
        })
    });


parcelRequire("acw62");

//#region src/components/icones/svg/multimedia/fotogaleria.svg?react
var $32dbb89a6b5d1502$export$2e2bcd8739ae039 = (t)=>/* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...t,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M20 4V16H8V4H20ZM20 2H8C6.9 2 6 2.9 6 4V16C6 17.1 6.9 18 8 18H20C21.1 18 22 17.1 22 16V4C22 2.9 21.1 2 20 2ZM11.5 11.67L13.19 13.93L15.67 10.83L19 15H9L11.5 11.67ZM2 6V20C2 21.1 2.9 22 4 22H18V20H4V6H2Z",
            fill: "currentColor"
        })
    });


parcelRequire("acw62");

//#region src/components/icones/svg/multimedia/grafic.svg?react
var $684f6b28345da2ee$export$2e2bcd8739ae039 = (t)=>/* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...t,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M23 8C23 9.1 22.1 10 21 10C20.82 10 20.65 9.98 20.49 9.93L16.93 13.48C16.98 13.64 17 13.82 17 14C17 15.1 16.1 16 15 16C13.9 16 13 15.1 13 14C13 13.82 13.02 13.64 13.07 13.48L10.52 10.93C10.36 10.98 10.18 11 10 11C9.82 11 9.64 10.98 9.48 10.93L4.93 15.49C4.98 15.65 5 15.82 5 16C5 17.1 4.1 18 3 18C1.9 18 1 17.1 1 16C1 14.9 1.9 14 3 14C3.18 14 3.35 14.02 3.51 14.07L8.07 9.52C8.02 9.36 8 9.18 8 9C8 7.9 8.9 7 10 7C11.1 7 12 7.9 12 9C12 9.18 11.98 9.36 11.93 9.52L14.48 12.07C14.64 12.02 14.82 12 15 12C15.18 12 15.36 12.02 15.52 12.07L19.07 8.51C19.02 8.35 19 8.18 19 8C19 6.9 19.9 6 21 6C22.1 6 23 6.9 23 8Z",
            fill: "currentColor"
        })
    });


parcelRequire("acw62");

//#region src/components/icones/svg/multimedia/interactiu.svg?react
var $fbb3b8577f5677f1$export$2e2bcd8739ae039 = (t)=>/* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...t,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M18.19 12.44L14.95 10.82C16.24 9.82 17.07 8.26 17.07 6.5C17.07 3.47 14.6 1 11.57 1C8.54 1 6.07 3.47 6.07 6.5C6.07 8.63 7.29 10.48 9.07 11.39V14.65C6.92 14.19 7.05 14.21 6.81 14.21C6.28 14.21 5.78 14.42 5.4 14.8L4 16.22L9.09 21.31C9.52 21.75 10.12 22 10.74 22H17.04C18.02 22 18.85 21.3 19.01 20.33L19.81 15.62C20.03 14.32 19.38 13.04 18.19 12.44ZM17.84 15.29L17.04 20H10.74C10.65 20 10.57 19.96 10.5 19.9L6.82 16.22L11.07 17.11V6.5C11.07 6.22 11.29 6 11.57 6C11.85 6 12.07 6.22 12.07 6.5V12.5H13.83L17.29 14.23C17.69 14.43 17.91 14.86 17.84 15.29ZM8.07 6.5C8.07 4.57 9.64 3 11.57 3C13.5 3 15.07 4.57 15.07 6.5C15.07 7.45 14.69 8.31 14.07 8.94V6.5C14.07 5.12 12.95 4 11.57 4C10.19 4 9.07 5.12 9.07 6.5V8.94C8.45 8.31 8.07 7.45 8.07 6.5Z",
            fill: "currentColor"
        })
    });


parcelRequire("acw62");

//#region src/components/icones/svg/multimedia/mur.svg?react
var $667852d9fe5f7731$export$2e2bcd8739ae039 = (t)=>/* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...t,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M20 17.17L18.83 16H4V4H20V17.17ZM20 2H4C2.9 2 2 2.9 2 4V16C2 17.1 2.9 18 4 18H18L22 22V4C22 2.9 21.1 2 20 2Z",
            fill: "currentColor"
        })
    });


parcelRequire("acw62");

//#region src/components/icones/svg/multimedia/test.svg?react
var $68d666b67e12680d$export$2e2bcd8739ae039 = (t)=>/* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...t,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M2 17H4V17.5H3V18.5H4V19H2V20H5V16H2V17ZM3 8H4V4H2V5H3V8ZM2 11H3.8L2 13.1V14H5V13H3.2L5 10.9V10H2V11ZM7 5V7H21V5H7ZM7 19H21V17H7V19ZM7 13H21V11H7V13Z",
            fill: "currentColor"
        })
    });


parcelRequire("acw62");

//#region src/components/icones/svg/multimedia/video.svg?react
var $dced43b7f5fe462d$export$2e2bcd8739ae039 = (t)=>/* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...t,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M7 5V19L18 12L7 5Z",
            fill: "currentColor"
        })
    });


parcelRequire("acw62");

//#region src/components/icones/svg/navegacio/afegeix.svg?react
var $e32a9f4d466b2c80$export$2e2bcd8739ae039 = (t)=>/* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...t,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M19 13H13V19H11V13H5V11H11V5H13V11H19V13Z",
            fill: "currentColor"
        })
    });


parcelRequire("acw62");

//#region src/components/icones/svg/navegacio/ajuda.svg?react
var $bb5f20cb0362f406$export$2e2bcd8739ae039 = (t)=>/* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...t,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M11 18H13V16H11V18ZM12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20ZM12 6C9.79 6 8 7.79 8 10H10C10 8.9 10.9 8 12 8C13.1 8 14 8.9 14 10C14 12 11 11.75 11 15H13C13 12.75 16 12.5 16 10C16 7.79 14.21 6 12 6Z",
            fill: "currentColor"
        })
    });


parcelRequire("acw62");

//#region src/components/icones/svg/navegacio/alerta.svg?react
var $12a1cf435e3d72c3$export$2e2bcd8739ae039 = (t)=>/* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...t,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M12 2L1 21H23M12 6L19.53 19H4.47M11 10V14H13V10M11 16V18H13V16",
            fill: "currentColor"
        })
    });


parcelRequire("acw62");

//#region src/components/icones/svg/navegacio/anterior.svg?react
var $6c7672d54a0b3949$export$2e2bcd8739ae039 = (t)=>/* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...t,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M20 11H7.83L13.42 5.41L12 4L4 12L12 20L13.41 18.59L7.83 13H20V11Z",
            fill: "currentColor"
        })
    });


parcelRequire("acw62");

//#region src/components/icones/svg/navegacio/buscar-off.svg?react
var $593721420e829dcf$export$2e2bcd8739ae039 = (t)=>/* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...t,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M14.71 14H15.5L19.74 18.26C20.15 18.67 20.15 19.34 19.74 19.75C19.33 20.16 18.66 20.16 18.25 19.75L14 15.5V14.71L13.73 14.43C12.48 15.51 10.81 16.11 9.01003 15.98L9.00003 15.97V13.95C9.04522 13.9553 9.08971 13.9613 9.13386 13.9673C9.25581 13.9838 9.37522 14 9.50003 14C11.99 14 14 11.99 14 9.5C14 6.95 11.65 4.8 9.11003 5.02C6.97003 5.2 5.29003 6.88 5.05003 9H3.03003C3.30003 5.38 6.54003 2.58 10.33 3.05C13.12 3.4 15.44 5.61 15.91 8.39C16.25 10.42 15.63 12.33 14.43 13.73L14.71 14ZM4.00002 13.29L6.12002 11.17C6.32002 10.98 6.63002 10.98 6.83002 11.17C7.03002 11.37 7.03002 11.68 6.83002 11.88L4.71002 14L6.83002 16.12C7.03002 16.32 7.03002 16.63 6.83002 16.83C6.63002 17.03 6.32002 17.03 6.12002 16.83L4.00002 14.71L1.88002 16.83C1.68002 17.03 1.37002 17.03 1.17002 16.83C0.97002 16.63 0.97002 16.32 1.17002 16.12L3.29002 14L1.17002 11.88C0.97002 11.68 0.97002 11.37 1.17002 11.17C1.37002 10.97 1.68002 10.97 1.88002 11.17L4.00002 13.29Z",
            fill: "currentColor"
        })
    });


parcelRequire("acw62");

//#region src/components/icones/svg/navegacio/buscar.svg?react
var $bcdd2bfdd941818f$export$2e2bcd8739ae039 = (t)=>/* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...t,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M15.5 14H14.71L14.43 13.73C15.63 12.33 16.25 10.42 15.91 8.39C15.44 5.61 13.12 3.39 10.32 3.05C6.09001 2.53 2.53002 6.09 3.05002 10.32C3.39002 13.12 5.61002 15.44 8.39002 15.91C10.42 16.25 12.33 15.63 13.73 14.43L14 14.71V15.5L18.25 19.75C18.66 20.16 19.33 20.16 19.74 19.75C20.15 19.34 20.15 18.67 19.74 18.26L15.5 14ZM9.50002 14C7.01002 14 5.00002 11.99 5.00002 9.5C5.00002 7.01 7.01002 5 9.50002 5C11.99 5 14 7.01 14 9.5C14 11.99 11.99 14 9.50002 14Z",
            fill: "currentColor"
        })
    });


parcelRequire("acw62");

//#region src/components/icones/svg/navegacio/check-box/buit.svg?react
var $22929fc32dfa35fb$export$2e2bcd8739ae039 = (t)=>/* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...t,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M18 19H6C5.45 19 5 18.55 5 18V6C5 5.45 5.45 5 6 5H18C18.55 5 19 5.45 19 6V18C19 18.55 18.55 19 18 19ZM19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3Z",
            fill: "currentColor"
        })
    });


parcelRequire("acw62");

//#region src/components/icones/svg/navegacio/check-box/null.svg?react
var $88f3e0cf612d4287$export$2e2bcd8739ae039 = (t)=>/* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...t,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M5 21C4.45 21 3.979 20.8043 3.587 20.413C3.19567 20.021 3 19.55 3 19V5C3 4.45 3.19567 3.979 3.587 3.587C3.979 3.19567 4.45 3 5 3H19C19.55 3 20.021 3.19567 20.413 3.587C20.8043 3.979 21 4.45 21 5V19C21 19.55 20.8043 20.021 20.413 20.413C20.021 20.8043 19.55 21 19 21H5ZM5 19H19V5H5V19ZM10.6 15.775C10.7333 15.775 10.8583 15.7543 10.975 15.713C11.0917 15.671 11.2 15.6 11.3 15.5L16.975 9.825C17.1583 9.64167 17.25 9.41667 17.25 9.15C17.25 8.88333 17.15 8.65 16.95 8.45C16.7667 8.26667 16.5333 8.175 16.25 8.175C15.9667 8.175 15.7333 8.26667 15.55 8.45L10.6 13.4L8.425 11.225C8.24167 11.0417 8.01667 10.95 7.75 10.95C7.48333 10.95 7.25 11.05 7.05 11.25C6.86667 11.4333 6.775 11.6667 6.775 11.95C6.775 12.2333 6.86667 12.4667 7.05 12.65L9.9 15.5C10 15.6 10.1083 15.671 10.225 15.713C10.3417 15.7543 10.4667 15.775 10.6 15.775Z",
            fill: "currentColor"
        })
    });


parcelRequire("acw62");

//#region src/components/icones/svg/navegacio/check-box/ple.svg?react
var $65349c354de9839d$export$2e2bcd8739ae039 = (t)=>/* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...t,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M19 3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3ZM10.71 16.29C10.32 16.68 9.69 16.68 9.3 16.29L5.71 12.7C5.32 12.31 5.32 11.68 5.71 11.29C6.1 10.9 6.73 10.9 7.12 11.29L10 14.17L16.88 7.29C17.27 6.9 17.9 6.9 18.29 7.29C18.68 7.68 18.68 8.31 18.29 8.7L10.71 16.29Z",
            fill: "currentColor"
        })
    });


parcelRequire("acw62");

//#region src/components/icones/svg/navegacio/confirma-accio.svg?react
var $8096dcfc0a138855$export$2e2bcd8739ae039 = (t)=>/* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...t,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20ZM16.59 7.58L10 14.17L7.41 11.59L6 13L10 17L18 9L16.59 7.58Z",
            fill: "currentColor"
        })
    });


parcelRequire("acw62");

//#region src/components/icones/svg/navegacio/descarrega.svg?react
var $70ffd2b98af0d7a4$export$2e2bcd8739ae039 = (t)=>/* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...t,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M19 9H15V3H9V9H5L12 16L19 9ZM5 18V20H19V18H5Z",
            fill: "currentColor"
        })
    });


parcelRequire("acw62");

//#region src/components/icones/svg/navegacio/desplega.svg?react
var $ad24819314ef8701$export$2e2bcd8739ae039 = (t)=>/* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...t,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M16.59 8.59L12 13.17L7.41 8.59L6 10L12 16L18 10L16.59 8.59Z",
            fill: "currentColor"
        })
    });


parcelRequire("acw62");

//#region src/components/icones/svg/navegacio/direccio.svg?react
var $dda423fcf078e816$export$2e2bcd8739ae039 = (t)=>/* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...t,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M16.01 11H4V13H16.01V16L20 12L16.01 8V11Z",
            fill: "currentColor"
        })
    });


parcelRequire("acw62");

//#region src/components/icones/svg/navegacio/editar.svg?react
var $c65e04ff4f28781e$export$2e2bcd8739ae039 = (t)=>/* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...t,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M14.06 9.02L14.98 9.94L5.92 19H5V18.08L14.06 9.02ZM17.66 3C17.41 3 17.15 3.1 16.96 3.29L15.13 5.12L18.88 8.87L20.71 7.04C21.1 6.65 21.1 6.02 20.71 5.63L18.37 3.29C18.17 3.09 17.92 3 17.66 3ZM14.06 6.19L3 17.25V21H6.75L17.81 9.94L14.06 6.19Z",
            fill: "currentColor"
        })
    });


parcelRequire("acw62");

//#region src/components/icones/svg/navegacio/encert.svg?react
var $e9357884128ebb58$export$2e2bcd8739ae039 = (t)=>/* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...t,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M8.99997 16.17L4.82997 12L3.40997 13.41L8.99997 19L21 7L19.59 5.59L8.99997 16.17Z",
            fill: "currentColor"
        })
    });


parcelRequire("acw62");

//#region src/components/icones/svg/navegacio/endarrere.svg?react
var $e64f03f6fac35391$export$2e2bcd8739ae039 = (t)=>/* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...t,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M15.61 7.41L14.2 6L8.2 12L14.2 18L15.61 16.59L11.03 12L15.61 7.41Z",
            fill: "currentColor"
        })
    });


parcelRequire("acw62");

//#region src/components/icones/svg/navegacio/endavant.svg?react
var $e639092e3392a364$export$2e2bcd8739ae039 = (t)=>/* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...t,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M10.02 6L8.61 7.41L13.19 12L8.61 16.59L10.02 18L16.02 12L10.02 6Z",
            fill: "currentColor"
        })
    });


parcelRequire("acw62");

//#region src/components/icones/svg/navegacio/error.svg?react
var $01e040087b463d48$export$2e2bcd8739ae039 = (t)=>/* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...t,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM13 17H11V15H13V17ZM13 13H11V7H13V13Z",
            fill: "currentColor"
        })
    });


parcelRequire("acw62");

//#region src/components/icones/svg/navegacio/esborra.svg?react
var $0414bb8eb83f999b$export$2e2bcd8739ae039 = (t)=>/* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...t,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M16 9V19H8V9H9.5V18H11.5V9H12.5V18H14.5V9H16ZM14.5 3H9.5L8.5 4H5V6H19V4H15.5L14.5 3ZM18 7H6V19C6 20.1 6.9 21 8 21H16C17.1 21 18 20.1 18 19V7Z",
            fill: "currentColor"
        })
    });


parcelRequire("acw62");

//#region src/components/icones/svg/navegacio/estrella-0-5.svg?react
var $9ef6be975a2dd900$export$2e2bcd8739ae039 = (t)=>/* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...t,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M22 9.24L14.81 8.62L12 2L9.19 8.63L2 9.24L7.46 13.97L5.82 21L12 17.27L18.18 21L16.55 13.97L22 9.24ZM12 15.4V6.1L13.71 10.14L18.09 10.52L14.77 13.4L15.77 17.68L12 15.4Z",
            fill: "currentColor"
        })
    });


parcelRequire("acw62");

//#region src/components/icones/svg/navegacio/estrella-0.svg?react
var $69d8243b40d1bda5$export$2e2bcd8739ae039 = (t)=>/* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...t,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M22 9.24L14.81 8.62L12 2L9.19 8.63L2 9.24L7.46 13.97L5.82 21L12 17.27L18.18 21L16.55 13.97L22 9.24ZM12 15.4L8.24 17.67L9.24 13.39L5.92 10.51L10.3 10.13L12 6.1L13.71 10.14L18.09 10.52L14.77 13.4L15.77 17.68L12 15.4Z",
            fill: "currentColor"
        })
    });


parcelRequire("acw62");

//#region src/components/icones/svg/navegacio/estrella-1.svg?react
var $59011d7dc3f50d04$export$2e2bcd8739ae039 = (t)=>/* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...t,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M12 17.27L18.18 21L16.54 13.97L22 9.24L14.81 8.63L12 2L9.19 8.63L2 9.24L7.46 13.97L5.82 21L12 17.27Z",
            fill: "currentColor"
        })
    });


parcelRequire("acw62");

//#region src/components/icones/svg/navegacio/external.svg?react
var $fd3bf2218888a7af$export$2e2bcd8739ae039 = (t)=>/* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...t,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M3 21V3H12V5H5V19H19V12H21V21H3ZM9.7 15.7L8.3 14.3L17.6 5H14V3H21V10H19V6.4L9.7 15.7Z",
            fill: "currentColor"
        })
    });


parcelRequire("acw62");

//#region src/components/icones/svg/navegacio/no-encert.svg?react
var $39cf54df8493717d$export$2e2bcd8739ae039 = (t)=>/* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...t,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41Z",
            fill: "currentColor"
        })
    });


parcelRequire("acw62");

//#region src/components/icones/svg/navegacio/pause.svg?react
var $a57d629012e494cf$export$2e2bcd8739ae039 = (t)=>/* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...t,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M6 19H10V5H6V19ZM14 5V19H18V5H14Z",
            fill: "currentColor"
        })
    });


parcelRequire("acw62");

//#region src/components/icones/svg/navegacio/play.svg?react
var $0d76b29c3926fa84$export$2e2bcd8739ae039 = (t)=>/* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...t,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M7 5V19L18 12L7 5Z",
            fill: "currentColor"
        })
    });


parcelRequire("acw62");

//#region src/components/icones/svg/navegacio/plega.svg?react
var $20ee0111bbe95950$export$2e2bcd8739ae039 = (t)=>/* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...t,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M12 8L6 14L7.41 15.41L12 10.83L16.59 15.41L18 14L12 8Z",
            fill: "currentColor"
        })
    });


parcelRequire("acw62");

//#region src/components/icones/svg/navegacio/radiobutton-off.svg?react
var $20c17079391acc98$export$2e2bcd8739ae039 = (t)=>/* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...t,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.58 20 4 16.42 4 12C4 7.58 7.58 4 12 4C16.42 4 20 7.58 20 12C20 16.42 16.42 20 12 20Z",
            fill: "currentColor"
        })
    });


parcelRequire("acw62");

//#region src/components/icones/svg/navegacio/radiobutton-on.svg?react
var $25d93415cabe880c$export$2e2bcd8739ae039 = (t)=>/* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...t,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M2 12C2 6.48 6.48 2 12 2C17.52 2 22 6.48 22 12C22 17.52 17.52 22 12 22C6.48 22 2 17.52 2 12ZM4 12C4 16.42 7.58 20 12 20C16.42 20 20 16.42 20 12C20 7.58 16.42 4 12 4C7.58 4 4 7.58 4 12ZM17 12C17 14.7614 14.7614 17 12 17C9.23858 17 7 14.7614 7 12C7 9.23858 9.23858 7 12 7C14.7614 7 17 9.23858 17 12Z",
            fill: "currentColor"
        })
    });


parcelRequire("acw62");

//#region src/components/icones/svg/navegacio/refresca.svg?react
var $d702a5048d8b699d$export$2e2bcd8739ae039 = (t)=>/* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...t,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
            transform: "translate(1 4)",
            d: "M11.05 16C8.81667 16 6.91667 15.225 5.35 13.675C3.78333 12.125 3 10.2333 3 8V7.825L1.4 9.425L0 8.025L4 4.025L8 8.025L6.6 9.425L5 7.825V8C5 9.66667 5.5875 11.0833 6.7625 12.25C7.9375 13.4167 9.36667 14 11.05 14C11.4833 14 11.9083 13.95 12.325 13.85C12.7417 13.75 13.15 13.6 13.55 13.4L15.05 14.9C14.4167 15.2667 13.7667 15.5417 13.1 15.725C12.4333 15.9083 11.75 16 11.05 16ZM18 11.975L14 7.975L15.4 6.575L17 8.175V8C17 6.33333 16.4125 4.91667 15.2375 3.75C14.0625 2.58333 12.6333 2 10.95 2C10.5167 2 10.0917 2.05 9.675 2.15C9.25833 2.25 8.85 2.4 8.45 2.6L6.95 1.1C7.58333 0.733333 8.23333 0.458333 8.9 0.275C9.56667 0.0916667 10.25 0 10.95 0C13.1833 0 15.0833 0.775 16.65 2.325C18.2167 3.875 19 5.76667 19 8V8.175L20.6 6.575L22 7.975L18 11.975Z",
            fill: "currentColor"
        })
    });


parcelRequire("acw62");

//#region src/components/icones/svg/navegacio/seguent.svg?react
var $bf96aa917d0575e0$export$2e2bcd8739ae039 = (t)=>/* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...t,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M12 4L10.59 5.41L16.17 11H4V13H16.17L10.59 18.59L12 20L20 12L12 4Z",
            fill: "currentColor"
        })
    });


parcelRequire("acw62");

//#region src/components/icones/svg/navegacio/tanca.svg?react
var $cb7a6bc44d233349$export$2e2bcd8739ae039 = (t)=>/* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...t,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41Z",
            fill: "currentColor"
        })
    });


parcelRequire("acw62");

//#region src/components/icones/svg/navegacio/visualitzar-off.svg?react
var $2c5f31ee74455dc2$export$2e2bcd8739ae039 = (t)=>/* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...t,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M12 6C15.79 6 19.17 8.13 20.82 11.5C20.23 12.72 19.4 13.77 18.41 14.62L19.82 16.03C21.21 14.8 22.31 13.26 23 11.5C21.27 7.11 17 4 12 4C10.73 4 9.51 4.2 8.36 4.57L10.01 6.22C10.66 6.09 11.32 6 12 6ZM10.93 7.14L13 9.21C13.57 9.46 14.03 9.92 14.28 10.49L16.35 12.56C16.43 12.22 16.49 11.86 16.49 11.49C16.5 9.01 14.48 7 12 7C11.63 7 11.28 7.05 10.93 7.14ZM2.01 3.87L4.69 6.55C3.06 7.83 1.77 9.53 1 11.5C2.73 15.89 7 19 12 19C13.52 19 14.98 18.71 16.32 18.18L19.74 21.6L21.15 20.19L3.42 2.45L2.01 3.87ZM9.51 11.37L12.12 13.98C12.08 13.99 12.04 14 12 14C10.62 14 9.5 12.88 9.5 11.5C9.5 11.45 9.51 11.42 9.51 11.37ZM6.11 7.97L7.86 9.72C7.63 10.27 7.5 10.87 7.5 11.5C7.5 13.98 9.52 16 12 16C12.63 16 13.23 15.87 13.77 15.64L14.75 16.62C13.87 16.86 12.95 17 12 17C8.21 17 4.83 14.87 3.18 11.5C3.88 10.07 4.9 8.89 6.11 7.97Z",
            fill: "currentColor"
        })
    });


parcelRequire("acw62");

//#region src/components/icones/svg/navegacio/visualitzar-on.svg?react
var $4161fa40a0cfeb34$export$2e2bcd8739ae039 = (t)=>/* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...t,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M12 6.5C15.79 6.5 19.17 8.63 20.82 12C19.17 15.37 15.8 17.5 12 17.5C8.2 17.5 4.83 15.37 3.18 12C4.83 8.63 8.21 6.5 12 6.5ZM12 4.5C7 4.5 2.73 7.61 1 12C2.73 16.39 7 19.5 12 19.5C17 19.5 21.27 16.39 23 12C21.27 7.61 17 4.5 12 4.5ZM12 9.5C13.38 9.5 14.5 10.62 14.5 12C14.5 13.38 13.38 14.5 12 14.5C10.62 14.5 9.5 13.38 9.5 12C9.5 10.62 10.62 9.5 12 9.5ZM12 7.5C9.52 7.5 7.5 9.52 7.5 12C7.5 14.48 9.52 16.5 12 16.5C14.48 16.5 16.5 14.48 16.5 12C16.5 9.52 14.48 7.5 12 7.5Z",
            fill: "currentColor"
        })
    });


parcelRequire("acw62");

//#region src/components/icones/svg/perfil/articles-regalats.svg?react
var $1de02fb29f161575$export$2e2bcd8739ae039 = (t)=>/* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...t,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M20 6H17.82C17.93 5.69 18 5.35 18 5C18 3.34 16.66 2 15 2C13.95 2 13.04 2.54 12.5 3.35L12 4.02L11.5 3.34C10.96 2.54 10.05 2 9 2C7.34 2 6 3.34 6 5C6 5.35 6.07 5.69 6.18 6H4C2.89 6 2.01 6.89 2.01 8L2 19C2 20.11 2.89 21 4 21H20C21.11 21 22 20.11 22 19V8C22 6.89 21.11 6 20 6ZM15 4C15.55 4 16 4.45 16 5C16 5.55 15.55 6 15 6C14.45 6 14 5.55 14 5C14 4.45 14.45 4 15 4ZM9 4C9.55 4 10 4.45 10 5C10 5.55 9.55 6 9 6C8.45 6 8 5.55 8 5C8 4.45 8.45 4 9 4ZM20 19H4V17H20V19ZM20 14H4V8H9.08L7 10.83L8.62 12L12 7.4L15.38 12L17 10.83L14.92 8H20V14Z",
            fill: "currentColor"
        })
    });


parcelRequire("acw62");

//#region src/components/icones/svg/perfil/botiga.svg?react
var $b456db26a148e840$export$2e2bcd8739ae039 = (t)=>/* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...t,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M15.55 13C16.3 13 16.96 12.59 17.3 11.97L20.88 5.48C21.25 4.82 20.77 4 20.01 4H5.21L4.27 2H1V4H3L6.6 11.59L5.25 14.03C4.52 15.37 5.48 17 7 17H19V15H7L8.1 13H15.55ZM6.16 6H18.31L15.55 11H8.53L6.16 6ZM7 18C5.9 18 5.01 18.9 5.01 20C5.01 21.1 5.9 22 7 22C8.1 22 9 21.1 9 20C9 18.9 8.1 18 7 18ZM17 18C15.9 18 15.01 18.9 15.01 20C15.01 21.1 15.9 22 17 22C18.1 22 19 21.1 19 20C19 18.9 18.1 18 17 18Z",
            fill: "currentColor"
        })
    });


parcelRequire("acw62");

//#region src/components/icones/svg/perfil/canvi-edicio.svg?react
var $bf7bffdda2e4f158$export$2e2bcd8739ae039 = (t)=>/* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...t,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M6 21V4H15.75C15.9833 4 16.2 4.05417 16.4 4.1625C16.6 4.27083 16.7667 4.41667 16.9 4.6L20 9L16.9 13.4C16.7667 13.5833 16.6 13.7292 16.4 13.8375C16.2 13.9458 15.9833 14 15.75 14H8V21H6ZM8 12H15.5L17.5 9L15.5 6H8V12Z",
            fill: "currentColor"
        })
    });


parcelRequire("acw62");

//#region src/components/icones/svg/perfil/club-premium.svg?react
var $f858e4de1c65ea20$export$2e2bcd8739ae039 = (t)=>/* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...t,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M2.83334 16.0631C2.83334 14.6971 3.64967 13.1262 5.11225 12.3066C7.59525 10.9748 11.5408 11.3162 13.0034 10.9406V7.76466C13.0034 5.37417 12.2891 4.38382 10.5544 4.38382C9.63606 4.38382 8.78572 4.62287 8.17348 5.03267C8.85375 5.64737 9.15987 6.29621 9.15987 7.14996C9.15987 8.78916 8.24151 9.74535 6.4728 9.74535C4.9762 9.74535 3.78573 8.61841 3.78573 7.18411C3.85375 4.99852 6.06464 3.66667 11.5068 3.66667C16.1327 3.66667 18.4116 5.37417 18.4116 9.47215V17.0534C18.4116 18.7951 19.1259 19.1707 20.9626 18.3511L21.1667 18.7268C19.8401 19.683 18.6497 20.2977 17.1531 20.2977C14.7381 20.2977 13.7177 19.3756 13.3435 17.5998H13.2075C11.983 19 10.3504 20.3318 7.93538 20.3318C4.39797 20.4001 2.83334 18.1462 2.83334 16.0631ZM13.0034 16.9168V11.6236C9.466 11.9992 8.54763 12.8871 8.54763 15.5167C8.54763 17.19 9.43198 18.2145 10.7925 18.2145C11.6769 18.2145 12.5612 17.6681 13.0034 16.9168Z",
            fill: "currentColor"
        })
    });


parcelRequire("acw62");

//#region src/components/icones/svg/perfil/columnes.svg?react
var $d1c17defbdad1e45$export$2e2bcd8739ae039 = (t)=>/* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...t,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M9.00003 5V5.38C8.17003 5.05 7.28003 4.88 6.39003 4.88C4.97003 4.88 3.55003 5.31 2.34003 6.17C1.83003 6.53 1.77003 7.26 2.21003 7.7L4.78003 10.27H5.89003V11.38C6.75003 12.24 7.87003 12.69 9.00003 12.74V15H7.00003C6.45003 15 6.00003 15.45 6.00003 16V18C6.00003 19.1 6.90003 20 8.00003 20H18C19.66 20 21 18.66 21 17V5C21 4.45 20.55 4 20 4H10C9.45003 4 9.00003 4.45 9.00003 5ZM7.89003 10.41V8.26H5.61003L4.57003 7.22C5.14003 7 5.76003 6.88 6.39003 6.88C7.73003 6.88 8.98003 7.4 9.93003 8.34L11.34 9.75L11.14 9.95C10.63 10.46 9.95003 10.75 9.22003 10.75C8.75003 10.75 8.29003 10.63 7.89003 10.41ZM19 17C19 17.55 18.55 18 18 18C17.45 18 17 17.55 17 17V16C17 15.45 16.55 15 16 15H11V12.41C11.57 12.18 12.1 11.84 12.56 11.38L12.76 11.18L15.59 14H17V12.59L11 6.62V6H19V17Z",
            fill: "currentColor"
        })
    });


parcelRequire("acw62");

//#region src/components/icones/svg/perfil/comentaris.svg?react
var $fb4f3fd935a4ec40$export$2e2bcd8739ae039 = (t)=>/* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...t,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M20 17.17L18.83 16H4V4H20V17.17ZM20 2H4C2.9 2 2 2.9 2 4V16C2 17.1 2.9 18 4 18H18L22 22V4C22 2.9 21.1 2 20 2Z",
            fill: "currentColor"
        })
    });


parcelRequire("acw62");

//#region src/components/icones/svg/perfil/condicions-generals.svg?react
var $e73adee30cf0099d$export$2e2bcd8739ae039 = (t)=>/* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...t,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M6 22C5.16667 22 4.45833 21.7083 3.875 21.125C3.29167 20.5417 3 19.8333 3 19V16H6V2H21V19C21 19.8333 20.7083 20.5417 20.125 21.125C19.5417 21.7083 18.8333 22 18 22H6ZM18 20C18.2833 20 18.5208 19.9042 18.7125 19.7125C18.9042 19.5208 19 19.2833 19 19V4H8V16H17V19C17 19.2833 17.0958 19.5208 17.2875 19.7125C17.4792 19.9042 17.7167 20 18 20ZM9 9V7H18V9H9ZM9 12V10H18V12H9ZM6 20H15V18H5V19C5 19.2833 5.09583 19.5208 5.2875 19.7125C5.47917 19.9042 5.71667 20 6 20ZM6 20H5H15H6Z",
            fill: "currentColor"
        })
    });


parcelRequire("acw62");

//#region src/components/icones/svg/perfil/configuracio.svg?react
var $a7b4a93a86bedd6f$export$2e2bcd8739ae039 = (t)=>/* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...t,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M19.43 12.98C19.47 12.66 19.5 12.34 19.5 12C19.5 11.66 19.47 11.34 19.43 11.02L21.54 9.37C21.73 9.22 21.78 8.95 21.66 8.73L19.66 5.27C19.57 5.11 19.4 5.02 19.22 5.02C19.16 5.02 19.1 5.03 19.05 5.05L16.56 6.05C16.04 5.65 15.48 5.32 14.87 5.07L14.49 2.42C14.46 2.18 14.25 2 14 2H9.99999C9.74999 2 9.53999 2.18 9.50999 2.42L9.12999 5.07C8.51999 5.32 7.95999 5.66 7.43999 6.05L4.94999 5.05C4.88999 5.03 4.82999 5.02 4.76999 5.02C4.59999 5.02 4.42999 5.11 4.33999 5.27L2.33999 8.73C2.20999 8.95 2.26999 9.22 2.45999 9.37L4.56999 11.02C4.52999 11.34 4.49999 11.67 4.49999 12C4.49999 12.33 4.52999 12.66 4.56999 12.98L2.45999 14.63C2.26999 14.78 2.21999 15.05 2.33999 15.27L4.33999 18.73C4.42999 18.89 4.59999 18.98 4.77999 18.98C4.83999 18.98 4.89999 18.97 4.94999 18.95L7.43999 17.95C7.95999 18.35 8.51999 18.68 9.12999 18.93L9.50999 21.58C9.53999 21.82 9.74999 22 9.99999 22H14C14.25 22 14.46 21.82 14.49 21.58L14.87 18.93C15.48 18.68 16.04 18.34 16.56 17.95L19.05 18.95C19.11 18.97 19.17 18.98 19.23 18.98C19.4 18.98 19.57 18.89 19.66 18.73L21.66 15.27C21.78 15.05 21.73 14.78 21.54 14.63L19.43 12.98ZM17.45 11.27C17.49 11.58 17.5 11.79 17.5 12C17.5 12.21 17.48 12.43 17.45 12.73L17.31 13.86L18.2 14.56L19.28 15.4L18.58 16.61L17.31 16.1L16.27 15.68L15.37 16.36C14.94 16.68 14.53 16.92 14.12 17.09L13.06 17.52L12.9 18.65L12.7 20H11.3L11.11 18.65L10.95 17.52L9.88999 17.09C9.45999 16.91 9.05999 16.68 8.65999 16.38L7.74999 15.68L6.68999 16.11L5.41999 16.62L4.71999 15.41L5.79999 14.57L6.68999 13.87L6.54999 12.74C6.51999 12.43 6.49999 12.2 6.49999 12C6.49999 11.8 6.51999 11.57 6.54999 11.27L6.68999 10.14L5.79999 9.44L4.71999 8.6L5.41999 7.39L6.68999 7.9L7.72999 8.32L8.62999 7.64C9.05999 7.32 9.46999 7.08 9.87999 6.91L10.94 6.48L11.1 5.35L11.3 4H12.69L12.88 5.35L13.04 6.48L14.1 6.91C14.53 7.09 14.93 7.32 15.33 7.62L16.24 8.32L17.3 7.89L18.57 7.38L19.27 8.59L18.2 9.44L17.31 10.14L17.45 11.27ZM12 8C9.78999 8 7.99999 9.79 7.99999 12C7.99999 14.21 9.78999 16 12 16C14.21 16 16 14.21 16 12C16 9.79 14.21 8 12 8ZM12 14C10.9 14 9.99999 13.1 9.99999 12C9.99999 10.9 10.9 10 12 10C13.1 10 14 10.9 14 12C14 13.1 13.1 14 12 14Z",
            fill: "currentColor"
        })
    });


parcelRequire("acw62");

//#region src/components/icones/svg/perfil/consentiment.svg?react
var $f48d409f688f9297$export$2e2bcd8739ae039 = (t)=>/* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...t,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M12 22C9.68333 21.4167 7.771 20.0873 6.263 18.012C4.75433 15.9373 4 13.6333 4 11.1V5L12 2L20 5V10.675C19.6833 10.5417 19.3583 10.4207 19.025 10.312C18.6917 10.204 18.35 10.125 18 10.075V6.4L12 4.15L6 6.4V11.1C6 11.8833 6.104 12.6667 6.312 13.45C6.52067 14.2333 6.81267 14.9793 7.188 15.688C7.56267 16.396 8.01667 17.05 8.55 17.65C9.08333 18.25 9.675 18.75 10.325 19.15C10.5083 19.6833 10.75 20.1917 11.05 20.675C11.35 21.1583 11.6917 21.5917 12.075 21.975C12.0583 21.975 12.046 21.9793 12.038 21.988C12.0293 21.996 12.0167 22 12 22ZM17 17C17.4167 17 17.7707 16.854 18.062 16.562C18.354 16.2707 18.5 15.9167 18.5 15.5C18.5 15.0833 18.354 14.7293 18.062 14.438C17.7707 14.146 17.4167 14 17 14C16.5833 14 16.2293 14.146 15.938 14.438C15.646 14.7293 15.5 15.0833 15.5 15.5C15.5 15.9167 15.646 16.2707 15.938 16.562C16.2293 16.854 16.5833 17 17 17ZM17 20C17.5167 20 17.9917 19.879 18.425 19.637C18.8583 19.3957 19.2083 19.075 19.475 18.675C19.1083 18.4583 18.7167 18.2917 18.3 18.175C17.8833 18.0583 17.45 18 17 18C16.55 18 16.1167 18.0583 15.7 18.175C15.2833 18.2917 14.8917 18.4583 14.525 18.675C14.7917 19.075 15.1417 19.3957 15.575 19.637C16.0083 19.879 16.4833 20 17 20ZM17 22C15.6167 22 14.4377 21.5127 13.463 20.538C12.4877 19.5627 12 18.3833 12 17C12 15.6167 12.4877 14.4373 13.463 13.462C14.4377 12.4873 15.6167 12 17 12C18.3833 12 19.5627 12.4873 20.538 13.462C21.5127 14.4373 22 15.6167 22 17C22 18.3833 21.5127 19.5627 20.538 20.538C19.5627 21.5127 18.3833 22 17 22Z",
            fill: "currentColor"
        })
    });


parcelRequire("acw62");

//#region src/components/icones/svg/perfil/contacta.svg?react
var $2b13479a9dc01330$export$2e2bcd8739ae039 = (t)=>/* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...t,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M11 18H13V16H11V18ZM12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20ZM12 6C9.79 6 8 7.79 8 10H10C10 8.9 10.9 8 12 8C13.1 8 14 8.9 14 10C14 12 11 11.75 11 15H13C13 12.75 16 12.5 16 10C16 7.79 14.21 6 12 6Z",
            fill: "currentColor"
        })
    });


parcelRequire("acw62");

//#region src/components/icones/svg/perfil/contrasenya.svg?react
var $f6038ac8764d777c$export$2e2bcd8739ae039 = (t)=>/* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...t,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M12 17C13.1 17 14 16.1 14 15C14 13.9 13.1 13 12 13C10.9 13 10 13.9 10 15C10 16.1 10.9 17 12 17ZM18 8H17V6C17 3.24 14.76 1 12 1C9.24 1 7 3.24 7 6V8H6C4.9 8 4 8.9 4 10V20C4 21.1 4.9 22 6 22H18C19.1 22 20 21.1 20 20V10C20 8.9 19.1 8 18 8ZM8.9 6C8.9 4.29 10.29 2.9 12 2.9C13.71 2.9 15.1 4.29 15.1 6V8H8.9V6ZM18 20H6V10H18V20Z",
            fill: "currentColor"
        })
    });


parcelRequire("acw62");

//#region src/components/icones/svg/perfil/convida-amic.svg?react
var $23e16f1cc9315e70$export$2e2bcd8739ae039 = (t)=>/* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...t,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M11 14H9C9 9.03 13.03 5 18 5V7C14.13 7 11 10.13 11 14ZM18 11V9C15.24 9 13 11.24 13 14H15C15 12.34 16.34 11 18 11ZM7 4C7 2.89 6.11 2 5 2C3.89 2 3 2.89 3 4C3 5.11 3.89 6 5 6C6.11 6 7 5.11 7 4ZM11.45 4.5H9.45C9.21 5.92 7.99 7 6.5 7H3.5C2.67 7 2 7.67 2 8.5V11H8V8.74C9.86 8.15 11.25 6.51 11.45 4.5ZM19 17C20.11 17 21 16.11 21 15C21 13.89 20.11 13 19 13C17.89 13 17 13.89 17 15C17 16.11 17.89 17 19 17ZM20.5 18H17.5C16.01 18 14.79 16.92 14.55 15.5H12.55C12.75 17.51 14.14 19.15 16 19.74V22H22V19.5C22 18.67 21.33 18 20.5 18Z",
            fill: "currentColor"
        })
    });


parcelRequire("acw62");

//#region src/components/icones/svg/perfil/cost.svg?react
var $5fa14409925086d8$export$2e2bcd8739ae039 = (t)=>/* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...t,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M14 20V7H9V4H22V7H17V20H14ZM5 20V12H2V9H11V12H8V20H5Z",
            fill: "currentColor"
        })
    });


parcelRequire("acw62");

//#region src/components/icones/svg/perfil/dades.svg?react
var $efa830fba4d6bbfd$export$2e2bcd8739ae039 = (t)=>/* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...t,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M15 7H20C21.1 7 22 7.9 22 9V20C22 21.1 21.1 22 20 22H4C2.9 22 2 21.1 2 20V9C2 7.9 2.9 7 4 7H9V4C9 2.9 9.9 2 11 2H13C14.1 2 15 2.9 15 4V7ZM11 4V7V9H13V7V4H11ZM4 9V20H20V9H15C15 10.1 14.1 11 13 11H11C9.9 11 9 10.1 9 9H4ZM18 12H14V13.5H18V12ZM18 15H14V16.5H18V15ZM9 15C9.82843 15 10.5 14.3284 10.5 13.5C10.5 12.6716 9.82843 12 9 12C8.17157 12 7.5 12.6716 7.5 13.5C7.5 14.3284 8.17157 15 9 15ZM9 15.75C9.74 15.75 10.44 15.9 11.08 16.18C11.64 16.42 12 16.96 12 17.57V18H6V17.57C6 16.96 6.36 16.42 6.92 16.18C7.56 15.9 8.26 15.75 9 15.75Z",
            fill: "currentColor"
        })
    });


parcelRequire("acw62");

//#region src/components/icones/svg/perfil/espai-del-subscriptor.svg?react
var $309052f5432c6d9f$export$2e2bcd8739ae039 = (t)=>/* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...t,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M21.41 11.58L12.41 2.58C12.05 2.22 11.55 2 11 2H4C2.9 2 2 2.9 2 4V11C2 11.55 2.22 12.05 2.59 12.42L11.59 21.42C11.95 21.78 12.45 22 13 22C13.55 22 14.05 21.78 14.41 21.41L21.41 14.41C21.78 14.05 22 13.55 22 13C22 12.45 21.77 11.94 21.41 11.58ZM13 20.01L4 11V4H11V3.99L20 12.99L13 20.01ZM6.5 8C7.32843 8 8 7.32843 8 6.5C8 5.67157 7.32843 5 6.5 5C5.67157 5 5 5.67157 5 6.5C5 7.32843 5.67157 8 6.5 8ZM9.49999 14C9.12999 13.62 8.89999 13.12 8.89999 12.55C8.89999 11.42 9.81999 10.5 10.95 10.5C11.51 10.5 12.03 10.73 12.4 11.11L13 11.7L13.6 11.1C13.97 10.73 14.48 10.5 15.05 10.5C16.18 10.5 17.1 11.42 17.1 12.55C17.1 13.11 16.87 13.63 16.5 14L13 17.5L9.49999 14Z",
            fill: "currentColor"
        })
    });


parcelRequire("acw62");

//#region src/components/icones/svg/perfil/firmes.svg?react
var $f805fcd157e462b2$export$2e2bcd8739ae039 = (t)=>/* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...t,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M14.06 9.02L14.98 9.94L5.92 19H5V18.08L14.06 9.02ZM17.66 3C17.41 3 17.15 3.1 16.96 3.29L15.13 5.12L18.88 8.87L20.71 7.04C21.1 6.65 21.1 6.02 20.71 5.63L18.37 3.29C18.17 3.09 17.92 3 17.66 3ZM14.06 6.19L3 17.25V21H6.75L17.81 9.94L14.06 6.19Z",
            fill: "currentColor"
        })
    });


parcelRequire("acw62");

//#region src/components/icones/svg/perfil/funcio-tancada.svg?react
var $5502159c3049d4f7$export$2e2bcd8739ae039 = (t)=>/* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...t,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M18 8H17V6C17 3.24 14.76 1 12 1C9.24 1 7 3.24 7 6V8H6C4.9 8 4 8.9 4 10V20C4 21.1 4.9 22 6 22H18C19.1 22 20 21.1 20 20V10C20 8.9 19.1 8 18 8ZM12 17C10.9 17 10 16.1 10 15C10 13.9 10.9 13 12 13C13.1 13 14 13.9 14 15C14 16.1 13.1 17 12 17ZM15.1 8H8.9V6C8.9 4.29 10.29 2.9 12 2.9C13.71 2.9 15.1 4.29 15.1 6V8Z",
            fill: "currentColor"
        })
    });


parcelRequire("acw62");

//#region src/components/icones/svg/perfil/gestio-descarregues.svg?react
var $b273d47bd70666dd$export$2e2bcd8739ae039 = (t)=>/* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...t,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M5 20C4.45 20 3.979 19.8043 3.587 19.413C3.19567 19.021 3 18.55 3 18V4C3 3.45 3.19567 2.979 3.587 2.587C3.979 2.19567 4.45 2 5 2H19C19.55 2 20.021 2.19567 20.413 2.587C20.8043 2.979 21 3.45 21 4V9.65C20.6833 9.5 20.3583 9.379 20.025 9.287C19.6917 9.19567 19.35 9.125 19 9.075V4H5V13H9.2C9.35 13.45 9.6 13.8417 9.95 14.175C10.3 14.5083 10.6917 14.7417 11.125 14.875C11.075 15.2083 11.0417 15.5457 11.025 15.887C11.0083 16.229 11.025 16.5667 11.075 16.9C10.475 16.7833 9.91233 16.5627 9.387 16.238C8.86233 15.9127 8.4 15.5 8 15H5V18H11.325C11.4417 18.3667 11.575 18.7167 11.725 19.05C11.875 19.3833 12.0583 19.7 12.275 20H5ZM17.025 21L16.725 19.5C16.525 19.4167 16.3377 19.3293 16.163 19.238C15.9877 19.146 15.8083 19.0333 15.625 18.9L14.175 19.35L13.175 17.65L14.325 16.65C14.2917 16.45 14.275 16.2333 14.275 16C14.275 15.7667 14.2917 15.55 14.325 15.35L13.175 14.35L14.175 12.65L15.625 13.1C15.8083 12.9667 15.9877 12.854 16.163 12.762C16.3377 12.6707 16.525 12.5833 16.725 12.5L17.025 11H19.025L19.325 12.5C19.525 12.5833 19.7127 12.6707 19.888 12.762C20.0627 12.854 20.2417 12.9667 20.425 13.1L21.875 12.65L22.875 14.35L21.725 15.35C21.7583 15.55 21.775 15.7667 21.775 16C21.775 16.2333 21.7583 16.45 21.725 16.65L22.875 17.65L21.875 19.35L20.425 18.9C20.2417 19.0333 20.0627 19.146 19.888 19.238C19.7127 19.3293 19.525 19.4167 19.325 19.5L19.025 21H17.025ZM18.025 18C18.575 18 19.046 17.8043 19.438 17.413C19.8293 17.021 20.025 16.55 20.025 16C20.025 15.45 19.8293 14.979 19.438 14.587C19.046 14.1957 18.575 14 18.025 14C17.475 14 17.0043 14.1957 16.613 14.587C16.221 14.979 16.025 15.45 16.025 16C16.025 16.55 16.221 17.021 16.613 17.413C17.0043 17.8043 17.475 18 18.025 18Z",
            fill: "currentColor"
        })
    });


parcelRequire("acw62");

//#region src/components/icones/svg/perfil/guardats.svg?react
var $d22225c88c3fa9f3$export$2e2bcd8739ae039 = (t)=>/* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...t,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M17 3H7C5.9 3 5 3.9 5 5V21L12 18L19 21V5C19 3.9 18.1 3 17 3ZM17 18L12 15.82L7 18V5H17V18Z",
            fill: "currentColor"
        })
    });


parcelRequire("acw62");

//#region src/components/icones/svg/perfil/info.svg?react
var $68799f133cbc03dd$export$2e2bcd8739ae039 = (t)=>/* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...t,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M11 7H13V9H11V7ZM11 11H13V17H11V11ZM12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20Z",
            fill: "currentColor"
        })
    });


parcelRequire("acw62");

//#region src/components/icones/svg/perfil/ios.svg?react
var $74716b3569a6adce$export$2e2bcd8739ae039 = (t)=>/* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...t,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M16.125 1.5C14.972 1.567 13.6483 2.20934 12.8613 3.02734C12.1503 3.77134 11.5894 4.87631 11.8184 5.94531C13.0714 5.97831 14.329 5.31933 15.082 4.48633C15.785 3.70733 16.318 2.62 16.125 1.5ZM16.1934 5.94336C14.3844 5.94336 13.628 7.05469 12.375 7.05469C11.086 7.05469 9.90766 6.01367 8.34766 6.01367C6.22566 6.01467 3 7.98033 3 12.6113C3 16.8243 6.81766 21.5 8.97266 21.5C10.2817 21.513 10.599 20.677 12.375 20.668C14.153 20.655 14.5367 21.511 15.8477 21.5C17.3237 21.489 18.4764 19.867 19.3184 18.582C19.9224 17.662 20.1707 17.1923 20.6387 16.1523C17.1657 15.2723 16.4747 9.67167 20.6387 8.51367C19.8527 7.17267 17.5584 5.94336 16.1934 5.94336Z",
            fill: "currentColor"
        })
    });


parcelRequire("acw62");

//#region src/components/icones/svg/perfil/lectors.svg?react
var $9e3ca046cb64712f$export$2e2bcd8739ae039 = (t)=>/* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...t,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M9 13.75C6.66 13.75 2 14.92 2 17.25V19H16V17.25C16 14.92 11.34 13.75 9 13.75ZM4.34 17C5.18 16.42 7.21 15.75 9 15.75C10.79 15.75 12.82 16.42 13.66 17H4.34ZM9 12C10.93 12 12.5 10.43 12.5 8.5C12.5 6.57 10.93 5 9 5C7.07 5 5.5 6.57 5.5 8.5C5.5 10.43 7.07 12 9 12ZM9 7C9.83 7 10.5 7.67 10.5 8.5C10.5 9.33 9.83 10 9 10C8.17 10 7.5 9.33 7.5 8.5C7.5 7.67 8.17 7 9 7ZM16.04 13.81C17.2 14.65 18 15.77 18 17.25V19H22V17.25C22 15.23 18.5 14.08 16.04 13.81ZM15 12C16.93 12 18.5 10.43 18.5 8.5C18.5 6.57 16.93 5 15 5C14.46 5 13.96 5.13 13.5 5.35C14.13 6.24 14.5 7.33 14.5 8.5C14.5 9.67 14.13 10.76 13.5 11.65C13.96 11.87 14.46 12 15 12Z",
            fill: "currentColor"
        })
    });


parcelRequire("acw62");

//#region src/components/icones/svg/perfil/mode.svg?react
var $7eeb1b1bba2a6aa8$export$2e2bcd8739ae039 = (t)=>/* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...t,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M12 23L15 20H20V15L23 12L20 9V4H15L12 1L9 4H4V9L1 12L4 15V20H9L12 23ZM12 18V6C13.6667 6 15.0833 6.58333 16.25 7.75C17.4167 8.91667 18 10.3333 18 12C18 13.6667 17.4167 15.0833 16.25 16.25C15.0833 17.4167 13.6667 18 12 18Z",
            fill: "currentColor"
        })
    });


parcelRequire("acw62");

//#region src/components/icones/svg/perfil/newsletters.svg?react
var $b41948f1e689117f$export$2e2bcd8739ae039 = (t)=>/* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...t,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M7 17C6.45 17 5.97917 16.8042 5.5875 16.4125C5.19583 16.0208 5 15.55 5 15V5C5 4.45 5.19583 3.97917 5.5875 3.5875C5.97917 3.19583 6.45 3 7 3H21C21.55 3 22.0208 3.19583 22.4125 3.5875C22.8042 3.97917 23 4.45 23 5V15C23 15.55 22.8042 16.0208 22.4125 16.4125C22.0208 16.8042 21.55 17 21 17H7ZM14 12.3L7 7.425V15H21V7.425L14 12.3ZM14 9.85L21 5H7L14 9.85ZM3 21C2.45 21 1.97917 20.8042 1.5875 20.4125C1.19583 20.0208 1 19.55 1 19V6.5H3V19H19.5V21H3Z",
            fill: "currentColor"
        })
    });


parcelRequire("acw62");

//#region src/components/icones/svg/perfil/notificacions-1.svg?react
var $f091c5aeee8670f1$export$2e2bcd8739ae039 = (t)=>/* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...t,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M12 22C13.1 22 14 21.1 14 20H10C10 21.1 10.9 22 12 22ZM18 16V11C18 7.93 16.37 5.36 13.5 4.68V4C13.5 3.17 12.83 2.5 12 2.5C11.17 2.5 10.5 3.17 10.5 4V4.68C7.64 5.36 6 7.92 6 11V16L4 18V19H20V18L18 16ZM16 17H8V11C8 8.52 9.51 6.5 12 6.5C14.49 6.5 16 8.52 16 11V17Z",
            fill: "currentColor"
        })
    });


parcelRequire("acw62");

//#region src/components/icones/svg/perfil/notificacions.svg?react
var $3bb6817bd4c7cda4$export$2e2bcd8739ae039 = (t)=>/* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...t,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M12 22C13.1 22 14 21.1 14 20H10C10 21.1 10.9 22 12 22ZM18 16V11C18 7.93 16.37 5.36 13.5 4.68V4C13.5 3.17 12.83 2.5 12 2.5C11.17 2.5 10.5 3.17 10.5 4V4.68C7.64 5.36 6 7.92 6 11V16L4 18V19H20V18L18 16ZM16 17H8V11C8 8.52 9.51 6.5 12 6.5C14.49 6.5 16 8.52 16 11V17Z",
            fill: "currentColor"
        })
    });


parcelRequire("acw62");

//#region src/components/icones/svg/perfil/punt-de-venda.svg?react
var $ca53114d2eb8007f$export$2e2bcd8739ae039 = (t)=>/* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...t,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M22.43 10.59L13.42 1.57999C12.67 0.829989 11.35 0.819989 10.59 1.57999L1.59 10.58C0.810005 11.36 0.810005 12.62 1.59 13.4L10.59 22.4C10.98 22.79 11.49 22.98 12 22.98C12.51 22.98 13.02 22.79 13.41 22.4L22.4 13.41C23.19 12.65 23.2 11.39 22.43 10.59ZM12.01 20.99L3.01 11.99L12.01 2.98999L21.01 11.99L12.01 20.99ZM8 11V15H10V12H14V14.5L17.5 11L14 7.49999V9.99999H9C8.45 9.99999 8 10.45 8 11Z",
            fill: "currentColor"
        })
    });


parcelRequire("acw62");

//#region src/components/icones/svg/perfil/punts-de-venda.svg?react
var $1165a3654cdaed70$export$2e2bcd8739ae039 = (t)=>/* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...t,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M12 12C12.55 12 13.021 11.804 13.413 11.412C13.8043 11.0207 14 10.55 14 10C14 9.45 13.8043 8.979 13.413 8.587C13.021 8.19567 12.55 8 12 8C11.45 8 10.9793 8.19567 10.588 8.587C10.196 8.979 10 9.45 10 10C10 10.55 10.196 11.0207 10.588 11.412C10.9793 11.804 11.45 12 12 12ZM12 19.35C14.0333 17.4833 15.5417 15.7873 16.525 14.262C17.5083 12.7373 18 11.3833 18 10.2C18 8.38333 17.4207 6.89567 16.262 5.737C15.104 4.579 13.6833 4 12 4C10.3167 4 8.89567 4.579 7.737 5.737C6.579 6.89567 6 8.38333 6 10.2C6 11.3833 6.49167 12.7373 7.475 14.262C8.45833 15.7873 9.96667 17.4833 12 19.35ZM12 21.625C11.8667 21.625 11.7333 21.6 11.6 21.55C11.4667 21.5 11.35 21.4333 11.25 21.35C8.81667 19.2 7 17.2043 5.8 15.363C4.6 13.521 4 11.8 4 10.2C4 7.7 4.80433 5.70833 6.413 4.225C8.021 2.74167 9.88333 2 12 2C14.1167 2 15.979 2.74167 17.587 4.225C19.1957 5.70833 20 7.7 20 10.2C20 11.8 19.4 13.521 18.2 15.363C17 17.2043 15.1833 19.2 12.75 21.35C12.65 21.4333 12.5333 21.5 12.4 21.55C12.2667 21.6 12.1333 21.625 12 21.625Z",
            fill: "currentColor"
        })
    });


parcelRequire("acw62");

//#region src/components/icones/svg/perfil/seguint.svg?react
var $dac9afcd847475da$export$2e2bcd8739ae039 = (t)=>/* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...t,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M13 7H11V11H7V13H11V17H13V13H17V11H13V7ZM12 2C6.48 2 2 6.48 2 12C2 17.52 6.48 22 12 22C17.52 22 22 17.52 22 12C22 6.48 17.52 2 12 2ZM12 20C7.59 20 4 16.41 4 12C4 7.59 7.59 4 12 4C16.41 4 20 7.59 20 12C20 16.41 16.41 20 12 20Z",
            fill: "currentColor"
        })
    });


parcelRequire("acw62");

//#region src/components/icones/svg/perfil/subscripcio.svg?react
var $e976fdf9ec97bf65$export$2e2bcd8739ae039 = (t)=>/* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...t,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M10 12C12.21 12 14 10.21 14 8C14 5.79 12.21 4 10 4C7.79 4 6 5.79 6 8C6 10.21 7.79 12 10 12ZM10 6C11.1 6 12 6.9 12 8C12 9.1 11.1 10 10 10C8.9 10 8 9.1 8 8C8 6.9 8.9 6 10 6ZM4 18V17.35C4 17.01 4.16 16.69 4.41 16.54C6.1 15.53 8.03 15 10 15C10.03 15 10.05 15 10.08 15.01C10.18 14.31 10.38 13.64 10.67 13.03C10.45 13.01 10.23 13 10 13C7.58 13 5.32 13.67 3.39 14.82C2.51 15.34 2 16.32 2 17.35V20H11.26C10.84 19.4 10.51 18.72 10.29 18H4ZM20.6938 15.3963C20.7225 15.5968 20.75 15.7892 20.75 16C20.75 16.2108 20.7225 16.4032 20.6938 16.6037L20.69 16.63L21.83 17.64L20.83 19.37L19.38 18.88C19.06 19.15 18.7 19.36 18.3 19.51L18 21H16L15.7 19.51C15.3 19.36 14.94 19.15 14.62 18.88L13.17 19.37L12.17 17.64L13.31 16.63C13.3088 16.6212 13.3075 16.6125 13.3063 16.6037C13.2776 16.4033 13.25 16.2108 13.25 16C13.25 15.7892 13.2776 15.5967 13.3063 15.3963C13.3075 15.3875 13.3088 15.3788 13.31 15.37L12.17 14.36L13.17 12.63L14.62 13.12C14.94 12.85 15.3 12.64 15.7 12.49L16 11H18L18.3 12.49C18.7 12.64 19.06 12.85 19.38 13.12L20.83 12.63L21.83 14.36L20.69 15.37L20.6938 15.3963ZM15 16C15 17.1 15.9 18 17 18C18.1 18 19 17.1 19 16C19 14.9 18.1 14 17 14C15.9 14 15 14.9 15 16Z",
            fill: "currentColor"
        })
    });


parcelRequire("acw62");

//#region src/components/icones/svg/perfil/targeta-subscriptor.svg?react
var $36ae4968f8444b46$export$2e2bcd8739ae039 = (t)=>/* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...t,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M20 2H4C2.89 2 2 2.89 2 4V15C2 16.11 2.89 17 4 17H8V22L12 20L16 22V17H20C21.11 17 22 16.11 22 15V4C22 2.89 21.11 2 20 2ZM20 15H4V13H20V15ZM20 10H4V4H20V10Z",
            fill: "currentColor"
        })
    });


parcelRequire("acw62");

//#region src/components/icones/svg/perfil/temes.svg?react
var $91de975cdf91158b$export$2e2bcd8739ae039 = (t)=>/* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...t,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M3 13H5V11H3V13ZM3 17H5V15H3V17ZM3 9H5V7H3V9ZM7 13H21V11H7V13ZM7 17H21V15H7V17ZM7 7V9H21V7H7ZM3 13H5V11H3V13ZM3 17H5V15H3V17ZM3 9H5V7H3V9ZM7 13H21V11H7V13ZM7 17H21V15H7V17ZM7 7V9H21V7H7Z",
            fill: "currentColor"
        })
    });


parcelRequire("acw62");

//#region src/components/icones/svg/perfil/us-de-dades.svg?react
var $5e54426c8dce4de6$export$2e2bcd8739ae039 = (t)=>/* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...t,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M12 3.19L19 6.3V11C19 15.52 16.02 19.69 12 20.93C7.98 19.69 5 15.52 5 11V6.3L12 3.19ZM12 1L3 5V11C3 16.55 6.84 21.74 12 23C17.16 21.74 21 16.55 21 11V5L12 1ZM11 7H13V9H11V7ZM11 11H13V17H11V11Z",
            fill: "currentColor"
        })
    });


parcelRequire("acw62");

//#region src/components/icones/svg/xxss/android.svg?react
var $4b997db0ada262a0$export$2e2bcd8739ae039 = (t)=>/* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...t,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M17.6 9.47997L19.44 6.29997C19.6 5.98997 19.48 5.60997 19.18 5.44997C18.89 5.29997 18.53 5.38997 18.35 5.66997L16.47 8.90997C13.61 7.69997 10.39 7.69997 7.53 8.90997L5.65 5.66997C5.46 5.37997 5.07 5.28997 4.78 5.46997C4.5 5.64997 4.41 6.00997 4.56 6.29997L6.4 9.47997C3.3 11.25 1.28 14.44 1 18H23C22.72 14.44 20.7 11.25 17.6 9.47997ZM7 15.25C6.31 15.25 5.75 14.69 5.75 14C5.75 13.31 6.31 12.75 7 12.75C7.69 12.75 8.25 13.31 8.25 14C8.25 14.69 7.69 15.25 7 15.25ZM17 15.25C16.31 15.25 15.75 14.69 15.75 14C15.75 13.31 16.31 12.75 17 12.75C17.69 12.75 18.25 13.31 18.25 14C18.25 14.69 17.69 15.25 17 15.25Z",
            fill: "currentColor"
        })
    });


parcelRequire("acw62");

//#region src/components/icones/svg/xxss/bluesky.svg?react
var $ea9a661c32dd7a0b$export$2e2bcd8739ae039 = (t)=>/* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...t,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M6.33526 4.18534C8.62822 5.90674 11.0945 9.39704 12.0001 11.2701C12.9056 9.39717 15.3718 5.90671 17.6649 4.18534C19.3193 2.94324 22 1.98218 22 5.04034C22 5.65109 21.6498 10.171 21.4445 10.9048C20.7306 13.4559 18.1292 14.1066 15.8152 13.7128C19.86 14.4012 20.8889 16.6815 18.6668 18.9617C14.4465 23.2924 12.601 17.8752 12.1278 16.4871C12.0412 16.2326 12.0006 16.1135 12 16.2148C11.9994 16.1135 11.9588 16.2326 11.8721 16.4871C11.3993 17.8752 9.55378 23.2925 5.33322 18.9617C3.11103 16.6815 4.13995 14.4011 8.18483 13.7128C5.87077 14.1066 3.26934 13.4559 2.55555 10.9048C2.35016 10.1709 2 5.65102 2 5.04034C2 1.98218 4.68074 2.94324 6.33515 4.18534H6.33526Z",
            fill: "currentColor"
        })
    });


parcelRequire("acw62");

//#region src/components/icones/svg/xxss/fb.svg?react
var $8a0e9008fc08259a$export$2e2bcd8739ae039 = (t)=>/* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...t,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M22 12C22 6.48 17.52 2 12 2C6.48 2 2 6.48 2 12C2 16.84 5.44 20.87 10 21.8V15H8V12H10V9.5C10 7.57 11.57 6 13.5 6H16V9H14C13.45 9 13 9.45 13 10V12H16V15H13V21.95C18.05 21.45 22 17.19 22 12Z",
            fill: "currentColor"
        })
    });


parcelRequire("acw62");

//#region src/components/icones/svg/xxss/google.svg?react
var $ad61c5a98e684146$export$2e2bcd8739ae039 = (n)=>/* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...n,
        children: [
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M20.64 12.2046C20.64 11.5664 20.5827 10.9527 20.4764 10.3636H12V13.845H16.8436C16.635 14.97 16.0009 15.9232 15.0477 16.5614V18.8196H17.9564C19.6582 17.2527 20.64 14.9455 20.64 12.2046Z",
                fill: "#4285F4"
            }),
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M12 21C14.43 21 16.4673 20.1941 17.9564 18.8195L15.0477 16.5613C14.2418 17.1013 13.2109 17.4204 12 17.4204C9.65591 17.4204 7.67182 15.8372 6.96409 13.71H3.95728V16.0418C5.43818 18.9831 8.48182 21 12 21Z",
                fill: "#34A853"
            }),
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M6.96409 13.7099C6.78409 13.1699 6.68182 12.5931 6.68182 11.9999C6.68182 11.4068 6.78409 10.8299 6.96409 10.2899V7.95813H3.95727C3.34773 9.17313 3 10.5477 3 11.9999C3 13.4522 3.34773 14.8268 3.95727 16.0418L6.96409 13.7099Z",
                fill: "#FBBC05"
            }),
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
                fillRule: "evenodd",
                clipRule: "evenodd",
                d: "M12 6.57955C13.3214 6.57955 14.5077 7.03364 15.4405 7.92545L18.0218 5.34409C16.4632 3.89182 14.4259 3 12 3C8.48182 3 5.43818 5.01682 3.95728 7.95818L6.96409 10.29C7.67182 8.16273 9.65591 6.57955 12 6.57955Z",
                fill: "#EA4335"
            })
        ]
    });


parcelRequire("acw62");

//#region src/components/icones/svg/xxss/ig.svg?react
var $e0fc8623ec746892$export$2e2bcd8739ae039 = (t)=>/* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...t,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M8 3C5.243 3 3 5.243 3 8V16C3 18.757 5.243 21 8 21H16C18.757 21 21 18.757 21 16V8C21 5.243 18.757 3 16 3H8ZM8 5H16C17.654 5 19 6.346 19 8V16C19 17.654 17.654 19 16 19H8C6.346 19 5 17.654 5 16V8C5 6.346 6.346 5 8 5ZM17 6C16.7348 6 16.4804 6.10536 16.2929 6.29289C16.1054 6.48043 16 6.73478 16 7C16 7.26522 16.1054 7.51957 16.2929 7.70711C16.4804 7.89464 16.7348 8 17 8C17.2652 8 17.5196 7.89464 17.7071 7.70711C17.8946 7.51957 18 7.26522 18 7C18 6.73478 17.8946 6.48043 17.7071 6.29289C17.5196 6.10536 17.2652 6 17 6ZM12 7C9.243 7 7 9.243 7 12C7 14.757 9.243 17 12 17C14.757 17 17 14.757 17 12C17 9.243 14.757 7 12 7ZM12 9C13.654 9 15 10.346 15 12C15 13.654 13.654 15 12 15C10.346 15 9 13.654 9 12C9 10.346 10.346 9 12 9Z",
            fill: "currentColor"
        })
    });


parcelRequire("acw62");

//#region src/components/icones/svg/xxss/ios.svg?react
var $80f5eae708bb9d6b$export$2e2bcd8739ae039 = (t)=>/* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...t,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M16.125 1.5C14.972 1.567 13.6483 2.20934 12.8613 3.02734C12.1503 3.77134 11.5894 4.87631 11.8184 5.94531C13.0714 5.97831 14.329 5.31933 15.082 4.48633C15.785 3.70733 16.318 2.62 16.125 1.5ZM16.1934 5.94336C14.3844 5.94336 13.628 7.05469 12.375 7.05469C11.086 7.05469 9.90766 6.01367 8.34766 6.01367C6.22566 6.01467 3 7.98033 3 12.6113C3 16.8243 6.81766 21.5 8.97266 21.5C10.2817 21.513 10.599 20.677 12.375 20.668C14.153 20.655 14.5367 21.511 15.8477 21.5C17.3237 21.489 18.4764 19.867 19.3184 18.582C19.9224 17.662 20.1707 17.1923 20.6387 16.1523C17.1657 15.2723 16.4747 9.67167 20.6387 8.51367C19.8527 7.17267 17.5584 5.94336 16.1934 5.94336Z",
            fill: "currentColor"
        })
    });


parcelRequire("acw62");

//#region src/components/icones/svg/xxss/linkedin.svg?react
var $9f89431164beab5e$export$2e2bcd8739ae039 = (t)=>/* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...t,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M17.25 3H6.75C4.67925 3 3 4.67925 3 6.75V17.25C3 19.3207 4.67925 21 6.75 21H17.25C19.3215 21 21 19.3207 21 17.25V6.75C21 4.67925 19.3215 3 17.25 3ZM9 17.25H6.75V9H9V17.25ZM7.875 8.049C7.1505 8.049 6.5625 7.4565 6.5625 6.726C6.5625 5.9955 7.1505 5.403 7.875 5.403C8.5995 5.403 9.1875 5.9955 9.1875 6.726C9.1875 7.4565 8.60025 8.049 7.875 8.049ZM18 17.25H15.75V13.047C15.75 10.521 12.75 10.7122 12.75 13.047V17.25H10.5V9H12.75V10.3237C13.797 8.38425 18 8.241 18 12.1807V17.25Z",
            fill: "currentColor"
        })
    });


parcelRequire("acw62");

//#region src/components/icones/svg/xxss/mail.svg?react
var $3a02c38c24ea59db$export$2e2bcd8739ae039 = (t)=>/* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...t,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M22 6C22 4.9 21.1 4 20 4H4C2.9 4 2 4.9 2 6V18C2 19.1 2.9 20 4 20H20C21.1 20 22 19.1 22 18V6ZM20 6L12 11L4 6H20ZM20 18H4V8L12 13L20 8V18Z",
            fill: "currentColor"
        })
    });


parcelRequire("acw62");

//#region src/components/icones/svg/xxss/rss.svg?react
var $b88bf70d2d4e2697$export$2e2bcd8739ae039 = (t)=>/* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...t,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M4 7.26994V4.43994C12.59 4.43994 19.56 11.4099 19.56 19.9999H16.73C16.73 12.9699 11.03 7.26994 4 7.26994ZM4 12.9299V10.0999C9.47 10.0999 13.9 14.5299 13.9 19.9999H11.07C11.07 16.0999 7.9 12.9299 4 12.9299ZM8.36 17.82C8.36 19.024 7.38398 20 6.18 20C4.97602 20 4 19.024 4 17.82C4 16.616 4.97602 15.64 6.18 15.64C7.38398 15.64 8.36 16.616 8.36 17.82Z",
            fill: "currentColor"
        })
    });


parcelRequire("acw62");

//#region src/components/icones/svg/xxss/tg.svg?react
var $d2444dce8f22c60c$export$2e2bcd8739ae039 = (t)=>/* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...t,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M2.20577 9.8311L21.3615 2.48987C22.2505 2.17062 23.027 2.70545 22.7389 4.04172L22.7406 4.04007L19.479 19.3133C19.2373 20.3961 18.5899 20.6594 17.6843 20.1493L12.7174 16.5108L10.3217 18.8048C10.0568 19.0681 9.83327 19.2903 9.32003 19.2903L9.67268 14.2661L18.878 6.00002C19.2787 5.64951 18.7886 5.45203 18.2605 5.80091L6.88459 12.92L1.9806 11.3994C0.916027 11.0637 0.892848 10.3412 2.20577 9.8311Z",
            fill: "currentColor"
        })
    });


parcelRequire("acw62");

//#region src/components/icones/svg/xxss/tw-old.svg?react
var $9c50853bca1a8e5d$export$2e2bcd8739ae039 = (t)=>/* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...t,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M22 3.99902C21.22 4.46202 19.655 5.09302 18.735 5.27502C18.708 5.28202 18.686 5.29102 18.66 5.29802C17.847 4.49602 16.733 3.99902 15.5 3.99902C13.015 3.99902 11 6.01402 11 8.49902C11 8.63002 10.989 8.87102 11 8.99902C7.64702 8.99902 5.09502 7.24302 3.26502 4.99902C3.06602 5.49902 2.97902 6.28902 2.97902 7.03102C2.97902 8.43202 4.07402 9.80802 5.77902 10.661C5.46502 10.742 5.11902 10.8 4.75902 10.8C4.17802 10.8 3.56302 10.647 3.00002 10.183C3.00002 10.2 3.00002 10.216 3.00002 10.234C3.00002 12.192 5.07802 13.525 6.92602 13.896C6.55102 14.117 5.79502 14.139 5.42602 14.139C5.16602 14.139 4.24602 14.02 4.00002 13.974C4.51402 15.579 6.36802 16.481 8.13502 16.513C6.75302 17.597 5.79402 17.999 2.96402 17.999H2.00002C3.78802 19.145 6.06502 20 8.34702 20C15.777 20 20 14.337 20 8.99902C20 8.91302 19.998 8.73302 19.995 8.55202C19.995 8.53402 20 8.51702 20 8.49902C20 8.47202 19.992 8.44602 19.992 8.41902C19.989 8.28302 19.986 8.15602 19.983 8.09002C20.773 7.52002 21.458 6.80902 22 5.99902C21.275 6.32102 20.497 6.53702 19.68 6.63502C20.514 6.13502 21.699 4.94302 22 3.99902Z",
            fill: "currentColor"
        })
    });


parcelRequire("acw62");

//#region src/components/icones/svg/xxss/wikipedia.svg?react
var $37cf77c4909d4df7$export$2e2bcd8739ae039 = (t)=>/* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...t,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M17.5 5.37347V5H13.292V5.37347C13.3747 5.38694 13.4332 5.39703 13.4677 5.40375C13.943 5.47778 14.1691 5.60395 14.3689 5.78226C14.5686 5.9606 14.6685 6.14733 14.6686 6.34247C14.6685 6.57845 14.5054 6.9595 14.2802 7.48562C14.2164 7.63463 14.1476 7.79527 14.0761 7.96756L13.0526 9.9145L12.0559 7.86662C11.732 7.15334 11.57 6.62847 11.57 6.292C11.57 6.04976 11.6686 5.85125 11.8658 5.69647C12.0629 5.54171 12.3785 5.43404 13.0404 5.37347V5H7.41671V5.37347C7.85329 5.40713 8.08613 5.48283 8.34315 5.60058C8.60017 5.71835 8.81671 5.88153 8.99275 6.09012C9.00872 6.10919 9.02992 6.133 9.05533 6.16153C9.20924 6.33433 9.51769 6.68064 9.7534 7.20043L11.9631 11.9868L9.91061 15.8911L5.65019 7.86662C5.33328 7.15334 5.17483 6.62847 5.17484 6.292C5.17483 6.04976 5.27128 5.85125 5.46418 5.69647C5.65707 5.54171 5.96581 5.43404 6.6134 5.37347V5H1V5.37347C1.42713 5.40713 1.76642 5.48283 2.01788 5.60058C2.26933 5.71835 2.48117 5.88153 2.6534 6.09012C2.66902 6.10919 2.68976 6.133 2.71462 6.16152C2.8652 6.33433 3.16696 6.68064 3.39757 7.20043L9.16658 19H9.54892L12.4687 13.0818L15.2009 19H15.5917L20.7467 7.35184C21.0354 6.67221 21.4755 6.16752 21.8487 5.83778C22.1092 5.61573 22.493 5.46096 23 5.37347V5H18.5849V5.37347C18.6694 5.38694 18.7292 5.39703 18.7644 5.40375C19.2503 5.47778 19.5953 5.60395 19.7996 5.78226C20.0038 5.9606 20.1059 6.14733 20.1059 6.34247C20.1059 6.57845 19.9391 6.9595 19.7089 7.48562C19.6437 7.63463 19.5734 7.79527 19.5003 7.96756L15.9614 15.8911L13.5386 10.9131L15.2955 7.35184C15.578 6.67221 16.0085 6.16752 16.3736 5.83778C16.6285 5.61573 17.004 5.46096 17.5 5.37347Z",
            fill: "currentColor"
        })
    });


parcelRequire("acw62");

//#region src/components/icones/svg/xxss/wp.svg?react
var $6aceabe7e9b6c569$export$2e2bcd8739ae039 = (t)=>/* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...t,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M12.0117 2C6.50572 2 2.02348 6.47837 2.02148 11.9844C2.02048 13.7444 2.48147 15.4626 3.35547 16.9766L2 22L7.23242 20.7637C8.69142 21.5597 10.3339 21.9775 12.0059 21.9785H12.0098C17.5148 21.9785 21.995 17.4991 21.998 11.9941C22 9.32514 20.9622 6.81573 19.0762 4.92773C17.1902 3.04073 14.6837 2.001 12.0117 2ZM12.0098 4C14.1458 4.001 16.1531 4.8338 17.6621 6.3418C19.1711 7.8518 20 9.85819 19.998 11.9922C19.996 16.3962 16.4138 19.9785 12.0078 19.9785C10.6748 19.9775 9.35441 19.6428 8.19141 19.0078L7.51758 18.6406L6.77344 18.8164L4.80469 19.2812L5.28516 17.4961L5.50195 16.6953L5.08789 15.9766C4.38989 14.7686 4.02048 13.3874 4.02148 11.9844C4.02348 7.58238 7.60677 4 12.0098 4ZM8.47656 7.375C8.30956 7.375 8.03955 7.4375 7.81055 7.6875C7.58155 7.9365 6.93555 8.53958 6.93555 9.76758C6.93555 10.9956 7.83008 12.1826 7.95508 12.3496C8.07908 12.5156 9.68175 15.1152 12.2188 16.1152C14.3267 16.9462 14.7549 16.7822 15.2129 16.7402C15.6709 16.6992 16.6904 16.1377 16.8984 15.5547C17.1064 14.9717 17.1069 14.4702 17.0449 14.3672C16.9829 14.2632 16.8164 14.2012 16.5664 14.0762C16.3174 13.9512 15.0903 13.3486 14.8613 13.2656C14.6323 13.1826 14.4648 13.1406 14.2988 13.3906C14.1328 13.6406 13.6558 14.2012 13.5098 14.3672C13.3638 14.5342 13.2188 14.5566 12.9688 14.4316C12.7188 14.3056 11.9149 14.0414 10.9609 13.1914C10.2189 12.5304 9.71827 11.7148 9.57227 11.4648C9.42727 11.2158 9.55859 11.0791 9.68359 10.9551C9.79559 10.8431 9.93164 10.6636 10.0566 10.5176C10.1806 10.3716 10.2236 10.2676 10.3066 10.1016C10.3896 9.93556 10.3472 9.78906 10.2852 9.66406C10.2232 9.53906 9.73763 8.3065 9.51562 7.8125C9.32863 7.3975 9.13112 7.38786 8.95312 7.38086C8.80813 7.37486 8.64256 7.375 8.47656 7.375Z",
            fill: "currentColor"
        })
    });


parcelRequire("acw62");

//#region src/components/icones/svg/xxss/x.svg?react
var $379ea7ed10bc7222$export$2e2bcd8739ae039 = (t)=>/* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...t,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M13.7124 10.6218L20.4134 3H18.8255L13.0071 9.61788L8.35992 3H3L10.0274 13.0074L3 21H4.58799L10.7324 14.0113L15.6401 21H21L13.7121 10.6218H13.7124ZM11.5375 13.0956L10.8255 12.0991L5.16017 4.16971H7.59923L12.1712 10.5689L12.8832 11.5655L18.8262 19.8835H16.3871L11.5375 13.096V13.0956Z",
            fill: "currentColor"
        })
    });


parcelRequire("acw62");

//#region src/components/icones/svg/xxss/yt.svg?react
var $8a4c9670b236eaaa$export$2e2bcd8739ae039 = (t)=>/* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("svg", {
        width: 24,
        height: 24,
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...t,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
            d: "M21.582 6.186C21.352 5.326 20.674 4.648 19.814 4.418C18.254 4 12 4 12 4C12 4 5.746 4 4.186 4.418C3.326 4.648 2.648 5.326 2.418 6.186C2 7.746 2 12 2 12C2 12 2 16.254 2.418 17.814C2.648 18.674 3.326 19.352 4.186 19.582C5.746 20 12 20 12 20C12 20 18.254 20 19.814 19.582C20.675 19.352 21.352 18.674 21.582 17.814C22 16.254 22 12 22 12C22 12 22 7.746 21.582 6.186ZM10 15.464V8.536L16 12L10 15.464Z",
            fill: "currentColor"
        })
    });


//#region src/components/icones/types.ts
var $f0bfd873d1a54ebf$export$85737a9953eb7c0a = /* @__PURE__ */ "barra-accions/comenta.barra-accions/comparteix.barra-accions/concurrents.barra-accions/guarda.barra-accions/guardats-ple.barra-accions/imatges-fotogaleria.barra-accions/like.barra-accions/regala.barra-accions/temps-lectura.boto-txt/add.boto-txt/check.comentaris/deixa-de-seguir.comentaris/denuncia.comentaris/denunciat.comentaris/desilencia.comentaris/mes.comentaris/perfil.comentaris/respon.comentaris/segueix.comentaris/silencia.menu/descobreix.menu/jocs.menu/logo.menu/log-out.menu/seccions.menu/ultima-hora.menu/ultima-hora-actiu.multimedia/arxius.multimedia/audio.multimedia/enquesta.multimedia/fotogaleria.multimedia/grafic.multimedia/interactiu.multimedia/mur.multimedia/test.multimedia/video.navegacio/afegeix.navegacio/ajuda.navegacio/alerta.navegacio/anterior.navegacio/buscar.navegacio/buscar-off.navegacio/check-box/buit.navegacio/check-box/null.navegacio/check-box/ple.navegacio/confirma-accio.navegacio/descarrega.navegacio/desplega.navegacio/direccio.navegacio/editar.navegacio/encert.navegacio/endarrere.navegacio/endavant.navegacio/error.navegacio/esborra.navegacio/estrella-0.navegacio/estrella-0-5.navegacio/estrella-1.navegacio/external.navegacio/no-encert.navegacio/pause.navegacio/play.navegacio/plega.navegacio/radiobutton-off.navegacio/radiobutton-on.navegacio/refresca.navegacio/seguent.navegacio/tanca.navegacio/visualitzar-off.navegacio/visualitzar-on.perfil/articles-regalats.perfil/botiga.perfil/canvi-edicio.perfil/club-premium.perfil/columnes.perfil/comentaris.perfil/condicions-generals.perfil/configuracio.perfil/consentiment.perfil/contacta.perfil/contrasenya.perfil/convida-amic.perfil/cost.perfil/dades.perfil/espai-del-subscriptor.perfil/firmes.perfil/funcio-tancada.perfil/gestio-descarregues.perfil/guardats.perfil/info.perfil/ios.perfil/lectors.perfil/mode.perfil/newsletters.perfil/notificacions.perfil/notificacions-1.perfil/punt-de-venda.perfil/punts-de-venda.perfil/seguint.perfil/subscripcio.perfil/targeta-subscriptor.perfil/temes.perfil/us-de-dades.xxss/android.xxss/bluesky.xxss/fb.xxss/google.xxss/ig.xxss/ios.xxss/linkedin.xxss/mail.xxss/rss.xxss/tg.xxss/tw-old.xxss/wikipedia.xxss/wp.xxss/x.xxss/yt".split(".");



//#region src/components/icones/index.tsx
var $2a183a46947eafc4$var$pt = Object.entries(/* @__PURE__ */ Object.assign({
    "./svg/barra-accions/comenta.svg": (0, $973b9146f3756d1c$export$2e2bcd8739ae039),
    "./svg/barra-accions/comparteix.svg": (0, $5f88a93f63a76718$export$2e2bcd8739ae039),
    "./svg/barra-accions/concurrents.svg": (0, $a934b4450e4f1b04$export$2e2bcd8739ae039),
    "./svg/barra-accions/guarda.svg": (0, $b42a738766dcbe21$export$2e2bcd8739ae039),
    "./svg/barra-accions/guardats-ple.svg": (0, $d9dcd8600386b8b0$export$2e2bcd8739ae039),
    "./svg/barra-accions/imatges-fotogaleria.svg": (0, $8e31e2f62c4708a1$export$2e2bcd8739ae039),
    "./svg/barra-accions/like.svg": (0, $b0e35be5ed982988$export$2e2bcd8739ae039),
    "./svg/barra-accions/regala.svg": (0, $13d59f9cadebb796$export$2e2bcd8739ae039),
    "./svg/barra-accions/temps-lectura.svg": (0, $780f851f62e41878$export$2e2bcd8739ae039),
    "./svg/boto-txt/add.svg": (0, $2dd5a364d1134466$export$2e2bcd8739ae039),
    "./svg/boto-txt/check.svg": (0, $976f59050c045dcc$export$2e2bcd8739ae039),
    "./svg/comentaris/deixa-de-seguir.svg": (0, $4a263096607b5985$export$2e2bcd8739ae039),
    "./svg/comentaris/denuncia.svg": (0, $5f974cc1d9e54f23$export$2e2bcd8739ae039),
    "./svg/comentaris/denunciat.svg": (0, $74805a3475ea0dae$export$2e2bcd8739ae039),
    "./svg/comentaris/desilencia.svg": (0, $f0c513577aab84b3$export$2e2bcd8739ae039),
    "./svg/comentaris/mes.svg": (0, $9760da9b9ac82366$export$2e2bcd8739ae039),
    "./svg/comentaris/perfil.svg": (0, $aff3cdd86f90c051$export$2e2bcd8739ae039),
    "./svg/comentaris/respon.svg": (0, $43aa37dba422056f$export$2e2bcd8739ae039),
    "./svg/comentaris/segueix.svg": (0, $dfdd4fd7d559275a$export$2e2bcd8739ae039),
    "./svg/comentaris/silencia.svg": (0, $60745f8ce6d17b27$export$2e2bcd8739ae039),
    "./svg/menu/descobreix.svg": (0, $28d48aa2b07e9769$export$2e2bcd8739ae039),
    "./svg/menu/jocs.svg": (0, $4133bb805d61a9b6$export$2e2bcd8739ae039),
    "./svg/menu/log-out.svg": (0, $5c2005a21d543783$export$2e2bcd8739ae039),
    "./svg/menu/logo.svg": (0, $b5f3dfa39a516548$export$2e2bcd8739ae039),
    "./svg/menu/seccions.svg": (0, $fab4f43b6e677d91$export$2e2bcd8739ae039),
    "./svg/menu/ultima-hora-actiu.svg": (0, $f6eabb0c0a522dba$export$2e2bcd8739ae039),
    "./svg/menu/ultima-hora.svg": (0, $222b30207139f37f$export$2e2bcd8739ae039),
    "./svg/multimedia/arxius.svg": (0, $59ad0c9d4550fcdb$export$2e2bcd8739ae039),
    "./svg/multimedia/audio.svg": (0, $335d7c4c5baec0b1$export$2e2bcd8739ae039),
    "./svg/multimedia/enquesta.svg": (0, $a37fd0b4b334c538$export$2e2bcd8739ae039),
    "./svg/multimedia/fotogaleria.svg": (0, $32dbb89a6b5d1502$export$2e2bcd8739ae039),
    "./svg/multimedia/grafic.svg": (0, $684f6b28345da2ee$export$2e2bcd8739ae039),
    "./svg/multimedia/interactiu.svg": (0, $fbb3b8577f5677f1$export$2e2bcd8739ae039),
    "./svg/multimedia/mur.svg": (0, $667852d9fe5f7731$export$2e2bcd8739ae039),
    "./svg/multimedia/test.svg": (0, $68d666b67e12680d$export$2e2bcd8739ae039),
    "./svg/multimedia/video.svg": (0, $dced43b7f5fe462d$export$2e2bcd8739ae039),
    "./svg/navegacio/afegeix.svg": (0, $e32a9f4d466b2c80$export$2e2bcd8739ae039),
    "./svg/navegacio/ajuda.svg": (0, $bb5f20cb0362f406$export$2e2bcd8739ae039),
    "./svg/navegacio/alerta.svg": (0, $12a1cf435e3d72c3$export$2e2bcd8739ae039),
    "./svg/navegacio/anterior.svg": (0, $6c7672d54a0b3949$export$2e2bcd8739ae039),
    "./svg/navegacio/buscar-off.svg": (0, $593721420e829dcf$export$2e2bcd8739ae039),
    "./svg/navegacio/buscar.svg": (0, $bcdd2bfdd941818f$export$2e2bcd8739ae039),
    "./svg/navegacio/check-box/buit.svg": (0, $22929fc32dfa35fb$export$2e2bcd8739ae039),
    "./svg/navegacio/check-box/null.svg": (0, $88f3e0cf612d4287$export$2e2bcd8739ae039),
    "./svg/navegacio/check-box/ple.svg": (0, $65349c354de9839d$export$2e2bcd8739ae039),
    "./svg/navegacio/confirma-accio.svg": (0, $8096dcfc0a138855$export$2e2bcd8739ae039),
    "./svg/navegacio/descarrega.svg": (0, $70ffd2b98af0d7a4$export$2e2bcd8739ae039),
    "./svg/navegacio/desplega.svg": (0, $ad24819314ef8701$export$2e2bcd8739ae039),
    "./svg/navegacio/direccio.svg": (0, $dda423fcf078e816$export$2e2bcd8739ae039),
    "./svg/navegacio/editar.svg": (0, $c65e04ff4f28781e$export$2e2bcd8739ae039),
    "./svg/navegacio/encert.svg": (0, $e9357884128ebb58$export$2e2bcd8739ae039),
    "./svg/navegacio/endarrere.svg": (0, $e64f03f6fac35391$export$2e2bcd8739ae039),
    "./svg/navegacio/endavant.svg": (0, $e639092e3392a364$export$2e2bcd8739ae039),
    "./svg/navegacio/error.svg": (0, $01e040087b463d48$export$2e2bcd8739ae039),
    "./svg/navegacio/esborra.svg": (0, $0414bb8eb83f999b$export$2e2bcd8739ae039),
    "./svg/navegacio/estrella-0-5.svg": (0, $9ef6be975a2dd900$export$2e2bcd8739ae039),
    "./svg/navegacio/estrella-0.svg": (0, $69d8243b40d1bda5$export$2e2bcd8739ae039),
    "./svg/navegacio/estrella-1.svg": (0, $59011d7dc3f50d04$export$2e2bcd8739ae039),
    "./svg/navegacio/external.svg": (0, $fd3bf2218888a7af$export$2e2bcd8739ae039),
    "./svg/navegacio/no-encert.svg": (0, $39cf54df8493717d$export$2e2bcd8739ae039),
    "./svg/navegacio/pause.svg": (0, $a57d629012e494cf$export$2e2bcd8739ae039),
    "./svg/navegacio/play.svg": (0, $0d76b29c3926fa84$export$2e2bcd8739ae039),
    "./svg/navegacio/plega.svg": (0, $20ee0111bbe95950$export$2e2bcd8739ae039),
    "./svg/navegacio/radiobutton-off.svg": (0, $20c17079391acc98$export$2e2bcd8739ae039),
    "./svg/navegacio/radiobutton-on.svg": (0, $25d93415cabe880c$export$2e2bcd8739ae039),
    "./svg/navegacio/refresca.svg": (0, $d702a5048d8b699d$export$2e2bcd8739ae039),
    "./svg/navegacio/seguent.svg": (0, $bf96aa917d0575e0$export$2e2bcd8739ae039),
    "./svg/navegacio/tanca.svg": (0, $cb7a6bc44d233349$export$2e2bcd8739ae039),
    "./svg/navegacio/visualitzar-off.svg": (0, $2c5f31ee74455dc2$export$2e2bcd8739ae039),
    "./svg/navegacio/visualitzar-on.svg": (0, $4161fa40a0cfeb34$export$2e2bcd8739ae039),
    "./svg/perfil/articles-regalats.svg": (0, $1de02fb29f161575$export$2e2bcd8739ae039),
    "./svg/perfil/botiga.svg": (0, $b456db26a148e840$export$2e2bcd8739ae039),
    "./svg/perfil/canvi-edicio.svg": (0, $bf7bffdda2e4f158$export$2e2bcd8739ae039),
    "./svg/perfil/club-premium.svg": (0, $f858e4de1c65ea20$export$2e2bcd8739ae039),
    "./svg/perfil/columnes.svg": (0, $d1c17defbdad1e45$export$2e2bcd8739ae039),
    "./svg/perfil/comentaris.svg": (0, $fb4f3fd935a4ec40$export$2e2bcd8739ae039),
    "./svg/perfil/condicions-generals.svg": (0, $e73adee30cf0099d$export$2e2bcd8739ae039),
    "./svg/perfil/configuracio.svg": (0, $a7b4a93a86bedd6f$export$2e2bcd8739ae039),
    "./svg/perfil/consentiment.svg": (0, $f48d409f688f9297$export$2e2bcd8739ae039),
    "./svg/perfil/contacta.svg": (0, $2b13479a9dc01330$export$2e2bcd8739ae039),
    "./svg/perfil/contrasenya.svg": (0, $f6038ac8764d777c$export$2e2bcd8739ae039),
    "./svg/perfil/convida-amic.svg": (0, $23e16f1cc9315e70$export$2e2bcd8739ae039),
    "./svg/perfil/cost.svg": (0, $5fa14409925086d8$export$2e2bcd8739ae039),
    "./svg/perfil/dades.svg": (0, $efa830fba4d6bbfd$export$2e2bcd8739ae039),
    "./svg/perfil/espai-del-subscriptor.svg": (0, $309052f5432c6d9f$export$2e2bcd8739ae039),
    "./svg/perfil/firmes.svg": (0, $f805fcd157e462b2$export$2e2bcd8739ae039),
    "./svg/perfil/funcio-tancada.svg": (0, $5502159c3049d4f7$export$2e2bcd8739ae039),
    "./svg/perfil/gestio-descarregues.svg": (0, $b273d47bd70666dd$export$2e2bcd8739ae039),
    "./svg/perfil/guardats.svg": (0, $d22225c88c3fa9f3$export$2e2bcd8739ae039),
    "./svg/perfil/info.svg": (0, $68799f133cbc03dd$export$2e2bcd8739ae039),
    "./svg/perfil/ios.svg": (0, $74716b3569a6adce$export$2e2bcd8739ae039),
    "./svg/perfil/lectors.svg": (0, $9e3ca046cb64712f$export$2e2bcd8739ae039),
    "./svg/perfil/mode.svg": (0, $7eeb1b1bba2a6aa8$export$2e2bcd8739ae039),
    "./svg/perfil/newsletters.svg": (0, $b41948f1e689117f$export$2e2bcd8739ae039),
    "./svg/perfil/notificacions-1.svg": (0, $f091c5aeee8670f1$export$2e2bcd8739ae039),
    "./svg/perfil/notificacions.svg": (0, $3bb6817bd4c7cda4$export$2e2bcd8739ae039),
    "./svg/perfil/punt-de-venda.svg": (0, $ca53114d2eb8007f$export$2e2bcd8739ae039),
    "./svg/perfil/punts-de-venda.svg": (0, $1165a3654cdaed70$export$2e2bcd8739ae039),
    "./svg/perfil/seguint.svg": (0, $dac9afcd847475da$export$2e2bcd8739ae039),
    "./svg/perfil/subscripcio.svg": (0, $e976fdf9ec97bf65$export$2e2bcd8739ae039),
    "./svg/perfil/targeta-subscriptor.svg": (0, $36ae4968f8444b46$export$2e2bcd8739ae039),
    "./svg/perfil/temes.svg": (0, $91de975cdf91158b$export$2e2bcd8739ae039),
    "./svg/perfil/us-de-dades.svg": (0, $5e54426c8dce4de6$export$2e2bcd8739ae039),
    "./svg/xxss/android.svg": (0, $4b997db0ada262a0$export$2e2bcd8739ae039),
    "./svg/xxss/bluesky.svg": (0, $ea9a661c32dd7a0b$export$2e2bcd8739ae039),
    "./svg/xxss/fb.svg": (0, $8a0e9008fc08259a$export$2e2bcd8739ae039),
    "./svg/xxss/google.svg": (0, $ad61c5a98e684146$export$2e2bcd8739ae039),
    "./svg/xxss/ig.svg": (0, $e0fc8623ec746892$export$2e2bcd8739ae039),
    "./svg/xxss/ios.svg": (0, $80f5eae708bb9d6b$export$2e2bcd8739ae039),
    "./svg/xxss/linkedin.svg": (0, $9f89431164beab5e$export$2e2bcd8739ae039),
    "./svg/xxss/mail.svg": (0, $3a02c38c24ea59db$export$2e2bcd8739ae039),
    "./svg/xxss/rss.svg": (0, $b88bf70d2d4e2697$export$2e2bcd8739ae039),
    "./svg/xxss/tg.svg": (0, $d2444dce8f22c60c$export$2e2bcd8739ae039),
    "./svg/xxss/tw-old.svg": (0, $9c50853bca1a8e5d$export$2e2bcd8739ae039),
    "./svg/xxss/wikipedia.svg": (0, $37cf77c4909d4df7$export$2e2bcd8739ae039),
    "./svg/xxss/wp.svg": (0, $6aceabe7e9b6c569$export$2e2bcd8739ae039),
    "./svg/xxss/x.svg": (0, $379ea7ed10bc7222$export$2e2bcd8739ae039),
    "./svg/xxss/yt.svg": (0, $8a4c9670b236eaaa$export$2e2bcd8739ae039)
})).reduce((e, [t, n])=>{
    let r = t.replace(/^\.\/svg\//, "").replace(/\.svg$/i, "").replace(/\\/g, "/").toLowerCase();
    return e[r] = n, e;
}, {}), $2a183a46947eafc4$export$a46bff82a64f449 = (0, $f0bfd873d1a54ebf$export$85737a9953eb7c0a), $2a183a46947eafc4$export$fbe2f6ebbbe0cd5a = ({ name: e, size: t = "24px", color: n, title: r, fallback: i = null, style: a, ...o })=>{
    let s = $2a183a46947eafc4$var$pt[e];
    return s ? /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(s, {
        width: t,
        height: t,
        focusable: "false",
        "aria-hidden": r ? void 0 : !0,
        role: r ? "img" : void 0,
        ...o,
        style: {
            ...a,
            color: n ?? a?.color
        },
        children: r ? /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("title", {
            children: r
        }) : null
    }) : /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {
        children: i
    });
};


//#region \0rolldown/runtime.js
var $14b872f206384382$var$e = Object.create, $14b872f206384382$var$t = Object.defineProperty, $14b872f206384382$var$n = Object.getOwnPropertyDescriptor, $14b872f206384382$var$r = Object.getOwnPropertyNames, $14b872f206384382$var$i = Object.getPrototypeOf, $14b872f206384382$var$a = Object.prototype.hasOwnProperty, $14b872f206384382$export$e1ac61be52371773 = (e, t)=>()=>(t || (e((t = {
            exports: {}
        }).exports, t), e = null), t.exports), $14b872f206384382$var$s = (e, i, o, s)=>{
    if (i && typeof i == "object" || typeof i == "function") for(var c = $14b872f206384382$var$r(i), l = 0, u = c.length, d; l < u; l++)d = c[l], !$14b872f206384382$var$a.call(e, d) && d !== o && $14b872f206384382$var$t(e, d, {
        get: ((e)=>i[e]).bind(null, d),
        enumerable: !(s = $14b872f206384382$var$n(i, d)) || s.enumerable
    });
    return e;
}, $14b872f206384382$export$82dec27a9dce9602 = (n, r, a)=>(a = n == null ? {} : $14b872f206384382$var$e($14b872f206384382$var$i(n)), $14b872f206384382$var$s(r || !n || !n.__esModule ? $14b872f206384382$var$t(a, "default", {
        value: n,
        enumerable: !0
    }) : a, n));



//#region node_modules/classnames/index.js
var $ba4d14fce8721970$export$f998fc56051369ed = /* @__PURE__ */ (0, $14b872f206384382$export$e1ac61be52371773)((e, t)=>{
    (function() {
        var e = {}.hasOwnProperty;
        function n() {
            for(var e = "", t = 0; t < arguments.length; t++){
                var n = arguments[t];
                n && (e = i(e, r(n)));
            }
            return e;
        }
        function r(t) {
            if (typeof t == "string" || typeof t == "number") return t;
            if (typeof t != "object") return "";
            if (Array.isArray(t)) return n.apply(null, t);
            if (t.toString !== Object.prototype.toString && !t.toString.toString().includes("[native code]")) return t.toString();
            var r = "";
            for(var a in t)e.call(t, a) && t[a] && (r = i(r, a));
            return r;
        }
        function i(e, t) {
            return t ? e ? e + " " + t : e + t : e;
        }
        t !== void 0 && t.exports ? (n.default = n, t.exports = n) : typeof define == "function" && typeof define.amd == "object" && define.amd ? define("classnames", [], function() {
            return n;
        }) : window.classNames = n;
    })();
});
var //#endregion
$ba4d14fce8721970$export$2e2bcd8739ae039 = $ba4d14fce8721970$export$f998fc56051369ed();


var $2f4c28208499c42a$export$2e2bcd8739ae039 = {
    container: "ara-ui_boto-ara-container_1gjm",
    simple: "ara-ui_boto-ara-simple_nLi5",
    primari: "ara-ui_boto-ara-primari_z2aC",
    secondari: "ara-ui_boto-ara-secondari_aPsx",
    solid: "ara-ui_boto-ara-solid_lAPq",
    mix: "ara-ui_boto-ara-mix_k6Oa",
    premium: "ara-ui_boto-ara-premium_zK8V",
    outline: "ara-ui_boto-ara-outline_CC9B",
    subscripcio: "ara-ui_boto-ara-subscripcio_HqfH",
    disabled: "ara-ui_boto-ara-disabled_HZdy",
    color: "ara-ui_boto-ara-color_Q-dy",
    soft: "ara-ui_boto-ara-soft_ctDr",
    personalitzat: "ara-ui_boto-ara-personalitzat_UFqc",
    hoverContent: "ara-ui_boto-ara-hoverContent_IfMF",
    round: "ara-ui_boto-ara-round_-huX"
};




var $acw62 = parcelRequire("acw62");
//#region src/components/boto-ara/shared.ts
var $a8f58a7e77290ca9$var$o = /* @__PURE__ */ (0, $14b872f206384382$export$82dec27a9dce9602)((0, $ba4d14fce8721970$export$f998fc56051369ed)(), 1), $a8f58a7e77290ca9$var$s = (e)=>e === "secondari" ? "outline" : "solid", $a8f58a7e77290ca9$export$7c24ba817a70e952 = ({ className: e, tipus: t = "primari", solidesa: r, simple: i = !1, round: a = !1, disabled: c = !1, includeDisabledClass: l = !1 })=>{
    let u = r ?? $a8f58a7e77290ca9$var$s(t), d = !!i, f = i === !0 ? "hard" : i === "accent" ? "color" : i;
    return {
        classes: (0, $a8f58a7e77290ca9$var$o.default)((0, $2f4c28208499c42a$export$2e2bcd8739ae039).container, e, {
            [(0, $2f4c28208499c42a$export$2e2bcd8739ae039).personalitzat]: t === "personalitzat" && !c,
            [(0, $2f4c28208499c42a$export$2e2bcd8739ae039).primari]: t === "primari" && !c && !d,
            [(0, $2f4c28208499c42a$export$2e2bcd8739ae039).secondari]: t === "secondari" && !c && !d,
            [(0, $2f4c28208499c42a$export$2e2bcd8739ae039).premium]: t === "premium" && !c && !d,
            [(0, $2f4c28208499c42a$export$2e2bcd8739ae039).subscripcio]: t === "subscripcio" && !c && !d,
            [(0, $2f4c28208499c42a$export$2e2bcd8739ae039).solid]: u === "solid" && !c && !d,
            [(0, $2f4c28208499c42a$export$2e2bcd8739ae039).outline]: u === "outline" && !c && !d,
            [(0, $2f4c28208499c42a$export$2e2bcd8739ae039).mix]: u === "mix" && !c && !d,
            [(0, $2f4c28208499c42a$export$2e2bcd8739ae039).simple]: d,
            [(0, $2f4c28208499c42a$export$2e2bcd8739ae039).color]: f === "color",
            [(0, $2f4c28208499c42a$export$2e2bcd8739ae039).soft]: f === "soft",
            [(0, $2f4c28208499c42a$export$2e2bcd8739ae039).round]: a && (t === "secondari" || t === "personalitzat"),
            [(0, $2f4c28208499c42a$export$2e2bcd8739ae039).disabled]: l && c
        }),
        esSimple: d
    };
}, $a8f58a7e77290ca9$export$d65ec7cc0f14562d = ({ esSimple: e, icona: t, children: o, hoverOverlay: s = !1 })=>{
    if (e) return o;
    let c = (0, $acw62.createElement)("span", null, t ? (0, $acw62.createElement)((0, $2a183a46947eafc4$export$fbe2f6ebbbe0cd5a), {
        name: t,
        size: 20
    }) : null, o);
    return s ? (0, $acw62.createElement)((0, $acw62.Fragment), null, c, (0, $acw62.createElement)("span", {
        className: (0, $2f4c28208499c42a$export$2e2bcd8739ae039).hoverContent,
        "aria-hidden": !0,
        inert: !0
    }, c)) : c;
}, $a8f58a7e77290ca9$export$21a26f4716ae21df = ({ colorText: e, colorFons: t, colorVora: n, colorIcona: r, colorHover: i, colorTextHover: a, colorIconaHover: o }, s)=>({
        "--boto-text": e,
        "--boto-fons": t,
        "--boto-vora": n,
        "--boto-icona": r,
        "--boto-hover": i,
        "--boto-text-hover": a,
        "--boto-icona-hover": o ?? (a === void 0 ? void 0 : "currentColor"),
        ...s
    });



//#region src/components/boto-ara/BotoAra.tsx
var $e5b45ea74e28b54b$export$6996e762581de38a = ({ children: i, className: a = "", tipus: o = "primari", solidesa: s, simple: c = !1, round: l = !1, icona: u, colorText: d, colorFons: f, colorVora: p, colorIcona: m, colorHover: h, colorTextHover: g, colorIconaHover: _, style: v, ...y })=>{
    let { disabled: b } = y, { classes: x, esSimple: S } = (0, $a8f58a7e77290ca9$export$7c24ba817a70e952)({
        className: a,
        tipus: o,
        solidesa: s,
        simple: c,
        round: l,
        disabled: b
    });
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("button", {
        className: x,
        style: o === "personalitzat" ? (0, $a8f58a7e77290ca9$export$21a26f4716ae21df)({
            colorText: d,
            colorFons: f,
            colorVora: p,
            colorIcona: m,
            colorHover: h,
            colorTextHover: g,
            colorIconaHover: _
        }, v) : v,
        ...y,
        children: (0, $a8f58a7e77290ca9$export$d65ec7cc0f14562d)({
            esSimple: S,
            icona: u,
            children: i,
            hoverOverlay: o === "personalitzat" && !b && (g !== void 0 || _ !== void 0)
        })
    });
};




//#region src/components/boto-ara/LinkAra.tsx
var $153631a56be0d02b$export$27c8cfb9e5df6130 = ({ children: i, className: a = "", tipus: o = "primari", solidesa: s, simple: c = !1, disabled: l = !1, round: u = !1, icona: d, colorText: f, colorFons: p, colorVora: m, colorIcona: h, colorHover: g, colorTextHover: _, colorIconaHover: v, style: y, ...b })=>{
    let { classes: x, esSimple: S } = (0, $a8f58a7e77290ca9$export$7c24ba817a70e952)({
        className: a,
        tipus: o,
        solidesa: s,
        simple: c,
        round: u,
        disabled: l,
        includeDisabledClass: !0
    });
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("a", {
        className: x,
        style: o === "personalitzat" ? (0, $a8f58a7e77290ca9$export$21a26f4716ae21df)({
            colorText: f,
            colorFons: p,
            colorVora: m,
            colorIcona: h,
            colorHover: g,
            colorTextHover: _,
            colorIconaHover: v
        }, y) : y,
        ...b,
        children: (0, $a8f58a7e77290ca9$export$d65ec7cc0f14562d)({
            esSimple: S,
            icona: d,
            children: i,
            hoverOverlay: o === "personalitzat" && !l && (_ !== void 0 || v !== void 0)
        })
    });
};


//#region src/utils/constants.ts
var $444d8bf17e3d997e$export$a7052c111377e79e = {
    URL: "https://www.ara.cat",
    NAME: "Diari ARA",
    URL_BALEARS: "https://www.arabalears.cat",
    NAME_BALEARS: "ARA Balears",
    SHORT_NAME: "ara.cat",
    URL_SUBSCRIPCIONS: "https://subscripcions.ara.cat",
    URL_PREMIUM: "https://premium.ara.cat",
    URL_JOCS: "https://jocs.ara.cat",
    URL_ULTIMA_HORA: "https://www.ara.cat/ultima-hora",
    URL_DESCOBREIX: "https://www.ara.cat/descobreix",
    NAME_CRIATURES: "Criatures",
    URL_CRIATURES: "https://criatures.ara.cat",
    NAME_EMPRESES: "ARA Empreses",
    URL_EMPRESES: "https://empreses.ara.cat",
    NAME_MENGEM: "Mengem",
    URL_MENGEM: "https://mengem.ara.cat",
    NAME_DIUMENGE: "Diumenge",
    URL_DIUMENGE: "https://diumenge.ara.cat/",
    NAME_LLEGIM: "Llegim",
    URL_LLEGIM: "https://llegim.ara.cat/",
    NAME_MOTOR: "Motor",
    URL_MOTOR: "https://motor.ara.cat/",
    URL_REGALA_ARA: "https://subscripcio.ara.cat/regalalara"
};



//#region src/components/logo-ara/index.tsx
var $eb374cfdb5a6536d$var$r = ({ color: r = "var(--ARA-Brand-Logo-2026)", height: i = 30, tipus: a = "logo_gran" })=>a === "icona" ? /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        width: `${i}px`,
        height: `${i}px`,
        viewBox: "0 0 38 33",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: [
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("title", {
                children: (0, $444d8bf17e3d997e$export$a7052c111377e79e).NAME
            }),
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M0 24.5449C0 21.8402 1.67275 18.7299 4.66977 17.107C9.75773 14.47 17.8427 15.1462 20.8397 14.4024V8.11402C20.8397 3.38084 19.3761 1.41995 15.8215 1.41995C13.9396 1.41995 12.1972 1.89327 10.9426 2.70467C12.3366 3.92177 12.9638 5.20649 12.9638 6.89691C12.9638 10.1425 11.082 12.0358 7.45769 12.0358C4.39098 12.0358 1.95155 9.80444 1.95155 6.96453C2.09094 2.63706 6.62132 0 17.773 0C27.2519 0 31.9217 3.38084 31.9217 11.4949V26.5058C31.9217 29.9542 33.3854 30.698 37.1491 29.0752L37.5673 29.819C34.849 31.7123 32.4096 32.9294 29.3429 32.9294C24.3943 32.9294 22.3034 31.1037 21.5367 27.5877H21.2579C18.7488 30.3599 15.4033 32.997 10.4547 32.997C3.20611 33.1322 0 28.6695 0 24.5449ZM20.8397 26.2353V15.7547C13.5911 16.4985 11.7093 18.2565 11.7093 23.463C11.7093 26.7763 13.5214 28.8048 16.3093 28.8048C18.1215 28.8048 19.9336 27.7229 20.8397 26.2353Z",
                fill: r
            })
        ]
    }) : /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        fill: r,
        width: `${i * 129 / 41}px`,
        height: `${i}px`,
        viewBox: "0 0 129 41",
        children: [
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("title", {
                children: (0, $444d8bf17e3d997e$export$a7052c111377e79e).NAME
            }),
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
                d: "M43.7,38.1 L43.7,39.6 L34.6,39.6 C28.8,39.6 25.8,37.6 25.5,33.5 L25,33.5 C21.3,37.9 17,40.1 12.3,40.1 C4.1,40.1 0,36.8 0,30 C0,25.9 1.9,22.9 5.6,20.9 C7.3,19.9 9.4,19.2 12,18.9 C14.6,18.6 17.2,18.3 19.9,18.1 C22.6,17.9 24.1,17.8 24.5,17.8 L24.5,10.2 C24.5,4.8 22.6,2.1 18.9,2.1 C16.5,2.1 14.5,2.6 12.8,3.6 C14.5,5 15.3,6.6 15.3,8.7 C15.3,12.8 13.1,14.8 8.7,14.8 C4.6,14.8 2.6,12.8 2.6,8.7 C2.5,2.9 8.6,0 20.8,0 C32,0 37.6,4.7 37.6,14.2 L37.6,32 C37.6,36.1 39.6,38.1 43.7,38.1 Z M24.4,19.3 C20,19.6 17.1,20.5 15.8,21.8 C14.5,23.1 13.8,25.4 13.8,28.4 C13.8,32.8 15.7,35 19.4,35 C21.4,35 23.1,34 24.5,32 L24.5,19.3 L24.4,19.3 Z M43.7,39.6 L71.1,39.6 L71.1,38.1 C65.7,38.1 63,36.9 63,34.5 L63,10.2 C65.4,6.8 67.6,5.1 69.6,5.1 C69.6,5.4 69.5,6 69.3,6.9 C69.1,7.7 69,8.3 69,8.7 C69,13.1 71.4,15.3 76.1,15.3 C80.5,15.3 82.7,12.8 82.7,7.7 C82.7,2.6 80.1,0 74.7,0 C69.6,0 65.7,2.9 63,8.6 L63,0.5 L44.2,1.5 L44.2,2.5 C48.3,2.5 50.3,3.9 50.3,6.6 L50.3,34 C50.3,36.7 48.1,38.1 43.7,38.1 L43.7,39.6 Z M96.6,40.1 C101.3,40.1 105.6,37.9 109.3,33.5 L109.8,33.5 C110.8,37.9 113.9,40.1 118.9,40.1 C121.6,40.1 124.8,38.9 128.6,36.5 L128.1,35.5 C124,37.2 122,36.2 122,32.5 L122,14.2 C122,4.7 116.4,0 105.2,0 C93,0 86.9,2.9 86.9,8.6 C86.9,12.7 89.1,14.7 93.5,14.7 C97.6,14.7 99.6,12.7 99.6,8.6 C99.6,6.6 98.9,4.9 97.6,3.5 C99,2.5 100.8,2 103.2,2 C106.9,2 108.8,4.7 108.8,10.1 L108.8,17.7 C108.5,17.7 107,17.8 104.5,18 C102,18.2 99.3,18.4 96.6,18.8 C93.9,19.2 91.7,19.8 90,20.8 C86.3,22.8 84.4,25.9 84.4,29.9 C84.4,36.8 88.4,40.1 96.6,40.1 Z M103.7,35.1 C100,35.1 98.1,32.9 98.1,28.5 C98.1,25.5 98.9,23.3 100.4,22.1 C101.9,20.9 104.7,20 108.8,19.3 L108.8,32 C107.4,34.1 105.7,35.1 103.7,35.1 Z"
            })
        ]
    }), $eb374cfdb5a6536d$export$3677adb25d297fc1 = ({ ambLink: n = !1, color: i = "var(--ARA-Brand-Logo-2026)", height: a = 30, tipus: o = "logo_gran" })=>n ? /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("a", {
        href: (0, $444d8bf17e3d997e$export$a7052c111377e79e).URL,
        target: "_blank",
        rel: "noopener noreferrer",
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($eb374cfdb5a6536d$var$r, {
            color: i,
            height: a,
            tipus: o
        })
    }) : /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($eb374cfdb5a6536d$var$r, {
        color: i,
        height: a,
        tipus: o
    });




//#region src/components/logo-arabalears/index.tsx
var $18e212819bad6b02$var$r = ({ color: r = "var(--ARA-Brand-Logo-2026)", height: i = 30 })=>/* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)("svg", {
        width: `${i * 305 / 43}px`,
        height: i,
        viewBox: "0 0 305 43",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        xmlnsXlink: "http://www.w3.org/1999/xlink",
        children: [
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("title", {
                children: (0, $444d8bf17e3d997e$export$a7052c111377e79e).NAME_BALEARS
            }),
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)("defs", {
                children: [
                    /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("polygon", {
                        id: "path-1",
                        points: "0 0.8153 96.2089 0.8153 96.2089 30.8153 0 30.8153"
                    }),
                    /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("polygon", {
                        id: "path-3",
                        points: "0.5406 0.734 35.8456 0.734 35.8456 42 0.5406 42"
                    }),
                    /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("polygon", {
                        id: "path-5",
                        points: "0.4568 0.734 18.9988 0.734 18.9988 41.441 0.4568 41.441"
                    }),
                    /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("polygon", {
                        id: "path-7",
                        points: "0.5858 0.5213 25.9218 0.5213 25.9218 31 0.5858 31"
                    })
                ]
            }),
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("g", {
                stroke: "none",
                strokeWidth: "1",
                fill: "none",
                fillRule: "evenodd",
                children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)("g", {
                    children: [
                        /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)("g", {
                            transform: "translate(0.000000, 11.266000)",
                            children: [
                                /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("mask", {
                                    id: "mask-2",
                                    fill: "white",
                                    children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("use", {
                                        xlinkHref: "#path-1"
                                    })
                                }),
                                /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("g", {
                                    id: "Clip-2"
                                }),
                                /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
                                    d: "M77.5809,27.0753 C74.8129,27.0753 73.3919,25.4293 73.3919,22.1383 C73.3919,19.8923 73.9899,18.2473 75.1119,17.3493 C76.2339,16.4513 78.3289,15.7783 81.3959,15.2553 L81.3959,24.7563 C80.3489,26.3273 79.0779,27.0753 77.5809,27.0753 L77.5809,27.0753 Z M72.2689,30.8153 C75.7859,30.8153 79.0019,29.1703 81.7699,25.8783 L82.1449,25.8783 C82.8929,29.1703 85.2119,30.8153 88.9529,30.8153 C90.9729,30.8153 93.3669,29.9183 96.2089,28.1223 L95.8349,27.3743 C92.7679,28.6463 91.2719,27.8973 91.2719,25.1303 L91.2719,11.4393 C91.2719,4.3323 87.0819,0.8153 78.7039,0.8153 C69.5759,0.8153 65.0129,2.9853 65.0129,7.2503 C65.0129,10.3163 66.6589,11.8133 69.9499,11.8133 C73.0179,11.8133 74.5139,10.3163 74.5139,7.2503 C74.5139,5.7533 73.9899,4.4813 73.0179,3.4333 C74.0649,2.6853 75.4119,2.3113 77.2069,2.3113 C79.9749,2.3113 81.3959,4.3323 81.3959,8.3723 L81.3959,14.0573 C81.1719,14.0573 80.0499,14.1333 78.1799,14.2823 C76.3099,14.4313 74.2889,14.5813 72.2689,14.8813 C70.2489,15.1793 68.6029,15.6293 67.3319,16.3773 C64.5639,17.8733 63.1419,20.1923 63.1419,23.1843 C63.1419,28.3463 66.1349,30.8153 72.2689,30.8153 L72.2689,30.8153 Z M32.6929,30.4413 L53.1919,30.4413 L53.1919,29.3193 C49.1519,29.3193 47.1319,28.4223 47.1319,26.6263 L47.1319,8.4463 C48.9279,5.9033 50.5739,4.6313 52.0699,4.6313 C52.0699,4.8553 51.9949,5.3043 51.8459,5.9773 C51.6959,6.5763 51.6209,7.0253 51.6209,7.3243 C51.6209,10.6163 53.4159,12.2623 56.9329,12.2623 C60.2249,12.2623 61.8709,10.3913 61.8709,6.5763 C61.8709,2.7613 59.9249,0.8153 55.8849,0.8153 C52.0699,0.8153 49.1519,2.9853 47.1319,7.2503 L47.1319,1.1893 L33.0669,1.9373 L33.0669,2.6853 C36.1349,2.6853 37.6309,3.7333 37.6309,5.7533 L37.6309,26.2523 C37.6309,28.2723 35.9849,29.3193 32.6929,29.3193 L32.6929,30.4413 Z M18.2539,15.2553 C14.9629,15.4783 12.7929,16.1523 11.8209,17.1253 C10.8479,18.0973 10.3239,19.8183 10.3239,22.0623 C10.3239,25.3543 11.7459,27.0003 14.5139,27.0003 C16.0099,27.0003 17.2819,26.2523 18.3289,24.7563 L18.3289,15.2553 L18.2539,15.2553 Z M32.6929,29.3193 L32.6929,30.4413 L25.8849,30.4413 C21.5459,30.4413 19.3019,28.9453 19.0779,25.8783 L18.7039,25.8783 C15.9349,29.1703 12.7179,30.8153 9.2019,30.8153 C3.0669,30.8153 -0.0001,28.3463 -0.0001,23.2603 C-0.0001,20.1923 1.4209,17.9483 4.1889,16.4513 C5.4609,15.7033 7.0329,15.1793 8.9769,14.9553 C10.9229,14.7303 12.8679,14.5073 14.8879,14.3563 C16.9079,14.2073 18.0299,14.1333 18.3289,14.1333 L18.3289,8.4463 C18.3289,4.4063 16.9079,2.3873 14.1399,2.3873 C12.3439,2.3873 10.8479,2.7613 9.5759,3.5093 C10.8479,4.5563 11.4459,5.7533 11.4459,7.3243 C11.4459,10.3913 9.8009,11.8873 6.5089,11.8873 C3.4409,11.8873 1.9449,10.3913 1.9449,7.3243 C1.8709,2.9853 6.4339,0.8153 15.5609,0.8153 C23.9399,0.8153 28.1299,4.3323 28.1299,11.4393 L28.1299,24.7563 C28.1299,27.8233 29.6259,29.3193 32.6929,29.3193 L32.6929,29.3193 Z",
                                    id: "Fill-1",
                                    fill: r,
                                    mask: "url(#mask-2)"
                                })
                            ]
                        }),
                        /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)("g", {
                            transform: "translate(94.000000, 0.266000)",
                            children: [
                                /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("mask", {
                                    id: "mask-4",
                                    fill: "white",
                                    children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("use", {
                                        xlinkHref: "#path-3"
                                    })
                                }),
                                /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
                                    d: "M19.9066,40.7306 C17.8116,40.7306 16.1606,39.3966 14.8276,36.7936 L14.8276,16.2206 C16.6056,15.0126 17.6846,14.4416 19.3356,14.4416 C23.3996,14.4416 25.4946,19.3936 25.4946,26.0626 C25.4946,34.6346 23.9076,40.7306 19.9066,40.7306 M24.2886,11.5216 C20.4156,11.5216 17.3036,13.0456 14.8276,15.2046 L14.8276,0.7336 L0.5406,1.4956 L0.5406,2.2576 C4.4766,2.3216 5.0486,3.4636 5.0486,5.3686 L5.0486,36.6666 L4.9496,41.4416 L5.9526,41.4416 C7.3636,41.4416 8.7366,40.9856 9.8666,40.1416 L11.0176,39.2826 C13.8746,41.1256 18.1296,42.0006 21.5576,42.0006 C30.3846,42.0006 35.8456,35.2696 35.8456,25.7446 C35.8456,18.0616 32.0356,11.5216 24.2886,11.5216",
                                    id: "Fill-4",
                                    fill: r,
                                    mask: "url(#mask-4)"
                                })
                            ]
                        }),
                        /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)("g", {
                            transform: "translate(164.000000, 0.266000)",
                            children: [
                                /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("mask", {
                                    id: "mask-6",
                                    fill: "white",
                                    children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("use", {
                                        xlinkHref: "#path-5"
                                    })
                                }),
                                /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
                                    d: "M0.7108,40.254 C4.2668,40.191 4.9648,39.556 4.9648,38.032 L4.9648,5.368 C4.9648,3.464 4.3308,2.321 0.4568,2.258 L0.4568,1.495 L14.7438,0.733 L14.7438,38.032 C14.7438,39.556 15.3788,40.191 18.9988,40.254 L18.9988,41.441 L0.7108,41.441 L0.7108,40.254 Z",
                                    id: "Fill-7",
                                    fill: r || "#000000",
                                    mask: "url(#mask-6)"
                                })
                            ]
                        }),
                        /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
                            d: "M193.6649,25.186 L202.6819,25.186 C203.5079,17.82 202.0469,13.057 198.5549,13.057 C195.2529,13.057 193.9189,17.693 193.6649,25.186 M183.3779,27.471 C183.3779,17.501 190.2999,11.788 198.9359,11.788 C208.0159,11.788 212.9049,17.693 212.4609,26.456 L193.6649,26.456 L193.6649,27.345 L193.6649,27.471 C193.6649,35.473 196.9039,39.536 202.9989,39.536 C206.7459,39.536 209.2859,37.695 211.6349,34.457 L212.3339,34.901 C209.3499,39.536 205.2219,42.266 198.9989,42.266 C189.7279,42.266 183.3779,37.124 183.3779,27.471",
                            id: "Fill-10",
                            fill: r || "#000000"
                        }),
                        /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)("g", {
                            transform: "translate(279.000000, 11.266000)",
                            children: [
                                /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("mask", {
                                    id: "mask-8",
                                    fill: "white",
                                    children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("use", {
                                        xlinkHref: "#path-7"
                                    })
                                }),
                                /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("g", {
                                    id: "Clip-13"
                                }),
                                /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
                                    d: "M0.5858,19.8253 L1.5388,19.8253 C5.6658,26.3033 9.3488,29.7303 13.8568,29.7303 C16.8408,29.7303 18.5558,28.1423 18.5558,25.4133 C18.5558,22.6193 16.9678,21.4763 10.1738,19.4433 C3.3798,17.4113 0.5858,15.3793 0.5858,10.5533 C0.5858,4.3943 5.3478,0.5213 12.6498,0.5213 C16.2698,0.5213 19.1908,1.4743 21.2858,2.8703 L23.1908,0.5213 L23.9528,0.5213 L23.9528,10.5533 L23.0008,10.5533 C19.3178,4.9023 16.7778,1.7913 12.6498,1.7913 C9.9198,1.7913 8.2058,3.5693 8.2058,6.4273 C8.2058,9.0303 10.9998,10.1733 14.9998,11.1263 C21.9848,12.7773 25.9218,15.1893 25.9218,20.6493 C25.9218,26.6183 20.6508,31.0003 13.2218,31.0003 C10.8728,31.0003 4.9038,29.5393 3.2528,28.5243 L1.3478,31.0003 L0.5858,31.0003 L0.5858,19.8253 Z",
                                    id: "Fill-12",
                                    fill: r || "#000000",
                                    mask: "url(#mask-8)"
                                })
                            ]
                        }),
                        /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
                            d: "M150.5218,35.8247 C149.6928,37.1517 148.1038,38.1027 146.5788,38.1027 C144.0948,38.1027 142.5078,36.2647 142.5078,33.2937 C142.5078,28.6067 144.1608,27.0247 150.5218,26.3287 L150.5218,35.8247 Z M160.2528,36.0267 L160.2528,22.4707 C160.2528,15.0647 156.1178,12.0257 147.7838,12.0257 C137.9858,12.0257 133.9798,14.4317 133.9798,18.2927 C133.9798,20.8877 136.1468,22.9157 138.8168,22.9157 C141.9988,22.9157 143.6508,21.1417 143.6508,18.2287 C143.6508,16.7127 143.0748,15.5097 141.8698,14.4317 C142.9508,13.7337 144.4788,13.2937 146.1318,13.2937 C149.2518,13.2937 150.5218,15.0647 150.5218,19.3657 L150.5218,25.0627 C147.9088,25.7597 140.7898,25.1267 136.3348,27.5327 C133.6628,28.9907 132.1988,31.7727 132.1988,34.2427 C132.1988,37.9737 135.0008,42.0257 141.3628,42.0257 C145.6888,42.0257 148.6138,39.6857 150.8358,37.1517 L151.0918,37.1517 C151.7968,40.3157 153.4768,41.7077 157.9638,41.7077 L165.0238,41.7077 L165.0238,40.4997 C161.3988,40.4337 160.2528,37.5487 160.2528,36.0267 L160.2528,36.0267 Z",
                            id: "Fill-15",
                            fill: r || "#000000"
                        }),
                        /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
                            d: "M248.2723,40.4995 C251.8973,40.4345 253.0423,38.8955 253.0423,37.3765 L253.0423,16.8365 C253.0423,14.9375 252.3393,13.8015 248.7173,13.7335 L248.7173,12.9755 L262.7093,12.2195 L262.7093,18.1655 C264.6833,14.3045 268.1213,12.0255 271.6133,12.0255 C275.5623,12.0255 277.7223,14.4325 277.7223,17.7215 C277.7223,21.0135 275.6263,23.2935 272.6963,23.2935 C269.2633,23.2935 267.2923,20.8885 267.2923,18.3545 C267.2923,17.4095 267.5453,16.3305 267.7983,15.5095 C266.2723,15.6345 264.1093,17.2835 262.8353,19.4295 L262.8353,37.9535 C262.8353,39.4725 263.7913,40.3085 268.6923,40.4995 L268.6923,41.7075 L248.2723,41.7075 L248.2723,40.4995 Z",
                            id: "Fill-17",
                            fill: r || "#000000"
                        }),
                        /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
                            d: "M233.7704,35.8247 C232.9414,37.1517 231.3524,38.1027 229.8274,38.1027 C227.3434,38.1027 225.7564,36.2647 225.7564,33.2937 C225.7564,28.6067 227.4094,27.0247 233.7704,26.3287 L233.7704,35.8247 Z M243.5014,36.0267 L243.5014,22.4707 C243.5014,15.0647 239.3664,12.0257 231.0324,12.0257 C221.2344,12.0257 217.2284,14.4317 217.2284,18.2927 C217.2284,20.8877 219.3954,22.9157 222.0654,22.9157 C225.2474,22.9157 226.8994,21.1417 226.8994,18.2287 C226.8994,16.7127 226.3234,15.5097 225.1184,14.4317 C226.1994,13.7337 227.7274,13.2937 229.3804,13.2937 C232.5004,13.2937 233.7704,15.0647 233.7704,19.3657 L233.7704,25.0627 C231.1574,25.7597 224.0384,25.1267 219.5834,27.5327 C216.9114,28.9907 215.4474,31.7727 215.4474,34.2427 C215.4474,37.9737 218.2494,42.0257 224.6114,42.0257 C228.9374,42.0257 231.8624,39.6857 234.0844,37.1517 L234.3404,37.1517 C235.0464,40.3157 236.7254,41.7077 241.2124,41.7077 L248.2724,41.7077 L248.2724,40.4997 C244.6474,40.4337 243.5014,37.5487 243.5014,36.0267 L243.5014,36.0267 Z",
                            id: "Fill-19",
                            fill: r || "#000000"
                        })
                    ]
                })
            })
        ]
    }), $18e212819bad6b02$export$16233f4d99e0950b = ({ ambLink: n = !1, color: i, height: a = 30 })=>n ? /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("a", {
        href: (0, $444d8bf17e3d997e$export$a7052c111377e79e).URL_BALEARS,
        target: "_blank",
        rel: "noreferrer noopener",
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($18e212819bad6b02$var$r, {
            color: i,
            height: a
        })
    }) : /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)($18e212819bad6b02$var$r, {
        color: i,
        height: a
    });




//#region src/components/logo-criatures/index.tsx
var $6bee859631b7b63b$export$bd3fbda7131dbe9d = ({ height: r = 30 })=>/* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("a", {
        href: (0, $444d8bf17e3d997e$export$a7052c111377e79e).URL_CRIATURES,
        target: "_blank",
        rel: "noopener noreferrer",
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: `${r / 30 * 165}px`,
            height: `${r}px`,
            viewBox: "0 0 165 30",
            fill: "none",
            children: [
                /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("title", {
                    children: (0, $444d8bf17e3d997e$export$a7052c111377e79e).NAME_CRIATURES
                }),
                /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
                    d: "M156.595 8.56445C161.098 8.56445 164.493 12.2114 164.693 14.5879L159.577 15.5293C159.412 14.1764 158.564 13.0586 156.701 13.0586C154.839 13.0586 154.497 13.7411 154.497 14.8115C154.497 15.882 155.18 16.1645 156.088 16.2939L158.764 16.835C162.972 17.682 165 20.2121 165 23.165C165 26.1179 162.359 30 156.937 30C151.514 29.9998 148.568 25.9062 148.391 23.6709L153.612 22.7178H153.636V22.7295C153.706 24.1177 154.686 25.4355 156.819 25.4355C158.952 25.4354 159.188 24.5883 159.188 23.6826C159.188 22.7768 158.717 22.3293 157.185 22.0234L154.874 21.4824C150.571 20.5412 148.838 18.1058 148.838 15.2588C148.838 12.4118 152.092 8.56459 156.595 8.56445ZM14.877 0C22.9046 9.16694e-05 27.3489 5.54139 28.3037 9.70605L22.2324 11.5996C21.7961 9.59959 19.9572 6.25888 14.877 6.25879C9.79627 6.25879 6.67194 9.03524 6.67188 15.0469C6.67188 21.0585 10.6681 23.5643 14.9707 23.5645C19.2732 23.5645 21.9495 20.2475 22.5273 18.1533L28.6572 19.9062C27.7022 23.8945 23.906 29.9883 14.959 29.9883C6.01187 29.9882 0 24.0115 0 15.0469C8.98633e-05 6.08228 6.84922 0 14.877 0ZM137.955 8.59473C144.219 8.59486 148.083 12.4511 148.083 18.9463C148.083 19.7988 148.002 20.7328 147.961 20.8545H133.887C134.009 23.1277 136.084 24.7519 138.483 24.752C140.72 24.752 141.981 23.6962 142.551 22.1133L147.717 23.5742C146.741 27.0653 143.527 29.9883 138.402 29.9883C132.83 29.9883 127.867 26.0099 127.867 19.2305C127.867 12.7353 132.708 8.59473 137.955 8.59473ZM63.9043 8.58789C69.8687 8.588 72.8513 12.2351 72.8516 16.3643V26.2354C72.8516 27.8226 73.0514 29.1396 73.0869 29.3408H67.5234C67.488 29.1757 67.3223 28.4579 67.3223 27.0703C66.2731 28.7644 64.3048 29.9062 61.6289 29.9062C57.1847 29.9062 54.6504 26.9998 54.6504 23.7881C54.6505 20.5801 57.2848 18.2176 60.6035 17.708V17.7178L65.3535 16.9766C66.438 16.8119 66.8154 16.3055 66.8154 15.5879C66.8152 14.3998 65.8015 13.3887 63.833 13.3887C61.8647 13.3888 60.5088 14.8468 60.3789 16.3643L55.0273 15.2822C55.2632 12.4117 57.9395 8.58789 63.9043 8.58789ZM110.586 25.7529C110.586 27.5765 110.751 29.0358 110.786 29.377H104.856C104.786 29.0359 104.727 27.8948 104.727 27.377V27.3643C103.677 29.1172 101.331 29.835 99.3037 29.835C94.3884 29.8347 91.6065 26.247 91.6064 21.9531V9.2002H97.7715V20.6357C97.7716 22.6002 98.8212 24.1172 101.025 24.1172C103.23 24.1171 104.42 22.6942 104.42 20.6709V9.17676H110.586V25.7529ZM83.2246 22.1885C83.2247 23.8471 84.1328 24.2939 85.4766 24.2939C86.6009 24.2939 87.2053 24.0988 87.2207 24.0938V29.2119C86.9723 29.3299 85.8405 29.7764 83.8848 29.7764C79.6883 29.7762 77.1309 27.2939 77.1309 23.2822V14.6357H73.5469V9.23535H74.5605C76.6706 9.23535 77.6962 7.81189 77.6963 5.94141V3.34082H83.2246V22.1885ZM36.5439 29.3525H30.3779V9.2002H36.5439V29.3525ZM52.4697 29.3525H46.3037V9.2002H52.4697V29.3525ZM119.875 29.3525H113.709V9.2002H119.875V29.3525ZM63.0078 21.2119C61.7231 21.412 60.7334 22.0239 60.7334 23.4473C60.7335 24.8706 61.4168 25.5058 63.1377 25.5059C64.9649 25.4706 66.8271 24.5882 66.8271 21.4824H66.8389V20.5996L63.0078 21.2119ZM60.6035 17.708V17.7061H60.6152C60.6114 17.7066 60.6074 17.7074 60.6035 17.708ZM138.036 13.4658C135.433 13.4658 134.131 15.374 134.009 16.876H142.104C142.022 15.3334 140.965 13.4658 138.036 13.4658ZM41.1172 8.58789C43.3216 8.58789 45.0781 10.3412 45.0781 12.5059C45.0781 14.6706 43.3098 16.4238 41.1172 16.4238C38.9247 16.4237 37.251 14.6705 37.251 12.5059C37.251 10.3412 39.019 8.58799 41.1172 8.58789ZM124.413 8.58789C126.617 8.58789 128.374 10.3412 128.374 12.5059C128.374 14.6706 126.617 16.4238 124.413 16.4238C122.209 16.4238 120.547 14.6706 120.547 12.5059C120.547 10.3412 122.315 8.58789 124.413 8.58789ZM87.3037 8.58789C89.2958 8.58791 90.8874 10.1645 90.8877 12.1172C90.8877 14.0701 89.2959 15.6474 87.3037 15.6475C85.3115 15.6475 83.8145 14.0701 83.8145 12.1172C83.8147 10.1645 85.406 8.58789 87.3037 8.58789ZM49.3457 0.871094C51.3378 0.871176 52.9287 2.4475 52.9287 4.40039C52.9285 6.35311 51.3377 7.92961 49.3457 7.92969C47.3536 7.92969 45.8566 6.35316 45.8564 4.40039C45.8564 2.44745 47.4478 0.871094 49.3457 0.871094Z",
                    fill: "#FF4E1E"
                })
            ]
        })
    });




//#region src/components/logo-empreses/index.tsx
var $646c87d311181b26$export$a45ee600317773a8 = ({ height: r = 22 })=>/* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("a", {
        href: (0, $444d8bf17e3d997e$export$a7052c111377e79e).URL_EMPRESES,
        target: "_blank",
        rel: "noopener noreferrer",
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: `${r / 22 * 165}px`,
            height: `${r}px`,
            viewBox: "0 0 165 22",
            fill: "none",
            children: [
                /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("title", {
                    children: (0, $444d8bf17e3d997e$export$a7052c111377e79e).NAME_EMPRESES
                }),
                /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
                    d: "M17.67 21.6856H0V20.9171L2.75934 20.7605V1.23952L0 1.08229V0.314453H17.3598V7.07138H17.174L14.2267 1.23952H7.25416L7.25385 10.5057H10.4833L12.4931 6.69434H12.6792V15.2428H12.4931L10.483 11.4308H7.25385V20.7605H14.4183L17.4839 14.1428H17.67V21.6856Z",
                    fill: "#000714"
                }),
                /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
                    d: "M108.975 21.6856H91.3054V20.9171L94.0648 20.7605V1.23952L91.3054 1.08229V0.314453H108.665V7.07138H108.479L105.532 1.23952H98.5596L98.5593 10.5057H101.789L103.799 6.69434H103.985V15.2428H103.799L101.788 11.4308H98.5593V20.7605H105.724L108.789 14.1428H108.975V21.6856Z",
                    fill: "#000714"
                }),
                /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
                    d: "M146.602 21.6856H128.932V20.9171L131.691 20.7605V1.23952L128.932 1.08229V0.314453H146.291V7.07138H146.106L143.159 1.23952H136.186L136.186 10.5057H139.415L141.425 6.69434H141.611V15.2428H141.425L139.415 11.4308H136.186V20.7605H143.35L146.416 14.1428H146.602V21.6856Z",
                    fill: "#000714"
                }),
                /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
                    d: "M33.6112 15.4626L39.0983 0.314453H46.4452V1.08229L43.691 1.23952L44.9196 20.7605L47.5923 20.9174V21.6859H37.4553V20.9174L40.305 20.7605L39.3446 1.89591L32.1086 22H31.4105L24.4659 2.09009L23.2816 20.7715L27.0708 20.9171V21.6856H20.0024V20.9171L22.4637 20.7605L23.6854 1.23952L20.9324 1.08229V0.314453H28.2796L33.6112 15.4626Z",
                    fill: "#000714"
                }),
                /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
                    d: "M48.3917 0.314453H57.8469C64.5427 0.314453 67.5189 2.76572 67.5189 7.07138C67.5189 11.3774 64.5427 13.8286 57.8469 13.8286H55.6459V20.7605L59.025 20.9174V21.6859H48.392V20.9174L51.1508 20.7605V1.23952L48.3917 1.08229V0.314453ZM55.6456 1.23952V12.5986H57.8466C61.2874 12.5986 62.6206 11.9745 62.6206 7.07169C62.6206 2.13741 61.3184 1.23982 57.7225 1.23982L55.6456 1.23952Z",
                    fill: "#000714"
                }),
                /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
                    d: "M68.6285 0.314453H78.6724C84.9033 0.314453 87.6314 2.32578 87.6314 5.81446C87.6314 8.86289 85.7405 10.7802 80.4085 11.2516C85.2755 11.7858 86.4226 13.6717 87.6624 18.0399L88.4282 20.7605L90.6696 20.9174V21.6859H83.9424L82.7026 16.5629C81.6486 12.1629 81.4315 11.4088 78.5174 11.4088H75.8824V20.7605L78.6414 20.9174V21.6859H68.6285V20.9174L71.3876 20.7605V1.23952L68.6285 1.08229V0.314453ZM75.8824 1.23952L75.8821 10.2004H78.6722C81.5863 10.2004 82.7336 9.80566 82.7336 5.81415C82.7336 1.82264 81.6486 1.23921 78.6724 1.23921L75.8824 1.23952Z",
                    fill: "#000714"
                }),
                /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
                    d: "M115.439 19.9255L113.592 21.6856H112.804L111.998 13.923L112.817 13.8601L114.221 16.7604C115.647 19.4321 117.392 21.0438 120.337 21.0438C122.879 21.0438 124.181 19.6523 124.181 17.6406C124.181 10.9777 112.68 13.9547 112.68 5.75157C112.68 2.38868 115.749 0 119.066 0C121.05 0 122.569 0.942771 123.778 2.26289L125.439 0.31446H126.227L126.754 7.44844L125.935 7.51133L124.779 5.20814C123.632 3.03958 122.012 0.925063 119.066 0.925063C117.051 0.925063 115.873 1.84524 115.873 3.73109C115.873 9.98519 127.374 7.38585 127.374 15.8403C127.374 18.8258 124.863 22 120.431 22C118.446 22 117.051 21.34 115.439 19.9255Z",
                    fill: "#000714"
                }),
                /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
                    d: "M153.066 19.9255L151.219 21.6856H150.431L149.625 13.923L150.444 13.8601L151.848 16.7604C153.274 19.4321 155.019 21.0438 157.964 21.0438C160.506 21.0438 161.808 19.6523 161.808 17.6406C161.808 10.9777 150.307 13.9547 150.307 5.75157C150.307 2.38868 153.376 0 156.693 0C158.677 0 160.196 0.942771 161.405 2.26289L163.066 0.31446H163.854L164.381 7.44844L163.562 7.51133L162.406 5.20814C161.259 3.03958 159.638 0.925063 156.693 0.925063C154.678 0.925063 153.5 1.84524 153.5 3.73109C153.5 9.98519 165.001 7.38585 165.001 15.8403C165.001 18.8258 162.49 22 158.057 22C156.073 22 154.678 21.34 153.066 19.9255Z",
                    fill: "#000714"
                })
            ]
        })
    });




//#region src/components/logo-mengem/index.tsx
var $c2d756ce4c6f0f64$export$c3970ae1cc01018a = ({ height: r = 55 })=>/* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("a", {
        href: (0, $444d8bf17e3d997e$export$a7052c111377e79e).URL_MENGEM,
        target: "_blank",
        rel: "noopener noreferrer",
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: `${r / 55 * 128}px`,
            height: `${r}px`,
            viewBox: "0 0 128 55",
            fill: "none",
            children: [
                /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("title", {
                    children: (0, $444d8bf17e3d997e$export$a7052c111377e79e).NAME_MENGEM
                }),
                /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
                    d: "M0 41.9619V40.6363H2.33933V14.436H0V13.1104H3.8209L9.47428 37.4393L15.1277 13.1104H19.5334V14.436H17.0381V40.6363H19.5334V41.9619H12.2815V40.6363H14.3869V21.4539L9.63023 41.9619H8.42158L3.66495 21.4539V40.6363H6.16023V41.9619H0Z",
                    fill: "#0D8738"
                }),
                /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
                    d: "M104.734 28.8516V27.526H107.073V1.32561H104.734V0H108.555L114.208 24.3289L119.862 0H124.267V1.32561H121.772V27.526H124.267V28.8516H117.015V27.526H119.121V8.34357L114.364 28.8516H113.155L108.399 8.34357V27.526H110.894V28.8516H104.734Z",
                    fill: "#0D8738"
                }),
                /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
                    d: "M126 37.3408L127.365 39.7044L107.777 50.0681L107.231 49.1227L126 37.3408ZM101.359 53.1433C101.06 52.6256 100.987 52.0827 101.139 51.5146C101.291 50.9465 101.626 50.513 102.144 50.2141C102.661 49.9152 103.204 49.8418 103.772 49.994C104.341 50.1463 104.774 50.4812 105.073 50.999C105.372 51.5167 105.445 52.0596 105.293 52.6277C105.141 53.1958 104.806 53.6293 104.288 53.9282C103.77 54.2272 103.227 54.3005 102.659 54.1483C102.091 53.9961 101.658 53.6611 101.359 53.1433Z",
                    fill: "#03240F"
                }),
                /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
                    d: "M22.0048 28.8516V27.526H25.2798V1.32561H22.0048V0H38.0292V8.34357H36.9375L36.3916 4.17178C36.1577 2.30033 35.079 1.3646 33.1556 1.3646H28.009V12.4374H33.0386V7.48582H34.2862V18.7145H33.0386V13.763H28.009V27.487H33.5454C35.4429 27.487 36.5086 26.5383 36.7425 24.6408L37.3274 19.7282H38.419V28.8516H22.0048Z",
                    fill: "#0D8738"
                }),
                /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
                    d: "M83.3628 41.9619V40.6363H86.6379V14.436H83.3628V13.1104H99.3872V21.4539H98.2955L97.7497 17.2821C97.5157 15.4107 96.437 14.475 94.5136 14.475H89.3671V25.5477H94.3966V20.5962H95.6443V31.8249H94.3966V26.8733H89.3671V40.5973H94.9035C96.8009 40.5973 97.8666 39.6486 98.1006 37.7512L98.6854 32.8386H99.7771V41.9619H83.3628Z",
                    fill: "#0D8738"
                }),
                /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
                    d: "M55.8741 42.3518L45.932 19.1146V40.6363H49.207V41.9619H42.1111V40.6363H44.6064V14.436H42.1111V13.1104H46.0879L55.4842 35.0999V14.436H52.2092V13.1104H59.3051V14.436H56.8099V42.3518H55.8741Z",
                    fill: "#0D8738"
                }),
                /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
                    d: "M71.3319 54.1943C70.1623 54.1943 69.0966 53.8175 68.1349 53.0637C67.1991 52.3099 66.3804 51.2572 65.6786 49.9056C65.0028 48.554 64.4699 46.9944 64.08 45.227C63.7161 43.4335 63.5342 41.51 63.5342 39.4566C63.5342 37.5852 63.7031 35.7657 64.041 33.9982C64.3789 32.2308 64.8858 30.6322 65.5616 29.2026C66.2374 27.7731 67.0822 26.6424 68.0959 25.8106C69.1096 24.9789 70.3052 24.563 71.6828 24.563C72.6446 24.563 73.4633 24.7839 74.1391 25.2258C74.8409 25.6417 75.3998 26.1485 75.8156 26.7464C76.2575 27.3442 76.5434 27.929 76.6734 28.5008H76.9853V24.9529H78.233V34.778H76.2055V33.8813C76.2055 31.8799 75.9716 30.3073 75.5037 29.1636C75.0619 28.02 74.477 27.2142 73.7492 26.7464C73.0215 26.2525 72.2417 26.0056 71.4099 26.0056C69.9803 26.0056 68.8497 26.6034 68.0179 27.799C67.2121 28.9947 66.8092 30.7102 66.8092 32.9455V45.8118C66.8092 48.0471 67.2121 49.7626 68.0179 50.9583C68.8237 52.1539 69.9024 52.7518 71.254 52.7518C72.3456 52.7518 73.2164 52.4009 73.8662 51.6991C74.516 50.9973 74.9969 50.0875 75.3088 48.9699C75.6467 47.8522 75.8676 46.6695 75.9716 45.4219C76.0756 44.1483 76.1276 42.9526 76.1276 41.835V39.3787H69.6554V38.0531H78.3109V53.8045H76.9463V49.1258H76.5954C76.4655 49.8536 76.1925 50.6074 75.7767 51.3872C75.3608 52.1669 74.7759 52.8297 74.0222 53.3756C73.2944 53.9214 72.3976 54.1943 71.3319 54.1943Z",
                    fill: "#0D8738"
                })
            ]
        })
    });














//#region src/components/menu-usuari/user.ts
var $e94e78ec1299875f$export$d5c8494b497ea99e = {
    userId: null
};
function $e94e78ec1299875f$var$t(e) {
    let t = document.cookie.split(";");
    for (let n of t){
        let [t, r] = n.trim().split("=");
        if (t === e) return decodeURIComponent(r);
    }
    return null;
}
function $e94e78ec1299875f$var$n(t) {
    if (t) try {
        let e = JSON.parse(t);
        return {
            userId: e.userId,
            nick: e.nick,
            name: e.name,
            email: e.email,
            avatarUrl: e.avatarUrl,
            subscriber: e.subscriber,
            premium: e.premium
        };
    } catch (t) {
        return console.error("No s'ha pogut descodificar el JSON de la cookie:", t), $e94e78ec1299875f$export$d5c8494b497ea99e;
    }
    else return $e94e78ec1299875f$export$d5c8494b497ea99e;
}
var $e94e78ec1299875f$export$7cbf767827cd68ba = ()=>$e94e78ec1299875f$var$n($e94e78ec1299875f$var$t("nx-session-user"));


var $c306540931998d18$export$2e2bcd8739ae039 = {
    accedir: "Inicia Sessi\xf3",
    accedir_perfil: "Accedeix al perfil",
    subscriu: "Subscriu-t'hi",
    fes_premium: "Fes-te Pr\xe8mium",
    titol_hot_topics: "Avui parlem de",
    regala_ara: "\uD83C\uDF81 Regala l\u2019ARA"
};


var $72c2cc23038ddedc$export$2e2bcd8739ae039 = {
    accedir: "Inicia Sesi\xf3n",
    accedir_perfil: "Accede al perfil",
    subscriu: "Suscr\xedbete",
    fes_premium: "Hazte Premium",
    titol_hot_topics: "Hoy hablamos de",
    regala_ara: "\uD83C\uDF81 Regala el ARA"
};


var $72ba1f35de9e8874$export$2e2bcd8739ae039 = {
    accedir: "Log in",
    accedir_perfil: "Profile access",
    subscriu: "Subscribe",
    fes_premium: "Go Premium",
    titol_hot_topics: "Today we talk about",
    regala_ara: "\uD83C\uDF81 Gift ARA"
};


//#region src/utils/funcions.ts
var $63c6b3fd54c8dbeb$var$r = (0, $c306540931998d18$export$2e2bcd8739ae039), $63c6b3fd54c8dbeb$var$i = (0, $72c2cc23038ddedc$export$2e2bcd8739ae039), $63c6b3fd54c8dbeb$var$a = (0, $72ba1f35de9e8874$export$2e2bcd8739ae039), $63c6b3fd54c8dbeb$export$625550452a3fa3ec = (e, t)=>{
    switch(t){
        case "ca":
            return $63c6b3fd54c8dbeb$var$r[e] || e;
        case "es":
            return $63c6b3fd54c8dbeb$var$i[e] || $63c6b3fd54c8dbeb$var$r[e] || e;
        case "en":
            return $63c6b3fd54c8dbeb$var$a[e] || $63c6b3fd54c8dbeb$var$r[e] || e;
        default:
            return e;
    }
};


var $1bb08e954409f9ef$export$2e2bcd8739ae039 = {
    container: "ara-ui_menu-usuari-container_9Squ",
    avatar: "ara-ui_menu-usuari-avatar_yU8e",
    premium: "ara-ui_menu-usuari-premium_-I1O",
    subscriu: "ara-ui_menu-usuari-subscriu_5-k5",
    perfil: "ara-ui_menu-usuari-perfil_CL6J",
    slideUp: "ara-ui_menu-usuari-slideUp_18wS",
    visible: "ara-ui_menu-usuari-visible_EE70",
    slideDown: "ara-ui_menu-usuari-slideDown_48aX"
};



var $acw62 = parcelRequire("acw62");

"use client";
//#region src/components/menu-usuari/index.tsx
var $e9f0ccf3b177d9d8$var$m = /* @__PURE__ */ (0, $14b872f206384382$export$82dec27a9dce9602)((0, $ba4d14fce8721970$export$f998fc56051369ed)(), 1), $e9f0ccf3b177d9d8$export$a84658460ef8c64 = ({ idioma: e = "ca", site: t = "ara" })=>{
    let [h, g] = (0, $acw62.useState)(""), [_, v] = (0, $acw62.useState)(""), [y, b] = (0, $acw62.useState)((0, $e94e78ec1299875f$export$d5c8494b497ea99e)), [x, S] = (0, $acw62.useState)(!1), [C, w] = (0, $acw62.useState)(!1), T = (0, $acw62.useRef)(null), E = t === "balears" ? (0, $444d8bf17e3d997e$export$a7052c111377e79e).URL_BALEARS : (0, $444d8bf17e3d997e$export$a7052c111377e79e).URL;
    return (0, $acw62.useEffect)(()=>{
        typeof window < "u" && (g(window.location.origin), v(window.location.pathname));
    }, []), (0, $acw62.useEffect)(()=>{
        b((0, $e94e78ec1299875f$export$7cbf767827cd68ba)());
    }, []), (0, $acw62.useEffect)(()=>{
        if (x) w(!0);
        else {
            let e = setTimeout(()=>{
                w(!1);
            }, 300);
            return ()=>clearTimeout(e);
        }
    }, [
        x
    ]), (0, $acw62.useEffect)(()=>{
        let e = (e)=>{
            T.current && (T.current.contains(e.target) || S(!1));
        }, t = (e)=>{
            e.key === "Escape" && S(!1);
        };
        return document.addEventListener("mousedown", e), document.addEventListener("keydown", t), ()=>{
            document.removeEventListener("mousedown", e), document.removeEventListener("keydown", t);
        };
    }, []), y.userId ? /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)("nav", {
        ref: T,
        className: (0, $1bb08e954409f9ef$export$2e2bcd8739ae039).container,
        children: [
            y.subscriber && /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $153631a56be0d02b$export$27c8cfb9e5df6130), {
                solidesa: "solid",
                href: (0, $444d8bf17e3d997e$export$a7052c111377e79e).URL_REGALA_ARA,
                target: "_blank",
                children: (0, $63c6b3fd54c8dbeb$export$625550452a3fa3ec)("regala_ara", e)
            }),
            !y.subscriber && /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $153631a56be0d02b$export$27c8cfb9e5df6130), {
                tipus: "subscripcio",
                solidesa: "solid",
                href: (0, $444d8bf17e3d997e$export$a7052c111377e79e).URL_SUBSCRIPCIONS,
                target: "_blank",
                children: (0, $63c6b3fd54c8dbeb$export$625550452a3fa3ec)("subscriu", e)
            }),
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("button", {
                className: (0, $e9f0ccf3b177d9d8$var$m.default)((0, $1bb08e954409f9ef$export$2e2bcd8739ae039).avatar, {
                    [(0, $1bb08e954409f9ef$export$2e2bcd8739ae039).premium]: y.premium === "S"
                }),
                onClick: ()=>S((e)=>!e),
                children: y.avatarUrl ? /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("img", {
                    src: y.avatarUrl,
                    alt: y.nick,
                    width: 39,
                    height: 39
                }) : /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("span", {
                    children: y.nick?.charAt(0) || ""
                })
            }),
            C && /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)("a", {
                href: `${E}/#profile`,
                className: (0, $e9f0ccf3b177d9d8$var$m.default)((0, $1bb08e954409f9ef$export$2e2bcd8739ae039).perfil, {
                    [(0, $1bb08e954409f9ef$export$2e2bcd8739ae039).visible]: x
                }),
                children: [
                    /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("span", {
                        children: (0, $63c6b3fd54c8dbeb$export$625550452a3fa3ec)("accedir_perfil", e)
                    }),
                    /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $2a183a46947eafc4$export$fbe2f6ebbbe0cd5a), {
                        name: "navegacio/external",
                        size: 16
                    })
                ]
            })
        ]
    }) : /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)("nav", {
        ref: T,
        className: (0, $1bb08e954409f9ef$export$2e2bcd8739ae039).container,
        children: [
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $153631a56be0d02b$export$27c8cfb9e5df6130), {
                className: (0, $1bb08e954409f9ef$export$2e2bcd8739ae039).subscriu,
                tipus: "subscripcio",
                solidesa: "outline",
                href: (0, $444d8bf17e3d997e$export$a7052c111377e79e).URL_SUBSCRIPCIONS,
                children: (0, $63c6b3fd54c8dbeb$export$625550452a3fa3ec)("subscriu", e)
            }),
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $153631a56be0d02b$export$27c8cfb9e5df6130), {
                href: `${E}/usuari/login?backUrl=${encodeURIComponent(h)}${_}`,
                icona: "menu/log-out",
                children: (0, $63c6b3fd54c8dbeb$export$625550452a3fa3ec)("accedir", e)
            })
        ]
    });
};


var $1134c0584ff2c7d9$export$2e2bcd8739ae039 = {
    container: "ara-ui_header-ara-container_lwbJ",
    mengem: "ara-ui_header-ara-mengem_aZE-",
    logo: "ara-ui_header-ara-logo_WY-f"
};



//#region src/components/header-ara/index.tsx
var $7ad002eb59ab5f4c$var$d = /* @__PURE__ */ (0, $14b872f206384382$export$82dec27a9dce9602)((0, $ba4d14fce8721970$export$f998fc56051369ed)(), 1), $7ad002eb59ab5f4c$export$4522f452a9a9b51e = ({ site: e = "ara", idioma: t = "ca", ...f })=>/* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)("header", {
        className: (0, $7ad002eb59ab5f4c$var$d.default)((0, $1134c0584ff2c7d9$export$2e2bcd8739ae039).container, {
            [(0, $1134c0584ff2c7d9$export$2e2bcd8739ae039).mengem]: e === "mengem"
        }),
        ...f,
        children: [
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: (0, $1134c0584ff2c7d9$export$2e2bcd8739ae039).logo,
                children: [
                    e === "ara" && /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $eb374cfdb5a6536d$export$3677adb25d297fc1), {
                        ambLink: !0
                    }),
                    e === "balears" && /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $18e212819bad6b02$export$16233f4d99e0950b), {
                        ambLink: !0
                    }),
                    e === "criatures" && /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $6bee859631b7b63b$export$bd3fbda7131dbe9d), {}),
                    e === "empreses" && /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $646c87d311181b26$export$a45ee600317773a8), {}),
                    e === "mengem" && /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $c2d756ce4c6f0f64$export$c3970ae1cc01018a), {})
                ]
            }),
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $e9f0ccf3b177d9d8$export$a84658460ef8c64), {
                site: e,
                idioma: t
            })
        ]
    });




//#region src/components/logo-diumenge/index.tsx
var $15d48e1cf1db41e6$export$e8f241ef41498d92 = ({ height: r = 30 })=>/* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("a", {
        href: (0, $444d8bf17e3d997e$export$a7052c111377e79e).URL_DIUMENGE,
        target: "_blank",
        rel: "noopener noreferrer",
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: `${r / 30 * 216}px`,
            height: `${r}px`,
            viewBox: "0 0 216 30",
            fill: "none",
            children: [
                /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("title", {
                    children: (0, $444d8bf17e3d997e$export$a7052c111377e79e).NAME_DIUMENGE
                }),
                /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
                    d: "M2.08702 27.7003V2.28419C2.08702 1.24448 1.88211 1.03197 0 0.827063V0.409668H13.5391C21.6671 0.409668 29.1652 6.24574 29.1652 14.9961C29.1652 23.7464 21.6671 29.5825 13.5391 29.5825H0V29.165C1.88211 28.9525 2.08702 28.74 2.08702 27.7003ZM13.5467 29.1574C18.7984 29.1574 20.21 22.904 20.21 14.9885C20.21 7.07296 18.7984 0.827063 13.5467 0.827063H10.6324V29.1574H13.5467Z",
                    fill: "black"
                }),
                /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
                    d: "M32.504 27.7003V2.28419C32.504 1.24448 32.2991 1.03197 30.417 0.827063V0.409668H43.1213V0.827063C41.2467 1.03197 41.0342 1.24448 41.0342 2.28419V27.7003C41.0342 28.74 41.2391 28.9525 43.1213 29.1574V29.5749H30.417V29.1574C32.2915 28.9525 32.504 28.74 32.504 27.7003Z",
                    fill: "black"
                }),
                /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
                    d: "M46.0431 18.3277V2.28419C46.0431 1.24448 45.8382 1.03197 43.9561 0.827063V0.409668H56.6603V0.827063C54.7858 1.03197 54.5733 1.24448 54.5733 2.28419V21.2419C54.5733 26.6606 58.1175 28.5351 61.8665 28.5351C67.2852 28.5351 69.782 23.7464 69.782 18.3277V2.28419C69.782 1.24448 69.5771 1.03197 64.3633 0.827063V0.409668H74.1534V0.827063C70.6092 1.03197 70.1918 1.24448 70.1918 2.28419V18.3277C70.1918 25.8258 65.9419 29.9922 59.1496 29.9922C50.6269 29.9922 46.0431 25.5374 46.0431 18.3277Z",
                    fill: "black"
                }),
                /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
                    d: "M78.335 2.07927V27.7003C78.335 28.74 79.1698 28.9525 83.9586 29.1574V29.5749H74.5859V29.1574C77.7127 28.9525 77.9176 28.74 77.9176 27.7003V2.28419C77.9176 1.24448 77.7127 1.03197 74.5859 0.827063V0.409668H86.463L93.7562 17.159L98.9244 0.409668H109.382V0.827063C107.508 1.03197 107.295 1.24448 107.295 2.28419V27.7003C107.295 28.74 107.5 28.9525 109.382 29.1574V29.5749H96.6704V29.1574C98.545 28.9525 98.7575 28.74 98.7575 27.7003V2.49669L90.4246 29.7873H90.0071L78.335 2.07927Z",
                    fill: "black"
                }),
                /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
                    d: "M112.911 27.7003V2.28419C112.911 1.24448 112.706 1.03197 110.824 0.827063V0.409668H133.114L133.319 7.70285H132.901C132.066 4.15871 129.987 0.827063 125.82 0.827063H121.449V14.3661H124.363C126.45 14.3661 128.363 12.4916 128.735 9.15998H129.152V19.9897H128.735C128.363 16.6581 126.443 14.7836 124.363 14.7836H121.449V29.1574H125.82C129.987 29.1574 132.066 26.2432 133.531 22.2816H133.948L133.531 29.5749H110.824V29.1574C112.706 28.9525 112.911 28.74 112.911 27.7003Z",
                    fill: "black"
                }),
                /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
                    d: "M138.957 4.37149V27.7006C138.957 28.7403 139.792 28.9528 144.164 29.1577V29.5751H134.791V29.1577C137.918 28.9528 138.54 28.7403 138.54 27.7006V4.78129C138.54 3.74157 138.335 1.03224 134.791 0.819739V0.402344H146.251L159.585 16.8633V2.27687C159.585 1.23715 158.75 1.02465 154.379 0.819739V0.402344H163.751V0.827336C160.625 1.03224 160.002 1.24475 160.002 2.28447V29.78H159.585L138.957 4.37149Z",
                    fill: "black"
                }),
                /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
                    d: "M163.744 14.9962C163.744 6.2459 170.574 0 179.788 0C183.954 0 186.868 1.45713 188.538 2.49684L188.955 8.95521H188.538C187.703 5.62357 184.789 0.417395 179.788 0.417395C175.788 0.417395 172.707 4.16645 172.707 15.0038C172.707 26.2509 175.371 29.5902 179.37 29.5902C180.038 29.5902 180.66 29.5067 181.245 29.3397V17.7131C181.245 16.6734 181.04 16.4609 179.158 16.256V15.8386H191.87V16.256C189.995 16.4609 189.783 16.6734 189.783 17.7131V29.7951H189.365L188.409 27.5866C186.656 28.6264 182.99 30 178.953 30C169.747 29.9924 163.744 23.7465 163.744 14.9962Z",
                    fill: "black"
                }),
                /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
                    d: "M194.783 27.7003V2.28419C194.783 1.24448 194.578 1.03197 192.696 0.827063V0.409668H214.986L215.198 7.70285H214.781C213.946 4.15871 211.867 0.827063 207.7 0.827063H203.329V14.3661H206.243C208.33 14.3661 210.242 12.4916 210.614 9.15998H211.032V19.9897H210.614C210.242 16.6581 208.322 14.7836 206.243 14.7836H203.329V29.1574H207.7C211.867 29.1574 213.954 26.2432 215.411 22.2816H215.828L215.411 29.5749H192.704V29.1574C194.578 28.9525 194.783 28.74 194.783 27.7003Z",
                    fill: "black"
                })
            ]
        })
    });




//#region src/components/logo-llegim/index.tsx
var $9e836c9c7e0a2837$export$157b66a32b6261a5 = ({ height: r = 30 })=>/* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("a", {
        href: (0, $444d8bf17e3d997e$export$a7052c111377e79e).URL_LLEGIM,
        target: "_blank",
        rel: "noopener noreferrer",
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: `${r / 30 * 117}px`,
            height: `${r}px`,
            viewBox: "0 0 117 30",
            fill: "none",
            children: [
                /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("title", {
                    children: (0, $444d8bf17e3d997e$export$a7052c111377e79e).NAME_LLEGIM
                }),
                /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
                    d: "M22.2973 28.2161V0.364746L12.9324 0.851233V1.33772C15.4865 1.37826 15.8919 2.10799 15.8919 3.36475V28.1756C15.8919 29.1891 15.4459 29.5945 13.0946 29.635H12.1216C9.77027 29.5945 9.32432 29.1891 9.32432 28.1756V0.364746L0 0.851233V1.33772C2.55405 1.37826 2.95946 2.10799 2.95946 3.36475V28.1756C2.95946 29.1891 2.51351 29.5945 0.162162 29.635V30.1215H10.0541H12.1216H13.0946H14.7973H25.0541V29.635C22.7027 29.5945 22.2973 29.1891 22.2973 28.2161Z",
                    fill: "#AA0032"
                }),
                /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
                    d: "M36.2831 10.5405C30.648 10.5405 26.1074 14.2703 26.1074 20.7973C26.1074 27.1216 30.2831 30.4865 36.3236 30.4865C40.3777 30.4865 43.0939 28.7027 45.0399 25.6621L44.5939 25.3784C43.0534 27.4865 41.3912 28.7027 38.9588 28.7027C34.9858 28.7027 32.8372 26.027 32.8372 20.7973V20.7162V20.1486H45.1615C45.4047 14.3919 42.202 10.5405 36.2831 10.5405ZM38.7155 19.2973H32.8372C32.9993 14.3919 33.8507 11.3513 36.0399 11.3513C38.3101 11.3513 39.2426 14.473 38.7155 19.2973Z",
                    fill: "#AA0032"
                }),
                /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
                    d: "M116.675 29.6351C114.324 29.5946 113.878 29.1891 113.878 28.1756V16.8243C113.878 12.8513 112.175 10.6216 108.486 10.6216C105.891 10.6216 103.215 12.4864 101.553 14.9594C101.107 12.1621 99.4046 10.6216 96.3641 10.6216C93.6479 10.6216 91.256 12.2432 89.5128 14.6756V10.7432L80.3506 11.2297V11.7162C82.7019 11.7567 83.1884 12.4864 83.1884 13.7432V28.1351C83.1884 29.1486 82.7425 29.554 80.3506 29.5946H79.0533C76.6614 29.554 76.256 29.1486 76.256 28.1351V10.7027L66.8506 11.1891V11.6756C69.2019 11.7162 69.8506 12.4459 69.8506 13.7027V28.0946C69.8506 29.1081 69.2425 29.5135 66.8506 29.554V30.0405H77.9587H79.0533H80.3506H82.7425H91.4182V29.554C89.9587 29.5135 89.5938 29.1081 89.5938 28.0946V15.5675C90.6479 14.2702 91.2965 13.4594 92.5533 13.4594C94.4587 13.4594 95.3506 14.7567 95.3506 16.9054V28.2162C95.3506 29.2297 94.9857 29.6351 93.4857 29.6756V30.1621H103.58V29.6756C102.161 29.6351 101.756 29.2297 101.756 28.2162V16.8648C101.756 16.581 101.756 16.3378 101.715 15.8108C102.851 14.3108 104.067 13.4594 104.918 13.4594C106.824 13.4594 107.553 14.7567 107.553 16.9054V28.2162C107.553 29.2297 107.148 29.6351 105.688 29.6756V30.1621H116.756V29.6351H116.675Z",
                    fill: "#AA0032"
                }),
                /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
                    d: "M69.9321 0.0405405C69.9321 0.0405405 69.2834 0 68.9591 0C62.5943 0 59.797 5.87838 62.5942 12.6486C62.0267 12.2027 61.378 11.8378 60.6483 11.5541C60.4051 11.4324 60.0807 11.3108 59.9186 11.2703C58.7429 10.9054 57.4051 10.7027 56.0267 10.7027C50.9186 10.7027 47.2699 13.2568 47.2699 17.2297C47.2699 20.3108 49.1753 22.2162 52.0943 23.1486C48.8915 23.7973 47.2294 25.7027 47.2294 27.0405C47.2294 27.6081 47.3915 28.2162 47.6753 28.8243C47.7159 28.8649 47.7564 28.9459 47.7564 28.9865C47.797 29.027 47.797 29.1081 47.8375 29.1486C47.878 29.2297 47.9591 29.3108 47.9997 29.3919C48.0402 29.4324 48.0402 29.473 48.0807 29.5135C48.1618 29.6351 48.2834 29.7568 48.3645 29.8378C48.4861 29.9595 48.6078 30.0811 48.7294 30.1622C49.2159 30.5676 49.8645 30.8919 50.5943 31.1757V31.2162C47.2699 31.7027 46.0537 32.7568 46.0537 34.5C46.0537 36.8919 49.9051 38.4324 55.0537 38.4324C61.7024 38.4324 66.1618 35.1892 66.1618 31.4189C66.1618 30.973 66.1213 30.527 65.9997 30.1216C65.9997 30.0811 65.9997 30.0811 65.9591 30.0405C65.9591 29.9595 65.9186 29.8784 65.9186 29.8378C65.878 29.6757 65.8375 29.5541 65.7564 29.4324C65.7564 29.3919 65.7159 29.3514 65.7159 29.3108C65.6348 29.1486 65.5537 28.9865 65.4726 28.8243C65.4726 28.8243 65.4321 28.7838 65.4321 28.7432C64.4186 27.2027 62.3916 26.4324 59.3105 26.4324H54.4456C52.0132 26.4324 50.9997 26.027 50.9997 25.1757C50.9997 24.3243 51.5672 23.7973 53.2294 23.3514C54.0807 23.473 54.9321 23.5541 55.9051 23.5541C60.9726 23.5541 64.6213 21 64.6213 16.9865C64.6213 16.0946 64.4186 15.2838 64.0943 14.5946C64.0537 14.5135 64.0132 14.473 64.0132 14.3919C64.0132 14.3514 63.9726 14.3514 63.9726 14.3108C59.8375 6.40541 63.9726 0.932432 67.6618 0.972973C69.2429 1.01351 70.0537 1.5 70.7429 2.22973C69.6078 2.87838 69.0807 4.01351 69.0807 5.14865C69.0807 7.17568 70.6618 8.27027 72.5672 8.27027C74.5943 8.27027 75.8915 6.81081 75.8915 4.86486C76.0132 3 74.5943 0.364865 69.9321 0.0405405ZM56.2699 37.7027C52.297 37.7027 50.1483 36.6486 50.1483 34.0135C50.1483 32.8378 50.6348 32.0676 51.6888 31.2568H57.7699C61.1753 31.2568 62.2294 32.1892 62.2294 33.6486C62.2294 36.2432 59.797 37.7027 56.2699 37.7027ZM56.1888 22.8243C54.0807 22.8243 53.3105 21.1216 53.3105 17.0676C53.3105 13.0541 53.7159 11.3919 55.824 11.3919C57.9726 11.3919 58.7024 13.4595 58.7024 17.0676C58.6618 21.1216 58.2159 22.8243 56.1888 22.8243Z",
                    fill: "#AA0032"
                })
            ]
        })
    });




//#region src/components/logo-motor/index.tsx
var $0d236a3bbd7e8a21$export$a4ef2b36fe2c9ba8 = ({ height: r = 30 })=>/* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("a", {
        href: (0, $444d8bf17e3d997e$export$a7052c111377e79e).URL_MOTOR,
        target: "_blank",
        rel: "noopener noreferrer",
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)("svg", {
            xmlns: "http://www.w3.org/2000/svg",
            width: `${r / 30 * 134}px`,
            height: `${r}px`,
            viewBox: "0 0 134 30",
            fill: "none",
            children: [
                /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("title", {
                    children: (0, $444d8bf17e3d997e$export$a7052c111377e79e).NAME_MOTOR
                }),
                /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
                    d: "M111.937 29.6226V29.0566C114.625 29.0094 115.144 28.5377 115.144 27.4057V11.0849C115.144 9.66981 114.625 8.82075 111.937 8.77358V8.20755L122.314 7.64151V12.0755C123.776 9.19811 126.323 7.5 128.918 7.5C131.842 7.5 133.446 9.29245 133.446 11.7453C133.446 14.1981 131.889 15.8962 129.72 15.8962C127.172 15.8962 125.71 14.1038 125.71 12.217C125.71 11.5094 125.899 10.7075 126.087 10.0943C124.955 10.1887 123.352 11.4151 122.408 13.0189V27.4057C122.408 28.5377 123.116 28.9151 126.748 29.0566V29.6226H111.937Z",
                    fill: "#007D32"
                }),
                /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
                    d: "M98.0773 29.9999C90.5773 29.9999 86.332 25.8018 86.332 18.7263C86.332 11.698 90.8603 7.3584 98.0773 7.3584C105.483 7.3584 109.775 11.5093 109.775 18.5376C109.775 25.6131 105.247 29.9999 98.0773 29.9999ZM98.266 29.0565C101.379 29.0565 102.087 24.9999 102.087 18.632C102.087 12.2641 101.049 8.30179 97.8415 8.30179C94.6811 8.30179 94.0207 12.2641 94.0207 18.632C94.0207 24.9999 95.0584 29.0565 98.266 29.0565Z",
                    fill: "#007D32"
                }),
                /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
                    d: "M78.0028 30C74.1349 30 70.8801 28.3019 70.8801 23.1604V9.71698H66.7764V8.82076L70.9745 7.9717V1.98113L78.1443 0V8.06604H84.7952V9.62264H78.1443V23.5849C78.1443 26.2264 78.8047 27.5 80.9273 27.5C82.4367 27.5 83.4745 26.6038 84.3707 24.4811L84.9839 24.7641C83.7103 28.3019 81.8235 30 78.0028 30Z",
                    fill: "#007D32"
                }),
                /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
                    d: "M54.3615 29.9999C46.8615 29.9999 42.6162 25.8018 42.6162 18.7263C42.6162 11.698 47.1445 7.3584 54.3615 7.3584C61.7672 7.3584 66.0596 11.5093 66.0596 18.5376C66.0596 25.6131 61.5313 29.9999 54.3615 29.9999ZM54.5502 29.0565C57.6634 29.0565 58.3709 24.9999 58.3709 18.632C58.3709 12.2641 57.3332 8.30179 54.1256 8.30179C50.9653 8.30179 50.3049 12.2641 50.3049 18.632C50.3049 24.9999 51.3426 29.0565 54.5502 29.0565Z",
                    fill: "#007D32"
                }),
                /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
                    d: "M14.8585 29.6226V29.0566C16.5566 29.0094 16.9811 28.5377 16.9811 27.4057V14.5755C16.9811 12.1226 15.9906 10.6604 13.8208 10.6604C12.4057 10.6604 11.6509 11.6038 10.4717 13.066V27.4057C10.4717 28.5377 10.8962 29.0094 12.5472 29.0566V29.6226H0V29.0566C2.68868 29.0094 3.20755 28.5377 3.20755 27.4057V11.0849C3.20755 9.66981 2.68868 8.82075 0 8.77358V8.20755L10.3774 7.64151V12.1226C12.3585 9.33962 15.0943 7.5 18.1604 7.5C21.6038 7.5 23.5377 9.24528 24.0566 12.4057C25.9434 9.62264 29.0094 7.5 31.934 7.5C36.1321 7.5 38.066 10 38.066 14.5283V27.4057C38.066 28.5377 38.5377 29.0094 41.2264 29.0566V29.6226H28.6792V29.0566C30.3302 29.0094 30.8019 28.5377 30.8019 27.4057V14.5755C30.8019 12.1226 30 10.6604 27.8302 10.6604C26.8868 10.6604 25.4717 11.6509 24.1981 13.3491C24.2453 13.9151 24.2453 14.1981 24.2453 14.5283V27.4057C24.2453 28.5377 24.717 29.0094 26.3208 29.0566V29.6226H14.8585Z",
                    fill: "#007D32"
                })
            ]
        })
    });


//#region node_modules/swiper/shared/ssr-window.esm.mjs
function $dab322d733560357$var$e(e) {
    return typeof e == "object" && !!e && "constructor" in e && e.constructor === Object;
}
function $dab322d733560357$var$t(n = {}, r = {}) {
    let i = [
        "__proto__",
        "constructor",
        "prototype"
    ];
    Object.keys(r).filter((e)=>i.indexOf(e) < 0).forEach((i)=>{
        n[i] === void 0 ? n[i] = r[i] : $dab322d733560357$var$e(r[i]) && $dab322d733560357$var$e(n[i]) && Object.keys(r[i]).length > 0 && $dab322d733560357$var$t(n[i], r[i]);
    });
}
var $dab322d733560357$var$n = {
    body: {},
    addEventListener () {},
    removeEventListener () {},
    activeElement: {
        blur () {},
        nodeName: ""
    },
    querySelector () {
        return null;
    },
    querySelectorAll () {
        return [];
    },
    getElementById () {
        return null;
    },
    createEvent () {
        return {
            initEvent () {}
        };
    },
    createElement () {
        return {
            children: [],
            childNodes: [],
            style: {},
            setAttribute () {},
            getElementsByTagName () {
                return [];
            }
        };
    },
    createElementNS () {
        return {};
    },
    importNode () {
        return null;
    },
    location: {
        hash: "",
        host: "",
        hostname: "",
        href: "",
        origin: "",
        pathname: "",
        protocol: "",
        search: ""
    }
};
function $dab322d733560357$export$f65ca476c09acec0() {
    let e = typeof document < "u" ? document : {};
    return $dab322d733560357$var$t(e, $dab322d733560357$var$n), e;
}
var $dab322d733560357$var$i = {
    document: $dab322d733560357$var$n,
    navigator: {
        userAgent: ""
    },
    location: {
        hash: "",
        host: "",
        hostname: "",
        href: "",
        origin: "",
        pathname: "",
        protocol: "",
        search: ""
    },
    history: {
        replaceState () {},
        pushState () {},
        go () {},
        back () {}
    },
    CustomEvent: function() {
        return this;
    },
    addEventListener () {},
    removeEventListener () {},
    getComputedStyle () {
        return {
            getPropertyValue () {
                return "";
            }
        };
    },
    Image () {},
    Date () {},
    screen: {},
    setTimeout () {},
    clearTimeout () {},
    matchMedia () {
        return {};
    },
    requestAnimationFrame (e) {
        return typeof setTimeout > "u" ? (e(), null) : setTimeout(e, 0);
    },
    cancelAnimationFrame (e) {
        typeof setTimeout > "u" || clearTimeout(e);
    }
};
function $dab322d733560357$export$38b2d434cce3ea22() {
    let e = typeof window < "u" ? window : {};
    return $dab322d733560357$var$t(e, $dab322d733560357$var$i), e;
}



//#region node_modules/swiper/shared/utils.mjs
function $9bf922a49190330a$var$t(e = "") {
    return e.trim().split(" ").filter((e)=>!!e.trim());
}
function $9bf922a49190330a$export$8694e5c03a4df8e6(e) {
    let t = e;
    Object.keys(t).forEach((e)=>{
        try {
            t[e] = null;
        } catch  {}
        try {
            delete t[e];
        } catch  {}
    });
}
function $9bf922a49190330a$export$bdd553fddd433dcb(e, t = 0) {
    return setTimeout(e, t);
}
function $9bf922a49190330a$export$461939dd4422153() {
    return Date.now();
}
function $9bf922a49190330a$var$a(t) {
    let n = (0, $dab322d733560357$export$38b2d434cce3ea22)(), r;
    return n.getComputedStyle && (r = n.getComputedStyle(t, null)), !r && t.currentStyle && (r = t.currentStyle), r ||= t.style, r;
}
function $9bf922a49190330a$export$5ec402b7fcf74398(t, n = "x") {
    let r = (0, $dab322d733560357$export$38b2d434cce3ea22)(), i, o1, s, c = $9bf922a49190330a$var$a(t);
    return r.WebKitCSSMatrix ? (o1 = c.transform || c.webkitTransform, o1.split(",").length > 6 && (o1 = o1.split(", ").map((e)=>e.replace(",", ".")).join(", ")), s = new r.WebKitCSSMatrix(o1 === "none" ? "" : o1)) : (s = c.MozTransform || c.OTransform || c.MsTransform || c.msTransform || c.transform || c.getPropertyValue("transform").replace("translate(", "matrix(1, 0, 0, 1,"), i = s.toString().split(",")), n === "x" && (o1 = r.WebKitCSSMatrix ? s.m41 : i.length === 16 ? parseFloat(i[12]) : parseFloat(i[4])), n === "y" && (o1 = r.WebKitCSSMatrix ? s.m42 : i.length === 16 ? parseFloat(i[13]) : parseFloat(i[5])), o1 || 0;
}
function $9bf922a49190330a$var$s(e) {
    return typeof e == "object" && !!e && e.constructor && Object.prototype.toString.call(e).slice(8, -1) === "Object";
}
function $9bf922a49190330a$var$c(e) {
    return typeof window < "u" && window.HTMLElement !== void 0 ? e instanceof HTMLElement : e && (e.nodeType === 1 || e.nodeType === 11);
}
function $9bf922a49190330a$export$8b58be045bf06082(...e) {
    let t = Object(e[0]);
    for(let n = 1; n < e.length; n += 1){
        let r = e[n];
        if (r != null && !$9bf922a49190330a$var$c(r)) {
            let e = Object.keys(Object(r)).filter((e)=>e !== "__proto__" && e !== "constructor" && e !== "prototype");
            for(let n = 0, i = e.length; n < i; n += 1){
                let i = e[n], a = Object.getOwnPropertyDescriptor(r, i);
                a !== void 0 && a.enumerable && ($9bf922a49190330a$var$s(t[i]) && $9bf922a49190330a$var$s(r[i]) ? r[i].__swiper__ ? t[i] = r[i] : $9bf922a49190330a$export$8b58be045bf06082(t[i], r[i]) : !$9bf922a49190330a$var$s(t[i]) && $9bf922a49190330a$var$s(r[i]) ? (t[i] = {}, r[i].__swiper__ ? t[i] = r[i] : $9bf922a49190330a$export$8b58be045bf06082(t[i], r[i])) : t[i] = r[i]);
            }
        }
    }
    return t;
}
function $9bf922a49190330a$export$a607267f322101fd(e, t, n) {
    e.style.setProperty(t, n);
}
function $9bf922a49190330a$export$a5dd2b4b1a116d6d({ swiper: t, targetPosition: n, side: r }) {
    let i = (0, $dab322d733560357$export$38b2d434cce3ea22)(), a = -t.translate, o = null, s, c = t.params.speed;
    t.wrapperEl.style.scrollSnapType = "none", i.cancelAnimationFrame(t.cssModeFrameID);
    let l = n > a ? "next" : "prev", u = (e, t)=>l === "next" && e >= t || l === "prev" && e <= t, d = ()=>{
        s = /* @__PURE__ */ new Date().getTime(), o === null && (o = s);
        let e = Math.max(Math.min((s - o) / c, 1), 0), l = a + (.5 - Math.cos(e * Math.PI) / 2) * (n - a);
        if (u(l, n) && (l = n), t.wrapperEl.scrollTo({
            [r]: l
        }), u(l, n)) {
            t.wrapperEl.style.overflow = "hidden", t.wrapperEl.style.scrollSnapType = "", setTimeout(()=>{
                t.wrapperEl.style.overflow = "", t.wrapperEl.scrollTo({
                    [r]: l
                });
            }), i.cancelAnimationFrame(t.cssModeFrameID);
            return;
        }
        t.cssModeFrameID = i.requestAnimationFrame(d);
    };
    d();
}
function $9bf922a49190330a$export$eb846d859f2895e6(t, n = "") {
    let r = (0, $dab322d733560357$export$38b2d434cce3ea22)(), i = [
        ...t.children
    ];
    return r.HTMLSlotElement && t instanceof HTMLSlotElement && i.push(...t.assignedElements()), n ? i.filter((e)=>e.matches(n)) : i;
}
function $9bf922a49190330a$var$p(e, t) {
    let n = [
        t
    ];
    for(; n.length > 0;){
        let t = n.shift();
        if (e === t) return !0;
        n.push(...t.children, ...t.shadowRoot ? t.shadowRoot.children : [], ...t.assignedElements ? t.assignedElements() : []);
    }
}
function $9bf922a49190330a$export$22524b9f05cc7272(t, n) {
    let r = (0, $dab322d733560357$export$38b2d434cce3ea22)(), i = n.contains(t);
    return !i && r.HTMLSlotElement && n instanceof HTMLSlotElement && (i = [
        ...n.assignedElements()
    ].includes(t), i ||= $9bf922a49190330a$var$p(t, n)), i;
}
function $9bf922a49190330a$export$da2f4e8190fdb5e1(e) {
    try {
        console.warn(e);
        return;
    } catch  {}
}
function $9bf922a49190330a$export$c8a8987d4410bf2d(e, n = []) {
    let r = document.createElement(e);
    return r.classList.add(...Array.isArray(n) ? n : $9bf922a49190330a$var$t(n)), r;
}
function $9bf922a49190330a$export$392b9fa9626e91e0(e, t) {
    let n = [];
    for(; e.previousElementSibling;){
        let r = e.previousElementSibling;
        t ? r.matches(t) && n.push(r) : n.push(r), e = r;
    }
    return n;
}
function $9bf922a49190330a$export$b245807c30cf5df8(e, t) {
    let n = [];
    for(; e.nextElementSibling;){
        let r = e.nextElementSibling;
        t ? r.matches(t) && n.push(r) : n.push(r), e = r;
    }
    return n;
}
function $9bf922a49190330a$export$4184470d4bd0f986(t, n) {
    return (0, $dab322d733560357$export$38b2d434cce3ea22)().getComputedStyle(t, null).getPropertyValue(n);
}
function $9bf922a49190330a$export$371885c503a01623(e) {
    let t = e, n;
    if (t) {
        for(n = 0; (t = t.previousSibling) !== null;)t.nodeType === 1 && (n += 1);
        return n;
    }
}
function $9bf922a49190330a$export$aedc7b608ca8e855(e, t) {
    let n = [], r = e.parentElement;
    for(; r;)t ? r.matches(t) && n.push(r) : n.push(r), r = r.parentElement;
    return n;
}
function $9bf922a49190330a$export$863f37913038cf77(t, n, r) {
    let i = (0, $dab322d733560357$export$38b2d434cce3ea22)();
    return r ? t[n === "width" ? "offsetWidth" : "offsetHeight"] + parseFloat(i.getComputedStyle(t, null).getPropertyValue(n === "width" ? "margin-right" : "margin-top")) + parseFloat(i.getComputedStyle(t, null).getPropertyValue(n === "width" ? "margin-left" : "margin-bottom")) : t.offsetWidth;
}
function $9bf922a49190330a$export$daf5c237e5477731(e) {
    return (Array.isArray(e) ? e : [
        e
    ]).filter((e)=>!!e);
}
function $9bf922a49190330a$export$55f7c773066364d6(e, t = "") {
    typeof trustedTypes < "u" ? e.innerHTML = trustedTypes.createPolicy("html", {
        createHTML: (e)=>e
    }).createHTML(t) : e.innerHTML = t;
}


//#region node_modules/swiper/shared/swiper-core.mjs
var $6130630b8727286b$var$y;
function $6130630b8727286b$var$b() {
    let n = (0, $dab322d733560357$export$38b2d434cce3ea22)(), r = (0, $dab322d733560357$export$f65ca476c09acec0)();
    return {
        smoothScroll: r.documentElement && r.documentElement.style && "scrollBehavior" in r.documentElement.style,
        touch: !!("ontouchstart" in n || n.DocumentTouch && r instanceof n.DocumentTouch)
    };
}
function $6130630b8727286b$var$x() {
    return $6130630b8727286b$var$y ||= $6130630b8727286b$var$b(), $6130630b8727286b$var$y;
}
var $6130630b8727286b$var$S;
function $6130630b8727286b$var$C({ userAgent: e } = {}) {
    let n = $6130630b8727286b$var$x(), r = (0, $dab322d733560357$export$38b2d434cce3ea22)(), i = r.navigator.platform, a = e || r.navigator.userAgent, o = {
        ios: !1,
        android: !1
    }, s = r.screen.width, c = r.screen.height, l = a.match(/(Android);?[\s\/]+([\d.]+)?/), u = a.match(/(iPad)(?!\1).*OS\s([\d_]+)/), d = a.match(/(iPod)(.*OS\s([\d_]+))?/), f = !u && a.match(/(iPhone\sOS|iOS)\s([\d_]+)/), p = i === "Win32", m = i === "MacIntel";
    return !u && m && n.touch && [
        "1024x1366",
        "1366x1024",
        "834x1194",
        "1194x834",
        "834x1112",
        "1112x834",
        "768x1024",
        "1024x768",
        "820x1180",
        "1180x820",
        "810x1080",
        "1080x810"
    ].indexOf(`${s}x${c}`) >= 0 && (u = a.match(/(Version)\/([\d.]+)/), u ||= [
        0,
        1,
        "13_0_0"
    ], m = !1), l && !p && (o.os = "android", o.android = !0), (u || f || d) && (o.os = "ios", o.ios = !0), o;
}
function $6130630b8727286b$var$w(e = {}) {
    return $6130630b8727286b$var$S ||= $6130630b8727286b$var$C(e), $6130630b8727286b$var$S;
}
var $6130630b8727286b$var$T;
function $6130630b8727286b$var$E() {
    let e = (0, $dab322d733560357$export$38b2d434cce3ea22)(), n = $6130630b8727286b$var$w(), r = !1;
    function i() {
        let t = e.navigator.userAgent.toLowerCase();
        return t.indexOf("safari") >= 0 && t.indexOf("chrome") < 0 && t.indexOf("android") < 0;
    }
    if (i()) {
        let t = String(e.navigator.userAgent);
        if (t.includes("Version/")) {
            let [e, n] = t.split("Version/")[1].split(" ")[0].split(".").map((e)=>Number(e));
            r = e < 16 || e === 16 && n < 2;
        }
    }
    let a = /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(e.navigator.userAgent), o = i(), s = o || a && n.ios;
    return {
        isSafari: r || o,
        needPerspectiveFix: r,
        need3dFix: s,
        isWebView: a
    };
}
function $6130630b8727286b$var$D() {
    return $6130630b8727286b$var$T ||= $6130630b8727286b$var$E(), $6130630b8727286b$var$T;
}
function $6130630b8727286b$var$O({ swiper: e, on: n, emit: r }) {
    let i = (0, $dab322d733560357$export$38b2d434cce3ea22)(), a = null, o = null, s = ()=>{
        !e || e.destroyed || !e.initialized || (r("beforeResize"), r("resize"));
    }, c = ()=>{
        !e || e.destroyed || !e.initialized || (a = new ResizeObserver((t)=>{
            o = i.requestAnimationFrame(()=>{
                let { width: n, height: r } = e, i = n, a = r;
                t.forEach(({ contentBoxSize: t, contentRect: n, target: r })=>{
                    r && r !== e.el || (i = n ? n.width : (t[0] || t).inlineSize, a = n ? n.height : (t[0] || t).blockSize);
                }), (i !== n || a !== r) && s();
            });
        }), a.observe(e.el));
    }, l = ()=>{
        o && i.cancelAnimationFrame(o), a && a.unobserve && e.el && (a.unobserve(e.el), a = null);
    }, u = ()=>{
        !e || e.destroyed || !e.initialized || r("orientationchange");
    };
    n("init", ()=>{
        if (e.params.resizeObserver && i.ResizeObserver !== void 0) {
            c();
            return;
        }
        i.addEventListener("resize", s), i.addEventListener("orientationchange", u);
    }), n("destroy", ()=>{
        l(), i.removeEventListener("resize", s), i.removeEventListener("orientationchange", u);
    });
}
function $6130630b8727286b$var$k({ swiper: e, extendParams: n, on: r, emit: i }) {
    let a = [], o = (0, $dab322d733560357$export$38b2d434cce3ea22)(), s = (t, n = {})=>{
        let r = new (o.MutationObserver || o.WebkitMutationObserver)((t)=>{
            if (e.__preventObserver__) return;
            if (t.length === 1) {
                i("observerUpdate", t[0]);
                return;
            }
            let n = function() {
                i("observerUpdate", t[0]);
            };
            o.requestAnimationFrame ? o.requestAnimationFrame(n) : o.setTimeout(n, 0);
        });
        r.observe(t, {
            attributes: n.attributes === void 0 ? !0 : n.attributes,
            childList: e.isElement || (n.childList === void 0 ? !0 : n).childList,
            characterData: n.characterData === void 0 ? !0 : n.characterData
        }), a.push(r);
    };
    n({
        observer: !1,
        observeParents: !1,
        observeSlideChildren: !1
    }), r("init", ()=>{
        if (e.params.observer) {
            if (e.params.observeParents) {
                let t = (0, $9bf922a49190330a$export$aedc7b608ca8e855)(e.hostEl);
                for(let e = 0; e < t.length; e += 1)s(t[e]);
            }
            s(e.hostEl, {
                childList: e.params.observeSlideChildren
            }), s(e.wrapperEl, {
                attributes: !1
            });
        }
    }), r("destroy", ()=>{
        a.forEach((e)=>{
            e.disconnect();
        }), a.splice(0, a.length);
    });
}
var $6130630b8727286b$var$A = {
    on (e, t, n) {
        let r = this;
        if (!r.eventsListeners || r.destroyed || typeof t != "function") return r;
        let i = n ? "unshift" : "push";
        return e.split(" ").forEach((e)=>{
            r.eventsListeners[e] || (r.eventsListeners[e] = []), r.eventsListeners[e][i](t);
        }), r;
    },
    once (e, t, n) {
        let r = this;
        if (!r.eventsListeners || r.destroyed || typeof t != "function") return r;
        function i(...n) {
            r.off(e, i), i.__emitterProxy && delete i.__emitterProxy, t.apply(r, n);
        }
        return i.__emitterProxy = t, r.on(e, i, n);
    },
    onAny (e, t) {
        let n = this;
        if (!n.eventsListeners || n.destroyed || typeof e != "function") return n;
        let r = t ? "unshift" : "push";
        return n.eventsAnyListeners.indexOf(e) < 0 && n.eventsAnyListeners[r](e), n;
    },
    offAny (e) {
        let t = this;
        if (!t.eventsListeners || t.destroyed || !t.eventsAnyListeners) return t;
        let n = t.eventsAnyListeners.indexOf(e);
        return n >= 0 && t.eventsAnyListeners.splice(n, 1), t;
    },
    off (e, t) {
        let n = this;
        return !n.eventsListeners || n.destroyed || !n.eventsListeners || e.split(" ").forEach((e)=>{
            t === void 0 ? n.eventsListeners[e] = [] : n.eventsListeners[e] && n.eventsListeners[e].forEach((r, i)=>{
                (r === t || r.__emitterProxy && r.__emitterProxy === t) && n.eventsListeners[e].splice(i, 1);
            });
        }), n;
    },
    emit (...e) {
        let t = this;
        if (!t.eventsListeners || t.destroyed || !t.eventsListeners) return t;
        let n, r, i;
        return typeof e[0] == "string" || Array.isArray(e[0]) ? (n = e[0], r = e.slice(1, e.length), i = t) : (n = e[0].events, r = e[0].data, i = e[0].context || t), r.unshift(i), (Array.isArray(n) ? n : n.split(" ")).forEach((e)=>{
            t.eventsAnyListeners && t.eventsAnyListeners.length && t.eventsAnyListeners.forEach((t)=>{
                t.apply(i, [
                    e,
                    ...r
                ]);
            }), t.eventsListeners && t.eventsListeners[e] && t.eventsListeners[e].forEach((e)=>{
                e.apply(i, r);
            });
        }), t;
    }
};
function $6130630b8727286b$var$j() {
    let e = this, t, n, r = e.el;
    t = e.params.width !== void 0 && e.params.width !== null ? e.params.width : r.clientWidth, n = e.params.height !== void 0 && e.params.height !== null ? e.params.height : r.clientHeight, !(t === 0 && e.isHorizontal() || n === 0 && e.isVertical()) && (t = t - parseInt((0, $9bf922a49190330a$export$4184470d4bd0f986)(r, "padding-left") || 0, 10) - parseInt((0, $9bf922a49190330a$export$4184470d4bd0f986)(r, "padding-right") || 0, 10), n = n - parseInt((0, $9bf922a49190330a$export$4184470d4bd0f986)(r, "padding-top") || 0, 10) - parseInt((0, $9bf922a49190330a$export$4184470d4bd0f986)(r, "padding-bottom") || 0, 10), Number.isNaN(t) && (t = 0), Number.isNaN(n) && (n = 0), Object.assign(e, {
        width: t,
        height: n,
        size: e.isHorizontal() ? t : n
    }));
}
function $6130630b8727286b$var$M() {
    let e = this;
    function t(t, n) {
        return parseFloat(t.getPropertyValue(e.getDirectionLabel(n)) || 0);
    }
    let n = e.params, { wrapperEl: r, slidesEl: i, rtlTranslate: o, wrongRTL: s } = e, c = e.virtual && n.virtual.enabled, u = c ? e.virtual.slides.length : e.slides.length, d = (0, $9bf922a49190330a$export$eb846d859f2895e6)(i, `.${e.params.slideClass}, swiper-slide`), p = c ? e.virtual.slides.length : d.length, m = [], h = [], g = [], v = n.slidesOffsetBefore;
    typeof v == "function" && (v = n.slidesOffsetBefore.call(e));
    let y = n.slidesOffsetAfter;
    typeof y == "function" && (y = n.slidesOffsetAfter.call(e));
    let b = e.snapGrid.length, x = e.slidesGrid.length, S = e.size - v - y, C = n.spaceBetween, w = -v, T = 0, E = 0;
    if (S === void 0) return;
    typeof C == "string" && C.indexOf("%") >= 0 ? C = parseFloat(C.replace("%", "")) / 100 * S : typeof C == "string" && (C = parseFloat(C)), e.virtualSize = -C - v - y, d.forEach((e)=>{
        o ? e.style.marginLeft = "" : e.style.marginRight = "", e.style.marginBottom = "", e.style.marginTop = "";
    }), n.centeredSlides && n.cssMode && ((0, $9bf922a49190330a$export$a607267f322101fd)(r, "--swiper-centered-offset-before", ""), (0, $9bf922a49190330a$export$a607267f322101fd)(r, "--swiper-centered-offset-after", "")), n.cssMode && ((0, $9bf922a49190330a$export$a607267f322101fd)(r, "--swiper-slides-offset-before", `${v}px`), (0, $9bf922a49190330a$export$a607267f322101fd)(r, "--swiper-slides-offset-after", `${y}px`));
    let D = n.grid && n.grid.rows > 1 && e.grid;
    D ? e.grid.initSlides(d) : e.grid && e.grid.unsetSlides();
    let O, k = n.slidesPerView === "auto" && n.breakpoints && Object.keys(n.breakpoints).filter((e)=>n.breakpoints[e].slidesPerView !== void 0).length > 0;
    for(let r = 0; r < p; r += 1){
        O = 0;
        let i = d[r];
        if (!(i && (D && e.grid.updateSlide(r, i, d), (0, $9bf922a49190330a$export$4184470d4bd0f986)(i, "display") === "none"))) {
            if (c && n.slidesPerView === "auto") n.virtual.slidesPerViewAutoSlideSize && (O = n.virtual.slidesPerViewAutoSlideSize), O && i && (n.roundLengths && (O = Math.floor(O)), i.style[e.getDirectionLabel("width")] = `${O}px`);
            else if (n.slidesPerView === "auto") {
                k && (i.style[e.getDirectionLabel("width")] = "");
                let r = getComputedStyle(i), a = i.style.transform, o = i.style.webkitTransform;
                if (a && (i.style.transform = "none"), o && (i.style.webkitTransform = "none"), n.roundLengths) O = e.isHorizontal() ? (0, $9bf922a49190330a$export$863f37913038cf77)(i, "width", !0) : (0, $9bf922a49190330a$export$863f37913038cf77)(i, "height", !0);
                else {
                    let e = t(r, "width"), n = t(r, "padding-left"), a = t(r, "padding-right"), o = t(r, "margin-left"), s = t(r, "margin-right"), c = r.getPropertyValue("box-sizing");
                    if (c && c === "border-box") O = e + o + s;
                    else {
                        let { clientWidth: t, offsetWidth: r } = i;
                        O = e + n + a + o + s + (r - t);
                    }
                }
                a && (i.style.transform = a), o && (i.style.webkitTransform = o), n.roundLengths && (O = Math.floor(O));
            } else O = (S - (n.slidesPerView - 1) * C) / n.slidesPerView, n.roundLengths && (O = Math.floor(O)), i && (i.style[e.getDirectionLabel("width")] = `${O}px`);
            i && (i.swiperSlideSize = O), g.push(O), n.centeredSlides ? (w = w + O / 2 + T / 2 + C, T === 0 && r !== 0 && (w = w - S / 2 - C), r === 0 && (w = w - S / 2 - C), Math.abs(w) < 0.001 && (w = 0), n.roundLengths && (w = Math.floor(w)), E % n.slidesPerGroup === 0 && m.push(w), h.push(w)) : (n.roundLengths && (w = Math.floor(w)), (E - Math.min(e.params.slidesPerGroupSkip, E)) % e.params.slidesPerGroup === 0 && m.push(w), h.push(w), w = w + O + C), e.virtualSize += O + C, T = O, E += 1;
        }
    }
    if (e.virtualSize = Math.max(e.virtualSize, S) + y, o && s && (n.effect === "slide" || n.effect === "coverflow") && (r.style.width = `${e.virtualSize + C}px`), n.setWrapperSize && (r.style[e.getDirectionLabel("width")] = `${e.virtualSize + C}px`), D && e.grid.updateWrapperSize(O, m), !n.centeredSlides) {
        let t = n.slidesPerView !== "auto" && n.slidesPerView % 1 != 0, r = n.snapToSlideEdge && !n.loop && (n.slidesPerView === "auto" || t), i = m.length;
        if (r) {
            let e;
            if (n.slidesPerView === "auto") {
                e = 1;
                let t = 0;
                for(let n = g.length - 1; n >= 0 && (t += g[n] + (n < g.length - 1 ? C : 0), t <= S); --n)e = g.length - n;
            } else e = Math.floor(n.slidesPerView);
            i = Math.max(p - e, 0);
        }
        let a = [];
        for(let t = 0; t < m.length; t += 1){
            let o = m[t];
            n.roundLengths && (o = Math.floor(o)), r ? t <= i && a.push(o) : m[t] <= e.virtualSize - S && a.push(o);
        }
        m = a, Math.floor(e.virtualSize - S) - Math.floor(m[m.length - 1]) > 1 && (r || m.push(e.virtualSize - S));
    }
    if (c && n.loop) {
        let t = g[0] + C;
        if (n.slidesPerGroup > 1) {
            let r = Math.ceil((e.virtual.slidesBefore + e.virtual.slidesAfter) / n.slidesPerGroup), i = t * n.slidesPerGroup;
            for(let e = 0; e < r; e += 1)m.push(m[m.length - 1] + i);
        }
        for(let r = 0; r < e.virtual.slidesBefore + e.virtual.slidesAfter; r += 1)n.slidesPerGroup === 1 && m.push(m[m.length - 1] + t), h.push(h[h.length - 1] + t), e.virtualSize += t;
    }
    if (m.length === 0 && (m = [
        0
    ]), C !== 0) {
        let t = e.isHorizontal() && o ? "marginLeft" : e.getDirectionLabel("marginRight");
        d.filter((e, t)=>!n.cssMode || n.loop ? !0 : t !== d.length - 1).forEach((e)=>{
            e.style[t] = `${C}px`;
        });
    }
    if (n.centeredSlides && n.centeredSlidesBounds) {
        let e = 0;
        g.forEach((t)=>{
            e += t + (C || 0);
        }), e -= C;
        let t = e > S ? e - S : 0;
        m = m.map((e)=>e <= 0 ? -v : e > t ? t + y : e);
    }
    if (n.centerInsufficientSlides) {
        let e = 0;
        if (g.forEach((t)=>{
            e += t + (C || 0);
        }), e -= C, e < S) {
            let t = (S - e) / 2;
            m.forEach((e, n)=>{
                m[n] = e - t;
            }), h.forEach((e, n)=>{
                h[n] = e + t;
            });
        }
    }
    if (Object.assign(e, {
        slides: d,
        snapGrid: m,
        slidesGrid: h,
        slidesSizesGrid: g
    }), n.centeredSlides && n.cssMode && !n.centeredSlidesBounds) {
        (0, $9bf922a49190330a$export$a607267f322101fd)(r, "--swiper-centered-offset-before", `${-m[0]}px`), (0, $9bf922a49190330a$export$a607267f322101fd)(r, "--swiper-centered-offset-after", `${e.size / 2 - g[g.length - 1] / 2}px`);
        let t = -e.snapGrid[0], n = -e.slidesGrid[0];
        e.snapGrid = e.snapGrid.map((e)=>e + t), e.slidesGrid = e.slidesGrid.map((e)=>e + n);
    }
    if (p !== u && e.emit("slidesLengthChange"), m.length !== b && (e.params.watchOverflow && e.checkOverflow(), e.emit("snapGridLengthChange")), h.length !== x && e.emit("slidesGridLengthChange"), n.watchSlidesProgress && e.updateSlidesOffset(), e.emit("slidesUpdated"), !c && !n.cssMode && (n.effect === "slide" || n.effect === "fade")) {
        let t = `${n.containerModifierClass}backface-hidden`, r = e.el.classList.contains(t);
        p <= n.maxBackfaceHiddenSlides ? r || e.el.classList.add(t) : r && e.el.classList.remove(t);
    }
}
function $6130630b8727286b$var$N(e) {
    let t = this, n = [], r = t.virtual && t.params.virtual.enabled, i = 0, a;
    typeof e == "number" ? t.setTransition(e) : e === !0 && t.setTransition(t.params.speed);
    let o = (e)=>r ? t.slides[t.getSlideIndexByData(e)] : t.slides[e];
    if (t.params.slidesPerView !== "auto" && t.params.slidesPerView > 1) {
        if (t.params.centeredSlides) (t.visibleSlides || []).forEach((e)=>{
            n.push(e);
        });
        else for(a = 0; a < Math.ceil(t.params.slidesPerView); a += 1){
            let e = t.activeIndex + a;
            if (e > t.slides.length && !r) break;
            n.push(o(e));
        }
    } else n.push(o(t.activeIndex));
    for(a = 0; a < n.length; a += 1)if (n[a] !== void 0) {
        let e = n[a].offsetHeight;
        i = e > i ? e : i;
    }
    (i || i === 0) && (t.wrapperEl.style.height = `${i}px`);
}
function $6130630b8727286b$var$ee() {
    let e = this, t = e.slides, n = e.isElement ? e.isHorizontal() ? e.wrapperEl.offsetLeft : e.wrapperEl.offsetTop : 0;
    for(let r = 0; r < t.length; r += 1)t[r].swiperSlideOffset = (e.isHorizontal() ? t[r].offsetLeft : t[r].offsetTop) - n - e.cssOverflowAdjustment();
}
var $6130630b8727286b$var$P = (e, t, n)=>{
    t && !e.classList.contains(n) ? e.classList.add(n) : !t && e.classList.contains(n) && e.classList.remove(n);
};
function $6130630b8727286b$var$te(e = this && this.translate || 0) {
    let t = this, n = t.params, { slides: r, rtlTranslate: i, snapGrid: a } = t;
    if (r.length === 0) return;
    r[0].swiperSlideOffset === void 0 && t.updateSlidesOffset();
    let o = -e;
    i && (o = e), t.visibleSlidesIndexes = [], t.visibleSlides = [];
    let s = n.spaceBetween;
    typeof s == "string" && s.indexOf("%") >= 0 ? s = parseFloat(s.replace("%", "")) / 100 * t.size : typeof s == "string" && (s = parseFloat(s));
    for(let e = 0; e < r.length; e += 1){
        let c = r[e], l = c.swiperSlideOffset;
        n.cssMode && n.centeredSlides && (l -= r[0].swiperSlideOffset);
        let u = (o + (n.centeredSlides ? t.minTranslate() : 0) - l) / (c.swiperSlideSize + s), d = (o - a[0] + (n.centeredSlides ? t.minTranslate() : 0) - l) / (c.swiperSlideSize + s), f = -(o - l), p = f + t.slidesSizesGrid[e], m = f >= 0 && f <= t.size - t.slidesSizesGrid[e], h = f >= 0 && f < t.size - 1 || p > 1 && p <= t.size || f <= 0 && p >= t.size;
        h && (t.visibleSlides.push(c), t.visibleSlidesIndexes.push(e)), $6130630b8727286b$var$P(c, h, n.slideVisibleClass), $6130630b8727286b$var$P(c, m, n.slideFullyVisibleClass), c.progress = i ? -u : u, c.originalProgress = i ? -d : d;
    }
}
function $6130630b8727286b$var$ne(e) {
    let t = this;
    if (e === void 0) {
        let n = t.rtlTranslate ? -1 : 1;
        e = t && t.translate && t.translate * n || 0;
    }
    let n = t.params, r = t.maxTranslate() - t.minTranslate(), { progress: i, isBeginning: a, isEnd: o, progressLoop: s } = t, c = a, l = o;
    if (r === 0) i = 0, a = !0, o = !0;
    else {
        i = (e - t.minTranslate()) / r;
        let n = Math.abs(e - t.minTranslate()) < 1, s = Math.abs(e - t.maxTranslate()) < 1;
        a = n || i <= 0, o = s || i >= 1, n && (i = 0), s && (i = 1);
    }
    if (n.loop) {
        let n = t.getSlideIndexByData(0), r = t.getSlideIndexByData(t.slides.length - 1), i = t.slidesGrid[n], a = t.slidesGrid[r], o = t.slidesGrid[t.slidesGrid.length - 1], c = Math.abs(e);
        s = c >= i ? (c - i) / o : (c + o - a) / o, s > 1 && --s;
    }
    Object.assign(t, {
        progress: i,
        progressLoop: s,
        isBeginning: a,
        isEnd: o
    }), (n.watchSlidesProgress || n.centeredSlides && n.autoHeight) && t.updateSlidesProgress(e), a && !c && t.emit("reachBeginning toEdge"), o && !l && t.emit("reachEnd toEdge"), (c && !a || l && !o) && t.emit("fromEdge"), t.emit("progress", i);
}
var $6130630b8727286b$var$F = (e, t, n)=>{
    t && !e.classList.contains(n) ? e.classList.add(n) : !t && e.classList.contains(n) && e.classList.remove(n);
};
function $6130630b8727286b$var$I() {
    let e = this, { slides: t, params: n, slidesEl: r, activeIndex: i } = e, o = e.virtual && n.virtual.enabled, s = e.grid && n.grid && n.grid.rows > 1, l = (e)=>(0, $9bf922a49190330a$export$eb846d859f2895e6)(r, `.${n.slideClass}${e}, swiper-slide${e}`)[0], u, f, p;
    if (o) {
        if (n.loop) {
            let t = i - e.virtual.slidesBefore;
            t < 0 && (t = e.virtual.slides.length + t), t >= e.virtual.slides.length && (t -= e.virtual.slides.length), u = l(`[data-swiper-slide-index="${t}"]`);
        } else u = l(`[data-swiper-slide-index="${i}"]`);
    } else s ? (u = t.find((e)=>e.column === i), p = t.find((e)=>e.column === i + 1), f = t.find((e)=>e.column === i - 1)) : u = t[i];
    u && (s || (p = (0, $9bf922a49190330a$export$b245807c30cf5df8)(u, `.${n.slideClass}, swiper-slide`)[0], n.loop && !p && (p = t[0]), f = (0, $9bf922a49190330a$export$392b9fa9626e91e0)(u, `.${n.slideClass}, swiper-slide`)[0], n.loop)), t.forEach((e)=>{
        $6130630b8727286b$var$F(e, e === u, n.slideActiveClass), $6130630b8727286b$var$F(e, e === p, n.slideNextClass), $6130630b8727286b$var$F(e, e === f, n.slidePrevClass);
    }), e.emitSlidesClasses();
}
var $6130630b8727286b$var$L = (e, t)=>{
    if (!e || e.destroyed || !e.params) return;
    let n = t.closest(e.isElement ? "swiper-slide" : `.${e.params.slideClass}`);
    if (n) {
        let t = n.querySelector(`.${e.params.lazyPreloaderClass}`);
        !t && e.isElement && (n.shadowRoot ? t = n.shadowRoot.querySelector(`.${e.params.lazyPreloaderClass}`) : requestAnimationFrame(()=>{
            n.shadowRoot && (t = n.shadowRoot.querySelector(`.${e.params.lazyPreloaderClass}`), t && !t.lazyPreloaderManaged && t.remove());
        })), t && !t.lazyPreloaderManaged && t.remove();
    }
}, $6130630b8727286b$var$R = (e, t)=>{
    if (!e.slides[t]) return;
    let n = e.slides[t].querySelector("[loading=\"lazy\"]");
    n && n.removeAttribute("loading");
}, $6130630b8727286b$var$z = (e)=>{
    if (!e || e.destroyed || !e.params) return;
    let t = e.params.lazyPreloadPrevNext, n = e.slides.length;
    if (!n || !t || t < 0) return;
    t = Math.min(t, n);
    let r = e.params.slidesPerView === "auto" ? e.slidesPerViewDynamic() : Math.ceil(e.params.slidesPerView), i = e.activeIndex;
    if (e.params.grid && e.params.grid.rows > 1) {
        let n = i, a = [
            n - t
        ];
        a.push(...Array.from({
            length: t
        }).map((e, t)=>n + r + t)), e.slides.forEach((t, n)=>{
            a.includes(t.column) && $6130630b8727286b$var$R(e, n);
        });
        return;
    }
    let a = i + r - 1;
    if (e.params.rewind || e.params.loop) for(let r = i - t; r <= a + t; r += 1){
        let t = (r % n + n) % n;
        (t < i || t > a) && $6130630b8727286b$var$R(e, t);
    }
    else for(let r = Math.max(i - t, 0); r <= Math.min(a + t, n - 1); r += 1)r !== i && (r > a || r < i) && $6130630b8727286b$var$R(e, r);
};
function $6130630b8727286b$var$re(e) {
    let { slidesGrid: t, params: n } = e, r = e.rtlTranslate ? e.translate : -e.translate, i;
    for(let e = 0; e < t.length; e += 1)t[e + 1] === void 0 ? r >= t[e] && (i = e) : r >= t[e] && r < t[e + 1] - (t[e + 1] - t[e]) / 2 ? i = e : r >= t[e] && r < t[e + 1] && (i = e + 1);
    return n.normalizeSlideIndex && (i < 0 || i === void 0) && (i = 0), i;
}
function $6130630b8727286b$var$ie(e) {
    let t = this, n = t.rtlTranslate ? t.translate : -t.translate, { snapGrid: r, params: i, activeIndex: a, realIndex: o, snapIndex: s } = t, c = e, l, u = (e)=>{
        let n = e - t.virtual.slidesBefore;
        return n < 0 && (n = t.virtual.slides.length + n), n >= t.virtual.slides.length && (n -= t.virtual.slides.length), n;
    };
    if (c === void 0 && (c = $6130630b8727286b$var$re(t)), r.indexOf(n) >= 0) l = r.indexOf(n);
    else {
        let e = Math.min(i.slidesPerGroupSkip, c);
        l = e + Math.floor((c - e) / i.slidesPerGroup);
    }
    if (l >= r.length && (l = r.length - 1), c === a && !t.params.loop) {
        l !== s && (t.snapIndex = l, t.emit("snapIndexChange"));
        return;
    }
    if (c === a && t.params.loop && t.virtual && t.params.virtual.enabled) {
        t.realIndex = u(c);
        return;
    }
    let d = t.grid && i.grid && i.grid.rows > 1, f;
    if (t.virtual && i.virtual.enabled) f = i.loop ? u(c) : c;
    else if (d) {
        let e = t.slides.find((e)=>e.column === c), n = parseInt(e.getAttribute("data-swiper-slide-index"), 10);
        Number.isNaN(n) && (n = Math.max(t.slides.indexOf(e), 0)), f = Math.floor(n / i.grid.rows);
    } else if (t.slides[c]) {
        let e = t.slides[c].getAttribute("data-swiper-slide-index");
        f = e ? parseInt(e, 10) : c;
    } else f = c;
    Object.assign(t, {
        previousSnapIndex: s,
        snapIndex: l,
        previousRealIndex: o,
        realIndex: f,
        previousIndex: a,
        activeIndex: c
    }), t.initialized && $6130630b8727286b$var$z(t), t.emit("activeIndexChange"), t.emit("snapIndexChange"), (t.initialized || t.params.runCallbacksOnInit) && (o !== f && t.emit("realIndexChange"), t.emit("slideChange"));
}
function $6130630b8727286b$var$ae(e, t) {
    let n = this, r = n.params, i = e.closest(`.${r.slideClass}, swiper-slide`);
    !i && n.isElement && t && t.length > 1 && t.includes(e) && [
        ...t.slice(t.indexOf(e) + 1, t.length)
    ].forEach((e)=>{
        !i && e.matches && e.matches(`.${r.slideClass}, swiper-slide`) && (i = e);
    });
    let a = !1, o;
    if (i) {
        for(let e = 0; e < n.slides.length; e += 1)if (n.slides[e] === i) {
            a = !0, o = e;
            break;
        }
    }
    if (i && a) n.clickedSlide = i, n.virtual && n.params.virtual.enabled ? n.clickedIndex = parseInt(i.getAttribute("data-swiper-slide-index"), 10) : n.clickedIndex = o;
    else {
        n.clickedSlide = void 0, n.clickedIndex = void 0;
        return;
    }
    r.slideToClickedSlide && n.clickedIndex !== void 0 && n.clickedIndex !== n.activeIndex && n.slideToClickedSlide();
}
var $6130630b8727286b$var$oe = {
    updateSize: $6130630b8727286b$var$j,
    updateSlides: $6130630b8727286b$var$M,
    updateAutoHeight: $6130630b8727286b$var$N,
    updateSlidesOffset: $6130630b8727286b$var$ee,
    updateSlidesProgress: $6130630b8727286b$var$te,
    updateProgress: $6130630b8727286b$var$ne,
    updateSlidesClasses: $6130630b8727286b$var$I,
    updateActiveIndex: $6130630b8727286b$var$ie,
    updateClickedSlide: $6130630b8727286b$var$ae
};
function $6130630b8727286b$var$se(e = this.isHorizontal() ? "x" : "y") {
    let t = this, { params: n, rtlTranslate: r, translate: i, wrapperEl: a } = t;
    if (n.virtualTranslate) return r ? -i : i;
    if (n.cssMode) return i;
    let o = (0, $9bf922a49190330a$export$5ec402b7fcf74398)(a, e);
    return o += t.cssOverflowAdjustment(), r && (o = -o), o || 0;
}
function $6130630b8727286b$var$ce(e, t) {
    let n = this, { rtlTranslate: r, params: i, wrapperEl: a, progress: o } = n, s = 0, c = 0;
    n.isHorizontal() ? s = r ? -e : e : c = e, i.roundLengths && (s = Math.floor(s), c = Math.floor(c)), n.previousTranslate = n.translate, n.translate = n.isHorizontal() ? s : c, i.cssMode ? a[n.isHorizontal() ? "scrollLeft" : "scrollTop"] = n.isHorizontal() ? -s : -c : i.virtualTranslate || (n.isHorizontal() ? s -= n.cssOverflowAdjustment() : c -= n.cssOverflowAdjustment(), a.style.transform = `translate3d(${s}px, ${c}px, 0px)`);
    let l, u = n.maxTranslate() - n.minTranslate();
    l = u === 0 ? 0 : (e - n.minTranslate()) / u, l !== o && n.updateProgress(e), n.emit("setTranslate", n.translate, t);
}
function $6130630b8727286b$var$le() {
    return -this.snapGrid[0];
}
function $6130630b8727286b$var$B() {
    return -this.snapGrid[this.snapGrid.length - 1];
}
function $6130630b8727286b$var$V(e = 0, t = this.params.speed, r = !0, i = !0, a) {
    let o = this, { params: s, wrapperEl: c } = o;
    if (o.animating && s.preventInteractionOnTransition) return !1;
    let l = o.minTranslate(), u = o.maxTranslate(), d;
    if (d = i && e > l ? l : i && e < u ? u : e, o.updateProgress(d), s.cssMode) {
        let e = o.isHorizontal();
        if (t === 0) c[e ? "scrollLeft" : "scrollTop"] = -d;
        else {
            if (!o.support.smoothScroll) return (0, $9bf922a49190330a$export$a5dd2b4b1a116d6d)({
                swiper: o,
                targetPosition: -d,
                side: e ? "left" : "top"
            }), !0;
            c.scrollTo({
                [e ? "left" : "top"]: -d,
                behavior: "smooth"
            });
        }
        return !0;
    }
    return t === 0 ? (o.setTransition(0), o.setTranslate(d), r && (o.emit("beforeTransitionStart", t, a), o.emit("transitionEnd"))) : (o.setTransition(t), o.setTranslate(d), r && (o.emit("beforeTransitionStart", t, a), o.emit("transitionStart")), o.animating || (o.animating = !0, o.onTranslateToWrapperTransitionEnd ||= function(e) {
        !o || o.destroyed || e.target === this && (o.wrapperEl.removeEventListener("transitionend", o.onTranslateToWrapperTransitionEnd), o.onTranslateToWrapperTransitionEnd = null, delete o.onTranslateToWrapperTransitionEnd, o.animating = !1, r && o.emit("transitionEnd"));
    }, o.wrapperEl.addEventListener("transitionend", o.onTranslateToWrapperTransitionEnd))), !0;
}
var $6130630b8727286b$var$H = {
    getTranslate: $6130630b8727286b$var$se,
    setTranslate: $6130630b8727286b$var$ce,
    minTranslate: $6130630b8727286b$var$le,
    maxTranslate: $6130630b8727286b$var$B,
    translateTo: $6130630b8727286b$var$V
};
function $6130630b8727286b$var$U(e, t) {
    let n = this;
    n.params.cssMode || (n.wrapperEl.style.transitionDuration = `${e}ms`, n.wrapperEl.style.transitionDelay = e === 0 ? "0ms" : ""), n.emit("setTransition", e, t);
}
function $6130630b8727286b$var$W({ swiper: e, runCallbacks: t, direction: n, step: r }) {
    let { activeIndex: i, previousIndex: a } = e, o = n;
    o ||= i > a ? "next" : i < a ? "prev" : "reset", e.emit(`transition${r}`), t && o === "reset" ? e.emit(`slideResetTransition${r}`) : t && i !== a && (e.emit(`slideChangeTransition${r}`), o === "next" ? e.emit(`slideNextTransition${r}`) : e.emit(`slidePrevTransition${r}`));
}
function $6130630b8727286b$var$ue(e = !0, t) {
    let n = this, { params: r } = n;
    r.cssMode || (r.autoHeight && n.updateAutoHeight(), $6130630b8727286b$var$W({
        swiper: n,
        runCallbacks: e,
        direction: t,
        step: "Start"
    }));
}
function $6130630b8727286b$var$de(e = !0, t) {
    let n = this, { params: r } = n;
    n.animating = !1, !r.cssMode && (n.setTransition(0), $6130630b8727286b$var$W({
        swiper: n,
        runCallbacks: e,
        direction: t,
        step: "End"
    }));
}
var $6130630b8727286b$var$fe = {
    setTransition: $6130630b8727286b$var$U,
    transitionStart: $6130630b8727286b$var$ue,
    transitionEnd: $6130630b8727286b$var$de
};
function $6130630b8727286b$var$pe(e = 0, t, r = !0, i, a) {
    typeof e == "string" && (e = parseInt(e, 10));
    let o = this, s = e;
    s < 0 && (s = 0);
    let { params: c, snapGrid: l, slidesGrid: u, previousIndex: d, activeIndex: f, rtlTranslate: p, wrapperEl: m, enabled: h } = o;
    if (!h && !i && !a || o.destroyed || o.animating && c.preventInteractionOnTransition) return !1;
    t === void 0 && (t = o.params.speed);
    let g = Math.min(o.params.slidesPerGroupSkip, s), _ = g + Math.floor((s - g) / o.params.slidesPerGroup);
    _ >= l.length && (_ = l.length - 1);
    let v = -l[_];
    if (c.normalizeSlideIndex) for(let e = 0; e < u.length; e += 1){
        let t = -Math.floor(v * 100), n = Math.floor(u[e] * 100), r = Math.floor(u[e + 1] * 100);
        u[e + 1] === void 0 ? t >= n && (s = e) : t >= n && t < r - (r - n) / 2 ? s = e : t >= n && t < r && (s = e + 1);
    }
    if (o.initialized && s !== f && (!o.allowSlideNext && (p ? v > o.translate && v > o.minTranslate() : v < o.translate && v < o.minTranslate()) || !o.allowSlidePrev && v > o.translate && v > o.maxTranslate() && (f || 0) !== s)) return !1;
    s !== (d || 0) && r && o.emit("beforeSlideChangeStart"), o.updateProgress(v);
    let y;
    y = s > f ? "next" : s < f ? "prev" : "reset";
    let b = o.virtual && o.params.virtual.enabled;
    if (!(b && a) && (p && -v === o.translate || !p && v === o.translate)) return o.updateActiveIndex(s), c.autoHeight && o.updateAutoHeight(), o.updateSlidesClasses(), c.effect !== "slide" && o.setTranslate(v), y !== "reset" && (o.transitionStart(r, y), o.transitionEnd(r, y)), !1;
    if (c.cssMode) {
        let e = o.isHorizontal(), r = p ? v : -v;
        if (t === 0) b && (o.wrapperEl.style.scrollSnapType = "none", o._immediateVirtual = !0), b && !o._cssModeVirtualInitialSet && o.params.initialSlide > 0 ? (o._cssModeVirtualInitialSet = !0, requestAnimationFrame(()=>{
            m[e ? "scrollLeft" : "scrollTop"] = r;
        })) : m[e ? "scrollLeft" : "scrollTop"] = r, b && requestAnimationFrame(()=>{
            o.wrapperEl.style.scrollSnapType = "", o._immediateVirtual = !1;
        });
        else {
            if (!o.support.smoothScroll) return (0, $9bf922a49190330a$export$a5dd2b4b1a116d6d)({
                swiper: o,
                targetPosition: r,
                side: e ? "left" : "top"
            }), !0;
            m.scrollTo({
                [e ? "left" : "top"]: r,
                behavior: "smooth"
            });
        }
        return !0;
    }
    let x = $6130630b8727286b$var$D().isSafari;
    return b && !a && x && o.isElement && o.virtual.update(!1, !1, s), o.setTransition(t), o.setTranslate(v), o.updateActiveIndex(s), o.updateSlidesClasses(), o.emit("beforeTransitionStart", t, i), o.transitionStart(r, y), t === 0 ? o.transitionEnd(r, y) : o.animating || (o.animating = !0, o.onSlideToWrapperTransitionEnd ||= function(e) {
        !o || o.destroyed || e.target === this && (o.wrapperEl.removeEventListener("transitionend", o.onSlideToWrapperTransitionEnd), o.onSlideToWrapperTransitionEnd = null, delete o.onSlideToWrapperTransitionEnd, o.transitionEnd(r, y));
    }, o.wrapperEl.addEventListener("transitionend", o.onSlideToWrapperTransitionEnd)), !0;
}
function $6130630b8727286b$var$me(e = 0, t, n = !0, r) {
    typeof e == "string" && (e = parseInt(e, 10));
    let i = this;
    if (i.destroyed) return;
    t === void 0 && (t = i.params.speed);
    let a = i.grid && i.params.grid && i.params.grid.rows > 1, o = e;
    if (i.params.loop) {
        if (i.virtual && i.params.virtual.enabled) o += i.virtual.slidesBefore;
        else {
            let e;
            if (a) {
                let t = o * i.params.grid.rows;
                e = i.slides.find((e)=>e.getAttribute("data-swiper-slide-index") * 1 === t).column;
            } else e = i.getSlideIndexByData(o);
            let t = a ? Math.ceil(i.slides.length / i.params.grid.rows) : i.slides.length, { centeredSlides: n, slidesOffsetBefore: s, slidesOffsetAfter: c } = i.params, l = n || !!s || !!c, u = i.params.slidesPerView;
            u === "auto" ? u = i.slidesPerViewDynamic() : (u = Math.ceil(parseFloat(i.params.slidesPerView, 10)), l && u % 2 == 0 && (u += 1));
            let d = t - e < u;
            if (l && (d ||= e < Math.ceil(u / 2)), r && l && i.params.slidesPerView !== "auto" && !a && (d = !1), d) {
                let n = l ? e < i.activeIndex ? "prev" : "next" : e - i.activeIndex - 1 < i.params.slidesPerView ? "next" : "prev";
                i.loopFix({
                    direction: n,
                    slideTo: !0,
                    activeSlideIndex: n === "next" ? e + 1 : e - t + 1,
                    slideRealIndex: n === "next" ? i.realIndex : void 0
                });
            }
            if (a) {
                let e = o * i.params.grid.rows;
                o = i.slides.find((t)=>t.getAttribute("data-swiper-slide-index") * 1 === e).column;
            } else o = i.getSlideIndexByData(o);
        }
    }
    return requestAnimationFrame(()=>{
        i.slideTo(o, t, n, r);
    }), i;
}
function $6130630b8727286b$var$he(e, t = !0, n) {
    let r = this, { enabled: i, params: a, animating: o } = r;
    if (!i || r.destroyed) return r;
    e === void 0 && (e = r.params.speed);
    let s = a.slidesPerGroup;
    a.slidesPerView === "auto" && a.slidesPerGroup === 1 && a.slidesPerGroupAuto && (s = Math.max(r.slidesPerViewDynamic("current", !0), 1));
    let c = r.activeIndex < a.slidesPerGroupSkip ? 1 : s, l = r.virtual && a.virtual.enabled;
    if (a.loop) {
        if (o && !l && a.loopPreventsSliding) return !1;
        if (r.loopFix({
            direction: "next"
        }), r._clientLeft = r.wrapperEl.clientLeft, r.activeIndex === r.slides.length - 1 && a.cssMode) return requestAnimationFrame(()=>{
            r.slideTo(r.activeIndex + c, e, t, n);
        }), !0;
    }
    return a.rewind && r.isEnd ? r.slideTo(0, e, t, n) : r.slideTo(r.activeIndex + c, e, t, n);
}
function $6130630b8727286b$var$ge(e, t = !0, n) {
    let r = this, { params: i, snapGrid: a, slidesGrid: o, rtlTranslate: s, enabled: c, animating: l } = r;
    if (!c || r.destroyed) return r;
    e === void 0 && (e = r.params.speed);
    let u = r.virtual && i.virtual.enabled;
    if (i.loop) {
        if (l && !u && i.loopPreventsSliding) return !1;
        r.loopFix({
            direction: "prev"
        }), r._clientLeft = r.wrapperEl.clientLeft;
    }
    let d = s ? r.translate : -r.translate;
    function f(e) {
        return e < 0 ? -Math.floor(Math.abs(e)) : Math.floor(e);
    }
    let p = f(d), m = a.map((e)=>f(e)), h = i.freeMode && i.freeMode.enabled, g = a[m.indexOf(p) - 1];
    if (g === void 0 && (i.cssMode || h)) {
        let e;
        a.forEach((t, n)=>{
            p >= t && (e = n);
        }), e !== void 0 && (g = h ? a[e] : a[e > 0 ? e - 1 : e]);
    }
    let _ = 0;
    if (g !== void 0 && (_ = o.indexOf(g), _ < 0 && (_ = r.activeIndex - 1), i.slidesPerView === "auto" && i.slidesPerGroup === 1 && i.slidesPerGroupAuto && (_ = _ - r.slidesPerViewDynamic("previous", !0) + 1, _ = Math.max(_, 0))), i.rewind && r.isBeginning) {
        let i = r.params.virtual && r.params.virtual.enabled && r.virtual ? r.virtual.slides.length - 1 : r.slides.length - 1;
        return r.slideTo(i, e, t, n);
    } else if (i.loop && r.activeIndex === 0 && i.cssMode) return requestAnimationFrame(()=>{
        r.slideTo(_, e, t, n);
    }), !0;
    return r.slideTo(_, e, t, n);
}
function $6130630b8727286b$var$_e(e, t = !0, n) {
    let r = this;
    if (!r.destroyed) return e === void 0 && (e = r.params.speed), r.slideTo(r.activeIndex, e, t, n);
}
function $6130630b8727286b$var$ve(e, t = !0, n, r = .5) {
    let i = this;
    if (i.destroyed) return;
    e === void 0 && (e = i.params.speed);
    let a = i.activeIndex, o = Math.min(i.params.slidesPerGroupSkip, a), s = o + Math.floor((a - o) / i.params.slidesPerGroup), c = i.rtlTranslate ? i.translate : -i.translate;
    if (c >= i.snapGrid[s]) {
        let e = i.snapGrid[s], t = i.snapGrid[s + 1];
        c - e > (t - e) * r && (a += i.params.slidesPerGroup);
    } else {
        let e = i.snapGrid[s - 1], t = i.snapGrid[s];
        c - e <= (t - e) * r && (a -= i.params.slidesPerGroup);
    }
    return a = Math.max(a, 0), a = Math.min(a, i.slidesGrid.length - 1), i.slideTo(a, e, t, n);
}
function $6130630b8727286b$var$ye() {
    let e = this;
    if (e.destroyed) return;
    let { params: t, slidesEl: n } = e, r = t.slidesPerView === "auto" ? e.slidesPerViewDynamic() : t.slidesPerView, i = e.getSlideIndexWhenGrid(e.clickedIndex), o, s = e.isElement ? "swiper-slide" : `.${t.slideClass}`, c = e.grid && e.params.grid && e.params.grid.rows > 1;
    if (t.loop) {
        if (e.animating) return;
        o = parseInt(e.clickedSlide.getAttribute("data-swiper-slide-index"), 10), t.centeredSlides ? e.slideToLoop(o) : i > (c ? (e.slides.length - r) / 2 - (e.params.grid.rows - 1) : e.slides.length - r) ? (e.loopFix(), i = e.getSlideIndex((0, $9bf922a49190330a$export$eb846d859f2895e6)(n, `${s}[data-swiper-slide-index="${o}"]`)[0]), (0, $9bf922a49190330a$export$bdd553fddd433dcb)(()=>{
            e.slideTo(i);
        })) : e.slideTo(i);
    } else e.slideTo(i);
}
var $6130630b8727286b$var$be = {
    slideTo: $6130630b8727286b$var$pe,
    slideToLoop: $6130630b8727286b$var$me,
    slideNext: $6130630b8727286b$var$he,
    slidePrev: $6130630b8727286b$var$ge,
    slideReset: $6130630b8727286b$var$_e,
    slideToClosest: $6130630b8727286b$var$ve,
    slideToClickedSlide: $6130630b8727286b$var$ye
};
function $6130630b8727286b$var$xe(e, t) {
    let n = this, { params: i, slidesEl: o } = n;
    if (!i.loop || n.virtual && n.params.virtual.enabled) return;
    let s = ()=>{
        (0, $9bf922a49190330a$export$eb846d859f2895e6)(o, `.${i.slideClass}, swiper-slide`).forEach((e, t)=>{
            e.setAttribute("data-swiper-slide-index", t);
        });
    }, c = ()=>{
        let e = (0, $9bf922a49190330a$export$eb846d859f2895e6)(o, `.${i.slideBlankClass}`);
        e.forEach((e)=>{
            e.remove();
        }), e.length > 0 && (n.recalcSlides(), n.updateSlides());
    }, l = n.grid && i.grid && i.grid.rows > 1;
    i.loopAddBlankSlides && (i.slidesPerGroup > 1 || l) && c();
    let u = i.slidesPerGroup * (l ? i.grid.rows : 1), d = n.slides.length % u !== 0, f = l && n.slides.length % i.grid.rows !== 0, p = (e)=>{
        for(let t = 0; t < e; t += 1){
            let e = n.isElement ? (0, $9bf922a49190330a$export$c8a8987d4410bf2d)("swiper-slide", [
                i.slideBlankClass
            ]) : (0, $9bf922a49190330a$export$c8a8987d4410bf2d)("div", [
                i.slideClass,
                i.slideBlankClass
            ]);
            n.slidesEl.append(e);
        }
    };
    d ? (i.loopAddBlankSlides ? (p(u - n.slides.length % u), n.recalcSlides(), n.updateSlides()) : (0, $9bf922a49190330a$export$da2f4e8190fdb5e1)("Swiper Loop Warning: The number of slides is not even to slidesPerGroup, loop mode may not function properly. You need to add more slides (or make duplicates, or empty slides)"), s()) : (f && (i.loopAddBlankSlides ? (p(i.grid.rows - n.slides.length % i.grid.rows), n.recalcSlides(), n.updateSlides()) : (0, $9bf922a49190330a$export$da2f4e8190fdb5e1)("Swiper Loop Warning: The number of slides is not even to grid.rows, loop mode may not function properly. You need to add more slides (or make duplicates, or empty slides)")), s());
    let m = i.centeredSlides || !!i.slidesOffsetBefore || !!i.slidesOffsetAfter;
    n.loopFix({
        slideRealIndex: e,
        direction: m ? void 0 : "next",
        initial: t
    });
}
function $6130630b8727286b$var$Se({ slideRealIndex: e, slideTo: t = !0, direction: n, setTranslate: r, activeSlideIndex: i, initial: a, byController: o, byMousewheel: s } = {}) {
    let c = this;
    if (!c.params.loop) return;
    c.emit("beforeLoopFix");
    let { slides: l, allowSlidePrev: u, allowSlideNext: d, slidesEl: f, params: p } = c, { centeredSlides: m, slidesOffsetBefore: h, slidesOffsetAfter: g, initialSlide: _ } = p, y = m || !!h || !!g;
    if (c.allowSlidePrev = !0, c.allowSlideNext = !0, c.virtual && p.virtual.enabled) {
        t && (!y && c.snapIndex === 0 ? c.slideTo(c.virtual.slides.length, 0, !1, !0) : y && c.snapIndex < p.slidesPerView ? c.slideTo(c.virtual.slides.length + c.snapIndex, 0, !1, !0) : c.snapIndex === c.snapGrid.length - 1 && c.slideTo(c.virtual.slidesBefore, 0, !1, !0)), c.allowSlidePrev = u, c.allowSlideNext = d, c.emit("loopFix");
        return;
    }
    let b = p.slidesPerView;
    b === "auto" ? b = c.slidesPerViewDynamic() : (b = Math.ceil(parseFloat(p.slidesPerView, 10)), y && b % 2 == 0 && (b += 1));
    let x = p.slidesPerGroupAuto ? b : p.slidesPerGroup, S = y ? Math.max(x, Math.ceil(b / 2)) : x;
    S % x !== 0 && (S += x - S % x), S += p.loopAdditionalSlides, c.loopedSlides = S;
    let C = c.grid && p.grid && p.grid.rows > 1;
    l.length < b + S || c.params.effect === "cards" && l.length < b + S * 2 ? (0, $9bf922a49190330a$export$da2f4e8190fdb5e1)("Swiper Loop Warning: The number of slides is not enough for loop mode, it will be disabled or not function properly. You need to add more slides (or make duplicates) or lower the values of slidesPerView and slidesPerGroup parameters") : C && p.grid.fill === "row" && (0, $9bf922a49190330a$export$da2f4e8190fdb5e1)("Swiper Loop Warning: Loop mode is not compatible with grid.fill = `row`");
    let w = [], T = [], E = C ? Math.ceil(l.length / p.grid.rows) : l.length, D = a && E - _ < b && !y, O = D ? _ : c.activeIndex;
    i === void 0 ? i = c.getSlideIndex(l.find((e)=>e.classList.contains(p.slideActiveClass))) : O = i;
    let k = n === "next" || !n, A = n === "prev" || !n, j = 0, M = 0, N = (C ? l[i].column : i) + (y && r === void 0 ? -b / 2 + .5 : 0);
    if (N < S) {
        j = Math.max(S - N, x);
        for(let e = 0; e < S - N; e += 1){
            let t = e - Math.floor(e / E) * E;
            if (C) {
                let e = E - t - 1;
                for(let t = l.length - 1; t >= 0; --t)l[t].column === e && w.push(t);
            } else w.push(E - t - 1);
        }
    } else if (N + b > E - S) {
        M = Math.max(N - (E - S * 2), x), D && (M = Math.max(M, b - E + _ + 1));
        for(let e = 0; e < M; e += 1){
            let t = e - Math.floor(e / E) * E;
            C ? l.forEach((e, n)=>{
                e.column === t && T.push(n);
            }) : T.push(t);
        }
    }
    if (c.__preventObserver__ = !0, requestAnimationFrame(()=>{
        c.__preventObserver__ = !1;
    }), c.params.effect === "cards" && l.length < b + S * 2 && (T.includes(i) && T.splice(T.indexOf(i), 1), w.includes(i) && w.splice(w.indexOf(i), 1)), A && w.forEach((e)=>{
        l[e].swiperLoopMoveDOM = !0, f.prepend(l[e]), l[e].swiperLoopMoveDOM = !1;
    }), k && T.forEach((e)=>{
        l[e].swiperLoopMoveDOM = !0, f.append(l[e]), l[e].swiperLoopMoveDOM = !1;
    }), c.recalcSlides(), p.slidesPerView === "auto" ? c.updateSlides() : C && (w.length > 0 && A || T.length > 0 && k) && c.slides.forEach((e, t)=>{
        c.grid.updateSlide(t, e, c.slides);
    }), p.watchSlidesProgress && c.updateSlidesOffset(), t) {
        if (w.length > 0 && A) {
            if (e === void 0) {
                let e = c.slidesGrid[O], t = c.slidesGrid[O + j] - e;
                s ? c.setTranslate(c.translate - t) : (c.slideTo(O + Math.ceil(j), 0, !1, !0), r && (c.touchEventsData.startTranslate = c.touchEventsData.startTranslate - t, c.touchEventsData.currentTranslate = c.touchEventsData.currentTranslate - t));
            } else if (r) {
                let e = C ? w.length / p.grid.rows : w.length;
                c.slideTo(c.activeIndex + e, 0, !1, !0), c.touchEventsData.currentTranslate = c.translate;
            }
        } else if (T.length > 0 && k) {
            if (e === void 0) {
                let e = c.slidesGrid[O], t = c.slidesGrid[O - M] - e;
                s ? c.setTranslate(c.translate - t) : (c.slideTo(O - M, 0, !1, !0), r && (c.touchEventsData.startTranslate = c.touchEventsData.startTranslate - t, c.touchEventsData.currentTranslate = c.touchEventsData.currentTranslate - t));
            } else {
                let e = C ? T.length / p.grid.rows : T.length;
                c.slideTo(c.activeIndex - e, 0, !1, !0);
            }
        }
    }
    if (c.allowSlidePrev = u, c.allowSlideNext = d, c.controller && c.controller.control && !o) {
        let a = {
            slideRealIndex: e,
            direction: n,
            setTranslate: r,
            activeSlideIndex: i,
            byController: !0
        };
        Array.isArray(c.controller.control) ? c.controller.control.forEach((e)=>{
            !e.destroyed && e.params.loop && e.loopFix({
                ...a,
                slideTo: e.params.slidesPerView === p.slidesPerView ? t : !1
            });
        }) : c.controller.control instanceof c.constructor && c.controller.control.params.loop && c.controller.control.loopFix({
            ...a,
            slideTo: c.controller.control.params.slidesPerView === p.slidesPerView ? t : !1
        });
    }
    c.emit("loopFix");
}
function $6130630b8727286b$var$Ce() {
    let e = this, { params: t, slidesEl: n } = e;
    if (!t.loop || !n || e.virtual && e.params.virtual.enabled) return;
    e.recalcSlides();
    let r = [];
    e.slides.forEach((e)=>{
        let t = e.swiperSlideIndex === void 0 ? e.getAttribute("data-swiper-slide-index") * 1 : e.swiperSlideIndex;
        r[t] = e;
    }), e.slides.forEach((e)=>{
        e.removeAttribute("data-swiper-slide-index");
    }), r.forEach((e)=>{
        n.append(e);
    }), e.recalcSlides(), e.slideTo(e.realIndex, 0);
}
var $6130630b8727286b$var$we = {
    loopCreate: $6130630b8727286b$var$xe,
    loopFix: $6130630b8727286b$var$Se,
    loopDestroy: $6130630b8727286b$var$Ce
};
function $6130630b8727286b$var$Te(e) {
    let t = this;
    if (!t.params.simulateTouch || t.params.watchOverflow && t.isLocked || t.params.cssMode) return;
    let n = t.params.touchEventsTarget === "container" ? t.el : t.wrapperEl;
    t.isElement && (t.__preventObserver__ = !0), n.style.cursor = "move", n.style.cursor = e ? "grabbing" : "grab", t.isElement && requestAnimationFrame(()=>{
        t.__preventObserver__ = !1;
    });
}
function $6130630b8727286b$var$Ee() {
    let e = this;
    e.params.watchOverflow && e.isLocked || e.params.cssMode || (e.isElement && (e.__preventObserver__ = !0), e[e.params.touchEventsTarget === "container" ? "el" : "wrapperEl"].style.cursor = "", e.isElement && requestAnimationFrame(()=>{
        e.__preventObserver__ = !1;
    }));
}
var $6130630b8727286b$var$De = {
    setGrabCursor: $6130630b8727286b$var$Te,
    unsetGrabCursor: $6130630b8727286b$var$Ee
};
function $6130630b8727286b$var$Oe(n, r = this) {
    function i(r) {
        if (!r || r === (0, $dab322d733560357$export$f65ca476c09acec0)() || r === (0, $dab322d733560357$export$38b2d434cce3ea22)()) return null;
        r.assignedSlot && (r = r.assignedSlot);
        let a = r.closest(n);
        return !a && !r.getRootNode ? null : a || i(r.getRootNode().host);
    }
    return i(r);
}
function $6130630b8727286b$var$G(e, n, r) {
    let i = (0, $dab322d733560357$export$38b2d434cce3ea22)(), { params: a } = e, o = a.edgeSwipeDetection, s = a.edgeSwipeThreshold;
    return o && (r <= s || r >= i.innerWidth - s) ? o === "prevent" ? (n.preventDefault(), !0) : !1 : !0;
}
function $6130630b8727286b$var$ke(t) {
    let n = this, r = (0, $dab322d733560357$export$f65ca476c09acec0)(), i = t;
    i.originalEvent && (i = i.originalEvent);
    let a = n.touchEventsData;
    if (i.type === "pointerdown") {
        if (a.pointerId !== null && a.pointerId !== i.pointerId) return;
        a.pointerId = i.pointerId;
    } else i.type === "touchstart" && i.targetTouches.length === 1 && (a.touchId = i.targetTouches[0].identifier);
    if (i.type === "touchstart") {
        $6130630b8727286b$var$G(n, i, i.targetTouches[0].pageX);
        return;
    }
    let { params: o, touches: c, enabled: l } = n;
    if (!l || !o.simulateTouch && i.pointerType === "mouse" || n.animating && o.preventInteractionOnTransition) return;
    !n.animating && o.cssMode && o.loop && n.loopFix();
    let u = i.target;
    if (o.touchEventsTarget === "wrapper" && !(0, $9bf922a49190330a$export$22524b9f05cc7272)(u, n.wrapperEl) || "which" in i && i.which === 3 || "button" in i && i.button > 0 || a.isTouched && a.isMoved) return;
    let d = !!o.noSwipingClass && o.noSwipingClass !== "", f = i.composedPath ? i.composedPath() : i.path;
    d && i.target && i.target.shadowRoot && f && (u = f[0]);
    let p = o.noSwipingSelector ? o.noSwipingSelector : `.${o.noSwipingClass}`, m = !!(i.target && i.target.shadowRoot);
    if (o.noSwiping && (m ? $6130630b8727286b$var$Oe(p, u) : u.closest(p))) {
        n.allowClick = !0;
        return;
    }
    if (o.swipeHandler && !u.closest(o.swipeHandler)) return;
    c.currentX = i.pageX, c.currentY = i.pageY;
    let h = c.currentX, _ = c.currentY;
    if (!$6130630b8727286b$var$G(n, i, h)) return;
    Object.assign(a, {
        isTouched: !0,
        isMoved: !1,
        allowTouchCallbacks: !0,
        isScrolling: void 0,
        startMoving: void 0
    }), c.startX = h, c.startY = _, a.touchStartTime = (0, $9bf922a49190330a$export$461939dd4422153)(), n.allowClick = !0, n.updateSize(), n.swipeDirection = void 0, o.threshold > 0 && (a.allowThresholdMove = !1);
    let v = !0;
    u.matches(a.focusableElements) && (v = !1, u.nodeName === "SELECT" && (a.isTouched = !1)), r.activeElement && r.activeElement.matches(a.focusableElements) && r.activeElement !== u && (i.pointerType === "mouse" || i.pointerType !== "mouse" && !u.matches(a.focusableElements)) && r.activeElement.blur();
    let y = v && n.allowTouchMove && o.touchStartPreventDefault;
    (o.touchStartForcePreventDefault || y) && !u.isContentEditable && i.preventDefault(), o.freeMode && o.freeMode.enabled && n.freeMode && n.animating && !o.cssMode && n.freeMode.onTouchStart(), n.emit("touchStart", i);
}
function $6130630b8727286b$var$Ae(t) {
    let n = (0, $dab322d733560357$export$f65ca476c09acec0)(), r = this, i = r.touchEventsData, { params: a, touches: o, rtlTranslate: s, enabled: c } = r;
    if (!c || !a.simulateTouch && t.pointerType === "mouse") return;
    let l = t;
    if (l.originalEvent && (l = l.originalEvent), l.type === "pointermove" && (i.touchId !== null || l.pointerId !== i.pointerId)) return;
    let u;
    if (l.type === "touchmove") {
        if (u = [
            ...l.changedTouches
        ].find((e)=>e.identifier === i.touchId), !u || u.identifier !== i.touchId) return;
    } else u = l;
    if (!i.isTouched) {
        i.startMoving && i.isScrolling && r.emit("touchMoveOpposite", l);
        return;
    }
    let d = u.pageX, f = u.pageY;
    if (l.preventedByNestedSwiper) {
        o.startX = d, o.startY = f;
        return;
    }
    if (!r.allowTouchMove) {
        l.target.matches(i.focusableElements) || (r.allowClick = !1), i.isTouched && (Object.assign(o, {
            startX: d,
            startY: f,
            currentX: d,
            currentY: f
        }), i.touchStartTime = (0, $9bf922a49190330a$export$461939dd4422153)());
        return;
    }
    if (a.touchReleaseOnEdges && !a.loop) {
        if (r.isVertical()) {
            if (f < o.startY && r.translate <= r.maxTranslate() || f > o.startY && r.translate >= r.minTranslate()) {
                i.isTouched = !1, i.isMoved = !1;
                return;
            }
        } else if (s && (d > o.startX && -r.translate <= r.maxTranslate() || d < o.startX && -r.translate >= r.minTranslate())) return;
        else if (!s && (d < o.startX && r.translate <= r.maxTranslate() || d > o.startX && r.translate >= r.minTranslate())) return;
    }
    if (n.activeElement && n.activeElement.matches(i.focusableElements) && n.activeElement !== l.target && l.pointerType !== "mouse" && n.activeElement.blur(), n.activeElement && l.target === n.activeElement && l.target.matches(i.focusableElements)) {
        i.isMoved = !0, r.allowClick = !1;
        return;
    }
    i.allowTouchCallbacks && r.emit("touchMove", l), o.previousX = o.currentX, o.previousY = o.currentY, o.currentX = d, o.currentY = f;
    let p = o.currentX - o.startX, m = o.currentY - o.startY;
    if (r.params.threshold && Math.sqrt(p ** 2 + m ** 2) < r.params.threshold) return;
    if (i.isScrolling === void 0) {
        let e;
        r.isHorizontal() && o.currentY === o.startY || r.isVertical() && o.currentX === o.startX ? i.isScrolling = !1 : p * p + m * m >= 25 && (e = Math.atan2(Math.abs(m), Math.abs(p)) * 180 / Math.PI, i.isScrolling = r.isHorizontal() ? e > a.touchAngle : 90 - e > a.touchAngle);
    }
    if (i.isScrolling && r.emit("touchMoveOpposite", l), i.startMoving === void 0 && (o.currentX !== o.startX || o.currentY !== o.startY) && (i.startMoving = !0), i.isScrolling || l.type === "touchmove" && i.preventTouchMoveFromPointerMove) {
        i.isTouched = !1;
        return;
    }
    if (!i.startMoving) return;
    r.allowClick = !1, !a.cssMode && l.cancelable && l.preventDefault(), a.touchMoveStopPropagation && !a.nested && l.stopPropagation();
    let h = r.isHorizontal() ? p : m, _ = r.isHorizontal() ? o.currentX - o.previousX : o.currentY - o.previousY;
    a.oneWayMovement && (h = Math.abs(h) * (s ? 1 : -1), _ = Math.abs(_) * (s ? 1 : -1)), o.diff = h, h *= a.touchRatio, s && (h = -h, _ = -_);
    let v = r.touchesDirection;
    r.swipeDirection = h > 0 ? "prev" : "next", r.touchesDirection = _ > 0 ? "prev" : "next";
    let y = r.params.loop && !a.cssMode, b = r.touchesDirection === "next" && r.allowSlideNext || r.touchesDirection === "prev" && r.allowSlidePrev;
    if (!i.isMoved) {
        if (y && b && r.loopFix({
            direction: r.swipeDirection
        }), i.startTranslate = r.getTranslate(), r.setTransition(0), r.animating) {
            let e = new window.CustomEvent("transitionend", {
                bubbles: !0,
                cancelable: !0,
                detail: {
                    bySwiperTouchMove: !0
                }
            });
            r.wrapperEl.dispatchEvent(e);
        }
        i.allowMomentumBounce = !1, a.grabCursor && (r.allowSlideNext === !0 || r.allowSlidePrev === !0) && r.setGrabCursor(!0), r.emit("sliderFirstMove", l);
    }
    if (/* @__PURE__ */ new Date().getTime(), a._loopSwapReset !== !1 && i.isMoved && i.allowThresholdMove && v !== r.touchesDirection && y && b && Math.abs(h) >= 1) {
        Object.assign(o, {
            startX: d,
            startY: f,
            currentX: d,
            currentY: f,
            startTranslate: i.currentTranslate
        }), i.loopSwapReset = !0, i.startTranslate = i.currentTranslate;
        return;
    }
    r.emit("sliderMove", l), i.isMoved = !0, i.currentTranslate = h + i.startTranslate;
    let x = !0, S = a.resistanceRatio;
    if (a.touchReleaseOnEdges && (S = 0), h > 0 ? (y && b && i.allowThresholdMove && i.currentTranslate > (a.centeredSlides ? r.minTranslate() - r.slidesSizesGrid[r.activeIndex + 1] - (a.slidesPerView !== "auto" && r.slides.length - a.slidesPerView >= 2 ? r.slidesSizesGrid[r.activeIndex + 1] + r.params.spaceBetween : 0) - r.params.spaceBetween : r.minTranslate()) && r.loopFix({
        direction: "prev",
        setTranslate: !0,
        activeSlideIndex: 0
    }), i.currentTranslate > r.minTranslate() && (x = !1, a.resistance && (i.currentTranslate = r.minTranslate() - 1 + (-r.minTranslate() + i.startTranslate + h) ** S))) : h < 0 && (y && b && i.allowThresholdMove && i.currentTranslate < (a.centeredSlides ? r.maxTranslate() + r.slidesSizesGrid[r.slidesSizesGrid.length - 1] + r.params.spaceBetween + (a.slidesPerView !== "auto" && r.slides.length - a.slidesPerView >= 2 ? r.slidesSizesGrid[r.slidesSizesGrid.length - 1] + r.params.spaceBetween : 0) : r.maxTranslate()) && r.loopFix({
        direction: "next",
        setTranslate: !0,
        activeSlideIndex: r.slides.length - (a.slidesPerView === "auto" ? r.slidesPerViewDynamic() : Math.ceil(parseFloat(a.slidesPerView, 10)))
    }), i.currentTranslate < r.maxTranslate() && (x = !1, a.resistance && (i.currentTranslate = r.maxTranslate() + 1 - (r.maxTranslate() - i.startTranslate - h) ** S))), x && (l.preventedByNestedSwiper = !0), !r.allowSlideNext && r.swipeDirection === "next" && i.currentTranslate < i.startTranslate && (i.currentTranslate = i.startTranslate), !r.allowSlidePrev && r.swipeDirection === "prev" && i.currentTranslate > i.startTranslate && (i.currentTranslate = i.startTranslate), !r.allowSlidePrev && !r.allowSlideNext && (i.currentTranslate = i.startTranslate), a.threshold > 0) {
        if (Math.abs(h) > a.threshold || i.allowThresholdMove) {
            if (!i.allowThresholdMove) {
                i.allowThresholdMove = !0, o.startX = o.currentX, o.startY = o.currentY, i.currentTranslate = i.startTranslate, o.diff = r.isHorizontal() ? o.currentX - o.startX : o.currentY - o.startY;
                return;
            }
        } else {
            i.currentTranslate = i.startTranslate;
            return;
        }
    }
    !a.followFinger || a.cssMode || ((a.freeMode && a.freeMode.enabled && r.freeMode || a.watchSlidesProgress) && (r.updateActiveIndex(), r.updateSlidesClasses()), a.freeMode && a.freeMode.enabled && r.freeMode && r.freeMode.onTouchMove(), r.updateProgress(i.currentTranslate), r.setTranslate(i.currentTranslate));
}
function $6130630b8727286b$var$je(e) {
    let t = this, n = t.touchEventsData, r = e;
    r.originalEvent && (r = r.originalEvent);
    let i;
    if (!(r.type === "touchend" || r.type === "touchcancel")) {
        if (n.touchId !== null || r.pointerId !== n.pointerId) return;
        i = r;
    } else if (i = [
        ...r.changedTouches
    ].find((e)=>e.identifier === n.touchId), !i || i.identifier !== n.touchId) return;
    if ([
        "pointercancel",
        "pointerout",
        "pointerleave",
        "contextmenu"
    ].includes(r.type) && !([
        "pointercancel",
        "contextmenu"
    ].includes(r.type) && (t.browser.isSafari || t.browser.isWebView))) return;
    n.pointerId = null, n.touchId = null;
    let { params: a, touches: o, rtlTranslate: s, slidesGrid: c, enabled: l } = t;
    if (!l || !a.simulateTouch && r.pointerType === "mouse") return;
    if (n.allowTouchCallbacks && t.emit("touchEnd", r), n.allowTouchCallbacks = !1, !n.isTouched) {
        n.isMoved && a.grabCursor && t.setGrabCursor(!1), n.isMoved = !1, n.startMoving = !1;
        return;
    }
    a.grabCursor && n.isMoved && n.isTouched && (t.allowSlideNext === !0 || t.allowSlidePrev === !0) && t.setGrabCursor(!1);
    let u = (0, $9bf922a49190330a$export$461939dd4422153)(), d = u - n.touchStartTime;
    if (t.allowClick) {
        let e = r.path || r.composedPath && r.composedPath();
        t.updateClickedSlide(e && e[0] || r.target, e), t.emit("tap click", r), d < 300 && u - n.lastClickTime < 300 && t.emit("doubleTap doubleClick", r);
    }
    if (n.lastClickTime = (0, $9bf922a49190330a$export$461939dd4422153)(), (0, $9bf922a49190330a$export$bdd553fddd433dcb)(()=>{
        t.destroyed || (t.allowClick = !0);
    }), !n.isTouched || !n.isMoved || !t.swipeDirection || o.diff === 0 && !n.loopSwapReset || n.currentTranslate === n.startTranslate && !n.loopSwapReset) {
        n.isTouched = !1, n.isMoved = !1, n.startMoving = !1;
        return;
    }
    n.isTouched = !1, n.isMoved = !1, n.startMoving = !1;
    let f;
    if (f = a.followFinger ? s ? t.translate : -t.translate : -n.currentTranslate, a.cssMode) return;
    if (a.freeMode && a.freeMode.enabled) {
        t.freeMode.onTouchEnd({
            currentPos: f
        });
        return;
    }
    let p = f >= -t.maxTranslate() && !t.params.loop, m = 0, _ = t.slidesSizesGrid[0];
    for(let e = 0; e < c.length; e += e < a.slidesPerGroupSkip ? 1 : a.slidesPerGroup){
        let t = e < a.slidesPerGroupSkip - 1 ? 1 : a.slidesPerGroup;
        c[e + t] === void 0 ? (p || f >= c[e]) && (m = e, _ = c[c.length - 1] - c[c.length - 2]) : (p || f >= c[e] && f < c[e + t]) && (m = e, _ = c[e + t] - c[e]);
    }
    let v = null, y = null;
    a.rewind && (t.isBeginning ? y = a.virtual && a.virtual.enabled && t.virtual ? t.virtual.slides.length - 1 : t.slides.length - 1 : t.isEnd && (v = 0));
    let b = (f - c[m]) / _, x = m < a.slidesPerGroupSkip - 1 ? 1 : a.slidesPerGroup;
    if (d > a.longSwipesMs) {
        if (!a.longSwipes) {
            t.slideTo(t.activeIndex);
            return;
        }
        t.swipeDirection === "next" && (b >= a.longSwipesRatio ? t.slideTo(a.rewind && t.isEnd ? v : m + x) : t.slideTo(m)), t.swipeDirection === "prev" && (b > 1 - a.longSwipesRatio ? t.slideTo(m + x) : y !== null && b < 0 && Math.abs(b) > a.longSwipesRatio ? t.slideTo(y) : t.slideTo(m));
    } else {
        if (!a.shortSwipes) {
            t.slideTo(t.activeIndex);
            return;
        }
        t.navigation && (r.target === t.navigation.nextEl || r.target === t.navigation.prevEl) ? r.target === t.navigation.nextEl ? t.slideTo(m + x) : t.slideTo(m) : (t.swipeDirection === "next" && t.slideTo(v === null ? m + x : v), t.swipeDirection === "prev" && t.slideTo(y === null ? m : y));
    }
}
function $6130630b8727286b$var$K() {
    let e = this, { params: t, el: n } = e;
    if (n && n.offsetWidth === 0) return;
    t.breakpoints && e.setBreakpoint();
    let { allowSlideNext: r, allowSlidePrev: i, snapGrid: a } = e, o = e.virtual && e.params.virtual.enabled;
    e.allowSlideNext = !0, e.allowSlidePrev = !0, e.updateSize(), e.updateSlides(), e.updateSlidesClasses();
    let s = o && t.loop;
    if ((t.slidesPerView === "auto" || t.slidesPerView > 1) && e.isEnd && !e.isBeginning && !e.params.centeredSlides && !s) {
        let t = o ? e.virtual.slides : e.slides;
        e.slideTo(t.length - 1, 0, !1, !0);
    } else e.params.loop && !o ? e.slideToLoop(e.realIndex, 0, !1, !0) : e.slideTo(e.activeIndex, 0, !1, !0);
    e.autoplay && e.autoplay.running && e.autoplay.paused && (clearTimeout(e.autoplay.resizeTimeout), e.autoplay.resizeTimeout = setTimeout(()=>{
        e.autoplay && e.autoplay.running && e.autoplay.paused && e.autoplay.resume();
    }, 500)), e.allowSlidePrev = i, e.allowSlideNext = r, e.params.watchOverflow && a !== e.snapGrid && e.checkOverflow();
}
function $6130630b8727286b$var$Me(e) {
    let t = this;
    t.enabled && (t.allowClick || (t.params.preventClicks && e.preventDefault(), t.params.preventClicksPropagation && t.animating && (e.stopPropagation(), e.stopImmediatePropagation())));
}
function $6130630b8727286b$var$Ne() {
    let e = this, { wrapperEl: t, rtlTranslate: n, enabled: r } = e;
    if (!r) return;
    e.previousTranslate = e.translate, e.isHorizontal() ? e.translate = -t.scrollLeft : e.translate = -t.scrollTop, e.translate === 0 && (e.translate = 0), e.updateActiveIndex(), e.updateSlidesClasses();
    let i, a = e.maxTranslate() - e.minTranslate();
    i = a === 0 ? 0 : (e.translate - e.minTranslate()) / a, i !== e.progress && e.updateProgress(n ? -e.translate : e.translate), e.emit("setTranslate", e.translate, !1);
}
function $6130630b8727286b$var$Pe(e) {
    let t = this;
    $6130630b8727286b$var$L(t, e.target), !(t.params.cssMode || t.params.slidesPerView !== "auto" && !t.params.autoHeight) && t.update();
}
function $6130630b8727286b$var$Fe() {
    let e = this;
    e.documentTouchHandlerProceeded || (e.documentTouchHandlerProceeded = !0, e.params.touchReleaseOnEdges && (e.el.style.touchAction = "auto"));
}
var $6130630b8727286b$var$q = (t, n)=>{
    let r = (0, $dab322d733560357$export$f65ca476c09acec0)(), { params: i, el: a, wrapperEl: o, device: s } = t, c = !!i.nested, l = n === "on" ? "addEventListener" : "removeEventListener", u = n;
    !a || typeof a == "string" || (r[l]("touchstart", t.onDocumentTouchStart, {
        passive: !1,
        capture: c
    }), a[l]("touchstart", t.onTouchStart, {
        passive: !1
    }), a[l]("pointerdown", t.onTouchStart, {
        passive: !1
    }), r[l]("touchmove", t.onTouchMove, {
        passive: !1,
        capture: c
    }), r[l]("pointermove", t.onTouchMove, {
        passive: !1,
        capture: c
    }), r[l]("touchend", t.onTouchEnd, {
        passive: !0
    }), r[l]("pointerup", t.onTouchEnd, {
        passive: !0
    }), r[l]("pointercancel", t.onTouchEnd, {
        passive: !0
    }), r[l]("touchcancel", t.onTouchEnd, {
        passive: !0
    }), r[l]("pointerout", t.onTouchEnd, {
        passive: !0
    }), r[l]("pointerleave", t.onTouchEnd, {
        passive: !0
    }), r[l]("contextmenu", t.onTouchEnd, {
        passive: !0
    }), (i.preventClicks || i.preventClicksPropagation) && a[l]("click", t.onClick, !0), i.cssMode && o[l]("scroll", t.onScroll), i.updateOnWindowResize ? t[u](s.ios || s.android ? "resize orientationchange observerUpdate" : "resize observerUpdate", $6130630b8727286b$var$K, !0) : t[u]("observerUpdate", $6130630b8727286b$var$K, !0), a[l]("load", t.onLoad, {
        capture: !0
    }));
};
function $6130630b8727286b$var$Ie() {
    let e = this, { params: t } = e;
    e.onTouchStart = $6130630b8727286b$var$ke.bind(e), e.onTouchMove = $6130630b8727286b$var$Ae.bind(e), e.onTouchEnd = $6130630b8727286b$var$je.bind(e), e.onDocumentTouchStart = $6130630b8727286b$var$Fe.bind(e), t.cssMode && (e.onScroll = $6130630b8727286b$var$Ne.bind(e)), e.onClick = $6130630b8727286b$var$Me.bind(e), e.onLoad = $6130630b8727286b$var$Pe.bind(e), $6130630b8727286b$var$q(e, "on");
}
function $6130630b8727286b$var$Le() {
    $6130630b8727286b$var$q(this, "off");
}
var $6130630b8727286b$var$Re = {
    attachEvents: $6130630b8727286b$var$Ie,
    detachEvents: $6130630b8727286b$var$Le
}, $6130630b8727286b$var$J = (e, t)=>e.grid && t.grid && t.grid.rows > 1;
function $6130630b8727286b$var$Y() {
    let t = this, { realIndex: n, initialized: r, params: i, el: a } = t, o = i.breakpoints;
    if (!o || o && Object.keys(o).length === 0) return;
    let s = (0, $dab322d733560357$export$f65ca476c09acec0)(), c = i.breakpointsBase === "window" || !i.breakpointsBase ? i.breakpointsBase : "container", l = [
        "window",
        "container"
    ].includes(i.breakpointsBase) || !i.breakpointsBase ? t.el : s.querySelector(i.breakpointsBase), u = t.getBreakpoint(o, c, l);
    if (!u || t.currentBreakpoint === u) return;
    let d = (u in o ? o[u] : void 0) || t.originalParams, f = $6130630b8727286b$var$J(t, i), m = $6130630b8727286b$var$J(t, d), h = t.params.grabCursor, g = d.grabCursor, _ = i.enabled;
    f && !m ? (a.classList.remove(`${i.containerModifierClass}grid`, `${i.containerModifierClass}grid-column`), t.emitContainerClasses()) : !f && m && (a.classList.add(`${i.containerModifierClass}grid`), (d.grid.fill && d.grid.fill === "column" || !d.grid.fill && i.grid.fill === "column") && a.classList.add(`${i.containerModifierClass}grid-column`), t.emitContainerClasses()), h && !g ? t.unsetGrabCursor() : !h && g && t.setGrabCursor(), [
        "navigation",
        "pagination",
        "scrollbar"
    ].forEach((e)=>{
        if (d[e] === void 0) return;
        let n = i[e] && i[e].enabled, r = d[e] && d[e].enabled;
        n && !r && t[e].disable(), !n && r && t[e].enable();
    });
    let v = d.direction && d.direction !== i.direction, y = i.loop && (d.slidesPerView !== i.slidesPerView || v), b = i.loop;
    v && r && t.changeDirection(), (0, $9bf922a49190330a$export$8b58be045bf06082)(t.params, d);
    let x = t.params.enabled, S = t.params.loop;
    Object.assign(t, {
        allowTouchMove: t.params.allowTouchMove,
        allowSlideNext: t.params.allowSlideNext,
        allowSlidePrev: t.params.allowSlidePrev
    }), _ && !x ? t.disable() : !_ && x && t.enable(), t.currentBreakpoint = u, t.emit("_beforeBreakpoint", d), r && (y ? (t.loopDestroy(), t.loopCreate(n), t.updateSlides()) : !b && S ? (t.loopCreate(n), t.updateSlides()) : b && !S && t.loopDestroy()), t.emit("breakpoint", d);
}
function $6130630b8727286b$var$ze(e, n = "window", r) {
    if (!e || n === "container" && !r) return;
    let i = !1, a = (0, $dab322d733560357$export$38b2d434cce3ea22)(), o = n === "window" ? a.innerHeight : r.clientHeight, s = Object.keys(e).map((e)=>typeof e == "string" && e.indexOf("@") === 0 ? {
            value: o * parseFloat(e.substr(1)),
            point: e
        } : {
            value: e,
            point: e
        });
    s.sort((e, t)=>parseInt(e.value, 10) - parseInt(t.value, 10));
    for(let e = 0; e < s.length; e += 1){
        let { point: t, value: o } = s[e];
        n === "window" ? a.matchMedia(`(min-width: ${o}px)`).matches && (i = t) : o <= r.clientWidth && (i = t);
    }
    return i || "max";
}
var $6130630b8727286b$var$Be = {
    setBreakpoint: $6130630b8727286b$var$Y,
    getBreakpoint: $6130630b8727286b$var$ze
};
function $6130630b8727286b$var$Ve(e, t) {
    let n = [];
    return e.forEach((e)=>{
        typeof e == "object" ? Object.keys(e).forEach((r)=>{
            e[r] && n.push(t + r);
        }) : typeof e == "string" && n.push(t + e);
    }), n;
}
function $6130630b8727286b$var$He() {
    let e = this, { classNames: t, params: n, rtl: r, el: i, device: a } = e, o = $6130630b8727286b$var$Ve([
        "initialized",
        n.direction,
        {
            "free-mode": e.params.freeMode && n.freeMode.enabled
        },
        {
            autoheight: n.autoHeight
        },
        {
            rtl: r
        },
        {
            grid: n.grid && n.grid.rows > 1
        },
        {
            "grid-column": n.grid && n.grid.rows > 1 && n.grid.fill === "column"
        },
        {
            android: a.android
        },
        {
            ios: a.ios
        },
        {
            "css-mode": n.cssMode
        },
        {
            centered: n.cssMode && n.centeredSlides
        },
        {
            "watch-progress": n.watchSlidesProgress
        }
    ], n.containerModifierClass);
    t.push(...o), i.classList.add(...t), e.emitContainerClasses();
}
function $6130630b8727286b$var$Ue() {
    let e = this, { el: t, classNames: n } = e;
    !t || typeof t == "string" || (t.classList.remove(...n), e.emitContainerClasses());
}
var $6130630b8727286b$var$We = {
    addClasses: $6130630b8727286b$var$He,
    removeClasses: $6130630b8727286b$var$Ue
};
function $6130630b8727286b$var$Ge() {
    let e = this, { isLocked: t, params: n } = e, { slidesOffsetBefore: r } = n;
    if (r) {
        let t = e.slides.length - 1, n = e.slidesGrid[t] + e.slidesSizesGrid[t] + r * 2;
        e.isLocked = e.size > n;
    } else e.isLocked = e.snapGrid.length === 1;
    n.allowSlideNext === !0 && (e.allowSlideNext = !e.isLocked), n.allowSlidePrev === !0 && (e.allowSlidePrev = !e.isLocked), t && t !== e.isLocked && (e.isEnd = !1), t !== e.isLocked && e.emit(e.isLocked ? "lock" : "unlock");
}
var $6130630b8727286b$var$Ke = {
    checkOverflow: $6130630b8727286b$var$Ge
}, $6130630b8727286b$export$ebe90cb607ad99e = {
    init: !0,
    direction: "horizontal",
    oneWayMovement: !1,
    swiperElementNodeName: "SWIPER-CONTAINER",
    touchEventsTarget: "wrapper",
    initialSlide: 0,
    speed: 300,
    cssMode: !1,
    updateOnWindowResize: !0,
    resizeObserver: !0,
    nested: !1,
    createElements: !1,
    eventsPrefix: "swiper",
    enabled: !0,
    focusableElements: "input, select, option, textarea, button, video, label",
    width: null,
    height: null,
    preventInteractionOnTransition: !1,
    userAgent: null,
    url: null,
    edgeSwipeDetection: !1,
    edgeSwipeThreshold: 20,
    autoHeight: !1,
    setWrapperSize: !1,
    virtualTranslate: !1,
    effect: "slide",
    breakpoints: void 0,
    breakpointsBase: "window",
    spaceBetween: 0,
    slidesPerView: 1,
    slidesPerGroup: 1,
    slidesPerGroupSkip: 0,
    slidesPerGroupAuto: !1,
    centeredSlides: !1,
    centeredSlidesBounds: !1,
    slidesOffsetBefore: 0,
    slidesOffsetAfter: 0,
    normalizeSlideIndex: !0,
    centerInsufficientSlides: !1,
    snapToSlideEdge: !1,
    watchOverflow: !0,
    roundLengths: !1,
    touchRatio: 1,
    touchAngle: 45,
    simulateTouch: !0,
    shortSwipes: !0,
    longSwipes: !0,
    longSwipesRatio: .5,
    longSwipesMs: 300,
    followFinger: !0,
    allowTouchMove: !0,
    threshold: 5,
    touchMoveStopPropagation: !1,
    touchStartPreventDefault: !0,
    touchStartForcePreventDefault: !1,
    touchReleaseOnEdges: !1,
    uniqueNavElements: !0,
    resistance: !0,
    resistanceRatio: .85,
    watchSlidesProgress: !1,
    grabCursor: !1,
    preventClicks: !0,
    preventClicksPropagation: !0,
    slideToClickedSlide: !1,
    loop: !1,
    loopAddBlankSlides: !0,
    loopAdditionalSlides: 0,
    loopPreventsSliding: !0,
    rewind: !1,
    allowSlidePrev: !0,
    allowSlideNext: !0,
    swipeHandler: null,
    noSwiping: !0,
    noSwipingClass: "swiper-no-swiping",
    noSwipingSelector: null,
    passiveListeners: !0,
    maxBackfaceHiddenSlides: 10,
    containerModifierClass: "swiper-",
    slideClass: "swiper-slide",
    slideBlankClass: "swiper-slide-blank",
    slideActiveClass: "swiper-slide-active",
    slideVisibleClass: "swiper-slide-visible",
    slideFullyVisibleClass: "swiper-slide-fully-visible",
    slideNextClass: "swiper-slide-next",
    slidePrevClass: "swiper-slide-prev",
    wrapperClass: "swiper-wrapper",
    lazyPreloaderClass: "swiper-lazy-preloader",
    lazyPreloadPrevNext: 0,
    runCallbacksOnInit: !0,
    _emitClasses: !1
};
function $6130630b8727286b$var$qe(e, t) {
    return function(n = {}) {
        let r = Object.keys(n)[0], i = n[r];
        if (typeof i != "object" || !i) {
            (0, $9bf922a49190330a$export$8b58be045bf06082)(t, n);
            return;
        }
        if (e[r] === !0 && (e[r] = {
            enabled: !0
        }), r === "navigation" && e[r] && e[r].enabled && !e[r].prevEl && !e[r].nextEl && (e[r].auto = !0), [
            "pagination",
            "scrollbar"
        ].indexOf(r) >= 0 && e[r] && e[r].enabled && !e[r].el && (e[r].auto = !0), !(r in e && "enabled" in i)) {
            (0, $9bf922a49190330a$export$8b58be045bf06082)(t, n);
            return;
        }
        typeof e[r] == "object" && !("enabled" in e[r]) && (e[r].enabled = !0), e[r] || (e[r] = {
            enabled: !1
        }), (0, $9bf922a49190330a$export$8b58be045bf06082)(t, n);
    };
}
var $6130630b8727286b$var$Z = {
    eventsEmitter: $6130630b8727286b$var$A,
    update: $6130630b8727286b$var$oe,
    translate: $6130630b8727286b$var$H,
    transition: $6130630b8727286b$var$fe,
    slide: $6130630b8727286b$var$be,
    loop: $6130630b8727286b$var$we,
    grabCursor: $6130630b8727286b$var$De,
    events: $6130630b8727286b$var$Re,
    breakpoints: $6130630b8727286b$var$Be,
    checkOverflow: $6130630b8727286b$var$Ke,
    classes: $6130630b8727286b$var$We
}, $6130630b8727286b$var$Q = {}, $6130630b8727286b$export$6b3850921bc5a414 = class t {
    constructor(...n){
        let r, i;
        n.length === 1 && n[0].constructor && Object.prototype.toString.call(n[0]).slice(8, -1) === "Object" ? i = n[0] : [r, i] = n, i ||= {}, i = (0, $9bf922a49190330a$export$8b58be045bf06082)({}, i), r && !i.el && (i.el = r);
        let a = (0, $dab322d733560357$export$f65ca476c09acec0)();
        if (i.el && typeof i.el == "string" && a.querySelectorAll(i.el).length > 1) {
            let e = [];
            return a.querySelectorAll(i.el).forEach((n)=>{
                let r = (0, $9bf922a49190330a$export$8b58be045bf06082)({}, i, {
                    el: n
                });
                e.push(new t(r));
            }), e;
        }
        let o = this;
        o.__swiper__ = !0, o.support = $6130630b8727286b$var$x(), o.device = $6130630b8727286b$var$w({
            userAgent: i.userAgent
        }), o.browser = $6130630b8727286b$var$D(), o.eventsListeners = {}, o.eventsAnyListeners = [], o.modules = [
            ...o.__modules__
        ], i.modules && Array.isArray(i.modules) && i.modules.forEach((e)=>{
            typeof e == "function" && o.modules.indexOf(e) < 0 && o.modules.push(e);
        });
        let s = {};
        return o.modules.forEach((e)=>{
            e({
                params: i,
                swiper: o,
                extendParams: $6130630b8727286b$var$qe(i, s),
                on: o.on.bind(o),
                once: o.once.bind(o),
                off: o.off.bind(o),
                emit: o.emit.bind(o)
            });
        }), o.params = (0, $9bf922a49190330a$export$8b58be045bf06082)({}, (0, $9bf922a49190330a$export$8b58be045bf06082)({}, $6130630b8727286b$export$ebe90cb607ad99e, s), $6130630b8727286b$var$Q, i), o.originalParams = (0, $9bf922a49190330a$export$8b58be045bf06082)({}, o.params), o.passedParams = (0, $9bf922a49190330a$export$8b58be045bf06082)({}, i), o.params && o.params.on && Object.keys(o.params.on).forEach((e)=>{
            o.on(e, o.params.on[e]);
        }), o.params && o.params.onAny && o.onAny(o.params.onAny), Object.assign(o, {
            enabled: o.params.enabled,
            el: r,
            classNames: [],
            slides: [],
            slidesGrid: [],
            snapGrid: [],
            slidesSizesGrid: [],
            isHorizontal () {
                return o.params.direction === "horizontal";
            },
            isVertical () {
                return o.params.direction === "vertical";
            },
            activeIndex: 0,
            realIndex: 0,
            isBeginning: !0,
            isEnd: !1,
            translate: 0,
            previousTranslate: 0,
            progress: 0,
            velocity: 0,
            animating: !1,
            cssOverflowAdjustment () {
                return Math.trunc(this.translate / 2 ** 23) * 2 ** 23;
            },
            allowSlideNext: o.params.allowSlideNext,
            allowSlidePrev: o.params.allowSlidePrev,
            touchEventsData: {
                isTouched: void 0,
                isMoved: void 0,
                allowTouchCallbacks: void 0,
                touchStartTime: void 0,
                isScrolling: void 0,
                currentTranslate: void 0,
                startTranslate: void 0,
                allowThresholdMove: void 0,
                focusableElements: o.params.focusableElements,
                lastClickTime: 0,
                clickTimeout: void 0,
                velocities: [],
                allowMomentumBounce: void 0,
                startMoving: void 0,
                pointerId: null,
                touchId: null
            },
            allowClick: !0,
            allowTouchMove: o.params.allowTouchMove,
            touches: {
                startX: 0,
                startY: 0,
                currentX: 0,
                currentY: 0,
                diff: 0
            },
            imagesToLoad: [],
            imagesLoaded: 0
        }), o.emit("_swiper"), o.params.init && o.init(), o;
    }
    getDirectionLabel(e) {
        return this.isHorizontal() ? e : ({
            width: "height",
            "margin-top": "margin-left",
            "margin-bottom ": "margin-right",
            "margin-left": "margin-top",
            "margin-right": "margin-bottom",
            "padding-left": "padding-top",
            "padding-right": "padding-bottom",
            marginRight: "marginBottom"
        })[e];
    }
    getSlideIndex(e) {
        let { slidesEl: t, params: n } = this, r = (0, $9bf922a49190330a$export$371885c503a01623)((0, $9bf922a49190330a$export$eb846d859f2895e6)(t, `.${n.slideClass}, swiper-slide`)[0]);
        return (0, $9bf922a49190330a$export$371885c503a01623)(e) - r;
    }
    getSlideIndexByData(e) {
        return this.getSlideIndex(this.slides.find((t)=>t.getAttribute("data-swiper-slide-index") * 1 === e));
    }
    getSlideIndexWhenGrid(e) {
        return this.grid && this.params.grid && this.params.grid.rows > 1 && (this.params.grid.fill === "column" ? e = Math.floor(e / this.params.grid.rows) : this.params.grid.fill === "row" && (e %= Math.ceil(this.slides.length / this.params.grid.rows))), e;
    }
    recalcSlides() {
        let e = this, { slidesEl: t, params: n } = e;
        e.slides = (0, $9bf922a49190330a$export$eb846d859f2895e6)(t, `.${n.slideClass}, swiper-slide`);
    }
    enable() {
        let e = this;
        e.enabled || (e.enabled = !0, e.params.grabCursor && e.setGrabCursor(), e.emit("enable"));
    }
    disable() {
        let e = this;
        e.enabled && (e.enabled = !1, e.params.grabCursor && e.unsetGrabCursor(), e.emit("disable"));
    }
    setProgress(e, t) {
        let n = this;
        e = Math.min(Math.max(e, 0), 1);
        let r = n.minTranslate(), i = (n.maxTranslate() - r) * e + r;
        n.translateTo(i, t === void 0 ? 0 : t), n.updateActiveIndex(), n.updateSlidesClasses();
    }
    emitContainerClasses() {
        let e = this;
        if (!e.params._emitClasses || !e.el) return;
        let t = e.el.className.split(" ").filter((t)=>t.indexOf("swiper") === 0 || t.indexOf(e.params.containerModifierClass) === 0);
        e.emit("_containerClasses", t.join(" "));
    }
    getSlideClasses(e) {
        let t = this;
        return t.destroyed ? "" : e.className.split(" ").filter((e)=>e.indexOf("swiper-slide") === 0 || e.indexOf(t.params.slideClass) === 0).join(" ");
    }
    emitSlidesClasses() {
        let e = this;
        if (!e.params._emitClasses || !e.el) return;
        let t = [];
        e.slides.forEach((n)=>{
            let r = e.getSlideClasses(n);
            t.push({
                slideEl: n,
                classNames: r
            }), e.emit("_slideClass", n, r);
        }), e.emit("_slideClasses", t);
    }
    slidesPerViewDynamic(e = "current", t = !1) {
        let { params: n, slides: r, slidesGrid: i, slidesSizesGrid: a, size: o, activeIndex: s } = this, c = 1;
        if (typeof n.slidesPerView == "number") return n.slidesPerView;
        if (n.centeredSlides) {
            let e = r[s] ? Math.ceil(r[s].swiperSlideSize) : 0, t;
            for(let n = s + 1; n < r.length; n += 1)r[n] && !t && (e += Math.ceil(r[n].swiperSlideSize), c += 1, e > o && (t = !0));
            for(let n = s - 1; n >= 0; --n)r[n] && !t && (e += r[n].swiperSlideSize, c += 1, e > o && (t = !0));
        } else if (e === "current") for(let e = s + 1; e < r.length; e += 1)(t ? i[e] + a[e] - i[s] < o : i[e] - i[s] < o) && (c += 1);
        else for(let e = s - 1; e >= 0; --e)i[s] - i[e] < o && (c += 1);
        return c;
    }
    update() {
        let e = this;
        if (!e || e.destroyed) return;
        let { snapGrid: t, params: n } = e;
        n.breakpoints && e.setBreakpoint(), [
            ...e.el.querySelectorAll("[loading=\"lazy\"]")
        ].forEach((t)=>{
            t.complete && $6130630b8727286b$var$L(e, t);
        }), e.updateSize(), e.updateSlides(), e.updateProgress(), e.updateSlidesClasses();
        function r() {
            let t = e.rtlTranslate ? e.translate * -1 : e.translate, n = Math.min(Math.max(t, e.maxTranslate()), e.minTranslate());
            e.setTranslate(n), e.updateActiveIndex(), e.updateSlidesClasses();
        }
        let i;
        if (n.freeMode && n.freeMode.enabled && !n.cssMode) r(), n.autoHeight && e.updateAutoHeight();
        else {
            if ((n.slidesPerView === "auto" || n.slidesPerView > 1) && e.isEnd && !n.centeredSlides) {
                let t = e.virtual && n.virtual.enabled ? e.virtual.slides : e.slides;
                i = e.slideTo(t.length - 1, 0, !1, !0);
            } else i = e.slideTo(e.activeIndex, 0, !1, !0);
            i || r();
        }
        n.watchOverflow && t !== e.snapGrid && e.checkOverflow(), e.emit("update");
    }
    changeDirection(e, t = !0) {
        let n = this, r = n.params.direction;
        return e ||= r === "horizontal" ? "vertical" : "horizontal", e === r || e !== "horizontal" && e !== "vertical" ? n : (n.el.classList.remove(`${n.params.containerModifierClass}${r}`), n.el.classList.add(`${n.params.containerModifierClass}${e}`), n.emitContainerClasses(), n.params.direction = e, n.slides.forEach((t)=>{
            e === "vertical" ? t.style.width = "" : t.style.height = "";
        }), n.emit("changeDirection"), t && n.update(), n);
    }
    changeLanguageDirection(e) {
        let t = this;
        t.rtl && e === "rtl" || !t.rtl && e === "ltr" || (t.rtl = e === "rtl", t.rtlTranslate = t.params.direction === "horizontal" && t.rtl, t.rtl ? (t.el.classList.add(`${t.params.containerModifierClass}rtl`), t.el.dir = "rtl") : (t.el.classList.remove(`${t.params.containerModifierClass}rtl`), t.el.dir = "ltr"), t.update());
    }
    mount(e) {
        let t = this;
        if (t.mounted) return !0;
        let n = e || t.params.el;
        if (typeof n == "string" && (n = document.querySelector(n)), !n) return !1;
        n.swiper = t, n.parentNode && n.parentNode.host && n.parentNode.host.nodeName === t.params.swiperElementNodeName.toUpperCase() && (t.isElement = !0);
        let i = ()=>`.${(t.params.wrapperClass || "").trim().split(" ").join(".")}`, o = n && n.shadowRoot && n.shadowRoot.querySelector ? n.shadowRoot.querySelector(i()) : (0, $9bf922a49190330a$export$eb846d859f2895e6)(n, i())[0];
        return !o && t.params.createElements && (o = (0, $9bf922a49190330a$export$c8a8987d4410bf2d)("div", t.params.wrapperClass), n.append(o), (0, $9bf922a49190330a$export$eb846d859f2895e6)(n, `.${t.params.slideClass}`).forEach((e)=>{
            o.append(e);
        })), Object.assign(t, {
            el: n,
            wrapperEl: o,
            slidesEl: t.isElement && !n.parentNode.host.slideSlots ? n.parentNode.host : o,
            hostEl: t.isElement ? n.parentNode.host : n,
            mounted: !0,
            rtl: n.dir.toLowerCase() === "rtl" || (0, $9bf922a49190330a$export$4184470d4bd0f986)(n, "direction") === "rtl",
            rtlTranslate: t.params.direction === "horizontal" && (n.dir.toLowerCase() === "rtl" || (0, $9bf922a49190330a$export$4184470d4bd0f986)(n, "direction") === "rtl"),
            wrongRTL: (0, $9bf922a49190330a$export$4184470d4bd0f986)(o, "display") === "-webkit-box"
        }), !0;
    }
    init(e) {
        let t = this;
        if (t.initialized || t.mount(e) === !1) return t;
        t.emit("beforeInit"), t.params.breakpoints && t.setBreakpoint(), t.addClasses(), t.updateSize(), t.updateSlides(), t.params.watchOverflow && t.checkOverflow(), t.params.grabCursor && t.enabled && t.setGrabCursor(), t.params.loop && t.virtual && t.params.virtual.enabled ? t.slideTo(t.params.initialSlide + t.virtual.slidesBefore, 0, t.params.runCallbacksOnInit, !1, !0) : t.slideTo(t.params.initialSlide, 0, t.params.runCallbacksOnInit, !1, !0), t.params.loop && t.loopCreate(void 0, !0), t.attachEvents();
        let n = [
            ...t.el.querySelectorAll("[loading=\"lazy\"]")
        ];
        return t.isElement && n.push(...t.hostEl.querySelectorAll("[loading=\"lazy\"]")), n.forEach((e)=>{
            e.complete ? $6130630b8727286b$var$L(t, e) : e.addEventListener("load", (e)=>{
                $6130630b8727286b$var$L(t, e.target);
            });
        }), $6130630b8727286b$var$z(t), t.initialized = !0, $6130630b8727286b$var$z(t), t.emit("init"), t.emit("afterInit"), t;
    }
    destroy(e = !0, t = !0) {
        let n = this, { params: r, el: a, wrapperEl: o, slides: s } = n;
        return n.params === void 0 || n.destroyed ? null : (n.emit("beforeDestroy"), n.initialized = !1, n.detachEvents(), r.loop && n.loopDestroy(), t && (n.removeClasses(), a && typeof a != "string" && a.removeAttribute("style"), o && o.removeAttribute("style"), s && s.length && s.forEach((e)=>{
            e.classList.remove(r.slideVisibleClass, r.slideFullyVisibleClass, r.slideActiveClass, r.slideNextClass, r.slidePrevClass), e.removeAttribute("style"), e.removeAttribute("data-swiper-slide-index");
        })), n.emit("destroy"), Object.keys(n.eventsListeners).forEach((e)=>{
            n.off(e);
        }), e !== !1 && (n.el && typeof n.el != "string" && (n.el.swiper = null), (0, $9bf922a49190330a$export$8694e5c03a4df8e6)(n)), n.destroyed = !0, null);
    }
    static extendDefaults(e) {
        (0, $9bf922a49190330a$export$8b58be045bf06082)($6130630b8727286b$var$Q, e);
    }
    static get extendedDefaults() {
        return $6130630b8727286b$var$Q;
    }
    static get defaults() {
        return $6130630b8727286b$export$ebe90cb607ad99e;
    }
    static installModule(e) {
        t.prototype.__modules__ || (t.prototype.__modules__ = []);
        let n = t.prototype.__modules__;
        typeof e == "function" && n.indexOf(e) < 0 && n.push(e);
    }
    static use(e) {
        return Array.isArray(e) ? (e.forEach((e)=>t.installModule(e)), t) : (t.installModule(e), t);
    }
};
Object.keys($6130630b8727286b$var$Z).forEach((e)=>{
    Object.keys($6130630b8727286b$var$Z[e]).forEach((t)=>{
        $6130630b8727286b$export$6b3850921bc5a414.prototype[t] = $6130630b8727286b$var$Z[e][t];
    });
}), $6130630b8727286b$export$6b3850921bc5a414.use([
    $6130630b8727286b$var$O,
    $6130630b8727286b$var$k
]);



//#region node_modules/swiper/shared/update-swiper.mjs
var $32a53a759126c58f$export$9e7786ca3b9bf18d = /* @__PURE__ */ "eventsPrefix.injectStyles.injectStylesUrls.modules.init._direction.oneWayMovement.swiperElementNodeName.touchEventsTarget.initialSlide._speed.cssMode.updateOnWindowResize.resizeObserver.nested.focusableElements._enabled._width._height.preventInteractionOnTransition.userAgent.url._edgeSwipeDetection._edgeSwipeThreshold._freeMode._autoHeight.setWrapperSize.virtualTranslate._effect.breakpoints.breakpointsBase._spaceBetween._slidesPerView.maxBackfaceHiddenSlides._grid._slidesPerGroup._slidesPerGroupSkip._slidesPerGroupAuto._centeredSlides._centeredSlidesBounds._slidesOffsetBefore._slidesOffsetAfter.normalizeSlideIndex._centerInsufficientSlides._snapToSlideEdge._watchOverflow.roundLengths.touchRatio.touchAngle.simulateTouch._shortSwipes._longSwipes.longSwipesRatio.longSwipesMs._followFinger.allowTouchMove._threshold.touchMoveStopPropagation.touchStartPreventDefault.touchStartForcePreventDefault.touchReleaseOnEdges.uniqueNavElements._resistance._resistanceRatio._watchSlidesProgress._grabCursor.preventClicks.preventClicksPropagation._slideToClickedSlide._loop.loopAdditionalSlides.loopAddBlankSlides.loopPreventsSliding._rewind._allowSlidePrev._allowSlideNext._swipeHandler._noSwiping.noSwipingClass.noSwipingSelector.passiveListeners.containerModifierClass.slideClass.slideActiveClass.slideVisibleClass.slideFullyVisibleClass.slideNextClass.slidePrevClass.slideBlankClass.wrapperClass.lazyPreloaderClass.lazyPreloadPrevNext.runCallbacksOnInit.observer.observeParents.observeSlideChildren.a11y._autoplay._controller.coverflowEffect.cubeEffect.fadeEffect.flipEffect.creativeEffect.cardsEffect.hashNavigation.history.keyboard.mousewheel._navigation._pagination.parallax._scrollbar._thumbs.virtual.zoom.control".split(".");
function $32a53a759126c58f$export$a6cdc56e425d0d0a(e) {
    return typeof e == "object" && !!e && e.constructor && Object.prototype.toString.call(e).slice(8, -1) === "Object" && !e.__swiper__;
}
function $32a53a759126c58f$export$8b58be045bf06082(e, t) {
    let i = [
        "__proto__",
        "constructor",
        "prototype"
    ];
    Object.keys(t).filter((e)=>i.indexOf(e) < 0).forEach((i)=>{
        e[i] === void 0 ? e[i] = t[i] : $32a53a759126c58f$export$a6cdc56e425d0d0a(t[i]) && $32a53a759126c58f$export$a6cdc56e425d0d0a(e[i]) && Object.keys(t[i]).length > 0 ? t[i].__swiper__ ? e[i] = t[i] : $32a53a759126c58f$export$8b58be045bf06082(e[i], t[i]) : e[i] = t[i];
    });
}
function $32a53a759126c58f$export$423ce9cad58a097b(e = {}) {
    return e.navigation && e.navigation.nextEl === void 0 && e.navigation.prevEl === void 0;
}
function $32a53a759126c58f$export$bcc3385f50c3c281(e = {}) {
    return e.pagination && e.pagination.el === void 0;
}
function $32a53a759126c58f$export$3f990fc5643c9587(e = {}) {
    return e.scrollbar && e.scrollbar.el === void 0;
}
function $32a53a759126c58f$export$fce1ceb9f96a0ccc(e = "") {
    let t = e.split(" ").map((e)=>e.trim()).filter((e)=>!!e), n = [];
    return t.forEach((e)=>{
        n.indexOf(e) < 0 && n.push(e);
    }), n.join(" ");
}
function $32a53a759126c58f$export$401fbb047013b330(e = "") {
    return e ? e.includes("swiper-wrapper") ? e : `swiper-wrapper ${e}` : "swiper-wrapper";
}
function $32a53a759126c58f$export$f69d13c24dc33989({ swiper: t, slides: r, passedParams: i, changedParams: a, nextEl: o, prevEl: s, scrollbarEl: c, paginationEl: l }) {
    let u = a.filter((e)=>e !== "children" && e !== "direction" && e !== "wrapperClass"), { params: d, pagination: f, navigation: p, scrollbar: m, virtual: h, thumbs: g } = t, _, v, y, b, x, S, C, w;
    a.includes("thumbs") && i.thumbs && i.thumbs.swiper && !i.thumbs.swiper.destroyed && d.thumbs && (!d.thumbs.swiper || d.thumbs.swiper.destroyed) && (_ = !0), a.includes("controller") && i.controller && i.controller.control && d.controller && !d.controller.control && (v = !0), a.includes("pagination") && i.pagination && (i.pagination.el || l) && (d.pagination || d.pagination === !1) && f && !f.el && (y = !0), a.includes("scrollbar") && i.scrollbar && (i.scrollbar.el || c) && (d.scrollbar || d.scrollbar === !1) && m && !m.el && (b = !0), a.includes("navigation") && i.navigation && (i.navigation.prevEl || s) && (i.navigation.nextEl || o) && (d.navigation || d.navigation === !1) && p && !p.prevEl && !p.nextEl && (x = !0);
    let T = (e)=>{
        t[e] && (t[e].destroy(), e === "navigation" ? (t.isElement && (t[e].prevEl.remove(), t[e].nextEl.remove()), d[e].prevEl = void 0, d[e].nextEl = void 0, t[e].prevEl = void 0, t[e].nextEl = void 0) : (t.isElement && t[e].el.remove(), d[e].el = void 0, t[e].el = void 0));
    };
    a.includes("loop") && t.isElement && (d.loop && !i.loop ? S = !0 : !d.loop && i.loop ? C = !0 : w = !0), u.forEach((e)=>{
        if ($32a53a759126c58f$export$a6cdc56e425d0d0a(d[e]) && $32a53a759126c58f$export$a6cdc56e425d0d0a(i[e])) Object.assign(d[e], i[e]), (e === "navigation" || e === "pagination" || e === "scrollbar") && "enabled" in i[e] && !i[e].enabled && T(e);
        else {
            let t = i[e];
            (t === !0 || t === !1) && (e === "navigation" || e === "pagination" || e === "scrollbar") ? t === !1 && T(e) : d[e] = i[e];
        }
    }), u.includes("controller") && !v && t.controller && t.controller.control && d.controller && d.controller.control && (t.controller.control = d.controller.control), a.includes("children") && r && h && d.virtual.enabled ? (h.slides = r, h.update(!0)) : a.includes("virtual") && h && d.virtual.enabled && (r && (h.slides = r), h.update(!0)), a.includes("children") && r && d.loop && (w = !0), _ && g.init() && g.update(!0), v && (t.controller.control = d.controller.control), y && (t.isElement && (!l || typeof l == "string") && (l = document.createElement("div"), l.classList.add("swiper-pagination"), l.part.add("pagination"), t.el.appendChild(l)), l && (d.pagination.el = l), f.init(), f.render(), f.update()), b && (t.isElement && (!c || typeof c == "string") && (c = document.createElement("div"), c.classList.add("swiper-scrollbar"), c.part.add("scrollbar"), t.el.appendChild(c)), c && (d.scrollbar.el = c), m.init(), m.updateSize(), m.setTranslate()), x && (t.isElement && ((!o || typeof o == "string") && (o = document.createElement("div"), o.classList.add("swiper-button-next"), (0, $9bf922a49190330a$export$55f7c773066364d6)(o, t.navigation.arrowSvg), o.part.add("button-next"), t.el.appendChild(o)), (!s || typeof s == "string") && (s = document.createElement("div"), s.classList.add("swiper-button-prev"), (0, $9bf922a49190330a$export$55f7c773066364d6)(s, t.navigation.arrowSvg), s.part.add("button-prev"), t.el.appendChild(s))), o && (d.navigation.nextEl = o), s && (d.navigation.prevEl = s), p.init(), p.update()), a.includes("allowSlideNext") && (t.allowSlideNext = i.allowSlideNext), a.includes("allowSlidePrev") && (t.allowSlidePrev = i.allowSlidePrev), a.includes("direction") && t.changeDirection(i.direction, !1), (S || w) && t.loopDestroy(), (C || w) && t.loopCreate(), t.update();
}




//#region node_modules/swiper/shared/update-on-virtual-data.mjs
function $aa4f23dfc1e9f220$export$ec161d740909e39d(r = {}, i = !0) {
    let a = {
        on: {}
    }, s1 = {}, c = {};
    (0, $32a53a759126c58f$export$8b58be045bf06082)(a, (0, $6130630b8727286b$export$ebe90cb607ad99e)), a._emitClasses = !0, a.init = !1;
    let l = {}, u = (0, $32a53a759126c58f$export$9e7786ca3b9bf18d).map((e)=>e.replace(/_/, "")), d = Object.assign({}, r);
    return Object.keys(d).forEach((e)=>{
        r[e] !== void 0 && (u.indexOf(e) >= 0 ? (0, $32a53a759126c58f$export$a6cdc56e425d0d0a)(r[e]) ? (a[e] = {}, c[e] = {}, (0, $32a53a759126c58f$export$8b58be045bf06082)(a[e], r[e]), (0, $32a53a759126c58f$export$8b58be045bf06082)(c[e], r[e])) : (a[e] = r[e], c[e] = r[e]) : e.search(/on[A-Z]/) === 0 && typeof r[e] == "function" ? i ? s1[`${e[2].toLowerCase()}${e.substr(3)}`] = r[e] : a.on[`${e[2].toLowerCase()}${e.substr(3)}`] = r[e] : l[e] = r[e]);
    }), [
        "navigation",
        "pagination",
        "scrollbar"
    ].forEach((e)=>{
        a[e] === !0 && (a[e] = {}), a[e] === !1 && delete a[e];
    }), {
        params: a,
        passedParams: c,
        rest: l,
        events: s1
    };
}
function $aa4f23dfc1e9f220$export$5cee122e2267a745({ el: e, nextEl: t, prevEl: n, paginationEl: o, scrollbarEl: s, swiper: c }, l) {
    (0, $32a53a759126c58f$export$423ce9cad58a097b)(l) && t && n && (c.params.navigation.nextEl = t, c.originalParams.navigation.nextEl = t, c.params.navigation.prevEl = n, c.originalParams.navigation.prevEl = n), (0, $32a53a759126c58f$export$bcc3385f50c3c281)(l) && o && (c.params.pagination.el = o, c.originalParams.pagination.el = o), (0, $32a53a759126c58f$export$3f990fc5643c9587)(l) && s && (c.params.scrollbar.el = s, c.originalParams.scrollbar.el = s), c.init(e);
}
function $aa4f23dfc1e9f220$export$b514b32229708c1(e, t, r, i, a) {
    let s = [];
    if (!t) return s;
    let c = (e)=>{
        s.indexOf(e) < 0 && s.push(e);
    };
    if (r && i) {
        let e = i.map(a), t = r.map(a);
        e.join("") !== t.join("") && c("children"), i.length !== r.length && c("children");
    }
    return (0, $32a53a759126c58f$export$9e7786ca3b9bf18d).filter((e)=>e[0] === "_").map((e)=>e.replace(/_/, "")).forEach((r)=>{
        if (r in e && r in t) {
            if ((0, $32a53a759126c58f$export$a6cdc56e425d0d0a)(e[r]) && (0, $32a53a759126c58f$export$a6cdc56e425d0d0a)(t[r])) {
                let n = Object.keys(e[r]), i = Object.keys(t[r]);
                n.length === i.length ? (n.forEach((n)=>{
                    e[r][n] !== t[r][n] && c(r);
                }), i.forEach((n)=>{
                    e[r][n] !== t[r][n] && c(r);
                })) : c(r);
            } else e[r] !== t[r] && c(r);
        }
    }), s;
}
var $aa4f23dfc1e9f220$export$3099bd366035f6d9 = (e)=>{
    !e || e.destroyed || !e.params.virtual || e.params.virtual && !e.params.virtual.enabled || (e.updateSlides(), e.updateProgress(), e.updateSlidesClasses(), e.emit("_virtualUpdated"), e.parallax && e.params.parallax && e.params.parallax.enabled && e.parallax.setTranslate());
};



var $acw62 = parcelRequire("acw62");
//#region node_modules/swiper/swiper-react.mjs
function $679a2ba60cd2de83$var$y() {
    return $679a2ba60cd2de83$var$y = Object.assign ? Object.assign.bind() : function(e) {
        for(var t = 1; t < arguments.length; t++){
            var n = arguments[t];
            for(var r in n)Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
        }
        return e;
    }, $679a2ba60cd2de83$var$y.apply(this, arguments);
}
function $679a2ba60cd2de83$var$b(e) {
    return e.type && e.type.displayName && e.type.displayName.includes("SwiperSlide");
}
function $679a2ba60cd2de83$var$x(e) {
    let t = [];
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Children.toArray(e).forEach((e)=>{
        $679a2ba60cd2de83$var$b(e) ? t.push(e) : e.props && e.props.children && $679a2ba60cd2de83$var$x(e.props.children).forEach((e)=>t.push(e));
    }), t;
}
function $679a2ba60cd2de83$var$S(e) {
    let t = [], n = {
        "container-start": [],
        "container-end": [],
        "wrapper-start": [],
        "wrapper-end": []
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Children.toArray(e).forEach((e)=>{
        if ($679a2ba60cd2de83$var$b(e)) t.push(e);
        else if (e.props && e.props.slot && n[e.props.slot]) n[e.props.slot].push(e);
        else if (e.props && e.props.children) {
            let r = $679a2ba60cd2de83$var$x(e.props.children);
            r.length > 0 ? r.forEach((e)=>t.push(e)) : n["container-end"].push(e);
        } else n["container-end"].push(e);
    }), {
        slides: t,
        slots: n
    };
}
function $679a2ba60cd2de83$var$C(e, t, n) {
    if (!n) return null;
    let r = (e)=>{
        let n = e;
        return e < 0 ? n = t.length + e : n >= t.length && (n -= t.length), n;
    }, i = e.isHorizontal() ? {
        [e.rtlTranslate ? "right" : "left"]: `${n.offset}px`
    } : {
        top: `${n.offset}px`
    }, { from: a, to: o } = n, s = e.params.loop ? -t.length : 0, c = e.params.loop ? t.length * 2 : t.length, l = [];
    for(let e = s; e < c; e += 1)e >= a && e <= o && l.push(t[r(e)]);
    return l.map((t, n)=>/* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).cloneElement(t, {
            swiper: e,
            style: i,
            key: t.props.virtualIndex || t.key || `slide-${n}`
        }));
}
function $679a2ba60cd2de83$var$w(e, t) {
    return typeof window > "u" ? (0, $acw62.useEffect)(e, t) : (0, $acw62.useLayoutEffect)(e, t);
}
var $679a2ba60cd2de83$var$T = /* @__PURE__ */ (0, $acw62.createContext)(null), $679a2ba60cd2de83$var$E = /* @__PURE__ */ (0, $acw62.createContext)(null), $679a2ba60cd2de83$export$6b3850921bc5a414 = /* @__PURE__ */ (0, $acw62.forwardRef)(({ className: p, tag: m = "div", wrapperTag: g = "div", children: b, onSwiper: x, ...T } = {}, D)=>{
    let O = !1, [k, A] = (0, $acw62.useState)("swiper"), [j, M] = (0, $acw62.useState)(null), [N, P] = (0, $acw62.useState)(!1), F = (0, $acw62.useRef)(!1), I = (0, $acw62.useRef)(null), L = (0, $acw62.useRef)(null), R = (0, $acw62.useRef)(null), z = (0, $acw62.useRef)(null), B = (0, $acw62.useRef)(null), V = (0, $acw62.useRef)(null), H = (0, $acw62.useRef)(null), U = (0, $acw62.useRef)(null), { params: W, passedParams: G, rest: K, events: q } = (0, $aa4f23dfc1e9f220$export$ec161d740909e39d)(T), { slides: J, slots: Y } = $679a2ba60cd2de83$var$S(b), X = ()=>{
        P(!N);
    };
    Object.assign(W.on, {
        _containerClasses (e, t) {
            A(t);
        }
    });
    let Z = ()=>{
        Object.assign(W.on, q), O = !0;
        let n = {
            ...W
        };
        if (delete n.wrapperClass, L.current = new (0, $6130630b8727286b$export$6b3850921bc5a414)(n), L.current.virtual && L.current.params.virtual.enabled) {
            L.current.virtual.slides = J;
            let e = {
                cache: !1,
                slides: J,
                renderExternal: M,
                renderExternalUpdate: !1
            };
            (0, $32a53a759126c58f$export$8b58be045bf06082)(L.current.params.virtual, e), (0, $32a53a759126c58f$export$8b58be045bf06082)(L.current.originalParams.virtual, e);
        }
    };
    I.current || Z(), L.current && L.current.on("_beforeBreakpoint", X);
    let Q = ()=>{
        O || !q || !L.current || Object.keys(q).forEach((e)=>{
            L.current.on(e, q[e]);
        });
    }, $ = ()=>{
        !q || !L.current || Object.keys(q).forEach((e)=>{
            L.current.off(e, q[e]);
        });
    };
    (0, $acw62.useEffect)(()=>()=>{
            L.current && L.current.off("_beforeBreakpoint", X);
        }), (0, $acw62.useEffect)(()=>{
        !F.current && L.current && (L.current.emitSlidesClasses(), F.current = !0);
    }), $679a2ba60cd2de83$var$w(()=>{
        if (D && (D.current = I.current), I.current) return L.current.destroyed && Z(), (0, $aa4f23dfc1e9f220$export$5cee122e2267a745)({
            el: I.current,
            nextEl: B.current,
            prevEl: V.current,
            paginationEl: H.current,
            scrollbarEl: U.current,
            swiper: L.current
        }, W), x && !L.current.destroyed && x(L.current), ()=>{
            L.current && !L.current.destroyed && L.current.destroy(!0, !1);
        };
    }, []), $679a2ba60cd2de83$var$w(()=>{
        Q();
        let e = (0, $aa4f23dfc1e9f220$export$b514b32229708c1)(G, R.current, J, z.current, (e)=>e.key);
        return R.current = G, z.current = J, e.length && L.current && !L.current.destroyed && (0, $32a53a759126c58f$export$f69d13c24dc33989)({
            swiper: L.current,
            slides: J,
            passedParams: G,
            changedParams: e,
            nextEl: B.current,
            prevEl: V.current,
            scrollbarEl: U.current,
            paginationEl: H.current
        }), ()=>{
            $();
        };
    }), $679a2ba60cd2de83$var$w(()=>{
        (0, $aa4f23dfc1e9f220$export$3099bd366035f6d9)(L.current);
    }, [
        j
    ]);
    function ee() {
        return W.virtual ? $679a2ba60cd2de83$var$C(L.current, J, j) : J.map((e, t)=>/* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).cloneElement(e, {
                swiper: L.current,
                swiperSlideIndex: t
            }));
    }
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(m, $679a2ba60cd2de83$var$y({
        ref: I,
        className: (0, $32a53a759126c58f$export$fce1ceb9f96a0ccc)(`${k}${p ? ` ${p}` : ""}`)
    }, K), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($679a2ba60cd2de83$var$E.Provider, {
        value: L.current
    }, Y["container-start"], /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(g, {
        className: (0, $32a53a759126c58f$export$401fbb047013b330)(W.wrapperClass)
    }, Y["wrapper-start"], ee(), Y["wrapper-end"]), (0, $32a53a759126c58f$export$423ce9cad58a097b)(W) && /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($acw62))).Fragment, null, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ref: V,
        className: "swiper-button-prev"
    }), /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ref: B,
        className: "swiper-button-next"
    })), (0, $32a53a759126c58f$export$3f990fc5643c9587)(W) && /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ref: U,
        className: "swiper-scrollbar"
    }), (0, $32a53a759126c58f$export$bcc3385f50c3c281)(W) && /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        ref: H,
        className: "swiper-pagination"
    }), Y["container-end"]));
});
$679a2ba60cd2de83$export$6b3850921bc5a414.displayName = "Swiper";
var $679a2ba60cd2de83$export$5c2bcc76ee716566 = /* @__PURE__ */ (0, $acw62.forwardRef)(({ tag: e = "div", children: t, className: n = "", swiper: r, zoom: i, lazy: o, virtualIndex: s, swiperSlideIndex: c, ...l } = {}, u)=>{
    let d = (0, $acw62.useRef)(null), [p, m] = (0, $acw62.useState)("swiper-slide"), [h, g] = (0, $acw62.useState)(!1);
    function b(e, t, n) {
        t === d.current && m(n);
    }
    $679a2ba60cd2de83$var$w(()=>{
        if (c !== void 0 && (d.current.swiperSlideIndex = c), u && (u.current = d.current), !(!d.current || !r)) {
            if (r.destroyed) {
                p !== "swiper-slide" && m("swiper-slide");
                return;
            }
            return r.on("_slideClass", b), ()=>{
                r && r.off("_slideClass", b);
            };
        }
    }), $679a2ba60cd2de83$var$w(()=>{
        r && d.current && !r.destroyed && m(r.getSlideClasses(d.current));
    }, [
        r
    ]);
    let x = {
        isActive: p.indexOf("swiper-slide-active") >= 0,
        isVisible: p.indexOf("swiper-slide-visible") >= 0,
        isFullyVisible: p.indexOf("swiper-slide-fully-visible") >= 0,
        isPrev: p.indexOf("swiper-slide-prev") >= 0,
        isNext: p.indexOf("swiper-slide-next") >= 0
    }, S = ()=>typeof t == "function" ? t(x) : t;
    return /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement(e, $679a2ba60cd2de83$var$y({
        ref: d,
        className: (0, $32a53a759126c58f$export$fce1ceb9f96a0ccc)(`${p}${n ? ` ${n}` : ""}`),
        "data-swiper-slide-index": s,
        onLoad: ()=>{
            g(!0);
        }
    }, l), i && /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($679a2ba60cd2de83$var$T.Provider, {
        value: x
    }, /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "swiper-zoom-container",
        "data-swiper-zoom": typeof i == "number" ? i : void 0
    }, S(), o && !h && /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "swiper-lazy-preloader",
        ref: (e)=>{
            e && (e.lazyPreloaderManaged = !0);
        }
    }))), !i && /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement($679a2ba60cd2de83$var$T.Provider, {
        value: x
    }, S(), o && !h && /* @__PURE__ */ (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).createElement("div", {
        className: "swiper-lazy-preloader",
        ref: (e)=>{
            e && (e.lazyPreloaderManaged = !0);
        }
    })));
});
$679a2ba60cd2de83$export$5c2bcc76ee716566.displayName = "SwiperSlide";




//#region node_modules/swiper/shared/create-element-if-not-defined.mjs
function $174c1afe5790e34e$export$f4bbea1d7959d26b(n, r, i, a) {
    return n.params.createElements && Object.keys(a).forEach((o)=>{
        if (!i[o] && i.auto === !0) {
            let s = (0, $9bf922a49190330a$export$eb846d859f2895e6)(n.el, `.${a[o]}`)[0];
            s || (s = (0, $9bf922a49190330a$export$c8a8987d4410bf2d)("div", a[o]), s.className = a[o], n.el.append(s)), i[o] = s, r[o] = s;
        }
    }), i;
}


//#region node_modules/swiper/modules/navigation.mjs
var $e802715f42588cf8$var$r = "<svg class=\"swiper-navigation-icon\" width=\"11\" height=\"20\" viewBox=\"0 0 11 20\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M0.38296 20.0762C0.111788 19.805 0.111788 19.3654 0.38296 19.0942L9.19758 10.2796L0.38296 1.46497C0.111788 1.19379 0.111788 0.754138 0.38296 0.482966C0.654131 0.211794 1.09379 0.211794 1.36496 0.482966L10.4341 9.55214C10.8359 9.9539 10.8359 10.6053 10.4341 11.007L1.36496 20.0762C1.09379 20.3474 0.654131 20.3474 0.38296 20.0762Z\" fill=\"currentColor\"/></svg>";
function $e802715f42588cf8$export$b8a61e5c71402559({ swiper: i, extendParams: a, on: o, emit: s }) {
    a({
        navigation: {
            nextEl: null,
            prevEl: null,
            addIcons: !0,
            hideOnClick: !1,
            disabledClass: "swiper-button-disabled",
            hiddenClass: "swiper-button-hidden",
            lockClass: "swiper-button-lock",
            navigationDisabledClass: "swiper-navigation-disabled"
        }
    }), i.navigation = {
        nextEl: null,
        prevEl: null,
        arrowSvg: $e802715f42588cf8$var$r
    };
    function c(e) {
        let t;
        return e && typeof e == "string" && i.isElement && (t = i.el.querySelector(e) || i.hostEl.querySelector(e), t) ? t : (e && (typeof e == "string" && (t = [
            ...document.querySelectorAll(e)
        ]), i.params.uniqueNavElements && typeof e == "string" && t && t.length > 1 && i.el.querySelectorAll(e).length === 1 ? t = i.el.querySelector(e) : t && t.length === 1 && (t = t[0])), e && !t ? e : t);
    }
    function l(t, n) {
        let r = i.params.navigation;
        t = (0, $9bf922a49190330a$export$daf5c237e5477731)(t), t.forEach((e)=>{
            e && (e.classList[n ? "add" : "remove"](...r.disabledClass.split(" ")), e.tagName === "BUTTON" && (e.disabled = n), i.params.watchOverflow && i.enabled && e.classList[i.isLocked ? "add" : "remove"](r.lockClass));
        });
    }
    function u() {
        let { nextEl: e, prevEl: t } = i.navigation;
        if (i.params.loop) {
            l(t, !1), l(e, !1);
            return;
        }
        l(t, i.isBeginning && !i.params.rewind), l(e, i.isEnd && !i.params.rewind);
    }
    function d(e) {
        e.preventDefault(), !(i.isBeginning && !i.params.loop && !i.params.rewind) && (i.slidePrev(), s("navigationPrev"));
    }
    function f(e) {
        e.preventDefault(), !(i.isEnd && !i.params.loop && !i.params.rewind) && (i.slideNext(), s("navigationNext"));
    }
    function p() {
        let a = i.params.navigation;
        if (i.params.navigation = (0, $174c1afe5790e34e$export$f4bbea1d7959d26b)(i, i.originalParams.navigation, i.params.navigation, {
            nextEl: "swiper-button-next",
            prevEl: "swiper-button-prev"
        }), !(a.nextEl || a.prevEl)) return;
        let o = c(a.nextEl), s = c(a.prevEl);
        Object.assign(i.navigation, {
            nextEl: o,
            prevEl: s
        }), o = (0, $9bf922a49190330a$export$daf5c237e5477731)(o), s = (0, $9bf922a49190330a$export$daf5c237e5477731)(s);
        let l = (e, n)=>{
            if (e) {
                if (a.addIcons && e.matches(".swiper-button-next,.swiper-button-prev") && !e.querySelector("svg")) {
                    let n = document.createElement("div");
                    (0, $9bf922a49190330a$export$55f7c773066364d6)(n, $e802715f42588cf8$var$r), e.appendChild(n.querySelector("svg")), n.remove();
                }
                e.addEventListener("click", n === "next" ? f : d);
            }
            !i.enabled && e && e.classList.add(...a.lockClass.split(" "));
        };
        o.forEach((e)=>l(e, "next")), s.forEach((e)=>l(e, "prev"));
    }
    function m() {
        let { nextEl: t, prevEl: n } = i.navigation;
        t = (0, $9bf922a49190330a$export$daf5c237e5477731)(t), n = (0, $9bf922a49190330a$export$daf5c237e5477731)(n);
        let r = (e, t)=>{
            e.removeEventListener("click", t === "next" ? f : d), e.classList.remove(...i.params.navigation.disabledClass.split(" "));
        };
        t.forEach((e)=>r(e, "next")), n.forEach((e)=>r(e, "prev"));
    }
    o("init", ()=>{
        i.params.navigation.enabled === !1 ? g() : (p(), u());
    }), o("toEdge fromEdge lock unlock", ()=>{
        u();
    }), o("destroy", ()=>{
        m();
    }), o("enable disable", ()=>{
        let { nextEl: t, prevEl: n } = i.navigation;
        if (t = (0, $9bf922a49190330a$export$daf5c237e5477731)(t), n = (0, $9bf922a49190330a$export$daf5c237e5477731)(n), i.enabled) {
            u();
            return;
        }
        [
            ...t,
            ...n
        ].filter((e)=>!!e).forEach((e)=>e.classList.add(i.params.navigation.lockClass));
    }), o("click", (t, n)=>{
        let { nextEl: r, prevEl: a } = i.navigation;
        r = (0, $9bf922a49190330a$export$daf5c237e5477731)(r), a = (0, $9bf922a49190330a$export$daf5c237e5477731)(a);
        let o = n.target, c = a.includes(o) || r.includes(o);
        if (i.isElement && !c) {
            let e = n.path || n.composedPath && n.composedPath();
            e && (c = e.find((e)=>r.includes(e) || a.includes(e)));
        }
        if (i.params.navigation.hideOnClick && !c) {
            if (i.pagination && i.params.pagination && i.params.pagination.clickable && (i.pagination.el === o || i.pagination.el.contains(o))) return;
            let e;
            r.length ? e = r[0].classList.contains(i.params.navigation.hiddenClass) : a.length && (e = a[0].classList.contains(i.params.navigation.hiddenClass)), s(e === !0 ? "navigationShow" : "navigationHide"), [
                ...r,
                ...a
            ].filter((e)=>!!e).forEach((e)=>e.classList.toggle(i.params.navigation.hiddenClass));
        }
    });
    let h = ()=>{
        i.el.classList.remove(...i.params.navigation.navigationDisabledClass.split(" ")), p(), u();
    }, g = ()=>{
        i.el.classList.add(...i.params.navigation.navigationDisabledClass.split(" ")), m();
    };
    Object.assign(i.navigation, {
        enable: h,
        disable: g,
        update: u,
        init: p,
        destroy: m
    });
}


var $22e5a75955f0de7c$export$2e2bcd8739ae039 = {
    container: "ara-ui_hot-topics-ara-container_bTaj",
    wrapper: "ara-ui_hot-topics-ara-wrapper_s9bl",
    slide: "ara-ui_hot-topics-ara-slide_qs0q"
};



"use client";
//#region src/components/hot-topics-ara/slider-hot-topics/index.tsx
var $a7cc46355243eaec$export$59d710163d638c90 = ({ hotTopics: o })=>/* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)((0, $679a2ba60cd2de83$export$6b3850921bc5a414), {
        modules: [
            (0, $e802715f42588cf8$export$b8a61e5c71402559)
        ],
        navigation: {
            nextEl: ".seg",
            prevEl: ".prev"
        },
        spaceBetween: 15,
        slidesOffsetAfter: 20,
        slidesPerView: "auto",
        tag: "nav",
        style: {
            maxWidth: "100%"
        },
        children: [
            o.map((e, n)=>/* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $679a2ba60cd2de83$export$5c2bcc76ee716566), {
                    className: (0, $22e5a75955f0de7c$export$2e2bcd8739ae039).slide,
                    children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("a", {
                        href: e.link.href,
                        title: e.link.text,
                        rel: e.link.rel || void 0,
                        target: e.link.target || void 0,
                        className: (0, $22e5a75955f0de7c$export$2e2bcd8739ae039).link,
                        children: e.link.title
                    })
                }, n)),
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("button", {
                className: "prev",
                children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("svg", {
                    xmlns: "http://www.w3.org/2000/svg",
                    width: "18",
                    height: "18",
                    viewBox: "0 0 18 18",
                    fill: "none",
                    children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M10.5 4.5L11.5575 5.5575L8.1225 9L11.5575 12.4425L10.5 13.5L6 9L10.5 4.5Z",
                        fill: "black"
                    })
                })
            }),
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("button", {
                className: "seg",
                children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("svg", {
                    xmlns: "http://www.w3.org/2000/svg",
                    width: "18",
                    height: "18",
                    viewBox: "0 0 18 18",
                    fill: "none",
                    children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
                        d: "M7.5 4.5L6.4425 5.5575L9.8775 9L6.4425 12.4425L7.5 13.5L12 9L7.5 4.5Z",
                        fill: "black"
                    })
                })
            })
        ]
    });









//#region src/components/hot-topics-ara/component.tsx
var $5c421e6ced3aa413$export$7452c58c1d48d2be = ({ idioma: a = "ca", hotTopics: o })=>/* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("div", {
        className: (0, $22e5a75955f0de7c$export$2e2bcd8739ae039).container,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)("div", {
            className: (0, $22e5a75955f0de7c$export$2e2bcd8739ae039).wrapper,
            children: [
                /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("p", {
                    children: (0, $63c6b3fd54c8dbeb$export$625550452a3fa3ec)("titol_hot_topics", a)
                }),
                /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("span", {}),
                /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $a7cc46355243eaec$export$59d710163d638c90), {
                    hotTopics: o
                })
            ]
        })
    });


//#region src/utils/hot-topics.ts
async function $4fbe4a84566125bd$export$d5429d6d91830e89() {
    try {
        let e = await fetch("https://www.ara.cat/api/hot-topics");
        return e.ok ? (await e.json()).response?.navigation ?? [] : [];
    } catch  {
        return [];
    }
}


var $60053840f91780ed$export$2e2bcd8739ae039 = {
    container: "ara-ui_tag-container_7GOG"
};



//#region src/components/tag/index.tsx
var $7ccea2396f3470f8$export$3288d34c523a1192 = ({ children: n, href: r, ...i })=>/* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("a", {
        href: r,
        className: (0, $60053840f91780ed$export$2e2bcd8739ae039).container,
        ...i,
        children: n
    });




//#region src/components/header-seccio/HeaderSeccio.module.scss
var $d673e46ca10b871a$export$2e2bcd8739ae039 = {};



//#region src/components/header-seccio/index.tsx
var $955da0a08a29324b$var$a = /* @__PURE__ */ (0, $14b872f206384382$export$82dec27a9dce9602)((0, $ba4d14fce8721970$export$f998fc56051369ed)(), 1), $955da0a08a29324b$export$d6b9e1f3e887dd1f = ({ seccio: e, subseccio: t, subseccions: o, ...s })=>{
    let c = window.location.pathname;
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: (0, $d673e46ca10b871a$export$2e2bcd8739ae039).container,
        ...s,
        children: [
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)("header", {
                children: [
                    /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("h2", {
                        children: e
                    }),
                    (t || o.find((e)=>c.includes(`/${e.slug}`))) && /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("h3", {
                        children: t?.nom || o.find((e)=>c.includes(`/${e.slug}`))?.nom
                    })
                ]
            }),
            o.length > 0 && /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("nav", {
                children: o.map((e)=>/* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("a", {
                        href: `/${e.slug}`,
                        className: (0, $955da0a08a29324b$var$a.default)({
                            [(0, $d673e46ca10b871a$export$2e2bcd8739ae039).active]: c.includes(`/${e.slug}`)
                        }),
                        children: e.nom
                    }, e.slug))
            })
        ]
    });
};






//#region node_modules/react-is/cjs/react-is.production.min.js
var $c582579e9688616e$export$f721772671d46943 = /* @__PURE__ */ (0, $14b872f206384382$export$e1ac61be52371773)((e)=>{
    var t = typeof Symbol == "function" && Symbol.for, n = t ? Symbol.for("react.element") : 60103, r = t ? Symbol.for("react.portal") : 60106, i = t ? Symbol.for("react.fragment") : 60107, a = t ? Symbol.for("react.strict_mode") : 60108, o = t ? Symbol.for("react.profiler") : 60114, s = t ? Symbol.for("react.provider") : 60109, c = t ? Symbol.for("react.context") : 60110, l = t ? Symbol.for("react.async_mode") : 60111, u = t ? Symbol.for("react.concurrent_mode") : 60111, d = t ? Symbol.for("react.forward_ref") : 60112, f = t ? Symbol.for("react.suspense") : 60113, p = t ? Symbol.for("react.suspense_list") : 60120, m = t ? Symbol.for("react.memo") : 60115, h = t ? Symbol.for("react.lazy") : 60116, g = t ? Symbol.for("react.block") : 60121, _ = t ? Symbol.for("react.fundamental") : 60117, v = t ? Symbol.for("react.responder") : 60118, y = t ? Symbol.for("react.scope") : 60119;
    function b(e) {
        if (typeof e == "object" && e) {
            var t = e.$$typeof;
            switch(t){
                case n:
                    switch(e = e.type, e){
                        case l:
                        case u:
                        case i:
                        case o:
                        case a:
                        case f:
                            return e;
                        default:
                            switch(e &&= e.$$typeof, e){
                                case c:
                                case d:
                                case h:
                                case m:
                                case s:
                                    return e;
                                default:
                                    return t;
                            }
                    }
                case r:
                    return t;
            }
        }
    }
    function x(e) {
        return b(e) === u;
    }
    e.AsyncMode = l, e.ConcurrentMode = u, e.ContextConsumer = c, e.ContextProvider = s, e.Element = n, e.ForwardRef = d, e.Fragment = i, e.Lazy = h, e.Memo = m, e.Portal = r, e.Profiler = o, e.StrictMode = a, e.Suspense = f, e.isAsyncMode = function(e) {
        return x(e) || b(e) === l;
    }, e.isConcurrentMode = x, e.isContextConsumer = function(e) {
        return b(e) === c;
    }, e.isContextProvider = function(e) {
        return b(e) === s;
    }, e.isElement = function(e) {
        return typeof e == "object" && !!e && e.$$typeof === n;
    }, e.isForwardRef = function(e) {
        return b(e) === d;
    }, e.isFragment = function(e) {
        return b(e) === i;
    }, e.isLazy = function(e) {
        return b(e) === h;
    }, e.isMemo = function(e) {
        return b(e) === m;
    }, e.isPortal = function(e) {
        return b(e) === r;
    }, e.isProfiler = function(e) {
        return b(e) === o;
    }, e.isStrictMode = function(e) {
        return b(e) === a;
    }, e.isSuspense = function(e) {
        return b(e) === f;
    }, e.isValidElementType = function(e) {
        return typeof e == "string" || typeof e == "function" || e === i || e === u || e === o || e === a || e === f || e === p || typeof e == "object" && !!e && (e.$$typeof === h || e.$$typeof === m || e.$$typeof === s || e.$$typeof === c || e.$$typeof === d || e.$$typeof === _ || e.$$typeof === v || e.$$typeof === y || e.$$typeof === g);
    }, e.typeOf = b;
});
var //#endregion
$c582579e9688616e$export$2e2bcd8739ae039 = $c582579e9688616e$export$f721772671d46943();



//#region node_modules/react-is/cjs/react-is.development.js
var $a6cd76d4f50aee67$export$db2d26051589141 = /* @__PURE__ */ (0, $14b872f206384382$export$e1ac61be52371773)((e)=>{});
var //#endregion
$a6cd76d4f50aee67$export$2e2bcd8739ae039 = $a6cd76d4f50aee67$export$db2d26051589141();


//#region node_modules/react-is/index.js
var $9538351711ee5a69$export$c792f6bbf98c7722 = /* @__PURE__ */ (0, $14b872f206384382$export$e1ac61be52371773)((e, r)=>{
    r.exports = (0, $c582579e9688616e$export$f721772671d46943)();
});
var //#endregion
$9538351711ee5a69$export$2e2bcd8739ae039 = $9538351711ee5a69$export$c792f6bbf98c7722();





//#region node_modules/object-assign/index.js
var $07389d7e68cd4589$export$9df84ec4d400b0cf = /* @__PURE__ */ (0, $14b872f206384382$export$e1ac61be52371773)((e, t)=>{
    var n = Object.getOwnPropertySymbols, r = Object.prototype.hasOwnProperty, i = Object.prototype.propertyIsEnumerable;
    function a(e) {
        if (e == null) throw TypeError("Object.assign cannot be called with null or undefined");
        return Object(e);
    }
    function o() {
        try {
            if (!Object.assign) return !1;
            var e = /* @__PURE__ */ new String("abc");
            if (e[5] = "de", Object.getOwnPropertyNames(e)[0] === "5") return !1;
            for(var t = {}, n = 0; n < 10; n++)t["_" + String.fromCharCode(n)] = n;
            if (Object.getOwnPropertyNames(t).map(function(e) {
                return t[e];
            }).join("") !== "0123456789") return !1;
            var r = {};
            return "abcdefghijklmnopqrst".split("").forEach(function(e) {
                r[e] = e;
            }), Object.keys(Object.assign({}, r)).join("") === "abcdefghijklmnopqrst";
        } catch  {
            return !1;
        }
    }
    t.exports = o() ? Object.assign : function(e, t) {
        for(var o, s = a(e), c, l = 1; l < arguments.length; l++){
            for(var u in o = Object(arguments[l]), o)r.call(o, u) && (s[u] = o[u]);
            if (n) {
                c = n(o);
                for(var d = 0; d < c.length; d++)i.call(o, c[d]) && (s[c[d]] = o[c[d]]);
            }
        }
        return s;
    };
});
var //#endregion
$07389d7e68cd4589$export$2e2bcd8739ae039 = $07389d7e68cd4589$export$9df84ec4d400b0cf();



//#region node_modules/prop-types/lib/ReactPropTypesSecret.js
var $21bacacf0b03af1d$export$ec4f4293d97e8e6a = /* @__PURE__ */ (0, $14b872f206384382$export$e1ac61be52371773)((e, t)=>{
    t.exports = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
});
var //#endregion
$21bacacf0b03af1d$export$2e2bcd8739ae039 = $21bacacf0b03af1d$export$ec4f4293d97e8e6a();



//#region node_modules/prop-types/lib/has.js
var $e6e7031ac7612c81$export$3018945da612e1b = /* @__PURE__ */ (0, $14b872f206384382$export$e1ac61be52371773)((e, t)=>{
    t.exports = Function.call.bind(Object.prototype.hasOwnProperty);
});
var //#endregion
$e6e7031ac7612c81$export$2e2bcd8739ae039 = $e6e7031ac7612c81$export$3018945da612e1b();





//#region node_modules/prop-types/checkPropTypes.js
var $5ffad717e118f001$export$f64d58c5d6c0bf1f = /* @__PURE__ */ (0, $14b872f206384382$export$e1ac61be52371773)((e, r)=>{
    var i = function() {};
    var a, o, s;
    function c(e, t, n, r, c) {
        var l, u, d, e1, f;
    }
    c.resetWarningCache = function() {}, r.exports = c;
});
var //#endregion
$5ffad717e118f001$export$2e2bcd8739ae039 = $5ffad717e118f001$export$f64d58c5d6c0bf1f();


//#region node_modules/prop-types/factoryWithTypeCheckers.js
var $882956493072d0e0$export$4f87c5f8b7ad72d4 = /* @__PURE__ */ (0, $14b872f206384382$export$e1ac61be52371773)((e, o)=>{
    var s = (0, $9538351711ee5a69$export$c792f6bbf98c7722)(), c = (0, $07389d7e68cd4589$export$9df84ec4d400b0cf)(), l = (0, $21bacacf0b03af1d$export$ec4f4293d97e8e6a)(), u = (0, $e6e7031ac7612c81$export$3018945da612e1b)(), d = (0, $5ffad717e118f001$export$f64d58c5d6c0bf1f)(), f = function() {};
    function p() {
        return null;
    }
    o.exports = function(e, t) {
        var n = typeof Symbol == "function" && Symbol.iterator, r = "@@iterator";
        function i(e) {
            var t = e && (n && e[n] || e[r]);
            if (typeof t == "function") return t;
        }
        var a = "<<anonymous>>", o = {
            array: _("array"),
            bigint: _("bigint"),
            bool: _("boolean"),
            func: _("function"),
            number: _("number"),
            object: _("object"),
            string: _("string"),
            symbol: _("symbol"),
            any: v(),
            arrayOf: y,
            element: b(),
            elementType: x(),
            instanceOf: S,
            node: E(),
            objectOf: w,
            oneOf: C,
            oneOfType: T,
            shape: O,
            exact: k
        };
        function m(e, t) {
            return e === t ? e !== 0 || 1 / e == 1 / t : e !== e && t !== t;
        }
        function h(e, t) {
            this.message = e, this.data = t && typeof t == "object" ? t : {}, this.stack = "";
        }
        h.prototype = Error.prototype;
        function g(e) {
            var n, r;
            function i(i, o, s, c, u, d, p) {
                if (c ||= a, d ||= s, p !== l) {
                    if (t) {
                        var m = /* @__PURE__ */ Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types");
                        throw m.name = "Invariant Violation", m;
                    } else var g;
                }
                return o[s] == null ? i ? o[s] === null ? new h("The " + u + " `" + d + "` is marked as required " + ("in `" + c + "`, but its value is `null`.")) : new h("The " + u + " `" + d + "` is marked as required in " + ("`" + c + "`, but its value is `undefined`.")) : null : e(o, s, c, u, d);
            }
            var o = i.bind(null, !1);
            return o.isRequired = i.bind(null, !0), o;
        }
        function _(e) {
            function t(t, n, r, i, a, o) {
                var s = t[n];
                if (M(s) !== e) {
                    var c = N(s);
                    return new h("Invalid " + i + " `" + a + "` of type " + ("`" + c + "` supplied to `" + r + "`, expected ") + ("`" + e + "`."), {
                        expectedType: e
                    });
                }
                return null;
            }
            return g(t);
        }
        function v() {
            return g(p);
        }
        function y(e) {
            function t(t, n, r, i, a) {
                if (typeof e != "function") return new h("Property `" + a + "` of component `" + r + "` has invalid PropType notation inside arrayOf.");
                var o = t[n];
                if (!Array.isArray(o)) {
                    var s = M(o);
                    return new h("Invalid " + i + " `" + a + "` of type " + ("`" + s + "` supplied to `" + r + "`, expected an array."));
                }
                for(var c = 0; c < o.length; c++){
                    var u = e(o, c, r, i, a + "[" + c + "]", l);
                    if (u instanceof Error) return u;
                }
                return null;
            }
            return g(t);
        }
        function b() {
            function t(t, n, r, i, a) {
                var o = t[n];
                if (!e(o)) {
                    var s = M(o);
                    return new h("Invalid " + i + " `" + a + "` of type " + ("`" + s + "` supplied to `" + r + "`, expected a single ReactElement."));
                }
                return null;
            }
            return g(t);
        }
        function x() {
            function e(e, t, n, r, i) {
                var a = e[t];
                if (!s.isValidElementType(a)) {
                    var o = M(a);
                    return new h("Invalid " + r + " `" + i + "` of type " + ("`" + o + "` supplied to `" + n + "`, expected a single ReactElement type."));
                }
                return null;
            }
            return g(e);
        }
        function S(e) {
            function t(t, n, r, i, o) {
                if (!(t[n] instanceof e)) {
                    var s = e.name || a, c = F(t[n]);
                    return new h("Invalid " + i + " `" + o + "` of type " + ("`" + c + "` supplied to `" + r + "`, expected ") + ("instance of `" + s + "`."));
                }
                return null;
            }
            return g(t);
        }
        function C(e) {
            if (!Array.isArray(e)) return p;
            function t(t, n, r, i, a) {
                for(var o = t[n], s = 0; s < e.length; s++)if (m(o, e[s])) return null;
                var c = JSON.stringify(e, function(e, t) {
                    return N(t) === "symbol" ? String(t) : t;
                });
                return new h("Invalid " + i + " `" + a + "` of value `" + String(o) + "` " + ("supplied to `" + r + "`, expected one of " + c + "."));
            }
            return g(t);
        }
        function w(e) {
            function t(t, n, r, i, a) {
                if (typeof e != "function") return new h("Property `" + a + "` of component `" + r + "` has invalid PropType notation inside objectOf.");
                var o = t[n], s = M(o);
                if (s !== "object") return new h("Invalid " + i + " `" + a + "` of type " + ("`" + s + "` supplied to `" + r + "`, expected an object."));
                for(var c in o)if (u(o, c)) {
                    var d = e(o, c, r, i, a + "." + c, l);
                    if (d instanceof Error) return d;
                }
                return null;
            }
            return g(t);
        }
        function T(e) {
            if (!Array.isArray(e)) return p;
            for(var t = 0; t < e.length; t++){
                var n = e[t];
                if (typeof n != "function") return f("Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + P(n) + " at index " + t + "."), p;
            }
            function r(t, n, r, i, a) {
                for(var o = [], s = 0; s < e.length; s++){
                    var c = e[s], d = c(t, n, r, i, a, l);
                    if (d == null) return null;
                    d.data && u(d.data, "expectedType") && o.push(d.data.expectedType);
                }
                var f = o.length > 0 ? ", expected one of type [" + o.join(", ") + "]" : "";
                return new h("Invalid " + i + " `" + a + "` supplied to " + ("`" + r + "`" + f + "."));
            }
            return g(r);
        }
        function E() {
            function e(e, t, n, r, i) {
                return A(e[t]) ? null : new h("Invalid " + r + " `" + i + "` supplied to " + ("`" + n + "`, expected a ReactNode."));
            }
            return g(e);
        }
        function D(e, t, n, r, i) {
            return new h((e || "React class") + ": " + t + " type `" + n + "." + r + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + i + "`.");
        }
        function O(e) {
            function t(t, n, r, i, a) {
                var o = t[n], s = M(o);
                if (s !== "object") return new h("Invalid " + i + " `" + a + "` of type `" + s + "` " + ("supplied to `" + r + "`, expected `object`."));
                for(var c in e){
                    var u = e[c];
                    if (typeof u != "function") return D(r, i, a, c, N(u));
                    var d = u(o, c, r, i, a + "." + c, l);
                    if (d) return d;
                }
                return null;
            }
            return g(t);
        }
        function k(e) {
            function t(t, n, r, i, a) {
                var o = t[n], s = M(o);
                if (s !== "object") return new h("Invalid " + i + " `" + a + "` of type `" + s + "` " + ("supplied to `" + r + "`, expected `object`."));
                for(var d in c({}, t[n], e)){
                    var f = e[d];
                    if (u(e, d) && typeof f != "function") return D(r, i, a, d, N(f));
                    if (!f) return new h("Invalid " + i + " `" + a + "` key `" + d + "` supplied to `" + r + "`.\nBad object: " + JSON.stringify(t[n], null, "  ") + "\nValid keys: " + JSON.stringify(Object.keys(e), null, "  "));
                    var p = f(o, d, r, i, a + "." + d, l);
                    if (p) return p;
                }
                return null;
            }
            return g(t);
        }
        function A(t) {
            switch(typeof t){
                case "number":
                case "string":
                case "undefined":
                    return !0;
                case "boolean":
                    return !t;
                case "object":
                    if (Array.isArray(t)) return t.every(A);
                    if (t === null || e(t)) return !0;
                    var n = i(t);
                    if (n) {
                        var r = n.call(t), a;
                        if (n !== t.entries) {
                            for(; !(a = r.next()).done;)if (!A(a.value)) return !1;
                        } else for(; !(a = r.next()).done;){
                            var o = a.value;
                            if (o && !A(o[1])) return !1;
                        }
                    } else return !1;
                    return !0;
                default:
                    return !1;
            }
        }
        function j(e, t) {
            return e === "symbol" ? !0 : t ? t["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && t instanceof Symbol : !1;
        }
        function M(e) {
            var t = typeof e;
            return Array.isArray(e) ? "array" : e instanceof RegExp ? "object" : j(t, e) ? "symbol" : t;
        }
        function N(e) {
            if (e == null) return "" + e;
            var t = M(e);
            if (t === "object") {
                if (e instanceof Date) return "date";
                if (e instanceof RegExp) return "regexp";
            }
            return t;
        }
        function P(e) {
            var t = N(e);
            switch(t){
                case "array":
                case "object":
                    return "an " + t;
                case "boolean":
                case "date":
                case "regexp":
                    return "a " + t;
                default:
                    return t;
            }
        }
        function F(e) {
            return !e.constructor || !e.constructor.name ? a : e.constructor.name;
        }
        return o.checkPropTypes = d, o.resetWarningCache = d.resetWarningCache, o.PropTypes = o, o;
    };
});
var //#endregion
$882956493072d0e0$export$2e2bcd8739ae039 = $882956493072d0e0$export$4f87c5f8b7ad72d4();




//#region node_modules/prop-types/factoryWithThrowingShims.js
var $cf90cc9300d0308a$export$eb7497db9d24afa1 = /* @__PURE__ */ (0, $14b872f206384382$export$e1ac61be52371773)((e, n)=>{
    var r = (0, $21bacacf0b03af1d$export$ec4f4293d97e8e6a)();
    function i() {}
    function a() {}
    a.resetWarningCache = i, n.exports = function() {
        function e(e, t, n, i, a, o) {
            if (o !== r) {
                var s = /* @__PURE__ */ Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
                throw s.name = "Invariant Violation", s;
            }
        }
        e.isRequired = e;
        function t() {
            return e;
        }
        var n = {
            array: e,
            bigint: e,
            bool: e,
            func: e,
            number: e,
            object: e,
            string: e,
            symbol: e,
            any: e,
            arrayOf: t,
            element: e,
            elementType: e,
            instanceOf: t,
            node: e,
            objectOf: t,
            oneOf: t,
            oneOfType: t,
            shape: t,
            exact: t,
            checkPropTypes: a,
            resetWarningCache: i
        };
        return n.PropTypes = n, n;
    };
});
var //#endregion
$cf90cc9300d0308a$export$2e2bcd8739ae039 = $cf90cc9300d0308a$export$eb7497db9d24afa1();


//#region node_modules/prop-types/index.js
var $272e10c4a54b9317$export$a6d0c630176ca1f5 = /* @__PURE__ */ (0, $14b872f206384382$export$e1ac61be52371773)((e, i)=>{
    var a;
    i.exports = (0, $cf90cc9300d0308a$export$eb7497db9d24afa1)()();
});
var //#endregion
$272e10c4a54b9317$export$2e2bcd8739ae039 = $272e10c4a54b9317$export$a6d0c630176ca1f5();



var $acw62 = parcelRequire("acw62");
//#region node_modules/@didomi/react/es/index.js
var $7b5751d54a176899$var$r = /* @__PURE__ */ (0, $14b872f206384382$export$82dec27a9dce9602)((0, $272e10c4a54b9317$export$a6d0c630176ca1f5)()), $7b5751d54a176899$export$89a04cf8534d7af5 = function(e) {
    var t = e.apiKey, r = t === void 0 ? null : t, i = e.noticeId, a = i === void 0 ? null : i, o = e.platform, s = o === void 0 ? null : o, c = e.config, l = c === void 0 ? {} : c, u = e.gdprAppliesGlobally, d = u === void 0 ? !0 : u, f = e.onReady, p = e.onConsentChanged, m = e.onNoticeShown, h = e.onNoticeHidden, g = e.onNoticeBackdropclick, _ = e.onNoticeClickAgree, v = e.onNoticeClickMoreInfo, y = e.onPreferencesClickAgreeToAll, b = e.onPreferencesClickDisagreeToAll, x = e.onPreferencesClickPurposeAgree, S = e.onPreferencesClickPurposeDisagree, C = e.onPreferencesClickViewVendors, w = e.onPreferencesClickSaveChoices, T = e.onPreferencesClickVendorAgree, E = e.onPreferencesClickVendorDisagree, D = e.onPreferencesClickVendorSaveChoices, O = e.sdkPath, k = O === void 0 ? "https://sdk.privacy-center.org/" : O, A = e.embedTCFStub, j = A === void 0 ? !0 : A, M = e.embedGPPStub, N = M === void 0 ? !1 : M, P = e.country, F = P === void 0 ? null : P, I = e.region, L = I === void 0 ? null : I, R = function() {
        f && (window.didomiOnReady = window.didomiOnReady || [], window.didomiOnReady.push(f)), window.didomiEventListeners = window.didomiEventListeners || [], p && window.didomiEventListeners.push({
            event: "consent.changed",
            listener: function(e) {
                p(e.consentToken);
            }
        }), m && window.didomiEventListeners.push({
            event: "notice.shown",
            listener: function() {
                return m();
            }
        }), h && window.didomiEventListeners.push({
            event: "notice.hidden",
            listener: function() {
                return h();
            }
        }), g && window.didomiEventListeners.push({
            event: "notice.backdropclick",
            listener: function() {
                return g();
            }
        }), _ && window.didomiEventListeners.push({
            event: "notice.clickagree",
            listener: function() {
                return _();
            }
        }), v && window.didomiEventListeners.push({
            event: "notice.clickmoreinfo",
            listener: function() {
                return v();
            }
        }), y && window.didomiEventListeners.push({
            event: "preferences.clickagreetoall",
            listener: function() {
                return y();
            }
        }), b && window.didomiEventListeners.push({
            event: "preferences.clickdisagreetoall",
            listener: function() {
                return b();
            }
        }), x && window.didomiEventListeners.push({
            event: "preferences.clickpurposeagree",
            listener: function() {
                return x();
            }
        }), S && window.didomiEventListeners.push({
            event: "preferences.clickpurposedisagree",
            listener: function() {
                return S();
            }
        }), C && window.didomiEventListeners.push({
            event: "preferences.clickviewvendors",
            listener: function() {
                return C();
            }
        }), w && window.didomiEventListeners.push({
            event: "preferences.clicksavechoices",
            listener: function() {
                return w();
            }
        }), T && window.didomiEventListeners.push({
            event: "preferences.clickvendoragree",
            listener: function() {
                return T();
            }
        }), E && window.didomiEventListeners.push({
            event: "preferences.clickvendordisagree",
            listener: function() {
                return E();
            }
        }), D && window.didomiEventListeners.push({
            event: "preferences.clickvendorsavechoices",
            listener: function() {
                return D();
            }
        });
    }, z = function() {
        var e;
        return l.app && l.app.apiKey && (e = l.app.apiKey), r || e;
    }, B = function() {
        var e, t = z(), n = d !== !1;
        window.didomiConfig = l || {}, window.didomiConfig.sdkPath = k, window.gdprAppliesGlobally = n, a ? (e = "target_type=notice&target=" + a, s && (e = "platform=" + s + "&" + e)) : e = "target=" + document.location.hostname, F && (e = e + "&country=" + F), L && (e = e + "&region=" + L), j && function() {
            function e(t) {
                if (!window.frames[t]) {
                    if (document.body && document.body.firstChild) {
                        var n = document.body, r = document.createElement("iframe");
                        r.style.display = "none", r.name = t, r.title = t, n.insertBefore(r, n.firstChild);
                    } else setTimeout(function() {
                        e(t);
                    }, 5);
                }
            }
            function t(e, t, n, r, i) {
                function a(e, n, r, a) {
                    if (typeof r == "function") {
                        window[t] || (window[t] = []);
                        var o = !1;
                        i && (o = i(e, n, r)), o || window[t].push({
                            command: e,
                            parameter: n,
                            callback: r,
                            version: a
                        });
                    }
                }
                a.stub = !0;
                function o(t) {
                    if (!(!window[e] || window[e].stub !== !0) && t.data) {
                        var i = typeof t.data == "string", a;
                        try {
                            a = i ? JSON.parse(t.data) : t.data;
                        } catch  {
                            return;
                        }
                        if (a[n]) {
                            var o = a[n];
                            window[e](o.command, o.parameter, function(e, n) {
                                var a = {};
                                a[r] = {
                                    returnValue: e,
                                    success: n,
                                    callId: o.callId
                                }, t.source.postMessage(i ? JSON.stringify(a) : a, "*");
                            }, o.version);
                        }
                    }
                }
                typeof window[e] != "function" && (window[e] = a, window.addEventListener ? window.addEventListener("message", o, !1) : window.attachEvent("onmessage", o));
            }
            t("__tcfapi", "__tcfapiBuffer", "__tcfapiCall", "__tcfapiReturn"), e("__tcfapiLocator");
        }(), N && function() {
            window.__gpp_addFrame = function(e) {
                if (!window.frames[e]) {
                    if (document.body) {
                        var t = document.createElement("iframe");
                        t.style.cssText = "display:none", t.name = e, document.body.appendChild(t);
                    } else window.setTimeout(function() {
                        window.__gpp_addFrame && window.__gpp_addFrame(e);
                    }, 10);
                }
            }, window.__gpp_stub = function() {
                var e = arguments;
                if (window.__gpp.queue = window.__gpp.queue || [], window.__gpp.events = window.__gpp.events || [], !e.length || e.length == 1 && e[0] == "queue") return window.__gpp.queue;
                if (e.length == 1 && e[0] == "events") return window.__gpp.events;
                var t = e[0], n = e.length > 1 ? e[1] : null, r = e.length > 2 ? e[2] : null;
                if (t === "ping") n({
                    gppVersion: "1.1",
                    cmpStatus: "stub",
                    cmpDisplayStatus: "hidden",
                    signalStatus: "not ready",
                    supportedAPIs: [
                        "2:tcfeuv2",
                        "5:tcfcav1",
                        "6:uspv1",
                        "7:usnatv1",
                        "8:uscav1",
                        "9:usvav1",
                        "10:uscov1",
                        "11:usutv1",
                        "12:usctv1"
                    ],
                    cmpId: 0,
                    sectionList: [],
                    applicableSections: [],
                    gppString: "",
                    parsedSections: {}
                }, !0);
                else if (t === "addEventListener") {
                    "lastId" in window.__gpp || (window.__gpp.lastId = 0), window.__gpp.lastId++;
                    var i = window.__gpp.lastId;
                    window.__gpp.events.push({
                        id: i,
                        callback: n,
                        parameter: r
                    }), n({
                        eventName: "listenerRegistered",
                        listenerId: i,
                        data: !0,
                        pingData: {
                            gppVersion: "1.1",
                            cmpStatus: "stub",
                            cmpDisplayStatus: "hidden",
                            signalStatus: "not ready",
                            supportedAPIs: [
                                "2:tcfeuv2",
                                "5:tcfcav1",
                                "6:uspv1",
                                "7:usnatv1",
                                "8:uscav1",
                                "9:usvav1",
                                "10:uscov1",
                                "11:usutv1",
                                "12:usctv1"
                            ],
                            cmpId: 0,
                            sectionList: [],
                            applicableSections: [],
                            gppString: "",
                            parsedSections: {}
                        }
                    }, !0);
                } else if (t === "removeEventListener") {
                    for(var a = !1, o = 0; o < window.__gpp.events.length; o++)if (window.__gpp.events[o].id == r) {
                        window.__gpp.events.splice(o, 1), a = !0;
                        break;
                    }
                    n({
                        eventName: "listenerRemoved",
                        listenerId: r,
                        data: a,
                        pingData: {
                            gppVersion: "1.1",
                            cmpStatus: "stub",
                            cmpDisplayStatus: "hidden",
                            signalStatus: "not ready",
                            supportedAPIs: [
                                "2:tcfeuv2",
                                "5:tcfcav1",
                                "6:uspv1",
                                "7:usnatv1",
                                "8:uscav1",
                                "9:usvav1",
                                "10:uscov1",
                                "11:usutv1",
                                "12:usctv1"
                            ],
                            cmpId: 0,
                            sectionList: [],
                            applicableSections: [],
                            gppString: "",
                            parsedSections: {}
                        }
                    }, !0);
                } else t === "hasSection" ? n(!1, !0) : t === "getSection" || t === "getField" ? n(null, !0) : window.__gpp.queue.push([].slice.apply(e));
            }, window.__gpp_msghandler = function(e) {
                var t = typeof e.data == "string";
                try {
                    var n = t ? JSON.parse(e.data) : e.data;
                } catch  {
                    n = null;
                }
                if (typeof n == "object" && n && "__gppCall" in n) {
                    var r = n.__gppCall;
                    window.__gpp && window.__gpp(r.command, function(n, i) {
                        var a = {
                            __gppReturn: {
                                returnValue: n,
                                success: i,
                                callId: r.callId
                            }
                        };
                        e.source.postMessage(t ? JSON.stringify(a) : a, "*");
                    }, "parameter" in r ? r.parameter : null, "version" in r ? r.version : "1.1");
                }
            }, (!("__gpp" in window) || typeof window.__gpp != "function") && (window.__gpp = window.__gpp_stub, window.addEventListener("message", window.__gpp_msghandler, !1), window.__gpp_addFrame("__gppLocator"));
        }();
        var r = "spcloader";
        if (document.getElementById(r)) return null;
        var i = document.createElement("script");
        i.id = r, i.type = "text/javascript", i.async = !0, i.src = k + t + "/loader.js?" + e, i.charset = "utf-8";
        var o = document.getElementsByTagName("script")[0];
        o.parentNode.insertBefore(i, o);
    };
    return (0, (/*@__PURE__*/$parcel$interopDefault($acw62))).useEffect(function() {
        R(), B();
    }, []), null;
};
$7b5751d54a176899$export$89a04cf8534d7af5.propTypes = {
    apiKey: $7b5751d54a176899$var$r.default.string,
    noticeId: $7b5751d54a176899$var$r.default.string,
    platform: $7b5751d54a176899$var$r.default.string,
    config: $7b5751d54a176899$var$r.default.object,
    gdprAppliesGlobally: $7b5751d54a176899$var$r.default.bool,
    onReady: $7b5751d54a176899$var$r.default.func,
    onConsentChanged: $7b5751d54a176899$var$r.default.func,
    onNoticeShown: $7b5751d54a176899$var$r.default.func,
    onNoticeHidden: $7b5751d54a176899$var$r.default.func,
    onNoticeBackdropclick: $7b5751d54a176899$var$r.default.func,
    onNoticeClickAgree: $7b5751d54a176899$var$r.default.func,
    onNoticeClickMoreInfo: $7b5751d54a176899$var$r.default.func,
    onPreferencesClickAgreeToAll: $7b5751d54a176899$var$r.default.func,
    onPreferencesClickDisagreeToAll: $7b5751d54a176899$var$r.default.func,
    onPreferencesClickPurposeAgree: $7b5751d54a176899$var$r.default.func,
    onPreferencesClickPurposeDisagree: $7b5751d54a176899$var$r.default.func,
    onPreferencesClickViewVendors: $7b5751d54a176899$var$r.default.func,
    onPreferencesClickSaveChoices: $7b5751d54a176899$var$r.default.func,
    onPreferencesClickVendorAgree: $7b5751d54a176899$var$r.default.func,
    onPreferencesClickVendorDisagree: $7b5751d54a176899$var$r.default.func,
    onPreferencesClickVendorSaveChoices: $7b5751d54a176899$var$r.default.func,
    sdkPath: $7b5751d54a176899$var$r.default.string,
    embedTCFStub: $7b5751d54a176899$var$r.default.bool,
    embedGPPStub: $7b5751d54a176899$var$r.default.bool,
    country: $7b5751d54a176899$var$r.default.string,
    region: $7b5751d54a176899$var$r.default.string
};



//#region src/components/analytics-ara/didomi-ara.tsx
var $96e1b22d6f6121c2$export$fb402d8e246cb752 = ({})=>/* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $7b5751d54a176899$export$89a04cf8534d7af5), {
        apiKey: "d20cb746-9cdd-461f-a57b-cd41f54fad65",
        iabVersion: 2,
        gdprAppliesGlobally: !0,
        onReady: (e)=>console.log("Didomi SDK is loaded and ready", e),
        onConsentChanged: (e)=>console.log("A consent has been given/withdrawn", e),
        onNoticeShown: ()=>console.log("Didomi Notice Shown"),
        onNoticeHidden: ()=>console.log("Didomi Notice Hidden")
    });



























var $bac595804ab21a44$export$2e2bcd8739ae039 = {
    container: "ara-ui_switch-container_tFDn",
    bullet: "ara-ui_switch-bullet_bB4n",
    active: "ara-ui_switch-active_51Si"
};



var $acw62 = parcelRequire("acw62");

"use client";
//#region src/components/switch/index.tsx
var $acc7006dc910dece$var$a = /* @__PURE__ */ (0, $14b872f206384382$export$82dec27a9dce9602)((0, $ba4d14fce8721970$export$f998fc56051369ed)(), 1), $acc7006dc910dece$export$b5d5cf8927ab7262 = ({ onClick: e = ()=>{}, active: t = !1, ...o })=>{
    let [s, c] = (0, $acw62.useState)(t);
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("button", {
        onClick: (t)=>{
            c(!s), e(), t.currentTarget.blur();
        },
        className: (0, $acc7006dc910dece$var$a.default)((0, $bac595804ab21a44$export$2e2bcd8739ae039).container, {
            [(0, $bac595804ab21a44$export$2e2bcd8739ae039).active]: s
        }),
        ...o,
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("div", {
            className: (0, $bac595804ab21a44$export$2e2bcd8739ae039).bullet
        })
    });
};


//#region src/utils/user.ts
var $7b0de4fe1dc2e7e1$var$e = {
    userId: null
};
function $7b0de4fe1dc2e7e1$var$t(e) {
    let t = document.cookie.split(";");
    for (let n of t){
        let [t, r] = n.trim().split("=");
        if (t === e) return decodeURIComponent(r);
    }
    return null;
}
function $7b0de4fe1dc2e7e1$var$n(t) {
    if (t) try {
        let e = JSON.parse(t);
        return {
            userId: e.userId,
            nick: e.nick,
            name: e.name,
            email: e.email,
            avatarUrl: e.avatarUrl,
            subscriber: e.subscriber
        };
    } catch (t) {
        return console.error("No s'ha pogut descodificar el JSON de la cookie:", t), $7b0de4fe1dc2e7e1$var$e;
    }
    else return $7b0de4fe1dc2e7e1$var$e;
}
var $7b0de4fe1dc2e7e1$export$7cbf767827cd68ba = ()=>$7b0de4fe1dc2e7e1$var$n($7b0de4fe1dc2e7e1$var$t("nx-session-user") || "");


var $d955cdd97a4d8447$export$2e2bcd8739ae039 = {
    container: "ara-ui_publi-header-sky-container_yzGq",
    sky: "ara-ui_publi-header-sky-sky_OpNb",
    skyRight: "ara-ui_publi-header-sky-skyRight_64iT",
    skyLeft: "ara-ui_publi-header-sky-skyLeft_552Z",
    fixed: "ara-ui_publi-header-sky-fixed_hRl-",
    publiTop: "ara-ui_publi-header-sky-publiTop_mMsb"
};



var $acw62 = parcelRequire("acw62");

"use client";
//#region src/components/publi-header-sky/index.tsx
var $3e9ddc155496516b$export$b34befcabb77195f = ({ idPositionTop: c, idPositionSkyLeft: l, idPositionSkyRight: u })=>{
    let d = (0, $acw62.useRef)(null), [f, p] = (0, $acw62.useState)({
        userId: null
    }), [m, h] = (0, $acw62.useState)(!1);
    return (0, $acw62.useEffect)(()=>{
        p((0, $7b0de4fe1dc2e7e1$export$7cbf767827cd68ba)());
    }, []), (0, $acw62.useEffect)(()=>{
        let e = ()=>{
            d.current && h(d.current.getBoundingClientRect().top <= 0);
        };
        return window.addEventListener("scroll", e), ()=>{
            window.removeEventListener("scroll", e);
        };
    }, []), /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: (0, $d955cdd97a4d8447$export$2e2bcd8739ae039).container,
        children: [
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: (0, $d955cdd97a4d8447$export$2e2bcd8739ae039).publiTop,
                ref: d,
                children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("div", {
                    "data-ad-position": c,
                    className: "ssmas-ad"
                })
            }),
            (f.userId && !f?.subscriber || !f.userId) && /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
                children: [
                    /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: `${(0, $d955cdd97a4d8447$export$2e2bcd8739ae039).skyLeft} ${m ? (0, $d955cdd97a4d8447$export$2e2bcd8739ae039).fixed : ""}`,
                        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("div", {
                            "data-ad-position": l,
                            className: "ssmas-ad"
                        })
                    }),
                    /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("div", {
                        className: `${(0, $d955cdd97a4d8447$export$2e2bcd8739ae039).skyRight} ${m ? (0, $d955cdd97a4d8447$export$2e2bcd8739ae039).fixed : ""}`,
                        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("div", {
                            "data-ad-position": u,
                            className: "ssmas-ad"
                        })
                    })
                ]
            })
        ]
    });
};






var $ab762bc727b843a6$export$2e2bcd8739ae039 = {
    container: "ara-ui_app-bar-container_BiC-",
    open: "ara-ui_app-bar-open_Zt1r",
    header: "ara-ui_app-bar-header_YUlq",
    wrapper: "ara-ui_app-bar-wrapper_chsL",
    cercador: "ara-ui_app-bar-cercador_qH1G",
    element: "ara-ui_app-bar-element_Qb-u"
};


//#region src/components/app-bar/menu.json
var $f3e2f115ff82eab2$export$2e2bcd8739ae039 = [
    {
        titol: "Hemeroteca",
        items: [
            {
                titol: "Edici\xf3 paper PDF",
                url: "https://www.ara.cat/hemeroteca/"
            }
        ]
    },
    {
        titol: "Seccions",
        items: [
            {
                titol: "Opini\xf3",
                url: "https://www.ara.cat/opinio/"
            },
            {
                titol: "Pol\xedtica",
                url: "https://www.ara.cat/politica/"
            },
            {
                titol: "Internacional",
                url: "https://www.ara.cat/internacional/"
            },
            {
                titol: "Economia",
                url: "https://www.ara.cat/economia/"
            },
            {
                titol: "Societat",
                url: "https://www.ara.cat/societat/"
            },
            {
                titol: "Medi i Crisi clim\xe0tica",
                url: "https://www.ara.cat/medi-i-crisi-climatica/"
            },
            {
                titol: "Ci\xe8ncia",
                url: "https://www.ara.cat/ciencia-medi-ambient/"
            },
            {
                titol: "Cultura",
                url: "https://www.ara.cat/cultura/"
            },
            {
                titol: "Investigaci\xf3",
                url: "https://www.ara.cat/investigacio/"
            },
            {
                titol: "Llengua",
                url: "https://www.ara.cat/llengua/"
            },
            {
                titol: "Esports",
                url: "https://www.ara.cat/esports/"
            },
            {
                titol: "M\xe8dia",
                url: "https://www.ara.cat/media/"
            },
            {
                titol: "Feminismes",
                url: "https://www.ara.cat/feminismes/"
            },
            {
                titol: "Estils",
                url: "https://www.ara.cat/estils/"
            },
            {
                titol: "Gent",
                url: "https://www.ara.cat/gent/"
            },
            {
                titol: "La M\xe9teo",
                url: "https://meteo.ara.cat"
            }
        ]
    },
    {
        titol: "Magazins",
        items: [
            {
                titol: "Diumenge",
                url: "https://diumenge.ara.cat/"
            },
            {
                titol: "Criatures",
                url: "https://criatures.ara.cat/"
            },
            {
                titol: "Empreses",
                url: "https://empreses.ara.cat/"
            },
            {
                titol: "Llegim",
                url: "https://llegim.ara.cat/"
            },
            {
                titol: "Mengem",
                url: "https://mengem.ara.cat/"
            },
            {
                titol: "Motor",
                url: "https://motor.ara.cat/"
            }
        ]
    },
    {
        titol: "Multim\xe8dia",
        items: [
            {
                titol: "Podcast",
                url: "https://www.ara.cat/podcasts.html"
            },
            {
                titol: "Interactius",
                url: "https://interactius.ara.cat/"
            },
            {
                titol: "Ara Data",
                url: "https://www.ara.cat/data/"
            },
            {
                titol: "Ara Mirades",
                url: "https://mirades.ara.cat/"
            },
            {
                titol: "V\xeddeo",
                url: "https://www.ara.cat/videos/"
            },
            {
                titol: "Foto",
                url: "https://www.ara.cat/fotografies/"
            },
            {
                titol: "Vinyetes",
                url: "https://www.ara.cat/vinyetes/"
            },
            {
                titol: "Dossiers",
                url: "https://www.ara.cat/dossier/"
            }
        ]
    },
    {
        titol: "Serveis",
        items: [
            {
                titol: "Botiga",
                url: "https://botiga.ara.cat/"
            },
            {
                titol: "Hemeroteca",
                url: "https://www.ara.cat/hemeroteca/"
            },
            {
                titol: "Newsletters",
                url: "https://perfil.ara.cat/newsletters"
            },
            {
                titol: "Trobamot",
                url: "https://jocs.ara.cat/trobamot/"
            },
            {
                titol: "Mots encreuats",
                url: "https://jocs.ara.cat/motsencreuats"
            },
            {
                titol: "Jocs",
                url: "https://jocs.ara.cat"
            },
            {
                titol: "Resultats electorals",
                url: "https://eleccions.ara.cat"
            }
        ]
    },
    {
        titol: "La Veu del Lector",
        items: [
            {
                titol: "Defensor del Lector",
                url: "https://www.ara.cat/defensor-del-lector/"
            },
            {
                titol: "B\xfastia d'investigaci\xf3",
                url: "https://www.ara.cat/investigacio.html"
            },
            {
                titol: "Cartes a la directora",
                url: "https://www.ara.cat/cartes/"
            },
            {
                titol: "Club pr\xe8mium",
                url: "https://premium.ara.cat/"
            },
            {
                titol: "Comunitat",
                url: "https://www.ara.cat/comunitat/"
            }
        ]
    },
    {
        titol: "Idioma",
        items: [
            {
                titol: "Catal\xe0",
                url: "https://www.ara.cat/"
            },
            {
                titol: "Castell\xe0",
                url: "https://es.ara.cat/"
            },
            {
                titol: "Angl\xe8s",
                url: "https://en.ara.cat/"
            }
        ]
    },
    {
        titol: "Edici\xf3",
        items: [
            {
                titol: "Catalunya",
                url: "https://www.ara.cat/"
            },
            {
                titol: "Balears",
                url: "https://www.arabalears.cat/"
            },
            {
                titol: "Pa\xeds Valenci\xe0",
                url: "https://www.ara.cat/paisvalencia/"
            },
            {
                titol: "Comarques gironines",
                url: "https://www.ara.cat/girona/"
            },
            {
                titol: "Camp de Tarragona",
                url: "https://www.ara.cat/campdetarragona/"
            },
            {
                titol: "Terres de Lleida",
                url: "https://www.ara.cat/terresdelleida/"
            }
        ]
    }
];



var $acw62 = parcelRequire("acw62");

//#region src/components/app-bar/MenuApp.tsx
var $13404fdc6ff7ea41$export$9ed4c587e6925517 = ({ isOpen: s = !1, ...c })=>{
    let [l, u] = (0, $acw62.useState)(""), d = (e)=>{
        e.preventDefault(), l.trim() !== "" && (window.location.href = `https://www.ara.cat/cercador?text=${encodeURIComponent(l)}`);
    };
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)("div", {
        ...c,
        className: `${(0, $ab762bc727b843a6$export$2e2bcd8739ae039).container} ${s ? (0, $ab762bc727b843a6$export$2e2bcd8739ae039).open : ""}`,
        children: [
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: (0, $ab762bc727b843a6$export$2e2bcd8739ae039).header,
                children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $7ad002eb59ab5f4c$export$4522f452a9a9b51e), {})
            }),
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: (0, $ab762bc727b843a6$export$2e2bcd8739ae039).wrapper,
                children: [
                    /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)("form", {
                        className: (0, $ab762bc727b843a6$export$2e2bcd8739ae039).cercador,
                        onSubmit: d,
                        children: [
                            l.trim() === "" ? /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $2a183a46947eafc4$export$fbe2f6ebbbe0cd5a), {
                                name: "navegacio/buscar",
                                size: 16
                            }) : /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("button", {
                                type: "reset",
                                onClick: ()=>u(""),
                                children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $2a183a46947eafc4$export$fbe2f6ebbbe0cd5a), {
                                    name: "navegacio/buscar-off",
                                    size: 16
                                })
                            }),
                            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("input", {
                                type: "text",
                                placeholder: "Cerca",
                                value: l,
                                onChange: (e)=>u(e.target.value)
                            })
                        ]
                    }),
                    /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("ul", {
                        children: (0, $f3e2f115ff82eab2$export$2e2bcd8739ae039).map((t, r)=>/* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)("li", {
                                children: [
                                    /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("p", {
                                        children: t.titol
                                    }),
                                    /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("nav", {
                                        children: t.items.map((t)=>/* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)("a", {
                                                href: t.url,
                                                className: (0, $ab762bc727b843a6$export$2e2bcd8739ae039).element,
                                                children: [
                                                    /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("span", {
                                                        children: t.titol
                                                    }),
                                                    /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $2a183a46947eafc4$export$fbe2f6ebbbe0cd5a), {
                                                        name: "navegacio/endavant",
                                                        size: 16
                                                    })
                                                ]
                                            }, t.url))
                                    })
                                ]
                            }, r))
                    })
                ]
            })
        ]
    });
};


var $d5a16215db74ed49$export$2e2bcd8739ae039 = {
    container: "ara-ui_app-bar-container_d-ID",
    actiu: "ara-ui_app-bar-actiu_P0cf"
};



var $acw62 = parcelRequire("acw62");

"use client";
//#region src/components/app-bar/index.tsx
var $de50741b5c954bc6$export$54035738ce87d8f1 = ({ navActiu: l = "portada", hihaUltimaHora: u = !1, ...d })=>{
    let [f, p] = (0, $acw62.useState)(!1), [m, h] = (0, $acw62.useState)(l), g = (e)=>{
        e.preventDefault(), p((e)=>!e), h((e)=>e === "seccions" ? l : "seccions");
    };
    return (0, $acw62.useEffect)(()=>{
        f ? document.body.style.overflow = "hidden" : document.body.style.removeProperty("overflow");
    }, [
        f
    ]), /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)("nav", {
                ...d,
                className: (0, $d5a16215db74ed49$export$2e2bcd8739ae039).container,
                children: [
                    /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)("a", {
                        href: (0, $444d8bf17e3d997e$export$a7052c111377e79e).URL,
                        title: (0, $444d8bf17e3d997e$export$a7052c111377e79e).NAME,
                        className: m === "portada" ? (0, $d5a16215db74ed49$export$2e2bcd8739ae039).actiu : "",
                        children: [
                            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $2a183a46947eafc4$export$fbe2f6ebbbe0cd5a), {
                                name: "menu/logo",
                                size: 20
                            }),
                            "Portada"
                        ]
                    }),
                    /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)("a", {
                        href: (0, $444d8bf17e3d997e$export$a7052c111377e79e).URL_ULTIMA_HORA,
                        className: m === "ultima-hora" ? (0, $d5a16215db74ed49$export$2e2bcd8739ae039).actiu : "",
                        children: [
                            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $2a183a46947eafc4$export$fbe2f6ebbbe0cd5a), {
                                size: 20,
                                name: u ? "menu/ultima-hora-actiu" : "menu/ultima-hora"
                            }),
                            "\xdaltima hora"
                        ]
                    }),
                    /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)("a", {
                        href: (0, $444d8bf17e3d997e$export$a7052c111377e79e).URL_DESCOBREIX,
                        className: m === "descobreix" ? (0, $d5a16215db74ed49$export$2e2bcd8739ae039).actiu : "",
                        children: [
                            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $2a183a46947eafc4$export$fbe2f6ebbbe0cd5a), {
                                size: 20,
                                name: "menu/descobreix"
                            }),
                            "Descobreix"
                        ]
                    }),
                    /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)("a", {
                        href: (0, $444d8bf17e3d997e$export$a7052c111377e79e).URL_JOCS,
                        className: m === "jocs" ? (0, $d5a16215db74ed49$export$2e2bcd8739ae039).actiu : "",
                        children: [
                            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $2a183a46947eafc4$export$fbe2f6ebbbe0cd5a), {
                                size: 20,
                                name: "menu/jocs"
                            }),
                            "Jocs"
                        ]
                    }),
                    /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)("a", {
                        href: "#",
                        onClick: g,
                        className: m === "seccions" ? (0, $d5a16215db74ed49$export$2e2bcd8739ae039).actiu : "",
                        children: [
                            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $2a183a46947eafc4$export$fbe2f6ebbbe0cd5a), {
                                size: 20,
                                name: f ? "navegacio/tanca" : "menu/seccions"
                            }),
                            "Seccions"
                        ]
                    })
                ]
            }),
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $13404fdc6ff7ea41$export$9ed4c587e6925517), {
                isOpen: f
            })
        ]
    });
};




var $af23a0df5e79d5ad$export$2e2bcd8739ae039 = {
    container: "ara-ui_tabs-bar-container_ypsW",
    active: "ara-ui_tabs-bar-active_Dn6I"
};



"use client";
//#region src/components/tabs-bar/tab.tsx
var $9737f1d3213b51aa$var$i = /* @__PURE__ */ (0, $14b872f206384382$export$82dec27a9dce9602)((0, $ba4d14fce8721970$export$f998fc56051369ed)(), 1), $9737f1d3213b51aa$export$3e41faf802a29e71 = ({ actiu: e, keyTab: t, handleClick: a, text: o, className: s, onClick: c, ...l })=>/* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("button", {
        className: (0, $9737f1d3213b51aa$var$i.default)((0, $af23a0df5e79d5ad$export$2e2bcd8739ae039).container, s, {
            [(0, $af23a0df5e79d5ad$export$2e2bcd8739ae039).active]: e
        }),
        onClick: (e)=>{
            a?.(t), c?.(e);
        },
        ...l,
        children: o
    });






var $58e91c94ed594417$export$2e2bcd8739ae039 = {
    container: "ara-ui_tabs-bar-container_7X-U",
    slide: "ara-ui_tabs-bar-slide_sMAL"
};



var $acw62 = parcelRequire("acw62");

"use client";
//#region src/components/tabs-bar/index.tsx
var $022321c99395772a$var$c = /* @__PURE__ */ (0, $14b872f206384382$export$82dec27a9dce9602)((0, $ba4d14fce8721970$export$f998fc56051369ed)(), 1), $022321c99395772a$export$162886b1cdc28bcc = ({ tabs: e, onTabChange: t, className: l, ...u })=>{
    let [d, f] = (0, $acw62.useState)(e.find((e)=>e.actiu)?.keyTab || e[0].keyTab), p = (e, n)=>{
        f(e), n.handleClick?.(e), t?.(e, n);
    };
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $679a2ba60cd2de83$export$6b3850921bc5a414), {
        className: (0, $022321c99395772a$var$c.default)((0, $58e91c94ed594417$export$2e2bcd8739ae039).container, l),
        "data-tab": d,
        slidesPerView: "auto",
        tag: "nav",
        ...u,
        children: e.map((e)=>/* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $679a2ba60cd2de83$export$5c2bcc76ee716566), {
                className: (0, $58e91c94ed594417$export$2e2bcd8739ae039).slide,
                children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $9737f1d3213b51aa$export$3e41faf802a29e71), {
                    ...e,
                    actiu: e.keyTab === d,
                    handleClick: (t)=>p(t, e)
                })
            }, e.keyTab))
    });
};







//#region node_modules/react-gtm-module/dist/utils/warn.js
var $d034e492df83bbe9$export$1c0e476705e0dae5 = /* @__PURE__ */ (0, $14b872f206384382$export$e1ac61be52371773)((e)=>{
    Object.defineProperty(e, "__esModule", {
        value: !0
    }), e.default = function(e) {
        console.warn("[react-gtm]", e);
    };
});
var //#endregion
$d034e492df83bbe9$export$2e2bcd8739ae039 = $d034e492df83bbe9$export$1c0e476705e0dae5();


//#region node_modules/react-gtm-module/dist/Snippets.js
var $3e62ef66a9f0dc4f$export$37c5ae12376d3a1d = /* @__PURE__ */ (0, $14b872f206384382$export$e1ac61be52371773)((e, n)=>{
    var r = i((0, $d034e492df83bbe9$export$1c0e476705e0dae5)());
    function i(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    n.exports = {
        tags: function(e) {
            var t = e.id, n = e.events, i = e.dataLayer, a = e.dataLayerName, o = e.preview, s = "&gtm_auth=" + e.auth, c = "&gtm_preview=" + o;
            return t || (0, r.default)("GTM Id is required"), {
                iframe: "\n      <iframe src=\"https://www.googletagmanager.com/ns.html?id=" + t + s + c + "&gtm_cookies_win=x\"\n        height=\"0\" width=\"0\" style=\"display:none;visibility:hidden\" id=\"tag-manager\"></iframe>",
                script: "\n      (function(w,d,s,l,i){w[l]=w[l]||[];\n        w[l].push({'gtm.start': new Date().getTime(),event:'gtm.js', " + JSON.stringify(n).slice(1, -1) + "});\n        var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';\n        j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl+'" + s + c + "&gtm_cookies_win=x';\n        f.parentNode.insertBefore(j,f);\n      })(window,document,'script','" + a + "','" + t + "');",
                dataLayerVar: this.dataLayer(i, a)
            };
        },
        dataLayer: function(e, t) {
            return "\n      window." + t + " = window." + t + " || [];\n      window." + t + ".push(" + JSON.stringify(e) + ")";
        }
    };
});
var //#endregion
$3e62ef66a9f0dc4f$export$2e2bcd8739ae039 = $3e62ef66a9f0dc4f$export$37c5ae12376d3a1d();


//#region node_modules/react-gtm-module/dist/TagManager.js
var $5d4397e0eec94487$export$de364e8bce9fadc4 = /* @__PURE__ */ (0, $14b872f206384382$export$e1ac61be52371773)((e, n)=>{
    var r = i((0, $3e62ef66a9f0dc4f$export$37c5ae12376d3a1d)());
    function i(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    n.exports = {
        dataScript: function(e) {
            var t = document.createElement("script");
            return t.innerHTML = e, t;
        },
        gtm: function(e) {
            var t = r.default.tags(e);
            return {
                noScript: function() {
                    var e = document.createElement("noscript");
                    return e.innerHTML = t.iframe, e;
                },
                script: function() {
                    var e = document.createElement("script");
                    return e.innerHTML = t.script, e;
                },
                dataScript: this.dataScript(t.dataLayerVar)
            };
        },
        initialize: function(e) {
            var t = e.gtmId, n = e.events, r = n === void 0 ? {} : n, i = e.dataLayer, a = e.dataLayerName, o = a === void 0 ? "dataLayer" : a, s = e.auth, c = s === void 0 ? "" : s, l = e.preview, u = l === void 0 ? "" : l, d = this.gtm({
                id: t,
                events: r,
                dataLayer: i || void 0,
                dataLayerName: o,
                auth: c,
                preview: u
            });
            i && document.head.appendChild(d.dataScript), document.head.insertBefore(d.script(), document.head.childNodes[0]), document.body.insertBefore(d.noScript(), document.body.childNodes[0]);
        },
        dataLayer: function(e) {
            var t = e.dataLayer, n = e.dataLayerName, i = n === void 0 ? "dataLayer" : n;
            if (window[i]) return window[i].push(t);
            var a = r.default.dataLayer(t, i), o = this.dataScript(a);
            document.head.insertBefore(o, document.head.childNodes[0]);
        }
    };
});
var //#endregion
$5d4397e0eec94487$export$2e2bcd8739ae039 = $5d4397e0eec94487$export$de364e8bce9fadc4();


//#region node_modules/react-gtm-module/dist/index.js
var $f9f810956998cdec$export$282d2224152022b9 = /* @__PURE__ */ (0, $14b872f206384382$export$e1ac61be52371773)((e, n)=>{
    var r = i((0, $5d4397e0eec94487$export$de364e8bce9fadc4)());
    function i(e) {
        return e && e.__esModule ? e : {
            default: e
        };
    }
    n.exports = r.default;
});
var //#endregion
$f9f810956998cdec$export$2e2bcd8739ae039 = $f9f810956998cdec$export$282d2224152022b9();



var $acw62 = parcelRequire("acw62");

"use client";
//#region src/components/analytics-ara/gtm-ara.tsx
var $aa9b4545b7aa1d67$var$a = /* @__PURE__ */ (0, $14b872f206384382$export$82dec27a9dce9602)((0, $f9f810956998cdec$export$282d2224152022b9)(), 1), $aa9b4545b7aa1d67$export$a4bca8ba1a12d598 = ({ GTM_ID: e = "GTM-M63PMSS", dataLayer: t = {} })=>((0, $acw62.useEffect)(()=>{
        let n = {
            gtmId: e,
            dataLayer: t
        };
        $aa9b4545b7aa1d67$var$a.default.initialize(n);
    }, []), /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $7b02d682eb115277$exports.Fragment), {}));





"use client";
//#region src/components/analytics-ara/index.tsx
var $c05bd4dc9a47517c$export$cab40a50416bf149 = ({ GTM_ID: a, dataLayer: o })=>/* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $96e1b22d6f6121c2$export$fb402d8e246cb752), {}),
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $aa9b4545b7aa1d67$export$a4bca8ba1a12d598), {
                GTM_ID: a,
                dataLayer: o
            })
        ]
    });





var $f443cc24a4d1fc41$export$2e2bcd8739ae039 = {
    container: "ara-ui_boto-multimedia-container_zduG",
    ambText: "ara-ui_boto-multimedia-ambText_TvTD",
    petit: "ara-ui_boto-multimedia-petit_0yY8"
};



//#region src/components/boto-multimedia/index.tsx
var $b8b6e245052c5190$var$o = /* @__PURE__ */ (0, $14b872f206384382$export$82dec27a9dce9602)((0, $ba4d14fce8721970$export$f998fc56051369ed)(), 1), $b8b6e245052c5190$var$s = {
    video: "multimedia/video",
    audio: "multimedia/audio",
    grafic: "multimedia/grafic",
    fotogaleria: "multimedia/fotogaleria",
    interactiu: "multimedia/interactiu",
    especial: "multimedia/interactiu",
    dossier: "multimedia/arxius",
    test: "multimedia/test",
    enquesta: "multimedia/enquesta"
}, $b8b6e245052c5190$var$c = {
    video: "V\xeddeo",
    audio: "\xc0udio",
    grafic: "Gr\xe0fic",
    fotogaleria: "Fotogaleria",
    interactiu: "Interactiu",
    especial: "Especial",
    dossier: "Dossier",
    test: "Test",
    enquesta: "Enquesta"
}, $b8b6e245052c5190$export$3d7f1b718d76033b = ({ children: e, className: t, sm: l = !1, text: u = !0, tipus: d, ...f })=>{
    let p = $b8b6e245052c5190$var$s[d];
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)("button", {
        className: (0, $b8b6e245052c5190$var$o.default)((0, $f443cc24a4d1fc41$export$2e2bcd8739ae039).container, t, {
            [(0, $f443cc24a4d1fc41$export$2e2bcd8739ae039).petit]: l,
            [(0, $f443cc24a4d1fc41$export$2e2bcd8739ae039).ambText]: u
        }),
        ...f,
        children: [
            p && /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $2a183a46947eafc4$export$fbe2f6ebbbe0cd5a), {
                name: p,
                width: l ? 16 : 18,
                color: "var(--BTN-TXT-Blanc_Blanc)"
            }),
            u && /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("span", {
                children: $b8b6e245052c5190$var$c[d]
            })
        ]
    });
};





var $35e3c077732c83e8$export$2e2bcd8739ae039 = {
    container: "ara-ui_slider-bar-container_34KD",
    bullets: "ara-ui_slider-bar-bullets_ZWoq",
    track: "ara-ui_slider-bar-track_Ybs5",
    actiu: "ara-ui_slider-bar-actiu_nYRG",
    inactiu: "ara-ui_slider-bar-inactiu_7QG-",
    nav: "ara-ui_slider-bar-nav_--jR",
    nomesNav: "ara-ui_slider-bar-nomesNav_OXyX"
};



"use client";
//#region src/components/slider-bar/index.tsx
var $89d4071f206e1e99$var$o = /* @__PURE__ */ (0, $14b872f206384382$export$82dec27a9dce9602)((0, $ba4d14fce8721970$export$f998fc56051369ed)(), 1), $89d4071f206e1e99$var$s = 3, $89d4071f206e1e99$var$c = 6, $89d4071f206e1e99$var$l = 5, $89d4071f206e1e99$export$5ff34efdd1b9ed54 = ({ bullets: e, className: t, indexActiu: u, total: d, onPrev: f, onNext: p, ...m })=>{
    let h = u <= 0, g = u >= d - 1, _ = Math.min(d, $89d4071f206e1e99$var$s), v = Math.max(0, Math.min(u - 1, d - _)), y = v + _ - 1, b = $89d4071f206e1e99$var$c + $89d4071f206e1e99$var$l, x = (e)=>e === u || _ < $89d4071f206e1e99$var$s ? !1 : h ? e === y : g ? e === v : e === v && v > 0 || e === y && y < d - 1, S = (e)=>{
        e < u ? f(e) : e > u && p(e);
    };
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)("nav", {
        className: (0, $89d4071f206e1e99$var$o.default)((0, $35e3c077732c83e8$export$2e2bcd8739ae039).container, t),
        ...m,
        children: [
            e && /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: (0, $35e3c077732c83e8$export$2e2bcd8739ae039).bullets,
                style: {
                    width: _ * $89d4071f206e1e99$var$c + (_ - 1) * $89d4071f206e1e99$var$l
                },
                children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("div", {
                    className: (0, $35e3c077732c83e8$export$2e2bcd8739ae039).track,
                    style: {
                        gap: $89d4071f206e1e99$var$l,
                        transform: `translateX(${-v * b}px)`
                    },
                    children: Array.from({
                        length: d
                    }).map((e, t)=>/* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("span", {
                            style: {
                                width: $89d4071f206e1e99$var$c,
                                height: $89d4071f206e1e99$var$c
                            },
                            className: (0, $89d4071f206e1e99$var$o.default)({
                                [(0, $35e3c077732c83e8$export$2e2bcd8739ae039).inactiu]: x(t),
                                [(0, $35e3c077732c83e8$export$2e2bcd8739ae039).actiu]: t === u
                            }),
                            onClick: ()=>S(t)
                        }, t))
                })
            }),
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)("div", {
                className: (0, $89d4071f206e1e99$var$o.default)((0, $35e3c077732c83e8$export$2e2bcd8739ae039).nav, {
                    [(0, $35e3c077732c83e8$export$2e2bcd8739ae039).nomesNav]: !e
                }),
                children: [
                    /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("button", {
                        disabled: h,
                        onClick: ()=>f(u - 1),
                        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $2a183a46947eafc4$export$fbe2f6ebbbe0cd5a), {
                            name: "navegacio/endarrere",
                            width: 18
                        })
                    }),
                    /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("button", {
                        disabled: g,
                        onClick: ()=>p(u + 1),
                        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $2a183a46947eafc4$export$fbe2f6ebbbe0cd5a), {
                            name: "navegacio/endavant",
                            width: 18
                        })
                    })
                ]
            })
        ]
    });
};





var $12cfbdfaf69316d3$export$2e2bcd8739ae039 = {
    container: "ara-ui_select-container_v98V",
    trigger: "ara-ui_select-trigger_wVLd",
    selected: "ara-ui_select-selected_HqnD",
    open: "ara-ui_select-open_fyC5",
    options: "ara-ui_select-options_l32Z",
    option: "ara-ui_select-option_A07o"
};



var $acw62 = parcelRequire("acw62");

"use client";
//#region src/components/select/index.tsx
var $96d00d74430c4f0c$var$l = /* @__PURE__ */ (0, $14b872f206384382$export$82dec27a9dce9602)((0, $ba4d14fce8721970$export$f998fc56051369ed)(), 1), $96d00d74430c4f0c$export$5fe1fe13f59d2524 = ({ items: e, titol: t, value: u, onChange: d, disabled: f })=>{
    let [p, m] = (0, $acw62.useState)(!1), [h, g] = (0, $acw62.useState)(), [_, v] = (0, $acw62.useState)(0), y = u ?? h, b = e.find((e)=>e.id === y) ?? null, x = (0, $acw62.useRef)(null), S = (0, $acw62.useRef)(null), C = (0, $acw62.useRef)(null), w = (0, $acw62.useRef)([]);
    (0, $acw62.useEffect)(()=>{
        p && C.current?.scrollTo({
            top: 0
        });
    }, [
        p
    ]), (0, $acw62.useEffect)(()=>{
        p && w.current[_]?.focus({
            preventScroll: !0
        });
    }, [
        p,
        _
    ]), (0, $acw62.useEffect)(()=>{
        if (!p) return;
        let e = (e)=>{
            x.current?.contains(e.target) || m(!1);
        };
        return document.addEventListener("pointerdown", e), ()=>document.removeEventListener("pointerdown", e);
    }, [
        p
    ]);
    let T = ()=>{
        let t = e.findIndex((e)=>e.id === y);
        v(t >= 0 ? t : 0), m(!0);
    }, E = (e)=>{
        u === void 0 && g(e.id), d?.(e.id), m(!1), S.current?.focus();
    };
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)("div", {
        ref: x,
        className: (0, $96d00d74430c4f0c$var$l.default)((0, $12cfbdfaf69316d3$export$2e2bcd8739ae039).container, {
            [(0, $12cfbdfaf69316d3$export$2e2bcd8739ae039).open]: p
        }),
        onBlur: (e)=>{
            e.currentTarget.contains(e.relatedTarget) || m(!1);
        },
        children: [
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)("button", {
                ref: S,
                type: "button",
                className: (0, $12cfbdfaf69316d3$export$2e2bcd8739ae039).trigger,
                disabled: f,
                "aria-haspopup": "listbox",
                "aria-expanded": p,
                onClick: ()=>p ? m(!1) : T(),
                onKeyDown: (e)=>{
                    (e.key === "ArrowDown" || e.key === "ArrowUp") && (e.preventDefault(), T());
                },
                children: [
                    /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("span", {
                        className: b ? (0, $12cfbdfaf69316d3$export$2e2bcd8739ae039).selected : void 0,
                        children: b?.label ?? t
                    }),
                    /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $2a183a46947eafc4$export$fbe2f6ebbbe0cd5a), {
                        name: "navegacio/desplega",
                        size: 18
                    })
                ]
            }),
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("ul", {
                ref: C,
                className: (0, $96d00d74430c4f0c$var$l.default)((0, $12cfbdfaf69316d3$export$2e2bcd8739ae039).options, {
                    [(0, $12cfbdfaf69316d3$export$2e2bcd8739ae039).open]: p
                }),
                role: "listbox",
                "aria-hidden": !p,
                children: e.map((t, n)=>/* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("li", {
                        role: "presentation",
                        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("button", {
                            ref: (e)=>{
                                w.current[n] = e;
                            },
                            type: "button",
                            role: "option",
                            "aria-selected": b?.id === t.id,
                            tabIndex: p && n === _ ? 0 : -1,
                            className: (0, $12cfbdfaf69316d3$export$2e2bcd8739ae039).option,
                            onClick: ()=>E(t),
                            onKeyDown: (t)=>{
                                t.key === "Escape" ? (t.preventDefault(), m(!1), S.current?.focus()) : t.key === "ArrowDown" || t.key === "ArrowUp" ? (t.preventDefault(), v((n + (t.key === "ArrowDown" ? 1 : -1) + e.length) % e.length)) : (t.key === "Home" || t.key === "End") && (t.preventDefault(), v(t.key === "Home" ? 0 : e.length - 1));
                            },
                            children: t.label
                        })
                    }, t.id))
            })
        ]
    });
};


var $0ec41bfa5cad4426$export$2e2bcd8739ae039 = {
    territoriInteractiu: "ara-ui_mapes-vectorials-territoriInteractiu_Qib5",
    tooltip: "ara-ui_mapes-vectorials-tooltip_Nyen"
};



var $acw62 = parcelRequire("acw62");


var $1u0KT = parcelRequire("1u0KT");
"use client";
//#region src/components/mapes-vectorials/tooltip.tsx
function $0f4f2e39a729daee$export$3acc8a7168131a25({ svgRef: c, component: l, ids: u, idMapa: d }) {
    let f = (0, $acw62.useId)(), [p, m] = (0, $acw62.useState)(null), [h, g] = (0, $acw62.useState)(null), _ = (0, $acw62.useRef)(null), v = (0, $acw62.useRef)(!1), y = (0, $acw62.useRef)(void 0), b = (0, $acw62.useRef)(null);
    function x() {
        clearTimeout(y.current);
    }
    function S() {
        x(), v.current = !1, m(null), g(null);
    }
    function C() {
        x(), v.current || (y.current = setTimeout(S, 150));
    }
    return (0, $acw62.useEffect)(()=>{
        let t = c.current;
        if (!t) return;
        let n = u ? new Set(u) : null, r = Array.from(t.querySelectorAll("[id]")).filter((e)=>/^\d+$/.test(e.id) && (!n || n.has(Number(e.id)))), i = r.map((e)=>({
                element: e,
                atributs: [
                    "tabindex",
                    "role",
                    "aria-label",
                    "aria-haspopup",
                    "aria-controls",
                    "style"
                ].map((t)=>[
                        t,
                        e.getAttribute(t)
                    ])
            }));
        for (let t of r)t.classList.add((0, $0ec41bfa5cad4426$export$2e2bcd8739ae039).territoriInteractiu), t.setAttribute("tabindex", "0"), t.setAttribute("role", "button"), t.setAttribute("aria-label", `Territori ${t.id}`), t.setAttribute("aria-haspopup", "dialog"), t.setAttribute("aria-controls", f);
        function a(e) {
            if (!(e instanceof Element)) return null;
            let n = e;
            for(; n && n !== t;){
                if (r.includes(n)) return n;
                n = n.parentElement;
            }
            return null;
        }
        function o(e) {
            x(), b.current = e, g(null), m({
                id: Number(e.id),
                element: e
            });
        }
        function s(e) {
            let t = a(e.target);
            t && (t !== b.current && (v.current = !1), v.current || o(t));
        }
        function l(e) {
            let t = e.relatedTarget;
            t instanceof Node && (a(t) === a(e.target) || _.current?.contains(t)) || C();
        }
        function d(e) {
            let t = a(e.target);
            t && (v.current = !0, o(t));
        }
        function p(e) {
            a(e.target) && (e.key === "Enter" || e.key === " ") && (e.preventDefault(), d(e));
        }
        function h(e) {
            e.target instanceof Node && !t.contains(e.target) && !_.current?.contains(e.target) && S();
        }
        function y(e) {
            e.key === "Escape" && (_.current?.contains(document.activeElement) && b.current?.focus(), S());
        }
        function w(e) {
            (!(e.target instanceof Node) || !_.current?.contains(e.target)) && S();
        }
        return t.addEventListener("pointerover", s), t.addEventListener("pointerout", l), t.addEventListener("focusin", s), t.addEventListener("focusout", l), t.addEventListener("click", d), t.addEventListener("keydown", p), document.addEventListener("pointerdown", h), document.addEventListener("keydown", y), window.addEventListener("resize", S), window.addEventListener("scroll", w, !0), S(), ()=>{
            x();
            for (let t of r)t.classList.remove((0, $0ec41bfa5cad4426$export$2e2bcd8739ae039).territoriInteractiu);
            for (let { element: e, atributs: t } of i)for (let [n, r] of t)r === null ? e.removeAttribute(n) : e.setAttribute(n, r);
            t.removeEventListener("pointerover", s), t.removeEventListener("pointerout", l), t.removeEventListener("focusin", s), t.removeEventListener("focusout", l), t.removeEventListener("click", d), t.removeEventListener("keydown", p), document.removeEventListener("pointerdown", h), document.removeEventListener("keydown", y), window.removeEventListener("resize", S), window.removeEventListener("scroll", w, !0);
        };
    }, [
        c,
        u,
        d,
        f
    ]), (0, $acw62.useLayoutEffect)(()=>{
        if (!p || !_.current) return;
        let e = p.element.getBoundingClientRect(), t = _.current.getBoundingClientRect(), n = e.top >= t.height + 16;
        g({
            left: Math.max(8, Math.min(window.innerWidth - t.width - 8, e.left + e.width / 2 - t.width / 2)),
            top: Math.max(8, Math.min(window.innerHeight - t.height - 8, n ? e.top - t.height - 8 : e.bottom + 8)),
            sobre: n
        }), v.current && document.activeElement === p.element && _.current.querySelector("button")?.focus();
    }, [
        p
    ]), p ? (0, $1u0KT.createPortal)(/* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("div", {
        ref: _,
        id: f,
        role: "dialog",
        "aria-label": `Territori ${p.id}`,
        className: (0, $0ec41bfa5cad4426$export$2e2bcd8739ae039).tooltip,
        "data-sobre": h?.sobre,
        style: {
            left: h?.left ?? 0,
            top: h?.top ?? 0,
            visibility: h ? "visible" : "hidden"
        },
        onPointerEnter: x,
        onPointerLeave: C,
        onFocus: x,
        onBlur: (e)=>{
            e.currentTarget.contains(e.relatedTarget) || C();
        },
        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)(l, {
            id: p.id,
            tancar: S
        })
    }), document.body) : null;
}



//#region src/components/mapes-vectorials/comunitats_es.tsx
var $7b20ca02f7508b6e$export$7296f128a741dd51 = ({ colors: n, color: r, colorLimits: i })=>/* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)("g", {
        fill: r,
        id: "comunitats",
        children: [
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
                id: "19",
                fill: n.get(19) ?? r,
                stroke: i,
                strokeMiterlimit: "10",
                d: "M273.571,487.561\n		c0,2.455-1.991,4.444-4.444,4.444c-2.455,0-4.444-1.989-4.444-4.444c0-2.455,1.989-4.444,4.444-4.444\n		C271.58,483.117,273.571,485.106,273.571,487.561"
            }),
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
                id: "18",
                fill: n.get(18) ?? r,
                stroke: i,
                strokeMiterlimit: "10",
                d: "M195.319,476.539\n		c0,2.455-1.991,4.444-4.444,4.444c-2.455,0-4.444-1.989-4.444-4.444c0-2.455,1.989-4.444,4.444-4.444\n		C193.328,472.095,195.319,474.084,195.319,476.539"
            }),
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
                id: "17",
                fill: n.get(17) ?? r,
                stroke: i,
                strokeMiterlimit: "10",
                d: "M304.102,106.099\n		c0.846-0.282,29.277,0.281,29.277,0.281l10.478,9.771l2.391-2.824l6.008-10.889l-33.793-18.397l-9.856-1.069\n		c-5.679-2.513-5.239-8.506-5.912-8.506c-0.94,0-14.645-1.315-14.645-1.315l-0.563,15.02l-1.313,12.765l7.129,10.791\n		L304.102,106.099z"
            }),
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
                id: "16",
                fill: n.get(16) ?? r,
                stroke: i,
                strokeMiterlimit: "10",
                d: "M351.799,30.35\n		c0.009,0,0.005-0.002-0.004-0.005l-0.663-0.875c-1.827-2.41-4.818-3.642-7.812-3.213l-23.539,3.361l-14.317-6.385\n		c-2.328-1.039-4.957-1.184-7.385-0.41l-13.595,4.336l-8.876,10.465l8.686,2.795l-0.475,8.517l-5.351,9.292l18.974,15.804\n		l5.252,0.434c0.673,0,0.233,5.994,5.914,8.508l9.855,1.067l7.51-27.597L351.799,30.35z"
            }),
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
                id: "15",
                fill: n.get(15) ?? r,
                stroke: i,
                strokeMiterlimit: "10",
                d: "M346.248,113.327l19.148,6.195l3.38-7.696\n		l-4.318-13.518l7.509-19.711l17.647-12.014V65.83l6.946-10.513l-0.94-2.816l-25.734-4.917c-2.32-0.443-3.94-2.551-3.776-4.905\n		l0.199-2.851c0.233-3.323-1.94-6.338-5.166-7.169c-4.1-1.058-9.021-2.31-9.347-2.31c-0.563,0-25.824,26.094-25.824,26.094\n		l-7.511,27.597l33.793,18.397L346.248,113.327z"
            }),
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
                id: "14",
                fill: n.get(14) ?? r,
                stroke: i,
                strokeMiterlimit: "10",
                d: "M396.325,365.872l-13.094-16.333l3.098-6.054\n		l0.14-5.21l-5.351-3.238l3.802-8.166l0.27-9.016l-7.591-7.035l-14.22,3.802l-1.268,19.571l-4.787,3.519l-6.194-4.365l-14.926,4.647\n		l-14.412,18.111l6.528,4.556l0,0l10.982,2.253l-1.97,12.955l19.148,17.176l7.782-8.082c1.999-2.075,4.904-3.01,7.737-2.492\n		l5.459,0.999l16.093-3.942c2.895-0.71,4.724-3.565,4.159-6.491L396.325,365.872z"
            }),
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("polygon", {
                id: "13",
                fill: n.get(13) ?? r,
                stroke: i,
                strokeMiterlimit: "10",
                points: "229.198,219.019 271.437,233.099 \n		282.983,231.973 283.356,232.726 291.43,224.651 271.719,190.578 274.253,174.526 264.679,165.235 233.141,198.814 233.14,198.814 \n		223.025,219.493 	"
            }),
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
                id: "12",
                fill: n.get(12) ?? r,
                stroke: i,
                strokeMiterlimit: "10",
                d: "M13.336,80.098l5.205,35.629\n		c0.487,3.521,4.288,5.525,7.468,3.936l25.436-12.719l-1.126,11.827l1.18,3.195c1.201,3.248,4.346,5.365,7.809,5.252l28.932-0.938\n		l10.138-8.072l9.051-1.878l12.022-22.34l-8.307-12.766l-7.828-0.788l11.257-27.184l-13.754-28.16l4.21-9.564L85.799,3.88\n		L74.348,2.378l0-0.001l-7.365-1.091c-1.771-0.262-3.572,0.209-4.988,1.303l-15.562,12.04c-1.366,1.056-2.297,2.578-2.618,4.277\n		l-1.38,7.313l-24.969,3.379L3.197,46.169c-1.949,2.264-2.423,5.445-1.217,8.176L13.336,80.098"
            }),
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
                id: "11",
                fill: n.get(11) ?? r,
                stroke: i,
                strokeMiterlimit: "10",
                d: "M201.601,272.1l-10.982-11.545\n		l0.986-12.954l-10.278-5.209l2.253-21.402l-17.361-2.533l-1.891,2.252l-9.011,0.189l-12.202-14.082l-16.333,13.893l-12.569,1.315\n		l-0.373-3.436l-4.448,2.162c-2.076,1.01-3.392,3.114-3.392,5.421v2.986l0.281,25.767l-14.977,0.93\n		c-4.456,0.278-6.97,5.244-4.555,8.997l10.098,15.697l0,0l-0.844,4.178l6.501,5.572c3.007,2.576,3.527,7.032,1.193,10.232\n		l-7.809,10.711c-1.026,1.405-1.699,3.037-1.964,4.759l-2.24,14.531l11.827,15.394l41.012,14.08l31.078-12.789l-2.254-17.06\n		l26.847-16.521l15.768-27.22l-2.439-16.333L201.601,272.1"
            }),
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
                id: "10",
                fill: n.get(10) ?? r,
                stroke: i,
                strokeMiterlimit: "10",
                d: "M437.864,306.041l-5.877-1.67\n		l-1.234-0.362l-13.729-35.047l5.508-16.526c8.517-12.829,33.524-48.961,33.524-48.961l-15.361-13.091l-17.289-1.401l-11.827,6.571\n		l4.13,17.46l-25.246,26.6l-1.788-0.692l-13.329-0.379l-13.895,23.096l-0.302,9.13l16.73,7.673l-5.633,14.222l5.21,7.321\n		l8.166-0.984l2.621,10.055v0.001l1.745,6.699l-4.799,2.098l-2.259-2.087l2.259,2.087l-0.271,9.026l-3.802,8.168l5.351,3.238\n		l-0.14,5.21l-3.098,6.054l13.096,16.334l0.016,0.08l18.148-36.55l23.649-12.421c2.342-1.23,3.253-4.119,2.04-6.47L437.864,306.041z\n		"
            }),
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
                id: "9",
                fill: n.get(9) ?? r,
                stroke: i,
                strokeMiterlimit: "10",
                d: "M449.462,159.345l-10.148,10.371\n		l1.347,0.717l4.693,6.383l-4.657,13.568l15.361,13.091l7.114-0.527l7.986-9.041c1.083-1.225,0.96-3.098-0.271-4.172l-2.688-2.343\n		c-1.321-1.152-1.448-3.16-0.286-4.47l2.577-2.907v0l5.669-6.354l29.063-9.257l0,0l3.978-1.255l21.061-6.476l5.534-9.096\n		l11.172-6.609l10.649-6.356l13.956-8.257l7.16-7.769c1.031-1.118,1.391-2.698,0.946-4.153l-2.678-8.753\n		c-0.82-2.682,0.689-5.521,3.371-6.34l1.903-0.582l2.814-5.82l-14.312-9.573l-34.543,3.191l-10.656-2.194l0,0l-8.492-1.748\n		l-6.2-0.458l-11.598,4.912l-2.777-8.235l1.252-6.745l-5.115-3.931l-25.151-7.654c-2.382-0.724-4.719,1.247-4.405,3.717l0.85,6.717\n		l1.502,27.972l-3.254,11.114l0,0l-3.505,12.165l-12.202,10.701l0.939,5.82l3.003,3.754l-3.376,4.182L449.462,159.345\n		L449.462,159.345L449.462,159.345"
            }),
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
                id: "8",
                fill: n.get(8) ?? r,
                stroke: i,
                strokeMiterlimit: "10",
                d: "M213.522,270.082l2.441,16.333\n		l-15.769,27.22l-0.825,0.508l34.925,21.712l0.003,0.011l68.116-10.683l0.954,0.477l0,0l11.436,5.717l4.786,12.954l-6.195,5.914\n		l8.398,5.861l14.412-18.111l14.924-4.646l6.196,4.365l4.787-3.521l1.267-19.569l14.22-3.803l7.592,7.036l4.798-2.106l-4.365-16.755\n		l-8.166,0.984l-5.21-7.321l5.633-14.22l-16.731-7.666l0.304-9.135l13.892-23.091l-4.426-1.995l-24.089-25.175l11.432-10.94\n		l-3.567-22.715l1.712-0.78l-15.98-11.985l-21.118,7.321l-11.829-12.108l-23.653-3.379l-19.148,8.449l9.573,9.291l-2.533,16.052\n		l19.711,34.074l-8.075,8.075l-0.372-0.753l-11.547,1.126l-42.238-14.08l-18.304,1.407l-27.954,6.579l-1.613,15.387l10.278,5.21\n		l-0.986,12.952l10.982,11.547L213.522,270.082 M291.43,224.651l-0.488-0.844h0L291.43,224.651L291.43,224.651z"
            }),
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
                id: "7",
                fill: n.get(7) ?? r,
                stroke: i,
                strokeMiterlimit: "10",
                d: "M132.967,152.562l-20.925,16.677\n		c-2.074,1.656-3.157,4.258-2.87,6.896l4.984,45.887l12.626-1.315l16.333-13.892l12.202,14.08l9.011-0.188l1.891-2.252l17.305,2.533\n		l-0.583,6.015l27.898-6.578l12.131-0.933l10.116-20.68l0.001,0l31.539-33.579l19.148-8.449l23.653,3.379l11.828,12.108\n		l16.677-5.781l-5.132-13.928l17.178-19.431l-1.972-14.926l-12.624-11.827c0,0-28.488-0.563-29.334-0.281\n		c-0.37,0.123-5.335,2.734-10.798,5.628l-7.13-10.79l1.315-12.766l0.563-15.02l9.391,0.881l-18.917-15.805l5.351-9.292l0.475-8.517\n		l-8.743-2.793l-3.701,4.365l-19.336,3.942l1.878,18.21l-13.228,0.652l0,0l-16.998-17.735l-11.026,1.595l-6.691-8.898l0,0\n		l-10.348-1.097l-2.535,5.491l-32.853,9.292l-10.982-6.9l-14.878,0.705l-2.674,7.884l-14.362,2.394l-3.788-3.053l-10.706,25.965\n		l7.83,0.788l8.298,12.765l-2.396,4.453l0,0l-9.625,17.887l14.08,3.222c1.89,0.431,3.338,2.013,3.547,3.942l0.97,8.95\n		c0.217,2.008,1.764,3.615,3.763,3.908l4.097,0.601c3.232,0.474,5.041,3.985,3.55,6.893L132.967,152.562"
            }),
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
                id: "6",
                fill: n.get(6) ?? r,
                stroke: i,
                strokeMiterlimit: "10",
                d: "M284.485,27.158l-16.159-8.241\n		c-1.697-0.865-3.628-1.16-5.507-0.839l-40.52,6.922l-0.986,8.589l-14.864,6.166l6.691,8.898l11.083-1.595l16.941,17.735\n		l13.283-0.652l-1.876-18.21l19.336-3.942L284.485,27.158z"
            }),
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)("g", {
                id: "5",
                fill: n.get(5) ?? r,
                children: [
                    /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("polygon", {
                        id: "Canaries_7_",
                        stroke: i,
                        strokeMiterlimit: "10",
                        points: "426.909,450.745 418.743,451.589 \n			416.208,457.503 424.376,475.244 429.444,473.554 432.823,458.348 		"
                    }),
                    /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("polygon", {
                        id: "Canaries_6_",
                        stroke: i,
                        strokeMiterlimit: "10",
                        points: "468.586,476.37 495.055,465.669 \n			505.193,465.951 505.475,470.176 490.55,491.576 477.596,496.645 		"
                    }),
                    /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("polygon", {
                        id: "Canaries_5_",
                        stroke: i,
                        strokeMiterlimit: "10",
                        points: "458.73,487.916 451.69,485.381 \n			448.029,487.07 447.185,492.984 453.098,498.335 460.419,494.393 		"
                    }),
                    /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("polygon", {
                        id: "Canaries_4_",
                        stroke: i,
                        strokeMiterlimit: "10",
                        points: "422.967,504.248 407.197,508.472 \n			408.043,513.258 418.181,516.639 425.782,507.909 		"
                    }),
                    /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
                        id: "Canaries_3_",
                        stroke: i,
                        strokeMiterlimit: "10",
                        d: "M519.903,485.24l-5.631,9.012l1.407,9.01\n			l7.322,5.07l9.856-4.507c0,0,3.379-3.661,3.379-5.068c0-1.409-2.816-13.798-2.816-13.798L519.903,485.24z"
                    }),
                    /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
                        id: "Canaries_2_",
                        stroke: i,
                        strokeMiterlimit: "10",
                        d: "M599.89,462.17l-10.701,20.275l0.282,6.196\n			l-12.11,7.321l7.885,3.942l7.321-7.603c0,0,12.108-1.97,12.108-2.816c0-0.844,5.07-20.275,5.07-20.275l-1.689-6.196l-3.098-2.533\n			L599.89,462.17z"
                    }),
                    /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("polygon", {
                        id: "Canaries_1_",
                        stroke: i,
                        strokeMiterlimit: "10",
                        points: "622.981,431.757 618.476,441.613 \n			607.494,446.964 605.241,455.412 611.435,457.383 625.233,449.499 628.05,437.389 624.482,431.1 		"
                    })
                ]
            }),
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)("g", {
                id: "4",
                fill: n.get(4) ?? r,
                children: [
                    /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("polygon", {
                        stroke: i,
                        strokeMiterlimit: "10",
                        points: "512.95,284.726 499.058,294.113 500.747,300.495 \n			508.256,302.748 520.084,292.235 		"
                    }),
                    /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
                        stroke: i,
                        strokeMiterlimit: "10",
                        d: "M578.659,239.106l-18.022,3.755l-21.402,19.523l7.885,7.463\n			l2.809-1.906c2.857-1.94,6.721-1.394,8.921,1.267c4.771,5.767,12.403,14.715,13.426,14.203\n			c1.501-0.751,18.772-20.275,18.772-21.401s1.126-9.387,1.126-9.387l-4.505-2.627l-5.914,3.519l-7.04-5.773l6.9-4.082\n			L578.659,239.106z"
                    }),
                    /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
                        stroke: i,
                        strokeMiterlimit: "10",
                        d: "M608.086,233.381v8.589l9.575-0.563l10.136,7.038\n			c0,0,3.521-4.363,3.661-4.786c0.14-0.423-6.617-11.405-6.617-11.405L608.086,233.381z"
                    }),
                    /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
                        stroke: i,
                        strokeMiterlimit: "10",
                        d: "M510.134,306.502c-0.188,0.751-3.191,5.068-3.191,5.068\n			l1.501,5.633l9.2-3.38L510.134,306.502z"
                    })
                ]
            }),
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
                id: "3",
                fill: n.get(3) ?? r,
                stroke: i,
                strokeMiterlimit: "10",
                d: "M191.886,19.93l-3.802-3.519L163.787,9.25\n		c-1.578-0.466-3.272-0.316-4.741,0.42l-9.257,4.629l-44.694,1.23l-4.21,9.564l13.688,28.16l-0.487,1.219l3.732,3.052l14.362-2.394\n		l2.674-7.884l14.935-0.705l10.982,6.9l32.796-9.293l2.535-5.491l10.348,1.097l14.864-6.166L222.299,25L191.886,19.93z"
            }),
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
                id: "2",
                fill: n.get(2) ?? r,
                stroke: i,
                strokeMiterlimit: "10",
                d: "M465.441,98.908l-1.502-27.972l-43.349-9.048\n		l-14.08,0.375l-9.95-6.946l-6.946,10.513v0.751l0,0l-17.646,12.014l-7.509,19.711l4.318,13.518l-3.38,7.696l-19.148-6.195\n		l-2.391,2.825l2.146,2.056l2.029,14.924l-17.178,19.431l5.132,13.929l4.443-1.54l15.98,11.985l-1.712,0.78l3.565,22.715\n		l-11.43,10.94l16.143,16.87l5.722,5.982l2.224,2.323l4.426,1.995l13.328,0.374l0.912,0.383l0.873,0.308l25.249-26.597l-4.13-17.459\n		l11.827-6.571l17.291,1.402l4.657-13.568l-4.693-6.383l-1.347-0.717l10.148-10.371l-2.415-12.702l0,0l3.376-4.182l-3.003-3.754\n		l-0.939-5.82l12.202-10.701L465.441,98.908z"
            }),
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
                id: "1",
                fill: n.get(1) ?? r,
                stroke: i,
                strokeMiterlimit: "10",
                d: "M328.319,360.661l-14.923-10.418\n		l6.194-5.913l-4.786-12.954l-12.392-6.195l-68.115,10.683l-0.003-0.011l-34.924-21.712l-26.022,16.013l2.253,17.06l0.015,0.032\n		l-31.092,12.757 M144.523,360.005l-36.116-12.389l-2.267,6.992l-11.264,1.407l-11.03,24.268c-0.608,1.334-0.734,2.835-0.362,4.251\n		l3.856,14.673c0.794,3.018,3.495,5.142,6.616,5.201l14.153,0.268c1.911,0.035,3.747,0.747,5.185,2.007l17.291,15.168\n		c1.166,1.022,3.718,1.702,3.718,1.702l17.403,39.223c0,0,17.816,8.562,18.368,8.701c0.552,0.137,13.258-6.076,13.258-6.076\n		l3.452-10.636l0,0l11.843-8.3c1.916-1.343,4.176-2.109,6.515-2.205l6.477-0.268c2.154-0.088,4.202-0.952,5.765-2.433l10.279-9.719\n		l30.937-2.562v-0.001l35.898-1.956l0,0.001l8.197,5.427l2.65-0.212c2.725-0.217,5.135-1.844,6.359-4.29l1.409-2.819l9.575-1.689\n		l2.691,2.466c2.171,1.989,5.588,1.653,7.329-0.721l23.771-32.439l-19.148-17.178l1.972-12.954l-10.982-2.253"
            })
        ]
    });



//#region src/components/mapes-vectorials/provincies_es.tsx
var $8e3415e3c8145414$export$bbb49b8373fec07e = ({ colors: n, color: r, colorLimits: i })=>/* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)("g", {
        fill: r,
        id: "provincies",
        children: [
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
                id: "52",
                fill: n.get(52) ?? r,
                stroke: i,
                strokeMiterlimit: "10",
                d: "M273.571,487.561\n		c0,2.455-1.991,4.444-4.444,4.444c-2.455,0-4.444-1.989-4.444-4.444c0-2.455,1.989-4.444,4.444-4.444\n		C271.58,483.117,273.571,485.106,273.571,487.561"
            }),
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
                id: "51",
                fill: n.get(51) ?? r,
                stroke: i,
                strokeMiterlimit: "10",
                d: "M195.319,476.539\n		c0,2.455-1.991,4.444-4.444,4.444c-2.455,0-4.444-1.989-4.444-4.444c0-2.455,1.989-4.444,4.444-4.444\n		C193.328,472.095,195.319,474.084,195.319,476.539"
            }),
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("polygon", {
                id: "50",
                fill: n.get(50) ?? r,
                stroke: i,
                strokeMiterlimit: "10",
                points: "346.248,113.327 343.857,116.152 \n		346.003,118.208 348.032,133.132 330.854,152.563 335.986,166.493 340.429,164.952 356.409,176.937 382.292,165.14 \n		394.683,168.707 406.51,152.375 439.314,169.716 449.462,159.345 447.047,146.643 429.412,150.497 414.582,132.475 \n		394.495,114.453 397.687,94.928 389.615,66.582 371.968,78.596 364.459,98.307 368.777,111.826 365.397,119.521 	"
            }),
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
                id: "49",
                fill: n.get(49) ?? r,
                stroke: i,
                strokeMiterlimit: "10",
                d: "M184.934,112.74l-6.282,2.792l-61.597-17.09\n		l-9.625,17.887l14.136,3.222c1.89,0.431,3.282,2.013,3.491,3.942l0.97,8.95c0.217,2.008,1.764,3.615,3.763,3.908l4.097,0.601\n		c3.232,0.474,5.041,3.985,3.55,6.893l-4.469,8.715l24.236,13.328l31.539-1.814l-1.689-46.807L184.934,112.74z"
            }),
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
                id: "48",
                fill: n.get(48) ?? r,
                stroke: i,
                strokeMiterlimit: "10",
                d: "M319.59,29.645l0.191-0.027l-14.318-6.386\n		c-2.328-1.039-4.957-1.184-7.385-0.41l-13.595,4.336l-8.876,10.465l13.289,4.272l2.675-4.787l3.379,1.972l3.238,9.433l11.879,1.5\n		L319.59,29.645z"
            }),
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("polygon", {
                id: "47",
                fill: n.get(47) ?? r,
                stroke: i,
                strokeMiterlimit: "10",
                points: "242.808,125.717 204.324,117.833 \n		199.139,96.783 183.721,102.156 184.987,112.717 184.935,112.741 187.051,117.27 188.741,164.075 195.688,166.079 213.897,166.079 \n		246.939,138.107 	"
            }),
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("polygon", {
                id: "46",
                fill: n.get(46) ?? r,
                stroke: i,
                strokeMiterlimit: "10",
                points: "377.88,278.443 372.247,292.665 \n		377.457,299.986 385.623,299.002 388.244,309.057 428.007,303.226 430.754,304.009 417.025,268.962 422.533,252.436 \n		388.675,238.923 375.346,238.544 361.452,261.64 361.15,270.77 	"
            }),
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("polygon", {
                id: "45",
                fill: n.get(45) ?? r,
                stroke: i,
                strokeMiterlimit: "10",
                points: "181.327,242.392 191.605,247.602 \n		190.619,260.554 201.601,272.101 213.523,270.081 221.032,262.666 243.277,262.949 248.064,279.562 266.932,278.999 \n		283.827,267.454 293.479,269.433 295.935,258.161 282.983,231.973 271.437,233.099 229.198,219.019 210.894,220.426 \n		182.939,227.005 	"
            }),
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("polygon", {
                id: "44",
                fill: n.get(44) ?? r,
                stroke: i,
                strokeMiterlimit: "10",
                points: "368.697,234.226 370.921,236.549 \n		375.346,238.544 388.675,238.918 389.587,239.301 390.46,239.608 415.708,213.012 411.578,195.553 423.406,188.982 \n		440.696,190.384 445.353,176.816 440.661,170.433 406.51,152.375 394.682,168.707 382.292,165.14 354.697,177.718 358.262,200.433 \n		346.832,211.373 362.974,228.244 	"
            }),
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
                id: "43",
                fill: n.get(43) ?? r,
                stroke: i,
                strokeMiterlimit: "10",
                d: "M500.043,145.879l-13.689-4.914\n		l-9.828,13.338l-17.55,3.51l-9.514,1.532l0,0l0,0l0,0l0,0l-10.148,10.371l1.347,0.717l4.693,6.383l-4.657,13.568l15.361,13.091\n		l7.114-0.527l7.986-9.041c1.083-1.225,0.96-3.098-0.271-4.172l-2.688-2.343c-1.321-1.152-1.448-3.16-0.286-4.47l2.577-2.907v0\n		l5.62-6.354l29.112-9.257l0,0l3.929-1.255l0.634-0.181L500.043,145.879z"
            }),
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
                id: "42",
                fill: n.get(42) ?? r,
                stroke: i,
                strokeMiterlimit: "10",
                d: "M283.828,156.786l23.653,3.379l11.827,12.108\n		l16.677-5.781l-5.132-13.928l17.178-19.431l-2.028-14.926l-12.624-11.827c0,0-28.431-0.563-29.277-0.281\n		c-0.844,0.281-25.625,13.517-25.625,13.517l-14.361,19.429L283.828,156.786z"
            }),
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
                id: "41",
                fill: n.get(41) ?? r,
                stroke: i,
                strokeMiterlimit: "10",
                d: "M198.524,372.177l-10.219,2.9l-12.609-27.862\n		l-31.172,12.789c-0.732,3.506-2.431,11.358-2.761,11.358c-0.421,0-10.419-0.423-10.419-0.423l-2.535,5.914l9.857,11.545\n		l0.704,31.539c-0.048,0.107-0.107,0.206-0.161,0.308l17.883,3.446l36.878-8.827l22.923-16.999L198.524,372.177z"
            }),
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
                id: "40",
                fill: n.get(40) ?? r,
                stroke: i,
                strokeMiterlimit: "10",
                d: "M246.707,137.413l0.231,0.694l-32.065,27.145\n		l10.945,31.239l7.322,2.323l31.539-33.579l19.148-8.449l-19.711-17.741l0.222-0.301\n		C259.412,138.371,252.511,137.848,246.707,137.413"
            }),
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
                id: "39",
                fill: n.get(39) ?? r,
                stroke: i,
                strokeMiterlimit: "10",
                d: "M284.485,27.158l-16.159-8.241\n		c-1.697-0.865-3.628-1.16-5.507-0.839l-40.52,6.922l-0.986,8.589l-14.864,6.166l6.691,8.898l11.083-1.595l16.941,17.735l0,0\n		l13.283-0.652l-1.876-18.21l19.336-3.942L284.485,27.158z"
            }),
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)("g", {
                id: "38",
                fill: n.get(38) ?? r,
                children: [
                    /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("polygon", {
                        stroke: i,
                        strokeMiterlimit: "10",
                        points: "426.909,450.745 418.743,451.589 416.208,457.503 \n			424.376,475.244 429.444,473.554 432.823,458.348 		"
                    }),
                    /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("polygon", {
                        stroke: i,
                        strokeMiterlimit: "10",
                        points: "468.586,476.37 495.055,465.669 505.193,465.951 \n			505.475,470.176 490.55,491.576 477.596,496.645 		"
                    }),
                    /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("polygon", {
                        stroke: i,
                        strokeMiterlimit: "10",
                        points: "458.73,487.916 451.69,485.381 448.029,487.07 \n			447.185,492.984 453.098,498.335 460.419,494.393 		"
                    }),
                    /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("polygon", {
                        stroke: i,
                        strokeMiterlimit: "10",
                        points: "422.967,504.248 407.197,508.472 408.043,513.258 \n			418.181,516.639 425.782,507.909 		"
                    })
                ]
            }),
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
                id: "37",
                fill: n.get(37) ?? r,
                stroke: i,
                strokeMiterlimit: "10",
                d: "M109.229,176.136l4.984,45.887\n		l12.569-1.315l16.333-13.892l12.202,14.08l9.011-0.188l31.362-37.359v-17.271l-6.978-2.004l-31.509,1.815l-24.235-13.329\n		l-20.869,16.677C110.025,170.895,108.942,173.497,109.229,176.136"
            }),
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
                id: "36",
                fill: n.get(36) ?? r,
                stroke: i,
                strokeMiterlimit: "10",
                d: "M64.981,80.286L64.981,80.286\n		l2.674-11.264l-5.446-9.366c0.002,0,0,0,0,0c-7.07,3.285-45.372,19.032-48.808,20.442l5.205,35.629\n		c0.487,3.521,4.288,5.525,7.468,3.936l25.437-12.719l-6.196-24.03L64.981,80.286z"
            }),
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)("g", {
                id: "35",
                fill: n.get(35) ?? r,
                children: [
                    /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
                        stroke: i,
                        strokeMiterlimit: "10",
                        d: "M519.903,485.24l-5.631,9.012l1.407,9.01\n			l7.322,5.07l9.856-4.507c0,0,3.379-3.661,3.379-5.068c0-1.409-2.816-13.798-2.816-13.798L519.903,485.24z"
                    }),
                    /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
                        stroke: i,
                        strokeMiterlimit: "10",
                        d: "M599.89,462.17l-10.701,20.275l0.282,6.196\n			l-12.11,7.321l7.885,3.942l7.321-7.603c0,0,12.108-1.97,12.108-2.816c0-0.844,5.07-20.275,5.07-20.275l-1.689-6.196l-3.098-2.533\n			L599.89,462.17z"
                    }),
                    /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("polygon", {
                        stroke: i,
                        strokeMiterlimit: "10",
                        points: "622.981,431.757 618.476,441.613 \n			607.494,446.964 605.241,455.412 611.435,457.383 625.233,449.499 628.05,437.389 624.482,431.1 		"
                    })
                ]
            }),
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("polygon", {
                id: "34",
                fill: n.get(34) ?? r,
                stroke: i,
                strokeMiterlimit: "10",
                points: "236.613,104.691 231.92,70.899 \n		241.164,64.793 224.223,47.058 213.14,48.653 203.01,64.705 205.121,80.755 202.305,95.68 199.14,96.783 204.323,117.833 \n		241.595,125.468 251.257,113.514 	"
            }),
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
                id: "33",
                fill: n.get(33) ?? r,
                stroke: i,
                strokeMiterlimit: "10",
                d: "M191.886,19.93l-3.802-3.519L163.787,9.25\n		c-1.578-0.466-3.272-0.316-4.741,0.42l-9.257,4.629l-44.694,1.23l-4.21,9.564l13.688,28.16l-0.487,1.219l3.732,3.052l14.362-2.394\n		l2.674-7.884l14.935-0.705l10.982,6.9l32.796-9.293l2.535-5.491l10.348,1.097l14.864-6.166L222.299,25L191.886,19.93z"
            }),
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
                id: "32",
                fill: n.get(32) ?? r,
                stroke: i,
                strokeMiterlimit: "10",
                d: "M50.384,118.771l1.181,3.195\n		c1.201,3.248,4.346,5.365,7.809,5.252l28.932-0.938l10.138-8.072l8.986-1.878l12.022-22.34l-8.242-12.765l-7.828-0.788\n		l-5.126,12.427L64.981,80.286l-19.665,2.627l6.195,24.03L50.384,118.771z"
            }),
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
                id: "31",
                fill: n.get(31) ?? r,
                stroke: i,
                strokeMiterlimit: "10",
                d: "M346.248,113.327l19.148,6.195l3.38-7.696\n		l-4.318-13.518l7.509-19.711l17.647-12.014V65.83l6.946-10.513l-0.94-2.816l-25.734-4.917c-2.32-0.443-3.94-2.551-3.776-4.905\n		l0.199-2.851c0.233-3.323-1.94-6.338-5.166-7.169c-4.1-1.058-9.021-2.31-9.347-2.31c-0.563,0-25.824,26.094-25.824,26.094\n		l-7.511,27.597l33.793,18.397L346.248,113.327z"
            }),
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
                id: "30",
                fill: n.get(30) ?? r,
                stroke: i,
                strokeMiterlimit: "10",
                d: "M396.325,365.872l-13.094-16.333l3.098-6.054\n		l0.14-5.21l-5.351-3.238l3.802-8.166l0.27-9.016l-7.591-7.035l-14.22,3.802l-1.268,19.571l-4.787,3.519l-6.194-4.365l-14.926,4.647\n		l-14.412,18.111l6.528,4.556l0,0l10.982,2.253l-1.97,12.955l19.148,17.176l7.782-8.082c1.999-2.075,4.904-3.01,7.737-2.492\n		l5.459,0.999l16.093-3.942c2.895-0.71,4.724-3.565,4.159-6.491L396.325,365.872z"
            }),
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
                id: "29",
                fill: n.get(29) ?? r,
                stroke: i,
                strokeMiterlimit: "10",
                d: "M258.462,422.31l-23.065-10.082l-7.456-14.362\n		h-11.049l-22.923,16.999l2.206,9.931l-19.059,11.049l9.667,18.92l11.843-8.3c1.916-1.343,4.176-2.109,6.515-2.205l6.477-0.268\n		c2.154-0.088,4.202-0.952,5.765-2.433l10.278-9.718l30.937-2.562L258.462,422.31z"
            }),
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("polygon", {
                id: "28",
                fill: n.get(28) ?? r,
                stroke: i,
                strokeMiterlimit: "10",
                points: "233.14,198.814 223.024,219.494 \n		229.198,219.02 271.437,233.098 282.983,231.972 283.357,232.727 291.43,224.651 271.719,190.578 274.252,174.526 264.679,165.235 \n			"
            }),
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
                id: "27",
                fill: n.get(27) ?? r,
                stroke: i,
                strokeMiterlimit: "10",
                d: "M100.884,25.093l4.21-9.564L85.864,3.88\n		L74.413,2.378c-0.905,4.811-10.538,55.98-11.076,56.695c-0.046,0.062-0.447,0.266-1.128,0.584l5.446,9.366l-2.674,11.264\n		l33.275,12.577l16.316-39.612L100.884,25.093z"
            }),
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
                id: "26",
                fill: n.get(26) ?? r,
                stroke: i,
                strokeMiterlimit: "10",
                d: "M304.102,106.099\n		c0.846-0.282,29.277,0.281,29.277,0.281l10.478,9.771l2.391-2.824l6.008-10.889l-33.793-18.397l-9.856-1.069\n		c-5.679-2.513-5.239-8.506-5.912-8.506c-0.94,0-14.645-1.315-14.645-1.315l-0.563,15.02l-1.313,12.765l7.129,10.791\n		L304.102,106.099z"
            }),
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
                id: "25",
                fill: n.get(25) ?? r,
                stroke: i,
                strokeMiterlimit: "10",
                d: "M509.4,101.947l-4.479-3.04l2.688-4.124\n		l7.452-1.849l-2.335-10.653l-1.843-0.127l-11.598,4.912l-2.777-8.235l1.252-6.745l-5.115-3.931l-25.151-7.654\n		c-2.382-0.724-4.719,1.247-4.405,3.717l0.85,6.717l1.502,27.972l-3.303,11.114l0,0l-3.456,12.165l-12.202,10.701l0.939,5.82\n		l3.003,3.754l-3.376,4.182l2.415,12.702l0,0l0,0l0,0l0,0l9.514-1.532l17.55-3.51l9.828-13.338l5.912,2.122\n		c1.77-3.38,3.04-5.808,3.04-5.808s12.686-22.384,12.943-23.542C508.505,112.579,509.4,101.947,509.4,101.947z"
            }),
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("polygon", {
                id: "24",
                fill: n.get(24) ?? r,
                stroke: i,
                strokeMiterlimit: "10",
                points: "213.14,48.653 206.449,39.754 \n		206.449,39.754 196.101,38.657 193.566,44.148 160.77,53.44 149.788,46.541 134.853,47.246 132.179,55.13 117.817,57.524 \n		114.086,54.471 114.573,53.252 103.38,80.436 103.38,80.436 111.21,81.224 119.451,93.989 117.055,98.442 178.65,115.532 \n		184.987,112.717 183.72,102.157 202.305,95.68 205.121,80.755 203.01,64.705 	"
            }),
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("polygon", {
                id: "23",
                fill: n.get(23) ?? r,
                stroke: i,
                strokeMiterlimit: "10",
                points: "319.59,344.33 314.804,331.376 \n		302.412,325.181 234.297,335.865 237.884,347.732 233.051,355.88 246.172,389.961 253.979,390.792 269.747,376.712 296.5,375.869 \n		313.396,350.243 	"
            }),
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("polygon", {
                id: "22",
                fill: n.get(22) ?? r,
                stroke: i,
                strokeMiterlimit: "10",
                points: "465.441,98.908 463.939,70.936 \n		420.59,61.889 406.509,62.264 396.56,55.318 389.614,65.831 389.614,66.582 397.686,94.929 394.495,114.453 414.582,132.475 \n		429.413,150.497 447.047,146.643 450.422,142.461 447.419,138.708 446.48,132.888 458.683,122.187 	"
            }),
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
                id: "21",
                fill: n.get(21) ?? r,
                stroke: i,
                strokeMiterlimit: "10",
                d: "M144.523,360.005l-36.116-12.389l-2.267,6.992\n		l-11.264,1.407l-11.03,24.268c-0.608,1.334-0.734,2.835-0.362,4.251l3.856,14.673c0.794,3.018,3.495,5.142,6.616,5.201\n		l14.153,0.268c1.911,0.035,3.747,0.747,5.185,2.007l17.291,15.168c2.827,2.477,7.244,1.516,8.784-1.913l-0.704-31.539\n		l-9.857-11.545l2.535-5.915c0,0,9.998,0.424,10.42,0.424C142.092,371.364,143.791,363.512,144.523,360.005"
            }),
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
                id: "20",
                fill: n.get(20) ?? r,
                stroke: i,
                strokeMiterlimit: "10",
                d: "M325.973,56.444\n		c0,0,25.263-26.094,25.826-26.094c0.062,0-0.367-0.08,0,0l-0.667-0.881c-1.827-2.41-4.818-3.642-7.812-3.213l-23.73,3.388\n		l-9.513,20.391L325.973,56.444z"
            }),
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("polygon", {
                id: "19",
                fill: n.get(19) ?? r,
                stroke: i,
                strokeMiterlimit: "10",
                points: "290.942,223.807 \n		291.431,224.651 290.942,223.807 299.597,222.399 301.849,209.727 331.136,195.365 346.832,211.374 346.832,211.374 \n		358.264,200.433 354.696,177.718 356.408,176.938 340.428,164.952 319.31,172.273 307.481,160.165 283.827,156.786 \n		264.679,165.235 274.252,174.526 271.719,190.578 291.43,224.651 290.942,223.807 	"
            }),
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("polygon", {
                id: "18",
                fill: n.get(18) ?? r,
                stroke: i,
                strokeMiterlimit: "10",
                points: "313.395,350.243 296.5,375.868 \n		269.748,376.713 253.979,390.793 246.171,389.962 231.244,404.227 235.398,412.228 258.462,422.31 258.6,429.278 294.499,427.322 \n		291.149,406.843 308.608,400.086 322.405,383.19 328.319,360.661 	"
            }),
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
                id: "17",
                fill: n.get(17) ?? r,
                stroke: i,
                strokeMiterlimit: "10",
                d: "M536.415,86.555l-10.656-2.194l0,0\n		l-8.492-1.748l-4.541-0.326l2.335,10.649l7.185,1.893l1.301,8.73l19.093,6.265l-6.855,11.141l20.092,14.76l1.738-1.113\n		l13.956-8.257l7.16-7.769c1.031-1.118,1.391-2.698,0.946-4.153l-2.678-8.753c-0.82-2.682,0.689-5.521,3.371-6.34l1.903-0.582\n		l2.814-5.82l-14.128-9.573L536.415,86.555z"
            }),
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("polygon", {
                id: "16",
                fill: n.get(16) ?? r,
                stroke: i,
                strokeMiterlimit: "10",
                points: "291.431,224.651 283.355,232.727 \n		295.936,258.16 293.479,269.434 294.809,269.707 302.234,277.13 302.835,276.465 313.536,274.916 326.067,281.675 334.656,274.635 \n		361.15,270.77 361.15,270.77 361.454,261.635 375.346,238.544 370.921,236.549 346.832,211.374 331.136,195.365 301.849,209.727 \n		299.597,222.399 290.942,223.807 	"
            }),
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
                id: "15",
                fill: n.get(15) ?? r,
                stroke: i,
                strokeMiterlimit: "10",
                d: "M74.414,2.377l-7.365-1.091\n		c-1.771-0.262-3.572,0.209-4.988,1.303l-15.562,12.04c-1.366,1.056-2.297,2.578-2.618,4.277l-1.38,7.313L17.53,29.598L3.262,46.169\n		c-1.949,2.264-2.423,5.445-1.217,8.176L13.4,80.098c0,0,49.374-20.275,49.937-21.026C63.901,58.321,74.414,2.377,74.414,2.377"
            }),
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("polygon", {
                id: "14",
                fill: n.get(14) ?? r,
                stroke: i,
                strokeMiterlimit: "10",
                points: "173.348,330.156 175.6,347.216 \n		188.304,375.078 198.523,372.177 216.891,397.865 227.94,397.865 231.244,404.228 246.171,389.962 233.05,355.88 237.885,347.733 \n		234.294,335.854 199.37,314.142 	"
            }),
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("polyline", {
                id: "13",
                fill: n.get(13) ?? r,
                stroke: i,
                strokeMiterlimit: "10",
                points: "234.296,335.865 \n		302.413,325.181 303.367,325.658 308.608,311.101 298.189,299.274 304.666,279.563 294.81,269.707 283.828,267.454 \n		266.931,278.999 248.065,279.563 243.278,262.948 221.031,262.667 213.522,270.082 215.963,286.414 200.194,313.635 \n		199.369,314.142 234.294,335.854 	"
            }),
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
                id: "12",
                fill: n.get(12) ?? r,
                stroke: i,
                strokeMiterlimit: "10",
                d: "M390.458,239.612l32.075,12.823\n		c0-0.563,33.524-48.961,33.524-48.961l-15.361-13.091l-17.289-1.401l-11.827,6.571l4.13,17.46L390.458,239.612z"
            }),
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
                id: "11",
                fill: n.get(11) ?? r,
                stroke: i,
                strokeMiterlimit: "10",
                d: "M196.176,424.796l-2.206-9.931l-36.878,8.827\n		l-17.883-3.446c0.053-0.102,0.112-0.201,0.161-0.308c-0.905,2.015-2.805,3.168-4.789,3.283l-0.278,0.332l17.403,39.223\n		c0,0,17.816,8.562,18.368,8.701c0.552,0.137,13.258-6.076,13.258-6.076l3.452-10.636l-9.667-18.92L196.176,424.796z"
            }),
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
                id: "10",
                fill: n.get(10) ?? r,
                stroke: i,
                strokeMiterlimit: "10",
                d: "M190.619,260.554l0.986-12.954l-10.278-5.209\n		l2.253-21.402l-17.361-2.533l-1.891,2.252l-9.011,0.189l-12.202-14.082l-16.333,13.893l-12.569,1.314l-0.373-3.436l-4.448,2.162\n		c-2.075,1.01-3.392,3.114-3.392,5.421v2.986l0.281,25.767l-14.977,0.93c-4.456,0.278-6.97,5.244-4.555,8.997l10.098,15.698\n		l13.798-7.322l7.463,4.365l-1.689,6.9l31.539,10.278l31.679-6.759l21.964-15.91L190.619,260.554z"
            }),
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
                id: "9",
                fill: n.get(9) ?? r,
                stroke: i,
                strokeMiterlimit: "10",
                d: "M284.295,40.418l-8.687-2.793l-3.701,4.365\n		l-19.336,3.942l1.878,18.21l-13.284,0.652l0,0l-9.243,6.106l4.692,33.791l14.643,8.824l-9.661,11.953l1.214,0.249l4.13,12.391\n		l-0.231-0.694c5.804,0.436,12.705,0.957,17.631,1.33l14.139-19.127c0,0,7.822-4.178,14.827-7.889l-7.131-10.791l1.315-12.765\n		l0.563-15.02l9.391,0.881l-18.974-15.805l5.351-9.292L284.295,40.418"
            }),
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
                id: "8",
                fill: n.get(8) ?? r,
                stroke: i,
                strokeMiterlimit: "10",
                d: "M509.784,162.968l20.476-6.295l5.534-9.096\n		l11.172-6.609l8.911-5.243l-20.081-14.733l6.855-11.141l-19.093-6.265l-1.301-8.73l-7.196-1.919l0,0l-7.441,1.875l-2.688,4.124\n		l4.479,3.04c0,0-0.895,10.631-1.151,11.79c-0.256,1.158-12.943,23.542-12.943,23.542s-1.27,2.428-3.04,5.808l7.777,2.792\n		L509.784,162.968z"
            }),
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)("g", {
                id: "7",
                fill: n.get(7) ?? r,
                children: [
                    /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("polygon", {
                        stroke: i,
                        strokeMiterlimit: "10",
                        points: "512.95,284.726 499.058,294.113 \n			500.747,300.495 508.256,302.748 520.084,292.235 		"
                    }),
                    /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
                        stroke: i,
                        strokeMiterlimit: "10",
                        d: "M578.659,239.106l-18.022,3.755l-21.402,19.523\n			l7.885,7.463l2.809-1.906c2.857-1.94,6.721-1.394,8.921,1.267c4.771,5.767,12.403,14.715,13.426,14.203\n			c1.501-0.751,18.772-20.275,18.772-21.401s1.126-9.387,1.126-9.387l-4.505-2.627l-5.914,3.519l-7.04-5.773l6.9-4.082\n			L578.659,239.106z"
                    }),
                    /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
                        stroke: i,
                        strokeMiterlimit: "10",
                        d: "M608.086,233.381v8.589l9.575-0.563\n			l10.136,7.038c0,0,3.521-4.363,3.661-4.786c0.14-0.423-6.617-11.405-6.617-11.405L608.086,233.381z"
                    }),
                    /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
                        stroke: i,
                        strokeMiterlimit: "10",
                        d: "M510.134,306.502\n			c-0.188,0.751-3.191,5.068-3.191,5.068l1.501,5.633l9.2-3.38L510.134,306.502z"
                    })
                ]
            }),
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
                id: "6",
                fill: n.get(6) ?? r,
                stroke: i,
                strokeMiterlimit: "10",
                d: "M96.003,284.725l6.501,5.572\n		c3.007,2.576,3.527,7.032,1.193,10.232l-7.809,10.711c-1.026,1.405-1.699,3.037-1.964,4.759l-2.24,14.531l11.827,15.395\n		l41.012,14.08l31.078-12.789l-2.254-17.06l26.847-16.521l15.768-27.22l-2.439-16.333l-11.922,2.018l-21.964,15.91l-31.681,6.758\n		l-31.539-10.277l1.689-6.9l-7.461-4.365l-13.799,7.321L96.003,284.725z"
            }),
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("polygon", {
                id: "5",
                fill: n.get(5) ?? r,
                stroke: i,
                strokeMiterlimit: "10",
                points: "182.939,227.005 210.894,220.426 \n		223.025,219.493 233.14,198.813 225.82,196.491 214.874,165.252 213.898,166.078 195.688,166.078 195.688,183.35 166.218,218.456 \n		183.579,220.99 	"
            }),
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
                id: "4",
                fill: n.get(4) ?? r,
                stroke: i,
                strokeMiterlimit: "10",
                d: "M337.331,375.869l1.972-12.954l-10.982-2.253\n		l-5.914,22.527l-13.799,16.896l-17.459,6.759l3.35,20.479l8.197,5.427l2.65-0.212c2.725-0.217,5.135-1.844,6.359-4.29l1.409-2.819\n		l9.575-1.689l2.691,2.466c2.171,1.989,5.588,1.653,7.329-0.721l23.771-32.439L337.331,375.869z"
            }),
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
                id: "3",
                fill: n.get(3) ?? r,
                stroke: i,
                strokeMiterlimit: "10",
                d: "M437.864,306.041l-9.857-2.816l-39.763,5.832\n		l1.745,6.699l-4.799,2.098l-2.259-2.087l2.259,2.087l-0.271,9.026l-3.802,8.168l5.351,3.238l-0.14,5.21l-3.098,6.054l13.096,16.334\n		l0.016,0.08l18.148-36.55l23.649-12.421c2.342-1.23,3.253-4.119,2.04-6.47L437.864,306.041z"
            }),
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("polygon", {
                id: "2",
                fill: n.get(2) ?? r,
                stroke: i,
                strokeMiterlimit: "10",
                points: "304.666,279.562 298.189,299.274 \n		308.607,311.101 303.369,325.658 302.413,325.181 314.804,331.376 319.589,344.329 313.395,350.243 321.793,356.104 \n		336.204,337.993 351.128,333.347 357.324,337.712 362.112,334.191 363.379,314.622 377.599,310.819 385.191,317.854 \n		389.99,315.748 385.625,298.993 377.459,299.977 372.248,292.656 377.881,278.436 361.15,270.77 334.655,274.634 326.068,281.674 \n		313.537,274.915 302.836,276.464 302.234,277.129 	"
            }),
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
                id: "1",
                fill: n.get(1) ?? r,
                stroke: i,
                strokeMiterlimit: "10",
                d: "M302.695,74.466\n		c0.673,0,0.233,5.994,5.914,8.508l9.856,1.067l7.509-27.597l-15.897-6.407l4.385-9.401l-0.008-0.005l-4.385,9.38l-11.879-1.5\n		l-3.238-9.433l-3.38-1.972l-2.674,4.787l-4.603-1.477l-0.475,8.517l-5.351,9.292l18.974,15.804L302.695,74.466z"
            })
        ]
    });



//#region src/components/mapes-vectorials/provincies_cat.tsx
var $3a6fc2a32aeadfde$export$13020ac9cdfef8bd = ({ colors: n, color: r, colorLimits: i })=>/* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)("g", {
        fill: r,
        id: "provincies",
        children: [
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
                id: "43",
                fill: n.get(43) ?? r,
                stroke: i,
                strokeMiterlimit: "10",
                d: "M500.043,145.879l-13.689-4.914\n		l-9.828,13.338l-17.55,3.51l-9.514,1.532l0,0l0,0l0,0l0,0l-10.148,10.371l1.347,0.717l4.693,6.383l-4.657,13.568l15.361,13.091\n		l7.114-0.527l7.986-9.041c1.083-1.225,0.96-3.098-0.271-4.172l-2.688-2.343c-1.321-1.152-1.448-3.16-0.286-4.47l2.577-2.907v0\n		l5.62-6.354l29.112-9.257l0,0l3.929-1.255l0.634-0.181L500.043,145.879z"
            }),
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
                id: "25",
                fill: n.get(25) ?? r,
                stroke: i,
                strokeMiterlimit: "10",
                d: "M509.4,101.947l-4.479-3.04l2.688-4.124\n		l7.452-1.849l-2.335-10.653l-1.843-0.127l-11.598,4.912l-2.777-8.235l1.252-6.745l-5.115-3.931l-25.151-7.654\n		c-2.382-0.724-4.719,1.247-4.405,3.717l0.85,6.717l1.502,27.972l-3.303,11.114l0,0l-3.456,12.165l-12.202,10.701l0.939,5.82\n		l3.003,3.754l-3.376,4.182l2.415,12.702l0,0l0,0l0,0l0,0l9.514-1.532l17.55-3.51l9.828-13.338l5.912,2.122\n		c1.77-3.38,3.04-5.808,3.04-5.808s12.686-22.384,12.943-23.542C508.505,112.579,509.4,101.947,509.4,101.947z"
            }),
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
                id: "17",
                fill: n.get(17) ?? r,
                stroke: i,
                strokeMiterlimit: "10",
                d: "M536.415,86.555l-10.656-2.194l0,0\n		l-8.492-1.748l-4.541-0.326l2.335,10.649l7.185,1.893l1.301,8.73l19.093,6.265l-6.855,11.141l20.092,14.76l1.738-1.113\n		l13.956-8.257l7.16-7.769c1.031-1.118,1.391-2.698,0.946-4.153l-2.678-8.753c-0.82-2.682,0.689-5.521,3.371-6.34l1.903-0.582\n		l2.814-5.82l-14.128-9.573L536.415,86.555z"
            }),
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
                id: "8",
                fill: n.get(8) ?? r,
                stroke: i,
                strokeMiterlimit: "10",
                d: "M509.784,162.968l20.476-6.295l5.534-9.096\n		l11.172-6.609l8.911-5.243l-20.081-14.733l6.855-11.141l-19.093-6.265l-1.301-8.73l-7.196-1.919l0,0l-7.441,1.875l-2.688,4.124\n		l4.479,3.04c0,0-0.895,10.631-1.151,11.79c-0.256,1.158-12.943,23.542-12.943,23.542s-1.27,2.428-3.04,5.808l7.777,2.792\n		L509.784,162.968z"
            })
        ]
    });



var $acw62 = parcelRequire("acw62");

"use client";
//#region src/components/mapes-vectorials/index.tsx
var $da8a4b538cbed3a2$export$bc141844ad426b25 = ({ color: c = "#D8D8D8", colorLimits: l = "#FFFFFF", idMapa: u, colors: d = [], tooltip: f, territorisAmbTooltip: p, ref: m, ...h })=>{
    let g = (0, $acw62.useRef)(null), _ = new Map(d.map(({ id: e, color: t })=>[
            e,
            t
        ]));
    return /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsxs)("svg", {
                ref: (e)=>{
                    if (g.current = e, typeof m == "function") return m(e);
                    m && (m.current = e);
                },
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: u === "provincies_cat" ? "437 54 154 156" : "0 0 635 520",
                ...h,
                role: f ? "group" : h.role,
                children: [
                    (0, $7b02d682eb115277$exports.jsx)(u === "provincies_cat" ? (0, $3a6fc2a32aeadfde$export$13020ac9cdfef8bd) : u === "comunitats_es" ? (0, $7b20ca02f7508b6e$export$7296f128a741dd51) : (0, $8e3415e3c8145414$export$bbb49b8373fec07e), {
                        colors: _,
                        color: c,
                        colorLimits: l
                    }),
                    u !== "provincies_cat" && /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("g", {
                        id: "linia",
                        children: /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)("path", {
                            fill: "none",
                            stroke: "#D8D8D8",
                            strokeLinecap: "round",
                            strokeLinejoin: "round",
                            d: "M369.989,516.639l24.013-75.059\n		c3.567-11.148,13.929-18.713,25.634-18.713h211.824"
                        })
                    })
                ]
            }),
            f ? /* @__PURE__ */ (0, $7b02d682eb115277$exports.jsx)((0, $0f4f2e39a729daee$export$3acc8a7168131a25), {
                svgRef: g,
                component: f,
                ids: p,
                idMapa: u
            }) : null
        ]
    });
};




















var $acw62 = parcelRequire("acw62");
var $bda5b0a1cec5eb2c$export$34e0f9847d4c02dd;
var $bda5b0a1cec5eb2c$export$ca787a737bfba0a9;
var $bda5b0a1cec5eb2c$export$2e6c959c16ff56b8;
$bda5b0a1cec5eb2c$export$34e0f9847d4c02dd = `QiLpzW_container`;
$bda5b0a1cec5eb2c$export$ca787a737bfba0a9 = `QiLpzW_inFlow`;
$bda5b0a1cec5eb2c$export$2e6c959c16ff56b8 = `QiLpzW_select`;


const $bf09101e5d650731$export$baf819189b0ccc9b = {
    mida_home: '978px',
    mida_noticia_lg: '1160px',
    mida_noticia_md: '600px',
    mida_noticia_sm: '320px',
    mida_noticia_xsm: '280px'
};


const $4cfd3027b4a2884b$var$VERSIONS = [
    {
        value: 'home',
        label: 'HOME'
    },
    {
        value: 'noticia_lg',
        label: "NOT\xcdCIA LG"
    },
    {
        value: 'noticia_md',
        label: "NOT\xcdCIA MD"
    },
    {
        value: 'noticia_sm',
        label: "NOT\xcdCIA SM"
    },
    {
        value: 'noticia_xsm',
        label: "NOT\xcdCIA XSM"
    }
];
const $4cfd3027b4a2884b$var$HeaderEmbed = ({ allowHomeEmbed: allowHomeEmbed = false, inFlow: inFlow = false, targetSelector: targetSelector = '[id^="app-"]' })=>{
    const [text, setText] = (0, $acw62.useState)(null);
    const [versioActiva, setVersioActiva] = (0, $acw62.useState)('noticia_md');
    const handleClick = (target)=>{
        const perHome = target === 'perHome';
        const targetLabel = target === 'perHome' ? 'HOME' : target === 'perNoticia1' ? "NOT\xcdCIA (1r embed)" : "NOT\xcdCIA (2n embed i posteriors)";
        const url = window.location.origin;
        const path = window.location.pathname;
        const projecte = path.split('/')[1];
        const query = new URLSearchParams(window.location.search);
        query.delete('preview');
        query.delete('embed-home');
        let datasets = '';
        query.forEach((value, key)=>{
            datasets += ` data-${key}="${value}"`;
        });
        const slug = query.get('slug');
        if (projecte === 'hemicicles' || projecte === 'widgets-eleccions') {
            const esHemicicles = projecte === 'hemicicles';
            const slugProj = esHemicicles ? `graficsweb/hemicicles/${slug}` : slug;
            const urlBase = query.get('url-base') || 'https://eleccions.ara.cat';
            const id = esHemicicles ? `hemicicle_${slug}` : slugProj?.replaceAll('/', '_');
            const embed = `<iframe id="${id}" src="${urlBase}/${slugProj}" height="58px" loading="lazy"></iframe>
			${perHome ? `<style>#${id}{width: 1px;min-width: 100%;margin-bottom: 20px;border: none;overflow: hidden;}
			@media only screen and (min-width: 768px) {#${id}{margin-bottom: 56px;}}</style>` : `<style>#${id}{width: 1px;min-width: 100%;border: none;overflow: hidden;}</style>`}
			<script type="text/javascript" src="${urlBase}/scripts/iframeResizer.min.js"></script>
			<script>document.addEventListener("DOMContentLoaded", function() { 
				document.getElementById("${id}").onload= function() { 
					iFrameResize({ log: false }, "#${id}");
				};
			});</script>`;
            navigator.clipboard.writeText(embed);
            setText(`Embed copiat per ${targetLabel} al porta-retalls`);
            setTimeout(()=>setText(null), 5000);
        } else {
            let embed = '';
            if (target === 'perNoticia2') embed = `<div id="app-${projecte}${slug ? `-${slug}` : ''}" class="embed-${projecte}"${datasets}></div>`;
            else embed = `<div id="app-${projecte}${slug ? `-${slug}` : ''}" class="embed-${projecte}"${datasets}${perHome ? ` data-embed-home="1"` : ''}></div>
	<link rel="stylesheet" href="${url}/projectes/${projecte}/dist/style.css">
	<script type="module" src="${url}/projectes/${projecte}/dist/index.js"></script>`;
            navigator.clipboard.writeText(embed);
            setText(`Embed copiat per ${targetLabel} al porta-retalls`);
            setTimeout(()=>setText(null), 5000);
        }
    };
    const handleVersio = (novaVersio)=>{
        localStorage.setItem('headerEmbedVersio', novaVersio ?? 'noticia_md');
        setVersioActiva(novaVersio);
        const url = new URL(window.location.href);
        // Editr search params
        const searchParams = new URLSearchParams(url.search);
        if (novaVersio === 'home') searchParams.set('embed-home', '1');
        else searchParams.delete('embed-home');
        const search = searchParams.toString();
        window.location.search = search;
    };
    const onVersio = (0, $acw62.useEffectEvent)((versio)=>{
        setVersioActiva(versio);
        const url = new URL(window.location.href);
        const searchParams = new URLSearchParams(url.search);
        if (versio === 'home' && searchParams.get('embed-home') !== '1') {
            searchParams.set('embed-home', '1');
            window.location.search = searchParams.toString();
        }
        const appElement = document.querySelector(targetSelector);
        appElement.style.maxWidth = versio === 'home' && allowHomeEmbed ? (0, $bf09101e5d650731$export$baf819189b0ccc9b).mida_home : (0, $bf09101e5d650731$export$baf819189b0ccc9b)[`mida_${versio}`];
        appElement.style.margin = inFlow ? '0 auto 40px' : '220px auto 40px';
        appElement.style.boxShadow = '0 0 12px rgba(0, 0, 0, 0.15)';
        appElement.style.backgroundColor = '#ffffff';
    });
    (0, $acw62.useEffect)(()=>{
        const versio = localStorage.getItem('headerEmbedVersio');
        document.body.style.backgroundColor = '#f4f6f8';
        if (!versio) {
            localStorage.setItem('headerEmbedVersio', 'noticia_md');
            onVersio('noticia_md');
        } else onVersio(versio);
    }, []);
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: `${$bda5b0a1cec5eb2c$export$34e0f9847d4c02dd}${inFlow ? ` ${$bda5b0a1cec5eb2c$export$ca787a737bfba0a9}` : ''}`,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        children: "Copia el codi de l\u2019embed a:"
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $acw62.Activity), {
                        mode: allowHomeEmbed ? 'visible' : 'hidden',
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                            className: `ara-button${text !== null ? ' disabled' : ''}`,
                            onClick: ()=>handleClick('perHome'),
                            children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                children: "HOME"
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        className: `ara-button${text !== null ? ' disabled' : ''}`,
                        onClick: ()=>handleClick('perNoticia1'),
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                            children: [
                                "NOT\xcdCIA ",
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    children: "(1r embed)"
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                        className: `ara-button${text !== null ? ' disabled' : ''}`,
                        onClick: ()=>handleClick('perNoticia2'),
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("span", {
                            children: [
                                "NOT\xcdCIA ",
                                /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                    children: "(2n embed i posteriors)"
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                style: {
                    opacity: text ? 1 : 0
                },
                children: text
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                className: $bda5b0a1cec5eb2c$export$2e6c959c16ff56b8,
                children: $4cfd3027b4a2884b$var$VERSIONS.map(({ value: value, label: label })=>{
                    const radio = /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        onClick: ()=>handleVersio(value),
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                                type: "radio",
                                value: value,
                                name: "versio",
                                checked: versioActiva === value,
                                onChange: ()=>{}
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                                htmlFor: value,
                                style: {
                                    fontWeight: versioActiva === value ? 700 : 400
                                },
                                children: label
                            })
                        ]
                    }, value);
                    if (value === 'home') return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $acw62.Activity), {
                        mode: allowHomeEmbed ? 'visible' : 'hidden',
                        children: radio
                    }, value);
                    return radio;
                })
            })
        ]
    });
};
var $4cfd3027b4a2884b$export$2e2bcd8739ae039 = $4cfd3027b4a2884b$var$HeaderEmbed;



var $72ee8b180e64cfcf$exports = {};

$parcel$export($72ee8b180e64cfcf$exports, "container", () => $72ee8b180e64cfcf$export$34e0f9847d4c02dd, (v) => $72ee8b180e64cfcf$export$34e0f9847d4c02dd = v);
$parcel$export($72ee8b180e64cfcf$exports, "labelText", () => $72ee8b180e64cfcf$export$51c3c710ff66e3c3, (v) => $72ee8b180e64cfcf$export$51c3c710ff66e3c3 = v);
var $72ee8b180e64cfcf$export$34e0f9847d4c02dd;
var $72ee8b180e64cfcf$export$51c3c710ff66e3c3;
$72ee8b180e64cfcf$export$34e0f9847d4c02dd = `k68gtq_container`;
$72ee8b180e64cfcf$export$51c3c710ff66e3c3 = `k68gtq_labelText`;




var $acw62 = parcelRequire("acw62");
var $d85749d50e6d7d33$exports = {};

$parcel$export($d85749d50e6d7d33$exports, "options", () => $d85749d50e6d7d33$export$41c562ebe57d11e2, (v) => $d85749d50e6d7d33$export$41c562ebe57d11e2 = v);
$parcel$export($d85749d50e6d7d33$exports, "select", () => $d85749d50e6d7d33$export$2e6c959c16ff56b8, (v) => $d85749d50e6d7d33$export$2e6c959c16ff56b8 = v);
$parcel$export($d85749d50e6d7d33$exports, "selectButton", () => $d85749d50e6d7d33$export$542cf336a574a3f8, (v) => $d85749d50e6d7d33$export$542cf336a574a3f8 = v);
var $d85749d50e6d7d33$export$41c562ebe57d11e2;
var $d85749d50e6d7d33$export$2e6c959c16ff56b8;
var $d85749d50e6d7d33$export$542cf336a574a3f8;
$d85749d50e6d7d33$export$41c562ebe57d11e2 = `_8iYmma_options`;
$d85749d50e6d7d33$export$2e6c959c16ff56b8 = `_8iYmma_select`;
$d85749d50e6d7d33$export$542cf336a574a3f8 = `_8iYmma_selectButton`;


const $d2d2a06c110a42e5$var$ponderaOptions = [
    {
        value: '0.1',
        label: '0,1'
    },
    {
        value: '0.2',
        label: '0,2'
    }
];
function $d2d2a06c110a42e5$export$2e2bcd8739ae039({ name: name }) {
    const [open, setOpen] = (0, $acw62.useState)(false);
    const [value, setValue] = (0, $acw62.useState)($d2d2a06c110a42e5$var$ponderaOptions[0].value);
    const selectRef = (0, $acw62.useRef)(null);
    const listboxId = (0, $acw62.useId)();
    const selectedOption = $d2d2a06c110a42e5$var$ponderaOptions.find((option)=>option.value === value) ?? $d2d2a06c110a42e5$var$ponderaOptions[0];
    (0, $acw62.useEffect)(()=>{
        const handlePointerDown = (event)=>{
            if (!selectRef.current?.contains(event.target)) setOpen(false);
        };
        const handleKeyDown = (event)=>{
            if (event.key === 'Escape') setOpen(false);
        };
        document.addEventListener('mousedown', handlePointerDown);
        document.addEventListener('keydown', handleKeyDown);
        return ()=>{
            document.removeEventListener('mousedown', handlePointerDown);
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, []);
    (0, $acw62.useEffect)(()=>{
        const form = selectRef.current?.closest('form');
        if (!form) return undefined;
        const handleReset = ()=>{
            setValue($d2d2a06c110a42e5$var$ponderaOptions[0].value);
            setOpen(false);
        };
        form.addEventListener('reset', handleReset);
        return ()=>form.removeEventListener('reset', handleReset);
    }, []);
    const handleOption = (optionValue)=>{
        setValue(optionValue);
        setOpen(false);
    };
    const handleButtonKeyDown = (event)=>{
        if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
            event.preventDefault();
            const currentIndex = $d2d2a06c110a42e5$var$ponderaOptions.findIndex((option)=>option.value === value);
            const direction = event.key === 'ArrowDown' ? 1 : -1;
            const nextIndex = (currentIndex + direction + $d2d2a06c110a42e5$var$ponderaOptions.length) % $d2d2a06c110a42e5$var$ponderaOptions.length;
            setValue($d2d2a06c110a42e5$var$ponderaOptions[nextIndex].value);
            setOpen(true);
        }
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($d85749d50e6d7d33$exports))).select,
        ref: selectRef,
        "data-open": open ? 'true' : 'false',
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                type: "hidden",
                name: name,
                value: value
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                type: "button",
                className: (0, (/*@__PURE__*/$parcel$interopDefault($d85749d50e6d7d33$exports))).selectButton,
                "aria-haspopup": "listbox",
                "aria-expanded": open,
                "aria-controls": listboxId,
                onClick: ()=>setOpen((currentOpen)=>!currentOpen),
                onKeyDown: handleButtonKeyDown,
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                    children: selectedOption.label
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("ul", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($d85749d50e6d7d33$exports))).options,
                id: listboxId,
                role: "listbox",
                "aria-label": "Ponderacio",
                children: $d2d2a06c110a42e5$var$ponderaOptions.map((option)=>/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("li", {
                        role: "option",
                        "aria-selected": option.value === value,
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("button", {
                            type: "button",
                            tabIndex: open ? 0 : -1,
                            onClick: ()=>handleOption(option.value),
                            children: option.label
                        })
                    }, option.value))
            })
        ]
    });
}


function $7748aa0b47591816$export$2e2bcd8739ae039({ name: name, min: min, max: max, pondera: pondera, step: step = 0.1, text: text }) {
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($72ee8b180e64cfcf$exports))).container,
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("label", {
                htmlFor: name,
                className: "e5",
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($72ee8b180e64cfcf$exports))).labelText,
                    children: text
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                children: [
                    pondera && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $d2d2a06c110a42e5$export$2e2bcd8739ae039), {
                        name: `${name}_pondera`
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("input", {
                        type: "number",
                        id: name,
                        name: name,
                        placeholder: "0,0",
                        min: min,
                        max: max,
                        step: step,
                        required: !pondera
                    })
                ]
            })
        ]
    });
}





function $56b49224f88889f4$export$2e2bcd8739ae039({ embedHome: embedHome, lang: lang, preview: preview, slug: slug }) {
    /**************************/ // Si cal afegir dades del CMS
    const [dadesCMS, setDadesCMS] = (0, $acw62.useState)(null);
    (0, $acw62.useEffect)(()=>{
        // Si tenim un slug, podem fer la consulta al CMS per obtenir les dades associades a aquest widget
        fetch(`${"https://widgets.ara.cat/api"}/embeds/v1/calculadora-nota-tall`).then((res)=>res.json()).then((json)=>setDadesCMS(json.data)).catch((error)=>console.log(error));
    }, []);
    /**************************/ const [estudis, setEstudis] = (0, $acw62.useState)('batxillerat');
    const [feedback, setFeedback] = (0, $acw62.useState)(0);
    const [resultat, setResultat] = (0, $acw62.useState)(null);
    const formatNota = (nota)=>nota.toFixed(2).replace('.', ',');
    const handleReset = ()=>{
        const form = document.getElementById('calculadora-nota-tall-form');
        form.reset();
        setResultat(null);
        setFeedback(0);
    };
    const handleSubmit = (event)=>{
        event.preventDefault();
        const formData = new FormData(event.target);
        const data = Object.fromEntries(Array.from(formData.entries(), ([key, value])=>{
            const numericValue = Number.parseFloat(value) || 0;
            return [
                key,
                Math.round(numericValue * 100) / 100
            ];
        }));
        const { nota_estudis: nota_estudis, catala: catala, castella: castella, estrangera: estrangera, historia: historia, optativa: optativa, especifica1: especifica1, especifica2: especifica2, especifica1_pondera: especifica1_pondera, especifica2_pondera: especifica2_pondera } = data;
        if (estudis === 'fp') {
            if (nota_estudis < 5) setFeedback(3);
            else {
                const nota = nota_estudis + especifica1 * especifica1_pondera + especifica2 * especifica2_pondera;
                setFeedback(1);
                setResultat(formatNota(nota));
            }
        } else {
            if (nota_estudis < 5) setFeedback(2);
            else if ((catala + castella + estrangera + historia + optativa) / 5 < 4) setFeedback(4);
            else {
                const notaGeneral = 0.6 * nota_estudis + 0.4 * ((catala + castella + estrangera + historia + optativa) / 5);
                const notaEspecifica = especifica1 * especifica1_pondera + especifica2 * especifica2_pondera;
                if (notaGeneral < 4.999) {
                    setFeedback(5);
                    setResultat(formatNota(notaGeneral));
                } else {
                    setFeedback(1);
                    setResultat(formatNota(notaGeneral + notaEspecifica));
                }
            }
        }
    };
    const handleEstudis = (key)=>{
        handleReset();
        setEstudis(key);
    };
    return /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)((0, $7b02d682eb115277$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $acw62.Activity), {
                mode: preview ? 'visible' : 'hidden',
                children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $4cfd3027b4a2884b$export$2e2bcd8739ae039), {
                    allowHomeEmbed: false
                })
            }),
            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("form", {
                id: "calculadora-nota-tall-form",
                onSubmit: handleSubmit,
                children: [
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                        className: "e3 titol",
                        children: dadesCMS?.titol
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("header", {
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $022321c99395772a$export$162886b1cdc28bcc), {
                            tabs: [
                                {
                                    actiu: true,
                                    keyTab: 'batxillerat',
                                    type: 'button',
                                    handleClick: handleEstudis,
                                    text: dadesCMS?.batxillerat
                                },
                                {
                                    actiu: false,
                                    keyTab: 'fp',
                                    type: 'button',
                                    handleClick: handleEstudis,
                                    text: dadesCMS?.fp
                                }
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                        children: /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7748aa0b47591816$export$2e2bcd8739ae039), {
                            name: "nota_estudis",
                            min: "0",
                            max: "10",
                            text: estudis === 'fp' ? dadesCMS?.nota_fp : dadesCMS?.nota_batxillerat
                        })
                    }),
                    estudis === 'batxillerat' && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "e4",
                                children: dadesCMS?.fase_general
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7748aa0b47591816$export$2e2bcd8739ae039), {
                                name: "catala",
                                min: "0",
                                max: "10",
                                text: dadesCMS?.catala
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7748aa0b47591816$export$2e2bcd8739ae039), {
                                name: "castella",
                                min: "0",
                                max: "10",
                                text: dadesCMS?.castella
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7748aa0b47591816$export$2e2bcd8739ae039), {
                                name: "estrangera",
                                min: "0",
                                max: "10",
                                text: dadesCMS?.estrangera
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7748aa0b47591816$export$2e2bcd8739ae039), {
                                name: "historia",
                                min: "0",
                                max: "10",
                                text: dadesCMS?.historia
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7748aa0b47591816$export$2e2bcd8739ae039), {
                                name: "optativa",
                                min: "0",
                                max: "10",
                                text: dadesCMS?.optativa
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "e4",
                                children: dadesCMS?.fase_especifica
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7748aa0b47591816$export$2e2bcd8739ae039), {
                                name: "especifica1",
                                min: "0",
                                max: "10",
                                text: dadesCMS?.especifica1,
                                pondera: true
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $7748aa0b47591816$export$2e2bcd8739ae039), {
                                name: "especifica2",
                                min: "0",
                                max: "10",
                                text: dadesCMS?.especifica2,
                                pondera: true
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("footer", {
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("div", {
                                children: feedback === 5 ? /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "e5 negatiu",
                                    children: `${dadesCMS?.feedback5} ${resultat} ${dadesCMS?.feedback5_2}`
                                }) : /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                    className: "e5 negatiu",
                                    style: {
                                        opacity: feedback > 1 ? 1 : 0
                                    },
                                    children: dadesCMS?.[`feedback${feedback}`]
                                })
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $e5b45ea74e28b54b$export$6996e762581de38a), {
                                type: "submit",
                                children: dadesCMS?.calcular
                            })
                        ]
                    }),
                    feedback === 1 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsxs)("div", {
                        className: "feedback",
                        children: [
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "e4",
                                children: dadesCMS?.[`feedback${feedback}`]
                            }),
                            feedback === 1 && /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("span", {
                                className: "e5",
                                children: resultat
                            }),
                            /*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)("p", {
                                className: "nota e8",
                                dangerouslySetInnerHTML: {
                                    __html: dadesCMS?.nota
                                }
                            })
                        ]
                    })
                ]
            })
        ]
    });
}


document.addEventListener("DOMContentLoaded", function() {
    const searchParams = new URLSearchParams(window.location.search);
    const lang = document.documentElement.lang || "ca";
    const preview = searchParams.get("preview") === "1";
    const slug = searchParams.get("slug");
    const containers = document.querySelectorAll(".embed-calculadora-nota-tall");
    containers.forEach((container)=>{
        const embedHome = searchParams.get("embed-home") === "1" || container.dataset.embedHome === "1";
        if (embedHome) container.classList.add($14d120258bb760db$export$711302eb3e721627);
        const root = (0, $7e96a608cb33bf79$exports.createRoot)(container);
        root.render(/*#__PURE__*/ (0, $7b02d682eb115277$exports.jsx)((0, $56b49224f88889f4$export$2e2bcd8739ae039), {
            lang: lang,
            preview: preview,
            embedHome: embedHome,
            slug: slug || container.dataset.slug || null
        }));
    });
});


//# sourceMappingURL=index.js.map
